/* BUILD 2026-10-27-B7.0.10 - Mounted Maps configurator (B7.0.10, 27 Oct: add to cart is all or nothing, so a label is never left unpaid. B7.0.9, 27 Oct: whole prices without ,00 and room captions bottom-right; rest as B7.0.8)
   B7.0.8 (Kevin, 26 Oct: "make it blue ... a pulsing dot"): the "Add a label
   and shipping is free" line is the configurator blue (#1E4FC4) with a small
   blue dot whose soft ring pulses 3 times when it appears, then holds still
   (no pulse for reduced-motion users). Not red. Everything else as B7.0.7.
   B7.0.7 (Kevin, 26 Oct): a tenth icon, Travel (plane), so None plus the
   icons fill two even rows of five on phone and desktop. The free-shipping
   line is red with an empty circle while no label is chosen ("Add a label
   and shipping is free") and green with a tick once added ("Free shipping
   earned"). On a desktop, Generate takes the page back to the top, and so
   does the finished render, so the model is in view (it used to land on the
   section below once the steps folded).
   B7.0.6 (Kevin, 26 Oct): the label preview shows the plaque a little bigger,
   up and to the left, with a flat close-up of the label in the bottom right
   and a pointer to it. The special date is three dropdowns (day, month,
   year; month first for US shoppers) instead of the calendar pop-up, and
   the label writes it the region's way (US MM.DD.YYYY, elsewhere
   DD.MM.YYYY). No focus jump when Special date opens. The ideas keep the
   emoji on the left on phones too, one line each.
   B7.0.5 (Kevin, 26 Oct): the plaque is curved round the frame ("the label
   ... isn't curved at all"), an arc on the middle of the face band with the
   words following it, on the 3D model, in the room photos and in the
   preview. It is the frame's own colour and material (oak grain on wood),
   with contrasting letters: soft white on black, near-black on white, dark
   walnut on oak ("needs to match each one"). With section B4.16 the label
   step says when the label takes the order to free shipping (EUR 75, GBP 65,
   USD 85, AUD 120, from snippets/mm-fs-local).
   B7.0.4 (Kevin, 26 Oct: "make the buildings in the example look more real
   ... coloured ... like a real place"): the model behind the label preview
   is the customer's own place, from the same cached map data the render
   uses (fetched when they pick a size): their buildings at render height,
   small houses with pitched roofs, streets, parks, water, trees and sun
   shadows, in their chosen colourway. Until that data lands it shows a
   made-up town drawn the same way (angled streets, terraces, a park).
   B7.0.3 (Kevin, 26 Oct: "Get rid of place name as the first suggestion ...
   prioritise them by what would convert the highest, such as special date
   ... the most important icons as well"): ideas now run Special date, Where
   we met, Our first home, Mr & Mrs, Place + year, Coordinates, Class of
   <year>, Place name. Icons: Love, Wedding, Home, New baby, Pin, Star, Pet,
   Graduation. Order is a judgement, not sales data. "Add a label" still
   fills in the place so the preview is never empty.
   B7.0.2 (Kevin, 26 Oct: "slanted and curved because that's what it really
   looks like", "a bit more zoomed out"): the label preview is drawn as the
   real thing, a slice of the round frame seen from the three-quarter
   photo's camera, the plaque flat in the frame's face where the 3D model
   puts it, so it sits slanted and the frame curves away either side. Real
   frame profile per size, a little of the model behind it in the chosen
   colours, the frame's own colour (oak grain on wood), soft shadow. Canvas
   2D, cached; the flat pill stays as the fallback.
   B7.0.1 (Kevin, 26 Oct: "can we make this look nicer and also add emojis
   for inspiration"): the label editor. The plaque preview sits in a strip
   of the chosen frame (black, white or wood) with "Set into your ... frame"
   under it; then the field; then "Need an idea?" with eight ideas in a tidy
   two-column grid, each with an emoji (on the buttons only, never on the
   label): Place name, Place + year, Coordinates, Special date, Our first
   home, Where we met, Mr & Mrs, Class of <year>. The date box only shows
   for Special date. "Add an icon": None or one of eight one-colour icons
   (Love, Home, Wedding, New baby, Graduation, Pet, Star, Pin) printed in
   front of the words in the plaque's colour; on the order as e.g.
   "Label: ❤ EYRE SQUARE" plus "Label icon: Love".
   B7.0 (Kevin, 25 Oct: "implement Muasher's version as its own step and make
   it optional ... Add a name label ... set into the frame"): a new step
   before the preview, "Name label". No label by default; "Add a label, set
   into the frame" adds the plaque Muasher designed (41.9 x 8.6 mm, black
   with bone capitals, white on a white frame, up to 14 characters), drawn on
   the 3D model and in the room photos. Priced from the "name-label" product
   (section B4.15, window.MM_CART.nameLabel*); the label text goes on the
   model line (Label) and the add-on line is linked to it. Off on Etsy and
   with any older section. Steps are counted from SEGMENTS now, not fixed at
   four.
   ---- B6.9 notes follow ----
   B6.9 (Kevin, 25 Oct, iPhone wall shot: "Shadow render is really
   blocky"): room module MMRooms R1.3. Safari has no canvas blur, so the
   room-shot shadows used a shrink-and-grow blur; Safari shrinks in one jump
   and skips pixels, which left steps. The new blur shrinks in exact halves,
   blurs the small image in JS (three box passes) and grows back in exact
   doubles. Measured against Chrome's real blur on wall and table shots for
   Ø15/Ø20/Ø40: within 3 of 255 (was up to 42). Chrome and Firefox unchanged.
   ---- B6.8 notes follow ----
   B6.8 (Kevin, 25 Oct: "the cast shadow can look a bit more real no?"):
   room module MMRooms R1.2. The table shadow copies the real props' shadows
   in each table photo (mug, pot, vase), measured off the photos:
   - colour: the wood under a real shadow gets darker and richer, red drops
     least and blue most (ratio r, r^1.5, r^1.9, r = 0.73 / 0.79 / 0.58 for
     the Ø15 / Ø20 / Ø40 photos), instead of a flat grey;
   - darkest and sharpest where the frame meets the table, softer and lighter
     further out (3 cm), like a real window shadow.
   B6.7 (same day): shadows only on the side away from the window, no dark
   line round the frame on the window side.
   Built on B6.6.1 (Etsy hook H6, Etsy mode only) so Shopify and Etsy share
   one file again.
   ---- B6.6.1 notes follow ----
   B6.6.1 (Kevin, 25 Oct, Etsy tool brought up to the new configurator):
   Etsy mode only, nothing changes on Shopify. The Etsy tool sells one
   finish (Natural Colour), so its Colour step shows that finish as one
   wide photo card, already ticked, on phones and computers alike, from
   settings colourGuidePhotos.full. Etsy hook H6 (see mm-etsy-mode/HOOKS.md):
   carry it into every later build.

   B6.6 (Kevin, 25 Oct: "when I click one of the suggestions it takes a
   while to load"), speed:
   - three.js (163 KB) is no longer loaded with the page (section B4.14 drops
     its script tag). It is fetched once the map is on screen and idle, or
     the moment the model is needed, whichever comes first.
   - The map's style sheet loads alongside the page instead of holding it up;
     it is switched on before the map is made, whatever the timing.

   B6.5.2 (Kevin, 25 Oct: "I need to ensure customers are getting good
   renders back"): a safety net round the room shots. Before they run, the
   page notes the state of everything they can touch: every part of the
   model and its materials (shown, colour, depth, opacity, reflections), the
   shadow floor, the contact shadow, every light and the exposure. After
   they run, whatever happened inside them (finished, failed half way, or
   left something changed), all of it is put back exactly as it was, and
   anything that had to be put back is logged in the console. The customer
   can lose a room photo, never the model.

   B6.5.1 (Kevin, 25 Oct 16:14, a Stillorgan render on his phone came back as
   a flat disc: no buildings, no trees, no frame). The B6.4 room passes hide
   the model's colour for the table shadow and put it back afterwards, one
   mesh at a time. Meshes share materials (every plain building uses the same
   one), so the second mesh "remembered" the already-hidden state and put
   that back: buildings, trees and frame stayed invisible. Phones show the
   live 3D model after the passes, so they saw it; desktop shows the still
   taken before them. Fixed: put back in reverse order (the first, true
   state wins). Also: the shadow floor and the exposure are put back after
   the passes, whatever happens inside them.

   B6.5 (Kevin, 25 Oct, on B6.4 room shots):
   - Size tiles, phones: the line under each size ("750 m across") stays on
     one line; it shrinks only as far as it must (15px down to 12.5px), the
     same on all three tiles.
   - Compare sizes: only the photos with the size under each; the Map /
     With frame rows are gone (every width).
   - Colour, phones: the finishes are chosen by their photos (mockup A):
     two photo cards side by side, name and line under each photo, tick on
     the chosen one. No Compare finishes panel on a phone any more.
   - The Gallery White photo is a brighter file (theme setting, not code).
   ---- B6.4 notes follow ----
   B6.4 (Kevin, 25 Oct): "new renders of the models in the rooms ... on the
   wall and on a table ... they can be infinitely better". Room shots rebuilt
   (MMRooms R1, built on B6.3 phone polish):
   - New room photos, one wall and one table per size, bright Scandi, 1600 px:
     Shopify > Content > Files, mm-room2-{15,20,40}-{wall,table}.jpg.
   - WALL: a true bird's-eye view. Orthographic camera straight down, so the
     frame is a perfect circle with no tilt (Kevin: "it wasn't like it was
     smaller at the bottom than the top ... make sure ... it's perfectly on the
     wall"). Lit from the room's window on the left: buildings throw short
     shadows to the right, the frame throws a soft shadow onto the wall.
   - TABLE: rendered from each photo's own camera angle and window light, with
     a real cast shadow onto the wood and a contact shadow under the frame.
   - Every size has its own two photos with everyday things at true scale
     beside the model (mug, candle, lamp), so Ø15, Ø20 and Ø40 look as big as
     they really are.
   - Compositing runs in the browser (canvas), Safari without canvas filters
     gets a shrink-and-grow blur instead.
   - If a new photo is missing, the room shots are skipped and the email falls
     back to the plain pictures, exactly as before.
   ---- B6.3 notes follow ----
   B6.3 (Kevin, 25 Oct, picked mockup V3b): phones.
   - Every step is its own white card. The step number is a big round badge
     on the card's left edge, and a line joins number to number, in front
     of the cards and behind the numbers.
   - A step is done once you tap a choice in it or scroll past it (what is
     picked by default does not count). Done = dark with a tick; the line
     fills blue down to the step you are on, whose number has a blue ring.
     A small pop, once, when a number changes. Nothing blinks.
   - The step bar under the header is gone on phones, and so are the
     "Next: Frame" lines.
   - Compare starts closed on a phone, and says "Show photos" / "Hide".
   - "See my 3D preview" takes you to the very top of the page.
   - Adjust the area and Start again sit at the bottom, under step 5, away
     from Add to cart (both take the model away). Start again asks once,
     in the page, before it clears anything; that part on every width.
   - The gift wrap sentence under the finished model is gone.
   - The room photos open on the one you tapped ("In a room" / "On a wall",
     the same words as the tiles), on every screen.

   B6.2 (Kevin, 25 Oct, testing B6.1.1 live on his phone): "this bottom
   button thing that follows makes it really hard to see on mobile, it's
   better to follow downwards with some sort of minimalistic peripheral
   hinting to go to the next step".
   - Phones: the bar fixed to the bottom of the screen is gone.
   - The end of Size, Frame and Colour carries one quiet line, "Next:
     Frame" with a small arrow that nudges once as it comes into view. Tap
     it to glide down, or just keep scrolling.
   - Step 5 keeps its big "See my 3D preview" button in the page.
   - After the render, Add to cart sits directly under the model (the
     theme's "Love it, or your money back" line follows it), part of the
     page rather than pinned. While a model builds, Cancel sits there too.
   - The step bar at the top stays.

   B6.1.1 (Kevin, 25 Oct): phones also get a big "See my 3D preview" button
   in the page, at the end of step 5 under the total, so the steps have a
   finish line you cannot scroll past without seeing. While that button is
   on screen the bar at the bottom steps aside, so there are never two of
   the same button at once.

   B6.1 (Kevin, 25 Oct): phones rebuilt for older customers. "I don't like
   how it's sending me flying across the page ... the next step should always
   be fixed at the bottom of the screen ... at the top you should always see
   what step you're progressing on ... so even an old person can navigate it."
   - Phones get the desktop layout in one column: place, map (full width, as
     big as before), then every step open one after the other. No more one
     step at a time with the page swapped underneath.
   - A step bar pinned under the theme header: Place, Size, Frame, Colour,
     Preview. The one you are looking at is underlined; tap any to go to it.
   - A bar fixed to the bottom of the screen: the total and one button that
     always says what is next ("Next: Frame"). It becomes "See my 3D preview"
     on the last step, Cancel while building, and Add to cart after.
   - Nothing scrolls on its own any more. The page moves only when a button
     is tapped, by as little as needed, and smoothly.
   - Compare panels arrive open on a phone (closed on desktop, as before).
   - Bigger type on phones (nothing under 15px apart from the licence line),
     and a tick on the chosen tile on every screen.
   - Step 5 on a phone lists every choice with a Change beside it.
   - The room shots show open under the model on a phone too.

   B6.0.2 (Kevin, 24 Oct, after testing B6.0.1):
   - Wide screens: "Pick a place, choose a size..." moves out of the pinned
     heading into the top of the right-hand panel, so it scrolls away with
     the panel instead of being cut by it.
   - The "Real-life comparison" link under the model is gone (the page has
     its own comparison section now).
   - Under the model: the colour legend, the build stats line and the
     second credit line are gone. The one credit line at the foot of the
     configurator (Mini Skyline, MapTiler, OpenStreetMap) stays: licence.
     The polished-water note stays, because it explains what the customer
     is looking at.
   - Finished steps are grey, not blue: ticks, "Change" links, "Change
     location", the phone chips. Add to cart is the one blue thing left
     once the model is up.
   B6.0.1 (Kevin, 24 Oct, after testing B6.0 live):
   - Wide screens: nothing on the left moves when the page scrolls. The
     theme's announcement bar is pinned under its header, the heading under
     that, and the map column exactly where it starts, so only the panel
     scrolls until the board ends. The map's hint chips and the enlarge pill
     sit on the map itself.
   - Compare panels start closed everywhere; they open on a tap.
   - Compare finishes: the two photos side by side, each under its own tile.
   - After a render (wide): the model is a little smaller (84%) and the two
     room shots, "In a room" and "On a wall", are shown open under it; a tap
     opens the full-size room view.
   B6.0 (Kevin, 24 Oct): the draft 3 layout on the same engine.
   Desktop: two columns. The map is a rounded square on the left and stays
   put (sticky) while one panel on the right holds every step: place, size,
   frame, colour, then the total and Generate. Sizes, frames and finishes
   are tiles in one row; each step has a Compare panel (the guides), one
   open at a time. After Generate the 3D model takes the map's place, the
   steps fold to one line each with a Change link, and Add to cart sits
   under the total with Adjust the area and Start again as two white
   buttons.
   Phone: the one-step-at-a-time flow stays (chips above), with the rounded
   square map, tiles in one row, the step's Compare panel open, and a bar
   with Back, the total and Next that sticks to the bottom of the screen.
   Add to cart sticks the same way once the model is ready.
   The ring and the concave card shapes are retired. Type is Hanken Grotesk
   and Bricolage Grotesque, as on the rest of the site. Last beige leftovers
   in the guides are now the grey.
   B5.78 (Kevin, 16 Oct): no expand button on the colour guide, and
   nothing in it opens a bigger view. A tap on a photo only picks it.
   Natural Colour tile line: "True-to-life colours" (was "Green, sand
   and water").
   B5.77 (Kevin, 16 Oct): the colour guide has no "Colour guide / Same
   model, two finishes" heading (the names are on the photos) and the
   expand button sits on the top photo. Beside step 4 it never runs past
   the bottom of the step 4 card: the photos get shorter first (centre
   crop, down to 2:1), then narrower; if it still cannot fit, the card
   is lifted so its bottom lines up with step 4.
   B5.76 (Kevin, 16 Oct): the colour guide is his photo twice, stacked:
   Gallery White on top, Natural Colour under it, each a horizontal 3:2
   photo with its name on it. Same placement and picking as B5.75.
   Photos: mm-colour-gallery-white.jpg (the same shot recoloured to one
   white material) and mm-colour-natural.jpg.
   B5.75 (Kevin, 16 Oct):
   - No "Free upgrade" pill on Natural Colour. Both finishes are presented
     as equals; each tile shows its own line again.
   - Colour guide for step 4, placed like the size and frame guides: page
     margin left of step 4 on wide screens, the panel above step 4 (same
     column) on laptops, under Next on a phone. Built from one photo per
     colour (settings colourGuidePhotos.mono / .full, section B4.11), so a
     photo works the moment it is picked: square, model centred, no text.
     Both photos set = guide on; either missing = no guide. One colour on
     offer (Etsy) = no guide.
   - Laptop placement is now "same column, other row" for every step
     (step 2 -> under it, step 3 -> under it, step 4 -> above it).
   B5.74 (Kevin, 15 Oct): frame guide pills follow the list order.
   Black now sits on the left of the circle and White on the right
   (Wood stays under it). Needs the new frame photo with the black
   side on the left (mm-frame-options.jpg, 15 Oct night); the circle
   sits in the same place, so the frame spot is unchanged.
   B5.73 (Kevin, 15 Oct): the guides no longer jump across the circle.
   Each one stays on its own step's side.
   - Wide screens (page margin at least 260 px, about 1660 px wide and
     up): beside the step, in the page margin. Sizes left of step 2,
     frames right of step 3, top aligned with the step.
   - Narrower desktops: in the panel directly under the step, same
     column (sizes under step 2, frames under step 3). That panel's
     own step, if done, keeps a "Colour: ... Change" line.
   - Phone: unchanged, open in the sheet under Next.
   - The margin card lives on <body>, not inside the section: .mm clips
     sideways overflow, which would hide anything in the margin. It is
     re-placed on every repaint, resize and page height change.
   B5.72.1 (15 Oct): B5.72 crashed the page when the guide photos were set
   and the customer arrived from the homepage with an address (phone and
   desktop). The hand-off draws the steps during start-up, before the
   guide constants further down init() had their values: the 24 Sep
   hoisting trap again. The constants now live at module level with
   MM_FACE, and the guide state (guideDims, guideRO) is created on first
   use. Tested: hand-off with photos set, phone and desktop.
   B5.72 (Kevin, 15 Oct): his size and frame photos, open in the steps.
   - Desktop: the empty panel on the other side of the circle shows the
     guide for the open step. Size open: the sizes, in the right panel.
     Frame open: the frames, in the left panel.
   - Phone: the guide sits open in the step sheet, under the options.
   - Built from his photos: the framed models are cut out of the graphic
     and laid out live, so the labels are sharp text at any width rather
     than 5 px type in a shrunken poster. Sizes stand side by side to
     scale with his framed sizes (17 / 22.4 / 44 cm); frames are his
     three-frame circle with White, Black and Wood around it.
   - The current pick is highlighted and tapping a model or label picks
     it. The expand button opens the original graphic full screen.
   - Settings: sizeGuideImage/Cut/Spots/Framed, frameGuideImage/Cut/Spot.
     Shopify fills Image and Cut from the section (B4.10 image pickers).
     No photo set = no guide, so nothing changes until one is picked.
   - Spots are where each model sits in Kevin's current photos. A new
     photo with a different layout needs new spots.
   B5.71.2 (14 Oct): no "Free upgrade" tag when only one colour is on offer
   (Etsy sells Natural Colour only). Shopify unchanged.
   B5.71.1 (14 Oct): landmarks in the search suggestions (MapTiler leaves
   POIs out unless asked: "eiffel tower" gave streets in the Philippines),
   and a trailing st, rd, ave... is spelled out ("grafton st" gave US towns).
   B5.71 (Kevin, 14 Oct):
   - Gallery White is first and preselected. Natural Colour is second, with a
     green "Free upgrade" tag. Both cost the same. Old links, saved sessions
     and render emails keep the scheme they were made with.
   - Search suggestions as you type, from the 2nd letter, through MapTiler
     (the same key as the satellite map; read from the map style when the
     section has no separate key). Photon took 7 s or timed out on the live
     site, and the section was set to Nominatim, which may not be used as
     you type, so there were no suggestions at all. Eircodes and UK
     postcodes keep their own lookups. Any MapTiler failure drops to the
     section's own geocoder, as before.
   - Etsy mode back in (it was in the 9 Oct B5.63.x builds for
     mountedmaps.app, but the Shopify line went B5.62 -> B5.63 colour
     schemes without it). Same hooks H1-H5 and roomBase, all gated on
     settings "mode": "etsy", so they do nothing on Shopify. One file again
     for both sites.
   B5.70.2: terrain despeckle (14 Oct, apply-despeckle.js). Some browsers add noise to
   canvas pixel reads (privacy protection). One unit of noise in a terrain
   tile's red byte is 256 m, which drew thin cliffs and sheets through the
   model (Bahia de Banderas, 14 Oct). A sample more than 100 m off the median
   of its 8 neighbours is replaced by that median. Real ground never does that
   at this resolution. The Renders tab build column notes it when it happens.
   blank-render guard (12 Oct, apply-guard.js). A render that comes back empty on the
   customer's device no longer becomes an empty room photo in the email or on
   the page: the email goes with no pictures and carries the device info.
   B5.70 (Kevin, 12 Oct): the Generate step summary says "White frame", not
   just "White", so it no longer reads "White · Gallery White". Nothing else.
   B5.69 (Kevin, 12 Oct): the Wood frame below, with the oak a touch darker
   and a finer, more natural grain. B5.68 was never uploaded; use this one.
   B5.68 (Kevin, 12 Oct): a third frame, Wood. Same premium frame shape as
   black and white (printed in wood filament with a wood finish), free like
   the others, on all three sizes. Shopify value "Wood frame". The render
   draws oak: irregular growth rings, fibres and pores, laid out in real
   millimetres so the grain runs unbroken round the ring and over every
   edge, with a light lacquer sheen. Black and white render as before.
   B5.67 (Kevin, 11 Oct): the "not yet" nudge. Tapping a step that is not
   open yet shakes the step you are on (0.5s) with a blue glow that follows
   its outline, rings its Next button twice, and lights up the tapped step's
   "Pick a ... first" line in blue. On a phone the tapped chip does the same.
   Before an area is chosen it is the area banner that shakes. Reduced motion
   keeps the glow, blue line and brightening, without the shake or ring
   (it has to out-rank a blanket rule in mm-configurator.css). FIRST PASS ONLY: once the customer has
   reached Generate it switches off for the rest of the visit (kept in the
   tab's saved state, and "Start a new model" does not bring it back), so
   going back to adjust a step never sets anything shaking. Locked desktop
   cards now take the tap (pointer-events), or none of this could fire there;
   only the finished step five stays untappable.
   B5.66 (Kevin, 11 Oct): the new taller premium frames. The ring was a flat
   rectangle 10/12/20 mm wide standing 0.6 mm above the land. It is now the
   real printed frame, turned from its measured cross-section: 13 / 16 / 20 mm
   deep, sides flaring wider toward the back, chamfered edges, the map sitting
   in the front recess with the frame face 1.5 mm proud of the lowest land.
   The object's back plane (desk, wall, contact shadow, framing) moved with it
   so the deeper frame stands on the surface instead of sinking through it.
   B5.65 (Kevin, 11 Oct): the white scheme is "Gallery White". Earlier names
   (Monochrome White, White) stay as legacy matches, so Add to cart keeps
   working whichever name Shopify holds at the moment of the switch.
   B5.64 (Kevin, 11 Oct): scheme names in title case, "Natural Colour" and
   "Monochrome White". Matching ignores case, so Shopify values in either
   case still find their variant.
   B5.63 (Kevin, 11 Oct): two colour schemes, one price per size. White &
   Blue is gone. Meadow is now "Natural colour" and White is "Monochrome
   white". Colour no longer changes the price (that lives in Shopify, so the
   +EUR badge on the colour tiles drops off by itself once the variants are
   flat). Variant matching tries the theme setting, the new name and the old
   name, exact before loose, so the Shopify rename and the theme settings can
   change in any order without breaking Add to cart. A saved link, session or
   "Open your model" email that still says White & Blue (or any unknown
   scheme) opens on Natural colour instead of crashing the Colour step.
   B5.62 (7 Oct): postcodes. Full Irish Eircodes, UK postcodes and numeric
   postcodes (75007, 1012 AB, 00-950...) are recognised before the normal
   search. UK goes to postcodes.io; Eircodes only accept an exact match (a
   near-miss used to land on a different Eircode or in Barcelona); numeric
   codes put the visitor's own country first (Shopify.country), then Europe.
   Also: the homepage now sends ?mmq=<lat,lon>&mmn=<name>, so the place
   arrives already picked and named instead of searched a second time.
   B5.61 (7 Oct): homepage search hand-off. /pages/configurator?mmq=<text>
   fills the search box and takes the first match, exactly as if the
   customer had typed it and pressed Enter. The IP lookup is skipped on a
   hand-off so it cannot move the map first, and the parameter comes off
   the address bar afterwards so a refresh does not search again.
   B5.60 (end-to-end test, 5 Oct): the render picture was missing from the
   cart line. The picture was saved under mm-thumb:53.38583,... but the cart
   looked it up under mm-thumb:53.38584,... (the centre moved by a hair between
   render and add-to-cart), so the lookup missed and the add fell back to no
   picture. It now falls back to mm-thumb:last -- the model just built, the same
   fallback the cart drawer already uses -- and logs which one it used.
   B5.59 (Kevin, 5 Oct: "search won't find anywhere and generation crashes"):
   - Photon (the free typeahead geocoder) was answering in 11-17 s. Every
     geocoder call now has a time limit (Photon/Stadia 2.5 s, Nominatim 5 s);
     a slow Photon drops the visit to Nominatim, the same as a dead one.
   - A late answer can no longer move the map. Next gave up after 2.5 s and
     carried on, then Photon's answer landed ~10 s later and moved the pin.
     Every query now has a number; only the newest one may act.
   - Searching a whole country, state or county ("Egypt", "Hawaii") dropped the
     pin on its centre point: desert, volcano, nothing to build. Big areas are
     no longer picked; the customer is asked for a town, street or landmark.
   - A build with genuinely no buildings or streets says so and offers
     "Choose another spot" instead of "Map data did not load. Check your
     connection".
   B5.56: no more empty models where OpenStreetMap is thin (Kevin, 5 Oct: a
   Bhubaneswar render came out with 1 building; the same link rebuilt here has
   234). The Overture building download now retries each request (3 tries,
   backoff), gives big tiles time to arrive on slow phones (timeout scales
   with size), keeps the tiles that did arrive if one fails, retries the whole
   fill once, and no longer needs DecompressionStream or BigInt DataView
   (older iPhones/Androids fell straight back to OSM). Every render now tells
   the mailer how many buildings it had and where they came from: the Renders
   tab 'build' column reads e.g. '2026-10-05-B5.56 · 284 bldg overture'.
   B5.55: the jumps really are instant. The theme sets html{scroll-behavior:
   smooth}, which silently turned every 'auto' scrollIntoView into a slow glide
   (and into nothing at all in a background tab). jumpTo() switches it off for
   the one call. Used by the place-pick jump (B5.54) and the after-gate jump.
   B5.54: "See it in a room" loops -- either swipe direction (and either arrow)
   always reaches the other photo, so opening on the wall never leaves a dead
   direction (Kevin, 4 Oct). Picking a place in the search jumps the page to the
   configurator, centred, on every screen size (Kevin, 4 Oct).
   B5.53: room shots match the live model: rendered without the baked grade
   and lit by the same key light as the live viewer, no warm tint (Kevin: the
   buildings must be as white as the live render). 15/20 cm table photos
   cropped tighter (mm-room-{15,20}-table-v2.jpg). Email gate: marketing
   checkbox removed (Kevin, 4 Oct).
   B5.52: room scenes. The customer's own model is composited onto the
   approved room photo for their size (table + wall). "See it in a room"
   sits next to the enlarge pill; it opens full screen on the wall shot,
   swipe back to the table. The render email gets the same two pictures.
   Wall shot is now square on to the wall (was 25 deg off); 40 cm gets one
   extra baked shot for its lower table photo. Live viewer unchanged.
   Photos: Shopify > Content > Files, mm-room-{15,20,40}-{wall,table}.jpg.
   B5.51: more depth -- buildings x2.4 on their first 20 m (was x1.9 on 12 m),
   flat terrain stretched up to x2.4 more (noise under 3 m left alone), relief
   ceiling 22 mm (was 16), camera and sun a little lower so height shows.
   City parks no longer fill as dense forest: tree cover next to buildings
   is planted at park spacing.
   B5.50: every tree is now a textured pine (four star-shaped tiers, drooping
   tips, dark-to-light shading, three shape variants). Satellite forest is
   filled as densely as a mapped wood on a jittered grid with a soft edge;
   spacing grows evenly when the tree cap would be hit. No invented trees on
   grassland/moor; park/garden scatter kept only where the satellite sees trees.
   B5.49: render email goes to Google (Apps Script) as text/plain; marketing
   opt-in checkbox on the email gate (unticked; only ticked addresses go to
   the Shopify newsletter); tile water/green collectors give up at 6 s, or at
   once when the tab is hidden.
   assets/mm-configurator.js — plain JS, no build step.

   Maps: MapLibre GL JS against OpenFreeMap vector tiles (no key, no limits).
   Search: Photon autocomplete, degrading to Nominatim-on-Enter if it fails.
   3D preview: Three.js, loaded from CDN only when the preview opens. */

(function () {
  'use strict';

  /* Three.js loading.
     Module imports (static or dynamic) from third-party CDNs are blocked in
     some browsers by content blockers; plain <script> tags are not — MapLibre
     loads that way here without trouble. So the primary path is a classic
     script tag in the section, which sets window.THREE (r160 is the last
     release shipping a UMD build). ESM is kept only as a last resort. */
  var THREE_ESM = [
    'https://cdn.jsdelivr.net/npm/three@0.160.0/build/three.module.js',
    'https://unpkg.com/three@0.160.0/build/three.module.js',
    'https://esm.sh/three@0.160.0'
  ];
  var threeCache = null;

  function threeFromEsm(i) {
    if (i >= THREE_ESM.length) {
      var e = new Error('all sources blocked');
      e.phase = 'library';
      return Promise.reject(e);
    }
    return import(THREE_ESM[i]).then(function (mod) {
      var T = mod && (mod.Scene ? mod : mod.default);
      if (!T || !T.Scene) throw new Error('module looks wrong');
      return T;
    }).catch(function (err) {
      if (window.console) {
        console.warn('[mm] three.js ESM source failed:', THREE_ESM[i], err && err.message);
      }
      return threeFromEsm(i + 1);
    });
  }

  function loadThree() {
    if (threeCache) return threeCache;
    threeCache = new Promise(function (resolve, reject) {
      function found() {
        if (window.THREE && window.THREE.Scene) return window.THREE;
        if (window.MM_THREE && window.MM_THREE.Scene) return window.MM_THREE;
        return null;
      }
      var got = found();
      if (got) {
        if (window.console) console.info('[mm] three.js ready (script tag)');
        return resolve(got);
      }
      /* B6.6: the section no longer puts three.js on the page; fetch it here.
         An older section that still has its own tag is simply waited for. */
      var tagFailed = false;
      try {
        if (window.MM_THREE_URL && !document.querySelector('script[data-mm-three]') &&
            !document.querySelector('script[src*="three.min.js"]')) {
          var ts = document.createElement('script');
          ts.src = window.MM_THREE_URL;
          ts.async = true;
          ts.setAttribute('data-mm-three', '');
          ts.onerror = function () { tagFailed = true; };
          (document.head || document.documentElement).appendChild(ts);
          if (window.console) console.info('[mm] three.js requested');
        }
      } catch (eT) {}
      // the script tag may still be in flight — wait for it before falling back
      var waited = 0;
      var poll = setInterval(function () {
        var t = found();
        if (t) {
          clearInterval(poll);
          if (window.console) console.info('[mm] three.js ready (script tag)');
          return resolve(t);
        }
        waited += 120;
        if (tagFailed || waited >= 12000) {
          clearInterval(poll);
          if (window.console) console.info('[mm] three.js script tag absent, trying ESM');
          threeFromEsm(0).then(resolve, reject);
        }
      }, 120);
    });
    threeCache.catch(function () { threeCache = null; });
    return threeCache;
  }

  var D2R = Math.PI / 180;

  /* Build stamp. Shopify caches assets hard, and a stale upload looks exactly
     like a change that did not work -- which has cost several rounds of
     chasing a fix that was already in the file. This says plainly which build
     is running. */
  /* B7.5.0 (1 Nov 2026, Jullian; Kevin: "simplify, make non-important things smaller or get rid of them"):
     no lead line under the heading; no Compare dropdowns (one "See real examples" link under the finishes);
     the name label is one tick box; one map hint that goes after the first drag; the 30-day count and the
     credits smaller; after a model is made the steps fold into one line with Edit; "Your model is ready" gone;
     "Email me my design" (unticked) under Add to cart sends the render email and joins the follow-ups. */
  /* B7.5.1 (1 Nov 2026, Jullian): phone Cancel hidden after a build; "See real examples" on phones too;
     the link stops below the sticky header. */
  /* B7.5.2 (3 Nov 2026, Jullian; Kevin from the 3 Nov audit: 11 of 12 buyers chose Natural Colour and the ads
     show it): Natural Colour is the default finish and the first tile; Gallery White is second. Saved
     sessions, old links and render emails keep the finish they were made with. Nothing else changed. */
  /* B7.5.3 (3 Nov 2026, Jullian; Kevin: "on desktop ... a lot of empty space ... showing each section of what someone
     chose" and "the buildings look a bit tanned" in the room photos): on a desktop the finished model keeps one row
     per choice (Your place, Size, Frame, Colour, Name label), each with Change, instead of the one line with Edit
     (phones keep the one line). Room shots: overhead sky light 0.2 to 0.9 (wall) and 0.35 to 1.0 (table), ambient
     0.035 to 0.08 and 0.05 to 0.1, and the warm multiply tint removed (1,1,1), so roofs read white, not tan. */
  /* B7.5.4 (3 Nov 2026, Jullian): on a wide screen the search box scrolls under the pinned heading
     instead of over it (z-index 3 there; phones unchanged). Nothing else changed. */
  var MM_BUILD = '2026-11-04-B7.5.4';
  /* Etsy mode (B5.63 hooks, back in B5.71). Module-level so buildDom (outside
     init) can read it. Set once in init from cfg.mode; false on every Shopify
     page. */
  var ETSY = false;
  /* Where the room photos live. Unset = the Shopify store's /cdn/shop/files/.
     The Etsy tool site sets settings.roomBase (e.g. "/rooms/"). */
  var ROOM_BASE = null;
  /* Also hung on window, deliberately. Shopify's CDN minifies this file before
     it serves it: comments go, and a local var that nothing ever reads is
     dropped outright -- so the build number disappeared from the served copy,
     which is precisely when you most want to know what is running. A property
     on a global is an observable side effect, so the minifier has to keep it.
     Check a deploy with window.MM_BUILDS in the console, not an md5. */
  (window.MM_BUILDS = window.MM_BUILDS || {}).configurator = MM_BUILD;

  /* B7.3.0 (Kevin, 28 Oct): "1,000+ maps designed on MountedMaps in the last
     30 days", in the loading circle and under See my 3D preview. The number is
     real: the mailer counts every new model (Counter.gs) and writes the last
     30 days to the Shopify record mm_stat/renders once an hour; the section
     hands it over as cfg.recentDesigns {n, at}. Always rounded DOWN to a
     milestone, hidden under 250, and hidden when it has not been refreshed for
     three days, because a stale 30-day count can only overstate. */
  var MM_PROOF_STEPS = [250, 500, 750, 1000, 1500, 2000, 2500, 3000, 4000, 5000,
    7500, 10000, 15000, 20000, 25000, 30000, 40000, 50000, 75000, 100000];
  function mmProofN(cfg) {
    var r = cfg && cfg.recentDesigns, n = r ? Number(r.n) : 0;
    if (!(n >= MM_PROOF_STEPS[0])) return 0;
    var at = Number(r.at) * 1000;
    if (!(at > 0) || Date.now() - at > 3 * 864e5) return 0;
    var m = 0;
    for (var i = 0; i < MM_PROOF_STEPS.length; i++) if (n >= MM_PROOF_STEPS[i]) m = MM_PROOF_STEPS[i];
    return m;
  }
  function mmProofHtml(cfg) {
    var m = mmProofN(cfg);
    if (!m) return '';
    return '<b style="font-weight:700;color:' + MM_ACCENT + '">' +
      String(m).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '+</b> maps designed on MountedMaps in the last 30\u00a0days';
  }

  /* B7.4.0 (Kevin, 28 Oct): landmarks. The map data turns some landmarks into
     a solid block (the Eiffel Tower came out as a 330 m tower block). Where the
     circle takes one in, what the data has standing on its base is left out
     and the designed model below goes in its place (see BUILDINGS, BUILD 2).
     To add one: its centre, the side of its base, its height, the size of the
     block the data usually has for it, and a geometry function. */
  /* Eiffel Tower for the configurator (landmark v1). Pure geometry, no assets.
     U(m): real metres across -> scene units. H(m): real height -> scene units
     (the configurator passes liftH so the tower gets the same lift as every
     building). MIN(mm): real millimetres on the finished model -> scene units,
     so thin parts never drop below what prints and what the eye can see.
     Built at the origin, standing on y = 0, faces along x and z; the caller
     turns it to the real tower and moves it onto the map.
     Shape follows the print-ready tower (what the printer can make): four legs
     with the four great arches, the two platforms, a solid shaft above the
     second floor, the top and the spire. */
  function mmEiffelGeo(THREE, U, H, MIN) {
    var pos = [];
    function tri(a, b, c, cen) {
      var ux = b[0] - a[0], uy = b[1] - a[1], uz = b[2] - a[2];
      var vx = c[0] - a[0], vy = c[1] - a[1], vz = c[2] - a[2];
      var nx = uy * vz - uz * vy, ny = uz * vx - ux * vz, nz = ux * vy - uy * vx;
      var mx = (a[0] + b[0] + c[0]) / 3 - cen[0], my = (a[1] + b[1] + c[1]) / 3 - cen[1],
          mz = (a[2] + b[2] + c[2]) / 3 - cen[2];
      if (nx * mx + ny * my + nz * mz < 0) { var t = b; b = c; c = t; }   // face outwards
      pos.push(a[0], a[1], a[2], b[0], b[1], b[2], c[0], c[1], c[2]);
    }
    function quad(a, b, c, d, cen) { tri(a, b, c, cen); tri(a, c, d, cen); }
    /* One convex block between two 4-point rings (same corner order). */
    function block(A, B, capA, capB) {
      var cen = [0, 0, 0], i;
      for (i = 0; i < 4; i++) {
        cen[0] += (A[i][0] + B[i][0]) / 8; cen[1] += (A[i][1] + B[i][1]) / 8; cen[2] += (A[i][2] + B[i][2]) / 8;
      }
      for (i = 0; i < 4; i++) { var j = (i + 1) % 4; quad(A[i], A[j], B[j], B[i], cen); }
      if (capA !== false) quad(A[0], A[1], A[2], A[3], cen);
      if (capB !== false) quad(B[0], B[1], B[2], B[3], cen);
    }
    function chain(rings) {
      for (var k = 0; k + 1 < rings.length; k++) block(rings[k], rings[k + 1], k === 0, k + 2 === rings.length);
    }
    function sq(x0, x1, z0, z1, y) { return [[x0, y, z0], [x0, y, z1], [x1, y, z1], [x1, y, z0]]; }
    function slab(half, y0, y1) { block(sq(-half, half, -half, half, y0), sq(-half, half, -half, half, y1)); }

    /* Outer half-width of the tower at real height h (metres). Base 125 m
       square; about 71 m wide at the first floor, 40 m at the second, the
       curve of the real tower between. */
    var F1 = 57.6, F2 = 115.7, F3 = 276;
    function W(h) {
      if (h <= F2) return 62.5 * Math.exp(-h / 101.6);
      var t = Math.min(1, (h - F2) / (F3 - F2));
      return 7.5 + (20 - 7.5) * Math.pow(1 - t, 1.55);
    }
    /* Width of one leg (metres): 26 m at the ground, 11 m at the second floor. */
    function L(h) { return h <= F1 ? 26 - 9 * (h / F1) : 17 - 6 * ((h - F1) / (F2 - F1)); }
    var minLeg = MIN(0.9);

    /* Four legs, ground to the second floor, curving in as they rise. */
    var hs = [0, 6, 12, 18, 24, 30, 36, 42, 48, 54, F1, 66, 76, 86, 96, 106, F2 + 1];
    [[1, 1], [1, -1], [-1, 1], [-1, -1]].forEach(function (c) {
      chain(hs.map(function (h) {
        var w = U(W(h)), l = Math.max(U(L(h)), minLeg), y = h === 0 ? -MIN(0.2) : H(h);
        var xo = c[0] * w, xi = c[0] * (w - l), zo = c[1] * w, zi = c[1] * (w - l);
        return sq(Math.min(xo, xi), Math.max(xo, xi), Math.min(zo, zi), Math.max(zo, zi), y);
      }));
    });

    /* The four great arches, one in each face, springing from the legs near
       the ground and meeting the first floor at the top. */
    var hS = 4, hA = 52.5, T = Math.max(U(4.5), MIN(0.5)), D = Math.max(U(3.5), MIN(0.45));
    var S = W(hS) - L(hS) + 2;                         // into the legs
    var N = 18;
    [0, 1, 2, 3].forEach(function (f) {
      var rings = [];
      for (var k = 0; k <= N; k++) {
        var th = Math.PI * k / N;                        // 0..pi across the face
        var s = -Math.cos(th) * S, a = hS + (hA - hS) * Math.sin(th);
        // normal of the arch line, in the face plane (s, height)
        var ns = -Math.cos(th) * (hA - hS), na = Math.sin(th) * S;   // outward: the band grows up and into the legs
        var nl = Math.hypot(ns, na) || 1; ns /= nl; na /= nl;
        var y0 = H(a), s0 = U(s);
        var y1 = y0 + na * T, s1 = s0 + ns * T;
        var o0 = U(W(a)) - U(0.4), o1 = U(W(Math.max(0, a + na * 4.5))) - U(0.4);
        var r = [[o0, y0, s0], [o1, y1, s1], [o1 - D, y1, s1], [o0 - D, y0, s0]];
        // turn the face: f = 0 +x, 1 +z, 2 -x, 3 -z
        rings.push(r.map(function (p) {
          if (f === 0) return [p[0], p[1], p[2]];
          if (f === 1) return [p[2], p[1], p[0]];
          if (f === 2) return [-p[0], p[1], -p[2]];
          return [-p[2], p[1], -p[0]];
        }));
      }
      chain(rings);
    });

    /* First floor: the frieze band over the arches, then the deck. */
    slab(U(W(50)) + U(0.6), H(50), H(F1));
    slab(U(W(F1)) + U(4), H(F1), H(F1 + 6));
    /* Second floor deck. */
    slab(U(W(F2)) + U(3), H(F2), H(F2 + 5));

    /* Above the second floor the legs close up into one solid shaft (as
       printed), but the four corner legs still stand proud of a recessed core,
       so each face keeps the groove that makes it read as the tower and not
       as an obelisk. */
    var up = [F2 + 5, 130, 150, 170, 190, 210, 230, 250, F3];
    chain(up.map(function (h) { var w = Math.max(U(W(h)) * 0.7, MIN(0.4)); return sq(-w, w, -w, w, H(h)); }));
    [[1, 1], [1, -1], [-1, 1], [-1, -1]].forEach(function (c) {
      chain(up.map(function (h) {
        var w = Math.max(U(W(h)), MIN(0.5)), l = Math.max(w * 0.42, MIN(0.25));
        var xo = c[0] * w, xi = c[0] * (w - l), zo = c[1] * w, zi = c[1] * (w - l);
        return sq(Math.min(xo, xi), Math.max(xo, xi), Math.min(zo, zi), Math.max(zo, zi), H(h));
      }));
    });

    /* The top: platform, lantern, cap, then the spire to 330 m. */
    slab(Math.max(U(9), MIN(0.6)), H(F3), H(F3 + 8));
    slab(Math.max(U(6), MIN(0.45)), H(F3 + 8), H(F3 + 18));
    slab(Math.max(U(4), MIN(0.4)), H(F3 + 18), H(F3 + 24));
    var sp0 = Math.max(U(1.6), MIN(0.3)), sp1 = Math.max(U(0.8), MIN(0.22));
    block(sq(-sp0, sp0, -sp0, sp0, H(F3 + 24)), sq(-sp1, sp1, -sp1, sp1, H(330)));

    var g = new THREE.BufferGeometry();
    g.setAttribute('position', new THREE.Float32BufferAttribute(pos, 3));
    g.computeVertexNormals();
    return g;
  }
  var MM_LANDMARKS = [
    { id: 'eiffel', name: 'Eiffel Tower', lat: 48.85826, lon: 2.29450, turn: 45,
      clearM: 64, baseM: 125, heightM: 330, footMinM2: 6000, footMaxM2: 26000, geo: mmEiffelGeo }
  ];

  /* ======================= B5.52 · ROOM SCENES ===========================
     The customer's own model, composited live onto the approved room photo
     for their size (Kevin, 4 Oct). Table shot first; tapping it opens the wall
     shot full screen; swipe back to the table.

     Numbers are measured off the approved sheet (scenes/v6/mm-scenes-v13.jpg):
       x, y  where the model's centre sits, % of the photo
       w     the model's outer width, % of the photo width
     Table widths are the approved look, which is about 12% over true scale
     (Kevin chose that, 4 Oct); walls are true scale. Caption says "about real
     size", never "to scale".

     The photos are plain files in Shopify > Content > Files, named exactly as
     below, and are read from /cdn/shop/files/ on the store's own domain -- same
     origin, so the canvas can always be read back for the email. The size
     block's old desk/wall photo settings are deliberately NOT used: they may
     still hold the previous photos, and these numbers only fit these files. */
  var MM_ROOMS = {
    15: { wall:  { file: 'mm-room-15-wall.jpg',  x: 46.53, y: 28.37, w: 45.13 },
          table: { file: 'mm-room-15-table-v2.jpg', x: 57.08, y: 61.06, w: 62.95, cam: 'hero' } },   // B5.53: tighter
    20: { wall:  { file: 'mm-room-20-wall.jpg',  x: 46.15, y: 32.69, w: 47.41 },
          table: { file: 'mm-room-20-table-v2.jpg', x: 50.00, y: 58.00, w: 71.89, cam: 'hero' } },   // B5.53: tighter
    40: { wall:  { file: 'mm-room-40-wall.jpg',  x: 49.74, y: 29.87, w: 28.96 },
          table: { file: 'mm-room-40-table.jpg', x: 61.69, y: 52.49, w: 42.90, cam: 'low' } }
  };
  /* ===================== B6.4 · ROOM SHOTS (MMRooms R1) ===================== */
  /* MM ROOMS R1.3 (2026-10-25) - room shots, rebuilt.
     R1.3 (Kevin, 25 Oct, iPhone wall shot: "Shadow render is really
     blocky"): the blur used where the browser has no canvas filter (Safari)
     shrank the shadow in one big jump; Safari skips pixels doing that, so the
     blown-up shadow had steps. softBlur() now shrinks in exact halves, blurs
     the small image in JS and grows it back in exact doubles: smooth on every
     browser. Chrome and Firefox still use the canvas filter, unchanged.
     R1.2 (Kevin, 25 Oct: "the cast shadow can look a bit more real no?"):
     table shadows now copy the real props' shadows in each photo (mug, pot,
     vase), measured off the photos: a warm shadow colour (the wood gets darker
     AND richer, red drops least, blue most: ratio r, r^1.5, r^1.9), darkest and
     sharpest where the frame meets the table, softer and lighter further out.
     See shadeTable() and the "shade" entry of each table photo.
     R1.1 (Kevin, 25 Oct, after R1 went live): "Shadow is good, but the tiny
     shadow around the edge where there wouldn't be a shadow in real life makes
     it look bad." Shadows now only fall on the side facing away from the
     light: the window side of the frame gets no dark line at all. The cast
     shadow itself is unchanged. See sideMask().
     Two pictures per size, each made for that size's own room photo:
     - WALL: a true bird's-eye view. Orthographic camera straight down onto the
       map, so the frame is a perfect circle with no keystone (Kevin, 25 Oct:
       "perfectly on the wall ... from directly above"). Lit by the room's own
       window light from the left, so the buildings throw short shadows to the
       right; the frame throws a soft shadow onto the wall.
     - TABLE: the model lying on the table, seen from the photo's own camera
       angle and lit from the photo's window, with a real cast shadow and a
       contact shadow where the frame meets the wood.
     The room photos are plain files in Shopify > Content > Files (names below).
     Placement numbers are fractions of the square photo. */
  (function () {
    'use strict';
    var V = '2026-10-25-R1.3';

    /* key: light position (scene units, model centre at 0). Wall camera looks
       straight down: screen right = +X, screen up = -Z. */
    var WALL_LIGHT = { key: [-8.85, 4.23, -1.88], keyI: 3.1, keyRadius: 3, skyI: 0.9, hemiI: 0.08, fillI: 0.05, env: 0.4 };
    var TABLE_LIGHT = { key: [-7, 6, -5], keyI: 2.8, keyRadius: 4, skyI: 1.0, hemiI: 0.1, fillI: 0.08, env: 0.6, shadowRadius: 10 };

    var PLATES = {};          // filled by setPlates() from the tuned table

    function setPlates(p) { PLATES = p || {}; }
    function forSize(cm) {
      var best = null, gap = 1e9;
      Object.keys(PLATES).forEach(function (k) {
        var d = Math.abs(+k - (+cm || 0));
        if (d < gap) { gap = d; best = PLATES[k]; }
      });
      return gap <= 3 ? best : null;
    }

    /* ---------------------------------------------------------------- passes
       c = { THREE, renderer, world, key, sky, fill, hemi, catcher, hide: [],
             models: [meshes], outer, plateBottom, frameTop, read(cam) -> canvas }
       read() draws the renderer's canvas into a fresh 2D canvas at the size the
       caller wants, so the passes survive the next render. */
    function aim(c, spec, cam) {
      var T = c.THREE;
      var look = new T.Vector3(0, c.plateBottom + (c.frameTop - c.plateBottom) * 0.5, 0);
      var el = (spec.el || 30) * Math.PI / 180, az = (spec.az || 0) * Math.PI / 180;
      var d = new T.Vector3(Math.sin(az) * Math.cos(el), Math.sin(el), Math.cos(az) * Math.cos(el));
      var fill = spec.fill || 0.8;
      var dist = c.outer / (2 * fill * Math.tan((spec.fov || 24) / 2 * Math.PI / 180));
      cam.fov = spec.fov || 24; cam.aspect = 1;
      cam.near = Math.max(0.5, dist - 40); cam.far = dist + 60;
      cam.position.copy(look).addScaledVector(d, dist);
      cam.up.set(0, 1, 0);
      cam.lookAt(look);
      cam.updateProjectionMatrix(); cam.updateMatrixWorld(true);
      return cam;
    }
    function wallCam(c) {
      var T = c.THREE, h = c.outer / 2 / 0.9;
      var cam = new T.OrthographicCamera(-h, h, h, -h, 0.1, 400);
      cam.position.set(0, c.plateBottom + 120, 0);
      cam.up.set(0, 0, -1);
      cam.lookAt(0, c.plateBottom, 0);
      cam.updateProjectionMatrix(); cam.updateMatrixWorld(true);
      return cam;
    }
    /* Where the footprint (the frame's outer circle at its base) lands in a
       shot, as fractions of the frame: centre, width, height. */
    function footGeo(c, cam) {
      var T = c.THREE, v = new T.Vector3(), lo = 1e9, hi = -1e9, top = 1e9, bot = -1e9;
      cam.updateMatrixWorld(true);
      cam.matrixWorldInverse.copy(cam.matrixWorld).invert();
      for (var a = 0; a < 144; a++) {
        var t = a / 144 * Math.PI * 2;
        v.set(Math.cos(t) * c.outer / 2, c.plateBottom, Math.sin(t) * c.outer / 2).project(cam);
        var x = (v.x + 1) / 2, y = (1 - v.y) / 2;
        if (x < lo) lo = x; if (x > hi) hi = x; if (y < top) top = y; if (y > bot) bot = y;
      }
      return { cx: (lo + hi) / 2, cy: (top + bot) / 2, w: hi - lo, h: bot - top };
    }

    /* Which way the key light throws shadows across the table, as a unit vector
       in screen space (x right, y down). Called inside withLights, after a
       render, so the key sits at the shot's own light position. */
    function shadowDir(c, cam) {
      try {
        var T = c.THREE, kp = new T.Vector3(), tg = new T.Vector3();
        c.key.getWorldPosition(kp);
        if (c.key.target && c.key.target.getWorldPosition) c.key.target.getWorldPosition(tg);
        var lx = kp.x - tg.x, lz = kp.z - tg.z, n = Math.sqrt(lx * lx + lz * lz);
        if (!(n > 1e-6)) return null;
        var s = c.outer / 4;
        var a = new T.Vector3(0, c.plateBottom, 0).project(cam);
        var b = new T.Vector3(-lx / n * s, c.plateBottom, -lz / n * s).project(cam);
        var dx = (b.x - a.x) / 2, dy = -(b.y - a.y) / 2, m = Math.sqrt(dx * dx + dy * dy);
        return m > 1e-9 ? [dx / m, dy / m] : null;
      } catch (e) { return null; }
    }

    function withLights(c, L, fn) {
      var keep = [];
      function set(o, k, v) { if (!o) return; keep.push([o, k, o[k]]); o[k] = v; }
      if (c.key) {
        keep.push([c.key.position, 'xyz', c.key.position.clone()]);
        c.key.position.set(L.key[0], L.key[1], L.key[2]);
        set(c.key, 'intensity', L.keyI);
        if (c.key.shadow) { keep.push([c.key.shadow, 'radius', c.key.shadow.radius]); c.key.shadow.radius = L.keyRadius; }
      }
      set(c.sky, 'intensity', L.skyI);
      set(c.hemi, 'intensity', L.hemiI);
      set(c.fill, 'intensity', L.fillI);
      (c.models || []).forEach(function (m) {
        (Array.isArray(m.material) ? m.material : [m.material]).forEach(function (mt) {
          if (mt && mt.envMapIntensity != null) {
            if (mt.userData.mmEnv0 == null) mt.userData.mmEnv0 = mt.envMapIntensity;
            keep.push([mt, 'envMapIntensity', mt.envMapIntensity]);
            mt.envMapIntensity = mt.userData.mmEnv0 * L.env;
          }
        });
      });
      var hid = [];
      (c.hide || []).forEach(function (o) { if (o) { hid.push([o, o.visible]); o.visible = false; } });
      try { return fn(); }
      finally {
        hid.forEach(function (h) { h[0].visible = h[1]; });
        for (var i = keep.length - 1; i >= 0; i--) {
          var k = keep[i];
          if (k[1] === 'xyz') k[0].copy(k[2]); else k[0][k[1]] = k[2];
        }
      }
    }

    /* B6.5.1: whatever happens in the passes, the live model gets its shadow
       floor and exposure back. */
    function passes(c, P, px) {
      var exp0 = c.renderer.toneMappingExposure, cat0 = c.catcher ? c.catcher.visible : null;
      try { return passesRaw(c, P, px); }
      finally {
        c.renderer.toneMappingExposure = exp0;
        if (c.catcher && cat0 != null) c.catcher.visible = cat0;
      }
    }
    function passesRaw(c, P, px) {
      var T = c.THREE, out = {};
      var exp0 = c.renderer.toneMappingExposure;
      // --- wall: straight down
      if (P.wall) {
        var wc = wallCam(c);
        c.renderer.toneMappingExposure = P.wall.exposure || 1;
        withLights(c, WALL_LIGHT, function () {
          if (c.catcher) { c.catcher.visible = false; }
          c.renderer.render(c.world, wc);
          out.wall = { img: c.read(px), geo: footGeo(c, wc) };
        });
      }
      // --- table: the photo's own camera
      if (P.table) {
        var tc = aim(c, P.table, new T.PerspectiveCamera(24, 1, 1, 200));
        var L = Object.assign({}, TABLE_LIGHT, P.table.light || {});
        c.renderer.toneMappingExposure = P.table.exposure || 1;
        withLights(c, L, function () {
          if (c.catcher) c.catcher.visible = false;
          c.renderer.render(c.world, tc);
          out.table = { img: c.read(px), geo: footGeo(c, tc) };
          // shadow only: the model still casts but draws nothing
          if (c.catcher) {
            var cat = c.catcher, keep = [cat.visible, cat.material.opacity, cat.position.y];
            var sky = c.sky ? c.sky.castShadow : null, fil = c.fill ? c.fill.castShadow : null;
            var rad = c.key && c.key.shadow ? c.key.shadow.radius : null;
            var mats = [];
            (c.models || []).forEach(function (m) {
              (Array.isArray(m.material) ? m.material : [m.material]).forEach(function (mt) {
                mats.push([mt, mt.colorWrite, mt.depthWrite]); mt.colorWrite = false; mt.depthWrite = false;
              });
            });
            try {
              if (c.sky) c.sky.castShadow = false;
              if (c.fill) c.fill.castShadow = false;
              if (c.key && c.key.shadow) c.key.shadow.radius = L.shadowRadius || 10;
              cat.visible = true; cat.material.opacity = 1;
              cat.position.y = c.plateBottom - 0.002; cat.updateMatrixWorld(true);
              c.renderer.render(c.world, tc);
              out.shadow = { img: c.read(px), dir: shadowDir(c, tc) };
            } finally {
              /* B6.5.1: newest first, so a material shared by several meshes
                 ends on the state it had before the first one changed it. */
              for (var mi = mats.length - 1; mi >= 0; mi--) {
                mats[mi][0].colorWrite = mats[mi][1]; mats[mi][0].depthWrite = mats[mi][2];
              }
              if (c.sky) c.sky.castShadow = sky;
              if (c.fill) c.fill.castShadow = fil;
              if (rad != null) c.key.shadow.radius = rad;
              cat.visible = keep[0]; cat.material.opacity = keep[1]; cat.position.y = keep[2]; cat.updateMatrixWorld(true);
            }
          }
        });
      }
      c.renderer.toneMappingExposure = exp0;
      return out;
    }

    /* -------------------------------------------------------------- composite */
    var FILTER_OK = (function () {
      try {
        var cv = document.createElement('canvas'); cv.width = cv.height = 8;
        var g = cv.getContext('2d');
        if (typeof g.filter !== 'string') return false;
        g.filter = 'blur(2px)'; g.fillStyle = '#000'; g.fillRect(3, 3, 2, 2);
        var d = g.getImageData(0, 0, 8, 8).data;
        return d[3] > 0 && d[3] < 255;             // a corner pixel picked up some blur
      } catch (e) { return false; }
    })();
    function canvas(w, h) { var c = document.createElement('canvas'); c.width = w; c.height = h || w; return c; }
    /* Gaussian blur on every browser: the canvas filter where it is real,
       otherwise softBlur() (Safari). */
    function blurred(src, sigma) {
      var w = src.width, h = src.height, out = canvas(w, h), g = out.getContext('2d');
      if (sigma < 0.6) { g.drawImage(src, 0, 0); return out; }
      if (FILTER_OK) { g.filter = 'blur(' + sigma.toFixed(2) + 'px)'; g.drawImage(src, 0, 0); g.filter = 'none'; return out; }
      out.width = 0;
      return softBlur(src, sigma);
    }
    /* R1.3: shrink in exact halves (each half averages 2 x 2 pixels, nothing
       skipped) until the blur is 3 to 6 px wide, blur that small image with
       three box passes (= a Gaussian) on its alpha, then grow back in exact
       doubles. The canvas is padded to a multiple of the shrink so nothing
       shifts. All layers it blurs are black with alpha. */
    function softBlur(src, sigma) {
      var w = src.width, h = src.height, f = 1;
      while (f < 32 && sigma / (f * 2) >= 3) f *= 2;
      var cur = canvas(Math.ceil(w / f) * f, Math.ceil(h / f) * f), s;
      cur.getContext('2d').drawImage(src, 0, 0);
      for (s = f; s > 1; s /= 2) cur = rescale(cur, cur.width / 2, cur.height / 2);
      boxBlurAlpha(cur, sigma / f);
      for (s = 1; s < f; s *= 2) cur = rescale(cur, cur.width * 2, cur.height * 2);
      var out = canvas(w, h);
      out.getContext('2d').drawImage(cur, 0, 0);
      cur.width = cur.height = 0;
      return out;
    }
    function rescale(cv, w, h) {
      var n = canvas(w, h), g = n.getContext('2d');
      g.imageSmoothingEnabled = true;
      g.drawImage(cv, 0, 0, w, h);
      cv.width = cv.height = 0;                          // iOS frees canvas memory on resize
      return n;
    }
    function boxBlurAlpha(cv, sig) {
      var w = cv.width, h = cv.height, g = cv.getContext('2d'), id = g.getImageData(0, 0, w, h), d = id.data;
      var N = w * h, a = new Float32Array(N), t = new Float32Array(N), i;
      for (i = 0; i < N; i++) a[i] = d[i * 4 + 3];
      var r = Math.max(1, Math.round((Math.sqrt(4 * sig * sig + 1) - 1) / 2));   // 3 boxes of 2r+1 ~ sigma
      for (var p = 0; p < 3; p++) { boxRun(a, t, w, h, r, 1, w); boxRun(t, a, h, w, r, w, 1); }
      for (i = 0; i < N; i++) { var o = i * 4; d[o] = d[o + 1] = d[o + 2] = 0; d[o + 3] = a[i] + 0.5 | 0; }
      g.putImageData(id, 0, 0);
    }
    /* one box pass along lines: len samples per line, step between samples,
       lines apart by `jump`; zeros outside the image (like the canvas filter). */
    function boxRun(s, o, len, lines, r, step, jump) {
      var n = 2 * r + 1;
      for (var L = 0; L < lines; L++) {
        var base = L * jump, acc = 0, x;
        for (x = 0; x < r && x < len; x++) acc += s[base + x * step];
        for (x = 0; x < len; x++) {
          if (x + r < len) acc += s[base + (x + r) * step];
          o[base + x * step] = acc / n;
          if (x - r >= 0) acc -= s[base + (x - r) * step];
        }
      }
    }

    /* R1.1: where a shadow is allowed. Seen from the frame's centre, a shadow
       can only fall on the half facing away from the light; it fades in from
       nothing at the two sideways points to full strength (smoothstep on the
       cosine between "away from the light" and the direction from the centre,
       lo..hi), so it tapers off smoothly round the frame instead of stopping at
       a line. The light half of the frame gets exactly nothing. Worked in circle
       space (y / q), where the footprint ellipse is a circle; built at 256 px
       (the mask is smooth) and scaled up. */
    function sideMask(S, cx, cy, rx, ry, dir, lo, hi) {
      var q = Math.max(0.05, ry / rx), dx = dir[0], dy = dir[1] / q, dn = Math.sqrt(dx * dx + dy * dy);
      dx /= dn; dy /= dn;
      var N = 256, k = S / N, sm = canvas(N), sg = sm.getContext('2d'), id = sg.createImageData(N, N), D = id.data;
      for (var j = 0; j < N; j++) {
        var Y = ((j + 0.5) * k - cy) / q;
        for (var i = 0; i < N; i++) {
          var X = (i + 0.5) * k - cx, r = Math.sqrt(X * X + Y * Y);
          var t = ((r > 1e-6 ? (X * dx + Y * dy) / r : 1) - lo) / (hi - lo);
          t = t < 0 ? 0 : t > 1 ? 1 : t;
          D[(j * N + i) * 4 + 3] = Math.round(t * t * (3 - 2 * t) * 255);
        }
      }
      sg.putImageData(id, 0, 0);
      var M = canvas(S), g = M.getContext('2d');
      g.imageSmoothingEnabled = true; g.imageSmoothingQuality = 'high';
      g.drawImage(sm, 0, 0, S, S);
      return M;
    }
    function keepIn(layer, mask) {
      var g = layer.getContext('2d');
      g.globalCompositeOperation = 'destination-in'; g.drawImage(mask, 0, 0); g.globalCompositeOperation = 'source-over';
      return layer;
    }
    /* R1.2: the table shadow, matched to the props in the photo.
       Z = { umbra, exp: [r, g, b], k, nearBlur, farBlur, reach, fade } (cm).
       Near the frame the 3D shadow is lightly blurred (sharp, like a real
       contact); by `reach` cm out it is the widely blurred one, `fade` lighter.
       The contact shadow is added on top. All of it is kept to the side away
       from the light (mask), then laid on the photo by multiplying with the
       photo's own shadow colour, so the wood darkens the way it does under the
       mug, pot or vase next to it. */
    function shadeTable(g, S, Z, sh, CB, ctK, mask, ox, oy, dw, ppc, cx, cy, rx, ry) {
      var L0 = canvas(S), l0 = L0.getContext('2d');
      l0.drawImage(sh.img, ox, oy, dw, dw);
      var near = blurred(L0, (Z.nearBlur || 0.12) * ppc), far = blurred(L0, (Z.farBlur || 1) * ppc);
      var q = Math.max(0.05, ry / rx), W = canvas(S), wg = W.getContext('2d');
      wg.setTransform(1, 0, 0, q, cx, cy);
      var rg = wg.createRadialGradient(0, 0, rx, 0, 0, rx + (Z.reach || 3) * ppc);
      rg.addColorStop(0, 'rgba(0,0,0,0)'); rg.addColorStop(1, 'rgba(0,0,0,1)');
      wg.fillStyle = rg; wg.fillRect(-4 * S, -4 * S / q, 8 * S, 8 * S / q);
      var ng = near.getContext('2d'); ng.globalCompositeOperation = 'destination-out'; ng.drawImage(W, 0, 0);
      var fg = far.getContext('2d'); fg.globalCompositeOperation = 'destination-in'; fg.drawImage(W, 0, 0);
      var A = canvas(S), ag = A.getContext('2d');
      ag.globalCompositeOperation = 'lighter';
      ag.drawImage(near, 0, 0);
      ag.globalAlpha = 1 - (Z.fade == null ? 0.4 : Z.fade); ag.drawImage(far, 0, 0);
      if (CB && ctK > 0) { ag.globalAlpha = ctK; ag.drawImage(CB, 0, 0); }
      ag.globalAlpha = 1;
      if (mask) keepIn(A, mask);
      var u = Z.umbra == null ? 0.6 : Z.umbra, e = Z.exp || [1, 1.5, 1.9];
      ag.globalCompositeOperation = 'source-in';
      ag.fillStyle = 'rgb(' + e.map(function (x) { return Math.round(Math.pow(u, x) * 255); }).join(',') + ')';
      ag.fillRect(0, 0, S, S);
      var M = canvas(S), mg = M.getContext('2d');
      mg.fillStyle = '#fff'; mg.fillRect(0, 0, S, S);
      mg.globalAlpha = Z.k == null ? 1 : Z.k; mg.drawImage(A, 0, 0); mg.globalAlpha = 1;
      g.globalCompositeOperation = 'multiply'; g.drawImage(M, 0, 0); g.globalCompositeOperation = 'source-over';
      [L0, near, far, W, A, M].forEach(function (c) { c.width = c.height = 0; });   // iOS frees canvas memory on resize
    }
    var NOISE = null;
    function noise() {
      if (NOISE) return NOISE;
      NOISE = canvas(256); var g = NOISE.getContext('2d'), id = g.createImageData(256, 256), d = id.data;
      for (var i = 0; i < d.length; i += 4) {
        var n = 128 + (Math.random() + Math.random() + Math.random() - 1.5) * 60;
        d[i] = d[i + 1] = d[i + 2] = n; d[i + 3] = 255;
      }
      g.putImageData(id, 0, 0); return NOISE;
    }

    /* shot: 'wall' | 'table'. pass: passes()[shot]; sh: passes().shadow (table).
       Returns a canvas S x S. */
    function composite(plateImg, P, shot, pass, sh, S) {
      var Q = P[shot], out = canvas(S), g = out.getContext('2d');
      g.imageSmoothingEnabled = true; g.imageSmoothingQuality = 'high';
      g.drawImage(plateImg, 0, 0, S, S);
      var src = pass.img, geo = pass.geo, N = src.width;
      var k = (Q.w * S) / (geo.w * N);                       // render px -> output px
      var dw = N * k, ox = Q.cx * S - geo.cx * dw, oy = Q.cy * S - geo.cy * dw;
      var ppc = Q.w * S / Q.cm;                              // output px per cm at the model
      var cx = Q.cx * S, cy = Q.cy * S, rx = Q.w * S / 2, ry = rx * (geo.h / geo.w);
      var cs = Q.cast || {}, ct = Q.contact || {};

      // R1.1: shadows only on the side facing away from the light
      var dir = null;
      if (Q.sideOnly !== false) {
        if (shot === 'table' && sh && sh.dir) dir = sh.dir;
        else if (shot === 'wall' && (cs.dx || cs.dy)) {
          var dl = Math.sqrt((cs.dx || 0) * (cs.dx || 0) + (cs.dy || 0) * (cs.dy || 0));
          dir = [(cs.dx || 0) / dl, (cs.dy || 0) / dl];
        }
      }
      var mask = null;
      if (dir) {
        var fade = Q.sideFade || [0, 0.5];
        try { mask = sideMask(S, cx, cy, rx, ry, dir, fade[0], fade[1]); } catch (eM) { mask = null; }
      }

      var Z = (shot === 'table' && Q.shade && sh && sh.img) ? Q.shade : null;
      // cast shadow (the wall's is an offset ellipse, already on the shadow side)
      if (cs.k > 0 && !Z) {
        var L = canvas(S), lg = L.getContext('2d');
        if (shot === 'wall') {
          lg.fillStyle = '#000';
          lg.beginPath(); lg.ellipse(cx + (cs.dx || 0) * ppc, cy + (cs.dy || 0) * ppc, rx, ry, 0, 0, Math.PI * 2); lg.fill();
        } else if (sh && sh.img) {
          lg.drawImage(sh.img, ox, oy, dw, dw);
        }
        var B = blurred(L, (cs.blur || 1) * ppc);
        if (mask && shot === 'table') keepIn(B, mask);
        g.globalAlpha = cs.k; g.drawImage(B, 0, 0); g.globalAlpha = 1;
      }
      // contact shadow: the footprint, grown a touch and softened
      if (ct.k > 0) {
        var C = canvas(S), cg = C.getContext('2d'), gr = (ct.grow || 0) * ppc;
        cg.fillStyle = '#000';
        cg.beginPath(); cg.ellipse(cx + (ct.dx || 0) * ppc, cy + (ct.dy || 0) * ppc, rx + gr, ry + gr * (ry / rx), 0, 0, Math.PI * 2); cg.fill();
        var CB = blurred(C, (ct.blur || 0.3) * ppc);
        if (mask) keepIn(CB, mask);
        if (!Z) { g.globalAlpha = ct.k; g.drawImage(CB, 0, 0); g.globalAlpha = 1; }
      }
      if (Z) {
        try { shadeTable(g, S, Z, sh, ct.k > 0 ? CB : null, ct.k || 0, mask, ox, oy, dw, ppc, cx, cy, rx, ry); }
        catch (eZ) {                                         // fall back to the R1.1 grey shadow
          g.globalCompositeOperation = 'source-over'; g.globalAlpha = 1;
          if (cs.k > 0) {
            var L1 = canvas(S); L1.getContext('2d').drawImage(sh.img, ox, oy, dw, dw);
            var B1 = blurred(L1, (cs.blur || 1) * ppc); if (mask) keepIn(B1, mask);
            g.globalAlpha = cs.k; g.drawImage(B1, 0, 0); g.globalAlpha = 1;
          }
          if (CB && ct.k > 0) { g.globalAlpha = ct.k; g.drawImage(CB, 0, 0); g.globalAlpha = 1; }
          if (window.console) console.warn('[mm] photo shadow failed, grey shadow used:', eZ && eZ.message);
        }
      }
      // the model, tinted to the room's light and given the photo's grain
      var M = canvas(S), mg = M.getContext('2d');
      mg.imageSmoothingEnabled = true; mg.imageSmoothingQuality = 'high';
      mg.drawImage(src, ox, oy, dw, dw);
      if (Q.tint) {
        mg.globalCompositeOperation = 'multiply';
        mg.fillStyle = 'rgb(' + Q.tint.map(function (v) { return Math.round(v * 255); }).join(',') + ')';
        mg.fillRect(0, 0, S, S);
        mg.globalCompositeOperation = 'destination-in';
        mg.drawImage(src, ox, oy, dw, dw);
      }
      if (Q.grain > 0) {
        mg.globalCompositeOperation = 'source-atop';
        mg.globalAlpha = Q.grain;
        var pat = mg.createPattern(noise(), 'repeat');
        mg.fillStyle = pat; mg.globalCompositeOperation = 'overlay';
        mg.fillRect(0, 0, S, S);
        mg.globalAlpha = 1;
        mg.globalCompositeOperation = 'destination-in';
        mg.drawImage(src, ox, oy, dw, dw);
        mg.globalCompositeOperation = 'source-over';
      }
      g.drawImage(M, 0, 0);
      return out;
    }

    window.MMRooms = { V: V, setPlates: setPlates, forSize: forSize, passes: passes, composite: composite,
                       WALL_LIGHT: WALL_LIGHT, TABLE_LIGHT: TABLE_LIGHT, filterOk: FILTER_OK };
  })();
  if (window.MMRooms) window.MMRooms.setPlates({"15":{"wall":{"file":"mm-room2-15-wall.jpg","cx":0.5,"cy":0.4943,"w":0.3991,"cm":17.0,"exposure":1.25,"tint":[1,1,1],"grain":0.06,"cast":{"dx":2.6,"dy":0.9,"blur":1.3,"k":0.36},"contact":{"k":0.4,"blur":0.25,"grow":0.1}},"table":{"file":"mm-room2-15-table.jpg","cx":0.5238,"cy":0.5238,"w":0.5262,"cm":17.0,"el":26,"fov":24,"exposure":1.25,"tint":[1,1,1],"grain":0.06,"cast":{"k":0.5,"blur":0.5},"contact":{"k":0.55,"blur":0.35,"grow":0.15,"dy":0.2},"shade":{"umbra":0.73,"fade":0.55,"farBlur":1.2,"reach":3,"exp":[1,1.5,1.9]}}},"20":{"wall":{"file":"mm-room2-20-wall-v2.jpg","cx":0.5,"cy":0.397,"w":0.4032,"cm":22.4,"exposure":1.25,"tint":[1,1,1],"grain":0.06,"cast":{"dx":2.6,"dy":0.9,"blur":1.3,"k":0.36},"contact":{"k":0.4,"blur":0.25,"grow":0.1}},"table":{"file":"mm-room2-20-table.jpg","cx":0.4844,"cy":0.5469,"w":0.504,"cm":22.4,"el":40,"fov":24,"exposure":0.9,"tint":[1,1,1],"grain":0.06,"cast":{"k":0.5,"blur":0.5},"contact":{"k":0.55,"blur":0.35,"grow":0.15,"dy":0.2},"shade":{"umbra":0.79,"fade":0.45,"farBlur":1.0,"reach":3,"exp":[1,1.5,1.9]}}},"40":{"wall":{"file":"mm-room2-40-wall.jpg","cx":0.5011,"cy":0.4932,"w":0.3875,"cm":44.0,"exposure":1.25,"tint":[1,1,1],"grain":0.06,"cast":{"dx":2.6,"dy":0.9,"blur":1.3,"k":0.36},"contact":{"k":0.4,"blur":0.25,"grow":0.1}},"table":{"file":"mm-room2-40-table.jpg","cx":0.4605,"cy":0.5958,"w":0.4863,"cm":44.0,"el":44,"fov":24,"exposure":1.15,"tint":[1,1,1],"grain":0.06,"cast":{"k":0.5,"blur":0.5},"contact":{"k":0.55,"blur":0.35,"grow":0.15,"dy":0.2},"shade":{"umbra":0.58,"fade":0.35,"farBlur":0.8,"reach":3,"exp":[1,1.5,1.9]}}}});
  /* =================== end B6.4 · ROOM SHOTS ===================== */

  /* The 40 cm table photo is taken from lower down (~21 deg above the table)
     than the hero shot (~28 deg), so 40 cm gets one extra baked shot from the
     hero's side at that height, rather than squashing the hero to fit. */
  var MM_ROOM_LOW_DIR = [-0.3474, 0.3660, 0.8631];

  function MM_roomFor(cm) {
    var best = null, gap = 1e9;
    Object.keys(MM_ROOMS).forEach(function (k) {
      var d = Math.abs(+k - (+cm || 0));
      if (d < gap) { gap = d; best = MM_ROOMS[k]; }
    });
    return gap <= 3 ? best : null;
  }
  function MM_roomUrl(file, px) {
    if (ROOM_BASE) return ROOM_BASE.replace(/\/?$/, '/') + file;
    return location.origin + '/cdn/shop/files/' + file + '?width=' + (px || 1600);
  }

  /* Model render + room photo -> one finished picture, the same recipe the
     approved sheet was made with: model scaled and placed from the numbers
     above, a light warm grade on the model only, then a fine grain over the
     whole frame so render and photo share one texture.
     o = { model: dataURL, geo: {cx, cy, w} as fractions of the render frame,
           room: MM_ROOMS[..].wall|table, S: page px, E: email px }
     done({ page, email }) or done(null) -- null if the photo is missing (not
     uploaded yet) or the canvas cannot be read. Never throws. */
  /* GUARD (12 Oct): blank-render guard. On some phones the WebGL render comes back
     empty (graphics memory runs out or the context is lost) and the room shots
     were then only the bare room photo: the email showed a sofa and a table
     with nothing on it (Kuřim 9 Oct, Delhi 8 Oct; 4 of ~165 emails checked).
     The model is drawn on transparency, so an empty render has no opaque
     pixels. done(fraction drawn), or done(-1) if it cannot be read (never
     treated as blank, so a guard failure can never stop a good email). */
  function MM_renderCoverage(src, done) {
    if (!src) return done(0);
    var im = new Image();
    im.onerror = function () { done(0); };
    im.onload = function () {
      try {
        var N = 64, c = document.createElement('canvas');
        c.width = c.height = N;
        var g = c.getContext('2d');
        g.drawImage(im, 0, 0, N, N);
        var p = g.getImageData(0, 0, N, N).data, hit = 0;
        for (var i = 3; i < p.length; i += 4) if (p[i] > 24) hit++;
        done(hit / (N * N));
      } catch (e) { done(-1); }
    };
    im.src = src;
  }
  /* Despeckle (14 Oct): true when this browser alters canvas pixel reads
     (Brave, Safari and Firefox privacy protections can). */
  function MM_canvasNoisy() {
    try {
      var c = document.createElement('canvas');
      c.width = c.height = 16;
      var g = c.getContext('2d', { willReadFrequently: true });
      g.fillStyle = 'rgb(37,141,203)';
      g.fillRect(0, 0, 16, 16);
      var p = g.getImageData(0, 0, 16, 16).data;
      for (var i = 0; i < p.length; i += 4) {
        if (p[i] !== 37 || p[i + 1] !== 141 || p[i + 2] !== 203 || p[i + 3] !== 255) return true;
      }
    } catch (e) { /* unreadable: say not noisy */ }
    return false;
  }
  function MM_isBlank(c) { return c >= 0 && c < 0.02; }
  /* A model position that is not a number draws nowhere: same empty room. */
  function MM_geoOk(g) {
    return !!g && isFinite(g.cx) && isFinite(g.cy) && isFinite(g.w) && g.w > 0.01;
  }
  /* What failed, so the Renders tab shows which phones do this. Runs only for a
     blank render. The throwaway context is released straight away. */
  function MM_deviceDiag(cover) {
    var n = window.navigator || {}, sc = window.screen || {}, gpu = '';
    try {
      var c = document.createElement('canvas'), gl = c.getContext('webgl');
      var x = gl && gl.getExtension('WEBGL_debug_renderer_info');
      if (x) gpu = String(gl.getParameter(x.UNMASKED_RENDERER_WEBGL));
      var lose = gl && gl.getExtension('WEBGL_lose_context');
      if (lose) lose.loseContext();
    } catch (e) { /* no GPU name, fine */ }
    return [
      'cover ' + (cover || []).map(function (v) { return Math.round(v * 100) + '%'; }).join('/'),
      'dpr ' + (window.devicePixelRatio || 1),
      'screen ' + (sc.width || '?') + 'x' + (sc.height || '?'),
      n.deviceMemory ? 'mem ' + n.deviceMemory + 'GB' : '',
      gpu ? 'gpu ' + gpu : '',
      String(n.userAgent || '').slice(0, 180)
    ].filter(Boolean).join(' \u00b7 ').slice(0, 400);
  }

  function MM_roomComposite(o, done) {
    var left = 2, over = false;
    var model = new Image(), bg = new Image();
    function fail(why) {
      if (over) return;
      over = true;
      if (window.console) console.warn('[mm] room shot skipped: ' + why);
      done(null);
    }
    function go() {
      if (over || --left) return;
      try {
        var S = o.S, N = model.naturalWidth || 1;
        var cv = document.createElement('canvas');
        cv.width = cv.height = S;
        var g = cv.getContext('2d');
        if (!g) return fail('no 2d context');
        g.imageSmoothingEnabled = true;
        g.imageSmoothingQuality = 'high';
        var r = Math.max(S / bg.naturalWidth, S / bg.naturalHeight);
        g.drawImage(bg, (S - bg.naturalWidth * r) / 2, (S - bg.naturalHeight * r) / 2,
                    bg.naturalWidth * r, bg.naturalHeight * r);

        // model, resized once to its finished size
        var mw = Math.max(8, Math.round((o.room.w / 100) * S / Math.max(o.geo.w, 0.01)));
        var mc = document.createElement('canvas');
        mc.width = mc.height = mw;
        var mg = mc.getContext('2d');
        mg.imageSmoothingEnabled = true;
        mg.imageSmoothingQuality = 'high';
        mg.drawImage(model, 0, 0, mw, mw);
        /* Feather the render's square edge. A long shadow that runs off the
           render frame would otherwise end in a hard straight line across the
           photo; this only touches the outer 4.5%, well clear of the model. */
        var f = 0.045;
        mg.globalCompositeOperation = 'destination-in';
        [[mw, 0], [0, mw]].forEach(function (v) {
          var lg = mg.createLinearGradient(0, 0, v[0], v[1]);
          lg.addColorStop(0, 'rgba(0,0,0,0)');
          lg.addColorStop(f, 'rgba(0,0,0,1)');
          lg.addColorStop(1 - f, 'rgba(0,0,0,1)');
          lg.addColorStop(1, 'rgba(0,0,0,0)');
          mg.fillStyle = lg;
          mg.fillRect(0, 0, mw, mw);
        });
        mg.globalCompositeOperation = 'source-over';
        /* B5.53: no colour grade. The model keeps the exact colours of the live
           viewer (Kevin: the warm grade made the buildings beige). */
        var i;

        var x = (o.room.x / 100) * S - o.geo.cx * mw;
        var y = (o.room.y / 100) * S - o.geo.cy * mw;
        var soft = typeof g.filter === 'string';
        if (soft) g.filter = 'blur(' + (0.5 * S / 1200).toFixed(2) + 'px)';
        g.drawImage(mc, Math.round(x), Math.round(y));
        if (soft) g.filter = 'none';

        // grain, sigma ~2.2, the same on all three channels
        var px = g.getImageData(0, 0, S, S), p = px.data, n;
        for (i = 0; i < p.length; i += 4) {
          n = (Math.random() + Math.random() + Math.random() - 1.5) * 4.4;
          p[i] += n; p[i + 1] += n; p[i + 2] += n;
        }
        g.putImageData(px, 0, 0);

        var page = cv.toDataURL('image/jpeg', 0.86), email = page;
        if (o.E && o.E < S) {
          var ec = document.createElement('canvas');
          ec.width = ec.height = o.E;
          var eg = ec.getContext('2d');
          eg.imageSmoothingEnabled = true;
          eg.imageSmoothingQuality = 'high';
          eg.drawImage(cv, 0, 0, o.E, o.E);
          email = ec.toDataURL('image/jpeg', 0.84);
        }
        over = true;
        done({ page: page, email: email });
      } catch (e) {
        fail('composite failed (' + (e && e.message) + ')');
      }
    }
    model.onload = go;
    model.onerror = function () { fail('no render'); };
    bg.crossOrigin = 'anonymous';
    bg.onload = go;
    bg.onerror = function () {
      fail('room photo missing -- upload ' + o.room.file + ' to Shopify > Content > Files');
    };
    if (!o.model || !o.geo) return fail('no render');
    model.src = o.model;
    bg.src = MM_roomUrl(o.room.file, o.S > 1200 ? 1600 : 1200);
  }

  /* The full-screen room view. Opens on the wall shot; the table shot is one
     swipe back. Scroll-snap does the swiping, so a finger, a trackpad and the
     arrow keys all work with no drag code of our own. */
  /* B6.3: `which` is the photo that was tapped ('table' or 'wall'). */
  function MM_openRooms(rooms, which) {
    if (!rooms || !rooms.table || !rooms.wall) return;
    if (document.querySelector('.mm-rooms-lb')) return;
    var docEl = document.documentElement, overflowWas = docEl.style.overflow;
    var lb = el('div', 'mm-rooms-lb');
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-label', 'Your model in a room');
    lb.setAttribute('style',
      'position:fixed;inset:0;z-index:99999;display:flex;flex-direction:column;' +
      'align-items:center;justify-content:center;gap:14px;background:rgba(18,19,22,.92);' +
      '-webkit-backdrop-filter:blur(3px);backdrop-filter:blur(3px)');

    var vw = window.innerWidth, vh = window.innerHeight;
    var side = Math.round(Math.min(vw, vh * 0.78));
    var edge = side >= vw - 1;
    var box = el('div', '');
    box.setAttribute('style', 'position:relative;width:' + side + 'px;height:' + side + 'px');
    var track = el('div', 'mm-rooms-track');
    track.setAttribute('style',
      'width:100%;height:100%;display:flex;overflow-x:auto;overflow-y:hidden;' +
      'scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;scrollbar-width:none;' +
      'overscroll-behavior-x:contain;border-radius:' + (edge ? 0 : 14) + 'px');
    var SL = [['table', 'In a room'], ['wall', 'On a wall']];   /* B6.3: as on the tiles */
    /* B5.54: a loop. The track holds a copy of each photo past the far end
       ([wall', table, wall, table']), and when a swipe lands on a copy the
       track jumps, without animating, to the real photo it shows. So from
       either photo both directions always lead to the other one. */
    var PH = [1, 0, 1, 0];                 // physical slide -> photo in SL
    PH.forEach(function (k, n) {
      var s = SL[k];
      var sl = el('div', '');
      if (n === 0 || n === PH.length - 1) sl.setAttribute('aria-hidden', 'true');
      sl.setAttribute('style', 'flex:0 0 100%;height:100%;scroll-snap-align:center;' +
                      'scroll-snap-stop:always');
      var im = new Image();
      im.src = rooms[s[0]];
      im.alt = 'Your model ' + s[1].toLowerCase();
      im.draggable = false;
      im.setAttribute('style', 'width:100%;height:100%;object-fit:cover;display:block;' +
                      '-webkit-user-select:none;user-select:none');
      sl.appendChild(im);
      track.appendChild(sl);
    });
    box.appendChild(track);
    lb.appendChild(box);

    var cap = el('div', '');
    cap.setAttribute('style', 'color:#fff;font:500 14.5px/1.3 ' + MM_FACE +
                     ';text-align:center;padding:0 16px');
    var dots = el('div', '');
    dots.setAttribute('style', 'display:flex;gap:8px;justify-content:center');
    var dotEls = SL.map(function (s, i) {
      var d = el('button', '');
      d.type = 'button';
      d.setAttribute('aria-label', s[1]);
      d.setAttribute('style', 'width:8px;height:8px;padding:0;border:0;border-radius:99px;' +
                     'cursor:pointer;background:rgba(255,255,255,.4)');
      d.addEventListener('click', function (ev) { ev.stopPropagation(); go(i + 1); });
      dots.appendChild(d);
      return d;
    });
    lb.appendChild(cap);
    lb.appendChild(dots);

    if (!IS_TOUCH) {
      [-1, 1].forEach(function (way) {
        var b = el('button', '',
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
          'stroke-width="2.2"><path d="M' + (way < 0 ? '15 5l-7 7 7 7' : '9 5l7 7-7 7') +
          '"></path></svg>');
        b.type = 'button';
        b.setAttribute('aria-label', way < 0 ? 'Previous' : 'Next');
        b.setAttribute('style', 'position:absolute;top:50%;' + (way < 0 ? 'left' : 'right') +
          ':12px;transform:translateY(-50%);width:40px;height:40px;border:0;border-radius:99px;' +
          'display:flex;align-items:center;justify-content:center;cursor:pointer;' +
          'background:rgba(255,255,255,.92);color:#17181A;box-shadow:0 2px 10px rgba(0,0,0,.2)');
        b.addEventListener('click', function (ev) { ev.stopPropagation(); go(at() + way); });
        box.appendChild(b);
      });
    }

    // same close button as the live enlarged view (B5.47)
    var shut = el('button', 'mm-live-close', 'Close');
    shut.type = 'button';
    shut.setAttribute('style',
      'position:fixed;top:max(14px,env(safe-area-inset-top));right:14px;' +
      'left:auto;bottom:auto;transform:none;width:auto;height:auto;' +
      'min-width:0;max-width:none;display:inline-block;' +
      'border:0;border-radius:99px;padding:11px 18px;cursor:pointer;' +
      'font:600 15px/1 ' + MM_FACE + ';background:#fff;color:#17181A;' +
      'box-shadow:0 2px 14px rgba(0,0,0,.3);z-index:3');
    shut.addEventListener('click', function (ev) { ev.stopPropagation(); close(); });
    lb.appendChild(shut);

    function at() {                        // physical slide, 0..3
      return Math.max(0, Math.min(PH.length - 1,
        Math.round(track.scrollLeft / Math.max(track.clientWidth, 1))));
    }
    function mark(n) {
      var i = PH[n];
      cap.textContent = SL[i][1] + ' · Ø ' + rooms.cm + ' cm, about real size';
      dotEls.forEach(function (d, k) {
        d.style.background = k === i ? '#fff' : 'rgba(255,255,255,.4)';
      });
    }
    function go(n, instant) {
      n = Math.max(0, Math.min(PH.length - 1, n));
      var x = n * track.clientWidth;
      if (instant || !track.scrollTo) track.scrollLeft = x;
      else track.scrollTo({ left: x, behavior: 'smooth' });
      mark(n);
    }
    /* Landed on a copy: swap to the real photo in place. Only once the track
       is at rest -- moving it mid-fling fights the browser's own momentum. */
    function settleLoop() {
      var n = at();
      if (Math.abs(track.scrollLeft - n * track.clientWidth) > 2) return;   // still moving
      if (n === 0) go(PH.length - 2, true);
      else if (n === PH.length - 1) go(1, true);
      else mark(n);
    }
    var tick = null;
    track.addEventListener('scroll', function () {
      clearTimeout(tick);
      tick = setTimeout(settleLoop, 140);
    }, { passive: true });
    track.addEventListener('scrollend', function () { clearTimeout(tick); settleLoop(); });
    function onKey(ev) {
      if (ev.key === 'Escape') close();
      else if (ev.key === 'ArrowLeft') go(at() - 1);
      else if (ev.key === 'ArrowRight') go(at() + 1);
    }
    function close() {
      document.removeEventListener('keydown', onKey);
      docEl.style.overflow = overflowWas;
      if (lb.parentNode) lb.parentNode.removeChild(lb);
    }
    // a tap on the dark backdrop closes; a tap on the picture does not
    lb.addEventListener('click', function (ev) { if (ev.target === lb) close(); });
    document.addEventListener('keydown', onKey);
    docEl.style.overflow = 'hidden';
    document.body.appendChild(lb);
    go(which === 'table' ? 1 : 2, true);   // B6.3: the one tapped; the wall shot otherwise
    if (!IS_TOUCH) { try { shut.focus({ preventScroll: true }); } catch (eF) {} }
  }

  /* For the render rig and ?mmdiag checks only. */
  window.MM_ROOMS_DIAG = { rooms: MM_ROOMS, composite: MM_roomComposite, open: MM_openRooms };

  /* ----------------------- cart thumbnail storage ------------------------ */
  /* The cart drawer has no picture of its own to fall back on: the Shopify
     product carries no images at all, so if this cache misses, the customer
     gets an empty grey square next to a EUR 219 line. Two things used to make
     it miss. The key was the centre coordinates and nothing else, so two models
     of the same place at different sizes overwrote each other; and eviction
     walked localStorage in enumeration order -- which is not defined -- and
     dropped whatever came first, quite possibly the one model still sitting in
     the cart. Key on the whole choice, and evict the genuinely oldest. */
  var MM_THUMB_MAX_BYTES = 3500000;   /* well inside a 5 MB localStorage */
  var MM_THUMB_MAX_COUNT = 24;        /* more than any realistic cart */

  function MM_thumbKey(sp) {
    if (!sp || !sp.centre) return null;
    return MM_thumbKeyLegacy(sp) +
      '|' + (sp.diameterCm || (sp.size && sp.size.cm) || '?') +
      '|' + (sp.frame || '?') +
      '|' + (sp.colourway || '?');
  }
  /* What builds before B5.45 wrote. Still read, so a cart filled yesterday
     keeps its pictures; nothing writes it any more. */
  function MM_thumbKeyLegacy(sp) {
    if (!sp || !sp.centre) return null;
    return 'mm-thumb:' + sp.centre.lat.toFixed(5) + ',' + sp.centre.lon.toFixed(5);
  }

  function MM_thumbIndex() {
    try { return JSON.parse(localStorage.getItem('mm-thumb-idx') || '{}') || {}; }
    catch (e) { return {}; }
  }
  function MM_thumbPut(key, url) {
    if (!key || !url) return;
    var idx = MM_thumbIndex();
    idx[key] = Date.now();
    /* Sweep anything the index has lost track of, so a key written by an older
       build cannot sit there forever holding space. */
    var live = [], bytes = 0, k, i;
    for (i = 0; i < localStorage.length; i++) {
      k = localStorage.key(i);
      if (!k || k.indexOf('mm-thumb:') !== 0 || k === 'mm-thumb:last') continue;
      live.push(k);
      if (idx[k] == null) idx[k] = 0;      /* unknown age: evict first */
    }
    for (k in idx) { if (live.indexOf(k) < 0 && k !== key) delete idx[k]; }

    var order = live.concat(live.indexOf(key) < 0 ? [key] : [])
      .sort(function (a, b) { return (idx[b] || 0) - (idx[a] || 0); });   /* newest first */

    function drop(kk) { try { localStorage.removeItem(kk); } catch (e) {} delete idx[kk]; }

    var keep = [];
    for (i = 0; i < order.length; i++) {
      k = order[i];
      var len = k === key ? url.length : (localStorage.getItem(k) || '').length;
      if (i >= MM_THUMB_MAX_COUNT || bytes + len > MM_THUMB_MAX_BYTES) { drop(k); continue; }
      bytes += len; keep.push(k);
    }
    /* Quota can still bite on a browser with a smaller allowance. Give ground
       one thumbnail at a time from the oldest end rather than failing outright
       and leaving a blank square. */
    for (i = 0; i < 6; i++) {
      try {
        localStorage.setItem(key, url);
        localStorage.setItem('mm-thumb:last', url);
        localStorage.setItem('mm-thumb-idx', JSON.stringify(idx));
        return;
      } catch (e) {
        var oldest = null;
        for (var j = keep.length - 1; j >= 0; j--) { if (keep[j] !== key) { oldest = keep[j]; break; } }
        if (!oldest) throw e;
        keep.splice(keep.indexOf(oldest), 1);
        drop(oldest);
      }
    }
  }

  /* Round models: a crop is described by how far it reaches across. */
  function fmtAcross(m) {
    if (m < 1000) return (Math.round(m / 10) * 10) + ' m across';
    var km = m / 1000;
    return (km < 10 ? km.toFixed(2).replace(/\.?0+$/, '') : km.toFixed(1).replace(/\.0$/, '')) + ' km across';
  }
  if (window.console) {
    console.info('[mm] configurator build ' + MM_BUILD +
                 (window.MMRender ? ' · render core ' + (window.MMRender.BUILD || 'unstamped')
                                  : ' · RENDER CORE NOT LOADED'));
  }

  /* Render tuning. Lives in assets/mm-render-core.js so every number that
     decides how a model looks sits in one small file, and changing the look
     worldwide means editing that rather than hunting through this one. The
     fallbacks below are the same values, so the configurator still runs if the
     asset fails to load. */
  var MM_T = (window.MMRender && window.MMRender.TUNING) || {
    exposure: 1.0, envIntensity: 0.55,
    keyIntensity: 2.30, keyShadowRadius: 6,
    skyIntensity: 0.80, skyShadowRadius: 34,
    fillIntensity: 0.12, hemiIntensity: 0.10,
    frameWidthMm: 3, frameLipMm: 0.6, baseThicknessMm: 6, stepMm: 0.5,
    reliefStrength: 1, reliefExaggeration: 1.25, maxReliefMm: 16,
    heightExaggeration: 1.9,
    twoToneBuildings: false, roofColour: 0xAAA9A3,
    /* Fallback only -- used when mm-render-core.js did not load. Kept in step
       with its TUNING so a fallback render is not silently uglier. */
    aoRadiusPx: 26, aoIntensity: 0.5, aoBias: 0.035, aoMaxJump: 0.5,
    gradeOn: true, gradeContrast: 1.08, gradeWarmth: 0.025,
    gradeSaturation: 1.04, gradeVibrance: 0.18,
    gradeGreenLift: 0.14, gradeWaterLift: 0.12,
    bldVariation: 0.055, roofBoost: 1.055,
    groundVariation: 0.1, groundReliefTone: 0.1, treeVariation: 1.0,
    keyRadius: 10.2, keyHeight: 6.6, topKey: [-7.0, 5.0, -5.0], riserLift: 1.2,
    cityWallM: 14, cityWallMinMm: 2.4,
    trees: true,
    maxInferredHeightM: 22,
    studioKey: [-7.5, 9.5, 2.5], wallKey: [-7.5, 6.2, -5.2]
  };
  /* B5.51 (Kevin, 2 Oct: renders look flat; printing is not a constraint).
     Overrides the render core's TUNING here so one upload changes it.
     Was: heightExaggeration 1.9, maxReliefMm 16, keyHeight 6.6, wallKey y 6.2. */
  MM_T.heightExaggeration = 2.4;
  MM_T.maxReliefMm = 22;
  MM_T.keyHeight = 5.8;                      // lower sun: longer shadows read as height
  MM_T.wallKey = [-7.5, 5.2, -5.2];


  /* ---------------------------- building heights -------------------------
     Order of trust: a measured height, then a level count, then the type of
     building, then its footprint. Only the last two are inference, and they
     run only where OSM has said nothing -- which in most of the world is most
     buildings. A flat 8 m fallback is what makes a suburb read as clones
     rather than as that suburb. */
  var MM_LEVEL_M = 3.1;
  var MM_TYPE_LEVELS = {
    house:2, detached:2, semidetached_house:2, terrace:2, bungalow:1,
    residential:3, apartments:4, dormitory:4, hotel:5,
    commercial:3, office:5, retail:2, supermarket:1, kiosk:1,
    industrial:2, warehouse:2, factory:2, hangar:2, service:1,
    church:9, cathedral:16, chapel:5, mosque:9, temple:8, synagogue:8,
    school:2, college:3, university:3, hospital:5, civic:3,
    public:3, government:4, museum:3, train_station:3, transportation:3,
    garage:1, garages:1, shed:1, hut:1, carport:1, roof:1, container:1,
    barn:2, farm:2, farm_auxiliary:1, stable:1, greenhouse:1, cowshed:1,
    parking:5, silo:12, storage_tank:10, tower:25, water_tower:22
  };

  function MM_num(v) { var n = parseFloat(v); return isFinite(n) ? n : null; }

  /* Build 2: a building:part is a slice of a building -- podium, shaft, crown,
     setback. Unlike a whole building it has a real bottom: height is the top
     above the ground, min_height where the slice starts. */
  function MM_partHeights(t, areaM2) {
    var top = MM_num(t.height) || MM_num(t['building:height']);
    var lv = MM_num(t['building:levels']) || MM_num(t.levels);
    var minLv = MM_num(t['building:min_level']) || MM_num(t.min_level) || 0;
    var bot = MM_num(t.min_height);
    if (bot == null) bot = minLv * MM_LEVEL_M;
    if (top == null) {
      if (lv != null) top = (lv + (MM_num(t['roof:levels']) || 0) * 0.6) * MM_LEVEL_M;
      else top = bot + Math.max(3, Math.min(MM_buildingHeight(t, areaM2), MM_T.maxInferredHeightM));
      if (lv != null && lv <= minLv) top = bot + MM_LEVEL_M;
    }
    if (!(top > bot)) top = bot + 2.5;
    return { top: top, bot: Math.max(0, bot) };
  }

  /* Trees are the difference between a wooded hillside and a bare green sheet,
     and OSM maps a wood as an outline rather than as individual trees -- so
     without scattering there is nothing on it. This was gated on cfg.trees,
     which meant an unset section setting silently switched every tree in the
     model off. Same failure as reliefStrength: absent is not the same as no. */
  var MM_TREES = true;

  function MM_ringAreaM2(ring) {
    if (!ring || ring.length < 4) return 0;
    var a = 0, i, j;
    for (i = 0, j = ring.length - 1; i < ring.length; j = i++) {
      a += (ring[j][0] + ring[i][0]) * (ring[j][1] - ring[i][1]);
    }
    var latR = Math.cos((ring[0][1] || 0) * D2R);
    return Math.abs(a / 2) * (111320 * latR) * 110540;
  }

  function MM_buildingHeight(t, areaM2) {
    t = t || {};
    var explicit = MM_num(t.height) || MM_num(t['building:height']) ||
                   MM_num(t.est_height) || MM_num(t.render_height);
    if (explicit) return Math.max(2.5, explicit - (MM_num(t.min_height) || 0));

    var lv = MM_num(t['building:levels']) || MM_num(t.levels);
    if (lv) {
      var roofLv = MM_num(t['roof:levels']) || 0;
      var minLv = MM_num(t['building:min_level']) || 0;
      return Math.max(2.5, (lv - minLv + roofLv * 0.6) * MM_LEVEL_M);
    }

    var kind = (t.building && t.building !== 'yes') ? t.building : t['building:use'];
    var levels = (kind && MM_TYPE_LEVELS[kind] != null) ? MM_TYPE_LEVELS[kind] : null;
    if (levels == null) {
      /* Nothing tagged at all. Footprint is the only signal left: a 30 m2 box
         is a shed, a 3,000 m2 one is not a house. Deliberately conservative --
         better to under-build than to invent a skyline. */
      levels = areaM2 < 45 ? 1 : areaM2 < 130 ? 2 : areaM2 < 450 ? 3
             : areaM2 < 1600 ? 4 : 5;
    }
    /* Capped, because everything below the tagged branches is a guess. A mast
       tagged building=tower would otherwise come back at 77 m and render as a
       needle standing over the city. Anything genuinely that tall is tagged
       with a height, and a tagged height is never capped. */
    return Math.max(2.5, Math.min(levels * MM_LEVEL_M, MM_T.maxInferredHeightM));
  }

  /* Ids stay mono/duo/full so existing variant settings keep working.
     Roads share the ground material on the print; in the preview they're a
     shade darker so they read as the recessed channels they actually are. */
  /* Roads are LIGHTER than the ground, not darker. That single inversion is
     most of why the street network vanished into the beige — on a real model
     the road surface is the raised, pale channel between the blocks. */
  /* Ordered by what we want chosen: Meadow leads because it is the scheme the
     photography is shot in and the one that shows what the product can do. */
  /* The fallback lives here rather than in the section settings, because a tile
     URL contains {z}/{x}/{y} and braces inside a Liquid output tag stop the
     theme file saving. Free, key-less, and the same AWS open dataset most
     terrain renderers use. */
  /* Elevation sources, tried in order. One endpoint is a single point of
     failure for the most important thing on the model: without terrain the
     plate is flat, and a flat plate has no terraces, no roads bending round a
     hillside and no reason for any of the relief work to exist. If a host is
     blocked, rate-limits, or serves without the CORS header that lets us read
     the pixels back, the next one is tried rather than the model silently
     coming out level. All three are terrarium-encoded, so nothing downstream
     changes. */
  var TERRAIN_SOURCES = [
    'https://s3.amazonaws.com/elevation-tiles-prod/terrarium/{z}/{x}/{y}.png',
    'https://elevation-tiles-prod.s3.amazonaws.com/terrarium/{z}/{x}/{y}.png',
    'https://demotiles.maplibre.org/terrain-tiles/{z}/{x}/{y}.png'
  ];
  var TERRAIN_FALLBACK = TERRAIN_SOURCES[0];

  var COLOURWAYS = [
    /* Retuned against a side-by-side with the reference. Three changes carry
       it: a green with real saturation instead of a sage wash, buildings in
       warm grey rather than pure white -- white clips to a flat silhouette
       under any decent key light and loses every face -- and a properly dark
       tree, so woods read as woods rather than as broccoli. */
    /* B5.63: renamed from Meadow. legacy = Shopify option values this scheme
       used to have, so a variant not yet renamed still matches. */
    { id: 'full', name: 'Natural Colour', opt: 'Natural Colour', legacy: ['Meadow'], materials: 4,
      swatch: ['#D1BC91', '#EEE8DA', '#7BBC85', '#86BCC8'],
      desc: 'Green countryside on desert tan ground, bone buildings and streets, soft water.',
      /* Roads sit a shade brighter than the buildings rather than identical to
         them. Both read as bone, but from directly above an identical pair
         welds the street grid onto the terrace fronts and the plan disappears.
         The buildings are off-white rather than pure white for the same reason
         as before -- #FFFFFF clips flat and loses every face. */
      /* Roads were near-white, which on green reads as concrete ribbons laid
         across a field. On the reference they are an earth tone -- a shade off
         the ground they are cut into, not a different material. */
      /* Walls a definite light grey rather than near-white. Against pale
         ground, bone-white buildings sat within a few per cent of the surface
         they stand on, so a town read as one mass with faint seams -- the
         reference's are clearly a different material from the streets. */
      /* Build 1, matched to the reference shots: a lighter warm tan for
         built-up ground, a warm grey where a centre is dense, a fresh mint
         green, clear aqua water, near-white buildings and a living tree green
         (varied per tree at render time). */
      /* Build 3.5: streets are bone again, with the buildings, as they were in
         2.2. The white sheet in Midtown was never the road colour -- it was
         relation-mapped buildings collapsing into flat slabs (see stitchRings).
         Four materials: ground, buildings with their roads and paths, grass,
         water. */
      base: 0xC4AE84, ground: 0xD1BC91, groundDense: 0xD1BC91, road: 0xEEE8DA,
      grass: 0x7BBC85, water: 0x86BCC8, bld: 0xEEE8DA, tree: 0x3C8F48 },
    /* B5.63: White & Blue (id 'duo') withdrawn, Kevin 11 Oct. Nobody bought it.
       If it ever comes back, its palette was base 0xE4DDCD, ground 0xE0D8C6,
       road 0xF4F0E6, grass 0xE0D8C6, water 0x5B87AC, bld 0xFFFFFF,
       tree 0xEEE8DC, swatch #FFFFFF / #5B87AC. */
    /* Actually white. It had been a warm bone, which reads as cream next to the
       other schemes and made the one-material option look like a colour choice
       rather than the absence of one. The small steps between ground, roads and
       buildings stay -- with a single material, shadow and these fractional
       tonal shifts are the only things separating a roof from a street. */
    { id: 'mono', name: 'Gallery White', opt: 'Gallery White', legacy: ['Monochrome White', 'White'], materials: 1,
      swatch: ['#FFFFFF'],
      desc: 'One material throughout. Detail reads through shadow alone.',
      base: 0xEDEDED, ground: 0xEFEFEF, road: 0xF8F8F8, grass: 0xEFEFEF,
      water: 0xEFEFEF, bld: 0xFFFFFF, tree: 0xEFEFEF }
  ];
  /* B5.71 (Kevin, 14 Oct): Gallery White first and preselected; Natural
     Colour is the free upgrade. Order here is order on screen, and
     COLOURWAYS[0] is the default everywhere a scheme is not given. */
  /* B7.5.2: no longer moved to the front; Natural Colour ('full') stays COLOURWAYS[0], the default. */
  var CW_UPGRADE = { full: 'Free upgrade' };
  var CW_SUB = { mono: 'One clean material', full: 'True-to-life colours' };


  /* Frame is a render + product attribute again (the map crop stays a plain
     yellow square — that's a separate thing). */
  var FRAMES = [
    { id: 'black', name: 'Black', opt: 'Black frame', hex: 0x1D1F22, css: '#1D1F22', sub: 'Deep matte edge' },
    { id: 'white', name: 'White', opt: 'White frame', hex: 0xFFFFFF, css: '#FFFFFF', sub: 'Clean bright edge' },
    /* B5.68: oak. hex is the mid tone, used for the swatch, the legend and as
       the fallback colour if the grain texture cannot be made. */
    { id: 'wood', name: 'Wood', opt: 'Wood frame', hex: 0x9E7752, css: '#9E7752', sub: 'Oak grain finish', grain: true }
  ];

  var MARKER_COLOURS = [
    { id: 'cream', name: 'Cream', hex: '#E8DEBD' },
    { id: 'blue',  name: 'Blue',  hex: '#7FB9DE' },
    { id: 'green', name: 'Green', hex: '#5FBF7F' }
  ];

  /* ------------------------------- helpers ------------------------------- */

  /* Coordinates typed or pasted straight into the search box.

     Someone framing a shot deliberately -- for product photography, or to match
     a place they already found elsewhere -- has an exact point in mind, and
     dragging a map until it looks right is the wrong tool for that. This
     recognises the coordinate on sight and skips the geocoder entirely, which
     also means no network call and no chance of a search engine picking a
     different Springfield.

     Accepts: plain decimal pairs, the degree format this configurator itself
     prints in its readout and cart lines, degrees-minutes-seconds, and Google
     Maps URLs pasted whole. */
  function parseCoords(raw) {
    var s = String(raw || '').trim();
    if (!s) return null;

    /* A Google Maps URL carries the point in one of two places: @lat,lon after
       the path, or a q=/ll= parameter. The @ form is the map's centre, which is
       what someone copying from the address bar means. */
    if (/^https?:\/\//i.test(s) || /(google\.[a-z.]+\/maps|goo\.gl|maps\.app)/i.test(s)) {
      var at = s.match(/@(-?\d+(?:\.\d+)?),(-?\d+(?:\.\d+)?)/);
      if (at) return finish(+at[1], +at[2]);
      var q = s.match(/[?&](?:q|ll|center|daddr)=(-?\d+(?:\.\d+)?),(-?\d+(?:\.\d+)?)/i);
      if (q) return finish(+q[1], +q[2]);
      var place = s.match(/\/place\/(-?\d+(?:\.\d+)?),(-?\d+(?:\.\d+)?)/);
      if (place) return finish(+place[1], +place[2]);
      /* A maps.app.goo.gl short link holds no coordinates until it is followed,
         and the browser cannot follow it from here. Say so rather than
         pretending the input was not a link at all. */
      if (/goo\.gl|maps\.app/i.test(s)) return { shortLink: true };
      return null;
    }

    /* Degrees, minutes, seconds -- 53°20'44"N 6°16'26"W, with or without the
       symbols, either hemisphere order. */
    var dms = s.match(
      /^\s*(\d+)[°\s:]+(\d+)['\u2032\s:]+([\d.]+)["\u2033\s]*\s*([NSns])[,\s]+(\d+)[°\s:]+(\d+)['\u2032\s:]+([\d.]+)["\u2033\s]*\s*([EWew])\s*$/);
    if (dms) {
      var la = (+dms[1]) + (+dms[2]) / 60 + (+dms[3]) / 3600;
      var lo = (+dms[5]) + (+dms[6]) / 60 + (+dms[7]) / 3600;
      if (/[Ss]/.test(dms[4])) la = -la;
      if (/[Ww]/.test(dms[8])) lo = -lo;
      return finish(la, lo);
    }

    /* Decimal degrees with hemisphere letters, which is what this configurator
       prints: 53.3455° N   6.2740° W. The letters can lead or follow. */
    var hemi = s.match(
      /^\s*([NSns])?\s*(-?[\d.]+)\s*°?\s*([NSns])?[,\s]+([EWew])?\s*(-?[\d.]+)\s*°?\s*([EWew])?\s*$/);
    if (hemi && hemi[2] && hemi[5]) {
      var ns = hemi[1] || hemi[3], ew = hemi[4] || hemi[6];
      var lat2 = Math.abs(+hemi[2]), lon2 = Math.abs(+hemi[5]);
      if (!ns && !ew) { lat2 = +hemi[2]; lon2 = +hemi[5]; }   // plain "53.3, -6.2"
      else {
        if (/[Ss]/.test(ns || '')) lat2 = -lat2;
        if (/[Ww]/.test(ew || '')) lon2 = -lon2;
      }
      return finish(lat2, lon2);
    }
    return null;

    function finish(lat, lon) {
      if (!isFinite(lat) || !isFinite(lon)) return null;
      if (Math.abs(lat) > 90 || Math.abs(lon) > 180) return null;
      /* 0,0 is in the Atlantic and is almost always a parse accident rather
         than somewhere anybody wants a model of. */
      if (lat === 0 && lon === 0) return null;
      return { lat: lat, lon: lon };
    }
  }

  /* ===================== B7.0: the name label (top level) =====================
     Muasher's design (his draft, 21-22 Oct, on B5.78), brought onto the B6
     configurator as its own optional step. A rounded plaque, 41.9 x 8.6 mm,
     1.2 mm deep, set into the front of the frame: black with bone-white
     capitals and border on a black or wood frame, white with black on a white
     frame. Up to 14 characters, capitals only, Futura-style lettering. The
     same text goes on the order (Label) so the frame can be printed with it. */
  var MM_LABEL_MAX = 14;
  var MM_LABEL_MM = { w: 41.9, h: 8.6, t: 1.2, inset: 0.7, line: 0.42, font: 4, textW: 31 };
  var MM_LABEL_BASE = '#1A1A1A', MM_LABEL_BONE = '#E8DBB7';
  var MM_LABEL_FACE = '"Futura", "Futura PT", "Century Gothic", "Avenir Next", "Outfit", system-ui, sans-serif';
  /* Letters the lettering cannot carry, folded to ones it can. */
  var MM_LABEL_SWAP = {
    'ß': 'SS', 'ẞ': 'SS', 'Æ': 'AE', 'æ': 'AE', 'Œ': 'OE', 'œ': 'OE',
    'Ø': 'O', 'ø': 'O', 'Ł': 'L', 'ł': 'L', 'Đ': 'D', 'đ': 'D',
    'Ð': 'D', 'ð': 'D', 'Þ': 'TH', 'þ': 'TH', 'ı': 'I',
    '‘': "'", '’': "'", 'ʼ': "'", '`': "'", '´': "'",
    '‐': '-', '‑': '-', '‒': '-', '–': '-', '—': '-', '−': '-',
    '•': '·', '‧': '·', '⋅': '·', '・': '·',
    'º': '°', '˚': '°', '∘': '°'
  };
  function labelFold(s) {
    s = String(s == null ? '' : s);
    var out = '', i, ch;
    for (i = 0; i < s.length; i++) {
      ch = s.charAt(i);
      out += Object.prototype.hasOwnProperty.call(MM_LABEL_SWAP, ch) ? MM_LABEL_SWAP[ch] : ch;
    }
    if (out.normalize) out = out.normalize('NFKD');
    return out.replace(/[̀-ͯ]/g, '').toUpperCase().replace(/\s+/g, ' ')
      .replace(/[^A-Z0-9 .,'&\-·°\/:]/g, '').replace(/ {2,}/g, ' ').replace(/^ +/, '');
  }
  function labelClean(s, live) {
    var out = labelFold(s).slice(0, MM_LABEL_MAX);
    return live ? out : out.replace(/ +$/, '');
  }
  /* Shortens at a word where it can, never mid-word unless it must. */
  function labelCut(s, max, wordsOnly) {
    s = String(s || '');
    if (max <= 0) return '';
    if (s.length <= max) return s;
    var toks = s.match(/[^ \-]+[ \-]*/g) || [], acc = '', i;
    for (i = 0; i < toks.length; i++) {
      if ((acc + toks[i]).replace(/[ \-]+$/, '').length > max) break;
      acc += toks[i];
    }
    acc = acc.replace(/[ \-]+$/, '');
    var shorter = acc.replace(/[ \-]+[A-Z]{1,2}$/, '');
    if (shorter && shorter !== acc) acc = shorter;
    if (!acc) acc = wordsOnly ? '' : s.slice(0, max);
    return acc.replace(/[ .,'&\-·\/:]+$/, '');
  }
  /* The place's own name from a search result ("Eyre Square, Galway, Ireland"
     -> "EYRE SQUARE"), skipping house numbers and postcodes. */
  function labelShortPlace(name) {
    var parts = String(name || '').split(','), i, c, firstAny = '';
    for (i = 0; i < parts.length; i++) {
      c = labelFold(parts[i]).replace(/ +$/, '');
      if (!/[A-Z]/.test(c)) continue;
      if (/[0-9]/.test(c)) c = c.replace(/^[0-9]+[A-Z]?[ ,\-]+/, '');
      if (/[A-Z]/.test(c) && !/[0-9]/.test(c)) return labelCut(c, MM_LABEL_MAX);
      if (!firstAny) firstAny = c;
    }
    return labelCut(firstAny, MM_LABEL_MAX);
  }
  function labelCoords(lat, lon) {
    lat = +lat; lon = +lon;
    if (!isFinite(lat) || !isFinite(lon)) return '';
    var s = '', d;
    for (d = 2; d >= 0; d--) {
      s = Math.abs(lat).toFixed(d) + '°' + (lat < 0 ? 'S' : 'N') + ' ' +
          Math.abs(lon).toFixed(d) + '°' + (lon < 0 ? 'W' : 'E');
      if (s.length <= MM_LABEL_MAX) break;
    }
    return s;
  }
  /* B7.0.6 (Kevin, 26 Oct): dates the way each region writes them. US shoppers
     get month first (MM.DD.YYYY), everyone else day first (DD.MM.YYYY). */
  function labelDateUS() {
    try { return String((window.Shopify && window.Shopify.country) || '').toUpperCase() === 'US'; } catch (eU) { return false; }
  }
  function labelDateFmt(iso) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso || ''));
    if (!m) return '';
    return labelDateUS() ? m[2] + '.' + m[3] + '.' + m[1] : m[3] + '.' + m[2] + '.' + m[1];
  }
  function labelPlaceYear(name, year) {
    var p = labelShortPlace(name), y = String(year || '').slice(0, 4), w;
    if (!p) return y;
    if ((p + ' · ' + y).length <= MM_LABEL_MAX) return p + ' · ' + y;
    if ((p + '·' + y).length <= MM_LABEL_MAX) return p + '·' + y;
    if ((p + " '" + y.slice(2)).length <= MM_LABEL_MAX) return p + " '" + y.slice(2);
    w = labelCut(p, MM_LABEL_MAX - y.length - 3, true);
    return w ? w + ' · ' + y : labelCut(p, MM_LABEL_MAX - y.length - 1) + '·' + y;
  }
  function labelMeasure(text, fs) {
    var c = labelMeasure.ctx || (labelMeasure.ctx = document.createElement('canvas').getContext('2d'));
    var w = 0, i;
    c.font = '500 100px ' + MM_LABEL_FACE;
    for (i = 0; i < text.length; i++) w += c.measureText(text.charAt(i)).width;
    return w * fs / 100;
  }
  /* Spreads short words, shrinks long ones, so every label fills the plaque. */
  function labelFit(text, avail, fs) {
    var n = text.length;
    if (!n) return { fs: fs, ls: 0, w: 0 };
    var gaps = Math.max(1, n - 1), w = labelMeasure(text, fs);
    var ls = Math.min(fs * 0.55, (avail - w) / gaps), minLs = fs * 0.06, k;
    if (ls < minLs) { k = avail / (w + minLs * gaps); fs *= k; w *= k; ls = minLs * k; }
    return { fs: fs, ls: ls, w: w + ls * (n - 1) };
  }
  /* The plaque as a picture, for the 3D model. */
  function labelCanvas(text, tone, iconId, inkOnly) {
    tone = tone || labelTone();
    var ic = labelIcon(iconId);
    var M = MM_LABEL_MM, W = 1024, H = Math.round(W * M.h / M.w), k = W / M.w;
    var cv = document.createElement('canvas');
    cv.width = W; cv.height = H;
    var c = cv.getContext('2d');
    function pill(x, y, w, h) {
      var r = h / 2;
      c.beginPath();
      c.moveTo(x + r, y); c.lineTo(x + w - r, y);
      c.arc(x + w - r, y + r, r, -Math.PI / 2, Math.PI / 2);
      c.lineTo(x + r, y + h);
      c.arc(x + r, y + r, r, Math.PI / 2, Math.PI * 1.5);
      c.closePath();
    }
    if (!inkOnly) { pill(0, 0, W, H); c.fillStyle = tone.base; c.fill(); }   /* B7.0.5: ink only when the plaque is the frame's own material */
    var lw = Math.max(2, M.line * k), ins = M.inset * k + lw / 2;
    pill(ins, ins, W - 2 * ins, H - 2 * ins);
    c.lineWidth = lw; c.strokeStyle = tone.ink; c.stroke();
    text = String(text || '');
    if (text) {
      var icW = ic ? (MM_LABEL_ICON.size + MM_LABEL_ICON.gap) * k : 0;
      var f = labelFit(text, M.textW * k - icW, M.font * k);
      c.font = '500 ' + f.fs.toFixed(1) + 'px ' + MM_LABEL_FACE;
      c.fillStyle = tone.ink;
      c.textBaseline = 'alphabetic';
      var cap = 0;
      try { cap = c.measureText('H').actualBoundingBoxAscent || 0; } catch (eM) { cap = 0; }
      if (!cap) cap = f.fs * 0.7;
      var x = (W - f.w - icW) / 2, y = H / 2 + cap / 2, i, ch;
      if (ic) {
        try {
          var isz = MM_LABEL_ICON.size * k, sc = isz / 24;
          c.save();
          c.translate(x, H / 2 - isz / 2);
          c.scale(sc, sc);
          c.fill(new Path2D(ic.d), ic.even ? 'evenodd' : 'nonzero');
          c.restore();
        } catch (eI) {}
        x += icW;
      }
      for (i = 0; i < text.length; i++) {
        ch = text.charAt(i);
        c.fillText(ch, x, y);
        x += c.measureText(ch).width + f.ls;
      }
    }
    return cv;
  }
  /* B7.0.5 (Kevin, 26 Oct: "the label ... needs to match each one"): the
     plaque is the frame's own colour and material, the letters contrast.
     Black frame: soft white letters. White frame: near-black. Oak: dark
     walnut, like a burnt-in mark. */
  function labelTone(frameId) {
    if (frameId === 'white') return { id: 'white', white: true, base: '#FFFFFF', hex: 0xFFFFFF, ink: '#1D1F22', rough: 0.72 };
    if (frameId === 'wood') return { id: 'wood', wood: true, white: false, base: '#A9825A', hex: 0x9E7752, ink: '#2B1C10', rough: 0.5 };
    return { id: 'black', white: false, base: '#1D1F22', hex: 0x1D1F22, ink: '#F2EFE8', rough: 0.62 };
  }
  /* B7.0.1: the label ideas (top level, so they exist before init's first sync). Text ideas are fixed wording, so they can be picked
     and the label still changes with the year where it uses one. */
  /* B7.0.3 (Kevin, 26 Oct: "prioritise them by what would convert the highest, such as special date"):
     gift ideas first, the plain place name last. Order is a judgement, not data. */
  var LABEL_IDEAS = [
    { id: 'date', icon: '📅', name: 'Special date' },
    { id: 'met', icon: '❤️', name: 'Where we met', text: function () { return 'WHERE WE MET'; } },
    { id: 'home', icon: '🏡', name: 'Our first home', text: function () { return 'OUR FIRST HOME'; } },
    { id: 'mrs', icon: '💍', name: 'Mr & Mrs', text: function () { return 'MR & MRS'; } },
    { id: 'placeyear', icon: '✨', name: 'Place + year' },
    { id: 'coords', icon: '🧭', name: 'Coordinates' },
    { id: 'grad', icon: '🎓', name: 'Class of ' + new Date().getFullYear(),
      text: function () { return 'CLASS OF ' + new Date().getFullYear(); } },
    { id: 'place', icon: '📍', name: 'Place name' }
  ];
  function labelIdea(id) { return LABEL_IDEAS.filter(function (x) { return x.id === id; })[0] || null; }

  /* B7.0.1: an icon in front of the words, printed in the plaque's own
     colour like the letters (one-colour shapes, nothing that needs a second
     colour). 24 x 24 paths. 'emoji' is how it is written on the order. */
  /* B7.0.3: most-used gift moments first (love, wedding, home, new baby), then the rest.
     B7.0.7: Travel added (Kevin: ten tiles with None, two even rows of five). */
  var LABEL_ICONS = [
    { id: 'heart', name: 'Love', emoji: '❤', even: false,
      d: 'M12 21.2s-7.6-4.7-9.7-9.4C.8 8.4 2.9 4.4 6.7 4.4c2.2 0 3.6 1.2 5.3 3.1 1.7-1.9 3.1-3.1 5.3-3.1 3.8 0 5.9 4 4.4 7.4-2.1 4.7-9.7 9.4-9.7 9.4z' },
    { id: 'ring', name: 'Wedding', emoji: '💍', even: true,
      d: 'M8.6 1.8h6.8l2.2 2.9L12 9.3 6.4 4.7z M12 8.6a6.9 6.9 0 1 0 0 13.8 6.9 6.9 0 0 0 0-13.8z m0 2.3a4.6 4.6 0 1 1 0 9.2 4.6 4.6 0 0 1 0-9.2z' },
    { id: 'home', name: 'Home', emoji: '🏠', even: false,
      d: 'M12 2.6L1.8 11.6h3V21h5.6v-6.1h3.2V21h5.6v-9.4h3z' },
    { id: 'baby', name: 'New baby', emoji: '👶', even: false,
      d: 'M11.6 2.6A8.4 8.4 0 0 0 3.2 11h8.4z M2.6 12.3h17.2c0 3.5-2.7 5.9-6.1 5.9H8.7c-3.4 0-6.1-2.4-6.1-5.9z M19.2 7.9h3.4v1.6h-1.8v2.2h-1.6z M7.4 22.4a1.9 1.9 0 1 0 0-3.8 1.9 1.9 0 0 0 0 3.8z M15.6 22.4a1.9 1.9 0 1 0 0-3.8 1.9 1.9 0 0 0 0 3.8z' },
    { id: 'plane', name: 'Travel', emoji: '✈', even: false,
      d: 'M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z' },
    { id: 'pin', name: 'Pin', emoji: '📍', even: true,
      d: 'M12 1.8c-4.1 0-7.4 3.2-7.4 7.3 0 5.4 7.4 12.9 7.4 12.9s7.4-7.5 7.4-12.9c0-4.1-3.3-7.3-7.4-7.3z m0 4.3a3 3 0 1 1 0 6 3 3 0 0 1 0-6z' },
    { id: 'star', name: 'Star', emoji: '⭐', even: false,
      d: 'M12 1.9l3 6.3 6.9.9-5.1 4.8 1.3 6.8L12 17.4l-6.1 3.3 1.3-6.8L2.1 9.1 9 8.2z' },
    { id: 'paw', name: 'Pet', emoji: '🐾', even: false,
      d: 'M5.4 12a2.2 2.7 0 1 0 0-5.4 2.2 2.7 0 0 0 0 5.4z M9.4 8.2a2.2 2.8 0 1 0 0-5.6 2.2 2.8 0 0 0 0 5.6z M14.6 8.2a2.2 2.8 0 1 0 0-5.6 2.2 2.8 0 0 0 0 5.6z M18.6 12a2.2 2.7 0 1 0 0-5.4 2.2 2.7 0 0 0 0 5.4z M12 10.6c-3.2 0-6.6 4.3-6.6 7.1 0 2 1.7 3 3.6 3 1.3 0 2-.5 3-.5s1.7.5 3 .5c1.9 0 3.6-1 3.6-3 0-2.8-3.4-7.1-6.6-7.1z' },
    { id: 'cap', name: 'Graduation', emoji: '🎓', even: false,
      d: 'M12 3.4L.8 8.9 12 14.4l8.6-4.2v5.6h1.9V8.9z M5.6 12.6v4.2c0 1.8 2.9 3.4 6.4 3.4s6.4-1.6 6.4-3.4v-4.2L12 15.7z' }
  ];
  function labelIcon(id) { return LABEL_ICONS.filter(function (x) { return x.id === id; })[0] || null; }
  /* Icon size and the gap after it, in plaque millimetres. */
  var MM_LABEL_ICON = { size: 4.4, gap: 1.5 };
  /* B7.0.2 (Kevin, 26 Oct: "slanted and curved because that's what it really
     looks like", "a bit more zoomed out"): the label preview is drawn as the
     real thing. A slice of the round frame seen from the three-quarter photo's
     own camera (ANGLES[0]: same direction, lens and fill), with the plaque set
     flat into the frame's top face exactly where the 3D model puts it, so it
     sits slanted and the frame curves away on both sides. Real profiles per
     size (the FRAME_PROFILES numbers), a little of the model behind it in the
     chosen colours, soft studio light and a contact shadow. Plain canvas 2D:
     nothing is loaded, it works before Generate. The frame and model are
     cached per frame / size / colour / width; typing only redraws the plaque. */
  var MM_LBL_SCENE_PROF = {
    15: { seat: 75.3, rIn: 75.8, rOut: 84.3, rCh: 85.3, rWall: 86.88, yWall: -12.4, rBot: 86.28, h: 13 },
    20: { seat: 100.3, rIn: 100.8, rOut: 111.3, rCh: 112.3, rWall: 114.3, yWall: -15.4, rBot: 113.7, h: 16 },
    40: { seat: 200.6, rIn: 201.1, rOut: 219.6, rCh: 220.6, rWall: 223.2, yWall: -19.4, rBot: 222.6, h: 20 }
  };
  var MM_LBL_SCENE = {
    cam: [-0.31, 0.46, 0.77], fov: 20, fill: 0.88,   /* ANGLES[0], the three-quarter photo */
    light: [-0.35, 0.85, 0.40], amb: 0.70, dif: 0.32,
    ground: -1.5,                                     /* the land sits a little below the frame's face */
    plaqueW: 0.52,                                    /* plaque width as a share of the picture */
    plaqueX: 0.40,                                    /* B7.0.6: plaque centre, across (left of middle) */
    plaqueY: 0.37,                                    /* plaque centre, down the picture */
    aspect: 0.62,                                     /* height / width */
    inset: { x0: 0.465, y0: 0.655, x1: 0.965, y1: 0.95 }   /* B7.0.6: the flat close-up, bottom right */
  };
  function lsN(v) { var l = Math.sqrt(v[0] * v[0] + v[1] * v[1] + v[2] * v[2]) || 1; return [v[0] / l, v[1] / l, v[2] / l]; }
  function lsDot(a, b) { return a[0] * b[0] + a[1] * b[1] + a[2] * b[2]; }
  function lsCross(a, b) { return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]]; }
  function lsRgb(hex) {
    if (typeof hex === 'string') hex = parseInt(hex.replace('#', ''), 16);
    return [(hex >> 16) & 255, (hex >> 8) & 255, hex & 255];
  }
  function lsCol(rgb, k, a) {
    var r = Math.max(0, Math.min(255, Math.round(rgb[0] * k))),
        g = Math.max(0, Math.min(255, Math.round(rgb[1] * k))),
        b = Math.max(0, Math.min(255, Math.round(rgb[2] * k)));
    return a == null ? 'rgb(' + r + ',' + g + ',' + b + ')' : 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
  }
  function lsRand(seed) {
    var s = seed >>> 0;
    return function () {
      s = (s + 0x6D2B79F5) >>> 0;
      var t = Math.imul(s ^ (s >>> 15), 1 | s);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }
  /* B7.0.5: the plaque is an arc on the middle of the face band, as on the
     3D frame (render.js uses the same outline). */
  function labelSceneZ(P) { return (P.rIn + P.rOut) / 2; }
  /* Outline of a pill bent round the frame: centre line radius rc, half
     height hh, straight part from -a to a (radians, 0 = nearest the viewer,
     +x to the right), round ends. Points as [x, z]. */
  function labelArcOutline(rc, hh, a, n) {
    var pts = [], i, t, ph;
    function at(r, p) { return [r * Math.sin(p), r * Math.cos(p)]; }
    function cap(p, dir, from, to) {
      var c = at(rc, p), er = [Math.sin(p), Math.cos(p)], et = [Math.cos(p) * dir, -Math.sin(p) * dir];
      for (i = 0; i <= n; i++) {
        t = from + (to - from) * i / n;
        pts.push([c[0] + hh * (Math.cos(t) * et[0] + Math.sin(t) * er[0]), c[1] + hh * (Math.cos(t) * et[1] + Math.sin(t) * er[1])]);
      }
    }
    for (i = 0; i <= n; i++) { ph = -a + 2 * a * i / n; pts.push(at(rc - hh, ph)); }
    cap(a, 1, -Math.PI / 2, Math.PI / 2);
    for (i = 0; i <= n; i++) { ph = a - 2 * a * i / n; pts.push(at(rc + hh, ph)); }
    cap(-a, -1, Math.PI / 2, -Math.PI / 2);
    return pts;
  }
  /* The camera and the picture transform: world mm -> canvas px. */
  function labelSceneView(P, Wc, Hc) {
    var S = MM_LBL_SCENE, d = lsN(S.cam);
    var D = (P.rWall / S.fill) / Math.tan(S.fov / 2 * Math.PI / 180);
    var T = [0, -P.h * 0.35, 0];
    var C = [T[0] + d[0] * D, T[1] + d[1] * D, T[2] + d[2] * D];
    var f = [-d[0], -d[1], -d[2]];
    var rt = lsN(lsCross(f, [0, 1, 0])), up = lsCross(rt, f);
    function raw(p) {
      var v = [p[0] - C[0], p[1] - C[1], p[2] - C[2]], z = lsDot(v, f);
      return [lsDot(v, rt) / z, -lsDot(v, up) / z, z];
    }
    var zc = labelSceneZ(P), LM = MM_LABEL_MM;
    var pc = raw([0, 0, zc]), pl = raw([-LM.w / 2, 0, zc]), pr = raw([LM.w / 2, 0, zc]);
    var k = S.plaqueW * Wc / Math.sqrt((pr[0] - pl[0]) * (pr[0] - pl[0]) + (pr[1] - pl[1]) * (pr[1] - pl[1]));
    var ox = Wc * (S.plaqueX || 0.5) - pc[0] * k, oy = Hc * S.plaqueY - pc[1] * k;
    return {
      C: C, f: f, zc: zc, k: k, mm: S.plaqueW * Wc / LM.w,     /* px per mm at the plaque */
      p: function (x, y, z) { var q = raw([x, y, z]); return [ox + q[0] * k, oy + q[1] * k, q[2]]; },
      depth: function (x, y, z) { return lsDot([x - C[0], y - C[1], z - C[2]], f); },
      sees: function (pt, n) { return lsDot(n, [C[0] - pt[0], C[1] - pt[1], C[2] - pt[2]]) > 0; }
    };
  }
  function lsShade(n) {
    var S = MM_LBL_SCENE;
    return S.amb + S.dif * Math.max(0, lsDot(lsN(n), lsN(S.light)));
  }
  function lsPoly(c, pts) {
    c.beginPath();
    c.moveTo(pts[0][0], pts[0][1]);
    for (var i = 1; i < pts.length; i++) c.lineTo(pts[i][0], pts[i][1]);
    c.closePath();
  }
  function lsRing(V, r, y, a0, a1, n) {
    var out = [], i, a;
    for (i = 0; i <= n; i++) { a = a0 + (a1 - a0) * i / n; out.push(V.p(Math.cos(a) * r, y, Math.sin(a) * r)); }
    return out;
  }
  function labelSceneFrameRgb(frameId) {
    var fr = FRAMES.filter(function (f) { return f.id === frameId; })[0] || FRAMES[0];
    if (frameId === 'white') return [246, 246, 244];
    if (frameId === 'wood') return [176, 136, 96];
    return lsRgb(fr.css || '#1D1F22');
  }
  /* The frame, the model behind it, the shadow: everything but the plaque. */
  function labelSceneBack(cv, o) {
    var P = MM_LBL_SCENE_PROF[o.cm] || MM_LBL_SCENE_PROF[20];
    var Wc = cv.width, Hc = cv.height, c = cv.getContext('2d');
    var V = labelSceneView(P, Wc, Hc), S = MM_LBL_SCENE, N = 220, i, j;
    var FR = labelSceneFrameRgb(o.frame), wood = o.frame === 'wood', white = o.frame === 'white';
    var cw = o.cw || {}, G = S.ground;
    /* studio sweep */
    var bg = c.createLinearGradient(0, 0, 0, Hc);
    bg.addColorStop(0, '#F5F6F8'); bg.addColorStop(1, '#E6E8EC');
    c.fillStyle = bg; c.fillRect(0, 0, Wc, Hc);
    /* contact shadow on the table, thrown in from off the canvas so its blur
       works everywhere (Safari has no canvas filter) */
    var off = Wc * 4;
    c.save();
    c.shadowColor = 'rgba(20,24,30,0.30)';
    c.shadowBlur = Math.max(4, V.mm * 4.5);
    c.shadowOffsetX = off; c.shadowOffsetY = V.mm * 0.8;
    lsPoly(c, lsRing(V, P.rBot + 0.6, -P.h, 0, Math.PI * 2, 96).map(function (q) { return [q[0] - off, q[1]]; }));
    c.fillStyle = '#000'; c.fill();
    c.restore();
    /* far half of the face (behind the model, mostly off the picture) */
    var face = lsCol(FR, lsShade([0, 1, 0]));
    lsPoly(c, lsRing(V, P.rOut, 0, Math.PI, Math.PI * 2, 60).concat(lsRing(V, P.rIn, 0, Math.PI * 2, Math.PI, 60)));
    c.fillStyle = face; c.fill();
    /* B7.0.4: the model. The customer's own streets when the map data for
       their area is in (it is fetched as soon as they pick a size, so it
       usually is by this step); a believable made-up town until then. */
    var pal = labelScenePalette(cw), feats = null;
    try { feats = o.geo ? labelSceneRealFeats(P, o.geo) : null; } catch (eG) { feats = null; }
    if (!feats || !feats.buildings.length && !feats.ground.length) feats = labelSceneTownFeats(P);
    c.save();
    lsPoly(c, lsRing(V, P.seat, G, 0, Math.PI * 2, 120)); c.clip();
    labelSceneDraw(c, V, P, feats, pal, G, Wc, Hc);
    c.restore();
    /* the near half of the frame: outer wall, chamfers, then the face */
    var prof = [[P.rOut, 0], [P.rCh, -1], [P.rWall, P.yWall], [P.rBot, -P.h]];
    /* Each band of the profile is one shape, shaded by a gradient across the
       picture sampled from the light at each angle: smooth, no seams. */
    for (j = prof.length - 2; j >= 0; j--) labelSceneBand(c, V, prof[j], prof[j + 1], FR, j === 0 ? 1.04 : 1, N, j ? prof[j - 1] : [P.rIn, 0]);
    lsPoly(c, lsRing(V, P.rOut, 0, 0, Math.PI, 90).concat(lsRing(V, P.rIn, 0, Math.PI, 0, 90)));
    c.fillStyle = face; c.fill();
    /* the inner edge of the face catches the light */
    c.beginPath();
    lsRing(V, P.rIn, 0, 0, Math.PI, 90).forEach(function (q, ix) { if (ix) c.lineTo(q[0], q[1]); else c.moveTo(q[0], q[1]); });
    c.strokeStyle = white ? 'rgba(0,0,0,0.10)' : 'rgba(255,255,255,0.16)'; c.lineWidth = Math.max(1, V.mm * 0.25); c.stroke();
    if (wood) labelSceneGrain(c, V, P, FR);
    return V;
  }
  /* pre: the profile point before a. The shape's top edge reaches 0.35 mm
     towards it, under the band drawn next, so no light hairline shows. */
  function labelSceneBand(c, V, a, b, FR, gain, N, pre) {
    var nr = -(b[1] - a[1]), ny = b[0] - a[0], vis = [], i, t, n3, pm;
    for (i = 0; i < N; i++) {
      t = i / N * Math.PI * 2;
      n3 = [nr * Math.cos(t), ny, nr * Math.sin(t)];
      pm = [Math.cos(t) * (a[0] + b[0]) / 2, (a[1] + b[1]) / 2, Math.sin(t) * (a[0] + b[0]) / 2];
      vis.push(V.sees(pm, n3));
    }
    var s0 = -1;
    for (i = 0; i < N; i++) if (vis[i] && !vis[(i + N - 1) % N]) { s0 = i; break; }
    if (s0 < 0) { if (!vis[0]) return; s0 = 0; }
    var ts = [];
    for (i = 0; i <= N; i++) { var ix = (s0 + i) % N; if (!vis[ix] && i) break; ts.push((s0 + i) / N * Math.PI * 2); }
    if (ts.length < 2) return;
    ts[0] -= 0.5 / N * Math.PI * 2; ts[ts.length - 1] += 0.5 / N * Math.PI * 2;   /* reach the silhouette */
    var ea = a;
    if (pre) { var dr = pre[0] - a[0], dy = pre[1] - a[1], dl = Math.sqrt(dr * dr + dy * dy) || 1; ea = [a[0] + dr / dl * 0.35, a[1] + dy / dl * 0.35]; }
    var top = ts.map(function (u) { return V.p(Math.cos(u) * ea[0], ea[1], Math.sin(u) * ea[0]); });
    var bot = ts.map(function (u) { return V.p(Math.cos(u) * b[0], b[1], Math.sin(u) * b[0]); });
    var mid = ts.map(function (u) { return V.p(Math.cos(u) * (a[0] + b[0]) / 2, (a[1] + b[1]) / 2, Math.sin(u) * (a[0] + b[0]) / 2); });
    var x0 = mid[0][0], x1 = mid[mid.length - 1][0];
    if (Math.abs(x1 - x0) < 1) return;
    var g = c.createLinearGradient(x0, 0, x1, 0), last = -1;
    for (i = 0; i < ts.length; i += 3) {
      var off = (mid[i][0] - x0) / (x1 - x0);
      if (!(off >= 0 && off <= 1) || off <= last) continue;
      last = off;
      g.addColorStop(off, lsCol(FR, lsShade([nr * Math.cos(ts[i]), ny, nr * Math.sin(ts[i])]) * gain));
    }
    lsPoly(c, top.concat(bot.reverse()));
    c.fillStyle = g; c.fill();
  }
  /* ---- B7.0.4: the model behind the label, as a real place ----
     Features in plate millimetres (x east, z south, so the label's side of
     the model is +z, as on the 3D render). Same colours as the render's
     colourway, buildings at the render's height (EXAG on the first 20 m),
     small houses with pitched roofs, trees, parks, water, streets, and soft
     sun shadows. */
  function labelScenePalette(cw) {
    function g(k, dflt) { return lsRgb(cw && cw[k] != null ? cw[k] : dflt); }
    return { land: g('ground', 0xEFEFEF), dense: g('groundDense', cw && cw.ground != null ? cw.ground : 0xEFEFEF),
             road: g('road', 0xF8F8F8), grass: g('grass', 0xEFEFEF), water: g('water', 0xEFEFEF),
             bld: g('bld', 0xFFFFFF), tree: g('tree', 0xEFEFEF) };
  }
  /* Smallest rectangle round a footprint, along one of its own edges. */
  function lsMinRect(r) {
    var n = r.length, best = null, e, i;
    for (e = 0; e < n; e++) {
      var a = r[e], c2 = r[(e + 1) % n], dx = c2[0] - a[0], dz = c2[1] - a[1], L = Math.sqrt(dx * dx + dz * dz);
      if (L < 1e-6) continue;
      var ux = dx / L, uz = dz / L, lo1 = 1e9, hi1 = -1e9, lo2 = 1e9, hi2 = -1e9;
      for (i = 0; i < n; i++) {
        var p1 = r[i][0] * ux + r[i][1] * uz, p2 = -r[i][0] * uz + r[i][1] * ux;
        if (p1 < lo1) lo1 = p1; if (p1 > hi1) hi1 = p1; if (p2 < lo2) lo2 = p2; if (p2 > hi2) hi2 = p2;
      }
      var ar = (hi1 - lo1) * (hi2 - lo2);
      if (!best || ar < best.area) best = { area: ar, ux: ux, uz: uz, lo1: lo1, hi1: hi1, lo2: lo2, hi2: hi2 };
    }
    return best;
  }
  function lsArea(r) {
    var A = 0, i, n = r.length;
    for (i = 0; i < n; i++) { var a = r[i], b = r[(i + 1) % n]; A += a[0] * b[1] - b[0] * a[1]; }
    return A / 2;
  }
  /* A gabled house from its footprint: the long side carries the ridge. */
  function lsGable(r, h) {
    var m = lsMinRect(r);
    if (!m) return null;
    var Lw = m.hi1 - m.lo1, Sw = m.hi2 - m.lo2;
    if (Sw < 0.8 || Sw > 3.4 || Math.abs(lsArea(r)) < m.area * 0.8) return null;
    if (Sw > Lw) {   /* keep u along the long side */
      m = { ux: -m.uz, uz: m.ux, lo1: m.lo2, hi1: m.hi2, lo2: -m.hi1, hi2: -m.lo1 };
      var t = Lw; Lw = Sw; Sw = t;
    }
    var rise = Math.min(Sw * 0.42, 1.6);
    function at(a, b) { return [a * m.ux - b * m.uz, a * m.uz + b * m.ux]; }
    return { c: [at(m.lo1, m.lo2), at(m.hi1, m.lo2), at(m.hi1, m.hi2), at(m.lo1, m.hi2)],
             ridge: [at(m.lo1, (m.lo2 + m.hi2) / 2), at(m.hi1, (m.lo2 + m.hi2) / 2)],
             eave: Math.max(0.6, h - rise * 0.5), top: Math.max(0.6, h - rise * 0.5) + rise };
  }
  function labelSceneRealFeats(P, geo) {
    var d = geo && geo.data, b = geo && geo.bbox;
    if (!d || !b || !geo.groundMeters || !d.buildings) return null;
    var cx = (b.minLon + b.maxLon) / 2, cy = (b.minLat + b.maxLat) / 2, k = (geo.cm * 10) / geo.groundMeters;
    var kx = 111320 * Math.cos(cy * Math.PI / 180) * k, kz = 110540 * k, R = P.seat;
    var ex = (typeof MM_T !== 'undefined' && MM_T && MM_T.heightExaggeration) || 2.4;
    function L(p) { return [(p[0] - cx) * kx, -(p[1] - cy) * kz]; }
    function south(r) { for (var i = 0; i < r.length; i++) if (r[i][1] > -R * 0.15) return true; return false; }
    var F = { ground: [], roads: [], lines: [], buildings: [], trees: [], real: true };
    function area(list, col) {
      (list || []).forEach(function (o) {
        if (!o || !o.rings || !o.rings.length) return;
        var rs = o.rings.map(function (r) { return r.map(L); });
        if (!south(rs[0])) return;
        F.ground.push({ rings: rs, col: col, tone: o.tone || 0, wooded: !!o.wooded });
      });
    }
    area(d.urban, 'dense'); area(d.grass, 'grass'); area(d.water, 'water');
    (d.waterways || []).forEach(function (o) {
      if (!o || !o.line) return; var pts = o.line.map(L); if (!south(pts)) return;
      F.lines.push({ pts: pts, w: Math.max(0.4, (o.width || 6) * k), col: 'water' });
    });
    (d.roads || []).forEach(function (o) {
      if (!o || !o.line) return; var pts = o.line.map(L); if (!south(pts)) return;
      F.roads.push({ pts: pts, w: Math.max(0.35, (o.width || 5) * k) });
    });
    d.buildings.forEach(function (o) {
      if (!o || !o.rings || !o.rings[0]) return;
      var rs = o.rings.map(function (r) { return r.map(L); }), r0 = rs[0], i, ok = false;
      for (i = 0; i < r0.length; i++) {
        if (Math.sqrt(r0[i][0] * r0[i][0] + r0[i][1] * r0[i][1]) > R - 0.2) return;   /* crosses the rim: leave it */
        if (r0[i][1] > -R * 0.15) ok = true;
      }
      if (!ok || r0.length < 3) return;
      var hm = +o.height || 6, h = Math.max(0.5, Math.min(16, (hm + (ex - 1) * Math.min(hm, 20)) * k));
      var pitched = o.roof ? /gabled|hipped|gambrel|mansard|saltbox|pyramidal|side_hipped|skillion/.test(o.roof)
                           : (rs.length === 1 && hm <= 13 && Math.abs(lsArea(r0)) < 260 * k * k);
      F.buildings.push({ rings: rs, h: h, gable: pitched ? lsGable(r0, h) : null });
    });
    (d.trees || []).forEach(function (t) {
      if (!t || t.length < 2) return; var q = L(t);
      if (q[1] < -R * 0.15 || Math.sqrt(q[0] * q[0] + q[1] * q[1]) > R - 0.8) return;
      F.trees.push({ x: q[0], z: q[1], r: 0.85 + ((Math.abs(q[0] * 7.13 + q[1] * 3.7) % 1) * 0.45) });
    });
    return F;
  }
  /* Until their own streets arrive: a made-up town that reads as a real one.
     Streets at an angle to the frame, terraces of pitched houses, a few
     bigger flat blocks, a park, street trees and a river. */
  function labelSceneTownFeats(P) {
    var rnd = lsRand(20261026), R = P.seat, F = { ground: [], roads: [], lines: [], buildings: [], trees: [], real: false };
    var an = 0.27, ca = Math.cos(an), sa = Math.sin(an);
    function W(u, v) { return [u * ca - v * sa, u * sa + v * ca]; }
    var pitchU = 13, pitchV = 9.5, street = 1.4, gx, gz, i;
    /* a river running across the back */
    var rv = [], rv2 = [];
    for (i = -R; i <= R; i += 6) { var zz = -R * 0.05 + Math.sin(i / 23) * 4; rv.push([i, zz - 4.2]); rv2.unshift([i, zz + 4.2]); }
    F.ground.push({ rings: [rv.concat(rv2)], col: 'water' });
    for (gx = -R - pitchU; gx < R + pitchU; gx += pitchU) {
      for (gz = -R * 0.02; gz < R + pitchV; gz += pitchV) {
        var uc = gx + pitchU / 2, vc = gz + pitchV / 2, cc = W(uc, vc);
        if (Math.sqrt(cc[0] * cc[0] + cc[1] * cc[1]) > R - 4 || cc[1] < 6) continue;
        var u0 = gx + street / 2, u1 = gx + pitchU - street / 2, v0 = gz + street / 2, v1 = gz + pitchV - street / 2;
        var kind = rnd();
        if (kind < 0.1) {
          F.ground.push({ rings: [[W(u0, v0), W(u1, v0), W(u1, v1), W(u0, v1)]], col: 'grass' });
          for (i = 0; i < 7; i++) { var tp = W(u0 + 1 + rnd() * (u1 - u0 - 2), v0 + 1 + rnd() * (v1 - v0 - 2)); F.trees.push({ x: tp[0], z: tp[1], r: 0.9 + rnd() * 0.5 }); }
        } else if (kind < 0.28) {
          var bh = 1.8 + rnd() * 3.2;
          F.buildings.push({ rings: [[W(u0 + 0.5, v0 + 0.5), W(u1 - 0.5, v0 + 0.5), W(u1 - 0.5, v1 - 0.5), W(u0 + 0.5, v1 - 0.5)]], h: bh, gable: null });
        } else {
          /* terraces both sides of the block, gardens in the middle */
          var n = 4 + Math.floor(rnd() * 3), du = (u1 - u0) / n, dep = 2.3, row;
          for (row = 0; row < 2; row++) {
            for (i = 0; i < n; i++) {
              var a0 = u0 + i * du + 0.05, a1 = a0 + du - 0.1, b0 = row ? v1 - dep : v0, b1 = row ? v1 : v0 + dep;
              var h = 1.3 + rnd() * 0.8, ring = [W(a0, b0), W(a1, b0), W(a1, b1), W(a0, b1)];
              F.buildings.push({ rings: [ring], h: h, gable: lsGable(ring, h) });
            }
          }
          if (rnd() < 0.5) { var t2 = W(u0 + rnd() * (u1 - u0), (v0 + v1) / 2); F.trees.push({ x: t2[0], z: t2[1], r: 0.8 + rnd() * 0.4 }); }
        }
      }
    }
    for (gz = -R * 0.02; gz < R + pitchV; gz += pitchV) {
      var p0 = W(-R * 1.4, gz), p1 = W(R * 1.4, gz);
      F.roads.push({ pts: [p0, p1], w: street });
    }
    for (gx = -R - pitchU; gx < R + pitchU; gx += pitchU) F.roads.push({ pts: [W(gx, -R * 0.02), W(gx, R * 1.3)], w: street });
    return F;
  }
  /* Paint the features: ground, streets, shadows, then buildings and trees
     from the back forwards. */
  function labelSceneDraw(c, V, P, F, pal, G, Wc, Hc) {
    var kTop = lsShade([0, 1, 0]), mg = Wc * 0.08;
    function onPic(pts) {
      var x0 = 1e9, x1 = -1e9, y0 = 1e9, y1 = -1e9, i;
      for (i = 0; i < pts.length; i++) { var q = pts[i]; if (q[0] < x0) x0 = q[0]; if (q[0] > x1) x1 = q[0]; if (q[1] < y0) y0 = q[1]; if (q[1] > y1) y1 = q[1]; }
      return x1 > -mg && x0 < Wc + mg && y1 > -mg && y0 < Hc + mg;
    }
    function proj(r, y) { return r.map(function (q) { return V.p(q[0], y, q[1]); }); }
    function ringsPath(rs, y) {
      c.beginPath();
      rs.forEach(function (r) { var pr = proj(r, y); c.moveTo(pr[0][0], pr[0][1]); for (var i = 1; i < pr.length; i++) c.lineTo(pr[i][0], pr[i][1]); c.closePath(); });
    }
    /* land */
    lsPoly(c, lsRing(V, P.seat, G, 0, Math.PI * 2, 120));
    c.fillStyle = lsCol(pal.land, kTop); c.fill();
    ['dense', 'grass', 'water'].forEach(function (col) {
      F.ground.forEach(function (gr) {
        if (gr.col !== col || !onPic(proj(gr.rings[0], G))) return;
        var base = pal[col], kk = kTop;
        if (col === 'grass') kk *= gr.wooded ? 0.86 : [1, 1.08, 1.04, 0.92][gr.tone] || 1;
        ringsPath(gr.rings, G);
        c.fillStyle = lsCol(base, kk); c.fill('evenodd');
      });
    });
    c.lineCap = 'round'; c.lineJoin = 'round';
    F.lines.forEach(function (ln) {
      var pr = proj(ln.pts, G); if (!onPic(pr)) return;
      c.beginPath(); c.moveTo(pr[0][0], pr[0][1]); for (var i = 1; i < pr.length; i++) c.lineTo(pr[i][0], pr[i][1]);
      c.strokeStyle = lsCol(pal[ln.col] || pal.water, kTop); c.lineWidth = ln.w * V.mm * 0.8; c.stroke();
    });
    F.roads.forEach(function (rd) {
      var pr = proj(rd.pts, G + 0.05); if (!onPic(pr)) return;
      c.beginPath(); c.moveTo(pr[0][0], pr[0][1]); for (var i = 1; i < pr.length; i++) c.lineTo(pr[i][0], pr[i][1]);
      c.strokeStyle = lsCol(pal.road, kTop * 1.01); c.lineWidth = Math.max(0.8, rd.w * V.mm * 0.8); c.stroke();
    });
    /* what is on the picture, back to front */
    var items = [];
    F.buildings.forEach(function (b) {
      var top = b.gable ? b.gable.top : b.h, pr = proj(b.rings[0], G).concat(proj(b.rings[0], G + top));
      if (!onPic(pr)) return;
      var r0 = b.rings[0], mx = 0, mz = 0;
      r0.forEach(function (q) { mx += q[0]; mz += q[1]; }); mx /= r0.length; mz /= r0.length;
      items.push({ b: b, d: V.depth(mx, G + top / 2, mz) });
    });
    F.trees.forEach(function (t) {
      var q = V.p(t.x, G + t.r * 1.3, t.z);
      if (q[0] < -mg || q[0] > Wc + mg || q[1] < -mg || q[1] > Hc + mg) return;
      items.push({ t: t, d: V.depth(t.x, G + t.r, t.z) });
    });
    /* sun shadows, as one layer so overlaps do not darken twice */
    var Lt = lsN(MM_LBL_SCENE.light), sx = -Lt[0] / Lt[1], sz = -Lt[2] / Lt[1];
    var sh = document.createElement('canvas'); sh.width = Wc; sh.height = Hc;
    var s2 = sh.getContext('2d'); s2.fillStyle = '#000';
    items.forEach(function (it) {
      if (it.t) {
        var tc = V.p(it.t.x + sx * it.t.r * 1.2, G, it.t.z + sz * it.t.r * 1.2), rr = it.t.r * V.mm;
        s2.beginPath(); s2.ellipse(tc[0], tc[1], rr * 1.05, rr * 0.55, 0, 0, Math.PI * 2); s2.fill();
        return;
      }
      var b = it.b, hh = b.gable ? b.gable.top : b.h, r0 = b.rings[0], i;
      var moved = r0.map(function (q) { return [q[0] + sx * hh, q[1] + sz * hh]; });
      function poly(rr2) { var pr = proj(rr2, G); s2.beginPath(); s2.moveTo(pr[0][0], pr[0][1]); for (var j = 1; j < pr.length; j++) s2.lineTo(pr[j][0], pr[j][1]); s2.closePath(); s2.fill(); }
      poly(moved);
      for (i = 0; i < r0.length; i++) { var a = r0[i], e = r0[(i + 1) % r0.length]; poly([a, e, moved[(i + 1) % r0.length], moved[i]]); }
    });
    c.save(); c.globalAlpha = 0.15; c.drawImage(sh, 0, 0); c.restore();
    items.sort(function (a, b) { return b.d - a.d; });
    items.forEach(function (it) {
      if (it.t) return lsTree(c, V, it.t, G, pal.tree);
      lsBuilding(c, V, it.b, G, pal.bld);
    });
  }
  function lsTree(c, V, t, G, col) {
    var tc = V.p(t.x, G + t.r * 1.15, t.z), rr = t.r * V.mm, sh = 0.9 + ((Math.abs(t.x * 3.1 + t.z * 1.7) % 1) * 0.16);
    c.beginPath(); c.ellipse(tc[0], tc[1], rr, rr * 0.95, 0, 0, Math.PI * 2);
    c.fillStyle = lsCol(col, 0.8 * sh); c.fill();
    c.beginPath(); c.ellipse(tc[0] - rr * 0.22, tc[1] - rr * 0.28, rr * 0.62, rr * 0.5, 0, 0, Math.PI * 2);
    c.fillStyle = lsCol(col, 1.02 * sh, 0.85); c.fill();
  }
  function lsBuilding(c, V, b, G, col) {
    var walls = [], i, j;
    function wall(a, e, y0, y1, out) {
      var n = [out * (e[1] - a[1]), 0, -out * (e[0] - a[0])], mid = [(a[0] + e[0]) / 2, (y0 + y1) / 2, (a[1] + e[1]) / 2];
      if (!V.sees(mid, n)) return;
      walls.push({ q: [V.p(a[0], y0, a[1]), V.p(e[0], y0, e[1]), V.p(e[0], y1, e[1]), V.p(a[0], y1, a[1])],
                   k: lsShade(n) * 0.95, d: V.depth(mid[0], mid[1], mid[2]) });
    }
    if (b.gable) {
      var g = b.gable, cr = g.c, y0 = G, ye = G + g.eave, yt = G + g.top, sgn = lsArea(cr) > 0 ? 1 : -1;
      for (i = 0; i < 4; i++) wall(cr[i], cr[(i + 1) % 4], y0, ye, sgn);
      walls.sort(function (a, b2) { return b2.d - a.d; }).forEach(function (w) { lsPoly(c, w.q); c.fillStyle = lsCol(col, w.k); c.fill(); });
      /* gable ends and the two roof slopes */
      var rA = g.ridge[0], rB = g.ridge[1];
      var ends = [[cr[0], cr[3], rA], [cr[1], cr[2], rB]], slopes = [[cr[0], cr[1], rB, rA], [cr[3], cr[2], rB, rA]];
      var parts = [];
      ends.forEach(function (t) {
        var n = [t[1][1] - t[0][1], 0, -(t[1][0] - t[0][0])], mid = [(t[0][0] + t[1][0]) / 2, ye, (t[0][1] + t[1][1]) / 2];
        var cxm = (cr[0][0] + cr[2][0]) / 2, czm = (cr[0][1] + cr[2][1]) / 2;
        if ((mid[0] - cxm) * n[0] + (mid[2] - czm) * n[2] < 0) n = [-n[0], 0, -n[2]];
        if (!V.sees(mid, n)) return;
        parts.push({ q: [V.p(t[0][0], ye, t[0][1]), V.p(t[1][0], ye, t[1][1]), V.p(t[2][0], yt, t[2][1])], k: lsShade(n) * 0.95, d: V.depth(mid[0], ye, mid[2]) });
      });
      slopes.forEach(function (sl) {
        var A = [sl[0][0], ye, sl[0][1]], B = [sl[1][0], ye, sl[1][1]], C = [sl[2][0], yt, sl[2][1]];
        var n = lsCross([B[0] - A[0], B[1] - A[1], B[2] - A[2]], [C[0] - A[0], C[1] - A[1], C[2] - A[2]]);
        if (n[1] < 0) n = [-n[0], -n[1], -n[2]];
        var mid = [(A[0] + C[0]) / 2, (A[1] + C[1]) / 2, (A[2] + C[2]) / 2];
        parts.push({ q: [V.p(A[0], ye, A[2]), V.p(B[0], ye, B[2]), V.p(C[0], yt, C[2]), V.p(sl[3][0], yt, sl[3][1])],
                     k: lsShade(n) * 1.02, d: V.depth(mid[0], mid[1], mid[2]), roof: true });
      });
      parts.sort(function (a, b2) { return b2.d - a.d; }).forEach(function (p) { lsPoly(c, p.q); c.fillStyle = lsCol(col, p.k); c.fill(); });
      return;
    }
    var yb = G, yh = G + b.h;
    b.rings.forEach(function (r, ri) {
      var sgn = (lsArea(r) > 0 ? 1 : -1) * (ri ? -1 : 1);
      for (j = 0; j < r.length; j++) wall(r[j], r[(j + 1) % r.length], yb, yh, sgn);
    });
    walls.sort(function (a, b2) { return b2.d - a.d; }).forEach(function (w) { lsPoly(c, w.q); c.fillStyle = lsCol(col, w.k); c.fill(); });
    c.beginPath();
    b.rings.forEach(function (r) { var pr = r.map(function (q) { return V.p(q[0], yh, q[1]); }); c.moveTo(pr[0][0], pr[0][1]); for (var k2 = 1; k2 < pr.length; k2++) c.lineTo(pr[k2][0], pr[k2][1]); c.closePath(); });
    c.fillStyle = lsCol(col, lsShade([0, 1, 0]) * 1.02); c.fill('evenodd');
  }
  /* Oak: the grain runs round the frame, on the face and down the wall. */
  function labelSceneGrain(c, V, P, FR) {
    var rnd = lsRand(1868), i, a, n = 90;
    c.save();
    lsPoly(c, lsRing(V, P.rOut, 0, 0, Math.PI, 90).concat(lsRing(V, P.rIn, 0, Math.PI, 0, 90)));
    c.clip();
    for (i = 0; i < 16; i++) {
      var r = P.rIn + (P.rOut - P.rIn) * rnd(), ph = rnd() * 6.28, amp = 0.15 + rnd() * 0.3, fq = 3 + rnd() * 9;
      c.beginPath();
      for (a = 0; a <= n; a++) {
        var t = a / n * Math.PI, rr = r + Math.sin(t * fq + ph) * amp, q = V.p(Math.cos(t) * rr, 0, Math.sin(t) * rr);
        if (a) c.lineTo(q[0], q[1]); else c.moveTo(q[0], q[1]);
      }
      c.strokeStyle = lsCol(FR, rnd() < 0.5 ? 0.78 : 1.12, 0.35 + rnd() * 0.3);
      c.lineWidth = Math.max(0.6, V.mm * (0.12 + rnd() * 0.25)); c.stroke();
    }
    c.restore();
    c.save();
    var wall = lsRing(V, P.rCh, -1, 0, Math.PI, 90).concat(lsRing(V, P.rWall, P.yWall, Math.PI, 0, 90));
    lsPoly(c, wall); c.clip();
    for (i = 0; i < 14; i++) {
      var f = rnd(), y = -1 + (P.yWall + 1) * f, rw = P.rCh + (P.rWall - P.rCh) * f, ph2 = rnd() * 6.28, fq2 = 2 + rnd() * 6;
      c.beginPath();
      for (a = 0; a <= n; a++) {
        var t2 = a / n * Math.PI, yy = y + Math.sin(t2 * fq2 + ph2) * 0.35, q2 = V.p(Math.cos(t2) * rw, yy, Math.sin(t2) * rw);
        if (a) c.lineTo(q2[0], q2[1]); else c.moveTo(q2[0], q2[1]);
      }
      c.strokeStyle = lsCol(FR, rnd() < 0.6 ? 0.72 : 1.1, 0.25 + rnd() * 0.3);
      c.lineWidth = Math.max(0.6, V.mm * (0.1 + rnd() * 0.22)); c.stroke();
    }
    c.restore();
  }
  /* The plaque: its seam in the face, then the plaque itself, bent round the
     frame with the same picture the 3D model uses, so the words follow the
     curve. */
  function labelScenePlaque(c, V, text, frameId, iconId) {
    var LM = MM_LABEL_MM, rc = V.zc, y = 0.02, w = LM.w, h = LM.h, tone = labelTone(frameId);
    var span = w / rc, a = span / 2 - (h / 2) / rc, i;
    /* B7.0.5: the plaque is the frame's own material, so only its seam and the
       letters show, the way a set-in piece does */
    lsPoly(c, labelArcOutline(rc, h / 2 + 0.12, a, 20).map(function (q) { return V.p(q[0], y, q[1]); }));
    c.strokeStyle = frameId === 'white' ? 'rgba(30,30,30,0.20)' : frameId === 'wood' ? 'rgba(52,30,12,0.55)' : 'rgba(0,0,0,0.75)';
    c.lineWidth = Math.max(1, V.mm * 0.28); c.stroke();
    lsPoly(c, labelArcOutline(rc, h / 2 - 0.05, a, 20).map(function (q) { return V.p(q[0], y, q[1]); }));
    c.fillStyle = frameId === 'white' ? 'rgba(0,0,0,0.025)' : frameId === 'wood' ? 'rgba(255,240,220,0.05)' : 'rgba(255,255,255,0.025)';
    c.fill();
    var img = labelCanvas(text, tone, iconId, true), IW = img.width, IH = img.height, N = 72, sw = IW / N;
    c.save();
    lsPoly(c, labelArcOutline(rc, h / 2, a, 20).map(function (q) { return V.p(q[0], y, q[1]); }));
    c.clip();
    c.imageSmoothingEnabled = true;
    try { c.imageSmoothingQuality = 'high'; } catch (eQ) {}
    for (i = 0; i < N; i++) {
      var p0 = -span / 2 + span * i / N, p1 = -span / 2 + span * (i + 1) / N, pm = (p0 + p1) / 2;
      var tl = V.p(Math.sin(p0) * (rc - h / 2), y, Math.cos(p0) * (rc - h / 2));
      var hx = V.p(Math.sin(p1) * rc, y, Math.cos(p1) * rc), hx0 = V.p(Math.sin(p0) * rc, y, Math.cos(p0) * rc);
      var vi = V.p(Math.sin(pm) * (rc - h / 2), y, Math.cos(pm) * (rc - h / 2)), vo = V.p(Math.sin(pm) * (rc + h / 2), y, Math.cos(pm) * (rc + h / 2));
      c.setTransform(hx[0] - hx0[0], hx[1] - hx0[1], vo[0] - vi[0], vo[1] - vi[1], tl[0], tl[1]);
      c.drawImage(img, i * sw, 0, Math.min(sw * 1.6, IW - i * sw), IH, 0, 0, Math.min(1.6, (IW - i * sw) / sw), 1);
    }
    c.restore();
  }
  /* Draw it all into cv (already sized in device pixels). */
  function labelScene(cv, o) {
    var key = [o.frame, o.cm, (o.cw && o.cw.id) || '', cv.width, cv.height, (o.geo && o.geo.key) || 'town'].join('|');
    var cache = labelScene.cache || (labelScene.cache = {});
    if (cache.key !== key) {
      var back = cache.cv || document.createElement('canvas');
      back.width = cv.width; back.height = cv.height;
      cache.V = labelSceneBack(back, o);
      cache.cv = back; cache.key = key;
    }
    var c = cv.getContext('2d');
    c.setTransform(1, 0, 0, 1, 0, 0);
    c.clearRect(0, 0, cv.width, cv.height);
    c.drawImage(cache.cv, 0, 0);
    labelScenePlaque(c, cache.V, o.text, o.frame, o.icon);
    try { labelSceneInset(c, cache.V, o, cv.width, cv.height); } catch (eI) {}
  }
  /* B7.0.6 (Kevin, 26 Oct: "a section in the bottom right ... with a line coming
     out of it ... shows the label more clearly on a 2D surface"): the label
     face on, flat and readable, in the frame's own colour, with a pointer
     from the plaque on the model. */
  function lsRound(c, x, y, w, h, r) {
    c.beginPath(); c.moveTo(x + r, y); c.lineTo(x + w - r, y); c.arcTo(x + w, y, x + w, y + r, r);
    c.lineTo(x + w, y + h - r); c.arcTo(x + w, y + h, x + w - r, y + h, r); c.lineTo(x + r, y + h);
    c.arcTo(x, y + h, x, y + h - r, r); c.lineTo(x, y + r); c.arcTo(x, y, x + r, y, r); c.closePath();
  }
  function labelSceneInset(c, V, o, Wc, Hc) {
    var B = MM_LBL_SCENE.inset, LM = MM_LABEL_MM, tone = labelTone(o.frame), FR = labelSceneFrameRgb(o.frame);
    var x0 = B.x0 * Wc, y0 = B.y0 * Hc, w = (B.x1 - B.x0) * Wc, h = (B.y1 - B.y0) * Hc, r = Math.min(h * 0.2, Wc * 0.032);
    var u = Wc / 330;                                   /* one css px at 330 wide, scaled */
    var a = V.p(0, 0.02, V.zc + LM.h / 2 + 0.4), b = [x0 + w * 0.26, y0 + 1];
    c.save();
    c.setTransform(1, 0, 0, 1, 0, 0);
    c.lineCap = 'round';
    c.beginPath(); c.moveTo(a[0], a[1]); c.lineTo(b[0], b[1]);
    c.strokeStyle = 'rgba(255,255,255,0.92)'; c.lineWidth = 4.2 * u; c.stroke();
    c.strokeStyle = '#121417'; c.lineWidth = 1.7 * u; c.stroke();
    c.beginPath(); c.arc(a[0], a[1], 4 * u, 0, Math.PI * 2); c.fillStyle = '#FFFFFF'; c.fill();
    c.beginPath(); c.arc(a[0], a[1], 2.4 * u, 0, Math.PI * 2); c.fillStyle = '#121417'; c.fill();
    /* the card: the frame's face, lifted off the picture */
    c.shadowColor = 'rgba(16,20,26,0.28)'; c.shadowBlur = 12 * u; c.shadowOffsetY = 3 * u;
    lsRound(c, x0, y0, w, h, r); c.fillStyle = lsCol(FR, 1.0); c.fill();
    c.shadowColor = 'transparent'; c.shadowBlur = 0; c.shadowOffsetY = 0;
    c.lineWidth = 1 * u; c.strokeStyle = o.frame === 'white' ? 'rgba(0,0,0,0.10)' : 'rgba(255,255,255,0.35)'; c.stroke();
    if (o.frame === 'wood') {
      c.save(); lsRound(c, x0, y0, w, h, r); c.clip();
      var rnd = lsRand(77), i;
      for (i = 0; i < 18; i++) {
        var yy = y0 + h * rnd(), amp = h * (0.01 + rnd() * 0.03), ph = rnd() * 6.28;
        c.beginPath();
        for (var t = 0; t <= 24; t++) { var xx = x0 + w * t / 24, y2 = yy + Math.sin(t / 3 + ph) * amp; if (t) c.lineTo(xx, y2); else c.moveTo(xx, y2); }
        c.strokeStyle = lsCol(FR, rnd() < 0.5 ? 0.8 : 1.12, 0.3 + rnd() * 0.3); c.lineWidth = (0.5 + rnd() * 1.1) * u; c.stroke();
      }
      c.restore();
    }
    /* the plaque, flat: its seam, then the letters on the frame's own material */
    var pw = w * 0.86, ph2 = pw * LM.h / LM.w;
    if (ph2 > h * 0.62) { ph2 = h * 0.62; pw = ph2 * LM.w / LM.h; }
    var px = x0 + (w - pw) / 2, py = y0 + (h - ph2) / 2, pr = ph2 / 2;
    lsRound(c, px - 1.2 * u, py - 1.2 * u, pw + 2.4 * u, ph2 + 2.4 * u, pr + 1.2 * u);
    c.strokeStyle = o.frame === 'white' ? 'rgba(30,30,30,0.22)' : o.frame === 'wood' ? 'rgba(52,30,12,0.6)' : 'rgba(0,0,0,0.85)';
    c.lineWidth = 1.4 * u; c.stroke();
    c.imageSmoothingEnabled = true;
    try { c.imageSmoothingQuality = 'high'; } catch (eQ) {}
    c.drawImage(labelCanvas(o.text, tone, o.icon, true), px, py, pw, ph2);
    c.restore();
  }
  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  /* There was a metres-per-pixel helper here. It assumed 256px tiles while
     MapLibre renders 512px ones, which made every crop square half its true
     size. Nothing computes screen scale by hand now -- sizeCrop asks the map
     to project the real bbox instead. */

  function bboxFor(lat, lon, ground) {
    var hLat = ground / 2 / 110540;
    var hLon = ground / 2 / (111320 * Math.cos(lat * D2R));
    return { minLat: lat - hLat, maxLat: lat + hLat, minLon: lon - hLon, maxLon: lon + hLon };
  }
  function fmtCoord(lat, lon) {
    return Math.abs(lat).toFixed(4) + '\u00B0 ' + (lat >= 0 ? 'N' : 'S') + '   ' +
           Math.abs(lon).toFixed(4) + '\u00B0 ' + (lon >= 0 ? 'E' : 'W');
  }
  function money(cents, fmt) {
    fmt = fmt || '{{amount}}';
    var out = fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, token) {
      var noDecimals = token.indexOf('no_decimals') !== -1 || Math.round(cents) % 100 === 0;
      var thousands = ',', point = '.';
      if (token.indexOf('comma_separator') !== -1) { thousands = '.'; point = ','; }
      else if (token.indexOf('apostrophe_separator') !== -1) { thousands = "'"; point = '.'; }
      else if (token.indexOf('period_and_space_separator') !== -1) { thousands = ' '; point = '.'; }
      else if (token.indexOf('space_separator') !== -1) { thousands = ' '; point = ','; }
      var value = cents / 100;
      var str = noDecimals ? String(Math.round(value)) : value.toFixed(2);
      var parts = str.split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return noDecimals ? whole : whole + point + parts[1];
    });
    return /\d/.test(out) ? out : (cents / 100).toFixed(2);
  }
  function centroidOf(ring) {
    var la = 0, lo = 0;
    ring.forEach(function (p) { lo += p[0]; la += p[1]; });
    return { lat: la / ring.length, lon: lo / ring.length };
  }
  function labelFor(t) {
    if (!t) return '';
    if (t.name) return t.name;
    if (t['addr:street']) return ((t['addr:housenumber'] || '') + ' ' + t['addr:street']).trim();
    return '';
  }
  /* The main Overpass instance rate-limits hard and returns 429 or 504 under
     load. Walk a list of mirrors before giving up, and carry the real status
     through so the message can say what actually happened. */
  /* Identical queries are re-issued constantly: change colour, change frame,
     regenerate, and the same bbox goes back to Overpass for the same bytes.
     Keyed on the query text, so a different area or size misses correctly.
     Promises are stored rather than results, which also collapses two clicks
     in flight at once into one request. */
  var OVERPASS_CACHE = {}, OVERPASS_KEYS = [];

  /* Build 3.7: the same answer also survives a page reload.
     sessionStorage, not localStorage: map data goes stale, and a shopper who
     comes back tomorrow should get today's OSM, not yesterday's. Everything
     here is wrapped -- private windows and blocked site data throw on the
     first touch, and a cache that cannot be written must never cost a render. */
  var OP_STORE_PREFIX = 'mm:op:' + MM_BUILD + ':';
  var OP_STORE_MAX = 3.5e6;          // bytes; above this it will not fit anyway

  function opKey(q) {
    var h = 5381;
    for (var i = 0; i < q.length; i++) h = ((h * 33) ^ q.charCodeAt(i)) >>> 0;
    return OP_STORE_PREFIX + h.toString(36) + '.' + q.length.toString(36);
  }
  function opStoreGet(q) {
    try { return window.sessionStorage.getItem(opKey(q)); } catch (e) { return null; }
  }
  /* Build 4.10: a degraded answer must not be kept. Overpass under load returns
     HTTP 200 with some layers missing, and storing that meant the shopper was
     served the same thinned-out model for the rest of the session -- parks
     rebuilt from tiles, trees scattered at invented positions -- with no way to
     ask again. Dropping the entry costs one refetch; keeping it cost the model. */
  function opStoreDrop(q) {
    try { window.sessionStorage.removeItem(opKey(q)); } catch (e) { /* nothing to do */ }
  }
  function opStorePut(q, text) {
    if (!text || text.length > OP_STORE_MAX) return;
    try {
      window.sessionStorage.setItem(opKey(q), text);
    } catch (e) {
      /* Full. Drop every entry we own and keep this one -- the newest crop is
         the one the shopper is looking at. */
      try {
        var ss = window.sessionStorage, kill = [];
        for (var i = 0; i < ss.length; i++) {
          var k = ss.key(i);
          if (k && k.indexOf('mm:op:') === 0) kill.push(k);
        }
        kill.forEach(function (k) { ss.removeItem(k); });
        ss.setItem(opKey(q), text);
      } catch (e2) { /* give up quietly: this is an optimisation, not a feature */ }
    }
  }

  function overpassCached(query, run) {
    if (OVERPASS_CACHE[query]) {
      if (window.console) console.info('[mm] overpass cache hit (memory)');
      return OVERPASS_CACHE[query];
    }
    var saved = opStoreGet(query);
    if (saved) {
      try {
        var parsed = JSON.parse(saved);
        if (window.console) console.info('[mm] overpass cache hit (session, ' +
          Math.round(saved.length / 1024) + ' KB) — no request');
        var hit = Promise.resolve(parsed);
        OVERPASS_CACHE[query] = hit;
        OVERPASS_KEYS.push(query);
        return hit;
      } catch (e) { /* corrupt entry: fall through and refetch */ }
    }
    var pr = run().catch(function (e) {
      delete OVERPASS_CACHE[query];               // never cache a failure
      var at = OVERPASS_KEYS.indexOf(query);
      if (at >= 0) OVERPASS_KEYS.splice(at, 1);
      throw e;
    });
    OVERPASS_CACHE[query] = pr;
    OVERPASS_KEYS.push(query);
    while (OVERPASS_KEYS.length > 6) delete OVERPASS_CACHE[OVERPASS_KEYS.shift()];
    return pr;
  }

  /* Build 3.7: mirrors are RACED, not queued.
     The old code called the primary, waited up to 100 s for it to hang, and
     only then tried the second host -- so one sulking instance cost the whole
     wait before anything else was even attempted. Now the primary goes first,
     and if it has not answered within HEDGE_MS the next mirror is started
     alongside it; first usable answer wins and the rest are aborted. A host
     that fails outright promotes the next one immediately rather than waiting
     out the hedge. Worst case drops from ~100 s to ~10 s, and the median
     improves too because the fastest instance answers rather than the first
     one on the list.
     One request per instance at a time, which is what a public instance asks
     for -- this races DIFFERENT instances, it does not hammer one. */
  /* 4s, down from 6. Every query this file sends now carries a server-side
     limit of 45s or less and the ones that work come back in one or two, so a
     host that has said nothing in four seconds is not about to. */
  var OP_HEDGE_MS = 4000;      // head start one MIRROR gets before the next

  /* How long the configured primary gets ALONE before any mirror is launched.
     27s, not 4.

     Up to B5.37 the primary got a 4-second head start and then a mirror joined
     it every 4 seconds, so by twelve seconds there were four requests in
     flight -- for each of FOUR queries, while the worker was itself racing
     three upstreams. Twelve-plus concurrent connections into public instances
     that allow about two per IP.

     MEASURED 28 Sep on the live store: three requests two seconds apart all
     returned 502 at exactly 25.1s, while the same query after a quiet spell
     came back in 1.1s with 687 buildings. We were starving ourselves.

     The worker now makes four short sequential attempts of its own inside 26s
     (see the cache worker, W1.6), which is a far better use of that time than
     three more browser connections fighting it for the same upstream slots.
     So it gets the whole window, alone. A mirror is a genuinely independent
     roll -- different IP, not Cloudflare's shared egress -- and is worth
     having, but AFTER, not alongside. */
  var OP_PRIMARY_GRACE_MS = 27000;

  /* A mirror attempt, once the primary has had its turn. Short, because every
     success logged on 28 Sep arrived at 1.1, 1.3, 2.7, 3.8, 4.7 or 5.0
     seconds, and every failure burned the entire cap and returned nothing.
     Waiting 28s on a mirror has never once produced data. */
  var OP_MIRROR_MS = 8000;
  /* 100s on a desktop, 70 on a phone. I cut this to 45 in 5.19 purely for
     speed, and that was the wrong trade: Dublin and Dubrovnik routinely take
     longer than 45s, so it forced EVERY mobile build down the simplified path
     -- which needs a second MapLibre WebGL context, is the fragile one on a
     phone, and carries no city walls. Slow is better than falling back. The
     time comes back from the render instead, which is where it actually went
     (see the phone cap on SIZE). */
  /* A CEILING now, not the actual limit. The real cap is derived per request
     from the [timeout:N] in the query itself -- see hardMs below. Those two
     numbers were unrelated before and that was the bug: a query that told the
     server to give up at 55s was given 70s by the client, so a mirror that had
     already quit still held a slot for fifteen more seconds, four times over.
     This only catches a query with an absurd or missing timeout. */
  var OP_HARD_MS = 70000;
  /* Hard ceiling on any single attempt, whatever the query asked the server
     for. See the note where hardMs is worked out. */
  var OP_ATTEMPT_MS = 30000;
  try {
    /* Inlined rather than reading IS_TOUCH: that is declared hundreds of lines
       below this, and `var` hoists the name without the value. Reading it here
       would give undefined -- the exact mistake that has blanked this page
       before. */
    if ((window.matchMedia && window.matchMedia('(hover:none)').matches) ||
        ('ontouchstart' in window)) OP_HARD_MS = 60000;
  } catch (e) { /* leave the desktop budget in place */ }

  /* ONE REQUEST PER INSTANCE, ACROSS THE WHOLE PAGE.

     Measured on Kevin's phone, 25 Sep, Dubrovnik at 20 cm: four 504s from
     overpass-api.de, two of them logged in the same millisecond. The buildings
     race and the structure race each began at hosts[0] and walked the same list
     in lockstep, so every public instance got two simultaneous requests from
     one client -- which is exactly what a public instance answers with a 504.
     The old comment here claimed the racer "does not hammer one instance"; that
     was true inside a single race and false across two running at once.

     These three are deliberately module-level, shared by every race on the
     page: busy is who is mid-request right now, ok is who has ever returned
     real data this session, and penalty pushes a host that keeps failing or
     answering empty towards the back of the list. */
  var OP_BUSY = {}, OP_OK = {}, OP_PENALTY = {};

  /* Public instances to race against whatever the theme sets. Racing needs
     more than one host to be worth anything, and the theme has only ever been
     configured with the main one -- so the mirrors ship with the code. Any
     host the theme lists is kept and goes first; these are only ever the
     spares, and are tried only when the theme's own host is slow. */
  /* overpass.osm.ch was removed on 28 Sep 2026 and should not come back.
     It has never once returned usable data in any log from this shop: it
     answers with an HTML error page, or with HTTP 200 and zero elements, in
     well under a second. That speed is the danger -- a fast clean empty counts
     as a vote in the "every mirror agrees this area is empty" rule below, so
     it was able to state that Darndale has no buildings and be believed. It is
     not a fallback, it is a fast liar with a vote. */
  var OP_SPARES = [
    'https://overpass.kumi.systems/api/interpreter',
    'https://overpass.private.coffee/api/interpreter'
  ];

  /* A diagnostics tape. Kevin is testing on a phone, where getting at a console
     needs a Mac and a cable, and I have spent a whole day asking him for console
     lines he cannot reasonably get. Every line that would answer a failure is
     recorded here as well as logged, and the error screen offers it as one tap
     to the clipboard. Capped, and it holds nothing but our own output. */
  var MM_DIAG = [];
  function diag(line) {
    try {
      MM_DIAG.push(new Date().toISOString().slice(11, 19) + '  ' + line);
      if (MM_DIAG.length > 60) MM_DIAG.shift();
      if (window.console) console.info('[mm] ' + line);
      /* B5.40: the tape also goes to sessionStorage on every line.

         Kevin, 28 Sep, on a phone: a 40 cm build reached the end of the wait
         and then the page RELOADED itself back to step 1. The one thing that
         would say why is this tape -- and it lived only in memory, so the
         reload destroyed the evidence along with the model. A crash that eats
         its own black box can't be fixed, only guessed at, and guessing has
         been expensive today.

         'mmBuildingAt' is set when a build starts and removed when it ends,
         so a page that comes back to life with it still set knows the previous
         one died mid-build -- which is exactly what an iOS Safari
         out-of-memory reload looks like from the inside. */
      try {
        sessionStorage.setItem('mmDiagTape', MM_DIAG.join('\n'));
        if (/^crop: /.test(line)) sessionStorage.setItem('mmBuildingAt', line);
        else if (/^timing: |^FAILED |cancelled|^backup map source/.test(line)) {
          sessionStorage.removeItem('mmBuildingAt');
        }
      } catch (eS) { /* private mode, or storage full: the console still has it */ }
    } catch (e) {}
  }

  /* Read the previous page's last words BEFORE anything writes over them. */
  var MM_PREV = (function () {
    try {
      var died = sessionStorage.getItem('mmBuildingAt');
      var tape = sessionStorage.getItem('mmDiagTape') || '';
      if (!died) return null;
      sessionStorage.removeItem('mmBuildingAt');
      if (window.console) {
        console.warn('[mm] THE PREVIOUS PAGE DIED MID-BUILD — ' + died);
      }
      return { died: died, tape: tape };
    } catch (e) { return null; }
  })();

  /* B5.46: the chip used to be created only inside build(), so after a crash --
     the one moment it is needed -- it did not exist until the next build, which
     on a phone that is out of memory is the next crash. An armed tab
     (?mmdiag=1, sticks for the tab) now gets it the moment the page loads,
     carrying the previous page's tape. build() swaps in the full chip. */
  function earlyChip() {
    try {
      var on = /[?&]mmdiag\b/.test(String(location.search || ''));
      try {
        if (on) sessionStorage.setItem('mmDiag', '1');
        on = sessionStorage.getItem('mmDiag') === '1';
      } catch (e0) {}
      if (!on || document.getElementById('mm-diag-chip')) return;
      var b = el('button', 'mm-btn', MM_PREV ? 'Copy crash report' : 'Copy build report');
      b.type = 'button';
      b.id = 'mm-diag-chip';
      b.setAttribute('data-early', '1');
      b.setAttribute('style',
        'position:fixed;left:12px;bottom:calc(74px + env(safe-area-inset-bottom,0px));' +
        'z-index:99998;width:auto;height:auto;padding:9px 13px;border:0;' +
        'border-radius:99px;font:600 12px/1 ' + MM_FACE + ';cursor:pointer;' +
        'background:#17181A;color:#fff;box-shadow:0 2px 12px rgba(0,0,0,.34)');
      b.addEventListener('click', function (ev) {
        ev.stopPropagation();
        var nav = window.navigator || {};
        var text = ['Mounted Maps diagnostics', 'build ' + MM_BUILD,
          'screen ' + (window.innerWidth || 0) + 'x' + (window.innerHeight || 0) +
            ' · dpr ' + (window.devicePixelRatio || 1),
          'device ' + (nav.userAgent || 'unknown'), ''].concat(MM_DIAG)
          .concat(MM_PREV ? ['', '=== THE PREVIOUS PAGE DIED MID-BUILD ===',
            'it was building: ' + MM_PREV.died, '--- its tape ---', MM_PREV.tape]
            : ['', '(no crash recorded in this tab)'])
          .join('\n');
        var done = function (ok) {
          b.textContent = ok ? 'Copied — paste it to Kevin' : 'Select and copy this';
          if (ok) return;
          var ta = document.createElement('textarea');
          ta.value = text;
          ta.setAttribute('style', 'position:fixed;left:12px;right:12px;height:160px;z-index:99999;' +
            'bottom:calc(120px + env(safe-area-inset-bottom,0px));font:11px/1.4 monospace');
          document.body.appendChild(ta);
          try { ta.select(); } catch (e2) {}
        };
        try {
          if (nav.clipboard && nav.clipboard.writeText) {
            nav.clipboard.writeText(text).then(function () { done(true); },
                                               function () { done(false); });
          } else { done(false); }
        } catch (e1) { done(false); }
      });
      document.body.appendChild(b);
    } catch (e) {}
  }
  /* Deferred a tick: MM_FACE is assigned further down this file. */
  setTimeout(function () {
    if (document.body) earlyChip();
    else document.addEventListener('DOMContentLoaded', earlyChip);
  }, 0);

  function overpassFetch(cfg, query) {
    var hosts = [];
    [cfg.overpassUrl].concat(cfg.overpassMirrors || [], OP_SPARES).forEach(function (h) {
      var v = String(h || '').trim();
      if (!v) return;
      var seen = false;
      hosts.forEach(function (x) { if (x.toLowerCase() === v.toLowerCase()) seen = true; });
      /* Three, not four. The fourth was only ever reached after the first
         three had failed, by which point we had spent the budget and were
         adding a connection rather than a chance. */
      if (!seen && hosts.length < 3) hosts.push(v);
    });

    /* A host that has already 504'd or answered empty twice this session goes
       to the back. Stable, so the theme's own host still leads among equals. */
    /* A host that has actually answered outranks one that has only misbehaved,
       and by more than a single failure costs it. Kevin's 17:18 log is the
       reason: overpass-api.de 504'd twice on the heavy queries and then served
       the light ones in 1304 ms and 1946 ms. It is the best host he has, and
       counting only its failures would have pushed it behind a mirror that
       answers empty to everything. */
    hosts = hosts.slice().sort(function (a, b) {
      var sa = (OP_PENALTY[a] || 0) - 2 * (OP_OK[a] || 0);
      var sb = (OP_PENALTY[b] || 0) - 2 * (OP_OK[b] || 0);
      return sa - sb;
    });

    return overpassCached(query, function () {
      return new Promise(function (resolve, reject) {
        if (!hosts.length) { var e0 = new Error('overpass'); e0.status = 0; return reject(e0); }
        var tried = {}, live = 0, lastStatus = 0, settled = false;
        var ctrls = [], hedge = null, t0 = Date.now();
        /* Build 4.6: an Overpass instance under load does NOT return an error.
           It returns HTTP 200 with zero elements and a "remark" saying it ran
           out of time or memory. Racing mirrors on arrival alone therefore lets
           the FASTEST FAILURE win: a loaded mirror answers empty in 14 s and
           beats the one that would have returned the city in 40. Downstream
           that reads as "no buildings and no roads", the whole Overpass path is
           abandoned, and the model is rebuilt from vector tiles -- which carry
           buildings and roads but no walls, no paths and no piers. That is what
           removed Dubrovnik's city wall.
           So an empty answer is not an answer. It is held aside, the race
           carries on, and it is only used if every mirror agrees the area is
           empty -- which, out at sea or in the desert, it honestly is. */
        var emptyFallback = null, emptyHost = '';
        /* Which of the four requests this race is for. Without it the log is a
           list of hosts and times with no way to tell the expensive query from
           the cheap one -- which is precisely the question. */
        var qSecs = /\[timeout:(\d+)\]/.exec(query);
        /* A ceiling on ONE attempt, on top of the server's own timeout.
           Measured 28 Sep: the buildings query asks for 45s, so this worked out
           at 57s, and we spent 57 seconds on kumi.systems and another 57 on
           private.coffee waiting for answers that were never coming -- most of
           a 65-second build. Nothing useful has ever arrived after ~30s in any
           log. Hosts are raced, so patience on one of them buys nothing that
           moving to the next does not buy faster. */
        var hardMs = Math.min(OP_HARD_MS, OP_ATTEMPT_MS,
                              ((qSecs ? +qSecs[1] : 45) + 8) * 1000);
        var qLabel = /node\["natural"="tree"\]/.test(query) ? 'trees'
                   : /way\["building"\]/.test(query) ? 'buildings + streets'
                   : /"leisure"/.test(query) ? 'water, parks and paths'
                   : 'walls';
        /* "An empty answer is not an answer" exists to stop a loaded mirror
           winning the race with nothing in it and taking the buildings down
           with it -- that is what removed Dubrovnik's wall. It does NOT apply
           to the two top-up queries: most crops genuinely have no mapped trees
           and no walls, and racing four mirrors to confirm that added about
           fourteen seconds to the common case. Found by the rig, on a coastal
           fixture with no trees in it, within a minute of splitting the query. */
        var acceptEmpty = (qLabel === 'trees' || qLabel === 'walls');
        /* ...but only from a host that has actually returned data at some point
           this session. In the Dubrovnik log overpass.osm.ch answered EVERY
           query empty in under three seconds, and this rule as first written
           took its word for it: "no walls here", for Dubrovnik, on the say-so
           of a mirror that had not returned a single element all session. The
           walls are the one thing this file has now lost twice. */
        function trustEmptyFrom(h) { return acceptEmpty && !!OP_OK[h]; }
        /* The top-ups are DECORATION and must never hold up a finished model.
           Kevin's 17:36 log, B5.28: the buildings landed at 1891 ms and the
           water, parks and paths at 7299 ms -- and then the build sat for
           FORTY MORE SECONDS while the trees query worked its way through a
           504, an empty answer and two mirrors that hung for 32 seconds each.
           The model was ready at 17:37:04 and the customer waited until
           17:37:44 for trees. So a top-up now gets a wall clock of its own,
           and it only ever goes to a mirror that has already proved it can
           answer -- kumi.systems and private.coffee have not returned a byte
           in any log Kevin has sent. */
        var SOFT = acceptEmpty;
        var capMs = SOFT ? (qLabel === 'trees' ? 5000 : 12000) : 0;
        if (capMs) {
          setTimeout(function () {
            if (settled) return;
            diag('overpass: gave up on ' + qLabel + ' after ' +
                 Math.round(capMs / 1000) + 's \u2014 decoration, not worth the wait');
            lose();
          }, capMs);
        }

        function stopAll() {
          if (hedge) { clearTimeout(hedge); hedge = null; }
          ctrls.forEach(function (c) { try { if (c) c.abort(); } catch (e) {} });
        }
        function win(json, host, raced) {
          if (settled) return;
          settled = true; stopAll();
          diag('overpass: ' + shortHost(host) + ' answered in ' + (Date.now() - t0) +
               ' ms' + (raced > 1 ? ' (' + raced + ' mirrors raced)' : '') +
               ' \u2014 ' + qLabel);
          resolve(json);
        }
        function lose() {
          if (settled) return;
          settled = true; stopAll();
          var e = new Error('overpass');
          e.status = lastStatus;
          reject(e);
        }
        function anyUntried() {
          for (var i = 0; i < hosts.length; i++) if (!tried[hosts[i]]) return true;
          return false;
        }
        /* The first host this race has not tried AND that no other race on the
           page is currently talking to. Returning null means "they are all
           busy" -- which is a reason to WAIT, not a reason to double up. */
        /* The shop's OWN endpoint -- the cache worker -- is exempt from the
           one-request-at-a-time rule. That rule protects shared public
           instances from us; the worker is ours, it races upstreams itself,
           and throttling it just sends our other queries to the mirrors that
           do not work. Measured 25 Sep: buildings came back from the worker in
           1448 ms while the structural query, locked out of it, spent 28
           seconds on kumi.systems. */
        var OWN = String((cfg && cfg.overpassUrl) || '').trim().toLowerCase();
        function freeHost() {
          var i, h, proven = null, any = null;
          for (i = 0; i < hosts.length; i++) {
            h = hosts[i];
            if (tried[h] || (OP_BUSY[h] && h.toLowerCase() !== OWN)) continue;
            if (!any) any = h;
            if (!proven && OP_OK[h]) proven = h;
          }
          /* Proven first, then anything free. The earlier version had a top-up
             WAIT for a proven mirror rather than use an unproven one, which
             made sense while trees ran after the structural query and had the
             field to themselves. Now they run alongside it the proven host is
             usually busy, and waiting would spend the whole cap doing nothing.
             The cap is what bounds a top-up; it does not need a second rule. */
          return proven || any;
        }
        function arm() {
          if (hedge) clearTimeout(hedge);
          hedge = null;
          if (settled || !anyUntried()) return;
          /* Only the primary has been launched: it is our own worker, making
             four sequential attempts of its own, and a mirror started now would
             compete with it for the very upstream slots it is queueing for.
             Wait it out. Once a mirror is involved the old head start applies,
             because those are independent instances. */
          var onlyPrimary = false;
          try {
            var ks = Object.keys(tried);
            onlyPrimary = ks.length === 1 && String(ks[0]).toLowerCase() === OWN;
          } catch (eA) {}
          var delay = onlyPrimary ? OP_PRIMARY_GRACE_MS : OP_HEDGE_MS;
          /* A decoration top-up has its own short wall clock; never sit through
             the full primary grace for one. */
          if (SOFT && capMs && delay > capMs) delay = OP_HEDGE_MS;
          hedge = setTimeout(function () { hedge = null; launch(); }, delay);
        }
        /* One line per ATTEMPT, not just per winner. The build that cost Kevin
           70 seconds logged exactly one overpass line -- the 1.4s success at
           the end of it -- and said nothing about the 66 seconds of failures
           before, which is the only part worth knowing. */
        function shortHost(h) { return h.replace(/^https?:\/\//, '').split('/')[0]; }
        function launch() {
          if (settled || !anyUntried()) return;
          var host = freeHost();
          if (!host) {
            /* Every remaining instance is answering another of our own queries.
               Come back shortly rather than queue a second request behind it --
               the wait is a fraction of the 504 it would earn. */
            if (hedge) clearTimeout(hedge);
            hedge = setTimeout(function () { hedge = null; launch(); }, 600);
            return;
          }
          tried[host] = 1; OP_BUSY[host] = 1;
          var started = Object.keys(tried).length, aT = Date.now();
          var ctrl = ('AbortController' in window) ? new AbortController() : null;
          if (ctrl) ctrls.push(ctrl);
          /* The server's own limit plus 12s for the connection and the body.
             Waiting longer than this cannot help: the instance has already
             promised to give up at N seconds. */
          /* The primary needs its full window -- it is running four attempts
             behind this one request. A mirror does not: it gets one try, and
             nothing useful has ever arrived from one after 8 seconds. */
          var thisCap = (host.toLowerCase() === OWN) ? hardMs
                                                     : Math.min(hardMs, OP_MIRROR_MS);
          var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, thisCap);
          live++;
          fetch(host, {
            method: 'POST',
            body: 'data=' + encodeURIComponent(query),
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            signal: ctrl ? ctrl.signal : undefined
          }).then(function (r) {
            if (!r.ok) {
              lastStatus = r.status;
              diag('overpass: ' + shortHost(host) + ' HTTP ' + r.status +
                   ' after ' + (Date.now() - aT) + ' ms');
              throw new Error('status ' + r.status);
            }
            /* Read the body as it arrives rather than waiting for the whole
               thing. Nothing about the parse changes -- the point is that the
               caller can report a real, rising figure during the wait instead
               of a panel that sits still for ninety seconds. Falls back to
               r.text() wherever streams or TextDecoder are missing. */
            var onBytes = cfg && cfg.onOpBytes;
            if (typeof onBytes !== 'function' || !r.body || !r.body.getReader ||
                typeof TextDecoder === 'undefined') {
              return r.text();
            }
            var reader = r.body.getReader(), dec = new TextDecoder(), buf = '', got = 0;
            return (function pump() {
              return reader.read().then(function (chunk) {
                if (chunk.done) { buf += dec.decode(); return buf; }
                got += chunk.value.length;
                buf += dec.decode(chunk.value, { stream: true });
                if (!settled) { try { onBytes(got); } catch (eB) {} }
                return pump();
              });
            })();
          }).then(function (text) {
            clearTimeout(timer);
            delete OP_BUSY[host];
            live--;
            if (settled) return;                     // a faster mirror already won
            var json = JSON.parse(text);
            var n = json && json.elements ? json.elements.length : 0;
            if (n) OP_OK[host] = (OP_OK[host] || 0) + 1;
            else OP_PENALTY[host] = (OP_PENALTY[host] || 0) + 1;
            if (!n) {
              /* B5.39: the worker marks an empty it got from the PAID endpoint.
                 That is a checked answer -- "there is genuinely nothing here" --
                 and it has to be believed, or every crop of farmland, coastline
                 or desert fails.

                 Measured 28 Sep: a bbox north of Dublin came back empty from
                 the paid host twice, in 209ms and 190ms, and the build failed
                 instead of building an empty field. People search their
                 hometown, and plenty of hometowns are fields.

                 Only the worker sets this flag, and only for the authenticated
                 upstream. A free mirror's empty still has to earn trust the old
                 way, because that is what cost Darndale its buildings. */
              if (json && json.mm_verified_empty === true) {
                diag('overpass: ' + shortHost(host) + ' checked \u2014 there is genuinely no ' +
                     qLabel + ' here (' + (Date.now() - aT) + ' ms)');
                settled = true; stopAll();
                resolve(json);
                return;
              }
              if (trustEmptyFrom(host)) {
                diag('overpass: ' + shortHost(host) + ' \u2014 no ' + qLabel +
                     ' here (' + (Date.now() - aT) + ' ms), accepted');
                settled = true; stopAll();
                resolve(json);
                return;
              }
              /* Keep it, in case every mirror says the same, but do not let it
                 end the race. json.remark is Overpass telling us why. */
              /* Only from a host that has returned real data at some point this
                 session. This is the same rule as trustEmptyFrom above, and not
                 having it here is what lost Darndale its buildings: osm.ch's
                 instant empty became the agreed answer for a housing estate. */
              if (!emptyFallback && OP_OK[host]) { emptyFallback = json; emptyHost = host; }
              /* THE failure mode of this whole file, and the one that has never
                 been visible: HTTP 200, zero elements, and the server's own
                 explanation in `remark`. */
              diag('overpass: ' + shortHost(host) + ' returned NOTHING after ' +
                   (Date.now() - aT) + ' ms' +
                   (json && json.remark ? ' \u2014 ' + String(json.remark).slice(0, 90) : ''));
              if (window.console) {
                console.warn('[mm] overpass: ' + host.replace(/^https?:\/\//, '').split('/')[0] +
                  ' returned nothing' + (json && json.remark ? ' (' + json.remark + ')' : '') +
                  ' -- not accepted, trying another mirror');
              }
              if (anyUntried()) launch();
              else if (live === 0) {
                if (emptyFallback) {
                  settled = true; stopAll();
                  diag('overpass: every proven mirror says there is genuinely no ' +
                       qLabel + ' here');
                  resolve(emptyFallback);
                } else {
                  /* Nobody credible said it was empty, so we do not know that it
                     is. Fail, and let the caller reach for the backup source. */
                  diag('overpass: no usable answer for ' + qLabel +
                       ' \u2014 not accepting an unproven empty');
                  lose();
                }
              }
              return;
            }
            opStorePut(query, text);
            win(json, host, started);
          }).catch(function (eF) {
            clearTimeout(timer);
            delete OP_BUSY[host];
            live--;
            if (settled) return;
            OP_PENALTY[host] = (OP_PENALTY[host] || 0) + 1;
            diag('overpass: ' + shortHost(host) + ' failed after ' +
                 (Date.now() - aT) + ' ms \u2014 ' +
                 ((eF && eF.name === 'AbortError') ? 'gave up waiting'
                                                   : ((eF && eF.message) || 'network')));
            /* This host is out. Don't wait on the hedge -- start the next one now. */
            if (anyUntried()) launch();
            else if (live === 0) {
              if (emptyFallback) { settled = true; stopAll(); resolve(emptyFallback); }
              else lose();
            }
          });
          arm();
        }
        launch();
      });
    });
  }

  function overpassMessage(status) {
    if (status === 429) {
      return 'The map data service is rate-limiting us right now. Wait about a minute and try again.';
    }
    if (status === 504 || status === 503) {
      return 'The map data service timed out. This area may be very dense; try a smaller size, or try again shortly.';
    }
    return 'Map data did not load. Check your connection and try again.';
  }

  /* Buildings from the last render, kept so the marker picker does not go back
     to Overpass for footprints already in memory. Holds one crop only -- change
     the area and it stops matching, which is the point. */
  var lastBuildings = { key: null, list: null };

  function bboxKey(b) {
    return [b.minLat, b.minLon, b.maxLat, b.maxLon].map(function (v) {
      return (+v).toFixed(5);
    }).join(',');
  }

  function overpassBuildings(cfg, bbox) {
    /* If a preview has been generated for this exact crop, the footprints are
       already here. Re-querying meant waiting again, just as long, for the same
       data -- on the slowest step in the whole flow. */
    if (lastBuildings.list && lastBuildings.key === bboxKey(bbox)) {
      if (window.console) {
        console.info('[mm] marker picker reusing', lastBuildings.list.length,
                     'buildings from the render');
      }
      return Promise.resolve({
        elements: lastBuildings.list.map(function (bl) {
          return {
            type: 'way', id: bl.id, tags: {},
            geometry: ((bl.rings && bl.rings[0]) || []).map(function (p) {
              return { lon: p[0], lat: p[1] };
            })
          };
        })
      });
    }
    var bb = bbox.minLat + ',' + bbox.minLon + ',' + bbox.maxLat + ',' + bbox.maxLon;
    return overpassFetch(cfg, '[out:json][timeout:60];way["building"](' + bb + ');out geom 2500;');
  }

  /* B7.1.0 (speed): the section (B4.17) preloads MapLibre instead of running
     it as a page script. It is run from here once the configurator has painted,
     so the first screen is no longer held up by the map library (the largest
     single cost on a phone). A section that still has its own script tag is
     simply waited for, as before. */
  var mlAsked = false;
  function askMapLibre() {
    if (mlAsked || window.maplibregl || !window.MM_MAPLIBRE_URL) return;
    mlAsked = true;
    if (document.querySelector('script[src*="maplibre-gl"]')) return;
    var gone = false;
    function go() {
      if (gone) return;
      gone = true;
      var s = document.createElement('script');
      s.src = window.MM_MAPLIBRE_URL;
      s.async = true;
      s.setAttribute('data-mm-maplibre', '');
      (document.head || document.documentElement).appendChild(s);
    }
    /* After the next paint; the timer covers a tab opened in the background,
       where animation frames do not run. */
    try { requestAnimationFrame(function () { setTimeout(go, 0); }); } catch (eR) {}
    setTimeout(go, 1200);
  }
  /* B7.1.0 (speed): the 1x icon sheet even on a sharp screen. The 2x one is
     about 340 KB for a few small map icons nobody is here to read. */
  function mmMapReq(url, type) {
    if ((type === 'SpriteImage' || type === 'SpriteJSON') && /@2x\./.test(url)) {
      return { url: url.replace('@2x.', '.') };
    }
    return { url: url };
  }
  /* MapLibre arrives via a <script> tag in the section, so wait for it
     rather than assuming load order. */
  function whenMapLibre(cb, fail) {
    if (window.maplibregl) return cb(window.maplibregl);
    askMapLibre();
    var waited = 0;
    var t = setInterval(function () {
      if (window.maplibregl) { clearInterval(t); return cb(window.maplibregl); }
      waited += 60;
      if (waited > 15000) { clearInterval(t); if (fail) fail(); }
    }, 60);
  }


  /* ---------------------------- gestures --------------------------------- */
  /* We drive the camera ourselves with Pointer Events rather than relying on
     MapLibre's handlers, which can be suppressed by theme CSS or a missing
     library stylesheet. One code path covers mouse, touch and pen.
     Deltas are accumulated and applied once per frame so dragging stays smooth
     on a phone, and the centre is only reported when the gesture ends — one
     state update per drag instead of one per frame. */

  function attachGestures(box, getMap, opts) {
    opts = opts || {};
    var pointers = {};
    var dragging = false, startPt = null, pinch = null;
    var panX = 0, panY = 0, targetZoom = null, raf = null;
    var moved = 0;

    function count() { return Object.keys(pointers).length; }
    function two() {
      var k = Object.keys(pointers);
      return [pointers[k[0]], pointers[k[1]]];
    }
    function dist(a, b) { return Math.hypot(a.x - b.x, a.y - b.y); }
    function clampZoom(z) { return Math.max(3, Math.min(19, z)); }

    function schedule() {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var map = getMap();
        if (!map) { panX = panY = 0; targetZoom = null; return; }
        if (targetZoom != null) { map.setZoom(clampZoom(targetZoom)); targetZoom = null; }
        if (panX || panY) {
          map.panBy([-panX, -panY], { animate: false });
          panX = panY = 0;
        }
      });
    }

    function endGesture() {
      dragging = false;
      box.classList.remove('is-dragging');
      var map = getMap();
      if (!map || !opts.onEnd) return;
      /* Apply any pan still queued for the next frame BEFORE reading the
         centre. Deltas are accumulated and flushed once per frame for
         smoothness, so a pointer released between frames leaves the last
         movement unapplied -- and the centre read here would be one frame
         behind where the square is drawn. */
      if (raf) { cancelAnimationFrame(raf); raf = null; }
      if (targetZoom != null) { map.setZoom(clampZoom(targetZoom)); targetZoom = null; }
      if (panX || panY) { map.panBy([-panX, -panY], { animate: false }); panX = panY = 0; }
      var c = map.getCenter();
      opts.onEnd({ lat: c.lat, lon: c.lng });
    }

    box.addEventListener('pointerdown', function (e) {
      if (opts.isLocked && opts.isLocked()) return;
      pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      moved = 0;
      if (count() === 1) {
        startPt = { x: e.clientX, y: e.clientY };
      } else if (count() === 2) {
        dragging = false;
        var p = two();
        var map = getMap();
        pinch = { d: dist(p[0], p[1]), z: map ? map.getZoom() : 14 };
      }
    });

    box.addEventListener('pointermove', function (e) {
      if (!pointers[e.pointerId]) return;
      var prev = pointers[e.pointerId];
      pointers[e.pointerId] = { x: e.clientX, y: e.clientY };

      if (count() >= 2 && pinch) {
        var p = two();
        var d = dist(p[0], p[1]);
        if (d > 0 && pinch.d > 0) {
          targetZoom = pinch.z + Math.log2(d / pinch.d);
          schedule();
        }
        e.preventDefault();
        return;
      }

      moved += Math.abs(e.clientX - prev.x) + Math.abs(e.clientY - prev.y);
      // Only claim the gesture once it's clearly a drag, so taps still reach
      // click handlers (the marker picker needs them).
      if (!dragging && moved > 4) {
        dragging = true;
        box.classList.add('is-dragging');
        if (box.setPointerCapture) { try { box.setPointerCapture(e.pointerId); } catch (err) {} }
        if (opts.onStart) opts.onStart();
      }
      if (dragging) {
        panX += e.clientX - prev.x;
        panY += e.clientY - prev.y;
        schedule();
        e.preventDefault();
      }
    });

    function up(e) {
      if (!pointers[e.pointerId]) return;
      delete pointers[e.pointerId];
      if (count() < 2) pinch = null;
      if (count() === 0) {
        if (dragging) endGesture();
        dragging = false;
        box.classList.remove('is-dragging');
      } else if (count() === 1) {
        // second finger lifted — resume as a single-finger drag
        var k = Object.keys(pointers)[0];
        startPt = { x: pointers[k].x, y: pointers[k].y };
      }
    }
    box.addEventListener('pointerup', up);
    box.addEventListener('pointercancel', up);
    box.addEventListener('lostpointercapture', function () { pinch = null; });

    box.addEventListener('wheel', function (e) {
      if (opts.isLocked && opts.isLocked()) return;
      var map = getMap();
      if (!map) return;
      e.preventDefault();
      targetZoom = (targetZoom != null ? targetZoom : map.getZoom()) - e.deltaY * 0.0028;
      schedule();
      if (opts.wheelEnd) opts.wheelEnd();
    }, { passive: false });

    box.addEventListener('dblclick', function (e) {
      if (opts.isLocked && opts.isLocked()) return;
      var map = getMap();
      if (!map) return;
      e.preventDefault();
      targetZoom = map.getZoom() + 1;
      schedule();
      setTimeout(function () { if (opts.onEnd) { var c = map.getCenter(); opts.onEnd({ lat: c.lat, lon: c.lng }); } }, 60);
    });

    return { endGesture: endGesture };
  }

  /* ----------------------------- geocoder -------------------------------- */

  function makeGeocoder(cfg, onTrouble) {
    var pending = null;
    var mode = cfg.geocoder;              // 'photon' | 'stadia' | 'nominatim' | 'maptiler'
    /* B5.71: MapTiler whenever a key is to hand -- its own setting, or the
       key already in the satellite map style. Fast enough to run as you
       type, and allowed to (Nominatim is not). A failure drops the visit to
       Nominatim through guard(), like the other providers. */
    var mtKey = cfg.maptilerKey || '';
    if (!mtKey) {
      var mk = /api\.maptiler\.com\/[^?]*\?(?:[^#]*&)?key=([A-Za-z0-9_-]+)/.exec(String(cfg.styleUrl || ''));
      if (mk) mtKey = mk[1];
    }
    if (mtKey && cfg.geocoder !== 'off') mode = 'maptiler';

    /* B5.59: every call has a time limit. Photon once took 11-17 s per answer
       without ever failing, so nothing fell back and search looked dead. A
       timeout is NOT an AbortError, so guard() treats it as a failure and
       moves the visit to Nominatim. */
    var FAST_MS = 2500, SLOW_MS = 5000;
    function run(url, exclusive, ms) {
      if (exclusive && pending) pending.abort();
      var ctrl = ('AbortController' in window) ? new AbortController() : null;
      if (exclusive) pending = ctrl;
      var timedOut = false, tid = null;
      if (ctrl && ms) tid = setTimeout(function () { timedOut = true; ctrl.abort(); }, ms);
      return fetch(url, ctrl ? { signal: ctrl.signal } : undefined).then(function (r) {
        if (!r.ok) throw new Error(String(r.status));
        return r.json();
      }).then(function (j) {
        if (tid) clearTimeout(tid);
        return j;
      }, function (e) {
        if (tid) clearTimeout(tid);
        if (timedOut) { var t = new Error('geocoder timeout'); t.name = 'GeoTimeout'; throw t; }
        throw e;
      });
    }

    /* B5.59: a whole country, state or county is not a place to model. Its
       centre point is wherever the maths lands -- the Western Desert for
       "Egypt", the side of Mauna Loa for "Hawaii" -- and the build then fails
       with nothing there. Small ones (Singapore, Monaco, County Dublin) are
       still fine, so size decides, not only the label. */
    var BIG_KINDS = { country: 1, state: 1, region: 1, province: 1, county: 1,
      state_district: 1, continent: 1, archipelago: 1, ocean: 1, sea: 1,
      macroregion: 1, macrocounty: 1, dependency: 1, territory: 1, island: 1 };
    function isBig(kind, span) {
      if (!kind || !BIG_KINDS[kind]) return false;
      if (kind === 'island') return span > 1.5;   // Achill (0.3) is fine
      return !(span > 0) || span > 1.5;           // Singapore (1.0) fine; unknown = big
    }

    /* Photon returns GeoJSON with address parts split across properties. */
    function fromPhoton(json) {
      return ((json && json.features) || []).map(function (f) {
        var p = f.properties || {}, c = (f.geometry || {}).coordinates || [];
        var name = p.name ||
          [p.housenumber, p.street].filter(Boolean).join(' ') ||
          p.city || p.county || '';
        var ctx = [p.street && p.name ? p.street : null, p.district, p.city, p.state, p.country]
          .filter(Boolean).join(', ');
        var ex = p.extent, span = (ex && ex.length === 4)
          ? Math.max(Math.abs(ex[2] - ex[0]), Math.abs(ex[1] - ex[3])) : 0;
        var kind = BIG_KINDS[p.osm_value] ? p.osm_value : p.type;
        return { name: name, ctx: ctx, lat: c[1], lon: c[0], big: isBig(kind, span) };
      }).filter(function (o) { return o.name && o.lat != null; });
    }

    function fromPelias(json) {
      return ((json && json.features) || []).map(function (f) {
        var p = f.properties || {}, c = (f.geometry || {}).coordinates || [];
        var name = p.name || p.label || '';
        var ctx = p.label && p.label !== name
          ? p.label.replace(name + ', ', '')
          : [p.locality, p.region, p.country].filter(Boolean).join(', ');
        var bb = f.bbox, span = (bb && bb.length === 4)
          ? Math.max(Math.abs(bb[2] - bb[0]), Math.abs(bb[3] - bb[1])) : 0;
        return { name: name, ctx: ctx, lat: c[1], lon: c[0], big: isBig(p.layer, span) };
      }).filter(function (o) { return o.lat != null; });
    }

    function fromNominatim(json) {
      if (json && json.display_name) json = [json];
      return (json || []).map(function (r) {
        var parts = String(r.display_name || '').split(', ');
        var bb = (r.boundingbox || []).map(parseFloat), span = bb.length === 4
          ? Math.max(Math.abs(bb[1] - bb[0]), Math.abs(bb[3] - bb[2])) : 0;
        var kind = BIG_KINDS[r.addresstype] ? r.addresstype
          : (r['class'] === 'place' ? r.type : '');
        return { name: parts.shift(), ctx: parts.join(', '),
                 lat: parseFloat(r.lat), lon: parseFloat(r.lon), big: isBig(kind, span) };
      });
    }

    function nominatimSearch(text, focus) {
      /* B5.62: Nominatim has no proximity bias, so with Photon down "Grafton
         Street" from Dublin went to Mayfair. A viewbox around the map centre
         (bounded=0, so only a preference) keeps the local one first. */
      var vb = '';
      if (focus && isFinite(focus.lat) && isFinite(focus.lon)) {
        vb = '&viewbox=' + (focus.lon - 1).toFixed(3) + ',' + (focus.lat + 1).toFixed(3) + ',' +
             (focus.lon + 1).toFixed(3) + ',' + (focus.lat - 1).toFixed(3);
      }
      return run('https://nominatim.openstreetmap.org/search?format=json&limit=6&q=' +
        encodeURIComponent(text) + vb, true, SLOW_MS).then(fromNominatim);
    }
    function nominatimReverse(lat, lon) {
      return run('https://nominatim.openstreetmap.org/reverse?format=json&zoom=12&lat=' +
        lat.toFixed(5) + '&lon=' + lon.toFixed(5), false, SLOW_MS).then(fromNominatim);
    }

    // Any hard failure drops us to Nominatim for the rest of the session, so a
    // throttled or unreachable provider degrades instead of going silent.
    function guard(promise, fallback) {
      return promise.catch(function (e) {
        if (e && e.name === 'AbortError') throw e;
        if (mode !== 'nominatim') { mode = 'nominatim'; if (onTrouble) onTrouble(); }
        return fallback();
      });
    }

    var MT_BIG = { country: 'country', region: 'region', subregion: 'state_district',
      county: 'county', continental_marine: 'ocean', major_landform: 'island' };
    /* Landmarks: MapTiler leaves POIs out unless asked ("eiffel tower" gave
       streets in the Philippines). A trailing street-type abbreviation is
       spelled out ("grafton st" gave towns in the US). */
    var MT_TYPES = 'poi,address,road,place,neighbourhood,locality,municipality,municipal_district,postal_code,county,region,subregion,country,joint_municipality,joint_submunicipality,continental_marine,major_landform';
    var MT_ABBR = { st: 'street', rd: 'road', ave: 'avenue', av: 'avenue', sq: 'square', ln: 'lane',
      dr: 'drive', ct: 'court', tce: 'terrace', cres: 'crescent', pk: 'park', blvd: 'boulevard' };
    function mtText(text) {
      return String(text).replace(/[;\/]+/g, ' ').trim()
        .replace(/\s(st|rd|ave|av|sq|ln|dr|ct|tce|cres|pk|blvd)\.?$/i, function (m, a) { return ' ' + MT_ABBR[a.toLowerCase()]; });
    }
    function fromMapTiler(json) {
      return ((json && json.features) || []).map(function (f) {
        var c = f.center || (f.geometry && f.geometry.coordinates) || [];
        var parts = String(f.place_name || f.text || '').split(', ');
        var name = parts.shift() || f.text || '';
        var bb = f.bbox, span = (bb && bb.length === 4)
          ? Math.max(Math.abs(bb[2] - bb[0]), Math.abs(bb[3] - bb[1])) : 0;
        return { name: name, ctx: parts.join(', '), lat: +c[1], lon: +c[0],
                 big: isBig(MT_BIG[(f.place_type || [])[0]] || '', span) };
      }).filter(function (o) { return o.name && isFinite(o.lat) && isFinite(o.lon); });
    }
    function maptiler(text, focus, auto) {
      var prox = (focus && isFinite(focus.lat) && isFinite(focus.lon))
        ? focus.lon.toFixed(4) + ',' + focus.lat.toFixed(4) : 'ip';
      var q = mtText(text);
      return run('https://api.maptiler.com/geocoding/' + encodeURIComponent(q) + '.json?key=' +
        encodeURIComponent(mtKey) + '&limit=6&language=en&fuzzyMatch=true&autocomplete=' +
        (auto ? 'true' : 'false') + '&proximity=' + prox + '&types=' + MT_TYPES, true, FAST_MS).then(fromMapTiler);
    }
    function bias(focus) {
      if (!focus) return '';
      return mode === 'photon'
        ? '&lat=' + focus.lat.toFixed(5) + '&lon=' + focus.lon.toFixed(5)
        : '&focus.point.lat=' + focus.lat.toFixed(5) + '&focus.point.lon=' + focus.lon.toFixed(5);
    }
    function stadia(path, params) {
      var u = cfg.geocodeBase.replace(/\/$/, '') + path + '?' + params;
      if (cfg.stadiaKey) u += '&api_key=' + encodeURIComponent(cfg.stadiaKey);
      return u;
    }

    /* B5.62: postcodes. Free-text geocoders treat "75007" or "D02 PN40" as
       just another word, so the first hit was often in the wrong country
       (10117 -> Santo Domingo, 75007 -> Texas) or, for an Eircode OSM does not
       have, a different Eircode or a road in Barcelona. A postcode-shaped
       query is now resolved here first and never falls through to a guess. */
    var PC_EIR = /^\s*([AC-FHKNPRTV-Y]\d{2}|D6W)\s*([0-9AC-FHKNPRTV-Y]{4})\s*$/i;
    var PC_UK = /^\s*([A-Z]{1,2}\d[A-Z\d]?)\s*(\d[A-Z]{2})\s*$/i;
    var PC_GEN = /^\s*(\d{4,5}|\d{4}\s?[A-Z]{2}|\d{3}\s\d{2}|\d{2}-\d{3}|\d{4}-\d{3})\s*$/i;
    var PC_EUROPE = ['ie','gb','fr','nl','be','lu','es','pt','it','mt','at','ch','dk','se','no','fi',
      'pl','cz','sk','hu','si','hr','ro','bg','gr','cy','ee','lv','lt','is','de'];
    function pcKind(text) {
      var m;
      if ((m = PC_EIR.exec(text))) return { kind: 'eir', code: (m[1] + ' ' + m[2]).toUpperCase() };
      if ((m = PC_UK.exec(text))) return { kind: 'uk', code: (m[1] + ' ' + m[2]).toUpperCase() };
      if ((m = PC_GEN.exec(text))) return { kind: 'gen', code: m[1].toUpperCase() };
      return null;
    }
    function pcSquash(s) { return String(s || '').replace(/[\s-]/g, '').toUpperCase(); }
    function visitorCountry() {
      try { return String((window.Shopify && window.Shopify.country) || '').toLowerCase(); }
      catch (e) { return ''; }
    }
    function photonRaw(text, limit) {
      return run(cfg.photonBase.replace(/\/$/, '') + '/api/?limit=' + (limit || 10) + '&lang=en&q=' +
        encodeURIComponent(text), true, FAST_MS).then(function (j) {
          var out = [];
          ((j && j.features) || []).forEach(function (f) {
            var o = fromPhoton({ features: [f] })[0];
            if (!o) return;
            var p = f.properties || {};
            o.cc = String(p.countrycode || '').toLowerCase();
            o.isPostcode = p.osm_value === 'postcode';
            out.push(o);
          });
          return out;
        });
    }
    function exactPostcode(list, code) {
      var want = pcSquash(code);
      return list.filter(function (o) { return pcSquash(o.name) === want; });
    }
    function nominatimPostcode(code, ccs) {
      return run('https://nominatim.openstreetmap.org/search?format=json&limit=6&postalcode=' +
        encodeURIComponent(code) + (ccs ? '&countrycodes=' + ccs : ''), true, SLOW_MS)
        .then(fromNominatim)
        .then(function (l) { return l.map(function (o) { o.name = code; return o; }); });
    }
    function eircode(code) {
      var viaPhoton = mode === 'photon'
        ? photonRaw(code, 6).then(function (l) { return exactPostcode(l, code); })
            .catch(function (e) { if (e && e.name === 'AbortError') throw e; return []; })
        : Promise.resolve([]);
      return viaPhoton.then(function (hit) {
        if (hit.length) return hit.slice(0, 1);
        return run('https://nominatim.openstreetmap.org/search?format=json&limit=3&countrycodes=ie&q=' +
          encodeURIComponent(code), true, SLOW_MS).then(fromNominatim)
          .then(function (l) { return exactPostcode(l, code).slice(0, 1); })
          .catch(function (e) { if (e && e.name === 'AbortError') throw e; return []; });
      });
    }
    function ukPostcode(code) {
      return run('https://api.postcodes.io/postcodes/' + encodeURIComponent(code), true, FAST_MS)
        .then(function (j) {
          var r = j && j.result;
          if (!r || r.latitude == null) return [];
          return [{ name: r.postcode || code,
                    ctx: [r.admin_ward, r.admin_district, r.country].filter(Boolean).join(', '),
                    lat: r.latitude, lon: r.longitude, big: false }];
        })
        .catch(function (e) {
          if (e && e.name === 'AbortError') throw e;
          return nominatimPostcode(code, 'gb').catch(function () { return []; });
        });
    }
    function genericPostcode(code) {
      var cc = visitorCountry();
      function rank(l) {
        return l.slice().sort(function (a, b) {
          function score(o) {
            if (cc && o.cc === cc) return 0;
            return PC_EUROPE.indexOf(o.cc) >= 0 ? 1 : 2;
          }
          return score(a) - score(b);
        });
      }
      var viaPhoton = mode === 'photon'
        ? photonRaw(code, 12).then(function (l) {
            return rank(exactPostcode(l.filter(function (o) { return o.isPostcode; }), code)).slice(0, 6);
          }).catch(function (e) { if (e && e.name === 'AbortError') throw e; return []; })
        : Promise.resolve([]);
      return viaPhoton.then(function (hit) {
        if (hit.length) return hit;
        var first = cc ? nominatimPostcode(code, cc) : Promise.resolve([]);
        return first.then(function (l) {
          return l.length ? l : nominatimPostcode(code, PC_EUROPE.join(','));
        }).catch(function (e) { if (e && e.name === 'AbortError') throw e; return []; });
      });
    }
    /* A promise of results for a postcode-shaped query, or null when the text
       is not a postcode and should go to the normal search. */
    function postcodeQuery(text) {
      var k = pcKind(text);
      if (!k) return null;
      if (k.kind === 'eir') return eircode(k.code);
      if (k.kind === 'uk') return ukPostcode(k.code);
      return genericPostcode(k.code);
    }

    return {
      canSuggest: function () { return mode !== 'nominatim'; },
      minChars: function () { return mode === 'maptiler' ? 2 : (cfg.suggestMinChars || 3); },

      suggest: function (text, focus) {
        var pcS = postcodeQuery(text);   // B5.62
        if (pcS) return pcS;
        if (mode === 'maptiler') {
          return guard(maptiler(text, focus, true), function () { return null; });
        }
        if (mode === 'photon') {
          return guard(
            run(cfg.photonBase.replace(/\/$/, '') + '/api/?limit=6&lang=en&q=' +
              encodeURIComponent(text) + bias(focus), true, FAST_MS).then(fromPhoton),
            function () { return null; });     // B5.59: null hides the list
        }
        if (mode === 'stadia') {
          return guard(
            run(stadia('/geocoding/v1/autocomplete',
              'text=' + encodeURIComponent(text) + '&size=6&lang=en' + bias(focus)), true, FAST_MS).then(fromPelias),
            function () { return null; });
        }
        return Promise.resolve(null);
      },

      search: function (text, focus) {
        var pcQ = postcodeQuery(text);   // B5.62
        if (pcQ) return pcQ;
        if (mode === 'maptiler') {
          return guard(maptiler(text, focus, false).then(function (l) {
            return l.length ? l : nominatimSearch(text, focus);
          }), function () { return nominatimSearch(text, focus); });
        }
        if (mode === 'photon') {
          return guard(
            run(cfg.photonBase.replace(/\/$/, '') + '/api/?limit=6&lang=en&q=' +
              encodeURIComponent(text) + bias(focus), true, FAST_MS).then(fromPhoton),
            function () { return nominatimSearch(text, focus); });
        }
        if (mode === 'stadia') {
          return guard(
            run(stadia('/geocoding/v1/search',
              'text=' + encodeURIComponent(text) + '&size=6&lang=en' + bias(focus)), true, FAST_MS).then(fromPelias),
            function () { return nominatimSearch(text, focus); });
        }
        return nominatimSearch(text, focus);
      },

      reverse: function (lat, lon) {
        var p;
        if (mode === 'maptiler') {
          p = guard(
            run('https://api.maptiler.com/geocoding/' + lon.toFixed(6) + ',' + lat.toFixed(6) +
              '.json?key=' + encodeURIComponent(mtKey) + '&limit=1&language=en', false, FAST_MS).then(fromMapTiler),
            function () { return nominatimReverse(lat, lon); });
        } else if (mode === 'photon') {
          p = guard(
            run(cfg.photonBase.replace(/\/$/, '') + '/reverse?lang=en&limit=1&lat=' +
              lat.toFixed(5) + '&lon=' + lon.toFixed(5), false, FAST_MS).then(fromPhoton),
            function () { return nominatimReverse(lat, lon); });
        } else if (mode === 'stadia') {
          p = guard(
            run(stadia('/geocoding/v1/reverse', 'point.lat=' + lat.toFixed(5) +
              '&point.lon=' + lon.toFixed(5) + '&size=1&lang=en'), false, FAST_MS).then(fromPelias),
            function () { return nominatimReverse(lat, lon); });
        } else {
          p = nominatimReverse(lat, lon);
        }
        return p.then(function (l) { return l[0] || null; });
      }
    };
  }

  /* --------------------------------- boot -------------------------------- */

  function boot() {
    var roots = document.querySelectorAll('[data-mm-root]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }
  /* The dispatch used to sit right here, and that was the bug behind every
     failure on 2026-09-24. The theme loads this asset with `defer`, so by the
     time it runs `document.readyState` is already 'interactive' -- boot() fired
     synchronously at this line, thousands of lines above where the module-level
     `var`s are assigned. `var` hoists the name, not the value, so SEG_ANGLE,
     SEGMENTS, MM_ACCENT, MM_FACE and friends were all `undefined` inside init()
     and the first read of SEG_ANGLE[0] threw before anything rendered. The
     dispatch now lives at the very bottom of this IIFE, after every declaration
     in the file, which is the only ordering that stays correct as the file
     grows. Do not move it back up. */

  function init(root) {
    if (root.dataset.mmReady) return;
    root.dataset.mmReady = '1';

    var cfg = JSON.parse(root.querySelector('[data-mm-settings]').textContent);
    /* B6.0: set here as well as where it is declared further down. The
       first paint now shows every price (all steps open on a wide screen)
       and runs before that line, when a hoisted `matrix` is still undefined
       -- so prices and the total came out of the fallback figures until the
       next repaint. */
    matrix = (cfg.variants || []).length > 0;
    /* Etsy mode (H1): only the schemes Etsy sells, prices hidden (they live
       on Etsy). */
    ETSY = cfg.mode === 'etsy';
    ROOM_BASE = (typeof cfg.roomBase === 'string' && cfg.roomBase) ? cfg.roomBase : null;
    if (ETSY && Array.isArray(cfg.colourways)) {
      var keepCw = COLOURWAYS.filter(function (c) { return cfg.colourways.indexOf(c.id) > -1; });
      if (keepCw.length) { COLOURWAYS.length = 0; Array.prototype.push.apply(COLOURWAYS, keepCw); }
    }
    if (ETSY) money = function () { return ''; };
    /* B7.0: the name label step, when the section offers it (never on Etsy). */
    var LABEL = (function () {
      var c = window.MM_CART || {};
      return { on: !ETSY && c.nameLabelOn === true,
               variantId: c.nameLabelVariantId || 0, price: +c.nameLabelPrice || 0,
               /* B7.0.5: free shipping from (cents, visitor's currency; section B4.16) */
               fs: +c.freeShipLocal || 0 };
    })();
    if (LABEL.on && SEGMENTS.indexOf('Name label') < 0) SEGMENTS.splice(SEGMENTS.length - 1, 0, 'Name label');
    /* The last step (the preview) by position, so a step can be added. */
    function GEN() { return SEGMENTS.length - 1; }
    function falses(n) { var a = []; for (var k = 0; k < n; k++) a.push(false); return a; }
    var SIZES = cfg.sizes || [];
    if (!SIZES.length) {
      root.appendChild(el('div', 'mm-note', 'Add at least one size block in the theme editor.'));
      return;
    }

    /* Add to cart is the last thing in this section, and the gap under it is
       never one thing: our own padding, the padding a theme puts on the section
       wrapper, the padding it puts on an inner wrapper inside that, and then
       the TOP padding of whatever section comes next. Tagging only the outer
       wrapper left most of it in place. CSS cannot select a parent, so the walk
       happens here: every ancestor up to and including the section wrapper, and
       then the next section's top, which is the other half of the gap. */
    (function () {
      var sec = null, node = root, guard = 0;
      while (node && node !== document.body && guard++ < 12) {
        node.classList.add('mm-sec-tight');
        var isSection = (node.className && String(node.className).indexOf('shopify-section') !== -1) ||
                        (node.id && node.id.indexOf('shopify-section') === 0);
        if (isSection) { sec = node; break; }
        node = node.parentElement;
      }
      if (cfg.tightenNext !== false && sec) {
        var next = sec.nextElementSibling;
        if (next) {
          next.classList.add('mm-sec-tight-top');
          // themes commonly pad an inner wrapper rather than the section itself
          if (next.firstElementChild) next.firstElementChild.classList.add('mm-sec-tight-top');
        }
      }
      if (cfg.tailSpace != null) {
        root.style.setProperty('--mm-tail', cfg.tailSpace + 'px');
      }

      /* The photo column pins itself while the options scroll past. Where it
         pins to depends on the theme: a shop with a sticky header needs the
         column to stop below it, or the top of the photo tucks underneath and
         is never seen. Measured rather than guessed, because every theme puts
         its header at a different height. */
      function stickyTop() {
        var tallest = 0, topZ = 0, sawHeader = false;
        var nodes = document.querySelectorAll(
          'header, nav, [class*="header"], [id*="header"], [class*="Header"]');
        for (var i = 0; i < nodes.length && i < 40; i++) {
          var n = nodes[i];
          if (n === root || root.contains(n)) continue;    // never measure ourselves
          var cs;
          try { cs = getComputedStyle(n); } catch (e) { continue; }
          if (cs.position !== 'fixed' && cs.position !== 'sticky') continue;
          var r = n.getBoundingClientRect();
          /* Must actually be sitting at the top right now, and be a plausible
             header. A negative top is a bar that has slid away -- the
             hide-on-scroll pattern -- and reserving space for it would leave a
             permanent gap. Over 240px tall is an overlay, not a header. */
          if (r.top < -2 || r.top > 4 || r.height < 20 || r.height > 240) continue;
          if (r.height > tallest) tallest = r.height;
          sawHeader = true;
          var z = parseInt(cs.zIndex, 10);
          if (isFinite(z) && z > topZ) topZ = z;
        }
        root.style.setProperty('--mm-sticky-top', (tallest + 16) + 'px');

        /* The search box carried a flat z-index:20, which on a theme whose
           sticky header sits below that made the search bar scroll OVER the
           header instead of under it -- the cart and account icons ended up
           behind our input. The number cannot be hardcoded, because it depends
           on a theme we do not control, so it is measured: sit just under
           whatever the header claims, and never drop below 3, which is what it
           takes to stay above the map disc (1) and its ring (2).

           A header with z-index:auto cannot be beaten this way -- we come later
           in the document, so equal stacking still paints us on top. Nothing to
           do about that from here except leave the old value and say so. */
        if (topZ > 3) {
          root.style.setProperty('--mm-z-search', String(topZ - 2));
          root.style.setProperty('--mm-z-sugg', String(topZ - 1));
        } else if (sawHeader && topZ === 0 && window.console) {
          console.info('[mm] sticky header has no z-index of its own, so the ' +
                       'search box cannot be layered beneath it');
        }
      }
      stickyTop();
      var stickyTimer = null;
      window.addEventListener('resize', function () {
        clearTimeout(stickyTimer);
        stickyTimer = setTimeout(stickyTop, 180);
      });
      /* Measured again after the first scroll: plenty of themes only make the
         header sticky once you move, so at load there is nothing to measure. */
      var zOnce = false;
      window.addEventListener('scroll', function () {
        if (zOnce) return;
        zOnce = true;
        setTimeout(stickyTop, 60);
      }, { passive: true });
    })();

    /* renderModel calls this when the composited image is ready. Registered on
       cfg because cfg is per-instance and already threaded all the way down --
       nothing else reaches from the renderer back up to the page. */
    cfg.onRendered = function (shot) {
      /* Etsy mode (H2): no render email on Etsy; mm-etsy.js keeps the shot. */
      if (ETSY) { if (window.MMEtsy) window.MMEtsy.onRendered(shot); return; }
      countModel();                                  // B7.3.0
      st.lastShot = shot;                            // B7.5.0: for "Email me my design"
      sendRender(shot);
    };
    /* B7.3.0: one count per new model, sent to the mailer (Counter.gs), which
       keeps the 30-day number the page shows. Nothing personal goes: no email,
       no place, only the build stamp. Colour, frame and mirror re-renders are
       the same model and are not counted. Only the published theme counts, so
       checks on a draft preview never add to the number. */
    function countModel() {
      if (!st.countDue) return;
      st.countDue = false;
      if (!cfg.renderEmailUrl) return;
      try {
        if (!(window.Shopify && Shopify.theme && Shopify.theme.role === 'main')) return;
        if (/[?&]mmdiag=/.test(location.search)) return;
        var body = JSON.stringify({ action: 'tick', build: MM_BUILD });
        var sent = false;
        if (navigator.sendBeacon) {
          sent = navigator.sendBeacon(cfg.renderEmailUrl,
            new Blob([body], { type: 'text/plain;charset=utf-8' }));
        }
        if (!sent) {
          fetch(cfg.renderEmailUrl, { method: 'POST', mode: 'no-cors', keepalive: true,
            headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: body })
            .catch(function () {});
        }
      } catch (eT) {}
    }
    /* B5.52: renderModel hands the two room shots up here (null when a new
       build starts, so a stale picture of the last model never lingers). */
    cfg.onRooms = function (rooms) {
      cfg.__mmRooms = rooms || null;
      roomChip();
    };
    function roomChip() {
      if (typeof ui === 'undefined' || !ui || !ui.turn) return;
      /* B6.0.1: wide screens show the two room shots open instead.
         B6.1: phones too. */
      {
        var oldW = ui.turn.querySelector('.mm-room');
        if (oldW) oldW.parentNode.removeChild(oldW);
        paintRooms();
        return;
      }
      paintRooms();
      var old = ui.turn.querySelector('.mm-room');
      var rooms = cfg.__mmRooms;
      if (!rooms || !ui.turn.querySelector('.mm-enl')) {
        if (old) old.parentNode.removeChild(old);
        return;
      }
      if (old && old.getAttribute('data-src') === rooms.table.slice(-64)) return;
      if (old) old.parentNode.removeChild(old);
      var b = el('button', 'mm-room');
      b.type = 'button';
      b.setAttribute('data-src', rooms.table.slice(-64));
      var im = new Image();
      im.src = rooms.table;
      im.alt = '';
      b.appendChild(im);
      b.appendChild(document.createTextNode('See it in a room'));
      ui.turn.appendChild(b);
    }

    var geo = makeGeocoder(cfg, function () { showSearchHint('degraded'); });
    /* Assigned when the search box is wired; the Next button calls it. */
    var commitTyped = function () { return Promise.resolve(false); };
    /* B5.59: dragging the map is a choice too; a search still in flight must
       not jump the pin away from where the customer just put it. */
    var bumpSearch = function () {};
    /* Up here because loadState() runs during init, hundreds of lines above
       where the save/restore pair is written. `var` hoists the name and not the
       value, so declaring this beside them would have handed getItem(undefined)
       and silently restored nothing -- the failure would have looked exactly
       like "the feature does not work". This file has lost a whole page to that
       mistake once already. */
    var SAVE_KEY = 'mm:cfg:' + (cfg.productId || (location.pathname || 'mm'));
    var st = {
      /* Always open on 20 cm. The liquid's "preselect size" checkbox emits a
         hardcoded index 0, which is the 15 cm -- so ticking a box labelled
         "preselect a size" silently opened the configurator on the smallest,
         cheapest thing we sell. Nobody chose that; it is an artefact of the
         template. 20 cm is the size the photography is shot at and the one most
         people buy, so that is what the first screen shows. A theme setting
         that names a specific size can still override it here later. */
      size: (function () {
        var twenty = SIZES.filter(function (x) { return x.cm === 20; })[0];
        return twenty || SIZES[0] || null;
      })(),
      center: { lat: cfg.startLat, lon: cfg.startLon },
      placeName: '', userPicked: false,
      /* Meadow by default: it is the scheme that shows what the product can do,
         and the one the photography is shot in. */
      zoomX: 1, colourway: COLOURWAYS[0].id, frame: 'black', photo: 0,
      /* Only the colour schemes open from the start. That is the choice worth
         seeing photographed -- four materials against one, and the difference
         is not something a name conveys. Black against white needs no picture
         to explain it, and sizes are a scale drawing tall enough to push the
         real choices off a phone screen.

         Set on the STATE, not by leaving the class off the element. sync() runs
         straight after the DOM is built and re-applies the hidden class from
         these flags, so a panel built visible closes again a frame later. */
      compare: false, cmpFrame: false, cmpCw: true, adding: false, error: '',
      markersOn: false, markers: [],
      /* Build 5, the dial: which screen is showing, which segment is live, how
         far the half dial has been swiped, and which of the four rendered
         angles the model is turned to. */
      stage: 'place', seg: 0, angle: 0, done: falses(SEGMENTS.length),
      labelSrc: 'none', labelText: '', labelDate: '', labelDateOpen: false, labelIcon: '',   /* B7.0 */
      /* true between pressing Generate and the render landing -- the step card
         and the buy button both have to say so. */
      /* Step 1 has to be settled before anything else opens. Set by the Use
         this area button; searching, dragging the map or locating sets
         st.userPicked, which counts for the same thing. */
      areaDone: false,
      /* Phone only: once the area is settled the search folds away to buy the
         sheet the room it needs, and Change brings it back. */
      areaEdit: false,
      building: false,
      /* Set only when a render actually landed. A failed build leaves the
         circle showing why it failed, but must not leave Add to cart sitting
         there ready to sell a model that was never made. */
      rendered: false,
      extras: { priority: false, gift: false, hanger: 0 }, giftMsg: '',
      /* Held from the gate until the render finishes, which is a different
         moment entirely -- see gatePreview. */
      email: '', emailSent: false
    };
    /* B6.0: which Compare panel is open (one at a time), and which folded
       step is open again after a render (-1 = none). */
    st.cmp = '';                 /* B6.0.1: closed until tapped */
    st.wideOpen = -1;

    /* The same three products the cart drawer offers, pulled forward to where
       intent is highest. Each is offered only if its variant is configured -- a
       priced option with no variant behind it is exactly what quoted customers
       more than Shopify charged for months. */
    /* Read from window.MM_CART, which the section already prints for the cart
       drawer. Copying these into the configurator's own settings block would
       mean two places to keep a variant ID correct, and the one thing this
       build learned the hard way is that a price in two places drifts. */
    var MMC = window.MM_CART || {};
    var EXTRAS = [
      { id: 'priority', name: 'Priority', price: MMC.priorityPrice || 0,
        variantId: MMC.priorityVariantId || 0 },
      { id: 'gift', name: 'Gift wrap', price: MMC.giftPrice || 0,
        variantId: MMC.giftVariantId || 0 },
      { id: 'hanger', name: 'Hanger', price: MMC.accessoryPrice || 0,
        variantId: MMC.accessoryVariantId || 0, firstQty: MMC.accessoryFirstQty || 2 }
    ];

    /* Declared here, not beside layout(): `var` hoists the name but not the
       value, and the first sync() draws the ring before that assignment would
       have run. Geometry only -- 5.3 dropped the travelling guide light for
       four static quarters, so there is nothing left to animate and nothing to
       ask prefers-reduced-motion about. */
    var RING = { cx: 0, cy: 0, r: 0, thick: 0, t: [0, 0, 0, 0], raf: 0 };
    var HASH_SET_AT = 0;
    var RING_STILL = false;
    try {
      RING_STILL = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) { /* no matchMedia: animate, which is the safe default */ }

    var ui = buildDom(root, cfg, SIZES);
    paintSection();
    var map = makeCropMap(ui.mapWrap, cfg, {
      getGround: ground,
      getCenter: function () { return st.center; },
      onMove: function (c) {
        bumpSearch();                                   // B5.59
        st.center = c;
        st.userPicked = true;
        dropOutOfBounds();
        sync();
      }
    });

    /* The gallery stylesheet also carries the attention cue, and the step cards
       need it long before any preview exists. Idempotent, so buildPreview
       calling it again later costs nothing. */
    try { ensureGalCss(); } catch (eC) {}

    /* Stored choices first, then the URL -- a link someone has just opened is an
       explicit request for that place and outranks whatever this tab was doing
       before. */
    /* The cart drawer's "Add another model" appends ?mmnew=1 (and fires
       mm:newmodel when it is already on this page). The saved state is still
       loaded first, because sessionStorage is what carries the place through
       the navigation -- then everything except the place is reset. */
    var FRESH = /[?&]mmnew\b/.test(String(location.search || ''));
    /* B5.61: the homepage search sends ?mmq=<what they typed>. Read once
       here so the IP lookup further down knows to stay out of the way. */
    var HANDOFF_Q = (function () {
      var m = /[?&]mmq=([^&#]*)/.exec(String(location.search || ''));
      if (!m) return '';
      try { return decodeURIComponent(m[1].replace(/\+/g, ' ')).trim().slice(0, 200); }
      catch (eQ) { return ''; }
    })();
    /* B5.62: the place name that goes with a ?mmq= coordinate pair. */
    var HANDOFF_N = (function () {
      var m = /[?&]mmn=([^&#]*)/.exec(String(location.search || ''));
      if (!m) return '';
      try { return decodeURIComponent(m[1].replace(/\+/g, ' ')).trim().slice(0, 120); }
      catch (eN) { return ''; }
    })();
    var restored = loadState();
    if (FRESH) {
      resetState();
      /* Strip it, or a refresh wipes their choices a second time. */
      try {
        if (history.replaceState) {
          history.replaceState(null, '',
            location.pathname + location.search.replace(/([?&])mmnew=1&?/, '$1')
              .replace(/[?&]$/, '') + location.hash);
        }
      } catch (eF) {}
    }
    if (restored && map && map.goTo) { try { map.goTo(st.center); } catch (eR) {} }
    restoreFromUrl();
    wireSearch();
    /* makeCropMap draws a readout, a gate message, a drag hint and a tile
       warning along the bottom of its box. Those are laid out for a rectangle,
       so a circular crop slices them in half -- and the header, the caption and
       the circle itself already carry what they said. */
    ['.mm-gate', '.mm-tilewarn', '.mm-readout', '.mm-hint'].forEach(function (sel) {
      var n = ui.lens.querySelector(sel);
      if (n) n.style.display = 'none';
    });

    wire();
    layout();
    sync();
    /* Once more, and not belt and braces: layout() measures the banner and the
       sheet to work out how much height the circle can have, and sync() is what
       fills both of them. The first layout() measures an empty shell, so on a
       phone the circle came out bigger than the space it actually had and the
       page ran past the bottom of the screen. */
    layout();
    try {
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { layout(); });
    } catch (eFR) {}
    // the map lives further down the column now, so size it once layout settles
    setTimeout(function () { map.refresh(); }, 120);
    /* And keep asking until the map is actually up. The crop ring is drawn by
       the map, so if the first attempts land before its style has loaded there
       is nothing to draw and nothing to try again -- which is how the first
       frame ended up with no yellow circle in it at all. */
    (function () {
      var tries = 0;
      var t = setInterval(function () {
        tries++;
        if (map.isReady && map.isReady()) { map.fit(); clearInterval(t); }
        else if (tries > 40) clearInterval(t);
      }, 250);
    })();
    if (window.addEventListener) {
      window.addEventListener('load', function () { map.refresh(); });
    }
    /* Not on a fresh start that kept a place: the customer came straight
       from the cart, and moving their map to whatever the IP says is the one
       thing that reset was written to avoid. */
    if (cfg.useIpLocation && !(FRESH && restored) && !HANDOFF_Q) ipLocate();   // B5.61

    /* ------------------------------ location ----------------------------- */
    /* Coarse, IP-derived location on load: no permission prompt, so nothing
       stands between arriving and configuring. Precise location is opt-in via
       the crosshair button. If the lookup fails we silently keep the fallback
       coordinates from the section settings. */

    function ipLocate() {
      fetch(cfg.ipLocationUrl, { mode: 'cors' })
        .then(function (r) { if (!r.ok) throw new Error('ip'); return r.json(); })
        .then(function (j) {
          if (st.userPicked) return;
          var lat = parseFloat(j.latitude != null ? j.latitude : j.lat);
          var lon = parseFloat(j.longitude != null ? j.longitude :
                               (j.lon != null ? j.lon : j.lng));
          if (isNaN(lat) || isNaN(lon)) return;
          st.center = { lat: lat, lon: lon };
          var city = j.city || j.region || j.country_name || j.country;
          if (city) {
            st.placeName = city;
            ui.searchInput.placeholder = ETSY ? (cfg.text.searchPlaceholder || 'Search your home, street or town') : 'Search near ' + city;
          }
          map.goTo(st.center);
          sync();
        })
        .catch(function () { /* keep the configured fallback area */ });
    }

    function locate(auto) {
      if (!navigator.geolocation) { if (!auto) showSearchHint('nolocate'); return; }
      ui.locateBtn.classList.add('is-busy');
      var settled = false;
      function done() { settled = true; ui.locateBtn.classList.remove('is-busy'); }

      navigator.geolocation.getCurrentPosition(function (pos) {
        done();
        if (st.userPicked) return;
        st.center = { lat: pos.coords.latitude, lon: pos.coords.longitude };
        st.markers = [];
        map.goTo(st.center);
        sync();
        geo.reverse(st.center.lat, st.center.lon).then(function (place) {
          if (place && !st.userPicked) {
            st.placeName = place.name;
            ui.searchInput.placeholder = ETSY ? (cfg.text.searchPlaceholder || 'Search your home, street or town') : 'Search near ' + place.name;
            sync();
          }
        }).catch(function () {});
      }, function () {
        done();
        if (!auto) showSearchHint('denied');
      }, { enableHighAccuracy: false, timeout: 8000, maximumAge: 600000 });

      setTimeout(function () { if (!settled) done(); }, 9000);
    }

    function showSearchHint(kind) {
      var msg = kind === 'degraded'
        ? 'Address suggestions are unavailable. Press Enter to search.'
        : kind === 'denied' ? 'Location unavailable. Type a place or address instead.'
        : kind === 'nolocate' ? 'This browser can\u2019t share a location. Type a place or address instead.'
        : '';
      ui.searchHint.textContent = msg;
      ui.searchHint.classList.toggle('mm-hide', !msg);
    }

    /* ------------------------------ derived ------------------------------ */

    /* If the product is built as Size x Colour x Frame, find the variant whose
       option values match the current selection. Real variants mean Shopify
       prices the order, so the browser total can never drift from the charge. */
    var matrix = (cfg.variants || []).length > 0;

    function addon(key) { return addonOf(cfg, key); }

    /* Variant matching. Exact first, then a forgiving pass, so "Black" still
       finds "Black frame" and you don't have to transcribe Shopify's wording
       character for character. Each option value is claimed by at most one
       attribute, which stops the colour "White" from being satisfied by the
       "White frame" option and returning the wrong variant. */
    function norm(x) {
      return String(x == null ? '' : x).toLowerCase().replace(/[^a-z0-9&]+/g, '');
    }
    function claim(opts, needle, used, loose) {
      var n = norm(needle);
      if (!n) return -1;
      var j;
      for (j = 0; j < opts.length; j++) if (!used[j] && opts[j] === n) return j;
      if (!loose) return -1;

      /* Loose means only "the stored value is more verbose than what we asked
         for" — Black finds Black frame. Never the reverse: allowing a shorter
         option to satisfy a longer request let "White & Blue" be answered by
         "White", silently returning the wrong variant and the wrong price.
         Among candidates, take the shortest, which is the most specific. */
      var best = -1, bestLen = Infinity;
      for (j = 0; j < opts.length; j++) {
        if (used[j]) continue;
        if (opts[j].indexOf(n) !== -1 && opts[j].length < bestLen) {
          best = j;
          bestLen = opts[j].length;
        }
      }
      return best;
    }

    /* Lowest real price for a size, across every colour and frame. The size
       cards were showing the theme's fallback numbers while the total came from
       Shopify, so the two disagreed on the same screen. */
    function minPriceForSize(size) {
      if (!matrix || !size) return size ? size.price : 0;
      var cmRe = new RegExp('(^|[^0-9])' + size.cm + '([^0-9]|$)');
      var want = size.optionValue ? norm(size.optionValue) : null;
      var best = null;
      for (var i = 0; i < cfg.variants.length; i++) {
        var v = cfg.variants[i];
        var raw = (v.options || []).map(function (o) { return String(o == null ? '' : o); });
        var hit = false;
        for (var j = 0; j < raw.length; j++) {
          if (want ? norm(raw[j]) === want : cmRe.test(raw[j])) { hit = true; break; }
        }
        if (!hit) continue;
        if (best === null || v.price < best) best = v.price;
      }
      return best === null ? size.price : best;
    }

    function matchVariant(overrideColour, overrideFrame) {
      if (!matrix || !st.size) return null;
      var cwId = overrideColour || st.colourway;
      var frId = overrideFrame || st.frame;
      var cw = COLOURWAYS.filter(function (c) { return c.id === cwId; })[0] || COLOURWAYS[0];
      /* B5.63: every name this scheme may carry in Shopify -- the theme setting,
         the current name, and the old ones -- tried exact first, then loose. */
      var colourNames = [(cfg.colourOptions || {})[cw.id], cw.opt, cw.name]
        .concat(cw.legacy || [])
        .filter(function (x, i, a) { return x && a.indexOf(x) === i; });
      var frame = FRAMES.filter(function (f) { return f.id === frId; })[0] || FRAMES[0];
      var wantFrame = (cfg.frameOptions || {})[frId] || frame.opt || frame.name;
      var sizeVal = st.size.optionValue;
      var cmRe = new RegExp('(^|[^0-9])' + st.size.cm + '([^0-9]|$)');

      function scan(loose, wantColour) {
        for (var i = 0; i < cfg.variants.length; i++) {
          var v = cfg.variants[i];
          var raw = (v.options || []).map(function (o) { return String(o == null ? '' : o); });
          var opts = raw.map(norm);
          var used = {}, j, si = -1;

          if (sizeVal) {
            si = claim(opts, sizeVal, used, loose);
          } else {
            for (j = 0; j < raw.length; j++) {
              if (cmRe.test(raw[j])) { si = j; break; }
            }
          }
          if (si < 0) continue;
          used[si] = 1;

          var ci = claim(opts, wantColour, used, loose);
          if (ci < 0) continue;
          used[ci] = 1;

          var fi = claim(opts, wantFrame, used, loose);
          if (fi < 0) continue;

          return v;
        }
        return null;
      }
      for (var pass = 0; pass < 2; pass++) {
        for (var k = 0; k < colourNames.length; k++) {
          var hitV = scan(pass === 1, colourNames[k]);
          if (hitV) return hitV;
        }
      }
      return null;
    }

    /* The size cards were showing the theme-setting fallback while the total
       came from the real variant — two numbers for the same thing. Read the
       card price from the variants too, so Shopify is the only source. */
    function minPriceFor(sz) {
      if (!matrix) return sz.price;
      var re = new RegExp('(^|[^0-9])' + sz.cm + '([^0-9]|$)');
      var min = null;
      cfg.variants.forEach(function (v) {
        var raw = (v.options || []).map(function (o) { return String(o == null ? '' : o); });
        var belongs = sz.optionValue
          ? raw.some(function (o) { return norm(o) === norm(sz.optionValue); })
          : raw.some(function (o) { return re.test(o); });
        if (belongs && (min === null || v.price < min)) min = v.price;
      });
      return min === null ? sz.price : min;
    }

    function ground()   { return st.size ? st.size.ground / st.zoomX : 1000; }
    function effScale() { return Math.round(cfg.scale / st.zoomX); }
    function cwObj()    { return COLOURWAYS.filter(function (c) { return c.id === st.colourway; })[0] || COLOURWAYS[0]; }
    /* B5.63: a scheme id from outside (old link, saved session, render email)
       may name one that no longer exists, e.g. 'duo'. Fall back to the default
       rather than storing it: cwObj().name would otherwise throw. */
    function knownCw(id) {
      return COLOURWAYS.some(function (c) { return c.id === id; }) ? id : COLOURWAYS[0].id;
    }
    function cropBbox() { return bboxFor(st.center.lat, st.center.lon, ground()); }

    function totalCents() {
      if (!st.size) return 0;
      var c;
      if (matrix) {
        var v = matchVariant();
        // no colourway upcharge here: the variant price already includes it
        c = v ? v.price : st.size.price;
      } else {
        c = st.size.price;
        var cw = cfg.addons['colourway_' + st.colourway];
        if (cw) c += cw.price;
      }
      /* Every extra here has a real variant behind it, so what is added to
         this figure is also added to the cart. */
      EXTRAS.forEach(function (x) {
        if (!x.variantId) return;
        if (x.id === 'hanger') c += st.extras.hanger * x.price;
        else if (st.extras[x.id]) c += x.price;
      });
      /* B7.0: the name label, once chosen. */
      if (labelIsOn()) c += LABEL.price;
      return c;
    }

    function spec() {
      if (!st.size) return null;
      /* Take the centre from the map itself, not from the stored copy. The
         stored one is updated when a drag ends, and every other way the camera
         can move -- a wheel zoom, a pinch, a fitBounds after a size change, a
         pan whose last frame lands after the pointer is released -- leaves it a
         little behind or, at worst, somewhere else entirely. The customer
         framed the square; the square follows the map; so the model must too. */
      var live = map && map.center ? map.center() : null;
      if (live) {
        if (window.console) {
          var dLat = Math.abs(live.lat - st.center.lat);
          var dLon = Math.abs(live.lon - st.center.lon);
          if (dLat > 1e-6 || dLon > 1e-6) {
            console.info('[mm] crop centre corrected from the map: ' +
                         dLat.toFixed(6) + ', ' + dLon.toFixed(6) + ' off');
          }
        }
        st.center = live;
      }
      var g = ground();
      return {
        version: 2,
        product: 'city-model',
        size: { id: st.size.id, cm: st.size.cm, plates: st.size.plates },
        zoom: st.zoomX,
        scale: effScale(),
        groundMeters: Math.round(g),
        shape: 'circle',
        diameterCm: st.size.cm,
        bbox: bboxFor(st.center.lat, st.center.lon, g),
        centre: { lat: +st.center.lat.toFixed(6), lon: +st.center.lon.toFixed(6) },
        placeName: st.placeName || null,
        colourway: st.colourway,
        materials: cwObj().materials,
        frame: st.frame,
        label: labelValue(),     /* B7.0: 'None' or the text set into the frame */
        labelIcon: labelIsOn() && labelValue() !== 'None' ? (st.labelIcon || '') : '',   /* B7.0.1 */
        /* Withdrawn in 4.7. The renderer still reads spec.mirrorWater and
           spec.markers, so they are left as a permanent empty answer rather
           than cut out of the water and building passes. */
        markers: [],
        dataSource: { provider: 'osm-overpass', frozenAt: null }
      };
    }

    function dropOutOfBounds() {
      if (!st.markers.length) return;
      var b = cropBbox();
      st.markers = st.markers.filter(function (m) {
        var ux = (m.lon - (b.minLon + b.maxLon) / 2) / ((b.maxLon - b.minLon) / 2);
        var uy = (m.lat - (b.minLat + b.maxLat) / 2) / ((b.maxLat - b.minLat) / 2);
        return ux * ux + uy * uy <= 1;
      });
    }

    /* --------------------------- preview gate ---------------------------- */
    /* Ask for an email before revealing the render. It's the one
       moment the visitor most wants something, so it converts — and it gives
       you a list of people who configured but didn't buy. */

    function gatePreview() {
      if (!st.size) return;
      if (!cfg.emailGate || st.emailDone) return showPreview();
      /* The visitor spends five to fifteen seconds on this form. That is dead
         time we were wasting -- kick the map fetch off now so it is warm, or
         finished, by the time they submit. overpassCached dedupes, so the real
         render reuses this rather than repeating it. */
      try { warmGeometry(spec(), cfg); } catch (e) { /* never block the gate */ }

      openEmailGate(cfg, function (email, optIn, optInText) {
        st.emailDone = true;
        /* Kept, because the render does not exist yet. It arrives thirty
           seconds to three minutes later, and the address has to still be here
           when it does -- that is the whole reason no render was ever emailed:
           notifyConfigured fired at this instant, with no picture to send. */
        /* B5.49: everyone gets their render; only a ticked box joins the
           newsletter. Before this every address went to Shopify marked
           accepts_marketing, which nobody had agreed to. */
        if (email) {
          st.email = email;
          st.optIn = !!optIn;
          st.optInText = optIn ? (optInText || '') : '';
          if (optIn) submitEmail(email);
          notifyConfigured(email);
        }
        showPreview();
      });
    }

    /* Hand the live viewer's WebGL context back BEFORE the next build starts.

       renderModel() already stops the old one, but renderModel runs at the END
       of a build -- so through the whole data fetch, which on a bad day is a
       minute and a half, the phone is holding: the visible MapLibre map, the
       old live viewer's context, and then a new offscreen renderer, and then
       MapLibre AGAIN if the tile fallback runs. iOS allows only a handful of
       WebGL contexts at once and quietly refuses the next one. That is my
       leading suspect for "it churned for ages on mobile and then failed", and
       releasing this early costs nothing either way. */
    function releaseLive() {
      if (!cfg.__mmLive) return;
      try { cfg.__mmLive.stop(); } catch (e) {}
      cfg.__mmLive = null;
      if (window.console) console.info('[mm] live view context released before the next build');
    }

    function showPreview() {
      releaseLive();
      /* Always inline now: the model screen IS the preview, so there is no
         separate modal to open on a wide screen. */
      {
        ui.pdp.classList.add('is-rendering');
        toModel();
        /* Two mounts, and this is the whole fix for 5.2's overlap: the model
           and its progress line go inside the circle, everything else the
           preview builds -- the real-life comparison row, the room shot, the
           build stats -- goes in the strip underneath it. In 5.2 the lot was
           appended into a 416px circle on top of the map. */
        st.building = true;
        st.rendered = false;
        st.countDue = true;                  /* B7.3.0: count it once it is built */
        sync();
        /* On press, not only on finish. Kevin: people scroll down while they
           wait, press Generate from there, and never see the progress circle --
           so as far as they know nothing happened. This runs after the email
           gate has closed, which is where showPreview() is called from. */
        teleportToModel();
        wideToTop();                                  // B6.0
        wideToPageTop();                              // B7.0.7
        inlinePreview(ui.belowHost, spec(), cfg, null, null, null, ui.renderHost,
          function (ok, why) {
            st.building = false; st.rendered = !!ok;
            /* Cancelled is not the same as failed. Kevin asked for Cancel so
               somebody who had misplaced their crop could fix it -- so put them
               back on the map with the crop where they left it, rather than on
               an empty circle offering to rebuild the same wrong place. */
            if (why === 'cancelled') { backToMap(); return; }
            sync(); layout();
            /* Either way. A failure that happens while they have scrolled away
               leaves them looking at nothing at all, with the explanation and
               the Try again button off screen. */
            centreOnModel();
            /* B6.2: once more after the page has settled, on a phone. */
            if (!wideBoard()) setTimeout(function () { centreOnModel(); }, 550);
            /* B7.0.7 (Kevin: "after I click Generate Model, it teleports me down
               to the comparison section. I need it to teleport me up to the top"):
               on a desktop the steps fold and the page gets much shorter, so the
               render lands with the reader below it. Back to the top, instantly,
               and once more after the room shots have settled the layout. */
            if (wideBoard()) { wideToPageTop(); setTimeout(wideToPageTop, 450); }
          },
          ui.restHost);
      }
    }

    function restoreFromUrl() {
      var tok = readStateToken();
      if (!tok) return;
      var o = unpackState(tok);
      if (!o) return;
      var sz = SIZES.filter(function (x) { return x.cm === o.c; })[0];
      if (sz) st.size = sz;
      if (o.z) st.zoomX = Math.max(1, Math.min(cfg.maxZoom, o.z));
      if (o.a != null && o.o != null) st.center = { lat: o.a, lon: o.o };
      if (o.w) st.colourway = knownCw(o.w);
      if (o.f) st.frame = o.f;
      if (o.n) st.placeName = o.n;
      if (o.l && typeof o.l === 'object' && LABEL.on) labelRestore(o.l[0], o.l[1], o.l[2], o.l[3]);   /* B7.0 */
      /* o.m, o.p and o.k are ignored from 4.7 on. A link saved while polished
         water, a name plate or markers existed still opens -- it just opens
         without them, rather than restoring a thing that can no longer be
         bought or removed. */
      // an arriving link is the visitor's own choice of place; don't override it
      st.userPicked = true;
      map.goTo(st.center);
    }

    /* ------------------- surviving whatever kills the page -----------------

       Kevin has been dumped back at step one more than once, and I have been
       chasing the triggers one at a time: a stray iOS hashchange after a failed
       render (fixed in 5.18), and before that the same thing after a finished
       one. A phone has more ways to lose a page than I can enumerate -- a
       reload, a crashed tab, iOS evicting it under memory pressure during a
       two-minute WebGL build, a back gesture, a link opened and closed. Every
       one of them used to cost the customer their whole configuration.

       So the configuration is written down as it changes, and read back on
       load. Then it does not matter which of those happened: they come back
       where they were. sessionStorage, so it lasts as long as the tab and never
       surprises someone returning next week to a half-built model. Wrapped,
       because private mode and blocked site data both throw on access. */
    function saveState() {
      try {
        if (!window.sessionStorage) return;
        sessionStorage.setItem(SAVE_KEY, JSON.stringify({
          v: 1,
          cm: st.size ? st.size.cm : null,
          lat: st.center.lat, lon: st.center.lon,
          zoom: st.zoomX, name: st.placeName,
          cw: st.colourway, frame: st.frame,
          areaDone: !!st.areaDone, picked: !!st.userPicked,
          done: st.done.slice(0, GEN()),  /* Generate is never restored as done */
          lbl: st.labelSrc, lblT: st.labelText, lblD: st.labelDate, lblI: st.labelIcon,   /* B7.0 */
          nudged: !!st.nudgeDone,         /* B5.67 */
          seg: st.seg
        }));
      } catch (e) { /* storage unavailable: the page simply behaves as before */ }
    }
    function loadState() {
      try {
        if (!window.sessionStorage) return false;
        var raw = sessionStorage.getItem(SAVE_KEY);
        if (!raw) return false;
        var o = JSON.parse(raw);
        if (!o || o.v !== 1) return false;
        var sz = SIZES.filter(function (x) { return x.cm === o.cm; })[0];
        if (sz) st.size = sz;
        if (isFinite(o.lat) && isFinite(o.lon)) st.center = { lat: o.lat, lon: o.lon };
        if (o.zoom) st.zoomX = Math.max(1, Math.min(cfg.maxZoom, o.zoom));
        if (o.name) st.placeName = o.name;
        if (o.cw) st.colourway = knownCw(o.cw);
        if (o.frame) st.frame = o.frame;
        st.areaDone = !!o.areaDone;
        st.userPicked = !!o.picked;
        (o.done || []).forEach(function (d, i) { st.done[i] = !!d; });
        /* B5.67: a tab saved before this build has no flag; a finished first
           pass (Colour done) means the same thing. */
        st.nudgeDone = !!o.nudged || !!(o.done && o.done[GEN() - 1]);
        if (o.lbl && LABEL.on) labelRestore(o.lbl, o.lblT, o.lblD, o.lblI);   /* B7.0 */
        /* Never restored mid-render: the model itself is gone with the page, so
           coming back to step five with nothing in the circle would be worse
           than coming back to the last choice they made. */
        st.done[GEN()] = false;
        st.seg = Math.max(0, Math.min(SEGMENTS.length - 1, o.seg || 0));
        if (window.console) console.info('[mm] restored your previous choices from this tab');
        return true;
      } catch (e) { return false; }
    }

    /* Back to a blank configurator, keeping the place on the map.

       Two routes reach this: "Start a new model" under a finished render, and
       "Add another model" in the cart drawer, which used to land the customer
       on the exact model they had just bought -- every choice restored from
       sessionStorage, steps already ticked.

       Kevin's call on scope: size, frame, colour, the steps and the render all
       reset; the map stays where they left it. Most people buying a second
       model want another part of the same city, and dropping them back on the
       default view is a worse start than the one they already had.

       areaDone and userPicked BOTH go false, because areaOk() is either of
       them -- leaving userPicked true would unlock every step and they would
       not be at the start at all. */
    function defaultSize() {
      var twenty = SIZES.filter(function (x) { return x.cm === 20; })[0];
      return twenty || SIZES[0] || null;
    }
    function resetState() {
      st.size = defaultSize();
      st.zoomX = 1;
      st.colourway = COLOURWAYS[0].id;
      st.frame = 'black';
      st.done = falses(SEGMENTS.length);
      st.stepDone = falses(GEN());   /* B6.3 */
      st.labelSrc = 'none'; st.labelText = ''; st.labelDate = ''; st.labelDateOpen = false; st.labelIcon = '';   /* B7.0 */
      st.placeSeen = false;
      st.askRestart = false;
      st.seg = 0;
      st.areaDone = false;
      st.areaEdit = false;
      st.userPicked = false;
      st.building = false;
      st.rendered = false;
      st.markers = [];
      st.error = '';
      st.extras = { priority: false, gift: false, hanger: 0 };
      st.giftMsg = '';
      /* emailDone is kept deliberately: they gave the address minutes ago and
         asking the same person again in the same tab is friction, not a lead. */
      warmedKey = '';
      saveState();
    }
    /* The button under a finished render. Tears the render down first, so the
       map is back in the circle before anything else changes. */
    function restartFlow() {
      clearInlineRender();
      resetState();
      sync(); layout();
      if (map && map.fit) map.fit();
      showBoard();
    }

    function stateUrl() {
      var loc = window.location || {};
      var base = (loc.origin || '') + (loc.pathname || '');
      return base + '?mm=' + packState(st);
    }

    /* One way out of the render, used by the Change the area button and by the
       back gesture. It tears the render down and puts the map back in the
       circle; toPlace() alone would have left the render sitting on top of it. */
    /* Phones only: the sheet holds Add to cart directly under the circle, so
       centring the circle puts the model and the buy button on screen together
       rather than leaving the customer to hunt for either. */
    /* Puts the circle and the sheet on screen together, with the banner above
       the fold. Phones only -- on a wide screen everything is already visible. */
    /* Where Change location should put you: looking at the SEARCH and the MAP.

       Kevin, 28 Sep, on a phone: "when I click change location it teleports me
       down the screen". It did. The handler called showBoard(), which scrolls
       the board's TOP edge to the top of the viewport -- and the board sits
       below the Your area bar, so the search field and the map were pushed off
       the top of the screen at the exact moment the customer wanted them.

       block:'nearest' is the whole fix: it scrolls only if the target is off
       screen, and does nothing at all when it is already visible. Tapping a
       button should never move the page under someone's thumb when what they
       asked for is already in front of them. */
    function showSearch() {
      if (wideBoard()) return;
      /* B6.1: by as little as needed, under the step bar. */
      if (ui.prog) { phoneReveal(ui.banner); return; }
      try {
        var t = (ui.searchBox && ui.searchBox.offsetParent !== null)
                  ? ui.searchBox : ui.banner;
        if (t && t.scrollIntoView) {
          t.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      } catch (e) { /* an old browser just leaves the page where it is */ }
    }

    function showBoard() {
      if (wideBoard()) return;
      if (ui.prog) { revealSection(0); return; }
      try {
        if (ui.board.scrollIntoView) {
          ui.board.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      } catch (e) { /* an old browser just leaves the page where it is */ }
    }

    /* Most of the circle already on screen. The old rule was "nothing scrolls",
       on the reasoning that the render appears exactly where the finger just
       was -- true when the customer is looking at the button, and wrong the
       moment they have scrolled down to read while they wait. Asking whether
       they can actually see it settles both cases. */
    function modelInView() {
      try {
        var r = ui.arena.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight || 0;
        if (!vh || !r.height) return false;
        return (Math.min(r.bottom, vh) - Math.max(r.top, 0)) / r.height > 0.6;
      } catch (e) { return false; }
    }
    /* B5.55: a real jump. The theme's html{scroll-behavior:smooth} makes even
       behavior:'auto' glide, so it is switched off on the root for this one
       call and put straight back. */
    function jumpTo(target, block) {
      var root = document.documentElement, was = root.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';
      try { target.scrollIntoView({ behavior: 'auto', block: block || 'center' }); }
      finally { root.style.scrollBehavior = was; }
    }

    function centreOnModel(force, instant) {
      if (wideBoard()) return;
      /* B6.2: on a phone, once the model is in, bring up the model and Add
         to cart together (Add to cart now sits under it in the page). */
      if (ui.prog && st.stage === 'cfg' && st.rendered && !st.building && ui.addBtn.offsetParent) {
        phoneRevealSpan(ui.arena, ui.addBtn);
        return;
      }
      if (!force && modelInView()) return;   // already looking at it; do not yank it
      /* B6.1: no jumps on a phone. Smoothly, and only as far as needed. */
      if (ui.prog) { phoneReveal(ui.arena); return; }
      try {
        if (ui.arena.scrollIntoView) {
          if (instant) jumpTo(ui.arena, 'center');
          else ui.arena.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      } catch (e) { /* an old browser just leaves the page where it is */ }
    }

    /* Straight after the email gate closes, three times over 700ms.

       Once is not enough on a phone. The customer has just typed into a field,
       so the soft keyboard is coming down: the visual viewport resizes after
       the modal has gone, and the browser restores its own scroll position
       afterwards -- on top of ours. The panel is also still laying out. Each
       attempt is instant rather than smooth, because Kevin asked to be
       teleported, and it stops as soon as the circle is actually centred. */
    function teleportToModel() {
      if (wideBoard()) return;
      /* B6.1: pressing "See my 3D preview" brings the model up, smoothly;
         once more if the page was still settling. */
      if (ui.prog) {
        /* B6.3 (Kevin): all the way to the top of the page, where the
           model is being made. Once more if the page was still settling. */
        var toTop = function () {
          try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, 0); }
        };
        requestAnimationFrame(toTop);
        setTimeout(function () { if ((window.pageYOffset || 0) > 2) toTop(); }, 700);
        return;
      }
      var tries = 0;
      function go() {
        if (tries++ > 2) return;
        centreOnModel(true, true);
        setTimeout(function () {
          if (!modelInView()) go();
        }, tries === 1 ? 260 : 420);
      }
      requestAnimationFrame(go);
    }

    /* B5.54 (Kevin, 4 Oct): "when I enter a place and have it selected it
       should teleport the screen to the middle of the configurator". On every
       screen size, unlike the phone-only helpers above: on a laptop the board
       sits below the fold too. The search field is blurred first so a phone's
       keyboard is already on its way down, then the jump is repeated (instant,
       up to three times over ~700ms) until the circle really is centred, for
       the same keyboard and layout reasons as teleportToModel. */
    function teleportToBoard(arriving) {
      try { if (ui.searchInput && ui.searchInput.blur) ui.searchInput.blur(); } catch (eB) {}
      /* B6.1, phones: a place picked from the search is shown on the map
         by moving the page as little as needed, smoothly, once the keyboard
         has gone. Arriving from the homepage, nothing moves at all. */
      if (!wideBoard() && ui.prog) {
        if (!arriving) setTimeout(function () { phoneReveal(ui.arena); }, 380);
        return;
      }
      /* B6.0.1: on a wide screen the map is pinned in view; nothing to do. */
      if (wideBoard()) {
        try {
          var ra = ui.arena.getBoundingClientRect();
          if (ra.top >= 0 && ra.bottom <= (window.innerHeight || 0) + 1) return;
        } catch (eW) {}
      }
      var tries = 0;
      function centred() {
        try {
          var r = ui.arena.getBoundingClientRect();
          var vh = window.innerHeight || document.documentElement.clientHeight || 0;
          return !vh || !r.height || Math.abs((r.top + r.bottom) / 2 - vh / 2) < 40;
        } catch (e) { return true; }
      }
      function go() {
        if (tries++ > 2) return;
        try {
          if (ui.arena && ui.arena.scrollIntoView) jumpTo(ui.arena, 'center');   // B5.55
        } catch (e) { return; }
        setTimeout(function () { if (!centred()) go(); }, tries === 1 ? 260 : 420);
      }
      setTimeout(go, 30);   // after sync() has laid the steps out
    }

    /* B6.0, wide screens: pressing Generate folds the steps, so the panel
       gets much shorter -- and someone who scrolled down to the button was
       left looking at the page footer with the model above the fold. Bring
       the board back up under the header, instantly, unless it is already
       sitting there. */
    /* B7.0.7: desktop only; the very top of the page, instantly. */
    function wideToPageTop() {
      if (!wideBoard()) return;
      try {
        var de = document.documentElement, was = de.style.scrollBehavior;
        de.style.scrollBehavior = 'auto';
        if ((window.pageYOffset || de.scrollTop || 0) > 2) window.scrollTo(0, 0);
        de.style.scrollBehavior = was;
      } catch (e) { /* stays where it is */ }
    }
    function wideToTop() {
      if (!wideBoard()) return;
      try {
        /* B6.0.1: the map column is pinned where it starts, so "back to the
           top" means the panel's top level with the map's again. */
        var d = ui.panel.getBoundingClientRect().top - ui.leftCol.getBoundingClientRect().top;
        if (Math.abs(d) < 2) return;
        var y = (window.pageYOffset || document.documentElement.scrollTop || 0) + d;
        var de = document.documentElement, was = de.style.scrollBehavior;
        de.style.scrollBehavior = 'auto';
        window.scrollTo(0, Math.max(0, Math.round(y)));
        de.style.scrollBehavior = was;
      } catch (e) { /* stays where it is */ }
    }

    function backToMap(fromHistory) {
      ui.pdp.classList.remove('is-rendering');
      ui.renderHost.classList.add('mm-hide');
      ui.renderHost.innerHTML = '';
      ui.belowHost.innerHTML = '';
      ui.restHost.innerHTML = '';
      toPlace(fromHistory);
      map.refresh();
    }

    // changing anything invalidates the render that's on screen
    /* Colour, frame and mirror change no geometry whatsoever -- same buildings,
       same roads, same trees, different materials. Tearing the render down and
       making someone press the green button again was asking them to re-earn a
       result we already had. The rebuild reuses the cached geometry, so it costs
       a redraw rather than a fetch. */
    function refreshRender() {
      if (!ui.pdp.classList.contains('is-rendering')) return;  // nothing on screen
      releaseLive();
      st.building = true;
      st.rendered = false;
      sync();
      inlinePreview(ui.belowHost, spec(), cfg, null, null, null, ui.renderHost,
        function (ok) { st.building = false; st.rendered = !!ok; sync(); layout(); },
        ui.restHost);
    }

    function clearInlineRender() {
      if (!ui.pdp.classList.contains('is-rendering')) return;
      /* Hand the GL context back before the DOM holding it is emptied. */
      if (cfg.__mmLive) { try { cfg.__mmLive.stop(); } catch (eC) {} cfg.__mmLive = null; }
      ui.pdp.classList.remove('is-rendering');
      ui.renderHost.classList.add('mm-hide');
      ui.renderHost.innerHTML = '';
      ui.belowHost.innerHTML = '';
      ui.restHost.innerHTML = '';
      if (st.stage === 'cfg') toPlace();
      map.refresh();
    }

    function configPayload(email) {
      return {
        email: email,
        restore_url: stateUrl(),
        size_cm: st.size ? st.size.cm : null,
        colourway: cwObj().name,
        frame: (FRAMES.filter(function (f) { return f.id === st.frame; })[0] || {}).name,
        /* B5.48: wrapped in Unicode isolates (FSI ... PDI) so a right-to-left
           name cannot drag the rest of the line with it -- "15 × 15 · پارک سوم cm"
           in the render email. Invisible in every client. */
        location: '\u2068' + (st.placeName || fmtCoord(st.center.lat, st.center.lon)) + '\u2069',
        total: (totalCents() / 100).toFixed(2),
        currency: cfg.currency || ''
      };
    }

    /* The render exists only as pixels in this browser, so nothing can email it
       unless it is handed to something that can. renderModel calls this once the
       image is composited; the address came from the gate, minutes earlier. */
    function sendRender(shot) {
      if (!shot || (!shot.image && !shot.blank)) {
        if (window.console) console.warn('[mm] render email skipped: no image produced');
        return;
      }
      if (!st.email) return;                       // they skipped the gate
      if (!cfg.renderEmailUrl) {
        if (window.console) {
          console.warn('[mm] render email skipped: no "Render email endpoint" set in the ' +
                       'section settings, so there is nowhere to send it');
        }
        return;
      }
      /* Once per session, on the first finished render. Colour, frame and
         mirror changes re-render, and keyed on the image each of those counted
         as a new send -- four tweaks, four emails into the same inbox. Sending
         on the FIRST render rather than debouncing to the last one is the
         deliberate trade: most people look once and leave, and an email that
         shows their opening choice beats one that never goes because they
         closed the tab before a timer expired. */
      if (st.emailSent) return;
      st.emailSent = true;

      var payload = configPayload(st.email);
      payload.image = shot.image;
      if (shot.imageDesk) payload.image_desk = shot.imageDesk;
      if (shot.blank) {                                   // GUARD (12 Oct)
        delete payload.image;
        payload.render_blank = true;
        payload.device = MM_deviceDiag(shot.cover);
      }
      payload.marketing_opt_in = !!st.optIn;
      payload.consent_text = st.optIn ? (st.optInText || '') : '';
      payload.build = MM_BUILD + (window.MM_LAST_GEO ? ' · ' + window.MM_LAST_GEO : '') +
        (window.MM_TERRAIN && (window.MM_TERRAIN.spikes || window.MM_TERRAIN.noisy)
          ? ' · terrain ' + window.MM_TERRAIN.spikes + ' spike(s) fixed' + (window.MM_TERRAIN.noisy ? ', noisy canvas' : '')
          : '');   // B5.56

      /* B5.49: text/plain, not application/json. Google Apps Script cannot
         answer a CORS preflight, and a JSON content type forces one; plain text
         is a "simple" request and goes straight through. The old Cloudflare
         worker reads the body the same way either way, so this is safe to ship
         before the endpoint is switched. Apps Script always answers 200, so the
         verdict is read from the JSON, not the status. */
      fetch(cfg.renderEmailUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(payload)
      }).then(function (r) {
        return r.text().then(function (t) {
          var j = null;
          try { j = JSON.parse(t); } catch (e) {}
          if (!window.console) return;
          if (r.ok && !(j && j.ok === false)) {
            console.info('[mm] render emailed to ' + st.email + ' (' + r.status + ')');
          } else {
            console.warn('[mm] render email rejected: ' + ((j && j.error) || ('HTTP ' + r.status)));
          }
        });
      }).catch(function (e) {
        if (window.console) console.warn('[mm] render email failed:', e && e.message);
      });
    }

    // Shopify's own newsletter endpoint, so the address lands as a customer
    // with marketing consent rather than somewhere you have to go and collect.
    /* Hand the address and a restore link to whatever sends your email. The
       link is the payload that matters: it reopens this exact configuration. */
    function notifyConfigured(email) {
      var payload = configPayload(email);

      if (cfg.webhookUrl) {
        fetch(cfg.webhookUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        }).catch(function () {});
      }

      if (cfg.klaviyoKey) {
        fetch('https://a.klaviyo.com/client/events/?company_id=' +
              encodeURIComponent(cfg.klaviyoKey), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: cfg.klaviyoRevision },
          body: JSON.stringify({
            data: {
              type: 'event',
              attributes: {
                properties: payload,
                metric: { data: { type: 'metric',
                  attributes: { name: cfg.klaviyoMetric || 'Configured a model' } } },
                profile: { data: { type: 'profile', attributes: { email: email } } }
              }
            }
          })
        }).catch(function () {});
      }
    }

    function submitEmail(email) {
      var rootPath = (window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root : '/';
      var body = new URLSearchParams();
      body.append('form_type', 'customer');
      body.append('utf8', '\u2713');
      body.append('contact[email]', email);
      body.append('contact[accepts_marketing]', 'true');
      body.append('contact[tags]', cfg.emailTag || 'configurator');
      fetch(rootPath + 'contact#contact_form', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString()
      }).catch(function () { /* never block the preview on this */ });
    }

    /* ------------------------- search + autocomplete ---------------------- */

    function wireSearch() {
      var input = ui.searchInput, list = ui.suggList;
      var items = [], active = -1, timer = null, lastQ = '';
      /* B5.59: every query gets a number and only the newest may act. A slow
         answer arriving after the customer has moved on is thrown away. */
      var qSeq = 0;
      bumpSearch = function () { qSeq++; };
      function tooBig(o) {
        qSeq++;
        list.innerHTML = '';
        items = []; active = -1;
        list.appendChild(el('div', 'mm-sugg-empty',
          esc(o.name) + ' covers too big an area to model. Type a town, street ' +
          'or landmark there, or drag the map to the exact spot.'));
        list.classList.remove('mm-hide');
      }

      function hide() { list.classList.add('mm-hide'); list.innerHTML = ''; items = []; active = -1; }
      function paintActive() {
        var nodes = list.querySelectorAll('.mm-sugg-item');
        for (var i = 0; i < nodes.length; i++) nodes[i].classList.toggle('is-active', i === active);
        if (active >= 0 && nodes[active]) nodes[active].scrollIntoView({ block: 'nearest' });
      }
      function choose(o) {
        if (o && o.big) return tooBig(o);                 // B5.59
        qSeq++;
        st.userPicked = true;
        st.center = { lat: o.lat, lon: o.lon };
        st.placeName = o.name;
        st.markers = [];
        input.value = o.ctx ? o.name + ', ' + o.ctx : o.name;
        lastQ = input.value;
        hide();
        map.goTo(st.center);
        sync();
        teleportToBoard();   // B5.54
      }
      function show(results) {
        list.innerHTML = '';
        items = results; active = -1;
        if (!results.length) {
          list.classList.remove('mm-hide');
          list.appendChild(el('div', 'mm-sugg-empty', 'No matches. Try a street, town or landmark.'));
          return;
        }
        results.forEach(function (o) {
          var b = el('button', 'mm-sugg-item',
            '<div class="mm-sugg-name">' + esc(o.name) + '</div>' +
            (o.ctx ? '<div class="mm-sugg-ctx">' + esc(o.ctx) + '</div>' : ''));
          b.type = 'button';
          b.addEventListener('click', function () { choose(o); });
          list.appendChild(b);
        });
        list.classList.remove('mm-hide');
      }
      function query(text, viaEnter) {
        /* Coordinates first. They are unambiguous, so there is nothing for a
           geocoder to add and a network round trip would only add latency and
           a chance of failure. */
        var pt = parseCoords(text);
        if (pt && pt.shortLink) {
          list.innerHTML = '';
          list.appendChild(el('div', 'mm-sugg-empty',
            'That is a shortened Google Maps link, which hides the coordinates. ' +
            'Open it, then copy the full address bar, or right-click the ' +
            'pin in Google Maps and copy the numbers it shows.'));
          list.classList.remove('mm-hide');
          items = []; active = -1;
          return;
        }
        if (pt) {
          hide();
          st.userPicked = true;
          st.center = { lat: pt.lat, lon: pt.lon };
          st.placeName = '';
          st.markers = [];
          input.value = fmtCoord(pt.lat, pt.lon);
          lastQ = input.value;
          map.goTo(st.center);
          /* Name it from what is actually there, so the cart line and the email
             say "Brooklyn" rather than a pair of numbers -- but only as a
             courtesy. The point is already set and does not move if this
             fails. */
          if (geo.reverse) {
            geo.reverse(pt.lat, pt.lon).then(function (place) {
              if (place && place.name &&
                  st.center.lat === pt.lat && st.center.lon === pt.lon) {
                st.placeName = place.name;
                sync();
              }
            }).catch(function () {});
          }
          sync();
          teleportToBoard();   // B5.54
          return;
        }

        var focus = { lat: st.center.lat, lon: st.center.lon };
        var my = ++qSeq;
        var p = (geo.canSuggest() && !viaEnter) ? geo.suggest(text, focus) : geo.search(text, focus);
        p.then(function (res) {
          if (my !== qSeq) return;                         // B5.59: stale
          if (res === null) { hide(); return; }            // suggestions went quiet
          /* Enter takes the FIRST match, not only a lone one. Requiring exactly
             one meant that typing a real address and pressing Enter usually did
             nothing visible, which is how people ended up pressing Next with
             their address still uncommitted and getting the default city.
             B5.59: a first match that is a whole country is refused by choose(),
             never swapped for a later one ("Egypt" must not become a hamlet
             called Egypt in Arkansas). */
          if (viaEnter && res.length) return choose(res[0]);
          show(res);
        }).catch(function (e) {
          if (e && e.name === 'AbortError') return;
          if (my !== qSeq) return;
          list.innerHTML = '';
          list.appendChild(el('div', 'mm-sugg-empty',
            'Search is unavailable right now. Try again in a moment.'));
          list.classList.remove('mm-hide');
          items = []; active = -1;
        });
      }

      input.addEventListener('input', function () {
        var q = input.value.trim();
        if (timer) clearTimeout(timer);
        if (q.length < geo.minChars() || q === lastQ) { hide(); return; }
        if (!geo.canSuggest()) { showSearchHint('degraded'); return; }
        /* Capped at 110ms whatever the theme says. 200ms plus a round trip is
           long enough that a fast typist reaches the Next button before the
           first suggestion has painted. */
        timer = setTimeout(function () { query(q, false); },
                           Math.max(0, Math.min(cfg.suggestDelay || 200, 110)));
      });

      input.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          if (!items.length) return;
          e.preventDefault();
          active = e.key === 'ArrowDown'
            ? (active + 1) % items.length
            : (active <= 0 ? items.length - 1 : active - 1);
          paintActive();
        } else if (e.key === 'Enter') {
          e.preventDefault();
          if (active >= 0 && items[active]) return choose(items[active]);
          var q = input.value.trim();
          if (q.length >= 2) query(q, true);
        } else if (e.key === 'Escape') { hide(); }
      });

      document.addEventListener('click', function (e) {
        if (!ui.searchBox.contains(e.target) && !list.contains(e.target)) hide();
      });

      /* Pressing Next with an address typed but nothing chosen was silently
         keeping whatever the map already showed -- the default city. Reported
         from real use: people type the address and treat Next as Enter, which
         is a perfectly reasonable thing to expect. Next now commits the typed
         text first, the same way Enter does.

         Returns a promise that always settles: a geocoder that is slow or down
         must never leave the button dead. */
      commitTyped = function () {
        var q = input.value.trim();
        if (!q || q === lastQ || q.length < 2) return Promise.resolve(false);
        if (parseCoords(q)) { query(q, true); return Promise.resolve(true); }
        /* A suggestion list already on screen is the answer -- no second trip. */
        if (items.length) {
          if (items[0].big) { tooBig(items[0]); return Promise.resolve('stay'); }
          choose(items[0]); return Promise.resolve(true);
        }
        var focus = { lat: st.center.lat, lon: st.center.lon };
        var my = ++qSeq;
        /* B5.59: 7 s covers a slow Photon (2.5 s) falling back to Nominatim
           (up to 5 s). If it still loses, the answer is dropped when it lands
           rather than moving the pin after the customer has moved on. */
        return Promise.race([
          geo.search(q, focus).then(function (res) {
            if (my !== qSeq) return false;
            if (res && res.length) {
              if (res[0].big) { tooBig(res[0]); return 'stay'; }
              choose(res[0]); return true;
            }
            return false;
          }).catch(function () { return false; }),
          new Promise(function (r) { setTimeout(function () {
            if (my === qSeq) qSeq++;
            r(false);
          }, 7000); })
        ]);
      };

      /* B5.61: homepage hand-off. Same as typing it and pressing Enter:
         first match wins, a whole country is refused by choose(), a pasted
         coordinate skips the geocoder. Then ?mmq= comes off the address bar
         so a refresh or a shared link does not search again. */
      if (HANDOFF_Q && HANDOFF_Q.length >= 2) {
        var hp = parseCoords(HANDOFF_Q);
        if (hp && !hp.shortLink && HANDOFF_N) {
          /* B5.62: picked on the homepage. Land on it and keep its name. */
          qSeq++;
          st.userPicked = true;
          st.center = { lat: hp.lat, lon: hp.lon };
          st.placeName = HANDOFF_N;
          st.markers = [];
          input.value = HANDOFF_N;
          lastQ = input.value;
          map.goTo(st.center);
          sync();
          teleportToBoard(true);
        } else {
          input.value = HANDOFF_Q;
          query(HANDOFF_Q, true);
        }
        try {
          if (history.replaceState) {
            history.replaceState(null, '',
              location.pathname + location.search.replace(/([?&])mmq=[^&#]*&?/, '$1')
                .replace(/([?&])mmn=[^&#]*&?/, '$1')
                .replace(/[?&]$/, '') + location.hash);
          }
        } catch (eH) {}
      }
    }

    /* ------------------------------- wiring ------------------------------ */

    function wire() {
      ui.locateBtn.addEventListener('click', function () { st.userPicked = false; locate(false); });
      ui.buildBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (st.stage === 'cfg' && st.rendered) { backToMap(); return; }
        if (st.size) {
          /* B6.0: desktop has no "Next step" under the search. Pressing
             Generate is accepting the area where the map is. */
          if (!areaOk()) st.areaDone = true;
          gatePreview();
        }
      });
      ui.backBtn.addEventListener('click', function () { backToMap(); });
      /* B6.3: asks first. */
      ui.restartBtn.addEventListener('click', function () {
        st.askRestart = true; sync();
        try { ui.askNo.focus({ preventScroll: true }); } catch (eA) {}
        /* The question is taller than the buttons: keep all of it on screen. */
        if (!wideBoard()) requestAnimationFrame(function () { phoneReveal(ui.askBox); });
      });
      ui.askYes.addEventListener('click', function () { st.askRestart = false; restartFlow(); });
      ui.askNo.addEventListener('click', function () { st.askRestart = false; sync(); });
      ui.cancelBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (cfg.__mmCancelBuild) { try { cfg.__mmCancelBuild(); } catch (eX) {} }
      });
      /* The cart drawer, when it is already on this page and cannot navigate. */
      window.addEventListener('mm:newmodel', function () { restartFlow(); });
      /* B5.59: "Choose another spot" on a build that found nothing to model. */
      window.addEventListener('mm:pickspot', function () { ui.areaEdit.click(); });
      ui.areaNext.addEventListener('click', function () {
        var btn = ui.areaNext, label = btn.textContent;
        var went = false;
        function go() {
          if (went) return;
          went = true;
          btn.disabled = false; btn.textContent = label;
          st.areaDone = true; st.areaEdit = false; st.seg = 0; sync(); layout();
          /* The banner has done its job; scroll it off so the map and the
             options are the screen. */
          showBoard();
        }
        var pending = commitTyped();
        /* Only says "Finding" if there is actually a wait. A committed place
           resolves on the spot and the button must not flicker. */
        var slow = setTimeout(function () {
          if (!went) { btn.disabled = true; btn.textContent = 'Finding that place\u2026'; }
        }, 140);
        pending.then(function (r) {
                       clearTimeout(slow);
                       if (r === 'stay') { btn.disabled = false; btn.textContent = label; return; }
                       go();
                     },
                     function () { clearTimeout(slow); go(); });
      });
      ui.areaEdit.addEventListener('click', function () {
        /* One control, three situations. It must not depend on the customer
           knowing which stage they are in -- that was the whole problem. */
        if (st.building) {
          /* Mid-build: stop it. cancelNow already puts the map back. */
          if (cfg.__mmCancelBuild) { try { cfg.__mmCancelBuild(); } catch (e) {} }
          else backToMap();
        } else if (st.stage === 'cfg') {
          backToMap();
        }
        st.areaEdit = true;
        sync(); layout();
        showSearch();
        /* Desktop only: on a phone this throws the keyboard up and shoves the
           layout around before they have even looked at the map. */
        if (!IS_TOUCH) { try { ui.searchInput.focus(); } catch (eS) {} }
      });
      ui.addBtn.addEventListener('click', addToCart);

      /* B6.1, phones: the step bar, the bar at the bottom of the screen. */
      ui.progBtns.forEach(function (b, k) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          if (k > 0 && !areaOk()) { st.areaDone = true; sync(); }
          revealSection(k);
        });
      });
      ui.pbarBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (st.building) return;
        var live = st.stage === 'cfg';
        if (live && st.rendered) return;
        var last = ui.progBtns.length - 1;
        if (live || PROG_CUR >= last) {
          if (!st.size) return;
          if (!areaOk()) st.areaDone = true;
          ui.buildBtn.click();
          return;
        }
        if (!areaOk()) { st.areaDone = true; sync(); }
        if (PROG_CUR === 1) warmNow('size chosen');
        revealSection(PROG_CUR + 1);
      });
      ui.pbarCancel.addEventListener('click', function (e) {
        e.preventDefault();
        ui.cancelBtn.click();
      });
      window.addEventListener('scroll', onPhoneScroll, { passive: true });
      /* B6.3: the line follows the steps when a Compare opens, a photo
         loads or the screen turns. */
      try {
        if (typeof ResizeObserver === 'function') new ResizeObserver(function () { paintRail(); }).observe(ui.panel);
      } catch (eR) {}
      ui.searchInput.addEventListener('focus', function () { SEARCH_FOCUS = true; paintBar(); });
      ui.searchInput.addEventListener('blur', function () {
        setTimeout(function () { SEARCH_FOCUS = false; paintBar(); }, 250);
      });
      /* The chat button arrives late; look again once it has. */
      setTimeout(function () { BAR_KEY = ''; paintBar(); }, 2500);
      setTimeout(function () { BAR_KEY = ''; paintBar(); }, 6000);

      ui.cards.forEach(function (card, i) {
        card.el.addEventListener('click', function () {
          /* B6.0: on a wide screen every step is open; the tiles do the work.
             B6.1: on a phone as well. */
          if (ui.prog) return;
          /* B5.72: a panel showing a guide is not a step while it does. */
          if (card.hosting) return;
          if (!canOpen(i)) {
            /* Locked, and it says so rather than doing nothing: a dead control
               teaches the customer that the page is broken. The step they are
               actually on gets the nudge, because that is where the way
               forward is. */
            /* On a phone the locked card is not on screen at all -- it is a
               chip -- so "Pick a frame first" written on the card reaches
               nobody. Say it where the finger just landed, then take it away. */
            var why = teaser(i);
            if (why && ui.turn) {
              var held = ui.turn.innerHTML;          // B5.47: keeps the enlarge pill
              ui.turn.textContent = why;
              setTimeout(function () {
                if (ui.turn.textContent === why) ui.turn.innerHTML = held;
              }, 2200);
            }
            /* B5.67: first pass only. Once they have reached Generate, going
               back to adjust is theirs to do without anything shaking. */
            if (!st.nudgeDone) {
              if (!areaOk()) {
                flash(ui.banner);
              } else {
                flash(ui.cards[st.seg].el);
                flash(card.val, 'mm-why');
                flash(card.el, 'mm-whycard');
              }
            }
            return;
          }
          st.seg = i; sync();
        });
        card.back.addEventListener('click', function (e) {
          e.stopPropagation();
          if (i > 0) { st.seg = i - 1; sync(); }
        });
        card.next.addEventListener('click', function (e) {
          e.stopPropagation();
          advance(i);
          sync();
        });
        card.chg.addEventListener('click', function (e) {
          e.stopPropagation();
          st.wideOpen = st.wideOpen === i ? -1 : i;
          sync();
        });
      });

      /* Four still renders, not a free orbit: dragging steps between the angles
         the renderer actually produced, so the control cannot promise a live 3D
         object the product does not make. Only once a render exists -- before
         that the same drag belongs to the map. */
      /* A second finger on the disc is a pinch. Swallow it: the browser's own
         page zoom is the thing that was throwing the layout apart and dumping
         the customer back at the start. */
      ui.disc.addEventListener('touchmove', function (e) {
        if (e.touches && e.touches.length > 1 && e.cancelable) e.preventDefault();
      }, { passive: false });

      /* The four-angle swipe. In live mode the canvas handles the drag itself
         and turns the actual model, so this would be a second, coarser control
         fighting the real one. */
      (function () {
        var x0 = null, a0 = 0;
        ui.disc.addEventListener('pointerdown', function (e) {
          if (cfg.liveView !== false) return;
          if (st.stage !== 'cfg') return;
          if (e.isPrimary === false) return;
          x0 = e.clientX; a0 = st.angle;
        });
        ui.disc.addEventListener('pointermove', function (e) {
          if (x0 === null) return;
          var next = ((a0 + Math.round((e.clientX - x0) / 70)) % 4 + 4) % 4;
          if (next !== st.angle) { st.angle = next; showAngle(); }
        });
        function up() { x0 = null; }
        ui.disc.addEventListener('pointerup', up);
        ui.disc.addEventListener('pointercancel', up);
      })();

      window.addEventListener('resize', layout);
      /* Only a hash change the customer caused counts. We set the hash
         ourselves in toModel(), and a browser that restores or re-fires it --
         which is what a pinch-zoom and a tab switch can do on iOS -- was
         tearing the finished render down and putting them back at the start. */
      window.addEventListener('hashchange', function () {
        if (location.hash === '#mm-model') return;
        if (st.stage !== 'cfg' || st.building) return;
        /* A FAILED render was the hole in this guard. Building is protected and
           a finished render is a fair thing to leave, but after a failure
           st.building goes false while st.rendered is still false -- and on iOS
           a pinch-zoom, a tab switch or the URL bar collapsing fires a
           hashchange on its own. So someone who had just waited two minutes for
           a build that failed got thrown back to step one by a stray gesture,
           on top of the failure. Nothing here is worth tearing down: the screen
           they are on has a Try again button. The on-screen back controls call
           backToMap() directly and still work. */
        if (!st.rendered) return;
        if (Date.now() - HASH_SET_AT < 900) return;
        backToMap(true);
      });
    }

    /* B5.67: class-based so the shake, glow and ring live in CSS. Remove,
       force a reflow, add: a second tap restarts it instead of being ignored.
       The timer is per class, so an older tap cannot strip a newer one. */
    function flash(node, cls) {
      if (!node) return;
      cls = cls || 'mm-nudge';
      node.classList.remove(cls);
      void node.offsetWidth;
      node.classList.add(cls);
      var tk = '_mmFlash_' + cls;
      clearTimeout(node[tk]);
      node[tk] = setTimeout(function () { node.classList.remove(cls); }, 1500);
    }

    var ANGLE_NAMES = ['three-quarter', 'from the left', 'from the right', 'from above'];
    function showAngle() {
      var track = ui.renderHost.querySelector('.mm-gal-track');
      if (track && track.children[st.angle]) {
        try { track.scrollTo({ left: track.children[st.angle].offsetLeft, behavior: 'smooth' }); }
        catch (e) { track.scrollLeft = track.children[st.angle].offsetLeft; }
      }
      if (ui.turn) {
        /* B5.47, Kevin 30 Sep: back to a labelled pill, and under the circle
           rather than on it. B5.44's icon-only arrows on the disc said nothing
           and its "See it full size" label flashed once and vanished. This
           line already sits directly under the circle on both layouts, so the
           pill lives here. Clicks are delegated on ui.turn (see buildDom), so
           the teaser that swaps this text out and back cannot orphan them. */
        if (cfg.liveView !== false) {
          if (!ui.turn.querySelector('.mm-enl')) {
            ui.turn.innerHTML = '<button type="button" class="mm-enl">' +
              '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
              'stroke-width="2" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle>' +
              '<path d="M20 20l-4-4"></path></svg>' +
              (IS_TOUCH ? 'Tap to enlarge' : 'Click to enlarge') + '</button>';
          }
          roomChip();                                 // B5.52
        } else {
          ui.turn.textContent = 'Viewed ' + ANGLE_NAMES[st.angle] + ' · drag to turn';
        }
      }
    }

    /* ---------------------------- step gating ---------------------------- */

    /* The first step that has not been completed. Everything up to and
       including it is open; everything after it is not. Steps already done stay
       clickable -- locking someone out of a choice they have already made is
       the thing that makes a configurator feel like a form. */
    function areaOk() { return !!(st.areaDone || st.userPicked); }
    function firstOpen() {
      for (var i = 0; i < SEGMENTS.length; i++) if (!st.done[i]) return i;
      return SEGMENTS.length - 1;
    }
    function canOpen(i) { return areaOk() && i <= firstOpen(); }

    /* Step five has no choices left once the model exists: its Total is on the
       Add to cart button and its one action has moved under it. So when the
       render lands it collapses to a tick like every step before it, and the
       ring closes on four completed quarters rather than three and an open
       one. Nothing is open after that, which is the correct state -- the next
       thing to do is buy it. */
    function segFinished(i) {
      return i === SEGMENTS.length - 1 && st.stage === 'cfg' && st.rendered && !st.building;
    }

    /* Only Next moves you on. Clicking an option used to advance immediately,
       which meant you could never click between two sizes and watch the yellow
       circle change -- the one thing the choice is actually for. */
    /* Warmed once per crop, and never twice for the same one. */
    var warmedKey = '';
    function warmNow(why) {
      if (!st.size || !areaOk()) return;
      try { loadThree(); } catch (eL) {}     /* B7.1.0: see makeCropMap */
      try {
        var sp = spec();
        var k = sp.bbox.minLat.toFixed(4) + ',' + sp.bbox.minLon.toFixed(4) + '|' +
                Math.round(sp.groundMeters);
        if (k === warmedKey) return;
        warmedKey = k;
        diag('prefetch started (' + why + ')');
        warmGeometry(sp, cfg);
      } catch (e) { /* opportunistic only, never blocks a step */ }
    }

    function advance(i) {
      st.done[i] = true;
      /* B5.67: reaching Generate ends the first pass; the nudge retires. */
      if (i >= SEGMENTS.length - 2) st.nudgeDone = true;
      st.seg = Math.min(i + 1, SEGMENTS.length - 1);
      /* The map data used to start downloading at the email gate. By then the
         area has been fixed for two steps and the customer has spent fifteen to
         thirty seconds picking a frame and a colour doing nothing -- so most of
         the wait can happen behind choices they are making anyway.

         Not before the size is chosen: size sets how much ground the crop
         covers, so an earlier query would be for the wrong bbox and thrown
         away. overpassCached dedupes, so the real build reuses this rather than
         repeating it. */
      if (i === 0) warmNow('size chosen');
    }

    /* ------------------------------- layout ------------------------------ */

    /* Every load-bearing size is set here, in JS. See the note above buildDom:
       a structural property left to a class can silently lose to the theme's
       own stylesheet, and that is how the map once covered the whole page. */
    function wideBoard() { return window.innerWidth >= 1000; }

    /* A phone's innerHeight changes by up to ~90px as the browser's URL bar
       collapses and expands with the scroll, and the circle was sized off it --
       so pulling the page down to refresh visibly shrank the map. The height is
       captured once and only refreshed when the width changes, which is a
       rotation or a real resize rather than a bar sliding away. */
    var VW0 = window.innerWidth || 360, VH0 = window.innerHeight || 800;
    function stableVh() {
      if (window.innerWidth !== VW0) {
        VW0 = window.innerWidth;
        VH0 = window.innerHeight || VH0;
      }
      return wideBoard() ? (window.innerHeight || VH0) : VH0;
    }

    /* B6.0: where everything lives. Wide: map column + steps panel inside
       the board. Phone: banner and hints above the board, the steps in the
       sheet. Only re-parented when the mode actually changes, and the board
       itself and the map column are never moved -- the map is inside them. */
    var CARD_HOME = null;
    function placeCards(wide) {
      if (CARD_HOME === (wide ? 'board' : 'sheet')) return;
      CARD_HOME = wide ? 'board' : 'sheet';
      var w = ui.pdp, s6 = ui.stage6, b = ui.board;
      if (wide) {
        b.insertBefore(ui.panel, ui.sheet);
        /* B6.0.1: the hint chips and the enlarge pill sit ON the map. */
        ui.arena.appendChild(ui.mapHint);
        ui.arena.appendChild(ui.turn);
        ui.leftCol.appendChild(ui.belowHost);
        ui.leftCol.appendChild(ui.roomsRow);
        ui.panel.appendChild(ui.pageLead);        /* B6.0.2: scrolls with the panel */
        ui.panel.appendChild(ui.banner);
        ui.cards.forEach(function (c) { ui.panel.appendChild(c.el); });
        ui.panel.appendChild(ui.addBtn);
        ui.panel.appendChild(ui.actRow);
        s6.insertBefore(ui.pageHead, b);
        w.appendChild(ui.err);
        w.appendChild(ui.restHost);
        w.appendChild(ui.credit);
      } else {
        /* B6.1: a phone gets the desktop layout in one column -- the place,
           the map, then every step open in one panel under it. Add to cart
           lives in the bar at the bottom of the screen. */
        b.insertBefore(ui.panel, ui.sheet);
        ui.arena.appendChild(ui.mapHint);
        ui.arena.appendChild(ui.turn);
        ui.leftCol.appendChild(ui.belowHost);
        ui.leftCol.appendChild(ui.roomsRow);
        ui.pageHead.appendChild(ui.pageLead);
        ui.cards.forEach(function (c) { ui.panel.appendChild(c.el); });
        /* B6.2: Add to cart (and Cancel while building) directly under
           the model, ahead of the room shots. */
        ui.leftCol.insertBefore(ui.cancelBtn, ui.roomsRow);
        ui.leftCol.insertBefore(ui.addBtn, ui.roomsRow);
        s6.insertBefore(ui.pageHead, b);
        s6.insertBefore(ui.banner, b);
        w.appendChild(ui.err);
        /* B6.3 (Kevin): Adjust the area and Start again at the bottom,
           under step 5, well away from Add to cart. */
        ui.panel.appendChild(ui.actRow);
        w.appendChild(ui.restHost);
        w.appendChild(ui.credit);
        /* On the page body, so nothing the theme wraps around the section
           (a transform, an animation) can stop it being fixed to the screen. */
        document.body.appendChild(ui.pbar);
      }
    }

    /* B6.0.1: on a wide screen the theme's announcement bar is pinned under
       its sticky header for as long as this page is open, so the heading and
       the map under it have something fixed to sit against. Put back as it
       was on a narrow screen. Only touches a section whose id says
       "announce", inside the theme's header group. */
    var PIN_BAR = null;
    function pinHeader(on) {
      var drift = 0;
      try {
        var hg = document.getElementById('header-group');
        if (!hg) return;
        var hdr = null, bar = null, kids = hg.children;
        for (var k = 0; k < kids.length; k++) {
          var pos = getComputedStyle(kids[k]).position;
          if (!hdr && (pos === 'sticky' || pos === 'fixed')) hdr = kids[k];
          if (!bar && /announce/i.test(kids[k].id || '')) bar = kids[k];
        }
        if (on && hdr && bar) {
          var ht = parseFloat(getComputedStyle(hdr).top) || 0;
          var z = parseInt(getComputedStyle(hdr).zIndex, 10);
          bar.style.position = 'sticky';
          bar.style.top = Math.round(hdr.offsetHeight + ht) + 'px';
          bar.style.zIndex = String(isFinite(z) && z > 1 ? z - 1 : 5);
          PIN_BAR = bar;
          /* The theme pins its header at top:-1px, so the header itself moves
             one pixel; everything pinned below moves the same pixel, or a
             hairline of the panel shows between them. */
          drift = Math.round(ht);
        } else if (!on && PIN_BAR) {
          PIN_BAR.style.position = ''; PIN_BAR.style.top = ''; PIN_BAR.style.zIndex = '';
          PIN_BAR = null;
        }
      } catch (e) { /* the theme's own layout stands */ }
      return drift;
    }

    /* B6.0.1: the room shots, open under the model on a wide screen. A tap
       opens the existing full-size room view. */
    function paintRooms() {
      var row = ui && ui.roomsRow, r = cfg.__mmRooms;
      if (!row) return;
      var show = st.stage === 'cfg' && st.rendered && !st.building &&
                 !!(r && r.table && r.wall);
      if (!show) {
        row.setAttribute('style', 'display:none');
        if (row.__mmKey) { row.innerHTML = ''; row.__mmKey = ''; }
        return;
      }
      row.setAttribute('style', 'display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:12px;' +
        'width:100%;box-sizing:border-box');
      var key = r.table.slice(-48) + '|' + r.wall.slice(-48);
      if (row.__mmKey === key) return;
      row.__mmKey = key;
      row.innerHTML = '';
      [['table', 'In a room'], ['wall', 'On a wall']].forEach(function (p) {
        var b = el('button', 'mm-roomtile');
        b.type = 'button';
        b.setAttribute('aria-label', 'Your model ' + p[1].toLowerCase() + ', full size');
        b.setAttribute('style', 'position:relative;display:block;width:100%;aspect-ratio:5 / 4;padding:0;' +
          'margin:0;border:0;border-radius:12px;overflow:hidden;cursor:zoom-in;background:#E9EBEE');
        var im = new Image();
        im.src = r[p[0]];
        im.alt = '';
        im.setAttribute('style', 'display:block;width:100%;height:100%;object-fit:cover');
        b.appendChild(im);
        var cap = el('span', '', esc(p[1]));
        cap.setAttribute('style', 'position:absolute;right:10px;bottom:10px;background:rgba(255,255,255,.94);' +
          'color:' + MM_INK + ';border-radius:8px;padding:7px 10px;font:600 13px/1 ' + MM_FACE);
        b.appendChild(cap);
        b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); MM_openRooms(r, p[0]); });
        row.appendChild(b);
      });
    }

    /* Where the circle and each card sit in the board grid. Held here rather
       than written straight onto the elements because paintCards() replaces the
       whole style attribute, and it runs on its own from sync(). */
    var ARENA_CELL = '';

    /* The theme paints its own background on a container with a width cap, so
       the section stopped short of the edges of the screen with a band of a
       different colour either side. Everything from this section's own wrapper
       inwards is repainted, which keeps the change inside this section rather
       than recolouring whatever else shares the page. */
    function paintSection() {
      try {
        var stop = root.closest ? root.closest('.shopify-section') : null;
        var n = root;
        for (var guard = 0; n && guard < 12; guard++) {
          n.style.background = MM_BG;
          if (n === stop || n === document.body) break;
          n = n.parentNode;
          if (!n || n.nodeType !== 1) break;
        }
      } catch (e) { /* a theme that will not budge is not worth throwing over */ }
    }

    /* B6.0 / B6.0.1. Wide: the map is a square as big as the column and the
       screen allow, and everything above it is pinned where it already is.
       Phone: a square the width of the page. */
    function layout() {
      var wide = wideBoard();
      placeCards(wide);
      var drift = pinHeader(wide) || 0;
      var avail = ui.board.getBoundingClientRect().width ||
                  ui.board.parentNode.getBoundingClientRect().width || 360;
      var vh = stableVh();
      var live = st.stage === 'cfg';
      var S, PW = 0, GAP = 32;
      ARENA_CELL = '';
      ui.cards.forEach(function (c) {
        c.cell = ''; c.cut = ''; c.geo = null;
        c.el.style.backgroundImage = '';
      });
      if (wide) {
        PW = Math.max(380, Math.min(460, Math.round(avail * 0.36)));
        ui.pdp.style.paddingTop = '0px';
        ui.stage6.setAttribute('style', 'width:100%;display:flex;flex-direction:column;align-items:center;gap:0');
        paintHead(true);
        var headCss = function (sidePad) {
          return 'position:-webkit-sticky;position:sticky;top:' + (stageTop + drift) + 'px;z-index:4;width:100%;' +
            'box-sizing:border-box;display:flex;flex-wrap:nowrap;align-items:flex-end;' +
            'justify-content:space-between;gap:10px 32px;padding:14px ' + sidePad + 'px 16px;' +
            'background:' + MM_BG + ';box-shadow:0 -80px 0 0 ' + MM_BG;
        };
        /* Kevin: from the first pixel of scroll, only the panel moves. So the
           heading and the map column are pinned at their own starting page
           positions -- stuck before anything moves -- with the theme's header
           and announcement bar pinned above them (pinHeader). They let go when
           the board ends, and the page then moves on as one. */
        var y0 = window.pageYOffset || document.documentElement.scrollTop || 0;
        var stageTop = Math.round(ui.stage6.getBoundingClientRect().top + y0);
        ui.pageHead.setAttribute('style', headCss(0));
        ui.board.style.marginTop = '';            /* measured without pinRelease's offset */
        var boardTop = Math.round(ui.board.getBoundingClientRect().top + y0);
        S = Math.max(340, Math.min(avail - PW - GAP, vh - boardTop - 16, 780));
        /* After a render the model gives up a little room to the room shots
           shown under it. */
        if (live) S = Math.max(320, S * 0.84);
        S = Math.round(S);
        ui.pageHead.setAttribute('style', headCss(Math.max(0, Math.round((avail - (S + PW + GAP)) / 2))));
        ui.board.setAttribute('style', 'display:grid;width:100%;box-sizing:border-box;align-items:start;' +
          'justify-content:center;column-gap:' + GAP + 'px;grid-template-columns:' + S + 'px ' + PW + 'px');
        ui.leftCol.setAttribute('style', 'grid-column:1;grid-row:1;position:-webkit-sticky;position:sticky;' +
          'top:' + (boardTop + drift) + 'px;display:flex;flex-direction:column;align-items:center;gap:12px;' +
          'min-width:0;z-index:1');
        ui.panel.setAttribute('style', 'grid-column:2;grid-row:1;min-width:0;box-sizing:border-box;' +
          'background:' + MM_SURFACE + ';border:1px solid ' + MM_LINE + ';border-radius:12px;' +
          'padding:4px 24px 24px;display:flex;flex-direction:column');
        ui.sheet.setAttribute('style', 'display:none');
        /* B7.5.4 (Kevin, 3 Nov, desktop screenshot): the pinned heading (z 4) covers the panel as it
           scrolls, but the search box sat at the theme header's z minus 2 (6) and slid over the
           heading, out of its card. 3 is under the heading and still over the map disc (1) and ring (2). */
        if (ui.searchBox) ui.searchBox.style.zIndex = '3';
      } else {
        /* B6.1: the map stays the full width of the screen (Kevin: it has
           to be as big as the competition's), then one panel with every
           step in it. */
        S = Math.round(Math.min(avail, 560));
        ui.pdp.style.paddingTop = '12px';
        ui.stage6.setAttribute('style', 'width:100%;display:flex;flex-direction:column;align-items:center;gap:12px');
        paintHead(false);
        ui.pageHead.setAttribute('style', 'display:none');
        if (ui.searchBox) ui.searchBox.style.zIndex = 'var(--mm-z-search,20)';   /* B7.5.4: phones as before */
        ui.board.setAttribute('style', 'display:grid;width:100%;gap:14px;grid-template-columns:minmax(0,1fr);' +
          'justify-items:stretch;box-sizing:border-box');
        ui.leftCol.setAttribute('style', 'grid-row:1;grid-column:1;display:flex;flex-direction:column;' +
          'align-items:center;gap:12px;min-width:0');
        /* B6.3: no box round the steps; each step is its own card, with
           its number on the card's left edge. */
        ui.panel.setAttribute('style', 'grid-row:2;grid-column:1;min-width:0;box-sizing:border-box;' +
          'position:relative;isolation:isolate;background:transparent;border:0;border-radius:0;' +
          'padding:0 0 0 18px;display:flex;flex-direction:column;gap:14px');
        ui.sheet.setAttribute('style', 'display:none');
      }
      /* B6.1: on the map itself on every screen. */
      ui.mapHint.setAttribute('style',
        'position:absolute;left:12px;bottom:12px;right:12px;z-index:3;margin:0;display:' + ((live || st.hintGone) ? 'none' : 'flex') +
        ';flex-wrap:wrap;gap:6px;pointer-events:none;font-size:14px;color:' + MM_INK +
        (wide ? '' : ';justify-content:flex-end'));
      ui.turn.setAttribute('style',
        'position:absolute;left:0;right:0;bottom:12px;z-index:3;pointer-events:none;' +
        'margin:0;text-align:center;font-size:13.5px;color:' + MM_LABEL +
        ';display:' + (live ? '' : 'none'));
      ui.chips.setAttribute('style', 'display:none');
      sizeArena(S);
      paintCards();
      paintRooms();
      pinRelease();
      aimRing();
      paintProg();
      paintBar();
      if (map && map.refresh) map.refresh();
    }

    /* ------------- B6.1, phones: where you are, and the way on -------------

       Kevin, 25 Oct: the steps are good, but one at a time on a phone he
       kept losing his place, and the page threw him about. So on a phone
       every step is open on one page, the step you are looking at is named
       in a bar under the header, and the next thing to do is a button fixed
       to the bottom of the screen. The page only ever moves when a button is
       tapped. */
    var PROG_CUR = 0, PH_RAF = 0, SEARCH_FOCUS = false, BAR_KEY = '', PROG_KEY = '';
    var CHAT_AT = 0;
    function secEls() {
      return [ui.banner].concat(ui.cards.map(function (c) { return c.el; }));
    }
    function secName(k) { return (ui.progBtns[k] && ui.progBtns[k].__mmName) || ''; }
    /* The theme pins its header on a phone too; the step bar sits under it.
       Measured every time, in case the theme slides its header away. */
    function hdrBottom() {
      try {
        var hg = document.getElementById('header-group');
        if (!hg) return 0;
        for (var k = 0; k < hg.children.length; k++) {
          var n = hg.children[k], cs = getComputedStyle(n);
          if (cs.position === 'sticky' || cs.position === 'fixed') {
            if (n.getBoundingClientRect().bottom <= 0) return 0;
            return Math.max(0, Math.round(n.offsetHeight + (parseFloat(cs.top) || 0)));
          }
        }
      } catch (e) {}
      return 0;
    }
    function progBottom() {
      try {
        if (ui.prog.style.display !== 'none') {
          var r = ui.prog.getBoundingClientRect();
          if (r.height) return Math.max(0, r.bottom);
        }
      } catch (e) {}
      return hdrBottom();
    }
    function barH() {
      return (ui.pbar && ui.pbar.style.display !== 'none') ? (ui.pbar.offsetHeight || 0) : 0;
    }
    /* The step you are looking at: the last one whose top has passed a line
       a third of the way down the free space. The last step counts once its
       end is on screen, because the page can end before it reaches the line. */
    function curSection() {
      var lk = lockedSection();
      if (lk >= 0) return lk;
      var els = secEls(), top = progBottom(), vh = window.innerHeight || 0;
      var line = top + Math.max(60, (vh - top - barH()) * 0.35);
      var cur = 0;
      for (var k = 0; k < els.length; k++) {
        var r = els[k].getBoundingClientRect();
        if (r.height && r.top <= line) cur = k;
      }
      var lr = els[els.length - 1].getBoundingClientRect();
      if (lr.height && lr.bottom <= vh - barH() + 2 && lr.top < vh) cur = els.length - 1;
      return cur;
    }
    /* After Next (or a tap on the step bar) the step it went to is the
       current one, even where the page cannot bring it all the way up,
       until the reader scrolls somewhere else themselves. */
    var PROG_LOCK = null;
    var PROG_ON = false;      /* B6.3: the step bar under the header, off */
    function glideBy(dy, k) {
      var y0 = window.pageYOffset || document.documentElement.scrollTop || 0;
      var maxY = Math.max(0, (document.documentElement.scrollHeight || 0) - (window.innerHeight || 0));
      var to = Math.max(0, Math.min(maxY, y0 + dy));
      if (typeof k === 'number') PROG_LOCK = { k: k, from: y0, to: to, arrived: Math.abs(to - y0) < 3 };
      if (Math.abs(to - y0) < 3) { paintProg(); paintBar(); return; }
      try { window.scrollTo({ top: to, behavior: 'smooth' }); }
      catch (e) { window.scrollTo(0, to); }
    }
    function lockedSection() {
      var L = PROG_LOCK;
      if (!L) return -1;
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      if (!L.arrived) {
        if (Math.abs(y - L.to) < 3) L.arrived = true;
        else if (y < Math.min(L.from, L.to) - 30 || y > Math.max(L.from, L.to) + 30) { PROG_LOCK = null; return -1; }
      } else if (Math.abs(y - L.to) > 40) { PROG_LOCK = null; return -1; }
      return L.k;
    }
    /* Only as far as needed: nothing moves if the thing is already on
       screen between the two bars. */
    function phoneReveal(node) {
      if (wideBoard() || !node) return;
      try {
        var top = progBottom() + 8, bottom = (window.innerHeight || 0) - barH() - 8;
        var r = node.getBoundingClientRect(), dy = 0;
        if (!r.height) return;
        if (r.height > bottom - top || r.top < top) dy = r.top - top;
        else if (r.bottom > bottom) dy = r.bottom - bottom;
        if (Math.abs(dy) >= 4) glideBy(dy);
      } catch (e) {}
    }
    /* B6.2: two nodes kept on screen together, moving as little as needed;
       if they cannot both fit, the lower one (the button) wins. */
    function phoneRevealSpan(a, b) {
      if (wideBoard() || !a || !b) return;
      try {
        var nx = b.nextElementSibling;
        var lowNode = (nx && /mm-promise-line/.test(nx.className || '') && nx.offsetHeight) ? nx : b;
        var top = progBottom() + 8, bottom = (window.innerHeight || 0) - 8;
        var t = a.getBoundingClientRect().top, bt = lowNode.getBoundingClientRect().bottom, dy = 0;
        if (bt - t > bottom - top) dy = bt - bottom;
        else if (t < top) dy = t - top;
        else if (bt > bottom) dy = bt - bottom;
        if (Math.abs(dy) >= 4) glideBy(dy);
      } catch (e) {}
    }

    /* A step, brought up under the step bar. Size is the exception: it sits
       under the map and changes the circle, so its tiles are brought into
       view with as much of the map left above them as fits. */
    function revealSection(k) {
      if (wideBoard()) return;
      var node = secEls()[k];
      if (!node) return;
      try {
        var top = progBottom() + 8, bottom = (window.innerHeight || 0) - barH() - 8;
        var r = node.getBoundingClientRect(), dy;
        if (k === 1) {
          var g = node.querySelector('.mm-optgrid');
          var rb = g ? g.getBoundingClientRect().bottom + 8 : r.bottom;
          if (rb > bottom) dy = Math.min(rb - bottom, r.top - top);
          else if (r.top < top) dy = r.top - top;
          else dy = 0;
        } else {
          dy = r.top - top;
        }
        glideBy(Math.abs(dy) >= 4 ? dy : 0, k);
      } catch (e) {}
    }
    /* The shop's chat button sits bottom left, where the bar now is. While
       the bar is up the button is lifted to sit just above it, and put back
       when the bar goes. It lives in the chat's own (open) shadow roots; if
       it cannot be found, nothing is touched. */
    var CHAT_EL = null;
    function chatBubble() {
      if (CHAT_EL && CHAT_EL.isConnected) return CHAT_EL;
      var now = Date.now();
      if (now - CHAT_AT < 1500) return null;
      CHAT_AT = now; CHAT_EL = null;
      try {
        var c = document.querySelector('shopify-chat');
        if (!c || !c.shadowRoot) return null;
        var walk = function (root, depth) {
          if (!root || depth > 6 || CHAT_EL) return;
          var hit = root.querySelector('.activator-nudge');
          if (hit) { CHAT_EL = hit; return; }
          var all = root.querySelectorAll('*');
          for (var j = 0; j < all.length && !CHAT_EL; j++) if (all[j].shadowRoot) walk(all[j].shadowRoot, depth + 1);
        };
        walk(c.shadowRoot, 0);
      } catch (e) {}
      return CHAT_EL;
    }
    function liftChat(px) {
      var b = chatBubble();
      if (!b) return;
      try {
        if (px > 0) {
          if (b.__mmBottom === undefined) b.__mmBottom = b.style.bottom || '';
          if (b.style.bottom !== px + 'px') b.style.bottom = px + 'px';
        } else if (b.__mmBottom !== undefined) {
          b.style.bottom = b.__mmBottom;
          b.__mmBottom = undefined;
        }
      } catch (e) {}
    }
    function paintProg() {
      if (!ui.prog) return;
      /* B6.3: retired on phones as well; the numbers on the cards do it. */
      if (wideBoard() || !PROG_ON) {
        if (ui.prog.style.display !== 'none') ui.prog.setAttribute('style', 'display:none');
        PROG_KEY = '';
        return;
      }
      var cur = curSection();
      /* B6.2: once the model is made, the top of the page is the preview. */
      if (cur === 0 && st.stage === 'cfg' && st.rendered && !st.building) cur = ui.progBtns.length - 1;
      PROG_CUR = cur;
      var live = st.stage === 'cfg', rendered = live && st.rendered && !st.building;
      var padL = 16;
      try { padL = parseFloat(getComputedStyle(ui.pdp).paddingLeft) || 16; } catch (e) {}
      var padT = parseFloat(ui.pdp.style.paddingTop) || 0;
      var key = cur + '|' + (rendered ? 1 : 0) + '|' + hdrBottom() + '|' + padL + '|' + padT;
      if (key === PROG_KEY) return;
      PROG_KEY = key;
      ui.prog.setAttribute('style', 'position:-webkit-sticky;position:sticky;top:' + hdrBottom() + 'px;' +
        'z-index:15;display:grid;grid-template-columns:repeat(' + ui.progBtns.length + ',minmax(0,1fr));' +
        'align-self:stretch;width:auto;box-sizing:border-box;margin:-' + padT + 'px -' + padL + 'px 0;' +
        'padding:0 ' + Math.max(6, padL - 8) + 'px;background:' + MM_SURFACE + ';' +
        'border-bottom:1px solid ' + MM_LINE + ';box-shadow:0 4px 14px rgba(18,20,23,.05)');
      ui.progBtns.forEach(function (b, k) {
        var on = k === cur, done = !rendered && k < cur;
        /* A narrow tick, so "Colour" still fits beside it on a 360px phone. */
        b.innerHTML = (done && !on
          ? '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.4" ' +
            'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="display:inline-block;' +
            'vertical-align:0;margin-right:3px"><path d="M5 12.5l4.5 4.5L19 7.5"></path></svg>'
          : '') + esc(b.__mmName);
        b.setAttribute('aria-current', on ? 'step' : 'false');
        b.setAttribute('style', 'min-width:0;margin:0;border:0;border-radius:0;background:none;cursor:pointer;' +
          'box-sizing:border-box;min-height:46px;padding:13px 2px 10px;display:block;text-align:center;' +
          'font:' + (on ? '700' : '600') + ' 15px/1.1 ' + MM_FACE + ';color:' + (on || done ? MM_INK : MM_LABEL) +
          ';border-bottom:3px solid ' + (on ? MM_INK : 'transparent') + ';white-space:nowrap;overflow:hidden;' +
          'text-overflow:ellipsis;-webkit-tap-highlight-color:transparent');
      });
    }
    function paintBar() {
      if (!ui.pbar) return;
      if (wideBoard()) {
        if (ui.pbar.style.display !== 'none') ui.pbar.setAttribute('style', 'display:none');
        ui.pdp.style.paddingBottom = '';
        BAR_KEY = '';
        liftChat(0);
        return;
      }
      /* Room for the bar under the last thing on the page. */
      /* B6.2: no bar any more, so no room kept for it. */
      ui.pdp.style.paddingBottom = '';
      var live = st.stage === 'cfg', rendered = live && st.rendered && !st.building;
      var vh = window.innerHeight || 0, r = ui.pdp.getBoundingClientRect();
      /* Shown for as long as the configurator is the thing on screen; gone
         once you scroll on into the rest of the page, and while typing in
         the search box (it would sit on top of the suggestions). */
      var show = false;   /* B6.2: retired on phones (kept off, not deleted) */
      /* B6.1.1: never two "See my 3D preview" buttons on screen at once. */
      if (show && !rendered && !st.building && ui.buildBtn.isConnected &&
          ui.pdp.contains(ui.buildBtn)) {
        var rbb = ui.buildBtn.getBoundingClientRect();
        /* Only once all of it is on screen; a sliver at the bottom edge
           leaves the bar where it is. */
        if (rbb.height && rbb.top >= progBottom() && rbb.bottom <= vh) show = false;
      }
      var last = ui.progBtns.length - 1;
      var gen = !live && PROG_CUR >= last;
      var label = st.building ? ''
        : rendered ? ''
        : live ? 'Try again'
        : gen ? 'See my 3D preview'
        : 'Next: ' + secName(Math.min(last, PROG_CUR + 1));
      var tot = (st.size && !ETSY) ? money(totalCents(), cfg.moneyFormat) : '';
      var gap = 0;
      liftChat(0);
      var key = [show ? 1 : 0, label, tot, st.building ? 1 : 0, rendered ? 1 : 0, gap, st.size ? 1 : 0].join('|');
      if (key === BAR_KEY) return;
      BAR_KEY = key;
      ui.pbar.setAttribute('style', 'position:fixed;left:0;right:0;bottom:0;z-index:40;' +
        'display:' + (show ? 'flex' : 'none') + ';flex-wrap:wrap;align-items:center;gap:8px 12px;' +
        'box-sizing:border-box;' +
        'padding:10px 16px calc(10px + env(safe-area-inset-bottom)) ' + (16 + gap) + 'px;' +
        'background:' + MM_SURFACE + ';border-top:1px solid ' + MM_LINE + ';' +
        'box-shadow:0 -8px 24px rgba(18,20,23,.08);font-family:' + MM_FACE);
      ui.pbarTot.innerHTML = st.building
        ? '<span style="display:block;font:600 16px/1.3 ' + MM_FACE + ';color:' + MM_INK + '">' +
            'Building your model\u2026</span>'
        : (tot && !rendered)
          ? '<span style="display:block;font:500 15px/1.2 ' + MM_FACE + ';color:' + MM_LABEL + '">Total</span>' +
            '<span style="display:block;font:700 19px/1.25 ' + MM_FACE + ';color:' + MM_INK + '">' + esc(tot) + '</span>'
          : '';
      ui.pbarTot.setAttribute('style', 'flex:1 1 auto;min-width:0;display:' +
        ((st.building || (tot && !rendered)) ? 'block' : 'none'));
      ui.pbarCancel.setAttribute('style', 'flex:none;display:' + (st.building ? 'flex' : 'none') + ';' +
        'align-items:center;justify-content:center;min-height:54px;padding:0 22px;box-sizing:border-box;' +
        'border:1px solid ' + MM_TRACK + ';border-radius:10px;background:' + MM_SURFACE + ';color:' + MM_INK +
        ';font:600 16px/1 ' + MM_FACE + ';cursor:pointer;margin:0');
      var blue = gen || label === 'Try again';
      var canGo = !(gen && !st.size);
      ui.pbarBtn.innerHTML = esc(label) + ((label && !blue)
        ? ' <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" ' +
          'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="flex:none">' +
          '<path d="M12 5v14M6 13l6 6 6-6"></path></svg>'
        : '');
      ui.pbarBtn.setAttribute('style', 'flex:none;display:' + (label ? 'flex' : 'none') + ';' +
        'align-items:center;justify-content:center;gap:8px;min-height:54px;padding:0 20px;' +
        'box-sizing:border-box;border:0;border-radius:10px;margin:0;white-space:nowrap;cursor:pointer;' +
        'background:' + (blue ? MM_ACCENT : MM_FOCUS) + ';color:#fff;font:700 17px/1 ' + MM_FACE +
        (canGo ? '' : ';opacity:.45;cursor:default'));
    }
    function onPhoneScroll() {
      if (PH_RAF || wideBoard()) return;
      PH_RAF = requestAnimationFrame(function () {
        PH_RAF = 0; paintProg(); paintBar();
        if (markPassed()) paintStepMarks();     /* B6.3 */
      });
    }

    /* B6.0.1: the heading lets go of the top at the same moment as the map.
       A sticky box stops when its margin box reaches the end of its
       containing block (the stage), so the heading carries a bottom margin
       as tall as the map column, and the board is pulled back up by the same
       amount -- nothing moves on the page, but the heading now runs out of
       room exactly when the map does. Kept in step as the map column grows
       (room shots arriving, the build strip). */
    var pinRO = null;
    function pinRelease() {
      if (!wideBoard()) {
        ui.pageHead.style.marginBottom = '';
        ui.board.style.marginTop = '';
        return;
      }
      var hl = ui.leftCol.offsetHeight || 0;
      ui.pageHead.style.marginBottom = hl + 'px';
      ui.board.style.marginTop = (-hl) + 'px';
      if (!pinRO && typeof ResizeObserver === 'function') {
        pinRO = new ResizeObserver(function () {
          if (wideBoard() && (ui.leftCol.offsetHeight || 0) + 'px' !== ui.pageHead.style.marginBottom) pinRelease();
        });
        pinRO.observe(ui.leftCol);
      }
    }

    function paintHead(wide) {
      ui.pageEyebrow.setAttribute('style', 'margin:0;display:' + (wide ? 'block' : 'none') +
        ';font:700 12px/1.2 ' + MM_FACE + ';letter-spacing:.14em;text-transform:uppercase;color:' + MM_LABEL);
      ui.pageTitle.setAttribute('style', 'margin:0;font:700 ' + (wide ? '34px' : '28px') + '/1.05 ' + MM_HEAD +
        ';letter-spacing:-.035em;color:' + MM_INK + ';text-transform:none;white-space:nowrap');
      ui.pageLead.setAttribute('style', 'margin:18px 0 0;display:none' + /* B7.5.0 */
        ';font:400 15px/1.45 ' + MM_FACE + ';color:' + MM_LABEL + ';text-wrap:balance');
    }

    function paintSizeTag() {
      if (!ui.sizeTag) return;
      var show = st.stage !== 'cfg' && !!st.size;
      ui.sizeTag.textContent = st.size ? '\u00D8 ' + st.size.cm + ' cm \u00B7 ' + fmtAcross(ground()) : '';
      ui.sizeTag.setAttribute('style', 'position:absolute;left:12px;top:12px;z-index:3;pointer-events:none;' +
        'display:' + (show ? 'block' : 'none') + ';background:' + MM_INK + ';color:#fff;border-radius:8px;' +
        'padding:8px 11px;font:600 ' + (wideBoard() ? '13.5' : '15') + 'px/1 ' + MM_FACE + ';white-space:nowrap');
    }

    function sizeArena(S) {
      var live = st.stage === 'cfg';
      ui.arena.setAttribute('style', 'position:relative;flex:none;width:' + S + 'px;height:' + S +
        'px;max-width:100%;margin:0 auto;box-sizing:border-box');
      ui.disc.setAttribute('style',
        'position:absolute;left:0;top:0;width:100%;height:100%;border-radius:12px;overflow:hidden;' +
        'background:#E9EBEE;z-index:1;' +
        /* touch-action:none, or a one-finger drag scrolls the page instead of
           panning the map and a two-finger pinch zooms the whole document. */
        'touch-action:none;-webkit-user-select:none;user-select:none;' +
        'cursor:' + (live ? 'grab' : 'default'));
      /* display stays in the same declaration as the rest of the lens's
         style (see B5.x): sync() and layout() both write it. */
      ui.lens.setAttribute('style',
        'position:absolute;left:0;top:0;width:100%;height:100%;display:' + (live ? 'none' : 'block'));
      ui.renderHost.setAttribute('style',
        'position:absolute;left:0;top:0;width:100%;height:100%;display:' + (live ? 'block' : 'none'));
      ui.ring.setAttribute('style', 'display:none');
      paintSizeTag();
    }

    /* ------------------------------ the ring ----------------------------- */

    /* Four quarter bands with square ends, sitting out wide of the map with a
       gap around it. As each step is completed its quarter slides inward, its
       angular gaps close, and it turns green. Four done and the gaps are zero,
       so the quarters seal into one unbroken green ring hugging the map -- the
       choices are locked in and the ring says so without a word.

       Position and colour both carry state, so neither has to carry it alone:
       pale and out = not reached, charcoal and out = the step you are on,
       green and closed = done. */
    function ringGeom(S) {
      var thick = Math.max(12, Math.round(S * 0.040));
      return {
        thick: thick,
        far: Math.max(10, Math.round(S * 0.042)),   /* gap to the map when open */
        near: Math.max(2, Math.round(S * 0.005))    /* gap to the map when shut */
      };
    }

    /* A quarter band: outer arc one way, inner arc back, closed. Square radial
       ends, which is what gives the sharp corners at the cut-off points -- a
       stroked arc with a round cap cannot do that. */
    /* All four quarters, including the last, close on st.done. 5.6 held the
       fourth back until the render landed; Kevin wants it to shut the moment
       Generate is pressed, and he is right -- the ring completing is the
       acknowledgement of the press, and the progress inside the circle is what
       reports the wait. */
    function ringDone(i) { return st.done[i]; }

    function bandPath(c, cx, cy, rIn, rOut, a0, a1) {
      c.beginPath();
      c.arc(cx, cy, rOut, a0, a1, false);
      c.arc(cx, cy, rIn, a1, a0, true);
      c.closePath();
    }

    /* Paints each panel's shape.

       Separate from layout() because a panel's true height is only known once
       the grid has settled -- an open step grows past its row. Separate from
       paintCards() because it also runs on every frame of the ring animation,
       so the panels close in step with the ring quarters rather than snapping.

       `measure` is false on animation frames: the rects are read once when
       something actually changed and reused after that, so a 60fps close does
       not force four reflows a frame. */
    function paintCardShapes(measure) {
      if (!wideBoard()) return;
      watchCardShapes();
      for (var i = 0; i < ui.cards.length; i++) {
        var c = ui.cards[i], g = c.geo;
        if (!g) continue;
        if (measure || !g.w) {
          var r = c.el.getBoundingClientRect();
          if (!(r.width > 4 && r.height > 4)) continue;
          g.w = r.width; g.h = r.height;
        }
        var t = RING.t[i];
        var gap = g.gapOpen + (g.gapShut - g.gapOpen) * t;
        var open = areaOk() && i === st.seg && !segFinished(i);
        var stroke = ringDone(i) ? MM_ACCENT : open ? MM_FOCUS : MM_TRACK;
        var sw = open ? 2 : 1;
        c.el.style.backgroundImage =
          cardShapeSvg(g.w, g.h, g.mx, g.my, g.S / 2 + gap, stroke, sw);
        c.el.style.backgroundRepeat = 'no-repeat';
        c.el.style.backgroundPosition = '0 0';
      }
    }

    /* The card outline is a background SVG generated at whatever size the card
       was when it was last measured, and nothing stretches it afterwards. So
       any height change that arrives after the measure leaves the outline at
       the old size and the content hanging past the drawn border -- which is
       how the Back arrow ended up outside the bottom of the Generate card. The
       repaint after fillCard() is not enough, because the things that add the
       height land later: a web font, a tile image, and the free-shipping
       snippet, which appends its brass tag on the following frame. Watching the
       boxes catches all of them. Repainting only sets a background image, which
       cannot change layout, so this cannot feed back on itself. */
    var shapeRO = null, shapeQueued = false;
    function watchCardShapes() {
      if (shapeRO || typeof ResizeObserver !== 'function' || !ui.cards) return;
      shapeRO = new ResizeObserver(function () {
        if (shapeQueued) return;
        shapeQueued = true;
        requestAnimationFrame(function () {
          shapeQueued = false;
          paintCardShapes(true);
        });
      });
      for (var i = 0; i < ui.cards.length; i++) {
        if (ui.cards[i] && ui.cards[i].el) shapeRO.observe(ui.cards[i].el);
      }
    }

    function drawRing() {
      if (B6_SQUARE) return;
      var S = ui.arena.offsetWidth || 320;
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      ui.ring.width = Math.round(S * dpr);
      ui.ring.height = Math.round(S * dpr);
      var c = ui.ring.getContext('2d');
      c.setTransform(dpr, 0, 0, dpr, 0, 0);
      c.clearRect(0, 0, S, S);

      var g = ringGeom(S);
      var cx = S / 2, cy = S / 2;
      RING.cx = cx; RING.cy = cy; RING.thick = g.thick;
      /* The disc is inset by far + thick, so the open band just fits inside the
         canvas and the closed band lands against the map. */
      var discR = S / 2 - g.far - g.thick;
      if (!(discR > 0)) return;

      for (var i = 0; i < SEG_ARC.length; i++) {
        var t = RING.t[i];                       /* 0 = open and out, 1 = shut  */
        var rIn = discR + g.far + (g.near - g.far) * t;
        var rOut = rIn + g.thick;
        var a0 = SEG_ARC[i][0], a1 = SEG_ARC[i][1];
        /* A non-finite angle paints nothing and throws nothing, which is how
           the NaN in 5.5 hid. Say so rather than drawing an empty canvas. */
        if (!isFinite(a0) || !isFinite(a1) || !isFinite(rIn)) {
          if (window.console && !drawRing.warned) {
            drawRing.warned = 1;
            console.warn('[mm] ring geometry is not finite - a constant read before it was assigned');
          }
          continue;
        }
        /* Clip to this quadrant, held back from both axes by the gap. The cut
           lines are the clip rectangle's own edges, so they are exactly
           horizontal and vertical with square corners. At t = 1 the gap goes
           slightly negative so neighbouring quarters overlap by half a pixel
           and the finished ring has no hairline seams in it. */
        var gp = Math.max(5, S * RING_GAP_BASE) * (1 - t) - 0.5 * t;
        var left = (i === 0 || i === 2), top = (i === 0 || i === 1);
        c.save();
        c.beginPath();
        c.rect(left ? -1 : cx + gp, top ? -1 : cy + gp,
               (left ? cx + gp : S - cx - gp) + 1, (top ? cy + gp : S - cy - gp) + 1);
        c.clip();
        bandPath(c, cx, cy, rIn, rOut, a0, a1);
        c.fillStyle = ringDone(i)
          ? MM_ACCENT
          : (i === st.seg && areaOk()) ? MM_FOCUS : MM_RING_IDLE;
        c.fill();
        c.restore();
      }
      /* The panels close as the ring closes -- one movement, not two. */
      paintCardShapes(false);
    }

    /* Eases each quarter towards where its state says it should be, and stops
       the moment they all arrive. Nothing animates on its own -- this only runs
       when a step is completed or undone, which is the "locking in" and the
       only movement on the page. */
    function aimRing() {
      var moved = false;
      for (var i = 0; i < 4; i++) {
        var want = ringDone(i) ? 1 : 0;
        if (Math.abs(RING.t[i] - want) > 0.001) moved = true;
      }
      if (!moved) { drawRing(); return; }
      if (RING_STILL) {
        for (var j = 0; j < 4; j++) RING.t[j] = ringDone(j) ? 1 : 0;
        drawRing();
        return;
      }
      if (RING.raf) return;
      RING.raf = requestAnimationFrame(function step() {
        var busy = false;
        for (var k = 0; k < 4; k++) {
          var target = ringDone(k) ? 1 : 0;
          var gap = target - RING.t[k];
          if (Math.abs(gap) < 0.004) { RING.t[k] = target; }
          else { RING.t[k] += gap * 0.16; busy = true; }
        }
        drawRing();
        RING.raf = busy ? requestAnimationFrame(step) : 0;
      });
    }

    /* ------------------------------ routing ------------------------------ */

    function toModel() {
      st.stage = 'cfg';
      st.done[GEN()] = true;
      st.seg = GEN(); st.angle = 0; st.wideOpen = -1; st.sumEdit = false;   /* B7.5.0 */
      sync(); layout(); showAngle();
      if (location.hash !== '#mm-model') { HASH_SET_AT = Date.now(); location.hash = 'mm-model'; }
    }
    function toPlace(fromHistory) {
      if (ui.turn) ui.turn.innerHTML = '';          // B5.47: no enlarge pill without a model
      st.stage = 'place';
      st.building = false;
      st.rendered = false;
      st.done[GEN()] = false;
      st.seg = 0;
      sync(); layout();
      if (map && map.refresh) map.refresh();
      if (!fromHistory && location.hash === '#mm-model') history.back();
    }

    /* -------------------------------- sync -------------------------------- */

    function sync() {
      var locked = !st.size, g = ground(), live = st.stage === 'cfg';
      if (LABEL.on) labelAuto();     /* B7.0: a place-name label follows the place */
      saveState();

      ui.where.textContent = st.placeName || fmtCoord(st.center.lat, st.center.lon);
      ui.price.textContent = st.size ? money(totalCents(), cfg.moneyFormat) : '';
      ui.buyAmt.textContent = st.size ? money(totalCents(), cfg.moneyFormat) : '';

      /* Step 1 stays open for as long as the map is what is in the circle: the
         area is adjustable at any point before you generate. */
      /* B6.1: never folded on a phone now -- the search stays above the map
         until there is a model, as on a wide screen. */
      var folded = false;
      ui.searchBox.style.display = (live || folded) ? 'none' : '';
      /* Was narrow-screens-only, so a desktop customer had no Change control
         at ANY stage -- the search bar was the only way to move, and that is
         hidden the moment Generate is pressed. Kevin reported being unable to
         get out of the area step twice before I stopped explaining it away.
         Now: every width, every stage a location exists, one place. */
      ui.areaEdit.textContent = 'Change location';
      ui.areaEdit.setAttribute('style',
        /* B6.1: on a phone the search box is right there until a model
           exists, so the button only shows after that. */
        'display:' + ((areaOk() && (wideBoard() || live)) ? 'inline-block' : 'none') + ';' +
        'margin-left:auto;flex:none;background:' + MM_SURFACE + ';cursor:pointer;' +
        'border:1px solid ' + MM_TRACK + ';border-radius:8px;' +
        /* !wideBoard() inline, NOT the `small` var -- that is declared a dozen
           lines below this and `var` hoists the name without the value, so it
           reads as undefined here. Same mistake that has blanked this page. */
        'padding:' + (!wideBoard() ? '12px 14px' : '8px 15px') + ';' +
        'font:600 ' + (!wideBoard() ? '15' : '13.5') + 'px/1 ' + MM_FACE + ';' +
        'color:' + MM_INK);
      var areaSet = areaOk();
      if (!wideBoard()) {
        /* B6.3: the same round number as the steps under the map. */
        paintSnum(ui.bNum, phoneSteps()[0], '1');
      } else {
        if (ui.bNum.__mmPh) {
          ui.bNum.__mmPh = false;
          ui.bNum.setAttribute('style', stepBadge('1', 'now', true).getAttribute('style'));
        }
        ui.bNum.textContent = areaSet ? '✓' : '1';
        ui.bNum.style.background = areaSet ? MM_DONE_BG : MM_FOCUS;
        ui.bNum.style.borderColor = areaSet ? MM_TRACK : MM_FOCUS;
        ui.bNum.style.color = areaSet ? MM_INK : '#fff';
      }
      ui.bLab.textContent = 'Your place';
      var small = !wideBoard();
      ui.bLab.style.font = (small ? '700 19px/1.15 ' : '600 16.5px/1.15 ') + MM_FACE;
      /* On a phone the place name is in the search box itself until there
         is a model; after that the box goes and the name shows here. */
      ui.where.style.display = (small && !live) ? 'none' : '';
      ui.where.style.fontSize = small ? '15.5px' : '14.5px';
      /* B6.0: on a wide screen step 1 is the top section of the panel. */
      ui.banner.setAttribute('style', !small
        ? 'width:100%;box-sizing:border-box;background:transparent;border:0;border-radius:0;' +
          'padding:18px 0 20px'
        : 'width:100%;max-width:1800px;box-sizing:border-box;background:transparent;border:0;' +
          'border-radius:0;padding:4px 0 0');
      /* One row on a phone, whatever the place is called: two wrapped rows here
         cost 26px that the circle needs more. */
      ui.head.setAttribute('style',
        'display:flex;align-items:center;gap:' + (small ? '8px' : '10px') + ';' +
        (small ? 'flex-wrap:nowrap;min-width:0' : 'flex-wrap:wrap'));
      /* Arriving, you are given a map and a search box and no signal which one
         to use. The search box breathes once, on arrival only, and stops the
         moment a place is chosen. It is the fastest route in and the one people
         miss in favour of dragging the map around. */
      if (!areaSet && !live) {
        if (!ui.searchBox.classList.contains('mm-attn')) {
          ui.searchBox.classList.add('mm-attn');
          ui.searchBox.style.borderRadius = '9px';
        }
      } else {
        ui.searchBox.classList.remove('mm-attn');
      }

      ui.areaNext.setAttribute('style',
        /* B6.1: the bar at the bottom of the screen is the way on now. */
        'display:none;' +
        'margin-top:' + (small ? '9px' : '11px') + ';' +
        'width:100%;max-width:' + (small ? '100%' : '280px') + ';border:0;border-radius:8px;' +
        'background:' + MM_FOCUS + ';color:#fff;cursor:pointer;box-sizing:border-box;' +
        'padding:' + (small ? '11px 16px' : '13px 18px') + ';' +
        'font:600 14.5px/1.15 ' + MM_FACE + ';');

      /* Adjust the area lives here now, directly under Add to cart, so step five
         can tick and close. It is the only thing left that needs a rebuild --
         size, frame and colour all re-render on their own. */
      /* Was `live && st.rendered && !st.building`. That meant a build which
         FAILED left no search, no map, no Adjust and one Try again button --
         measured identical at 390px and 1440px. That is the trap Kevin hit as
         "you can't get out of it at all". The way back must not depend on the
         build having worked; it matters most when it did not. */
      var showAdjust = live && !st.building;
      /* B6.0 (Kevin, 23 Oct): Adjust the area and Start again are their own
         buttons, white, side by side -- not blue, and not a link. */
      var twoBtn = 'flex:1 1 0;min-width:0;align-items:center;justify-content:center;' +
        'box-sizing:border-box;background:' + MM_SURFACE + ';color:' + MM_INK + ';' +
        'border:1px solid ' + MM_TRACK + ';border-radius:8px;min-height:48px;padding:12px 14px;' +
        'font:600 15px/1.15 ' + MM_FACE + ';cursor:pointer;text-align:center;margin:0';
      ui.backBtn.textContent = 'Adjust the area';
      var showRestart = live && st.rendered && !st.building;
      if (!showRestart) st.askRestart = false;
      var asking = !!st.askRestart;
      ui.backBtn.setAttribute('style', 'display:' + (showAdjust && !asking ? 'flex' : 'none') + ';' + twoBtn);
      ui.restartBtn.textContent = 'Start again';
      ui.restartBtn.setAttribute('style', 'display:' + (showRestart && !asking ? 'flex' : 'none') + ';' + twoBtn);
      /* B6.3: the question, in place of the two buttons. Keep my model is
         the dark one, so the safe answer is the obvious one. */
      ui.askBox.setAttribute('style', asking
        ? 'display:flex;flex-wrap:wrap;gap:10px;flex:1 1 100%;min-width:0;box-sizing:border-box;' +
          'padding:14px;background:' + MM_SURFACE + ';border:1px solid ' + MM_TRACK + ';border-radius:10px'
        : 'display:none');
      ui.askTxt.setAttribute('style', 'flex:1 1 100%;margin:0 0 2px;font:600 ' + (small ? '16px' : '15px') +
        '/1.35 ' + MM_FACE + ';color:' + MM_INK);
      ui.askNo.setAttribute('style', 'display:flex;' + twoBtn + ';background:' + MM_INK + ';color:#fff;' +
        'border-color:' + MM_INK);
      ui.askYes.setAttribute('style', 'display:flex;' + twoBtn);
      ui.actRow.setAttribute('style', 'display:' + (showAdjust ? 'flex' : 'none') + ';gap:10px;' +
        'width:100%;box-sizing:border-box;margin-top:' + (small ? '0' : '10px') + ';' +
        (small ? 'max-width:460px;align-self:center' : ''));
      /* Add to cart. On a phone it sticks to the bottom of the screen while
         the sheet is on it, so the model and the button are never apart. */
      ui.addBtn.setAttribute('style',
        'width:100%;box-sizing:border-box;background:' + MM_ACCENT + ';color:#fff;border:0;' +
        'border-radius:' + (small ? '10px' : '8px') + ';padding:' + (small ? '0 18px' : '18px 22px') + ';' +
        'font:700 17px/1 ' + MM_FACE + ';cursor:pointer;' +
        'display:' + ((live && st.rendered) ? 'flex' : 'none') + ';align-items:center;' +
        'justify-content:center;gap:10px;' +
        /* B6.1: on a phone it is the bar at the bottom of the screen. */
        (small ? 'min-height:58px;margin:2px 0 0;font-size:18px' : 'margin-top:14px') +
        (st.adding ? ';opacity:.7;cursor:progress' : ''));
      ui.belowHost.style.display = live ? 'flex' : 'none';
      ui.restHost.style.display = live ? 'block' : 'none';
      ui.renderHost.style.display = live ? 'block' : 'none';
      ui.lens.style.display = live ? 'none' : 'block';

      /* The map instructions sit above the circle; the angle caption stays
         under it, next to the dots that drive it. */
      ui.mapHint.style.display = (live || st.hintGone) ? 'none' : 'flex';   /* B7.5.0 */
      /* Two plain instructions, and the zoom one names the gesture the device
         in front of you actually has. "pinch or scroll" made the reader work
         out which half applied to them. */
      var chip = function (txt) {
        return '<span style="display:inline-flex;align-items:center;gap:6px;' +
          'background:' + MM_SURFACE + ';border:1px solid ' + MM_TRACK + ';' +
          'border-radius:8px;padding:' + (small ? '8px 12px' : '7px 14px') + ';' +
          'font-size:' + (small ? '15' : '14.5') + 'px;font-weight:500">' + txt + '</span>';
      };
      /* Two chips, the same as each other, and nothing else. A chip next to a
         sentence in a different size and colour was three visual languages for
         one instruction. */
      /* B7.5.0: one chip, gone after the first drag or zoom. */
      ui.mapHint.innerHTML = areaSet
        ? chip('Drag to move \u00B7 ' + (IS_TOUCH ? 'pinch' : 'scroll') + ' to zoom')
        : chip('Search a place, or drag the map');
      if (!ui.lens.__mmHint) {
        ui.lens.__mmHint = true;
        var hintGo = function () { if (st.hintGone) return; st.hintGone = true; ui.mapHint.style.display = 'none'; };
        ui.lens.addEventListener('pointerdown', hintGo, { passive: true });
        ui.lens.addEventListener('wheel', hintGo, { passive: true });
        ui.lens.addEventListener('touchstart', hintGo, { passive: true });
      }
      ui.turn.style.display = live ? '' : 'none';

      paintSizeTag();
      paintCards();
      paintRooms();
      aimRing();
      paintProg();
      paintBar();

      ui.err.textContent = st.error || '';
      ui.err.style.display = st.error ? '' : 'none';

      map.update(g, locked);
    }

    /* ------------------------------ the cards ---------------------------- */

    /* An option is a full-width row, not a pill: a name, room for a picture of
       the thing, and the price difference on the right. Pills could not carry
       any of that and gave a two-word label the same weight as a decision worth
       sixty euro. The media box is always built, so the moment a frame or
       colourway image is set in the theme settings it appears with no code
       change; until then it shows the swatch or a true-to-scale circle, which
       are useful in their own right. */
    /* A round split disc drawn with ONE conic-gradient, not a grid of child
       spans. The grid version is what made every colour tile an empty box:
       `base` below sets align-items:center, the swatch branch overrode only
       `display`, and that centring survived -- so the child spans, which carry
       no content of their own, were laid out at zero height. A gradient has no
       children to collapse, which is why this cannot come back.

       Segments are generic in the number of colours, so a new colourway needs
       no code here: Meadow's four split into quarters, White & Blue into
       halves, White stays solid with a hairline so it reads against the tile
       rather than dissolving into it. */
    function swatchCss(colours, d) {
      /* Kept for the single-colour case and for the badge fallback. */
      var list = (colours || []).slice(0, 6);
      if (!list.length) return '';
      return 'display:block;width:' + d + 'px;height:' + d + 'px;border-radius:50%;' +
             'box-sizing:border-box;background:' + esc(list[0]) +
             ';border:1px solid rgba(0,0,0,.14)';
    }

    /* Wedges as SVG paths, not a conic-gradient.

       The gradient version fringed: a hard stop in conic-gradient is not
       antialiased the way a shape edge is, so the browser blends the two
       colours across a sub-pixel band and each boundary picks up a smear of
       its neighbour. At 30 px across that is most of what you see.

       Paths antialias properly. The catch with adjacent paths is the opposite
       one -- two antialiased edges meeting leave a hairline of background
       between them -- so each wedge is drawn a third of a degree long and the
       next one laps over it. No gap, no blend, and the overlap is well under
       one pixel at any tile size we draw. */
    function swatchSvg(colours, d) {
      var list = (colours || []).slice(0, 6);
      if (!list.length) return '';
      var r = d / 2, hair = 'rgba(0,0,0,.14)';
      if (list.length === 1) {
        return '<svg width="' + d + '" height="' + d + '" viewBox="0 0 ' + d + ' ' + d +
               '" style="display:block" aria-hidden="true">' +
               '<circle cx="' + r + '" cy="' + r + '" r="' + (r - 0.5) + '" fill="' + esc(list[0]) +
               '" stroke="' + hair + '" stroke-width="1"></circle></svg>';
      }
      var step = 360 / list.length, parts = [], i;
      for (i = 0; i < list.length; i++) {
        /* -90 puts the first boundary at twelve o'clock; the 0.34 lap closes
           the seam with the wedge that follows. */
        var a0 = (-90 + i * step) * Math.PI / 180;
        var a1 = (-90 + (i + 1) * step + 0.34) * Math.PI / 180;
        var x0 = (r + r * Math.cos(a0)).toFixed(3), y0 = (r + r * Math.sin(a0)).toFixed(3);
        var x1 = (r + r * Math.cos(a1)).toFixed(3), y1 = (r + r * Math.sin(a1)).toFixed(3);
        var big = (step + 0.34) > 180 ? 1 : 0;
        parts.push('<path d="M' + r + ' ' + r + ' L' + x0 + ' ' + y0 +
                   ' A' + r + ' ' + r + ' 0 ' + big + ' 1 ' + x1 + ' ' + y1 + ' Z" fill="' +
                   esc(list[i]) + '"></path>');
      }
      return '<svg width="' + d + '" height="' + d + '" viewBox="0 0 ' + d + ' ' + d +
             '" style="display:block" aria-hidden="true">' +
             '<g clip-path="url(#mmcw' + d + ')">' + parts.join('') + '</g>' +
             '<defs><clipPath id="mmcw' + d + '"><circle cx="' + r + '" cy="' + r +
             '" r="' + r + '"></circle></clipPath></defs>' +
             '<circle cx="' + r + '" cy="' + r + '" r="' + (r - 0.5) +
             '" fill="none" stroke="' + hair + '" stroke-width="1"></circle></svg>';
    }

    /* A frame is an edge, so it is drawn as one. A filled dot said nothing
       useful about a white frame -- a white disc on a near-white tile is
       invisible, which is half of why these tiles read as empty. */
    function ringCss(colour, d) {
      var w = Math.max(3, Math.round(d * 0.20));
      return 'display:block;width:' + d + 'px;height:' + d + 'px;border-radius:50%;' +
             'box-sizing:border-box;background:transparent;border:' + w + 'px solid ' +
             esc(colour) + ';box-shadow:0 0 0 1px rgba(0,0,0,.16),' +
             'inset 0 0 0 1px rgba(0,0,0,.16)';
    }

    function mediaBox(kind, value, size, badge) {
      var box = el('span', 'mm-tile-media');
      var base = 'flex:none;width:' + size + 'px;height:' + size + 'px;border-radius:9px;' +
        'overflow:hidden;box-sizing:border-box;display:flex;align-items:center;' +
        'justify-content:center;border:1px solid ' + MM_TRACK + ';background:' + MM_BG;
      if (kind === 'img' && value) {
        box.setAttribute('style', base + ';position:relative');
        var inner = '<img src="' + esc(value) + '" alt="" ' +
          'style="width:100%;height:100%;object-fit:cover;display:block">';
        /* The photo says what the thing looks like; the badge says which
           option it is. Outline rather than box-shadow, so it does not fight
           the ring's own shadow. */
        if (badge && badge.colours && badge.colours.length) {
          inner += '<span style="position:absolute;right:4px;bottom:4px;display:block;' +
                   'border-radius:50%;outline:1.5px solid ' + MM_SURFACE + '">' +
                   swatchSvg(badge.colours, 17) + '</span>';
        } else if (badge && badge.ring) {
          inner += '<span style="position:absolute;right:4px;bottom:4px;' +
                   ringCss(badge.ring, 17) + ';outline:1.5px solid ' + MM_SURFACE + '"></span>';
        }
        box.innerHTML = inner;
      } else if (kind === 'swatch' && value && value.length) {
        box.setAttribute('style', base);
        box.innerHTML = swatchSvg(value, Math.round(size * 0.68));
      } else if (kind === 'solid' && value) {
        box.setAttribute('style', base);
        box.innerHTML = '<span style="' + ringCss(value, Math.round(size * 0.68)) + '"></span>';
      } else if (kind === 'scale') {
        /* The circle is drawn at the option's real share of the largest size,
           so 15, 20 and 40 are visibly what they are. */
        var d = Math.max(0.3, Math.min(1, value)) * (size - 12);
        box.setAttribute('style', base);
        box.innerHTML = '<span style="width:' + d.toFixed(1) + 'px;height:' + d.toFixed(1) +
          'px;border-radius:50%;background:' + MM_INK + ';opacity:.82"></span>';
      } else {
        box.setAttribute('style', base);
      }
      return box;
    }

    function tileEl(o) {
      var big = wideBoard();
      var msize = big ? 50 : 44;
      /* A real photograph earns the room; a swatch does not. These slots are
         empty today -- every cw_img_* and frame_img_* in the theme emits null
         -- so this only changes anything once a picture is actually set. */
      if (o.mediaKind === 'img') msize = 64;
      var b = el('button', 'mm-tile');
      b.type = 'button';
      b.setAttribute('style',
        'width:100%;box-sizing:border-box;display:flex;align-items:center;gap:12px;' +
        'text-align:left;cursor:pointer;border-radius:13px;' +
        'padding:' + (big ? '11px 14px' : '9px 12px') + ';' +
        'border:' + (o.on ? '2px solid ' + MM_ACCENT : '1px solid ' + MM_TRACK) + ';' +
        /* The selected tile keeps a white face and says so with its border, the
           way the Apple pages Kevin sent do. A tinted fill plus a coloured
           border reads as two signals for one state. */
        'background:' + MM_SURFACE + ';color:' + MM_INK + ';' +
        'margin:' + (o.on ? '0' : '1px 0') + ';' +
        'transition:border-color .14s,box-shadow .14s');
      b.appendChild(mediaBox(o.mediaKind, o.media, msize, o.badge));
      var txt = el('span', 'mm-tile-txt');
      txt.setAttribute('style', 'flex:1;min-width:0;display:flex;flex-direction:column;gap:2px');
      var nm = el('span', 'mm-tile-name', esc(o.label));
      nm.setAttribute('style', 'font:' + (o.on ? '600' : '500') + ' ' +
        (big ? '15.5' : '15') + 'px/1.2 ' + MM_FACE);
      txt.appendChild(nm);
      /* B5.71: the free-upgrade tile shows a small green pill under its name
         in place of the sub line. The corner cards are too narrow for a pill
         beside the name without wrapping it. */
      if (o.tag) {
        var tg = el('span', 'mm-tile-tag', esc(o.tag));
        tg.setAttribute('style', 'align-self:flex-start;white-space:nowrap;margin-top:2px;' +
          'font:600 11.5px/1 ' + MM_FACE + ';color:#1E4FC4;background:#E8EEFB;' +
          'border-radius:8px;padding:4px 8px');
        txt.appendChild(tg);
      } else if (o.sub) {
        var sb = el('span', 'mm-tile-sub', esc(o.sub));
        sb.setAttribute('style', 'font-size:12.5px;line-height:1.3;color:' + MM_LABEL +
          ';overflow:hidden;text-overflow:ellipsis;white-space:nowrap');
        txt.appendChild(sb);
      }
      b.appendChild(txt);
      var right = el('span', 'mm-tile-x', o.extra ? esc(o.extra) : '');
      right.setAttribute('style', 'flex:none;font:500 13.5px/1.2 ' + MM_FACE + ';color:' +
        (o.extra ? MM_LABEL : 'transparent'));
      b.appendChild(right);
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        /* B7.1.0 (speed): show the tap first, then do the work. Re-laying out
           every step took 45-90 ms on a laptop and several times that on a
           phone, and the screen showed nothing until it was done (Google's
           INP was 437 ms). Now the tile turns blue in the next frame and the
           rest follows straight after. */
        if (o.on) return o.onClick();
        if (b.__mmBusy) return;
        b.__mmBusy = true;
        b.style.borderColor = MM_ACCENT;
        b.style.boxShadow = 'inset 0 0 0 1px ' + MM_ACCENT;
        requestAnimationFrame(function () {
          setTimeout(function () { b.__mmBusy = false; o.onClick(); }, 0);
        });
      });
      return b;
    }

    /* ------------------------------------------------------------------
       B5.72 -- Kevin's size and frame photos, open in the steps.

       His two graphics are posters: heading, photos, labels and scale bars
       on one canvas. Shrunk into a ~220px panel their type is about 5px, so
       the photos are used and the type is not: each framed model is cut out
       of the graphic (a round mask over the spot it sits in) and the labels
       are set as live text. Sizes keep his idea -- side by side, to scale,
       standing on one line -- and his framed sizes. Frames keep his circle
       and his three pills.

       Spots are [centre x, centre y, radius] as fractions of the photo's
       WIDTH and HEIGHT (radius: of width), measured on his 15 Oct files.
       Shopify uses these defaults; the Etsy page passes its own for its
       cropped copy. The framed sizes are Kevin's figures from the graphic.
       ------------------------------------------------------------------ */
    /* Constants for the guides live at module level (B5.72.1), next to
       MM_FACE: the first paint can run before this point in init(). */

    function guideState() {
      return cfg.__mmGuide || (cfg.__mmGuide = { dims: {}, ro: null });
    }
    /* B5.75: the colour guide is two photos, one per finish, not one graphic,
       so it needs no measuring: whatever is picked is shown as it is. */
    function colourGuidePhotos() {
      var set = cfg.colourGuidePhotos || {};
      return COLOURWAYS.filter(function (cw) { return !!set[cw.id]; })
        .map(function (cw) { return { cw: cw, url: set[cw.id] }; });
    }
    function guideCfg(kind) {
      if (kind === 'colour') {
        var ph = colourGuidePhotos();
        if (ph.length < 2 || ph.length !== COLOURWAYS.length) return null;
        var cur = ph.filter(function (p) { return p.cw.id === st.colourway; })[0] || ph[0];
        return { full: cur.url, cut: null, spots: null, photos: ph };
      }
      var full = cfg[kind + 'GuideImage'];
      var cut = cfg[kind + 'GuideCut'] || full;
      if (!full && !cut) return null;
      return {
        full: full || cut,
        cut: cut,
        spots: (kind === 'size' ? cfg.sizeGuideSpots : cfg.frameGuideSpot) || GUIDE_SPOTS[kind]
      };
    }
    /* Sizes the guide can draw: the ones on sale that have a spot. Fewer than
       two is not a comparison. */
    function guideSizes(g) {
      var out = SIZES.filter(function (x) { return g.spots[String(x.cm)]; });
      return out.length >= 2 ? out : [];
    }
    function guideFrames(g) {
      return FRAMES.filter(function (x) { return GUIDE_DOT[x.id]; });
    }
    /* Which guide the open step has, if any. */
    function guideKindFor(i) {
      var name = SEGMENTS[i];
      var g;
      if (name === 'Size' && (g = guideCfg('size')) && guideSizes(g).length) return 'size';
      if (name === 'Frame' && (g = guideCfg('frame')) && guideFrames(g).length >= 2) return 'frame';
      if (name === 'Colour' && COLOURWAYS.length > 1 && guideCfg('colour')) return 'colour';
      return null;
    }

    /* One cut-out: a round window onto the photo, sized D px, showing the
       model at spot [cx, cy, r]. The mask sits 1% inside the frame's own
       edge so no background shows round the rim. */
    function guideDisc(url, spot, aspect, D) {
      var d = el('span', 'mm-guide-disc');
      var r = spot[2] * 0.99;
      var iw = D / (2 * r), ih = iw * aspect;
      d.setAttribute('style', 'display:block;flex:none;width:' + D.toFixed(1) + 'px;height:' +
        D.toFixed(1) + 'px;border-radius:50%;background-color:#E9EBEE;' +
        'background-image:url("' + String(url).replace(/"/g, '%22') + '");background-repeat:no-repeat;' +
        'background-size:' + iw.toFixed(1) + 'px ' + ih.toFixed(1) + 'px;' +
        'background-position:' + (D / 2 - spot[0] * iw).toFixed(1) + 'px ' +
        (D / 2 - spot[1] * ih).toFixed(1) + 'px;' +
        'box-shadow:0 2px 5px rgba(23,24,26,.16),0 10px 22px -10px rgba(23,24,26,.35)');
      return d;
    }
    function guidePill(text, on, dot, small) {
      var p = el('span', 'mm-guide-pill' + (on ? ' is-on' : ''));
      p.setAttribute('style', 'display:inline-flex;align-items:center;gap:6px;white-space:nowrap;' +
        'font:600 ' + (small ? '11.5' : '12.5') + 'px/1 ' + GUIDE_FONT + ';border-radius:8px;' +
        'padding:' + (small ? '5px 8px' : '6px 10px') +
        (dot ? ' 6px 7px' : '') + ';background:' + (on ? GUIDE_INK : GUIDE_PILL) + ';color:' +
        (on ? '#FFFFFF' : GUIDE_INK) + ';transition:background .15s,color .15s');
      if (dot) {
        var dt = el('span');
        dt.setAttribute('style', 'width:10px;height:10px;border-radius:50%;flex:none;background:' + dot +
          ';box-shadow:inset 0 0 0 1px rgba(23,24,26,' + (dot === '#FFFFFF' ? '.28' : '.12') + ')' +
          (on ? ',0 0 0 1.5px rgba(255,255,255,.9)' : ''));
        p.appendChild(dt);
      }
      p.appendChild(document.createTextNode(text));
      return p;
    }
    function guideZoomBtn(g, kind) {
      var z = el('button', 'mm-guide-zoom',
        '<svg width="13" height="13" viewBox="0 0 10 10" fill="none" aria-hidden="true">' +
        '<path d="M6 1h3v3M4 9H1V6M9 1 5.6 4.4M1 9l3.4-3.4" stroke="' + MM_INK +
        '" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>');
      z.type = 'button';
      z.title = 'See the full photo';
      z.setAttribute('aria-label', 'See the full ' + (kind === 'size' ? 'sizes'
        : kind === 'colour' ? 'colour' : 'frames') + ' photo');
      z.setAttribute('style', 'flex:none;width:32px;height:32px;border-radius:8px;cursor:zoom-in;' +
        'display:flex;align-items:center;justify-content:center;padding:0;background:' + MM_SURFACE +
        ';border:1px solid ' + MM_TRACK + ';box-shadow:0 1px 2px rgba(23,24,26,.05)');
      z.addEventListener('click', function (e) { e.stopPropagation(); openGuide(g, kind); });
      return z;
    }
    /* guideDims / guideRO: see guideState(). */
    function openGuide(g, kind) {
      var dims = guideState().dims[g.full];
      if (!dims) {
        var pre = new Image();
        pre.onload = function () {
          guideState().dims[g.full] = [pre.naturalWidth, pre.naturalHeight];
          openGuide(g, kind);
        };
        pre.src = g.full;
        return;
      }
      var im = document.createElement('img');
      im.src = g.full;
      im.alt = kind === 'size' ? 'Every size shown to scale'
        : kind === 'colour' ? 'The model in ' + cwObj().name
        : 'Every frame option side by side';
      im.draggable = false;
      im.setAttribute('style', 'display:block;border-radius:14px;background:' + MM_BG +
        ';object-fit:contain;user-select:none;-webkit-user-select:none;-webkit-user-drag:none');
      openLightboxNode(im, {
        aspect: dims[0] / dims[1],
        fill: 0.9,
        hint: IS_TOUCH ? 'Pinch or tap to zoom · tap outside to close'
                       : 'Click or scroll to zoom · click outside to close'
      });
    }

    function pickSize(sz) {
      var had = st.stage === 'cfg';
      st.size = sz; st.zoomX = 1;
      try { loadThree(); } catch (eL) {}   /* B7.1.0: the 3D engine, now a size is chosen */
      /* A different size is a different patch of the world, so the render on
         screen is no longer of what is being bought. */
      if (had) clearInlineRender();
      dropOutOfBounds();
      sync();
      map.fit();
    }
    function pickFrame(fr) { st.frame = fr.id; sync(); refreshRender(); }
    function pickColour(cw) { st.colourway = cw.id; sync(); refreshRender(); }

    /* ===================== B7.0: the name label step =====================
       Optional, "No label" until they choose otherwise. Choosing "Add a name
       label" fills it with the place's own name; they can type their own (14
       characters, capitals) or pick coordinates, a special date or place +
       year. The plaque is drawn live under the field and on the 3D model. */
    var lblUi, lblVal;     /* no value here: init may run this line after the first sync */
    function labelIsOn() { return LABEL.on && st.labelSrc !== 'none'; }
    function labelYear() {
      return st.labelDate ? st.labelDate.slice(0, 4) : String(new Date().getFullYear());
    }
    function labelValue() {
      if (!LABEL.on) return 'None';
      labelAuto();
      var t = String(st.labelText || '').replace(/ +$/, '');
      return st.labelSrc === 'none' || !t ? 'None' : t;
    }
    function labelAuto() {
      var s = st.labelSrc, v, idea = labelIdea(s);
      if (s === 'place') v = labelShortPlace(st.placeName) || labelCoords(st.center.lat, st.center.lon);
      else if (s === 'coords') v = labelCoords(st.center.lat, st.center.lon);
      else if (s === 'placeyear') v = labelPlaceYear(st.placeName, labelYear());
      else if (s === 'date') v = labelDateFmt(st.labelDate) || st.labelText;
      else if (idea && idea.text) v = idea.text();
      else return;                       /* custom keeps what they typed; none keeps it for later */
      st.labelText = labelClean(v, false);
    }
    function labelRestore(src, text, date, icon) {
      if (!/^(place|coords|date|placeyear|custom|none|home|met|mrs|grad)$/.test(String(src))) return;
      st.labelIcon = labelIcon(icon) ? icon : '';
      st.labelSrc = src;
      st.labelText = labelClean(text || '', false);
      st.labelDate = /^\d{4}-\d{2}-\d{2}$/.test(date || '') ? date : '';
      st.labelDateOpen = src === 'date';
    }
    function labelSummary() {
      var v = labelValue(), ic = labelIcon(st.labelIcon);
      return v === 'None' ? (labelIsOn() ? 'Type your label' : 'No label') : (ic ? ic.emoji + ' ' : '') + v;
    }
    /* How the label is written on the order: icon first, then the words. */
    function labelOrderText() {
      var v = labelValue(), ic = labelIcon(st.labelIcon);
      return v === 'None' ? 'None' : (ic ? ic.emoji + ' ' : '') + v;
    }
    function labelSet(src) {
      st.labelSrc = src;
      if (src === 'none') st.labelDateOpen = false;
      labelAuto();
      sync();               /* tiles, total and the summary under Preview */
      refreshRender();      /* a model on screen gets the new plaque */
    }
    function labelCss() {
      if (document.getElementById('mm-lbl-css')) return;
      var F = MM_FACE, B = MM_LABEL_BONE;
      var s = document.createElement('style');
      s.id = 'mm-lbl-css';
      s.textContent = [
        '.mm-lbl{display:flex;flex-direction:column;gap:12px;margin:4px 0 0;padding:0;box-sizing:border-box;width:100%;container-type:inline-size;' +
          'color:' + MM_INK + ';font-family:' + F + ';text-align:left;cursor:default}',
        /* the plaque, set into a strip of the chosen frame */
        '.mm-lbl .mm-lbl-stage{position:relative;display:flex;align-items:center;justify-content:center;box-sizing:border-box;' +
          'width:100%;padding:16px 18px;border-radius:14px;background:#1D1F22;' +
          'box-shadow:inset 0 1px 0 rgba(255,255,255,.06),inset 0 -2px 6px rgba(0,0,0,.35)}',
        '.mm-lbl .mm-lbl-stage.is-white{background:#F3F3F1;box-shadow:inset 0 0 0 1px ' + MM_TRACK + ',inset 0 -2px 6px rgba(0,0,0,.06)}',
        '.mm-lbl .mm-lbl-stage.is-wood{background:linear-gradient(100deg,#C9A77F 0%,#D4B48E 18%,#C29E74 37%,#D2B089 58%,#BF9A70 79%,#CEAC84 100%);' +
          'box-shadow:inset 0 1px 0 rgba(255,255,255,.18),inset 0 -2px 6px rgba(60,35,10,.25)}',
        '.mm-lbl .mm-lbl-prev{container-type:inline-size;width:100%;max-width:300px;margin:0}',
        '.mm-lbl .mm-lbl-pill{position:relative;box-sizing:border-box;width:100%;aspect-ratio:41.9/8.6;border-radius:999px;' +
          'background:' + MM_LABEL_BASE + ';color:' + B + ';display:flex;align-items:center;justify-content:center;overflow:hidden;' +
          'box-shadow:inset 0 1px 2px rgba(0,0,0,.55),0 0 0 1px rgba(0,0,0,.35)}',
        '.mm-lbl .mm-lbl-pill::before{content:"";position:absolute;inset:4px;inset:1.671cqw;border:1px solid ' + B + ';' +
          'border-width:max(1px,1.002cqw);border-radius:999px;pointer-events:none}',
        '.mm-lbl .mm-lbl-txt{position:relative;display:inline-block;color:' + B + ';white-space:nowrap;line-height:1;' +
          'font-family:' + MM_LABEL_FACE + ';font-weight:500;font-size:14px}',
        '.mm-lbl .mm-lbl-pill.is-white{background:#FFFFFF;color:' + MM_LABEL_BASE + ';box-shadow:inset 0 1px 2px rgba(0,0,0,.18),0 0 0 1px rgba(0,0,0,.10)}',
        '.mm-lbl .mm-lbl-pill.is-white::before{border-color:' + MM_LABEL_BASE + '}',
        '.mm-lbl .mm-lbl-pill.is-white .mm-lbl-txt{color:' + MM_LABEL_BASE + '}',
        '.mm-lbl .mm-lbl-pill.is-none{background:rgba(255,255,255,.08);box-shadow:inset 0 0 0 1px rgba(255,255,255,.35)}',
        '.mm-lbl .mm-lbl-stage.is-white .mm-lbl-pill.is-none,.mm-lbl .mm-lbl-stage.is-wood .mm-lbl-pill.is-none{' +
          'background:rgba(255,255,255,.55);box-shadow:inset 0 0 0 1px rgba(0,0,0,.18)}',
        '.mm-lbl .mm-lbl-pill.is-none::before{display:none}',
        '.mm-lbl .mm-lbl-pill.is-none .mm-lbl-txt{color:#C9CDD2;font:500 14px/1 ' + F + '}',
        '.mm-lbl .mm-lbl-stage.is-white .mm-lbl-pill.is-none .mm-lbl-txt,.mm-lbl .mm-lbl-stage.is-wood .mm-lbl-pill.is-none .mm-lbl-txt{color:' + MM_LABEL + '}',
        '.mm-lbl .mm-lbl-cap{margin:-4px 0 0;font:500 13px/1.3 ' + F + ';color:' + MM_LABEL + ';text-align:center}',
        /* the text */
        '.mm-lbl .mm-lbl-field{position:relative;display:block;margin:0}',
        '.mm-lbl .mm-lbl-in{display:block;width:100%;max-width:none;box-sizing:border-box;margin:0;height:auto;min-height:0;' +
          'font:600 17px/1.25 ' + F + ';letter-spacing:.08em;text-transform:uppercase;padding:14px 64px 14px 16px;' +
          'border:1px solid ' + MM_TRACK + ';border-radius:12px;background:' + MM_SURFACE + ';color:' + MM_INK + ';' +
          'outline:none;box-shadow:none;-webkit-appearance:none;appearance:none}',
        '.mm-lbl .mm-lbl-in::placeholder{color:' + MM_LABEL + ';opacity:.8;text-transform:none;letter-spacing:0;font-weight:500}',
        '.mm-lbl .mm-lbl-in:focus{border-color:' + MM_ACCENT + ';box-shadow:0 0 0 3px ' + MM_ACCENT_SOFT + '}',
        '.mm-lbl .mm-lbl-count{position:absolute;right:16px;top:50%;transform:translateY(-50%);font:500 13px/1 ' + F + ';' +
          'color:' + MM_LABEL + ';pointer-events:none;font-variant-numeric:tabular-nums}',
        /* the ideas */
        '.mm-lbl .mm-lbl-ideas-h{margin:2px 0 -4px;font:600 13px/1.2 ' + F + ';letter-spacing:.06em;text-transform:uppercase;color:' + MM_LABEL + '}',
        '.mm-lbl .mm-lbl-sugs{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:8px}',
        '.mm-lbl .mm-lbl-sug{display:flex;align-items:center;gap:9px;margin:0;min-height:46px;min-width:0;width:100%;height:auto;' +
          'box-sizing:border-box;border:1px solid ' + MM_TRACK + ';background:' + MM_SURFACE + ';color:' + MM_INK + ';border-radius:12px;' +
          'padding:9px 10px 9px 11px;font:500 14.5px/1.2 ' + F + ';letter-spacing:0;text-transform:none;text-align:left;cursor:pointer;' +
          'box-shadow:none;transition:border-color .14s,background .14s}',
        '.mm-lbl .mm-lbl-sug .mm-lbl-emo{flex:none;width:22px;font-size:19px;line-height:1;text-align:center}',
        '.mm-lbl .mm-lbl-sug .mm-lbl-nm{flex:1;min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
        '.mm-lbl .mm-lbl-sug:hover{border-color:' + MM_INK + '}',
        '.mm-lbl .mm-lbl-sug.is-on{border-color:' + MM_ACCENT + ';background:' + MM_ACCENT_SOFT + ';color:' + MM_ACCENT_INK + ';' +
          'box-shadow:inset 0 0 0 1px ' + MM_ACCENT + '}',
        /* the icons */
        /* B7.0.7: None + nine icons = two even rows of five; one row of ten on a wide panel */
        '.mm-lbl .mm-lbl-icons{display:grid;grid-template-columns:repeat(5,minmax(0,1fr));gap:6px}',
        '@container (min-width: 560px){.mm-lbl .mm-lbl-icons{grid-template-columns:repeat(10,minmax(0,1fr))}}',
        '.mm-lbl .mm-lbl-icb{display:flex;align-items:center;justify-content:center;margin:0;padding:0;min-width:0;width:100%;' +
          'aspect-ratio:1/1;max-height:52px;box-sizing:border-box;border:1px solid ' + MM_TRACK + ';border-radius:12px;background:' + MM_SURFACE + ';' +
          'color:' + MM_INK + ';cursor:pointer;font:600 12.5px/1 ' + F + ';box-shadow:none;transition:border-color .14s,background .14s}',
        '.mm-lbl .mm-lbl-icb svg{width:22px;height:22px;display:block}',
        '.mm-lbl .mm-lbl-icb:hover{border-color:' + MM_INK + '}',
        '.mm-lbl .mm-lbl-icb.is-on{border-color:' + MM_ACCENT + ';background:' + MM_ACCENT_SOFT + ';color:' + MM_ACCENT_INK + ';' +
          'box-shadow:inset 0 0 0 1px ' + MM_ACCENT + '}',
        '.mm-lbl .mm-lbl-ico{display:inline-block;flex:none;fill:currentColor}',
        /* narrow (phones): emoji above the words, so every idea fits on one line */
        /* B7.0.6 (Kevin: "don't take up too much more space"): emoji on the left on every screen, one line, tighter on phones */
        '@container (max-width: 380px){.mm-lbl .mm-lbl-sug{gap:6px;padding:8px 7px 8px 8px;min-height:42px;font-size:13.5px}' +
          '.mm-lbl .mm-lbl-sug .mm-lbl-emo{width:18px;font-size:16px}' +
          '.mm-lbl .mm-lbl-sug .mm-lbl-nm{white-space:normal;overflow:visible;text-overflow:clip;line-height:1.15}}',
        '.mm-lbl .mm-lbl-date{display:none;align-items:stretch;gap:8px;font:600 14px/1.2 ' + F + ';color:' + MM_INK + '}',
        '.mm-lbl .mm-lbl-date.is-open{display:flex}',
        /* B7.0.6: day, month, year as three quick dropdowns (no calendar pop-up) */
        '.mm-lbl .mm-lbl-dsel{flex:1 1 0;min-width:0;margin:0;height:auto;box-sizing:border-box;font:500 16px/1.2 ' + F + ';' +
          'padding:12px 28px 12px 12px;border:1px solid ' + MM_TRACK + ';border-radius:12px;background:' + MM_SURFACE + ' ' +
          'url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 8%27%3E%3Cpath d=%27M1 1.5l5 5 5-5%27 fill=%27none%27 stroke=%27%23667085%27 stroke-width=%271.6%27 stroke-linecap=%27round%27/%3E%3C/svg%3E") ' +
          'right 11px center/11px 8px no-repeat;color:' + MM_LABEL + ';-webkit-appearance:none;appearance:none;cursor:pointer;outline:none;box-shadow:none}',
        '.mm-lbl .mm-lbl-dsel.is-m{flex-grow:1.25}',
        '.mm-lbl .mm-lbl-dsel.is-y{flex-grow:1.2}',
        '.mm-lbl .mm-lbl-dsel.has-v{color:' + MM_INK + '}',
        '.mm-lbl .mm-lbl-dsel:focus{border-color:' + MM_ACCENT + ';box-shadow:0 0 0 3px ' + MM_ACCENT_SOFT + '}',
        '.mm-lbl .mm-lbl-datein{flex:1;min-width:0;margin:0;height:auto;font:500 16px/1.2 ' + F + ';padding:11px 12px;' +
          'border:1px solid ' + MM_TRACK + ';border-radius:12px;background:' + MM_SURFACE + ';color:' + MM_INK + ';box-sizing:border-box}',
        '.mm-lbl-fs{display:flex;align-items:center;gap:6px;margin:10px 0 0;font:600 13.5px/1.3 ' + F + ';color:#1C7A45}',
        /* B7.0.7 (Kevin): red with an empty circle while there is no label; green tick once it is earned */
        /* B7.0.8 (Kevin): blue (the configurator accent), not red; an offer, not an error.
           A small dot with a soft ring that pulses 3 times when the note appears, then holds still. */
        '.mm-lbl-fs.is-off{color:' + MM_ACCENT + '}',
        '.mm-lbl-fs.is-off::before{width:8px;height:8px;margin:0 4px;background:' + MM_ACCENT + '!important;box-shadow:0 0 0 0 rgba(30,79,196,.5);animation:mmLblFsPulse 1.6s ease-out 3}',
        '@keyframes mmLblFsPulse{0%{box-shadow:0 0 0 0 rgba(30,79,196,.5)}70%{box-shadow:0 0 0 7px rgba(30,79,196,0)}100%{box-shadow:0 0 0 0 rgba(30,79,196,0)}}',
        '@media (prefers-reduced-motion:reduce){.mm-lbl-fs.is-off::before{animation:none}}',
        '.mm-lbl-fs::before{content:"";flex:none;width:16px;height:16px;border-radius:50%;background:#1C7A45 url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M4 8.2l2.6 2.6L12 5.4%27 fill=%27none%27 stroke=%27white%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E") center/16px no-repeat}',
        /* B7.0.2: the drawn preview (the frame as it really looks). The flat pill stays underneath as the fallback. */
        '.mm-lbl .mm-lbl-cv{display:none}',
        '.mm-lbl .mm-lbl-stage.is-scene{display:block;padding:0;overflow:hidden;background:#EEF0F3;box-shadow:inset 0 0 0 1px rgba(0,0,0,.05)}',
        '.mm-lbl .mm-lbl-stage.is-scene .mm-lbl-prev{display:none}',
        '.mm-lbl .mm-lbl-stage.is-scene .mm-lbl-cv{display:block;width:100%;height:auto;border-radius:inherit}'
      ].join('\n');
      document.head.appendChild(s);
    }
    function labelPaint() {
      if (lblVal && lblVal.el) lblVal.el.textContent = labelSummary();
      var u = lblUi;
      if (!u) return;
      var shown = st.labelSrc === 'none' ? '' : String(st.labelText || '');
      var typing = document.activeElement === u.inp;
      if (u.inp.value !== shown && !(typing && labelClean(u.inp.value, false) === shown)) u.inp.value = shown;
      u.count.textContent = u.inp.value.length + '/' + MM_LABEL_MAX;
      var val = labelValue(), t = val === 'None' ? '' : val;
      var fr = st.frame === 'white' ? 'white' : st.frame === 'wood' ? 'wood' : 'black';
      u.stage.classList[fr === 'white' ? 'add' : 'remove']('is-white');
      u.stage.classList[fr === 'wood' ? 'add' : 'remove']('is-wood');
      u.cap.textContent = 'Set into your ' + (FRAMES.filter(function (f) { return f.id === st.frame; })[0] || { name: 'Black' }).name.toLowerCase() + ' frame';
      u.pill.classList[t ? 'remove' : 'add']('is-none');
      u.pill.classList[labelTone(st.frame).white ? 'add' : 'remove']('is-white');
      var ic = labelIcon(st.labelIcon);
      if (!t) {
        u.txt.textContent = 'Your label shows here';
        u.txt.removeAttribute('style');
        u.ico.style.display = 'none';
      } else {
        var icMM = ic ? MM_LABEL_ICON.size + MM_LABEL_ICON.gap : 0;
        var f = labelFit(t, MM_LABEL_MM.textW - icMM, MM_LABEL_MM.font), em = (f.ls / f.fs).toFixed(3) + 'em';
        u.txt.textContent = t;
        u.txt.style.fontSize = (f.fs / MM_LABEL_MM.w * 100).toFixed(3) + 'cqw';
        u.txt.style.letterSpacing = em;
        u.txt.style.paddingLeft = em;
        if (ic) {
          u.icoPath.setAttribute('d', ic.d);
          u.icoPath.setAttribute('fill-rule', ic.even ? 'evenodd' : 'nonzero');
          var icq = (MM_LABEL_ICON.size / MM_LABEL_MM.w * 100).toFixed(3) + 'cqw';
          u.ico.style.cssText = 'display:inline-block;width:' + icq + ';height:' + icq + ';margin-right:' +
            (MM_LABEL_ICON.gap / MM_LABEL_MM.w * 100).toFixed(3) + 'cqw';
        } else {
          u.ico.style.display = 'none';
        }
      }
      labelScenePaint(u, t, fr);
      u.icbs.forEach(function (b) {
        var on = (b.getAttribute('data-icon') || '') === (st.labelIcon || '');
        b.classList[on ? 'add' : 'remove']('is-on');
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      u.sugs.forEach(function (b) {
        var on = b.getAttribute('data-src') === st.labelSrc;
        b.classList[on ? 'add' : 'remove']('is-on');
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      u.date.classList[st.labelSrc === 'date' ? 'add' : 'remove']('is-open');
      var dm = /^(\d{4})-(\d{2})-(\d{2})$/.exec(st.labelDate || '');
      if (dm && u.dD) {
        [[u.dY, dm[1]], [u.dM, dm[2]], [u.dD, dm[3]]].forEach(function (q) { if (q[0].value !== q[1]) q[0].value = q[1]; q[0].classList.add('has-v'); });
      }
    }
    /* B7.0.4: the customer's own map data for the preview. The same cached
       promise the render uses (it starts when they pick a size), so this asks
       for nothing new; until it lands the preview shows a made-up town. */
    var lblGeo = { key: '', want: '', geo: null };
    function labelGeo() {
      try {
        if (!st.size || !areaOk()) return null;
        var sp = spec(), k = geomKey(cfg, sp), gg = lblGeo.geo;
        if (lblGeo.key === k) return gg;
        /* the map's centre wobbles by a hair as it settles; only a real move refetches */
        if (gg && gg.cm === sp.size.cm && Math.abs(gg.groundMeters - sp.groundMeters) < 1) {
          var ob = gg.bbox, nb = sp.bbox, cyl = ((nb.minLat + nb.maxLat) / 2) * Math.PI / 180;
          var dz = ((ob.minLat + ob.maxLat) - (nb.minLat + nb.maxLat)) / 2 * 110540;
          var dx = ((ob.minLon + ob.maxLon) - (nb.minLon + nb.maxLon)) / 2 * 111320 * Math.cos(cyl);
          if (Math.sqrt(dx * dx + dz * dz) < sp.groundMeters * 0.02) return gg;
        }
        if (lblGeo.want !== k) {
          lblGeo.want = k;
          var keep = { bbox: sp.bbox, groundMeters: sp.groundMeters, cm: sp.size.cm };
          collectFromOverpass(cfg, sp).then(function (g) {
            if (lblGeo.want !== k || !g) return;
            lblGeo.key = k;
            lblGeo.geo = { key: k, data: g, bbox: keep.bbox, groundMeters: keep.groundMeters, cm: keep.cm };
            if (window.console) console.info('[mm] label preview: your own streets (' + (g.buildings || []).length + ' buildings)');
            if (lblUi) labelPaint();
          }).catch(function () {});
        }
        return null;
      } catch (eG) { return null; }
    }
    /* B7.0.2: draw the frame with the plaque in it. Any trouble and the flat
       pill underneath shows instead; the step itself never breaks. */
    function labelScenePaint(u, t, fr) {
      if (!u.cv || !u.stage.classList.contains('is-scene')) return;
      var w = u.stage.clientWidth;
      if (!w) return;                       /* hidden for now: the resize watcher draws it once it shows */
      try {
        var h = Math.round(w * MM_LBL_SCENE.aspect), dpr = Math.min(3, Math.max(1, window.devicePixelRatio || 1));
        var W = Math.round(w * dpr), H = Math.round(h * dpr);
        if (u.cv.width !== W || u.cv.height !== H) { u.cv.width = W; u.cv.height = H; }
        u.cv.style.height = h + 'px';
        labelScene(u.cv, { frame: fr, cm: st.size && st.size.cm, cw: cwObj(), text: t, icon: t ? st.labelIcon : '', geo: labelGeo() });
        u.stage.setAttribute('aria-label', t ? 'Your label, ' + t + ', set into the ' + fr + ' frame' : 'Your label will show here, set into the frame');
        u.drawnW = w;
      } catch (eS) {
        u.stage.classList.remove('is-scene');
        if (window.console) console.warn('[mm] label preview drawn flat: ' + (eS && eS.message));
      }
    }
    function labelUi() {
      if (lblUi) return lblUi.root;
      labelCss();
      var root2 = el('div', 'mm-lbl');
      /* 1. what it will look like, in the frame they picked */
      var stage = el('div', 'mm-lbl-stage');
      var prev = el('div', 'mm-lbl-prev'), pill = el('div', 'mm-lbl-pill');
      pill.setAttribute('aria-hidden', 'true');
      var SVGNS = 'http://www.w3.org/2000/svg';
      var ico = document.createElementNS(SVGNS, 'svg');
      ico.setAttribute('viewBox', '0 0 24 24');
      ico.setAttribute('class', 'mm-lbl-ico');
      ico.setAttribute('aria-hidden', 'true');
      ico.style.display = 'none';
      var icoPath = document.createElementNS(SVGNS, 'path');
      ico.appendChild(icoPath);
      var txt = el('span', 'mm-lbl-txt', '');
      pill.appendChild(ico); pill.appendChild(txt); prev.appendChild(pill); stage.appendChild(prev);
      var cv = document.createElement('canvas');
      cv.className = 'mm-lbl-cv';
      cv.setAttribute('aria-hidden', 'true');
      stage.appendChild(cv);
      stage.setAttribute('role', 'img');
      if (cv.getContext && cv.getContext('2d') && typeof labelScene === 'function') stage.classList.add('is-scene');
      var cap = el('p', 'mm-lbl-cap', '');
      /* 2. the words */
      var field = el('div', 'mm-lbl-field');
      var inp = document.createElement('input');
      inp.type = 'text';
      inp.className = 'mm-lbl-in';
      inp.maxLength = MM_LABEL_MAX;
      inp.placeholder = 'Type your label';
      inp.setAttribute('autocomplete', 'off');
      inp.setAttribute('autocapitalize', 'characters');
      inp.setAttribute('autocorrect', 'off');
      inp.setAttribute('spellcheck', 'false');
      inp.setAttribute('enterkeyhint', 'done');
      inp.setAttribute('aria-label', 'Label text, up to ' + MM_LABEL_MAX + ' characters');
      var count = el('span', 'mm-lbl-count', '');
      count.setAttribute('aria-hidden', 'true');
      field.appendChild(inp); field.appendChild(count);
      /* 3. an icon in front, if they want one */
      var iconsH = el('p', 'mm-lbl-ideas-h', 'Add an icon');
      var iconRow = el('div', 'mm-lbl-icons');
      var icbs = [{ id: '', name: 'No icon' }].concat(LABEL_ICONS).map(function (d) {
        var b = el('button', 'mm-lbl-icb', d.id
          ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" fill-rule="' + (d.even ? 'evenodd' : 'nonzero') +
            '" d="' + d.d + '"/></svg>'
          : 'None');
        b.type = 'button';
        b.setAttribute('data-icon', d.id);
        b.setAttribute('aria-label', d.name);
        b.title = d.name;
        b.addEventListener('click', function () {
          st.labelIcon = d.id;
          sync();
          refreshRender();
        });
        iconRow.appendChild(b);
        return b;
      });
      /* 4. ideas, for anyone stuck for words */
      var ideasH = el('p', 'mm-lbl-ideas-h', 'Need an idea?');
      var sugRow = el('div', 'mm-lbl-sugs');
      /* B7.0.6: the special date as day, month and year dropdowns, in the
         order the shopper's region writes dates (US: month first) */
      var date = el('div', 'mm-lbl-date');
      date.setAttribute('role', 'group');
      date.setAttribute('aria-label', 'Special date');
      function pad2(n) { return (n < 10 ? '0' : '') + n; }
      function dsel(cls, ph, opts) {
        var sl = document.createElement('select');
        sl.className = 'mm-lbl-dsel ' + cls;
        sl.setAttribute('aria-label', ph);
        var o0 = document.createElement('option'); o0.value = ''; o0.textContent = ph; sl.appendChild(o0);
        opts.forEach(function (p) { var o = document.createElement('option'); o.value = p[0]; o.textContent = p[1]; sl.appendChild(o); });
        return sl;
      }
      var dd = [], dmo = [], dyr = [], kk, yNow = new Date().getFullYear();
      for (kk = 1; kk <= 31; kk++) dd.push([pad2(kk), String(kk)]);
      ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'].forEach(function (m, ix) { dmo.push([pad2(ix + 1), m]); });
      for (kk = yNow + 1; kk >= 1940; kk--) dyr.push([String(kk), String(kk)]);
      var dD = dsel('is-d', 'Day', dd), dM = dsel('is-m', 'Month', dmo), dY = dsel('is-y', 'Year', dyr);
      (labelDateUS() ? [dM, dD, dY] : [dD, dM, dY]).forEach(function (sl) { date.appendChild(sl); });
      function dateRead() {
        var d = dD.value, m = dM.value, y = dY.value;
        if (!d || !m || !y) return '';
        var dim = new Date(+y, +m, 0).getDate();
        if (+d > dim) { d = pad2(dim); dD.value = d; }
        return y + '-' + m + '-' + d;
      }
      [dD, dM, dY].forEach(function (sl) {
        sl.addEventListener('change', function () {
          sl.classList[sl.value ? 'add' : 'remove']('has-v');
          var v = dateRead();
          st.labelSrc = 'date';
          st.labelDateOpen = true;
          if (v) { st.labelDate = v; labelSet('date'); } else { labelPaint(); saveState(); }
        });
      });
      var dateIn = { value: '' };   /* kept so older paint code has something to read */
      var sugs = LABEL_IDEAS.map(function (d) {
        var b = el('button', 'mm-lbl-sug',
          '<span class="mm-lbl-emo" aria-hidden="true">' + d.icon + '</span><span class="mm-lbl-nm">' + esc(d.name) + '</span>');
        b.type = 'button';
        b.setAttribute('data-src', d.id);
        b.addEventListener('click', function () {
          if (d.id === 'date') {
            st.labelDateOpen = true;
            if (st.labelDate) return labelSet('date');
            st.labelSrc = 'date';
            labelPaint();
            return;                     /* B7.0.6: no calendar pop-up, no focus jump; the three dropdowns open in place */
          }
          labelSet(d.id);
        });
        sugRow.appendChild(b);
        return b;
      });
      inp.addEventListener('input', function () {
        var raw = inp.value, caret = inp.selectionStart, v = labelClean(raw, true);
        if (v !== raw) {
          var p = labelClean(raw.slice(0, caret == null ? raw.length : caret), true).length;
          inp.value = v;
          try { inp.setSelectionRange(p, p); } catch (eS) {}
        }
        st.labelText = labelClean(v, false);
        st.labelSrc = 'custom';
        labelPaint();
        saveState();
      });
      inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); inp.blur(); } });
      inp.addEventListener('change', function () {
        inp.value = labelClean(inp.value, false);
        st.labelText = inp.value;
        st.labelSrc = 'custom';
        sync();
        refreshRender();
      });
      root2.addEventListener('click', function (e) { e.stopPropagation(); });
      root2.appendChild(stage);
      root2.appendChild(cap);
      root2.appendChild(field);
      root2.appendChild(iconsH);
      root2.appendChild(iconRow);
      root2.appendChild(ideasH);
      root2.appendChild(sugRow);
      root2.appendChild(date);
      lblUi = { root: root2, stage: stage, cap: cap, inp: inp, count: count, pill: pill, txt: txt, ico: ico, icoPath: icoPath,
                icbs: icbs, sugs: sugs, date: date, dateIn: dateIn, dD: dD, dM: dM, dY: dY, cv: cv, drawnW: 0 };
      /* redraw when it first shows or the panel changes width, and once the fonts are in */
      try {
        if (window.ResizeObserver) {
          new ResizeObserver(function () { if (lblUi && stage.clientWidth && stage.clientWidth !== lblUi.drawnW) labelPaint(); }).observe(stage);
        }
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (lblUi) labelPaint(); });
      } catch (eR) {}
      return root2;
    }

    /* B5.76 -- colours: the same shot twice, stacked in list order (Gallery
       White above Natural Colour), each a 3:2 photo with its name on it.
       The picked one is ringed and its pill filled; a tap picks it. */
    function guideColourBody(root, g, W, maxH) {
      var list = g.photos, GAP = 10;
      var H = Math.round(W * 2 / 3);
      /* B5.77: room is short beside step 4 -- shorter photos first (centre
         crop, down to 2:1), then narrower ones at 2:1. */
      if (maxH > 0) {
        var fitH = Math.floor((maxH - GAP * (list.length - 1) - 4) / list.length);
        if (fitH < H) {
          H = Math.max(fitH, Math.round(W / 2));
          if (fitH < H && fitH >= 90) { H = fitH; W = H * 2; }
        }
      }
      /* B6.0.1 (Kevin): in the Compare panel the two finishes sit side by
         side, each under its own tile -- Gallery White left, Natural Colour
         right -- as square crops. */
      var side = !!(root.__mmGuide && root.__mmGuide.where === 'cmp') && list.length === 2;
      var W2 = Math.floor((W - GAP) / 2);
      if (side) H = W2;
      var col = el('div', 'mm-guide-row');
      col.setAttribute('style', side
        ? 'position:relative;display:grid;grid-template-columns:repeat(2,' + W2 + 'px);gap:' + GAP + 'px;' +
          'justify-content:space-between;padding:2px 0'
        : 'position:relative;display:flex;flex-direction:column;align-items:center;' +
          'gap:' + GAP + 'px;padding:2px 0');
      list.forEach(function (p) {
        var on = st.colourway === p.cw.id;
        var b = el('button', 'mm-guide-item mm-guide-cw' + (on ? ' is-on' : ''));
        b.type = 'button';
        b.setAttribute('aria-label', p.cw.name + (on ? ', selected' : ''));
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.setAttribute('style', 'position:relative;display:block;width:' + (side ? W2 : W) + 'px;height:' + H + 'px;' +
          'padding:0;margin:0;border:0;border-radius:12px;background:transparent;cursor:pointer;' +
          'color:inherit;font:inherit');
        var ph = el('span', 'mm-guide-photo');
        ph.setAttribute('style', 'position:absolute;inset:0;display:block;border-radius:12px;' +
          'background:#E9EBEE url("' + String(p.url).replace(/"/g, '%22') + '") center/cover no-repeat;' +
          'transition:box-shadow .15s;box-shadow:' +
          (on ? '0 0 0 2px ' + MM_SURFACE + ',0 0 0 4px ' + GUIDE_INK
              : 'inset 0 0 0 1px rgba(23,24,26,.08)'));
        b.appendChild(ph);
        var tag = el('span', 'mm-guide-cwtag');
        tag.setAttribute('style', 'position:absolute;left:10px;bottom:10px;display:flex;align-items:center;' +
          'gap:6px;max-width:calc(100% - 20px)');
        var pill = guidePill(p.cw.name, on, null, true);
        pill.style.boxShadow = '0 2px 8px rgba(23,24,26,.18)';
        if (!on) pill.style.background = 'rgba(255,255,255,.92)';
        tag.appendChild(pill);
        b.appendChild(tag);
        b.addEventListener('click', function (e) { e.stopPropagation(); if (!on) pickColour(p.cw); });
        col.appendChild(b);
      });
      root.appendChild(col);
    }

    /* The guide. `where` is 'panel' (a desktop side panel, which is the card)
       or 'sheet' (the phone's step sheet, where it sits on a tinted card of
       its own so it is not mistaken for another option). Built empty and
       laid out once it is on the page and has a width. */
    function guideEl(kind, where, host) {
      var g = guideCfg(kind);
      if (!g) return null;
      var root = el('div', 'mm-guide mm-guide--' + kind);
      root.__mmGuide = { kind: kind, g: g, where: where, w: 0, host: host == null ? -1 : host };
      root.setAttribute('style', 'width:100%;box-sizing:border-box;display:flex;flex-direction:column;' +
        'gap:12px;color:' + MM_INK + ';font-family:' + GUIDE_FONT + ';' +
        (where === 'sheet'
          ? 'background:' + MM_BG + ';border-radius:12px;padding:14px 14px 12px;margin-top:6px'
          : where === 'cmp'
            ? 'background:' + MM_SURFACE + ';padding:14px 12px 12px'
            : 'padding:0'));
      root.addEventListener('click', function (e) { e.stopPropagation(); });
      /* The caller lays it out as soon as it is on the page (no blank frame
         on a repaint); this is the fallback. The ResizeObserver keeps it
         right through font loads and window resizes. */
      requestAnimationFrame(function () { guideLayout(root); });
      if (typeof ResizeObserver === 'function') {
        var gs = guideState();
        if (!gs.ro) {
          gs.ro = new ResizeObserver(function (list) {
            list.forEach(function (en) {
              if (!en.target.isConnected) { gs.ro.unobserve(en.target); return; }
              guideLayout(en.target);
            });
          });
        }
        gs.ro.observe(root);
      }
      return root;
    }
    function guideHead(kind, g) {
      var head = el('div', 'mm-guide-head');
      head.setAttribute('style', 'display:flex;align-items:flex-start;gap:10px');
      var tx = el('div');
      tx.setAttribute('style', 'flex:1;min-width:0');
      var eb = el('div', 'mm-guide-eyebrow', kind === 'size' ? 'Size guide'
        : kind === 'colour' ? 'Colour guide' : 'Frame guide');
      eb.setAttribute('style', 'font:600 10.5px/1.2 ' + GUIDE_FONT + ';letter-spacing:.14em;' +
        'text-transform:uppercase;color:' + GUIDE_INK + ';margin-bottom:4px');
      var tt = el('div', 'mm-guide-title', kind === 'size'
        ? 'Every size shown to scale'
        : kind === 'colour' ? 'Same model, two finishes' : 'Every frame is included free');
      tt.setAttribute('style', 'font:600 15.5px/1.25 ' + GUIDE_FONT + ';color:' + MM_INK +
        ';text-wrap:balance');
      tx.appendChild(eb); tx.appendChild(tt);
      head.appendChild(tx);
      head.appendChild(guideZoomBtn(g, kind));
      return head;
    }
    function guideLayout(root) {
      var m = root && root.__mmGuide;
      if (!m || !root.isConnected) return;
      var cs = window.getComputedStyle(root);
      var W = Math.floor(root.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight));
      if (!(W > 60)) return;
      var maxH = (m.kind === 'colour' && m.where === 'margin') ? guideMarginRoom() : 0;
      var key = W + '|' + maxH;
      if (key === m.key) return;
      m.key = key; m.w = W;
      root.innerHTML = '';
      /* B5.77: the colour guide has no heading; its names are on the photos. */
      if (m.kind !== 'colour') root.appendChild(guideHead(m.kind, m.g));
      if (m.kind === 'size') guideSizeBody(root, m.g, W);
      else if (m.kind === 'colour') guideColourBody(root, m.g, W, maxH);
      else guideFrameBody(root, m.g, W);
      if (m.where === 'panel' && m.host >= 0) guideFooter(root, m.host);
    }

    /* Sizes: the models standing side by side at their real proportions,
       then a small table of the framed sizes. Each model's column is at
       least as wide as its label; the scale is the largest that fits. */
    function guideSizeBody(root, g, W) {
      var list = guideSizes(g);
      var GAP = 10, LMIN = 46, MAXD = W >= 300 ? 158 : 150;
      var outer = list.map(function (x) { return GUIDE_OUTER[String(x.cm)] || x.cm; });
      var big = outer.reduce(function (a, b) { return Math.max(a, b); }, 1);
      var lo = 0, hi = MAXD / big;
      for (var it = 0; it < 30; it++) {
        var mid = (lo + hi) / 2, tot = GAP * (list.length - 1);
        outer.forEach(function (o) { tot += Math.max(o * mid, LMIN); });
        if (tot <= W) lo = mid; else hi = mid;
      }
      var sc = lo;
      var row = el('div', 'mm-guide-row');
      row.setAttribute('style', 'display:flex;align-items:flex-end;justify-content:center;gap:' + GAP +
        'px;padding:6px 0 2px');
      var cur = st.size ? st.size.id : null;
      list.forEach(function (x, k) {
        var on = x.id === cur;
        var it2 = el('button', 'mm-guide-item' + (on ? ' is-on' : ''));
        it2.type = 'button';
        it2.setAttribute('aria-label', 'Ø ' + x.cm + ' cm' + (on ? ', selected' : ''));
        it2.setAttribute('aria-pressed', on ? 'true' : 'false');
        it2.setAttribute('style', 'flex:none;width:' + Math.max(outer[k] * sc, LMIN).toFixed(1) + 'px;' +
          'display:flex;flex-direction:column;align-items:center;gap:10px;padding:0;margin:0;' +
          'border:0;background:transparent;cursor:pointer;color:inherit;font:inherit');
        it2.appendChild(guideDisc(g.cut, g.spots[String(x.cm)], g.spots.aspect || 1, outer[k] * sc));
        it2.appendChild(guidePill('Ø' + x.cm, on));
        it2.addEventListener('click', function (e) { e.stopPropagation(); if (!on) pickSize(x); });
        row.appendChild(it2);
      });
      root.appendChild(row);
      /* Framed sizes: Kevin's figures. A size he has not given one for just
         shows its diameter. */
      var framed = cfg.sizeGuideFramed || GUIDE_FRAMED;
      var tb = el('div', 'mm-guide-table');
      tb.setAttribute('style', 'display:flex;flex-direction:column;font-size:13px;line-height:1.3');
      function tr(a, b, head, on) {
        var r = el('div', 'mm-guide-tr');
        r.setAttribute('style', 'display:flex;justify-content:space-between;gap:10px;padding:' +
          (head ? '0 0 6px' : '7px 0') + ';border-' + (head ? 'bottom' : 'top') + ':1px solid ' +
          (head ? GUIDE_LINE : 'transparent') + ';' +
          (head ? 'font:600 10.5px/1.2 ' + GUIDE_FONT + ';letter-spacing:.12em;text-transform:uppercase;color:' + MM_LABEL
                : 'color:' + (on ? GUIDE_INK : MM_INK) + ';font-weight:' + (on ? '600' : '500')));
        var l = el('span', '', esc(a)), rr = el('span', '', esc(b));
        rr.setAttribute('style', 'text-align:right;white-space:nowrap;' + (head || on ? '' : 'color:' + MM_LABEL));
        r.appendChild(l); r.appendChild(rr);
        return r;
      }
      tb.appendChild(tr('Map', 'With frame', true));
      list.forEach(function (x, k) {
        var r = tr('Ø ' + x.cm + ' cm', framed[String(x.cm)] || '', false, x.id === cur);
        if (k) r.style.borderTop = '1px solid ' + GUIDE_LINE;
        tb.appendChild(r);
      });
      /* B6.5 (Kevin): the Map / With frame rows are gone; the photos with
         their sizes under them say it. */
      void tb;
    }

    /* Frames: his circle, with a pill for each frame where his graphic puts
       it -- White over the white side, Black over the black, Wood under the
       wood. The pills pick the frame. */
    function guideFrameBody(root, g, W) {
      var list = guideFrames(g);
      var D = Math.round(Math.min(W * 0.64, 200));
      var PH = 26;
      var stage = el('div', 'mm-guide-stage');
      stage.setAttribute('style', 'position:relative;width:' + W + 'px');
      /* On the page before the pills go in, so each pill can be measured. */
      root.appendChild(stage);
      var btn = {};
      list.forEach(function (fr) {
        var on = st.frame === fr.id;
        var b = el('button', 'mm-guide-frame' + (on ? ' is-on' : ''));
        b.type = 'button';
        b.setAttribute('aria-label', fr.name + ' frame' + (on ? ', selected' : ''));
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.setAttribute('style', 'position:absolute;z-index:1;padding:0;margin:0;border:0;' +
          'background:transparent;cursor:pointer;border-radius:8px;' +
          'box-shadow:0 2px 8px rgba(23,24,26,.10)');
        b.appendChild(guidePill(fr.name, on, GUIDE_DOT[fr.id]));
        b.addEventListener('click', function (e) { e.stopPropagation(); if (!on) pickFrame(fr); });
        stage.appendChild(b);
        btn[fr.id] = b;
      });
      function wOf(id) { return btn[id] ? (btn[id].offsetWidth || 72) : 0; }
      var x0 = (W - D) / 2;
      /* Beside the circle, as on his graphic, when there is room for the
         pill to clear the rim; above it, over its own half, in a narrow
         panel. B5.74: the black side is the left of the circle, the white
         the right, the wood the bottom (the list order). */
      var reach = x0 + 0.115 * D - 6;
      var beside = reach >= Math.max(wOf('white'), wOf('black'));
      var top0 = beside ? 0 : PH + 10;
      var disc = guideDisc(g.cut, g.spots.c, g.spots.aspect || 1, D);
      disc.style.position = 'absolute';
      disc.style.left = x0.toFixed(1) + 'px';
      disc.style.top = top0 + 'px';
      stage.insertBefore(disc, stage.firstChild);
      var yPill = beside ? (0.185 * D - PH / 2) : 0;
      if (btn.black) {
        btn.black.style.left = Math.max(0, beside ? reach - wOf('black') : W / 2 - 6 - wOf('black')) + 'px';
        btn.black.style.top = yPill + 'px';
      }
      if (btn.white) {
        btn.white.style.left = Math.min(W - wOf('white'), beside ? W - reach : W / 2 + 6) + 'px';
        btn.white.style.top = yPill + 'px';
      }
      if (btn.wood) {
        btn.wood.style.left = ((W - wOf('wood')) / 2) + 'px';
        btn.wood.style.top = (top0 + D + 10) + 'px';
      }
      stage.style.height = (top0 + D + 10 + PH) + 'px';
      var cap = el('div', 'mm-guide-cap', (IS_TOUCH ? 'Tap' : 'Click') + ' a label to choose it.');
      cap.setAttribute('style', 'font-size:12.5px;color:' + MM_LABEL + ';text-align:center');
      root.appendChild(cap);
    }

    /* B5.73 -- the guide in the page margin, beside its own step.

       Room = the narrower of the two margins beside the board, less a 24px
       gap to the board and 16px to the window edge. Under 220px of card it
       is not worth it, and the panel under the step is used instead. */
    function guideMarginWidth() {
      if (!ui || !ui.board) return 0;
      var br = ui.board.getBoundingClientRect();
      if (!(br.width > 0)) return 0;
      var vw = document.documentElement.clientWidth || window.innerWidth;
      var room = Math.min(br.left, vw - br.right) - 24 - 16;
      return room >= 220 ? Math.min(300, Math.floor(room)) : 0;
    }
    /* On <body>, not in the section: .mm clips anything that pokes out
       sideways, and the margin is exactly that. Made once, kept in step with
       the board as the page moves. */
    function guideMarginBox() {
      var gs = guideState();
      if (gs.box) return gs.box;
      gs.box = el('div', 'mm-guide-side');
      gs.box.setAttribute('style', 'display:none');
      document.body.appendChild(gs.box);
      if (typeof ResizeObserver === 'function') {
        var ro = new ResizeObserver(function () { guideMarginPlace(); });
        ro.observe(document.body);
        if (ui.pdp) ro.observe(ui.pdp);
      }
      window.addEventListener('load', guideMarginPlace);
      return gs.box;
    }
    function placeMarginGuide(kind, seg, w) {
      var gs = guideState();
      if (!kind) {
        if (gs.box) gs.box.style.display = 'none';
        gs.kind = null;
        return;
      }
      var box = guideMarginBox();
      var fresh = gs.kind !== kind || box.style.display === 'none';
      gs.kind = kind; gs.seg = seg; gs.w = w;
      box.innerHTML = '';
      box.setAttribute('style', 'position:absolute;z-index:20;display:block;box-sizing:border-box;' +
        'width:' + w + 'px;left:0;top:0;background:' + MM_SURFACE + ';border:1px solid ' + MM_TRACK +
        ';border-radius:18px;padding:18px;transition:opacity .25s ease;opacity:' + (fresh ? '0' : '1'));
      var g = guideEl(kind, 'margin', -1);
      box.appendChild(g);
      guideLayout(g);
      guideMarginPlace();
      if (fresh) requestAnimationFrame(function () { box.style.opacity = '1'; });
    }
    /* B5.77: height the colour guide may use beside its step: down to the
       bottom of that step's card, less the margin card's padding/border. */
    function guideMarginRoom() {
      var gs = guideState();
      if (!ui || !ui.cards || !ui.cards[gs.seg]) return 0;
      var cr = ui.cards[gs.seg].el.getBoundingClientRect();
      var h = Math.floor(cr.height - 38);
      return h > 120 ? h : 0;
    }
    function guideMarginPlace() {
      var gs = guideState(), box = gs.box;
      if (!box || !gs.kind || box.style.display === 'none' || !ui.cards[gs.seg]) return;
      var br = ui.board.getBoundingClientRect();
      var cr = ui.cards[gs.seg].el.getBoundingClientRect();
      var left = (gs.seg % 2 === 0) ? br.left - 24 - gs.w : br.right + 24;
      /* Page coordinates, whether or not the theme positions <body>. */
      var ox, oy, bs = window.getComputedStyle(document.body).position;
      if (bs === 'static') { ox = window.pageXOffset; oy = window.pageYOffset; }
      else { var bb = document.body.getBoundingClientRect(); ox = -bb.left; oy = -bb.top; }
      box.style.left = Math.round(left + ox) + 'px';
      /* B5.77: never past the bottom of the step's card -- lift it instead. */
      var top = cr.top, bh = box.offsetHeight;
      if (bh && top + bh > cr.bottom + 1) top = Math.max(br.top, cr.bottom - bh);
      box.style.top = Math.round(top + oy) + 'px';
    }

    /* In a side panel that belongs to a finished step, its answer stays in
       view under the guide, with the way back. */
    function guideFooter(root, host) {
      if (!st.done[host]) return;
      var name = SEGMENTS[host];
      var val = name === 'Size' ? (st.size ? 'Ø ' + st.size.cm + ' cm' : '')
              : name === 'Frame' ? ((FRAMES.filter(function (x) { return x.id === st.frame; })[0] || {}).name || '')
              : name === 'Colour' ? cwObj().name
              : '';
      if (!val) return;
      var f = el('button', 'mm-guide-done');
      f.type = 'button';
      f.setAttribute('style', 'display:flex;align-items:center;gap:8px;width:100%;box-sizing:border-box;' +
        'margin-top:2px;padding:10px 0 0;border:0;border-top:1px solid ' + GUIDE_LINE + ';' +
        'background:transparent;cursor:pointer;text-align:left;font:500 13px/1.3 ' + GUIDE_FONT +
        ';color:' + MM_INK);
      f.innerHTML = '<span style="width:18px;height:18px;border-radius:50%;flex:none;display:flex;' +
        'align-items:center;justify-content:center;background:' + MM_DONE_BG + ';color:' + MM_INK + ';' +
        'font:700 11px/1 ' + GUIDE_FONT + '">✓</span>' +
        '<span style="flex:1;min-width:0">' + esc(name) + ': <b style="font-weight:600">' + esc(val) +
        '</b></span><span style="color:' + MM_INK + ';font-weight:600;text-decoration:underline;' +
        'text-underline-offset:3px">Change</span>';
      f.addEventListener('click', function (e) { e.stopPropagation(); st.seg = host; sync(); });
      root.appendChild(f);
    }

    /* What a step that has not been reached yet says about itself. Enough to
       show it is coming and roughly what it asks, without stating a value the
       customer has not chosen. */
    /* What a step that is not open yet says about itself.

       It used to preview the options -- "\u00D8 15 \u00b7 \u00D8 20 \u00b7 \u00D8 40" -- on a
       card that is dimmed and refuses every click. A greyed-out list of things
       you cannot pick is ambiguous: broken, loading, or not yet? So a locked
       step now names the one thing standing in its way, which is the only
       information the customer can act on. This is the instruction manual,
       written into the place it is needed rather than at the top of the page. */
    function teaser(i) {
      if (!areaOk()) return 'Choose your area first';
      var need = SEGMENTS[i - 1];
      return need ? 'Pick a ' + need.toLowerCase() + ' first' : '';
    }

    /* The three steps that are not open, as chips above the sheet. Phone only:
       four cards stacked is what pushed the page past one screen. */
    function paintChips() {
      { ui.chips.innerHTML = ''; return; }      /* B6.1: no chips anywhere */
      var gate = areaOk(), open0 = firstOpen();
      ui.chips.innerHTML = '';
      SEGMENTS.forEach(function (name, i) {
        var open = gate && i === st.seg && !segFinished(i);
        var usable = gate && i <= open0;
        var b = el('button', 'mm-chip',
          '<span style="font-weight:600">' + (st.done[i] && !open ? '✓' : (i + SEG_N0)) +
          '</span> ' + esc(name));
        b.type = 'button';
        b.setAttribute('style',
          'flex:1;min-width:0;border-radius:8px;cursor:' + (usable ? 'pointer' : 'default') + ';' +
          'padding:7px 4px;font:500 11.5px/1.1 ' + MM_FACE + ';box-sizing:border-box;' +
          'white-space:nowrap;overflow:hidden;text-overflow:ellipsis;' +
          'border:1px solid ' + (open ? MM_FOCUS : MM_TRACK) + ';' +
          'background:' + (open ? MM_FOCUS : (st.done[i] ? MM_DONE_BG : MM_SURFACE)) + ';' +
          'color:' + (open ? '#fff' : (st.done[i] ? MM_INK : MM_LABEL)) + ';' +
          'opacity:' + (usable ? '1' : '.45'));
        b.addEventListener('click', function () {
          if (!usable) {
            if (!st.nudgeDone) {                     // B5.67: first pass only
              if (!gate) {
                flash(ui.banner);
              } else {
                flash(ui.cards[st.seg].el);
                flash(b, 'mm-why');
                flash(b, 'mm-whycard');
              }
            }
            return;
          }
          st.seg = i; sync();
        });
        /* Kevin, on the first version: the cue was on the card, and on a phone
           the card for the step you are being pointed at is the one collapsed
           out of sight, so the pulse happened where nobody could see it. The
           chip is the only part of a step that is on screen at every moment,
           so the chip is what pulses. */
        if (i === cuedSeg && Date.now() - cuedAt < CUE_MS) b.classList.add('mm-attn');
        ui.chips.appendChild(b);
      });
    }

    /* Which step last had the cue, so it fires on the change and not on every
       repaint -- and so exactly one thing on the page has just moved. */
    var cuedSeg = -2, cuedAt = 0;
    /* B6.0, phone: the step whose Compare panel was last opened for it. */
    var cmpSeg = -1;
    /* Twice through a 1.25s animation. Setting the area fires sync() and then
       layout() a frame later, and layout() rebuilds the chips -- so a cue
       applied on the edge alone was created and destroyed within one frame,
       which is exactly the 1 -> 2 handover Kevin says is the one that matters.
       A window, not an edge: any chip built inside it carries the cue. */
    var CUE_MS = 2600;
    function paintCards() {
      var big = wideBoard();
      var gate = areaOk();
      var open0 = firstOpen();
      var live = st.stage === 'cfg';
      var liveSeg = gate && !segFinished(st.seg) ? st.seg : -1;
      var cueNow = liveSeg !== cuedSeg;
      if (cueNow) { cuedSeg = liveSeg; cuedAt = Date.now(); }
      paintChips();
      paintSum(live);                                   /* B7.5.0 */
      ui.cards.forEach(function (card, i) {
        if (card.sheetGuide) {
          if (card.sheetGuide.parentNode) card.sheetGuide.parentNode.removeChild(card.sheetGuide);
          card.sheetGuide = null;
        }
        card.hosting = null;
        if (cueNow) {
          card.el.classList.remove('mm-attn');
          card.lab.classList.remove('mm-attn');
          card.lab.classList.remove('mm-attn-pill');
        }
        /* B6.1: every screen, every step open. The rest is the old phone
           sheet, kept for reference but no longer reached. */
        paintWideCard(card, i, live); return;

        var usable = gate && i <= open0;
        var fin = segFinished(i);
        var open = gate && i === st.seg && !fin;
        var tappable = usable && !fin;
        /* On a phone only the open step is in the sheet; the rest are chips --
           except the finished step five, which is what the sheet shows once the
           model is there, rather than nothing at all. */
        if (!open && !(fin && st.seg === i)) {
          card.el.setAttribute('style', 'display:none'); return;
        }
        if (card.val.parentNode === card.top) card.el.insertBefore(card.val, card.opts);
        card.top.style.display = 'flex';
        card.chg.style.display = 'none';
        card.el.setAttribute('style',
          'border:0;border-radius:0;box-sizing:border-box;min-width:0;background:' + MM_SURFACE + ';' +
          'box-shadow:none;padding:2px 0 0;flex-direction:column;gap:9px;justify-content:flex-start;' +
          'align-items:stretch;text-align:left;display:flex;' +
          'cursor:' + (tappable ? 'pointer' : 'default') + ';' +
          'pointer-events:' + (fin ? 'none' : 'auto') + ';' +
          'opacity:' + (usable ? '1' : '.45') + ';transition:opacity .2s');
        var kind = open ? 'now' : (st.done[i] ? 'done' : 'todo');
        var fresh = stepBadge((st.done[i] && !open) ? '\u2713' : String(i + SEG_N0), kind, false);
        card.top.replaceChild(fresh, card.num);
        card.num = fresh;
        card.lab.setAttribute('style',
          'font:600 15px/1.15 ' + MM_FACE + ';letter-spacing:.01em;color:' + (usable ? MM_INK : MM_LABEL));
        card.val.setAttribute('style',
          'font-size:13.5px;color:' + MM_LABEL + ';min-height:1.2em;line-height:1.4');
        card.opts.style.display = open ? 'flex' : 'none';
        card.opts.style.flexDirection = 'column';
        card.opts.style.gap = '10px';
        card.note.style.display = 'none';
        card.opts.innerHTML = '';
        fillCard(i, card, open);
        if (!usable) card.val.textContent = teaser(i);
        paintNav(i, card, open, false);
      });
      /* The B5.73 page-margin guide is retired with the corner layout. */
      placeMarginGuide(null);
      paintStepMarks();     /* B6.3 */
    }

    /* B6.0, wide: one section of the panel per step, separated by a line.
       Before a render every step is open; after one they fold to a line
       each (badge, name, value, Change) so the total and Add to cart are on
       screen, and Change opens one again. */
    /* B7.5.0: once a model is made, place and choices read as one line with one Edit. Edit brings back the
       per-step rows (each with Change); a new build folds them again. */
    function sumMode() { return st.stage === 'cfg' && st.rendered && !st.building && !st.sumEdit && !ETSY && !wideBoard(); }   /* B7.5.3: desktop keeps the rows */
    function paintSum(live) {
      if (!ui.sumLine) {
        ui.sumLine = el('div', 'mm-sumline');
        ui.sumTxt = el('span', 'mm-sum-t', '');
        ui.sumEdit = el('button', 'mm-sum-edit', 'Edit');
        ui.sumEdit.type = 'button';
        ui.sumEdit.addEventListener('click', function (e) { e.stopPropagation(); st.sumEdit = true; sync(); });
        ui.sumLine.appendChild(ui.sumTxt); ui.sumLine.appendChild(ui.sumEdit);
      }
      var c0 = ui.cards[0] && ui.cards[0].el;
      if (c0 && c0.parentNode && ui.sumLine.nextSibling !== c0) c0.parentNode.insertBefore(ui.sumLine, c0);
      var on = sumMode(), ph = !wideBoard();
      var fr = FRAMES.filter(function (x) { return x.id === st.frame; })[0];
      var bits = [st.placeName || fmtCoord(st.center.lat, st.center.lon)];
      if (st.size) bits.push('\u00D8 ' + st.size.cm + ' cm');
      if (fr) bits.push(fr.name);
      bits.push(cwObj().name);
      if (labelIsOn()) bits.push('Label');
      ui.sumTxt.textContent = bits.join(' \u00B7 ');
      ui.sumLine.setAttribute('style', on
        ? 'display:flex;align-items:center;gap:12px;width:100%;box-sizing:border-box;padding:' + (ph ? '14px 14px' : '4px 0 16px') + ';' +
          (ph ? 'background:' + MM_SURFACE + ';border:1px solid ' + MM_LINE + ';border-radius:14px' : 'border:0')
        : 'display:none');
      ui.sumTxt.setAttribute('style', 'flex:1;min-width:0;font:600 ' + (ph ? '15.5px' : '15px') + '/1.35 ' + MM_FACE + ';color:' + MM_INK);
      ui.sumEdit.setAttribute('style', 'flex:none;margin:0;padding:6px 0 6px 6px;border:0;background:none;cursor:pointer;' +
        'font:600 ' + (ph ? '15.5px' : '14px') + '/1 ' + MM_FACE + ';color:' + MM_INK + ';text-decoration:underline;' +
        'text-underline-offset:3px;text-decoration-color:' + MM_TRACK);
      if (on && ui.banner) ui.banner.style.display = 'none';
      paintMailme();
    }

    /* B7.5.0: "Email me my design". Unticked; the email field opens when ticked. Sends the render email
       (the same one the old email gate sent) and, because they ticked it, they join the follow-ups. */
    var MAILME_CONSENT = 'Email me my design. Also send me a few reminders about it. Unsubscribe any time.';
    function paintMailme() {
      if (!ui.mailme) {
        var m = el('div', 'mm-mailme');
        m.innerHTML =
          '<label class="mm-mailme-row" style="display:flex;align-items:center;gap:10px;cursor:pointer;' +
            'font:600 15px/1.3 ' + MM_FACE + ';color:' + MM_INK + '">' +
            '<input type="checkbox" class="mm-mailme-chk" style="flex:none;width:19px;height:19px;margin:0;' +
            'accent-color:' + MM_ACCENT + ';cursor:pointer">Email me my design</label>' +
          '<form class="mm-mailme-form" novalidate style="display:none;gap:8px;margin:10px 0 0">' +
            '<input type="email" class="mm-mailme-in" autocomplete="email" placeholder="Your email" aria-label="Your email" ' +
            'style="flex:1;min-width:0;box-sizing:border-box;height:46px;padding:0 14px;border:1px solid ' + MM_TRACK + ';' +
            'border-radius:8px;font:400 16px/1.2 ' + MM_FACE + ';color:' + MM_INK + ';background:#fff">' +
            '<button type="submit" class="mm-mailme-go" style="flex:none;height:46px;padding:0 18px;border:1px solid ' + MM_INK + ';' +
            'border-radius:8px;background:' + MM_INK + ';color:#fff;font:600 15px/1 ' + MM_FACE + ';cursor:pointer">Send</button>' +
          '</form>' +
          '<p class="mm-mailme-note" style="display:none;margin:8px 0 0;font:400 12.5px/1.4 ' + MM_FACE + ';color:' + MM_LABEL + '">' +
            'We\u2019ll email your design and a few reminders about it. Unsubscribe any time.</p>' +
          '<p class="mm-mailme-done" role="status" style="display:none;margin:0;font:600 15px/1.35 ' + MM_FACE + ';color:#1C7A45"></p>';
        var chk = m.querySelector('.mm-mailme-chk'), form = m.querySelector('form'), inp = m.querySelector('.mm-mailme-in');
        var note = m.querySelector('.mm-mailme-note'), doneP = m.querySelector('.mm-mailme-done');
        chk.addEventListener('change', function () {
          form.style.display = chk.checked ? 'flex' : 'none';
          note.style.display = chk.checked ? 'block' : 'none';
          if (chk.checked) { try { inp.focus({ preventScroll: true }); } catch (e) {} }
        });
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var v = String(inp.value || '').trim();
          if (!/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(v)) {
            note.textContent = 'Please check your email address.';
            note.style.color = '#B42318';
            try { inp.focus(); } catch (e2) {}
            return;
          }
          st.email = v.toLowerCase();
          st.optIn = true;
          st.optInText = MAILME_CONSENT;
          st.mailmeDone = true;
          submitEmail(st.email);
          if (st.lastShot) { st.emailSent = false; sendRender(st.lastShot); }
          m.querySelector('.mm-mailme-row').style.display = 'none';
          form.style.display = 'none';
          note.style.display = 'none';
          doneP.textContent = 'Sent to ' + st.email + '. Check your inbox.';
          doneP.style.display = 'block';
        });
        ui.mailme = m;
      }
      var show = st.stage === 'cfg' && st.rendered && !st.building && !ETSY && !!cfg.renderEmailUrl && !!ui.addBtn;
      ui.mailme.setAttribute('style', show
        ? 'display:block;width:100%;box-sizing:border-box;margin:' + (wideBoard() ? '14px 0 0' : '12px 0 0') +
          ';padding:14px 16px;border:1px solid ' + MM_LINE + ';border-radius:10px;background:' + MM_SURFACE
        : 'display:none');
      if (!show) return;
      var b = ui.addBtn, nx = b.nextElementSibling;
      var anchor = (nx && /mm-promise-line/.test(nx.className || '')) ? nx : b;
      if (anchor.parentNode && anchor.nextSibling !== ui.mailme) anchor.parentNode.insertBefore(ui.mailme, anchor.nextSibling);
    }

    function paintWideCard(card, i, live) {
      var last = i === SEGMENTS.length - 1;
      /* B7.5.0: folded into the one line; on a phone the empty Preview card after a model goes too */
      if (sumMode() && (!last || !wideBoard())) {
        card.el.setAttribute('style', 'display:none');
        /* B7.5.1: the Preview card is where a phone's Cancel is hidden after a build; folded, that never ran. */
        if (last && ui.cancelBtn) ui.cancelBtn.style.display = 'none';
        return;
      }
      var ph = !wideBoard();
      var openW = !last && !st.building && (!live || st.wideOpen === i);
      card.el.setAttribute('style', ph
        /* B6.3: a white card per step. The number sits on its left edge:
           the top row reaches back past the padding to put it there. */
        ? 'display:flex;flex-direction:column;gap:12px;box-sizing:border-box;min-width:0;position:relative;' +
          'background:' + MM_SURFACE + ';border:1px solid ' + MM_LINE + ';border-radius:14px;box-shadow:none;' +
          'padding:14px 12px 16px 28px;cursor:default;pointer-events:auto;opacity:1;text-align:left;' +
          'align-items:stretch'
        : 'display:flex;flex-direction:column;gap:12px;box-sizing:border-box;min-width:0;' +
          'background:transparent;border:0;border-top:1px solid ' + MM_LINE +
          ';border-radius:0;box-shadow:none;padding:' + (last ? '20px 0 2px' : '18px 0') +
          ';cursor:default;pointer-events:auto;opacity:1;text-align:left;align-items:stretch');
      card.top.style.marginLeft = ph ? '-47px' : '';
      card.top.style.gap = ph ? '12px' : '10px';
      /* B6.1: on a phone step 5 has a heading like the others ("Preview"),
         because the step bar names it. */
      card.top.style.display = ((last && !ph) || (!ph && !live && SEGMENTS[i] === 'Name label')) ? 'none' : 'flex';   /* B7.5.0 */
      if (last) card.lab.textContent = 'Preview';
      if (!last || ph) {
        if (ph) {
          if (!card.snum) card.snum = el('span', 'mm-snum', '');
          if (card.num !== card.snum) { card.top.replaceChild(card.snum, card.num); card.num = card.snum; }
          paintSnum(card.snum, phoneSteps()[i + 1], String(i + SEG_N0));
        } else {
          var doneB = live && (!last || (st.rendered && !st.building));
          var fresh = stepBadge(doneB ? '\u2713' : String(i + SEG_N0), doneB ? 'done' : 'now', true);
          card.top.replaceChild(fresh, card.num);
          card.num = fresh;
        }
        card.lab.setAttribute('style', 'flex:none;font:700 ' + (ph ? '19px' : '16.5px') + '/1.15 ' + MM_FACE +
          ';color:' + MM_INK);
      }
      if (!last) {
        card.val.setAttribute('style', 'flex:1;min-width:0;text-align:right;font-size:' + (ph ? '15.5px' : '14.5px') +
          ';line-height:1.3;color:' + (ph ? MM_INK : MM_LABEL) + ';white-space:nowrap;overflow:hidden;' +
          'text-overflow:ellipsis');
        if (card.val.parentNode !== card.top) card.top.insertBefore(card.val, card.chg);
      } else {
        card.val.setAttribute('style', 'font-size:' + (ph ? '16px' : '14px') + ';line-height:1.4;color:' +
          (ph ? MM_INK : MM_LABEL));
      }
      var showChg = !last && live && !st.building;
      card.chg.style.display = showChg ? 'inline-flex' : 'none';
      card.chg.textContent = st.wideOpen === i ? 'Done' : 'Change';
      card.chg.style.fontSize = ph ? '15.5px' : '14px';
      card.chg.style.padding = ph ? '12px 0 12px 12px' : '6px 0 6px 6px';
      card.note.style.fontSize = ph ? '15px' : '';
      card.opts.innerHTML = '';
      card.opts.style.display = (openW || last) ? 'flex' : 'none';
      card.opts.style.flexDirection = 'column';
      card.opts.style.gap = '10px';
      card.note.style.display = 'none';
      card.nav.style.display = 'none';
      fillCard(i, card, openW || last);
      paintNextHint(card, i, live);
    }

    /* B6.3, phones: one state per number -- place, size, frame, colour,
       preview. Done once a choice in the step is tapped or the step has
       been scrolled past; a default alone does not count. Once you have
       pressed See my 3D preview, steps 1 to 4 are done. The first step not
       done is the one you are on. */
    function phoneSteps() {
      var live = st.stage === 'cfg', built = live && st.rendered && !st.building;
      var sd = st.stepDone || [];
      var done = [live || areaOk() || !!st.placeSeen];
      for (var q = 0; q < GEN(); q++) done.push(live || !!sd[q]);
      done.push(built);
      var cur = done.indexOf(false);
      return done.map(function (d, k) { return d ? 'done' : (k === cur ? 'now' : 'todo'); });
    }
    function markStep(i) {
      if (!st.stepDone) st.stepDone = falses(GEN());
      if (i < 0 || i >= GEN() || st.stepDone[i]) return;
      st.stepDone[i] = true;
      requestAnimationFrame(paintStepMarks);
    }
    /* Scrolled past: the card's bottom edge has gone up into the top third
       of the screen, so the reader is on the next one. */
    function markPassed() {
      if (wideBoard() || st.stage === 'cfg' || !ui.cards) return false;
      var hb = hdrBottom(), vh = window.innerHeight || 0;
      var line = hb + Math.max(0, vh - hb) * 0.3, ch = false;
      if (!st.placeSeen && !areaOk()) {
        var ra = ui.arena.getBoundingClientRect();
        if (ra.height && ra.bottom < line) { st.placeSeen = true; ch = true; }
      }
      if (!st.stepDone) st.stepDone = falses(GEN());
      for (var k = 0; k < GEN(); k++) {
        if (st.stepDone[k]) continue;
        var r = ui.cards[k].el.getBoundingClientRect();
        if (r.height && r.bottom < line) { st.stepDone[k] = true; ch = true; }
      }
      return ch;
    }
    function paintStepMarks() {
      if (!ui || !ui.cards) return;
      if (!wideBoard()) {
        var kk = phoneSteps();
        paintSnum(ui.bNum, kk[0], '1');
        ui.cards.forEach(function (c, i) {
          if (c.snum && c.num === c.snum) paintSnum(c.snum, kk[i + 1], String(i + SEG_N0));
        });
      }
      paintRail();
    }
    var RAIL_KEY = '';
    function paintRail() {
      var R = ui && ui.rail;
      if (!R) return;
      if (wideBoard()) {
        if (R.style.display !== 'none') R.setAttribute('style', 'display:none');
        RAIL_KEY = '';
        return;
      }
      try {
        var pr = ui.panel.getBoundingClientRect(), cs = [];
        for (var k = 0; k < ui.cards.length; k++) {
          var b = ui.cards[k].num.getBoundingClientRect();
          if (!b.height) {
            if (R.style.display !== 'none') R.setAttribute('style', 'display:none');
            RAIL_KEY = '';
            return;
          }
          cs.push(Math.round(b.top + b.height / 2 - pr.top));
        }
        var cur = phoneSteps().indexOf('now');
        var top = cs[0], h = cs[cs.length - 1] - top;
        var f = cur < 0 ? h : (cur <= 1 ? 0 : cs[cur - 1] - top);
        var key = top + '|' + h + '|' + f;
        if (key === RAIL_KEY) return;
        RAIL_KEY = key;
        R.setAttribute('style', 'position:absolute;z-index:1;left:16px;top:' + top + 'px;width:4px;' +
          'height:' + h + 'px;border-radius:4px;background:' + MM_LINE + ';pointer-events:none;display:block');
        ui.railFill.style.height = f + 'px';
      } catch (e) {}
    }

    /* B6.2, phones: where to go next, said once at the end of a step and
       nowhere else. Plain text and a small arrow that nudges once when it
       first comes into view; tapping it glides to the next step, and simply
       scrolling on works just as well. */
    var HINT_IO = null;
    function paintNextHint(card, i, live) {
      var last = i === SEGMENTS.length - 1;
      var want = false;   /* B6.3: retired; the numbers lead the way */
      if (!card.hint) {
        if (!want) return;
        var h = el('button', 'mm-next-hint', '');
        h.type = 'button';
        h.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          if (!areaOk()) { st.areaDone = true; sync(); }
          if (i === 0) warmNow('size chosen');
          revealSection(i + 2);
        });
        card.hint = h;
        try {
          if (typeof IntersectionObserver === 'function') {
            if (!HINT_IO) {
              HINT_IO = new IntersectionObserver(function (ents) {
                ents.forEach(function (en) {
                  if (en.isIntersecting && !en.target.__mmSeen) {
                    en.target.__mmSeen = true;
                    en.target.classList.add('is-seen');
                  }
                });
              }, { threshold: 1 });
            }
            HINT_IO.observe(h);
          }
        } catch (eI) {}
      }
      var hn = card.hint;
      if (hn.parentNode !== card.el) card.el.appendChild(hn);
      if (!want) { hn.style.display = 'none'; return; }
      hn.innerHTML = '<span>Next: ' + esc(secName(i + 2)) + '</span>' +
        '<svg class="mm-next-hint-a" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
        'stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="M12 5v14M6 13l6 6 6-6"></path></svg>';
      hn.setAttribute('style', 'display:flex;align-items:center;justify-content:center;gap:8px;width:100%;' +
        'box-sizing:border-box;margin:2px 0 0;padding:12px 0 2px;border:0;border-radius:0;background:none;' +
        'cursor:pointer;color:' + MM_INK + ';font:600 16px/1.2 ' + MM_FACE + ';-webkit-tap-highlight-color:transparent');
    }

    /* Back and Next, phone only. B6.0: the bar sticks to the bottom of the
       screen while its step is on it, with the running total between the
       two, so Next is never a scroll away. On the last step the Generate
       button takes Next's place (fillCard puts it in the bar). */
    function paintNav(i, card, open, big) {
      if (!open || big) { card.nav.style.display = 'none'; return; }
      card.nav.setAttribute('style', 'display:flex;gap:10px;align-items:center;' +
        'position:-webkit-sticky;position:sticky;bottom:0;z-index:6;margin:6px -16px 0;' +
        'padding:10px 16px calc(10px + env(safe-area-inset-bottom));background:' + MM_SURFACE +
        ';border-top:1px solid ' + MM_LINE + ';box-shadow:0 -8px 20px rgba(18,20,23,.06)');
      var canBack = i > 0;
      card.back.setAttribute('style',
        'flex:none;display:' + (canBack ? 'flex' : 'none') + ';align-items:center;' +
        'justify-content:center;width:44px;height:46px;border-radius:8px;border:1px solid ' + MM_TRACK +
        ';background:' + MM_SURFACE + ';color:' + MM_INK + ';cursor:pointer;font:400 19px/1 ' + MM_FACE);
      card.navPrice.innerHTML = (st.size && !ETSY)
        ? '<span style="display:block;font:500 11.5px/1.2 ' + MM_FACE + ';color:' + MM_LABEL + '">Total</span>' +
          '<span style="display:block;font:700 17px/1.2 ' + MM_FACE + ';color:' + MM_INK + '">' +
          esc(money(totalCents(), cfg.moneyFormat)) + '</span>'
        : '';
      card.navPrice.setAttribute('style', 'flex:1;min-width:0');
      if (i === SEGMENTS.length - 1) { card.next.style.display = 'none'; return; }
      card.next.textContent = 'Next: ' + SEGMENTS[i + 1] + ' \u203A';
      card.next.setAttribute('style',
        'flex:none;display:block;border:0;border-radius:8px;background:' + MM_FOCUS +
        ';color:#fff;cursor:pointer;box-sizing:border-box;min-height:46px;padding:12px 18px;' +
        'font:600 15px/1.15 ' + MM_FACE + ';white-space:nowrap');
    }

    /* B6.0: options as tiles in one row -- three sizes, three frames, two
       finishes -- on a phone as well as on a wide screen. Selected = blue
       edge on a faint blue face; the edge is drawn with an inset shadow so
       picking never shifts the layout by a pixel. */
    function optTile(o) {
      var big = wideBoard();
      var ph = !big;
      var b = el('button', 'mm-tile');
      b.type = 'button';
      b.setAttribute('aria-pressed', o.on ? 'true' : 'false');
      var common = 'position:relative;width:100%;min-width:0;box-sizing:border-box;margin:0;cursor:pointer;' +
        'border-radius:12px;color:' + MM_INK + ';border:1px solid ' + (o.on ? MM_ACCENT : MM_TRACK) + ';' +
        'box-shadow:' + (o.on ? 'inset 0 0 0 1px ' + MM_ACCENT : 'none') + ';' +
        'background:' + (o.on ? '#F5F8FE' : MM_SURFACE) + ';font-family:' + MM_FACE + ';' +
        'transition:border-color .14s,background .14s,box-shadow .14s;';
      if (o.stack) {
        b.setAttribute('style', common + 'display:flex;flex-direction:column;align-items:center;' +
          'justify-content:center;gap:3px;text-align:center;min-height:' + (big ? 96 : 104) + 'px;' +
          'padding:' + (big ? '10px 6px' : '10px 3px'));
        b.innerHTML =
          '<span style="font:700 ' + (big ? '16.5' : '17') + 'px/1.15 ' + MM_FACE + ';white-space:nowrap">' +
            esc(o.label) + '</span>' +
          (o.sub ? '<span class="mm-tile-sub" style="font:500 ' + (big ? '12.5' : '15') + 'px/1.25 ' + MM_FACE +
            ';color:' + (big ? MM_LABEL : '#3F444C') + (big ? '' : ';white-space:nowrap') + '">' +
            esc(o.sub) + '</span>' : '') +
          (o.extra ? '<span style="margin-top:3px;font:700 ' + (big ? '15.5' : '17') + 'px/1.1 ' + MM_FACE + '">' +
            esc(o.extra) + '</span>' : '');
      } else if (ph && o.narrow) {
        /* B6.1: three across on a phone has no room for a picture beside
           the name, so the picture goes on top. */
        b.setAttribute('style', common + 'display:flex;flex-direction:column;align-items:center;' +
          'justify-content:center;gap:8px;text-align:center;min-height:96px;padding:12px 6px');
        b.appendChild(mediaBox(o.mediaKind, o.media, o.mediaKind === 'img' ? 44 : 34, o.badge));
        var nl = el('span', 'mm-tile-txt', esc(o.label));
        nl.setAttribute('style', 'font:600 16.5px/1.15 ' + MM_FACE + ';white-space:nowrap');
        b.appendChild(nl);
      } else if (ph) {
        /* B6.1: a phone lets the name and its line wrap rather than cut. */
        b.setAttribute('style', common + 'display:flex;align-items:center;gap:10px;text-align:left;' +
          'min-height:68px;padding:10px 12px');
        b.appendChild(mediaBox(o.mediaKind, o.media, o.mediaKind === 'img' ? 44 : 34, o.badge));
        var tp = el('span', 'mm-tile-txt');
        tp.setAttribute('style', 'flex:1;min-width:0;display:flex;flex-direction:column;gap:3px');
        tp.innerHTML =
          '<span style="font:600 16.5px/1.2 ' + MM_FACE + '">' + esc(o.label) + '</span>' +
          (o.sub ? '<span style="font:500 15px/1.25 ' + MM_FACE + ';color:#3F444C">' + esc(o.sub) + '</span>' : '') +
          (o.extra ? '<span style="font:700 15px/1.2 ' + MM_FACE + '">' + esc(o.extra) + '</span>' : '');
        b.appendChild(tp);
      } else {
        b.setAttribute('style', common + 'display:flex;align-items:center;gap:9px;text-align:left;' +
          'min-height:56px;padding:8px 10px');
        b.appendChild(mediaBox(o.mediaKind, o.media, o.mediaKind === 'img' ? 40 : 30, o.badge));
        var tx = el('span', 'mm-tile-txt');
        tx.setAttribute('style', 'flex:1;min-width:0;display:flex;flex-direction:column;gap:2px');
        tx.innerHTML =
          '<span style="font:600 14.5px/1.2 ' + MM_FACE + ';white-space:nowrap;overflow:hidden;' +
            'text-overflow:ellipsis">' + esc(o.label) + '</span>' +
          (o.sub ? '<span style="font:500 12px/1.25 ' + MM_FACE + ';color:' + MM_LABEL + ';white-space:nowrap;' +
            'overflow:hidden;text-overflow:ellipsis">' + esc(o.sub) + '</span>' : '');
        b.appendChild(tx);
        if (o.extra) {
          var x = el('span', 'mm-tile-x', esc(o.extra));
          x.setAttribute('style', 'flex:none;font:600 12.5px/1.2 ' + MM_FACE + ';color:' + MM_LABEL);
          b.appendChild(x);
        }
      }
      /* B6.1: the chosen one carries a tick as well as the blue edge, so it
         does not depend on telling two shades apart. */
      if (o.on) {
        var tk = el('span', 'mm-tick',
          '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.4" ' +
          'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"></path></svg>');
        tk.setAttribute('style', 'position:absolute;top:-7px;right:-7px;width:22px;height:22px;border-radius:50%;' +
          'background:' + MM_ACCENT + ';color:#fff;display:flex;align-items:center;justify-content:center;' +
          'box-shadow:0 0 0 2px ' + MM_SURFACE + ';pointer-events:none;z-index:1');
        b.appendChild(tk);
      }
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        /* B7.1.0 (speed): show the tap first, then do the work. Re-laying out
           every step took 45-90 ms on a laptop and several times that on a
           phone, and the screen showed nothing until it was done (Google's
           INP was 437 ms). Now the tile turns blue in the next frame and the
           rest follows straight after. */
        if (o.on) return o.onClick();
        if (b.__mmBusy) return;
        b.__mmBusy = true;
        b.style.borderColor = MM_ACCENT;
        b.style.boxShadow = 'inset 0 0 0 1px ' + MM_ACCENT;
        requestAnimationFrame(function () {
          setTimeout(function () { b.__mmBusy = false; o.onClick(); }, 0);
        });
      });
      return b;
    }
    /* B6.5 (Kevin): the line under each size ("750 m across") on one line.
       Shrinks only as far as it must, 15px down to 12.5px, the same on every
       tile; if even that is too wide (a long figure on a small phone) it is
       allowed to wrap rather than be cut. */
    function fitTileSubs(g) {
      try {
        if (!g || !g.isConnected) return;
        var subs = g.querySelectorAll('.mm-tile-sub');
        if (!subs.length) return;
        var px = 15, fits = false;
        for (; px >= 12.5; px -= 0.5) {
          fits = true;
          for (var k = 0; k < subs.length; k++) {
            var sp = subs[k], t = sp.parentNode;
            sp.style.whiteSpace = 'nowrap';
            sp.style.fontSize = px + 'px';
            var cs = getComputedStyle(t);
            var room = t.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
            if (sp.getBoundingClientRect().width > room + 0.5) fits = false;
          }
          if (fits) break;
        }
        if (!fits) {
          for (var j = 0; j < subs.length; j++) { subs[j].style.whiteSpace = 'normal'; subs[j].style.fontSize = '13px'; }
        }
        if (document.fonts && document.fonts.status !== 'loaded' && !g.__mmFontWait) {
          g.__mmFontWait = true;
          document.fonts.ready.then(function () { fitTileSubs(g); });
        }
      } catch (e) {}
    }

    /* B6.5: the finish photos as the choice itself. CW_STYLE picks the
       layout: 'A' two photo cards side by side, name and line under each;
       'B' wide photo cards one above the other; 'C' the photo is the whole
       button, the name on it. */
    var CW_STYLE = 'A';
    function colourPhotoTiles(card, list, prices, cheapest, i) {
      var sty = window.__mmCW || (list.length === 1 ? 'B' : CW_STYLE);
      var g = el('div', 'mm-optgrid mm-cwgrid');
      g.setAttribute('style', 'display:grid;grid-template-columns:' +
        (sty === 'B' ? 'minmax(0,1fr)' : 'repeat(2,minmax(0,1fr))') + ';gap:10px;width:100%');
      card.opts.appendChild(g);
      list.forEach(function (p) {
        var cw = p.cw, k = COLOURWAYS.indexOf(cw), on = st.colourway === cw.id;
        var dd = (prices[k] || 0) - cheapest;
        var extra = (dd > 0 && !ETSY) ? '+' + money(dd, cfg.moneyFormat) : '';
        var sub = CW_SUB[cw.id] || '';
        var url = String(p.url).replace(/"/g, '%22');
        var b = el('button', 'mm-tile mm-cwtile');
        b.type = 'button';
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.setAttribute('aria-label', cw.name + (sub ? ', ' + sub : '') + (extra ? ', ' + extra : ''));
        var edge = 'border:1px solid ' + (on ? MM_ACCENT : MM_TRACK) + ';box-shadow:' +
          (on ? 'inset 0 0 0 1px ' + MM_ACCENT : 'none') + ';';
        var base = 'position:relative;display:flex;width:100%;min-width:0;box-sizing:border-box;margin:0;' +
          'cursor:pointer;text-align:left;color:' + MM_INK + ';font-family:' + MM_FACE + ';' +
          'transition:border-color .14s,background .14s,box-shadow .14s;';
        var photo = function (ratio, rad) {
          return '<span aria-hidden="true" style="display:block;width:100%;aspect-ratio:' + ratio + ';' +
            'border-radius:' + rad + ';background:#E9EBEE url(&quot;' + url + '&quot;) center/cover no-repeat"></span>';
        };
        var words = function (pad) {
          return '<span style="display:flex;flex-direction:column;gap:2px;padding:' + pad + '">' +
            '<span style="font:600 16.5px/1.2 ' + MM_FACE + '">' + esc(cw.name) + '</span>' +
            (sub ? '<span style="font:500 14px/1.3 ' + MM_FACE + ';color:#3F444C">' + esc(sub) + '</span>' : '') +
            (extra ? '<span style="font:700 15px/1.2 ' + MM_FACE + ';margin-top:2px">' + esc(extra) + '</span>' : '') +
            '</span>';
        };
        if (sty === 'B') {
          b.setAttribute('style', base + edge + 'flex-direction:column;gap:0;padding:6px;border-radius:14px;' +
            'background:' + (on ? '#F5F8FE' : MM_SURFACE));
          b.innerHTML = photo('2 / 1', '10px') + words('10px 6px 4px');
        } else if (sty === 'C') {
          b.setAttribute('style', base + 'flex-direction:column;justify-content:flex-end;padding:0;border-radius:14px;' +
            'overflow:hidden;aspect-ratio:4 / 5;border:0;background:#E9EBEE url("' + url + '") center/cover no-repeat;' +
            'box-shadow:' + (on ? '0 0 0 2px ' + MM_SURFACE + ',0 0 0 4px ' + MM_ACCENT : 'inset 0 0 0 1px rgba(23,24,26,.08)'));
          b.innerHTML = '<span style="display:flex;flex-direction:column;gap:2px;padding:30px 12px 11px;color:#fff;' +
            'background:linear-gradient(180deg,rgba(18,20,23,0) 0%,rgba(18,20,23,.72) 100%)">' +
            '<span style="font:700 16.5px/1.2 ' + MM_FACE + '">' + esc(cw.name) + '</span>' +
            (sub ? '<span style="font:500 13.5px/1.3 ' + MM_FACE + ';opacity:.92">' + esc(sub) + '</span>' : '') +
            (extra ? '<span style="font:700 14.5px/1.2 ' + MM_FACE + ';margin-top:2px">' + esc(extra) + '</span>' : '') +
            '</span>';
        } else {
          b.setAttribute('style', base + edge + 'flex-direction:column;gap:0;padding:6px;border-radius:14px;' +
            'background:' + (on ? '#F5F8FE' : MM_SURFACE));
          b.innerHTML = photo('1 / 1', '10px') + words('10px 4px 4px');
        }
        if (on) {
          var tk = el('span', 'mm-tick',
            '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.4" ' +
            'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"></path></svg>');
          tk.setAttribute('style', 'position:absolute;top:' + (sty === 'C' ? '10px' : '-7px') + ';right:' +
            (sty === 'C' ? '10px' : '-7px') + ';width:24px;height:24px;border-radius:50%;background:' + MM_ACCENT +
            ';color:#fff;display:flex;align-items:center;justify-content:center;box-shadow:0 0 0 2px ' + MM_SURFACE +
            ';pointer-events:none;z-index:1');
          b.appendChild(tk);
        }
        b.addEventListener('click', function (e) { e.stopPropagation(); markStep(i); pickColour(cw); });
        g.appendChild(b);
      });
    }

    /* B7.5.0: "See real examples", to the Recent models section further down (hidden if the page has none). */
    function examplesLink(card) {
      var tgt = document.querySelector('[id^="mmfin-"]');
      if (!tgt) return;
      var a = el('button', 'mm-examples', 'See real examples \u203A');
      a.type = 'button';
      a.setAttribute('style', 'align-self:flex-start;margin:2px 0 0;padding:4px 0;border:0;background:none;cursor:pointer;' +
        'font:600 14px/1.3 ' + MM_FACE + ';color:' + MM_ACCENT + ';text-decoration:underline;text-underline-offset:3px');
      a.addEventListener('click', function (e) {
        e.stopPropagation();
        /* B7.5.1: stop below the sticky header (and the sticky announcement bar on a wide screen). */
        var off = 12;
        ['header', '[id*="mm_announce"]'].forEach(function (sel) {
          var n = document.querySelector(sel);
          if (n && /sticky|fixed/.test(getComputedStyle(n).position)) off += n.getBoundingClientRect().height;
        });
        var y = tgt.getBoundingClientRect().top + (window.pageYOffset || 0) - off;
        try { window.scrollTo({ top: y, behavior: 'smooth' }); } catch (e2) { window.scrollTo(0, y); }
      });
      card.opts.appendChild(a);
    }

    function optGrid(card, n) {
      var g = el('div', 'mm-optgrid');
      g.setAttribute('style', 'display:grid;grid-template-columns:repeat(' + Math.max(1, n) +
        ',minmax(0,1fr));gap:8px;width:100%');
      card.opts.appendChild(g);
      return g;
    }

    /* B6.0: the Compare panel under a step's tiles -- the B5.72-B5.78
       guides, behind one toggle. One open at a time on a wide screen; on a
       phone each step arrives with its own open. */
    function cmpPanel(i, card) {
      var kind = guideKindFor(i);
      if (!kind) return;
      /* B7.5.0: no Compare panels. The finishes step gets one quiet link to the real photos further down. */
      if (SEGMENTS[i] === 'Colour') examplesLink(card);
      return;
      /* B6.1: on a phone every Compare arrives open, and each closes on its
         own. A wide screen keeps one at a time, closed to start with. */
      var phC = !wideBoard();
      if (!st.cmpShut) st.cmpShut = {};
      /* B6.3: on a phone each one starts closed now, and says so. */
      if (!st.cmpOpen) st.cmpOpen = {};
      var openC = phC ? !!st.cmpOpen[kind] : st.cmp === kind;
      var box = el('div', 'mm-cmp');
      box.setAttribute('style', 'border:1px solid ' + MM_LINE + ';border-radius:12px;overflow:hidden;' +
        'background:' + MM_SURFACE + ';width:100%;box-sizing:border-box');
      var b = el('button', 'mm-cmp-btn');
      b.type = 'button';
      b.setAttribute('aria-expanded', openC ? 'true' : 'false');
      b.setAttribute('style', 'display:flex;align-items:center;justify-content:space-between;gap:10px;' +
        'width:100%;min-height:' + (phC ? '50px' : '46px') + ';padding:' + (phC ? '0 12px 0 14px' : '0 14px') +
        ';margin:0;border:0;border-radius:0;' +
        'background:' + MM_BG + ';cursor:pointer;color:' + MM_INK + ';font:600 ' + (phC ? '15.5px' : '14.5px') +
        '/1.2 ' + MM_FACE + ';text-align:left');
      var cmpIcon = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" ' +
        'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="flex:none"><rect x="3" y="5" width="18" ' +
        'height="14" rx="2"></rect><circle cx="8.5" cy="10" r="1.6"></circle><path d="M21 16l-5-5-8 8">' +
        '</path></svg>';
      var cmpChev = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
        'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="flex:none;' +
        'transition:transform .2s;transform:rotate(' + (openC ? 180 : 0) + 'deg)"><path d="M6 9l6 6 6-6"></path></svg>';
      b.innerHTML = phC
        /* B6.3, phones: "Show photos" / "Hide" in the site blue on the right. */
        ? '<span style="flex:1 1 auto;min-width:0">' + esc(CMP_LABEL[kind]) + '</span>' +
          '<span class="mm-cmp-tog" style="flex:none;display:inline-flex;align-items:center;gap:3px;' +
          'color:' + MM_ACCENT + ';font:600 15px/1.2 ' + MM_FACE + '">' + (openC ? 'Hide' : 'Show photos') +
          cmpChev + '</span>'
        : '<span style="display:inline-flex;align-items:center;gap:8px">' + cmpIcon +
          esc(CMP_LABEL[kind]) + '</span>' + cmpChev;
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        if (phC) st.cmpOpen[kind] = !openC;
        else st.cmp = openC ? '' : kind;
        sync();
      });
      box.appendChild(b);
      var g = openC ? guideEl(kind, 'cmp', -1) : null;
      if (g) box.appendChild(g);
      card.opts.appendChild(box);
      if (g) guideLayout(g);
    }

    function fillCard(i, card, open) {
      var name = SEGMENTS[i];
      var big = wideBoard();

      if (name === 'Size') {
        card.val.textContent = st.size
          ? '\u00D8 ' + st.size.cm + ' cm'
          : 'Choose a size';
        if (!open) return;
        var gs = optGrid(card, SIZES.length > 4 ? 3 : SIZES.length);
        SIZES.forEach(function (s) {
          gs.appendChild(optTile({
            stack: true,
            label: '\u00D8 ' + s.cm + ' cm',
            sub: fmtAcross(s.ground / st.zoomX),
            extra: matrix ? money(minPriceFor(s), cfg.moneyFormat) : '',
            on: !!st.size && s.id === st.size.id,
            onClick: function () { markStep(i); pickSize(s); }
          }));
        });
        /* B6.5 (Kevin): one line each on a phone, the same size on all. */
        if (!big) requestAnimationFrame(function () { fitTileSubs(gs); });
        if (st.stage === 'cfg') {
          card.note.textContent = 'Changing the size rebuilds the model.';
          card.note.style.display = '';
        }
        cmpPanel(i, card);

      } else if (name === 'Frame') {
        var f = FRAMES.filter(function (x) { return x.id === st.frame; })[0];
        card.val.textContent = f ? f.name : '';
        if (!open) return;
        var fimg = cfg.frameImages || {};
        var gf = optGrid(card, FRAMES.length > 4 ? 3 : FRAMES.length);
        FRAMES.forEach(function (fr) {
          gf.appendChild(optTile({
            narrow: FRAMES.length >= 3,
            label: fr.name,
            on: st.frame === fr.id,
            mediaKind: fimg[fr.id] ? 'img' : 'solid',
            media: fimg[fr.id] || fr.css,
            badge: { ring: fr.css },
            onClick: function () { markStep(i); pickFrame(fr); }
          }));
        });
        cmpPanel(i, card);

      } else if (name === 'Colour') {
        card.val.textContent = cwObj().name;
        if (!open) return;
        /* Priced against the cheapest scheme at this size and frame, so the
           figure reads as the extra actually payable rather than a list price. */
        var prices = COLOURWAYS.map(function (x) {
          var v = matchVariant(x.id, st.frame);
          if (v) return v.price;
          var a = cfg.addons['colourway_' + x.id];
          return (a && a.price) || 0;
        });
        var cheapest = prices.reduce(function (a, b) { return Math.min(a, b); }, Infinity);
        var cimg = cfg.colourwayImages || {};
        /* B6.5 (Kevin): on a phone the finishes are chosen by their photos;
           no Compare panel, the photos are the buttons. */
        /* B6.6.1 (H6): Etsy has one finish; its photo is the card, any screen. */
        var cwPh = (big && !ETSY) ? [] : colourGuidePhotos();
        if (cwPh.length >= (ETSY ? 1 : 2) && cwPh.length === COLOURWAYS.length) {
          colourPhotoTiles(card, cwPh, prices, cheapest, i);
          if (!ETSY) examplesLink(card);                 /* B7.5.1: phones get the link too */
          return;
        }
        var gc = optGrid(card, COLOURWAYS.length > 3 ? 2 : COLOURWAYS.length);
        COLOURWAYS.forEach(function (cw, k) {
          var dd = prices[k] - cheapest;
          gc.appendChild(optTile({
            label: cw.name,
            sub: CW_SUB[cw.id] || (cw.materials + (cw.materials === 1 ? ' material' : ' materials')),
            on: st.colourway === cw.id,
            mediaKind: cimg[cw.id] ? 'img' : 'swatch',
            media: cimg[cw.id] || cw.swatch,
            badge: { colours: cw.swatch },
            extra: (dd > 0 && !ETSY) ? '+' + money(dd, cfg.moneyFormat) : '',
            onClick: function () { markStep(i); pickColour(cw); }
          }));
        });
        cmpPanel(i, card);

      } else if (name === 'Name label') {
        /* B7.0: optional. No label, or a label set into the frame. */
        lblVal = { el: card.val };
        card.val.textContent = labelSummary();
        if (!open) return;
        var lp = LABEL.price || 0;
        /* B7.5.0: one tick box, not two cards. */
        var lchk = el('label', 'mm-lblchk');
        lchk.setAttribute('style', 'display:flex;align-items:center;gap:12px;width:100%;box-sizing:border-box;' +
          'padding:12px 14px;border:1px solid ' + (st.labelSrc !== 'none' ? MM_ACCENT : MM_LINE) + ';border-radius:10px;' +
          'background:' + MM_SURFACE + ';cursor:pointer;font:600 15px/1.25 ' + MM_FACE + ';color:' + MM_INK);
        lchk.innerHTML = '<input type="checkbox"' + (st.labelSrc !== 'none' ? ' checked' : '') +
          ' style="flex:none;width:20px;height:20px;margin:0;accent-color:' + MM_ACCENT + ';cursor:pointer">' +
          '<span style="flex:1;min-width:0">Add a name label<span style="display:block;font:400 13px/1.3 ' + MM_FACE +
          ';color:' + MM_LABEL + '">Set into the frame</span></span>' +
          ((lp > 0 && !ETSY) ? '<span style="flex:none;font:600 14.5px/1 ' + MM_FACE + ';color:' + MM_LABEL + '">+' +
            esc(money(lp, cfg.moneyFormat)) + '</span>' : '');
        lchk.querySelector('input').addEventListener('change', function (e) {
          markStep(i);
          labelSet(e.target.checked ? 'place' : 'none');
        });
        card.opts.appendChild(lchk);
        /* B7.0.5: say it when the label is what takes the order to free shipping */
        if (LABEL.fs > 0 && lp > 0 && !ETSY) {
          var tNow = totalCents(), base = tNow - (labelIsOn() ? lp : 0);
          if (base < LABEL.fs && base + lp >= LABEL.fs) {
            labelCss();
            card.opts.appendChild(el('p', 'mm-lbl-fs ' + (labelIsOn() ? 'is-on' : 'is-off'), labelIsOn() ? 'Free shipping earned' : 'Add a label and shipping is free'));
          }
        }
        if (st.labelSrc !== 'none') {
          var lr = labelUi();
          card.opts.appendChild(lr);
          labelPaint();
        }

      } else if (name === 'Generate') {
        /* Step five is the button, not a set of choices. Extras live in the
           cart drawer. */
        var f2 = FRAMES.filter(function (x) { return x.id === st.frame; })[0];
        var rendered = st.stage === 'cfg' && st.rendered;
        card.val.textContent = st.building
          ? 'Building your model\u2026'
          : rendered
          ? ''   /* B7.5.0 */
          : st.stage === 'cfg'
          ? 'That build did not finish. Try again.'
          : (st.size
            ? '\u00D8 ' + st.size.cm + ' cm \u00B7 ' + (f2 ? f2.name + ' frame' : '') + ' \u00B7 ' + cwObj().name
            : 'Pick a size first');
        if (!open) return;
        /* Once a model exists the way to rebuild is Adjust the area, under
           Add to cart, so the button itself goes. */
        ui.buildBtn.textContent = st.building
          ? 'Building\u2026'
          : (st.stage === 'cfg' && !st.rendered)
            ? 'Try again'
            : (cfg.text.buildCta || 'Generate my model');
        ui.buildBtn.disabled = st.building || !st.size;
        var can = st.size && !st.building;
        if (big) {
          if (st.size && !ETSY) {
            var tot = el('div', 'mm-total');
            tot.setAttribute('style', 'width:100%;display:flex;justify-content:space-between;' +
              'align-items:baseline;padding-bottom:2px');
            tot.innerHTML = '<span style="font:600 16px/1.2 ' + MM_FACE + ';color:' + MM_INK + '">Total</span>' +
              '<span style="font:700 26px/1.1 ' + MM_FACE + ';letter-spacing:-.01em;color:' + MM_INK + '">' +
              esc(money(totalCents(), cfg.moneyFormat)) + '</span>';
            card.opts.appendChild(tot);
          }
          ui.buildBtn.setAttribute('style',
            'display:' + (rendered ? 'none' : 'flex') + ';align-items:center;justify-content:center;' +
            'width:100%;box-sizing:border-box;background:' + MM_ACCENT + ';color:#fff;border:0;' +
            'border-radius:8px;min-height:56px;padding:16px 20px;font:700 17px/1 ' + MM_FACE + ';' +
            'cursor:pointer;' + (can ? '' : 'opacity:.45;cursor:default'));
          card.opts.appendChild(ui.buildBtn);
        } else {
          /* B6.1: the button is the bar at the bottom of the screen. Here,
             everything they chose, each with a way back to it, so nothing is
             missed before they press it. */
          if (ui.buildBtn.parentNode) ui.buildBtn.parentNode.removeChild(ui.buildBtn);
          var failed = st.stage === 'cfg' && !st.rendered && !st.building;
          var showBtn = (st.stage !== 'cfg' && !st.building) || failed;
          var pre = st.stage !== 'cfg' && !st.building;
          card.val.style.display = pre ? 'none' : '';
          if (pre) {
            var fr2 = FRAMES.filter(function (x) { return x.id === st.frame; })[0];
            var rowsP = [
              ['Place', st.placeName || fmtCoord(st.center.lat, st.center.lon), 0],
              ['Size', st.size ? '\u00D8 ' + st.size.cm + ' cm' : 'Not chosen', 1],
              ['Frame', fr2 ? fr2.name : '', 2],
              ['Colour', cwObj().name, 3]
            ];
            if (LABEL.on) rowsP.push(['Label', labelSummary(), 4]);   /* B7.0 */
            var sum = el('div', 'mm-pick');
            sum.setAttribute('style', 'display:flex;flex-direction:column;width:100%;border:1px solid ' + MM_LINE +
              ';border-radius:12px;overflow:hidden');
            rowsP.forEach(function (rw, k) {
              var line = el('div', 'mm-pick-row');
              line.setAttribute('style', 'display:flex;align-items:center;gap:10px;min-height:56px;' +
                'padding:6px 4px 6px 14px;box-sizing:border-box;' + (k ? 'border-top:1px solid ' + MM_LINE + ';' : ''));
              line.innerHTML =
                '<span style="flex:none;width:64px;font:500 15px/1.2 ' + MM_FACE + ';color:' + MM_LABEL + '">' +
                  esc(rw[0]) + '</span>' +
                '<span style="flex:1;min-width:0;font:600 16px/1.3 ' + MM_FACE + ';color:' + MM_INK + ';' +
                  'overflow:hidden;text-overflow:ellipsis;white-space:nowrap">' + esc(rw[1]) + '</span>';
              var cb = el('button', 'mm-pick-chg', 'Change');
              cb.type = 'button';
              cb.setAttribute('style', 'flex:none;margin:0;border:0;background:none;cursor:pointer;' +
                'padding:12px 10px;font:600 15.5px/1 ' + MM_FACE + ';color:' + MM_INK + ';' +
                'text-decoration:underline;text-underline-offset:3px;text-decoration-color:' + MM_TRACK);
              cb.addEventListener('click', function (e) { e.stopPropagation(); revealSection(rw[2]); });
              line.appendChild(cb);
              sum.appendChild(line);
            });
            card.opts.appendChild(sum);
          }
          if (st.size && !ETSY && !(st.stage === 'cfg' && st.rendered)) {
            var totP = el('div', 'mm-pick-total');
            totP.setAttribute('style', 'width:100%;display:flex;justify-content:space-between;' +
              'align-items:baseline;padding:4px 2px 0;box-sizing:border-box');
            totP.innerHTML = '<span style="font:600 17px/1.2 ' + MM_FACE + ';color:' + MM_INK + '">Total</span>' +
              '<span style="font:700 24px/1.1 ' + MM_FACE + ';letter-spacing:-.01em;color:' + MM_INK + '">' +
              esc(money(totalCents(), cfg.moneyFormat)) + '</span>';
            card.opts.appendChild(totP);
          }
          /* B6.1.1: the finish line of the steps, in the page. */
          if (showBtn) {
            ui.buildBtn.textContent = failed ? 'Try again' : 'See my 3D preview';
            ui.buildBtn.setAttribute('style',
              'display:flex;align-items:center;justify-content:center;width:100%;box-sizing:border-box;' +
              'margin:6px 0 0;background:' + MM_ACCENT + ';color:#fff;border:0;border-radius:10px;' +
              'min-height:58px;padding:16px 20px;font:700 18px/1 ' + MM_FACE + ';cursor:pointer;' +
              (can ? '' : 'opacity:.45;cursor:default'));
            card.opts.appendChild(ui.buildBtn);
          }
        }
        ui.cancelBtn.setAttribute('style',
          'display:' + (st.building ? 'block' : 'none') + ';width:100%;box-sizing:border-box;' +
          'margin-top:' + (big ? '8px' : '2px') + ';background:' + MM_SURFACE + ';color:' + MM_INK + ';' +
          'border:1px solid ' + MM_TRACK + ';border-radius:' + (big ? '8px' : '10px') + ';' +
          'padding:' + (big ? '13px 18px' : '17px 18px') + ';' +
          'font:600 ' + (big ? '14.5px' : '16px') + '/1 ' + MM_FACE + ';cursor:pointer');
        /* B6.2: on a phone Cancel waits under the model, where the build is. */
        if (big) card.opts.appendChild(ui.cancelBtn);
        card.note.textContent = st.building
          ? 'Usually under a minute. Keep this page open, as switching tabs or ' +
            'locking the phone pauses the build.'
          : rendered
            ? (ETSY ? 'Happy with it? Get your Etsy code, then order on Etsy.' : '')
            : 'Takes 30 seconds to a few minutes. Keep the page open.';
        /* B6.3: nothing under a finished model except on the Etsy page. */
        card.note.style.display = (rendered && (big || !ETSY)) ? 'none' : '';
        card.note.style.fontSize = big ? '13px' : '15px';
        card.note.style.lineHeight = '1.45';
        card.note.style.color = big ? MM_LABEL : '#3F444C';
        /* B7.3.0: the 30-day count under See my 3D preview, until they build. */
        var proof = (!st.building && !rendered) ? mmProofHtml(cfg) : '';
        if (proof) {
          var pf = el('div', 'mm-proof-line');
          pf.setAttribute('style', 'display:flex;align-items:flex-start;gap:8px;' +
            'margin-top:' + (big ? '8' : '10') + 'px;font:500 ' + (big ? '12.5' : '13.5') + 'px/1.4 ' +
            MM_FACE + ';color:' + MM_LABEL);   /* B7.5.0: smaller */
          pf.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="' + MM_ACCENT +
            '" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" ' +
            'style="flex:none;margin-top:1px"><path d="M12 2l9 5v10l-9 5-9-5V7z"></path>' +
            '<path d="M12 22V12"></path><path d="M21 7l-9 5-9-5"></path></svg><span style="text-wrap:balance">' + proof + '</span>';
          card.note.appendChild(pf);
        }
      }
    }

    /* Working days only. Promising a Sunday dispatch is the kind of small lie
       that turns into a support ticket. */
    function shipBy(days) {
      var d = new Date(), added = 0;
      while (added < Math.max(0, days)) {
        d.setDate(d.getDate() + 1);
        var w = d.getDay();
        if (w !== 0 && w !== 6) added++;
      }
      return d.toLocaleDateString(MMC.locale || undefined,
        { weekday: 'long', day: 'numeric', month: 'long' });
    }

    /* --------------------------------- cart ------------------------------- */

    function addToCart() {
      /* Etsy mode (H3): an Etsy code instead of the cart. */
      if (ETSY) {
        if (!st.size || st.adding || !window.MMEtsy) return;
        st.adding = true; st.error = ''; sync();
        window.MMEtsy.getCode({ state: packState(st), spec: spec(), sizeCm: st.size.cm, frame: st.frame,
                                colourway: cwObj().name })
          .then(function () { st.adding = false; sync(); },
                function (e) { st.adding = false; st.error = e.message; sync(); });
        return;
      }
      if (!st.size || st.adding) return;

      var chosen = matrix ? matchVariant() : null;
      var variantId = chosen ? chosen.id : st.size.variantId;

      if (!variantId) {
        st.error = matrix
          ? 'No variant found for ' + st.size.cm + ' cm / ' + cwObj().name + ' / ' +
            ((FRAMES.filter(function (f) { return f.id === st.frame; })[0] || {}).name || '?') +
            '. Check the option values in the section settings match your product exactly.'
          : 'This size has no variant ID set in the theme editor.';
        return sync();
      }
      if (chosen && chosen.available === false) {
        st.error = 'That combination is marked unavailable in Shopify. ' +
          'Tick "Continue selling when out of stock" on the variant.';
        return sync();
      }
      /* B7.0: a chosen label needs its text and its product. */
      if (labelIsOn()) {
        if (labelValue() === 'None') { st.error = 'Type your label, or choose No label.'; return sync(); }
        if (!LABEL.variantId) { st.error = 'The name label is not set up in the shop yet.'; return sync(); }
      }
      st.adding = true; st.error = ''; sync();

      var props = {
        'Location': st.placeName || fmtCoord(st.center.lat, st.center.lon),
        'Coordinates': fmtCoord(st.center.lat, st.center.lon),
        'Area shown': '\u00D8 ' + fmtAcross(ground()),
        'Scale': '1:' + effScale().toLocaleString(),
        'Colourway': cwObj().name,
        'Frame': (FRAMES.filter(function (f) { return f.id === st.frame; })[0] || {}).name,
        '_spec': JSON.stringify(spec()),
        /* The exact localStorage key for this model's thumbnail. The drawer
           used to rebuild it from _spec, which meant both files had to round
           the same coordinates the same way forever. Writing it once here
           removes that whole class of silent mismatch. */
        '_thumb': MM_thumbKey(spec())
      };
      if (labelIsOn()) {   /* B7.0: on the order, for printing */
        props['Label'] = labelOrderText();
        if (labelIcon(st.labelIcon)) props['Label icon'] = labelIcon(st.labelIcon).name;
      }
      /* The variant price is one number covering size, frame and colour, so the
         cart had no way to show what the colour actually cost -- it could only
         print the total and call it "Base price". Split it here, where the whole
         variant matrix is in hand: base is the cheapest colour at this size and
         frame, and the rest is what this colourway adds. Underscored, so it
         carries the figures without appearing at checkout as raw JSON. */
      if (matrix && chosen) {
        var basePrice = null;
        COLOURWAYS.forEach(function (c) {
          var v = matchVariant(c.id, st.frame);
          if (v && (basePrice === null || v.price < basePrice)) basePrice = v.price;
        });
        if (basePrice !== null) {
          props['_priceParts'] = JSON.stringify({
            base: basePrice,
            colour: Math.max(chosen.price - basePrice, 0),
            colourName: cwObj().name
          });
        }
      }

      var items = [{ id: variantId, quantity: 1, properties: props }];
      var link = { _linkedTo: fmtCoord(st.center.lat, st.center.lon) };
      if (!matrix) {
        var cwAddon = cfg.addons['colourway_' + st.colourway];
        if (cwAddon && cwAddon.variantId) {
          items.push({ id: cwAddon.variantId, quantity: 1, properties: link });
        }
      }

      EXTRAS.forEach(function (x) {
        if (!x.variantId) return;
        var qty = x.id === 'hanger' ? st.extras.hanger : (st.extras[x.id] ? 1 : 0);
        if (!qty) return;
        items.push({ id: x.variantId, quantity: qty, properties: x.id === 'gift'
          ? { _linkedTo: link._linkedTo, 'Gift message': st.giftMsg || '(no message)' }
          : link });
      });
      /* B7.0: the label's own line, tied to this model. */
      if (labelIsOn() && LABEL.variantId) {
        items.push({ id: LABEL.variantId, quantity: 1,
                     properties: { _linkedTo: link._linkedTo, 'Label': labelOrderText() } });
      }

      var rootPath = (window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root : '/';

      /* B5.57: the customer's own render goes into the cart with the model.
         Until now it only existed in this browser (the cart thumbnail) and in
         the render email, so the abandoned checkout emails had nothing of theirs
         to show and fell back to a stock picture of somewhere else. Shopify
         stores a file sent as a line item property on its own CDN and puts the
         URL in the property, so the emails (and the order) can show the exact
         model. Underscored, so it never appears at checkout.
         The upload is best effort and can never cost a sale: no thumbnail, an
         old browser, or any failure at all, and it falls straight back to the
         plain JSON add this always used. */
      function postJson(list) {
        return fetch(rootPath + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: list })
        }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); });
      }
      function renderBlob() {
        try {
          var u = props['_thumb'] ? localStorage.getItem(props['_thumb']) : null;
          /* B5.60: an exact-key miss (the centre moved by a hair after the
             render) used the last model built instead of sending no picture. */
          if (!u) {
            u = localStorage.getItem('mm-thumb:last');
            if (u && window.console) console.info('[mm] cart picture: exact key missed, using the last model built');
          }
          if (!u || u.indexOf('data:image/') !== 0 || typeof FormData === 'undefined' || typeof Blob === 'undefined') return null;
          var parts = u.split(','), mime = (parts[0].match(/:(.*?);/) || [])[1] || 'image/jpeg';
          var bin = atob(parts[1]), n = bin.length, arr = new Uint8Array(n);
          while (n--) arr[n] = bin.charCodeAt(n);
          return new Blob([arr], { type: mime });
        } catch (e) { return null; }
      }
      function addWithRender() {
        var blob = renderBlob();
        if (!blob) return postJson(items);
        var fd = new FormData();
        fd.append('id', String(items[0].id));
        fd.append('quantity', '1');
        Object.keys(items[0].properties).forEach(function (k) {
          var v = items[0].properties[k];
          if (v != null) fd.append('properties[' + k + ']', String(v));
        });
        fd.append('properties[_render]', blob, 'mm-render.jpg');
        var main = fetch(rootPath + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error((res.body && (res.body.description || res.body.message)) || 'render upload refused');
            return res;
          });
        /* The second handler only catches the main line failing; a failure
           adding the extras afterwards still reaches the normal error path. */
        return main.then(function (res) {
            if (window.console) {
              var got = res.body && res.body.properties && res.body.properties._render;
              console.info('[mm] render attached to cart line: ' + (typeof got === 'string' ? got : 'no URL returned'));
            }
            /* B7.2.0: the email clip is named after this render and uploaded in
               the background. Nothing extra goes into the cart. */
            try { if (typeof got === 'string' && window.MM_CLIP) window.MM_CLIP.attach(got); } catch (eClip2) {}
            if (items.length < 2) return res; /* B7.0.10: all or nothing. If the add-ons (label, gift note...) fail after the model went in, the model comes back out, so the cart never holds a labelled model without its paid label line. */ return postJson(items.slice(1)).then(function (r2) { if (r2.ok) return r2; var line = res.body || {}; if (!line.key) return r2; return fetch(rootPath + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: line.key, quantity: Math.max(0, (line.quantity || 1) - 1) }) }).then(function () { return r2; }, function () { return r2; }); });
          }, function (e) {
            if (window.console) console.warn('[mm] render upload failed, adding without it:', e && e.message);
            return postJson(items);
          });
      }

      addWithRender()
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add to cart.');
          /* Open the drawer rather than navigating to /cart. This is the highest
             intent moment in the session -- throwing the customer onto a cart
             page loses the configuration they just spent five minutes on, and
             loses the one place the made-to-order terms can be shown before
             payment. Falls back to the cart page if the drawer is missing. */
          st.adding = false;
          sync();
          if (window.MMCart && window.MMCart.open) window.MMCart.open();
          else window.location.href = rootPath + 'cart';
        })
        .catch(function (e) { st.adding = false; st.error = e.message; sync(); });
    }

    /* -------------------------------- sync -------------------------------- */

  }

  /* ------------------------------ DOM build ------------------------------ */
  /* Build 5.4: an area banner, then four quarters, then the action.

     Step 1 is the area, and it sits in a full-width banner above everything
     rather than as a floating search box: an address field with a dropdown is
     unusable crammed into a corner card, and leaving it unnumbered while four
     numbered cards sat below it was the main reason the page read as
     disconnected. Steps 2 to 5 are the four quarters, clockwise from the top
     left, so the arc on the ring sweeps round instead of jumping about.

     Selecting an option no longer jumps you forward. You pick, you look at the
     circle, and a Back/Next pair moves you between steps when you are ready.

     Palette is cool near-white for this section only: the store's beige against
     grey tracks, green and blue was reading muddy. The brand green is
     unchanged -- it was the background under it that was the problem.

     Every load-bearing size is an inline style set from JS. The theme ships
     74KB of CSS written for the old markup, its rules land after anything
     injected here, and a structural property that silently loses is how the map
     ended up covering the whole page in 5.0. For the same reason the circle
     wrapper is .mm-arena and not .mm-stage: the theme already styles .mm-stage
     (font-size:14px;font-weight:600) for the progress line inside the render,
     and that was cascading into every child of the board. */
  /* White and Meadow. The 5.4 palette was cool near-white, and the blue cast in
     it fought the green rather than sitting under it. Cards are white; the page
     behind them is a warm off-white barely off the card, because white cards on
     a white page leave the border doing all the work and that reads as cheap.
     Green is the only colour on the page, and green means locked in -- which is
     why the "you are here" marker is charcoal and not a second hue. */
  /* The store's own beige, sampled from the band below the configurator, so
     the section does not read as a cool-grey panel dropped into a warm page.
     White cards and the blue gain contrast against it, which is the point. */
  var MM_BG = '#F3F4F6', MM_SURFACE = '#FFFFFF';
  var MM_INK = '#121417', MM_LABEL = '#5A606A';
  var MM_TRACK = '#DFE2E6';
  /* The ring's untouched quarters need their own tone: a border grey that works
     as a 1px line disappears completely as a 30px band on an off-white page. */
  var MM_RING_IDLE = '#D5D8DC';
  /* Apple's own store blue. Kevin picked blue for the accent and for Add to
     cart, and this is the exact tone the pages he sent use for both -- it is
     the most-tested action colour on the web, it holds white text at full
     contrast, and it does not have to compete with the satellite map the way a
     green ring around a green map does.
     Interface only: the printed model's Meadow colourway is untouched and
     still lives in COLOURWAYS. */
  var MM_ACCENT = '#1E4FC4', MM_ACCENT_INK = '#183FA0', MM_ACCENT_SOFT = '#E8EEFB';
  var MM_FOCUS = '#121417', MM_FOCUS_SOFT = '#FFFFFF';
  /* B6.0: single quotes inside, because these also go into style="..."
     attributes written as HTML -- double quotes there ended the attribute
     early and the rest of the declaration was silently lost. */
  var MM_FACE = "'Hanken Grotesk', 'Outfit', 'Avenir Next', system-ui, sans-serif";
  /* B6.0: headings in the site's display face; lines in the site's grey. */
  var MM_HEAD = "'Bricolage Grotesque', 'Hanken Grotesk', system-ui, sans-serif";
  var MM_LINE = '#E2E4E8';
  /* B6.0.2: a finished step is quiet -- grey face, ink tick -- so the only
     blue left once the model is up is Add to cart. */
  var MM_DONE_BG = '#EEF0F3';
  /* B6.0: no ring. drawRing() checks this and stops. */
  var B6_SQUARE = true;
  /* B5.72.1: the guide constants. Module level for the same reason as the
     ring constants below: the first paint can read them during start-up. */
  var GUIDE_INK = '#1E4FC4', GUIDE_PILL = '#E8EEFB', GUIDE_LINE = '#E2E4E8';
  var GUIDE_SPOTS = {
    size: { aspect: 2400 / 3600,
            '15': [0.12833, 0.64208, 0.08056],
            '20': [0.37056, 0.60417, 0.10611],
            '40': [0.73944, 0.45083, 0.20778] },
    frame: { aspect: 1, c: [0.50024, 0.57324, 0.30078] }
  };
  var GUIDE_FRAMED = { '15': '17 cm / 6.7 in', '20': '22.4 cm / 8.8 in', '40': '44 cm / 17.3 in' };
  /* Outer, framed diameters in cm -- what the photo shows, so the models
     stand at the sizes they are drawn at. */
  var GUIDE_OUTER = { '15': 17, '20': 22.4, '40': 44 };
  var GUIDE_DOT = { white: '#FFFFFF', black: '#1B1B1B', wood: '#CBAC88' };
  var GUIDE_FONT;            /* = MM_FACE, set just below it */
  GUIDE_FONT = MM_FACE;
  var SEGMENTS = ['Size', 'Frame', 'Colour', 'Generate'];
  /* Displayed numbers start at 2: the area banner above the board is step 1. */
  var SEG_N0 = 2;
  /* B6.0: Compare panel labels. Module level: the first paint reads it
     before init() reaches its own declarations (the hoisting trap). */
  var CMP_LABEL = { size: 'Compare sizes', frame: 'Compare frames', colour: 'Compare finishes' };
  /* Reading order: TL, TR, BL, BR, in canvas angles (0 = east, positive = down).
     It was clockwise in 5.3-5.4, and the only argument for that was a travelling
     arc sweeping round the ring. 5.5 replaces the arc with four quarters that
     close in and lock, so nothing travels and nothing needs to sweep -- which
     leaves reading order, which is how people actually scan. */
  /* How the gap between quarters is cut.

     5.5 trimmed each quarter by an angle, which puts the cut on a radius --
     a line pointing at the centre, so every edge except the four on the axes
     came out tilted. 5.6 cuts with straight lines parallel to the axes instead,
     so all eight edges are exactly horizontal or vertical and the corners are
     square. The gap is a constant number of pixels rather than an angle, which
     also means it does not widen as the circle grows.

     Module level, not inside init(), and that is not a style choice: init()
     calls layout() near its top and declares the ring section hundreds of lines
     below it. `var` hoists the name and not the value, so a constant declared
     down there is `undefined` when the first draw reads it -- every arc angle
     came out NaN and the ring painted nothing at all. Same bug that blanked the
     whole page on 24 Sep. Anything the first layout() touches belongs up here. */
  var RING_GAP_BASE = 0.013;   /* of the circle's width */
  /* Which gesture the device in front of you actually has. Module level with
     everything else the first draw reads -- see the note above. */
  var IS_TOUCH = false;
  try {
    IS_TOUCH = (window.matchMedia && window.matchMedia('(hover:none)').matches) ||
               ('ontouchstart' in window);
  } catch (e) { /* assume a mouse, which is the safer instruction */ }
  var SEG_ARC = [
    [Math.PI, Math.PI * 1.5],          /* top left     */
    [Math.PI * 1.5, Math.PI * 2],      /* top right    */
    [Math.PI * 0.5, Math.PI],          /* bottom left  */
    [0, Math.PI * 0.5]                 /* bottom right */
  ];

  /* The panel shape: a rounded rectangle with the circle bitten out of the
     corner that faces it.

     This was a CSS radial-gradient mask, and a mask cannot carry a border --
     which is exactly why the panels had no outline along the curve, however
     the border was set. The shape is drawn as one real path instead, so a
     stroke follows the whole outline, arc included.

     Built by sampling the rounded rect and pushing any point that falls inside
     the cut circle out onto it. That traces the arc in the right place and in
     the right order without solving arc/rectangle intersections by hand, and
     it degrades sanely whatever the panel's proportions turn out to be. */
  function cardShapePath(w, h, mx, my, R, rad) {
    var pts = [];
    function corner(cx0, cy0, a0, a1) {
      for (var k = 0; k <= 8; k++) {
        var a = a0 + (a1 - a0) * (k / 8);
        pts.push([cx0 + Math.cos(a) * rad, cy0 + Math.sin(a) * rad]);
      }
    }
    function edge(x0, y0, x1, y1) {
      var steps = Math.max(2, Math.round(Math.hypot(x1 - x0, y1 - y0) / 4));
      for (var k = 1; k <= steps; k++) {
        pts.push([x0 + (x1 - x0) * k / steps, y0 + (y1 - y0) * k / steps]);
      }
    }
    corner(rad, rad, Math.PI, Math.PI * 1.5);
    edge(rad, 0, w - rad, 0);
    corner(w - rad, rad, Math.PI * 1.5, Math.PI * 2);
    edge(w, rad, w, h - rad);
    corner(w - rad, h - rad, 0, Math.PI * 0.5);
    edge(w - rad, h, rad, h);
    corner(rad, h - rad, Math.PI * 0.5, Math.PI);
    edge(0, h - rad, 0, rad);
    var d = '', i;
    for (i = 0; i < pts.length; i++) {
      var px = pts[i][0], py = pts[i][1];
      var dx = px - mx, dy = py - my, dist = Math.hypot(dx, dy);
      if (dist < R && dist > 1e-6) { px = mx + dx / dist * R; py = my + dy / dist * R; }
      d += (i ? 'L' : 'M') + px.toFixed(1) + ' ' + py.toFixed(1);
    }
    return d + 'Z';
  }

  function cardShapeSvg(w, h, mx, my, R, stroke, sw) {
    /* Inset by half the stroke, or the outline is clipped by the box. */
    var d = cardShapePath(w - sw, h - sw, mx - sw / 2, my - sw / 2, R, 16);
    var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="' + Math.round(w) +
      '" height="' + Math.round(h) + '" viewBox="0 0 ' + Math.round(w) + ' ' +
      Math.round(h) + '"><path d="' + d + '" transform="translate(' + (sw / 2) +
      ',' + (sw / 2) + ')" fill="' + MM_SURFACE + '" stroke="' + stroke +
      '" stroke-width="' + sw + '" stroke-linejoin="round"/></svg>';
    return 'url("data:image/svg+xml;utf8,' + encodeURIComponent(svg) + '")';
  }

  /* B6.3, phones: the round step number on a card's edge, kept as one
     element and restyled in place, so a pop can run to the end. */
  var MM_TICK_SVG = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" ' +
    'stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M5 12.5l4.5 4.5L19 7.5"></path></svg>';
  function paintSnum(b, kind, n) {
    if (!b || (b.__mmPh && b.__mmK === kind && b.__mmN === n)) return;
    var prev = b.__mmPh ? b.__mmK : '';
    b.__mmK = kind; b.__mmN = n; b.__mmPh = true;
    b.innerHTML = kind === 'done' ? MM_TICK_SVG : esc(n);
    b.setAttribute('style',
      'position:relative;z-index:2;flex:none;width:36px;height:36px;box-sizing:border-box;margin:0;' +
      'border-radius:50%;display:flex;align-items:center;justify-content:center;' +
      'font:700 15px/1 ' + MM_FACE + ';box-shadow:0 0 0 4px #FFFFFF;' +
      'transition:background-color .25s ease,border-color .25s ease,color .25s ease;' +
      (kind === 'done'
        ? 'background:' + MM_INK + ';border:2px solid ' + MM_INK + ';color:#FFFFFF'
        : kind === 'now'
          ? 'background:#FFFFFF;border:2px solid ' + MM_ACCENT + ';color:' + MM_INK
          : 'background:#FFFFFF;border:2px solid ' + MM_TRACK + ';color:#6B717A'));
    b.classList.add('mm-snum');
    b.classList.remove('mm-pop');
    b.classList.remove('mm-wake');
    if (prev && prev !== kind && kind !== 'todo') {
      void b.offsetWidth;
      b.classList.add(kind === 'done' ? 'mm-pop' : 'mm-wake');
    }
  }

  function stepBadge(txt, kind, big) {
    var d = big ? 26 : 22;
    var b = el('span', 'mm-step-n', txt);
    b.setAttribute('style',
      'flex:none;width:' + d + 'px;height:' + d + 'px;border-radius:7px;display:flex;' +
      'align-items:center;justify-content:center;font:600 ' + (big ? '13' : '12') +
      'px/1 ' + MM_FACE + ';' +
      (kind === 'done'
        ? 'background:' + MM_DONE_BG + ';color:' + MM_INK + ';border:1px solid ' + MM_TRACK
        : kind === 'now'
          ? 'background:' + MM_FOCUS + ';color:#fff;border:1px solid ' + MM_FOCUS
          : 'border:1px solid ' + MM_TRACK + ';color:' + MM_LABEL));
    return b;
  }

  /* B6.0: the site's own faces. The homepage sections load them the same
     way; this page has none of those sections, so it asks for them itself. */
  function ensureFonts() {
    try {
      if (document.getElementById('mm-fonts')) return;
      var l = document.createElement('link');
      l.id = 'mm-fonts';
      l.rel = 'stylesheet';
      l.href = 'https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:wght@600;700&' +
               'family=Hanken+Grotesk:wght@400;500;600;700&display=swap';
      /* 27 Oct 2026: fonts are self-hosted (snippets/mm-seo.liquid), so the Google Fonts link is no longer added. */
      var cs6 = document.createElement('style');
      cs6.id = 'mm-b6-css';
      cs6.textContent = '.mm-arena .mm-turn > *{pointer-events:auto}' +
        /* B6.3: a number pops once when its step is done; the next one
           swells once as the line reaches it. */
        '@keyframes mmPop{0%{transform:scale(1)}40%{transform:scale(1.18)}100%{transform:scale(1)}}' +
        '@keyframes mmWake{0%{transform:scale(1)}45%{transform:scale(1.1)}100%{transform:scale(1)}}' +
        '.mm-snum.mm-pop{animation:mmPop .42s cubic-bezier(.3,1.5,.5,1) 1}' +
        '.mm-snum.mm-wake{animation:mmWake .5s ease-out .45s 1}' +
        '@media (prefers-reduced-motion:reduce){.mm-snum.mm-pop,.mm-snum.mm-wake{animation:none}' +
        '.mm-railfill{transition:none!important}}' +
        /* B6.2: the arrow on the quiet "Next" line nudges twice, once. */
        '@keyframes mmNudge{0%,100%{transform:translateY(0)}50%{transform:translateY(5px)}}' +
        '.mm-next-hint.is-seen .mm-next-hint-a{animation:mmNudge .9s ease-in-out 2}' +
        '@media (prefers-reduced-motion:reduce){.mm-next-hint.is-seen .mm-next-hint-a{animation:none}}' +
        /* B6.1: the theme's "Love it, or your money back" line sits under
           Add to cart wherever that button is; in the phone bar, centred
           under it on its own row. */
        '.mm-pbar .mm-promise-line{flex:1 1 100%!important;width:100%!important;margin:0!important;' +
        'padding:0 0 2px!important;text-align:center!important;font-size:15px!important;line-height:1.3!important}' +
        '.mm .mm-credit a{color:inherit;text-decoration:underline;text-underline-offset:2px}';
      document.head.appendChild(cs6);
    } catch (e) { /* system fonts are a fine fallback */ }
  }

  function buildDom(root, cfg, SIZES) {
    ensureFonts();
    var wrap = el('div', 'mm');
    wrap.setAttribute('style',
      'display:flex;flex-direction:column;align-items:center;gap:16px;position:relative;' +
      'width:100%;max-width:1800px;margin:0 auto;padding:22px 16px 34px;' +
      'box-sizing:border-box;color:' + MM_INK + ';background:' + MM_BG);

    /* B6.0: a page heading, as in draft 3. Styled in paintHead(). */
    var pageHead = el('div', 'mm-head');
    var pageHeadL = el('div', 'mm-head-l');
    pageHeadL.setAttribute('style', 'display:flex;flex-direction:column;gap:6px;min-width:0');
    var pageEyebrow = el('p', 'mm-head-eyebrow', 'Custom 3D map model');
    var pageTitle = el('h1', 'mm-head-title', 'Design your model');
    var pageLead = el('p', 'mm-head-lead', 'Pick a place, choose a size and see it in 3D before you pay.');
    pageHeadL.appendChild(pageEyebrow); pageHeadL.appendChild(pageTitle);
    pageHead.appendChild(pageHeadL); pageHead.appendChild(pageLead);
    wrap.appendChild(pageHead);

    /* ---- step 1: the area. Full width, numbered, with the price alongside. */
    var banner = el('div', 'mm-area');
    var bTop = el('div', 'mm-area-top');
    bTop.setAttribute('style',
      'display:flex;align-items:center;gap:10px;flex-wrap:wrap');
    var bNum = stepBadge('1', 'now', true);
    var bLab = el('span', 'mm-area-lab', 'Choose your area');
    bLab.setAttribute('style',
      'font:600 16.5px/1.15 ' + MM_FACE + ';white-space:nowrap;flex:none');
    var where = el('div', 'mm-where', '');
    where.setAttribute('style',
      'font-size:14.5px;color:' + MM_LABEL + ';overflow:hidden;text-overflow:ellipsis;' +
      'white-space:nowrap;flex:1 1 40px;min-width:0');
    /* The price used to sit up here and had no business doing so: nothing in
       this step changes it. It lives in step 5 next to Generate, and on the buy
       button. Kept as a detached node so everything that writes to it still
       can. */
    var price = el('div', 'mm-price', '');
    var areaEdit = el('button', 'mm-area-edit', 'Change');
    areaEdit.type = 'button';
    bTop.appendChild(bNum); bTop.appendChild(bLab);
    bTop.appendChild(where); bTop.appendChild(areaEdit);
    banner.appendChild(bTop);

    /* The list is a sibling of the input row inside a positioned box -- not a
       flex item beside the input, which is what sent the dropdown shooting off
       to the right in 5.1. */
    var searchBox = el('div', 'mm-search-wrap');
    searchBox.setAttribute('style',
      'position:relative;width:100%;z-index:var(--mm-z-search,20);' +
      'box-sizing:border-box;margin-top:11px');
    var searchRow = el('div', 'mm-search-row');
    searchRow.setAttribute('style', 'display:flex;gap:9px;align-items:center;width:100%');
    var input = document.createElement('input');
    input.type = 'search';
    input.className = 'mm-search-input';
    input.placeholder = cfg.text.searchPlaceholder || 'Search a place or address';
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('style',
      /* 16px exactly, never less: iOS Safari zooms the entire page in when you
         focus an input with a smaller font, and will not zoom back out. */
      'flex:1;min-width:0;font:inherit;font-size:16px;padding:14px 18px;box-sizing:border-box;' +
      'border:1px solid ' + MM_TRACK + ';border-radius:8px;background:' + MM_SURFACE +
      ';color:inherit');
    var locateBtn = el('button', 'mm-locate', '◎');
    locateBtn.type = 'button';
    locateBtn.setAttribute('aria-label', 'Use my location');
    locateBtn.setAttribute('style',
      'flex:none;width:50px;height:50px;border-radius:8px;border:1px solid ' + MM_TRACK +
      ';background:' + MM_SURFACE + ';cursor:pointer;color:inherit;font-size:17px');
    searchRow.appendChild(input); searchRow.appendChild(locateBtn);
    searchBox.appendChild(searchRow);
    var suggList = el('div', 'mm-sugg-list mm-hide');
    suggList.setAttribute('style',
      'position:absolute;left:0;right:59px;top:calc(100% + 6px);' +
      'z-index:var(--mm-z-sugg,30);background:' +
      MM_SURFACE + ';border:1px solid ' + MM_TRACK + ';border-radius:12px;overflow:auto;' +
      'max-height:300px;box-shadow:0 12px 32px rgba(21,24,29,.12)');
    searchBox.appendChild(suggList);
    banner.appendChild(searchBox);

    /* Nothing below unlocks until the area is settled. The button exists for
       the case where the customer is happy with where the map already is --
       searching, dragging the map or using their location all count on their
       own, but somebody who does none of those still needs a way forward. */
    var areaNext = el('button', 'mm-area-next', 'Next step ›');
    areaNext.type = 'button';
    banner.appendChild(areaNext);
    wrap.appendChild(banner);

    /* How to move the map, above the circle rather than under it. Underneath
       it read as a caption on something you had already finished with. */
    var mapHint = el('p', 'mm-maphint', '');
    mapHint.setAttribute('style',
      'margin:0;display:flex;flex-wrap:wrap;gap:7px 9px;justify-content:center;' +
      'align-items:center;font-size:14.5px;color:' + MM_INK);
    wrap.appendChild(mapHint);

    /* ---- the board: circle in the middle, a step in each corner ---- */
    var board = el('div', 'mm-board');
    /* Width set here as well as in layout(), because the wrapper is a centred
       flex column: until the board has an explicit width it shrinks to its
       content, and layout() measures it before it has written its own style. */
    board.setAttribute('style', 'width:100%;box-sizing:border-box');
    var arena = el('div', 'mm-arena');
    var disc = el('div', 'mm-disc');
    var lens = el('div', 'mm-lens');
    var renderHost = el('div', 'mm-modelhost');
    renderHost.style.display = 'none';
    disc.appendChild(lens); disc.appendChild(renderHost);
    var ring = document.createElement('canvas');
    ring.className = 'mm-ring';
    arena.appendChild(disc); arena.appendChild(ring);
    /* B6.0: the size and the ground it covers, on the map itself. */
    var sizeTag = el('span', 'mm-sizetag');
    arena.appendChild(sizeTag);
    /* B6.0: the map column (desktop: sticky) and the steps panel. The arena
       is put in its column here and never moved again -- the map's WebGL
       canvas lives inside it. */
    var leftCol = el('div', 'mm-left');
    leftCol.appendChild(arena);
    var panel = el('div', 'mm-panel');
    /* B6.3, phones: the line joining the step numbers. In front of the
       cards, so it is the same weight all the way down, and behind the
       numbers. Placed and filled in paintRail(). */
    var rail = el('span', 'mm-rail');
    rail.setAttribute('aria-hidden', 'true');
    rail.setAttribute('style', 'display:none');
    var railFill = el('span', 'mm-railfill');
    railFill.setAttribute('style', 'position:absolute;left:0;top:0;width:4px;height:0;border-radius:4px;' +
      'background:' + MM_ACCENT + ';transition:height .7s cubic-bezier(.4,0,.2,1)');
    rail.appendChild(railFill);
    panel.appendChild(rail);

    /* The green Generate button lives inside step 5's card. Built here so there
       is one of it and wire() can reach it. */
    var buildBtn = el('button', 'mm-cta', esc(cfg.text.buildCta || 'Generate my model'));
    buildBtn.type = 'button';

    /* Sits directly under Generate while a build is running. */
    var cancelBtn = el('button', 'mm-cancel', 'Cancel this build');
    cancelBtn.type = 'button';
    cancelBtn.setAttribute('style', 'display:none');

    var cards = SEGMENTS.map(function (name, i) {
      var card = el('div', 'mm-step-card');
      var top = el('div', 'mm-step-top');
      top.setAttribute('style', 'display:flex;align-items:center;gap:10px');
      var num = el('span', 'mm-step-n', String(i + SEG_N0));
      var lab = el('span', 'mm-step-lab', esc(name));
      top.appendChild(num); top.appendChild(lab);
      /* B6.0: desktop, after a render -- reopens a folded step. */
      var chg = el('button', 'mm-step-chg', 'Change');
      chg.type = 'button';
      chg.setAttribute('style', 'display:none;flex:none;margin-left:6px;padding:6px 0 6px 6px;' +
        'border:0;background:none;cursor:pointer;font:600 14px/1 ' + MM_FACE + ';color:' + MM_INK +
        ';text-decoration:underline;text-underline-offset:3px;text-decoration-color:' + MM_TRACK);
      top.appendChild(chg);
      var val = el('div', 'mm-step-val', '');
      var opts = el('div', 'mm-step-opts');
      opts.setAttribute('style',
        'display:none;flex-direction:column;gap:8px;padding-top:2px;width:100%');
      var note = el('div', 'mm-step-note', '');
      note.setAttribute('style', 'font-size:12.5px;display:none;color:' + MM_LABEL);
      /* Back and Next. Kevin's call, and the right one: a choice that jumped you
         to the next step the instant you clicked it gave you no chance to click
         between the options and watch the circle change. */
      var nav = el('div', 'mm-step-nav');
      nav.setAttribute('style', 'display:none;gap:9px;align-items:center;padding-top:4px');
      var back = el('button', 'mm-step-back', '‹');
      back.type = 'button';
      back.setAttribute('aria-label', 'Previous step');
      var next = el('button', 'mm-step-next', 'Next');
      next.type = 'button';
      /* B6.0: the running total, between Back and Next on a phone. */
      var navPrice = el('div', 'mm-step-price');
      nav.appendChild(back); nav.appendChild(navPrice); nav.appendChild(next);
      card.appendChild(top); card.appendChild(val); card.appendChild(opts);
      card.appendChild(note); card.appendChild(nav);
      return { el: card, top: top, num: num, lab: lab, val: val, opts: opts,
               note: note, nav: nav, back: back, next: next, chg: chg, navPrice: navPrice };
    });
    /* On a phone the four corners have nowhere to go, so the steps move into a
       sheet under the circle: the current step only, with the other three as
       chips above it. Everything stays on one screen and the controls sit in
       the thumb zone, which is the pattern every mobile checkout worth copying
       uses. On a wide screen the sheet is empty and the cards go back to the
       corners. */
    var sheet = el('div', 'mm-sheet');
    var chips = el('div', 'mm-chips');
    sheet.appendChild(chips);

    board.appendChild(leftCol);
    cards.forEach(function (c) { sheet.appendChild(c.el); });
    board.appendChild(sheet);
    wrap.appendChild(board);

    var turn = el('p', 'mm-turn', '');
    /* B5.47: the enlarge pill. Same action as tapping the model itself. */
    turn.addEventListener('click', function (ev) {
      /* B5.52: the room shots. */
      var rb = ev.target && ev.target.closest && ev.target.closest('.mm-room');
      if (rb) {
        ev.preventDefault(); ev.stopPropagation();
        return MM_openRooms(cfg.__mmRooms);
      }
      var b = ev.target && ev.target.closest && ev.target.closest('.mm-enl');
      if (!b) return;
      ev.preventDefault(); ev.stopPropagation();
      if (cfg.__mmLive && cfg.__mmLive.enlarge) return cfg.__mmLive.enlarge();
      var track = renderHost.querySelector('.mm-gal-track');
      var kids = track ? [].slice.call(track.children) : [];
      var w = kids.filter(function (c) { return c.querySelector('canvas'); })[0] || kids[0];
      if (w) w.click();
    });
    turn.setAttribute('style',
      'margin:0;text-align:center;font-size:13.5px;color:' + MM_LABEL);
    wrap.appendChild(turn);

    /* The angle dots and caption: directly under the circle, because they drive
       it. Everything else the preview builds goes below the buy button. */
    var belowHost = el('div', 'mm-below');
    /* Centred, because the dots and their caption are the control for the
       circle above them and were sitting hard against the left edge of a 720px
       box. */
    belowHost.setAttribute('style',
      'width:100%;max-width:720px;box-sizing:border-box;display:none;' +
      'text-align:center;flex-direction:column;align-items:center');
    wrap.appendChild(belowHost);

    var err = el('div', 'mm-err', '');
    err.setAttribute('style', 'color:#9B2C2C;font-size:13px;text-align:center;display:none');
    wrap.appendChild(err);

    /* Add to cart sits here, immediately under the circle and its dots -- not
       below the comparison row and the build stats, which is what made it a
       scroll away the moment a render landed. */
    var addBtn = el('button', 'mm-buy',
      '<span>' + (ETSY ? 'Get my Etsy code' : 'Add to cart') + '</span><span class="mm-buy-amt" style="opacity:.75"></span>');
    addBtn.type = 'button';
    addBtn.setAttribute('style',
      'width:100%;max-width:460px;background:' + MM_ACCENT + ';color:#fff;border:0;border-radius:14px;' +
      'padding:18px 22px;font:600 17px/1 ' + MM_FACE + ';cursor:pointer;display:none;' +
      'align-items:center;justify-content:center;gap:10px;box-sizing:border-box');
    wrap.appendChild(addBtn);

    var backBtn = el('button', 'mm-back', '‹ Change the area');
    backBtn.type = 'button';
    backBtn.setAttribute('style',
      'background:none;border:0;padding:6px 10px;cursor:pointer;color:' + MM_LABEL +
      ';font-size:14px;display:none');

    /* Start again, as distinct from Adjust the area. Adjust keeps every choice
       and reopens the map; this throws the choices away and goes back to step
       one. Quiet on purpose -- it sits under Add to cart and must not compete
       with it. */
    var restartBtn = el('button', 'mm-restart', 'Start a new model \u203A');
    restartBtn.type = 'button';
    restartBtn.setAttribute('style', 'display:none');
    /* B6.0: Adjust the area and Start again, side by side. */
    var actRow = el('div', 'mm-actrow');
    actRow.appendChild(backBtn); actRow.appendChild(restartBtn);
    /* B6.3: Start again asks once, in the page, before it clears anything. */
    var askBox = el('div', 'mm-ask');
    askBox.setAttribute('role', 'group');
    askBox.setAttribute('style', 'display:none');
    var askTxt = el('p', 'mm-ask-t', 'This clears your model and your choices.');
    var askYes = el('button', 'mm-ask-yes', 'Yes, start again');
    askYes.type = 'button';
    var askNo = el('button', 'mm-ask-no', 'Keep my model');
    askNo.type = 'button';
    askBox.appendChild(askTxt); askBox.appendChild(askNo); askBox.appendChild(askYes);
    actRow.appendChild(askBox);
    wrap.appendChild(actRow);

    /* The comparison link, the legend and the build stats. Below the buy
       button on purpose: useful, but not worth standing between someone and
       the checkout. */
    var restHost = el('div', 'mm-rest');
    restHost.setAttribute('style',
      'width:100%;max-width:720px;box-sizing:border-box;display:none');
    wrap.appendChild(restHost);

    /* Attribution, and not optional: Mini Skyline's licence requires a credit on
       every commercial use of a model it generated, and OpenStreetMap's requires
       one wherever its data is shown. */
    var credit = el('p', 'mm-credit',
      'Models generated with <a href="https://miniskyline.com" target="_blank" rel="noopener">Mini Skyline</a>' +
      ' · © <a href="https://www.maptiler.com/copyright/" target="_blank" rel="noopener">MapTiler</a>' +
      ' · Map data © <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a> contributors');
    credit.setAttribute('style',
      'margin:4px 0 0;text-align:center;font-size:9.5px;line-height:1.5;opacity:.75;color:' + MM_LABEL);   /* B7.5.0 */
    wrap.appendChild(credit);

    /* B6.0.1: the heading and the board share one box, so on a wide screen
       the pinned heading lets go at the same moment as the pinned map. Made
       before the map exists, so nothing holding a WebGL canvas is moved. */
    var stage = el('div', 'mm-stage6');
    wrap.insertBefore(stage, pageHead);
    stage.appendChild(pageHead); stage.appendChild(banner);
    stage.appendChild(mapHint); stage.appendChild(board);
    /* B6.0.1: the two room shots, open under the model on a wide screen. */
    var roomsRow = el('div', 'mm-roomsrow');
    roomsRow.setAttribute('style', 'display:none');

    /* B6.1, phones: the step you are on, pinned under the header, and the
       way on, pinned to the bottom of the screen. Styled in paintProg() and
       paintBar(); hidden on a wide screen. */
    var prog = el('div', 'mm-stepbar');
    prog.setAttribute('style', 'display:none');
    var progBtns = ['Place'].concat(SEGMENTS.map(function (n) {
      return n === 'Generate' ? 'Preview' : n === 'Name label' ? 'Label' : n;
    })).map(function (name) {
      var pb = el('button', 'mm-stepbar-b', esc(name));
      pb.type = 'button';
      pb.__mmName = name;
      prog.appendChild(pb);
      return pb;
    });
    wrap.insertBefore(prog, wrap.firstChild);
    var pbar = el('div', 'mm-pbar');
    pbar.setAttribute('style', 'display:none');
    var pbarTot = el('div', 'mm-pbar-tot', '');
    var pbarCancel = el('button', 'mm-pbar-cancel', 'Cancel');
    pbarCancel.type = 'button';
    var pbarBtn = el('button', 'mm-pbar-go', '');
    pbarBtn.type = 'button';
    pbar.appendChild(pbarTot); pbar.appendChild(pbarCancel); pbar.appendChild(pbarBtn);
    wrap.appendChild(pbar);

    root.appendChild(wrap);
    /* B7.1.0 (speed): the section holds this space open until now (B4.17), so
       the photos further down the page are not fetched before the map. */
    root.classList.add('mm-built');

    return {
      prog: prog, progBtns: progBtns, pbar: pbar, pbarTot: pbarTot, pbarBtn: pbarBtn,
      pbarCancel: pbarCancel,
      pdp: wrap, stage6: stage, roomsRow: roomsRow, banner: banner, bNum: bNum, bLab: bLab, where: where, price: price,
      areaNext: areaNext, areaEdit: areaEdit,
      head: bTop,
      searchBox: searchBox, searchInput: input, suggList: suggList,
      searchHint: turn, locateBtn: locateBtn,
      board: board, arena: arena, stage: arena, disc: disc, lens: lens, mapWrap: lens,
      mapHint: mapHint, sheet: sheet, chips: chips,
      modelHost: renderHost, renderHost: renderHost,
      belowHost: belowHost, restHost: restHost, ring: ring,
      cards: cards, turn: turn,
      err: err, buildBtn: buildBtn, backBtn: backBtn, addBtn: addBtn,
      restartBtn: restartBtn, cancelBtn: cancelBtn,
      buyAmt: addBtn.querySelector('.mm-buy-amt'),
      pageHead: pageHead, pageEyebrow: pageEyebrow, pageTitle: pageTitle, pageLead: pageLead,
      leftCol: leftCol, panel: panel, rail: rail, railFill: railFill, sizeTag: sizeTag, actRow: actRow, askBox: askBox, askTxt: askTxt, askYes: askYes, askNo: askNo, credit: credit
    };
  }

  function makeCropMap(box, cfg, hooks) {
    var canvasBox = el('div', 'mm-canvasbox');
    box.appendChild(canvasBox);
    var crop = el('div', 'mm-crop mm-hide');
    crop.style.borderColor = cfg.cropColour || '#F2C21A';
    crop.style.borderRadius = '50%';   // round models: the crop is a circle
    box.appendChild(crop);
    var readout = el('div', 'mm-readout mm-mono', '');
    box.appendChild(readout);
    var gate = el('div', 'mm-gate', esc(cfg.text.gate));
    box.appendChild(gate);
    var warn = el('div', 'mm-tilewarn mm-hide', '');
    box.appendChild(warn);
    var hint = el('div', 'mm-hint', cfg.text.dragHint);
    box.appendChild(hint);

    var map = null, ready = false, pending = null, locked = true, ground = 1000;

    attachGestures(box, function () { return ready ? map : null; }, {
      isLocked: function () { return locked; },
      onStart: function () { hideHint(); },
      onEnd: function (c) { hooks.onMove(c); },
      wheelEnd: function () { hideHint(); }
    });

    whenMapLibre(function (maplibregl) {
      /* B6.6: the style sheet arrives alongside the page now; make sure it
         applies before the map is made. */
      try {
        var mlCss = document.querySelector('link[data-mm-maplibre-css]');
        if (mlCss && mlCss.media !== 'all') mlCss.media = 'all';
      } catch (eC) {}
      map = new maplibregl.Map({ transformRequest: mmMapReq,
        container: canvasBox,
        style: cfg.styleUrl,
        center: [hooks.getCenter().lon, hooks.getCenter().lat],
        zoom: 14,
        minZoom: 3,
        maxZoom: 19,
        /* No built-in attribution control: a compact badge parked in the
           bottom-left corner of a square map lands halfway off a circle, which
           is exactly what Kevin photographed. The credit moves to the line
           under the configurator, where it is legible and still discharges
           MapTiler's and OpenStreetMap's attribution terms. */
        attributionControl: false,
        // We supply our own gestures, so MapLibre's handlers stay off entirely.
        interactive: false,
        maxPitch: 0,
        fadeDuration: 120
      });
      /* And no zoom buttons: the top-left corner of a square map is outside a
         circle. The instruction above the map names the gesture instead, which
         is what people actually reach for. */

      /* B7.1.0 (speed): the 3D engine used to come down as soon as the map
         settled, for every visitor. It now comes down when a size is picked
         (warmNow), still well before See my 3D preview, and never for
         someone who only looks at the map. */
      map.on('load', function () {
        ready = true;
        map.resize();
        if (!canvasBox.clientHeight) {
          warn.classList.remove('mm-hide');
          warn.textContent = 'The map container has no height. A theme style is overriding the configurator CSS.';
        }
        if (pending) { jump(pending); pending = null; }
        sizeCrop();
        if (!locked) fitCrop();
      });

      map.on('error', function (e) {
        if (!e || !e.error) return;
        warn.classList.remove('mm-hide');
        warn.textContent = 'Map tiles aren\u2019t loading. Check the map style URL in the section settings.';
      });

      // Cheap enough to run per frame: it only resizes one div and rewrites
      // the readout. The centre is reported once, when the gesture ends.
      map.on('move', sizeCrop);

      if (window.ResizeObserver) {
        new ResizeObserver(function () {
          if (map) { map.resize(); sizeCrop(); }
        }).observe(box);
      }
    }, function () {
      warn.classList.remove('mm-hide');
      warn.textContent = 'The map library failed to load. Check the MapLibre script URL.';
    });

    function sizeCrop() {
      if (!ready || !map) return;
      crop.classList.toggle('mm-hide', locked);
      readout.classList.toggle('mm-hide', locked);
      if (locked) return;

      var c = map.getCenter();
      /* Ask the map where the crop lands, rather than computing it from a
         metres-per-pixel formula of our own.

         The old formula assumed 256px tiles. MapLibre renders 512px ones, so a
         CSS pixel covers half as much ground as it claimed, every square came
         out at half its true width, and the render covered FOUR TIMES the area
         the customer had framed -- at every latitude, at every zoom, since the
         day the map was built. It reads as "close enough" in a city you know
         and as plainly wrong in one you don't.

         Projecting the SAME bbox that renderModel is handed makes the square
         correct by construction. There is no constant left that can be wrong,
         and if MapLibre ever changes tile size or projection this follows it. */
      var b = bboxFor(c.lat, c.lng, ground);
      var w = 0, h = 0;
      try {
        var nw = map.project([b.minLon, b.maxLat]);
        var se = map.project([b.maxLon, b.minLat]);
        w = Math.abs(se.x - nw.x);
        h = Math.abs(se.y - nw.y);
      } catch (e) { /* fall through */ }
      if (!(w > 1 && h > 1)) {
        // only if project() is unavailable -- note the +1 for 512px tiles
        var mppx = (156543.03392 * Math.cos(c.lat * D2R)) / Math.pow(2, map.getZoom() + 1);
        w = h = ground / mppx;
      }
      crop.style.width = w + 'px';
      crop.style.height = h + 'px';

      readout.innerHTML = esc(fmtCoord(c.lat, c.lng)) + '<br>' +
        '\u00D8 ' + fmtAcross(ground);
    }

    function fitCrop() {
      if (!ready || !map || locked) return;
      var c = map.getCenter();
      var b = bboxFor(c.lat, c.lng, ground);
      /* Padding back, deliberately. The big circle is the map; the yellow circle
         inside it is the crop that actually prints, and it has to read as
         smaller than the map or there is no way to see what you are leaving out
         while you pan. */
      map.fitBounds([[b.minLon, b.minLat], [b.maxLon, b.maxLat]],
        { padding: 26, animate: false, maxZoom: 19 });
      sizeCrop();
    }

    function jump(c) { map.jumpTo({ center: [c.lon, c.lat] }); }

    function hideHint() {
      if (hint && !hint.classList.contains('mm-hide')) hint.classList.add('mm-hide');
    }

    return {
      // Redraw only — never moves the camera, so panning stays the visitor's.
      update: function (g, isLocked) {
        ground = g;
        locked = isLocked;
        gate.classList.toggle('mm-hide', !isLocked);
        sizeCrop();
      },
      /* The live centre, straight from the map. The yellow square is drawn
         around this every frame, so anything that decides what to RENDER has to
         read the same value -- otherwise the square and the model are answering
         to two different sources and any path that moves the camera without
         finishing a pointer gesture leaves them disagreeing. */
      center: function () {
        if (!map || !ready) return null;
        var c = map.getCenter();
        return { lat: c.lat, lon: c.lng };
      },
      fit: function () { fitCrop(); },
      goTo: function (c) {
        if (!map || !ready) { pending = c; return; }
        jump(c);
        fitCrop();
      },
      /* fitCrop as well as sizeCrop. The crop ring starts hidden and only
         sizeCrop reveals it, and sizeCrop refuses to run before the map is
         ready -- so on a slow first paint the ring never appeared and the whole
         outer circle read as the selected area. */
      refresh: function () {
        if (!map) return;
        setTimeout(function () {
          map.resize();
          sizeCrop();
          if (!locked) fitCrop();
        }, 30);
      },
      isReady: function () { return !!ready; }
    };
  }



  /* A draggable split between the on-screen preview and a photograph of a
     finished model. The preview is deliberately reduced quality -- saying so in
     words invites doubt, showing the difference settles it. */
  /* Which pair of photos to show. A scheme-specific pair when one has been
     uploaded, the general pair otherwise -- resolved per image rather than per
     pair, so a scheme with only its real photo done still gets that photo
     against the general render instead of falling back wholesale. Nothing here
     ever returns empty while the general pair exists, which is what stops a
     half-filled setup showing a blank frame. */
  function examplePair(cfg, colourway) {
    var byCw = (cfg.exampleByCw || {})[colourway] || {};
    return {
      preview: byCw.preview || cfg.examplePreview || null,
      real: byCw.real || cfg.exampleReal || null,
      tailored: !!(byCw.preview || byCw.real)
    };
  }

  function openExampleCompare(cfg, colourway) {
    var m = modalShell(cfg.text.exampleTitle || 'View example', '', true);
    var pair = examplePair(cfg, colourway);
    if (!pair.preview && !pair.real) {
      /* No pictures configured yet. Say so plainly rather than opening an empty
         panel -- and name the setting, because the only person who will ever see
         this is whoever has to go and fill it in. */
      m.inner.appendChild(el('p', 'mm-foot-note',
        'No comparison images have been set yet. Add them in the theme editor ' +
        'under \u201cPreview vs the real model\u201d.'));
      return;
    }
    var wrap = el('div', 'mm-cmpx');
    wrap.innerHTML =
      '<div class="mm-cmpx-side mm-cmpx-real">' +
        (pair.real ? '<img src="' + esc(pair.real) + '" alt="">' : '') +
        '<span class="mm-cmpx-lab is-right">' +
          esc(cfg.text.exampleRealLabel || 'Model quality') + '</span>' +
      '</div>' +
      '<div class="mm-cmpx-side mm-cmpx-prev">' +
        (pair.preview ? '<img src="' + esc(pair.preview) + '" alt="">' : '') +
        '<span class="mm-cmpx-lab is-left">' +
          esc(cfg.text.examplePreviewLabel || 'Preview quality') + '</span>' +
      '</div>' +
      '<div class="mm-cmpx-handle" role="slider" aria-label="Compare" tabindex="0">' +
        '<span>\u2039 \u203A</span></div>';
    m.inner.appendChild(wrap);
    m.inner.appendChild(el('p', 'mm-foot-note',
      cfg.text.exampleNote ||
      'Drag to compare. The preview is a fast, simplified render. The model ' +
      'itself carries finer detail and a real surface finish.'));

    var handle = wrap.querySelector('.mm-cmpx-handle');
    var pct = 50;
    function apply() {
      wrap.style.setProperty('--mm-x', pct + '%');
      handle.style.left = pct + '%';
    }
    function at(clientX) {
      var r = wrap.getBoundingClientRect();
      pct = Math.max(2, Math.min(98, ((clientX - r.left) / r.width) * 100));
      apply();
    }
    var dragging = false;
    function down(e) { dragging = true; at((e.touches ? e.touches[0] : e).clientX); }
    function move(e) {
      if (!dragging) return;
      if (e.cancelable) e.preventDefault();      // never scroll the sheet mid-drag
      at((e.touches ? e.touches[0] : e).clientX);
    }
    function up() { dragging = false; }

    wrap.addEventListener('mousedown', down);
    wrap.addEventListener('touchstart', down, { passive: true });
    window.addEventListener('mousemove', move);
    wrap.addEventListener('touchmove', move, { passive: false });
    window.addEventListener('mouseup', up);
    wrap.addEventListener('touchend', up);
    handle.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { pct = Math.max(2, pct - 4); apply(); }
      if (e.key === 'ArrowRight') { pct = Math.min(98, pct + 4); apply(); }
    });
    m.onClose(function () {
      window.removeEventListener('mousemove', move);
      window.removeEventListener('mouseup', up);
    });
    apply();
  }

  /* Zooming used to open the raw render PNG on its own, which threw away the
     room the customer had just been shown. Cloning the pane keeps the backdrop,
     the model, and its position -- everything inside is sized in percentages,
     so it scales to any size cleanly. */
  function openLightboxNode(node, opts) {
    if (!node) return;
    /* B5.72: opts.aspect for a node that is not on the page (a guide photo),
       opts.hint for words that fit it, opts.fill to leave room for the hint
       and the Close button around a photo that has its own heading. */
    opts = opts || {};
    var r = node.getBoundingClientRect();
    var ar = opts.aspect || ((r.width && r.height) ? r.width / r.height : 1);
    var w = Math.min(window.innerWidth * 0.94, window.innerHeight * 0.88 * (opts.fill || 1) * ar);

    var lb = el('div', 'mm-lightbox');
    var big = node.cloneNode(true);
    var z = big.querySelector('.mm-pv-zoom');
    if (z) z.parentNode.removeChild(z);
    big.style.width = Math.round(w) + 'px';
    big.style.height = Math.round(w / ar) + 'px';
    big.style.maxWidth = 'none';
    big.style.maxHeight = 'none';
    big.style.opacity = '1';
    big.style.cursor = 'grab';
    var stage = el('div', 'mm-lb-stage');
    stage.appendChild(big);
    lb.appendChild(stage);

    /* An explicit way out. Tapping the backdrop works, but on a phone the image
       fills most of the screen and there is no visible signal that it does. */
    var shut = el('button', 'mm-lb-close', 'Close');
    shut.type = 'button';
    lb.appendChild(shut);
    shut.addEventListener('click', function (e) { e.stopPropagation(); close(); });

    /* Says how, once, and gets out of the way on the first zoom. */
    lb.appendChild(el('div', 'mm-lb-hint', opts.hint || (IS_TOUCH
      ? 'Pinch, or tap the model to zoom \u00B7 tap outside to close'
      : 'Scroll or double-click to zoom \u00B7 click outside to close')));

    document.body.appendChild(lb);

    /* ------------------------------- zoom -------------------------------- */
    /* Pinch, wheel, double-tap and drag, all against the same transform. The
       point people care about is the one under their fingers, so every zoom is
       anchored there rather than at the centre of the image -- zooming to the
       middle when you are looking at a corner is what makes a viewer feel like
       it is fighting you. */
    var MINZ = 1, MAXZ = 6;
    var zoom = 1, tx = 0, ty = 0;

    function clamp() {
      /* Never let the image drift off its own edges: at 1x it is pinned, and
         beyond that it can only travel as far as the overhang allows. */
      var r0 = stage.getBoundingClientRect();
      var maxX = Math.max(0, (r0.width * zoom - r0.width) / 2);
      var maxY = Math.max(0, (r0.height * zoom - r0.height) / 2);
      tx = Math.max(-maxX, Math.min(maxX, tx));
      ty = Math.max(-maxY, Math.min(maxY, ty));
    }
    function apply(animate) {
      stage.style.transition = animate ? 'transform .22s ease' : 'none';
      stage.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + zoom + ')';
      big.style.cursor = zoom > 1 ? 'grab' : 'zoom-in';
      lb.classList.toggle('is-zoomed', zoom > 1);
    }
    function zoomAt(nextZoom, cx, cy, animate) {
      var r0 = stage.getBoundingClientRect();
      var ox = cx - (r0.left + r0.width / 2);
      var oy = cy - (r0.top + r0.height / 2);
      var k = nextZoom / zoom;
      tx = tx - ox * (k - 1);
      ty = ty - oy * (k - 1);
      zoom = nextZoom;
      clamp(); apply(animate);
    }

    lb.addEventListener('wheel', function (e) {
      e.preventDefault();
      var next = Math.max(MINZ, Math.min(MAXZ, zoom * (e.deltaY < 0 ? 1.14 : 1 / 1.14)));
      zoomAt(next, e.clientX, e.clientY, false);
    }, { passive: false });

    /* Touch and mouse are handled on separate paths that must never both run.
       A tap on a phone fires touchend AND, ~300ms later, a synthesized click at
       the same point -- so the touchend zoomed in and the click handler
       immediately toggled it straight back out. From the outside that is a tap
       that does nothing at all. `lastTouch` is the timestamp of the last touch
       to finish; any click within 700ms of it is that phantom and is dropped. */
    var lastTouch = 0, pinched = false;
    var startD = 0, startZ = 1, panning = false, px = 0, py = 0, moved = 0;

    function dist(t) {
      var dx = t[0].clientX - t[1].clientX, dy = t[0].clientY - t[1].clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }
    function mid(t) {
      return { x: (t[0].clientX + t[1].clientX) / 2, y: (t[0].clientY + t[1].clientY) / 2 };
    }

    lb.addEventListener('touchstart', function (e) {
      moved = 0;
      if (e.touches.length === 2) {
        startD = dist(e.touches); startZ = zoom; panning = false;
        /* A pinch ends with both fingers lifting and `moved` still at zero, so
           without this every pinch was also read as a tap and undone. */
        pinched = true;
      } else if (e.touches.length === 1) {
        panning = true; px = e.touches[0].clientX; py = e.touches[0].clientY;
      }
    }, { passive: true });

    lb.addEventListener('touchmove', function (e) {
      if (e.touches.length === 2 && startD) {
        e.preventDefault();
        var m2 = mid(e.touches);
        zoomAt(Math.max(MINZ, Math.min(MAXZ, startZ * (dist(e.touches) / startD))),
               m2.x, m2.y, false);
      } else if (e.touches.length === 1 && panning && zoom > 1) {
        e.preventDefault();
        var t0 = e.touches[0];
        tx += t0.clientX - px; ty += t0.clientY - py;
        moved += Math.abs(t0.clientX - px) + Math.abs(t0.clientY - py);
        px = t0.clientX; py = t0.clientY;
        clamp(); apply(false);
      }
    }, { passive: false });

    lb.addEventListener('touchend', function (e) {
      if (e.touches.length === 0) {
        startD = 0; panning = false;
        lastTouch = Date.now();
        var wasPinch = pinched; pinched = false;
        /* One tap, not two. A single tap on the model toggles between fit and a
           working magnification, anchored on the point you touched; a tap
           anywhere else closes. Both decided here, on touchend -- the click
           that follows is ignored, so there is nothing left to fight with. */
        if (wasPinch || moved >= 8) return;
        var t1 = e.changedTouches && e.changedTouches[0];
        if (!t1) return;
        var hit = document.elementFromPoint(t1.clientX, t1.clientY);
        /* The Close button runs its own handler; leave it alone. */
        if (hit && hit.closest && hit.closest('.mm-lb-close')) return;
        if (big && hit && big.contains(hit)) {
          if (zoom > 1.05) { zoom = 1; tx = ty = 0; apply(true); }
          else zoomAt(2.6, t1.clientX, t1.clientY, true);
        } else {
          close();
        }
      }
    }, { passive: true });

    /* Mouse drag to pan once zoomed in. */
    var mdown = false, mx = 0, my = 0, mMoved = 0;
    big.addEventListener('mousedown', function (e) {
      if (zoom <= 1) return;
      mdown = true; mMoved = 0; mx = e.clientX; my = e.clientY;
      big.style.cursor = 'grabbing';
      e.preventDefault();
    });
    window.addEventListener('mousemove', onMouseMove);
    function onMouseMove(e) {
      if (!mdown) return;
      tx += e.clientX - mx; ty += e.clientY - my;
      mMoved += Math.abs(e.clientX - mx) + Math.abs(e.clientY - my);
      mx = e.clientX; my = e.clientY;
      clamp(); apply(false);
    }
    window.addEventListener('mouseup', onMouseUp);
    function onMouseUp() { mdown = false; big.style.cursor = zoom > 1 ? 'grab' : 'zoom-in'; }

    /* A click on the image zooms in; a click on the backdrop closes. Dragging
       does neither, or panning would keep dismissing the thing you are reading. */
    big.addEventListener('click', function (e) {
      e.stopPropagation();
      if (Date.now() - lastTouch < 700) return;   /* phantom click after a tap */
      if (mMoved > 6) { mMoved = 0; return; }
      if (zoom > 1.05) { zoom = 1; tx = ty = 0; apply(true); }
      else zoomAt(2.6, e.clientX, e.clientY, true);
    });
    lb.addEventListener('click', function () {
      if (Date.now() - lastTouch < 700) return;   /* touchend already decided */
      close();
    });

    function onKey(e) {
      if (e.key === 'Escape') close();
      if (e.key === '+' || e.key === '=') zoomAt(Math.min(MAXZ, zoom * 1.3), window.innerWidth / 2, window.innerHeight / 2, true);
      if (e.key === '-') zoomAt(Math.max(MINZ, zoom / 1.3), window.innerWidth / 2, window.innerHeight / 2, true);
    }
    document.addEventListener('keydown', onKey);

    function close() {
      document.removeEventListener('keydown', onKey);
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseup', onMouseUp);
      lb.remove();
    }

    apply(false);
  }

  function openLightbox(src) {
    if (!src) return;
    var lb = el('div', 'mm-lightbox');
    var big = el('img');
    big.src = src;
    lb.appendChild(big);
    lb.addEventListener('click', function () { lb.remove(); });
    document.body.appendChild(lb);
  }

  function isNarrow() { return window.innerWidth <= 940; }

  /* Add-on prices come from the Shopify product where possible. Keeping the
     amount in two places meant the page could quote one figure while the cart
     charged another, with nothing to catch the drift. */
  function addonOf(cfg, key) {
    var manual = (cfg.addons || {})[key] || { variantId: 0, price: 0 };
    var wanted = (cfg.addonTitles || {})[key];
    if (wanted && (cfg.addonVariants || []).length) {
      var w = String(wanted).toLowerCase().trim();
      for (var i = 0; i < cfg.addonVariants.length; i++) {
        var v = cfg.addonVariants[i];
        if (String(v.title || '').toLowerCase().trim() === w) {
          return { variantId: v.id, price: v.price, available: v.available };
        }
      }
    }
    return manual;
  }

  /* The whole configuration packed into a URL. This is what makes an "Open your
     model" link possible with no database: the link *is* the saved model. */
  function b64urlEncode(str) {
    return btoa(unescape(encodeURIComponent(str)))
      .replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  function b64urlDecode(str) {
    var t = str.replace(/-/g, '+').replace(/_/g, '/');
    while (t.length % 4) t += '=';
    return decodeURIComponent(escape(atob(t)));
  }

  function packState(st) {
    var o = {
      c: st.size ? st.size.cm : null,
      z: +st.zoomX.toFixed(2),
      a: +st.center.lat.toFixed(6),
      o: +st.center.lon.toFixed(6),
      w: st.colourway,
      f: st.frame,
      n: st.placeName || null
    };
    /* B7.0: a name label travels with a saved link. */
    if (st.labelSrc && st.labelSrc !== 'none' && st.labelText) o.l = [st.labelSrc, st.labelText, st.labelDate || '', st.labelIcon || ''];
    return b64urlEncode(JSON.stringify(o));
  }

  function unpackState(token) {
    try { return JSON.parse(b64urlDecode(token)); } catch (e) { return null; }
  }

  function readStateToken() {
    var href = (window.location && window.location.href) || '';
    var m = /[?&#]mm=([^&#]+)/.exec(href);
    return m ? m[1] : null;
  }

  /* -------------------------- modal shell helper ------------------------- */

  function modalShell(title, subtitle, wide) {
    var overlay = el('div', 'mm-modal');
    var inner = el('div', 'mm-modal-in');
    if (!wide) inner.style.maxWidth = '560px';
    var head = el('div', 'mm-modal-h',
      '<div><h3 class="mm-modal-t">' + esc(title) + '</h3>' +
      (subtitle ? '<p class="mm-modal-s">' + esc(subtitle) + '</p>' : '') + '</div>' +
      '<button type="button" class="mm-btn is-ghost">Close</button>');
    inner.appendChild(head);
    overlay.appendChild(inner);

    var host = el('div', 'mm');
    host.style.cssText = 'position:static;padding:0';
    host.appendChild(overlay);
    document.body.appendChild(host);

    /* The body is deliberately left alone. Pinning it with position:fixed is the
       standard scroll-lock, and it is what was moving the page: the browser drops
       to offset zero the moment the body goes fixed, and putting it back on close
       is a visible move however it is done. The overlay is fixed and covers the
       viewport, so locking the page underneath buys nothing worth that. */

    var closers = [];
    function close() {
      closers.forEach(function (f) { if (f) f(); });
      /* Nothing to restore, so nothing moves. The overlay simply goes. */
      host.remove();
    }
    head.querySelector('button').addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    function onKey(e) { if (e.key === 'Escape') close(); }
    document.addEventListener('keydown', onKey);
    closers.push(function () { document.removeEventListener('keydown', onKey); });

    return { inner: inner, close: close, onClose: function (f) { closers.push(f); } };
  }

  /* ---------------------------- email gate ------------------------------ */

  var OPT_IN_LABEL = 'Email me Mounted Maps news and offers. Unsubscribe any time.';
  /* B5.58 (Kevin, 5 Oct): everyone who gives an email at the gate joins the
     list, so the gate now says so plainly under the field instead of a box.
     The same sentence is stored with each address as the consent wording. */
  var OPT_IN_NOTE = 'We\u2019ll email your model, plus the odd offer from Mounted Maps. Unsubscribe any time.';

  function openEmailGate(cfg, onDone) {
    var m = modalShell(cfg.text.emailTitle, cfg.text.emailBody, false);
    var form = el('div', 'mm-plaque-form');
    var input = el('input', 'mm-input');
    input.type = 'email';
    input.placeholder = cfg.text.emailPlaceholder;
    input.autocomplete = 'email';
    form.appendChild(input);
    /* B5.53: the B5.49 marketing checkbox is gone (Kevin, 4 Oct). */
    var note = el('div', 'mm-gate-note', esc(OPT_IN_NOTE));
    note.style.cssText = 'margin-top:8px;font-size:12px;line-height:1.45;color:#6B6F69;text-align:left;';
    form.appendChild(note);
    var err = el('div', 'mm-err mm-hide', '');
    form.appendChild(err);
    m.inner.appendChild(form);

    var foot = el('div', 'mm-modal-f');
    var go = el('button', 'mm-btn', cfg.text.emailButton);
    go.type = 'button';
    foot.appendChild(go);
    if (cfg.emailSkip) {
      var skip = el('button', 'mm-addon-remove', 'Skip for now');
      skip.type = 'button';
      skip.style.flex = '0 0 auto';
      skip.addEventListener('click', function () { m.close(); onDone(null); });
      foot.appendChild(skip);
    }
    m.inner.appendChild(foot);

    function submit() {
      var v = input.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) {
        err.textContent = 'That doesn\u2019t look like an email address.';
        err.classList.remove('mm-hide');
        input.focus();
        return;
      }

      /* The jump is the keyboard, not the render. While the field is focused iOS
         has scrolled the page up to make room for the keyboard; dismissing it
         resizes the visual viewport and leaves the page somewhere else. Blurring
         first lets that settle before anything else changes, and the correction
         below catches whatever drift is left. */
      var before = window.pageYOffset || document.documentElement.scrollTop || 0;
      input.blur();
      m.close();
      onDone(v, true, OPT_IN_NOTE);      // B5.58: giving the email is the sign-up

      var root = document.documentElement;
      var t0 = Date.now();
      (function settle() {
        var now = window.pageYOffset || root.scrollTop || 0;
        if (Math.abs(now - before) > 4) {
          var prevBehavior = root.style.scrollBehavior;
          root.style.scrollBehavior = 'auto';       // never animate a correction
          window.scrollTo(0, before);
          root.style.scrollBehavior = prevBehavior;
        }
        /* The keyboard takes a few frames to finish collapsing, and the drift
           can land on any one of them, so keep watching briefly. */
        if (Date.now() - t0 < 400) requestAnimationFrame(settle);
      })();
    }
    /* Start the keyboard collapsing on touch-down, a beat before the click is
       processed, so the two do not happen in the same frame. */
    go.addEventListener('pointerdown', function () { input.blur(); });
    go.addEventListener('click', submit);
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') submit(); });
    /* No autofocus. THIS was the jump: focusing a field inside a fixed overlay
       makes the browser scroll the page underneath to bring that field into
       view, which happens the instant the green button is pressed and long
       before any render exists. The field is the only thing in the dialog --
       nobody needs it focused for them. */
  }

  /* ------------------ geometry source: Overture buildings ----------------- */
  /* OpenStreetMap has almost no building footprints across much of the global
     south. Roads, rivers, contours and trees are all mapped; the buildings
     were never traced. A render of Ejido or Ranchi therefore comes out
     correct and empty, which reads to a customer as broken.

     Overture's buildings theme is OSM conflated with Microsoft and Google ML
     footprints -- 2.5 billion buildings, ODbL, published as one 168 GB PMTiles
     archive on public S3. We never download it. We read the handful of byte
     ranges holding the tiles under the crop.

     No dependencies and no CDN, deliberately. The obvious route is the pmtiles
     library behind a MapLibre source, and that is precisely what does not work
     here: pmtiles 3.x registers a callback-style protocol, MapLibre 5 expects
     a promise, and the failure is silent -- zero buildings, no error, which
     cost an hour to find. Both formats are small and frozen, so we read them
     ourselves and own the failure modes. */

  var MM_OV = (function () {
    'use strict';

    /* Pinned release. Overture cuts a new one monthly; this is a dated snapshot,
       which is the behaviour we want — the same crop renders the same buildings
       next month. Bump it deliberately, never automatically. */
    var RELEASE = '2026-09-23.1';
    var ARCHIVE = 'https://overturemaps-extras-us-west-2.s3.us-west-2.amazonaws.com/' +
                  'tiles/' + RELEASE + '/buildings.pmtiles';

    /* The archive's max zoom. Asking for 15 gets nothing at all rather than an
       overzoomed 14, so this is not a preference. At z14 a tile spans ~2.4 km at
       the equator over a 4096 grid: ~0.6 m per unit, which on a 20 cm disc of
       1 km is 0.12 mm — below what the printer can resolve. */
    var Z = 14;

    var MAX_TILES = 9;      /* a crop wider than this many tiles is not our case */
    var FETCH_MS = 20000;
    /* B5.56: a ~1 MB tile on a slow phone connection can take longer than 20 s,
       and one timeout used to throw away every building. Each request now gets
       up to 3 tries, and a timeout that grows with its size (20 s floor, about
       25 KB/s assumed, 90 s ceiling). */
    var TRIES = 3;
    var BACKOFF_MS = [0, 900, 2600];
    function timeoutFor(len) { return Math.min(90000, Math.max(FETCH_MS, Math.round(len / 25))); }

    /* ----------------------------- varint --------------------------------- */
    /* Arithmetic, not bitwise. Tile offsets in a 168 GB archive run past 2^32,
       and `<<` in JS silently truncates to 32 bits. This is exact to 2^53. */
    function rv(p) {
      var r = 0, m = 1, b;
      do {
        b = p.buf[p.pos++];
        r += (b & 0x7f) * m;
        m *= 128;
      } while (b >= 0x80);
      return r;
    }
    function skipField(p, wire) {
      if (wire === 0) { rv(p); return; }
      if (wire === 1) { p.pos += 8; return; }
      if (wire === 2) { p.pos += rv(p); return; }
      if (wire === 5) { p.pos += 4; return; }
      throw new Error('bad wire type ' + wire);
    }

    /* ----------------------------- gunzip --------------------------------- */
    /* B5.56: a small pure-JS inflate for browsers without DecompressionStream
       (Safari before 16.4, older Android WebViews). Until now those phones
       silently fell back to OSM, which is how a thinly mapped town became an
       empty disc. tiny-inflate 1.0.3, Devon Govett, MIT licence. */
    var TINF = (function () {
var TINF_OK = 0;
var TINF_DATA_ERROR = -3;

function Tree() {
  this.table = new Uint16Array(16);   /* table of code length counts */
  this.trans = new Uint16Array(288);  /* code -> symbol translation table */
}

function Data(source, dest) {
  this.source = source;
  this.sourceIndex = 0;
  this.tag = 0;
  this.bitcount = 0;
  
  this.dest = dest;
  this.destLen = 0;
  
  this.ltree = new Tree();  /* dynamic length/symbol tree */
  this.dtree = new Tree();  /* dynamic distance tree */
}

/* --------------------------------------------------- *
 * -- uninitialized global data (static structures) -- *
 * --------------------------------------------------- */

var sltree = new Tree();
var sdtree = new Tree();

/* extra bits and base tables for length codes */
var length_bits = new Uint8Array(30);
var length_base = new Uint16Array(30);

/* extra bits and base tables for distance codes */
var dist_bits = new Uint8Array(30);
var dist_base = new Uint16Array(30);

/* special ordering of code length codes */
var clcidx = new Uint8Array([
  16, 17, 18, 0, 8, 7, 9, 6,
  10, 5, 11, 4, 12, 3, 13, 2,
  14, 1, 15
]);

/* used by tinf_decode_trees, avoids allocations every call */
var code_tree = new Tree();
var lengths = new Uint8Array(288 + 32);

/* ----------------------- *
 * -- utility functions -- *
 * ----------------------- */

/* build extra bits and base tables */
function tinf_build_bits_base(bits, base, delta, first) {
  var i, sum;

  /* build bits table */
  for (i = 0; i < delta; ++i) bits[i] = 0;
  for (i = 0; i < 30 - delta; ++i) bits[i + delta] = i / delta | 0;

  /* build base table */
  for (sum = first, i = 0; i < 30; ++i) {
    base[i] = sum;
    sum += 1 << bits[i];
  }
}

/* build the fixed huffman trees */
function tinf_build_fixed_trees(lt, dt) {
  var i;

  /* build fixed length tree */
  for (i = 0; i < 7; ++i) lt.table[i] = 0;

  lt.table[7] = 24;
  lt.table[8] = 152;
  lt.table[9] = 112;

  for (i = 0; i < 24; ++i) lt.trans[i] = 256 + i;
  for (i = 0; i < 144; ++i) lt.trans[24 + i] = i;
  for (i = 0; i < 8; ++i) lt.trans[24 + 144 + i] = 280 + i;
  for (i = 0; i < 112; ++i) lt.trans[24 + 144 + 8 + i] = 144 + i;

  /* build fixed distance tree */
  for (i = 0; i < 5; ++i) dt.table[i] = 0;

  dt.table[5] = 32;

  for (i = 0; i < 32; ++i) dt.trans[i] = i;
}

/* given an array of code lengths, build a tree */
var offs = new Uint16Array(16);

function tinf_build_tree(t, lengths, off, num) {
  var i, sum;

  /* clear code length count table */
  for (i = 0; i < 16; ++i) t.table[i] = 0;

  /* scan symbol lengths, and sum code length counts */
  for (i = 0; i < num; ++i) t.table[lengths[off + i]]++;

  t.table[0] = 0;

  /* compute offset table for distribution sort */
  for (sum = 0, i = 0; i < 16; ++i) {
    offs[i] = sum;
    sum += t.table[i];
  }

  /* create code->symbol translation table (symbols sorted by code) */
  for (i = 0; i < num; ++i) {
    if (lengths[off + i]) t.trans[offs[lengths[off + i]]++] = i;
  }
}

/* ---------------------- *
 * -- decode functions -- *
 * ---------------------- */

/* get one bit from source stream */
function tinf_getbit(d) {
  /* check if tag is empty */
  if (!d.bitcount--) {
    /* load next tag */
    d.tag = d.source[d.sourceIndex++];
    d.bitcount = 7;
  }

  /* shift bit out of tag */
  var bit = d.tag & 1;
  d.tag >>>= 1;

  return bit;
}

/* read a num bit value from a stream and add base */
function tinf_read_bits(d, num, base) {
  if (!num)
    return base;

  while (d.bitcount < 24) {
    d.tag |= d.source[d.sourceIndex++] << d.bitcount;
    d.bitcount += 8;
  }

  var val = d.tag & (0xffff >>> (16 - num));
  d.tag >>>= num;
  d.bitcount -= num;
  return val + base;
}

/* given a data stream and a tree, decode a symbol */
function tinf_decode_symbol(d, t) {
  while (d.bitcount < 24) {
    d.tag |= d.source[d.sourceIndex++] << d.bitcount;
    d.bitcount += 8;
  }
  
  var sum = 0, cur = 0, len = 0;
  var tag = d.tag;

  /* get more bits while code value is above sum */
  do {
    cur = 2 * cur + (tag & 1);
    tag >>>= 1;
    ++len;

    sum += t.table[len];
    cur -= t.table[len];
  } while (cur >= 0);
  
  d.tag = tag;
  d.bitcount -= len;

  return t.trans[sum + cur];
}

/* given a data stream, decode dynamic trees from it */
function tinf_decode_trees(d, lt, dt) {
  var hlit, hdist, hclen;
  var i, num, length;

  /* get 5 bits HLIT (257-286) */
  hlit = tinf_read_bits(d, 5, 257);

  /* get 5 bits HDIST (1-32) */
  hdist = tinf_read_bits(d, 5, 1);

  /* get 4 bits HCLEN (4-19) */
  hclen = tinf_read_bits(d, 4, 4);

  for (i = 0; i < 19; ++i) lengths[i] = 0;

  /* read code lengths for code length alphabet */
  for (i = 0; i < hclen; ++i) {
    /* get 3 bits code length (0-7) */
    var clen = tinf_read_bits(d, 3, 0);
    lengths[clcidx[i]] = clen;
  }

  /* build code length tree */
  tinf_build_tree(code_tree, lengths, 0, 19);

  /* decode code lengths for the dynamic trees */
  for (num = 0; num < hlit + hdist;) {
    var sym = tinf_decode_symbol(d, code_tree);

    switch (sym) {
      case 16:
        /* copy previous code length 3-6 times (read 2 bits) */
        var prev = lengths[num - 1];
        for (length = tinf_read_bits(d, 2, 3); length; --length) {
          lengths[num++] = prev;
        }
        break;
      case 17:
        /* repeat code length 0 for 3-10 times (read 3 bits) */
        for (length = tinf_read_bits(d, 3, 3); length; --length) {
          lengths[num++] = 0;
        }
        break;
      case 18:
        /* repeat code length 0 for 11-138 times (read 7 bits) */
        for (length = tinf_read_bits(d, 7, 11); length; --length) {
          lengths[num++] = 0;
        }
        break;
      default:
        /* values 0-15 represent the actual code lengths */
        lengths[num++] = sym;
        break;
    }
  }

  /* build dynamic trees */
  tinf_build_tree(lt, lengths, 0, hlit);
  tinf_build_tree(dt, lengths, hlit, hdist);
}

/* ----------------------------- *
 * -- block inflate functions -- *
 * ----------------------------- */

/* given a stream and two trees, inflate a block of data */
function tinf_inflate_block_data(d, lt, dt) {
  while (1) {
    var sym = tinf_decode_symbol(d, lt);

    /* check for end of block */
    if (sym === 256) {
      return TINF_OK;
    }

    if (sym < 256) {
      d.dest[d.destLen++] = sym;
    } else {
      var length, dist, offs;
      var i;

      sym -= 257;

      /* possibly get more bits from length code */
      length = tinf_read_bits(d, length_bits[sym], length_base[sym]);

      dist = tinf_decode_symbol(d, dt);

      /* possibly get more bits from distance code */
      offs = d.destLen - tinf_read_bits(d, dist_bits[dist], dist_base[dist]);

      /* copy match */
      for (i = offs; i < offs + length; ++i) {
        d.dest[d.destLen++] = d.dest[i];
      }
    }
  }
}

/* inflate an uncompressed block of data */
function tinf_inflate_uncompressed_block(d) {
  var length, invlength;
  var i;
  
  /* unread from bitbuffer */
  while (d.bitcount > 8) {
    d.sourceIndex--;
    d.bitcount -= 8;
  }

  /* get length */
  length = d.source[d.sourceIndex + 1];
  length = 256 * length + d.source[d.sourceIndex];

  /* get one's complement of length */
  invlength = d.source[d.sourceIndex + 3];
  invlength = 256 * invlength + d.source[d.sourceIndex + 2];

  /* check length */
  if (length !== (~invlength & 0x0000ffff))
    return TINF_DATA_ERROR;

  d.sourceIndex += 4;

  /* copy block */
  for (i = length; i; --i)
    d.dest[d.destLen++] = d.source[d.sourceIndex++];

  /* make sure we start next block on a byte boundary */
  d.bitcount = 0;

  return TINF_OK;
}

/* inflate stream from source to dest */
function tinf_uncompress(source, dest) {
  var d = new Data(source, dest);
  var bfinal, btype, res;

  do {
    /* read final block flag */
    bfinal = tinf_getbit(d);

    /* read block type (2 bits) */
    btype = tinf_read_bits(d, 2, 0);

    /* decompress block */
    switch (btype) {
      case 0:
        /* decompress uncompressed block */
        res = tinf_inflate_uncompressed_block(d);
        break;
      case 1:
        /* decompress block with fixed huffman trees */
        res = tinf_inflate_block_data(d, sltree, sdtree);
        break;
      case 2:
        /* decompress block with dynamic huffman trees */
        tinf_decode_trees(d, d.ltree, d.dtree);
        res = tinf_inflate_block_data(d, d.ltree, d.dtree);
        break;
      default:
        res = TINF_DATA_ERROR;
    }

    if (res !== TINF_OK)
      throw new Error('Data error');

  } while (!bfinal);

  if (d.destLen < d.dest.length) {
    if (typeof d.dest.slice === 'function')
      return d.dest.slice(0, d.destLen);
    else
      return d.dest.subarray(0, d.destLen);
  }
  
  return d.dest;
}

/* -------------------- *
 * -- initialization -- *
 * -------------------- */

/* build fixed huffman trees */
tinf_build_fixed_trees(sltree, sdtree);

/* build extra bits and base tables */
tinf_build_bits_base(length_bits, length_base, 4, 3);
tinf_build_bits_base(dist_bits, dist_base, 2, 1);

/* fix a special case */
length_bits[28] = 0;
length_base[28] = 258;

return tinf_uncompress;

    })();
    function gunzipJs(u8) {
      var flg = u8[3], pos = 10;
      if (flg & 4) pos += 2 + (u8[pos] | (u8[pos + 1] << 8));   // FEXTRA
      if (flg & 8) { while (u8[pos++]) {} }                     // FNAME
      if (flg & 16) { while (u8[pos++]) {} }                    // FCOMMENT
      if (flg & 2) pos += 2;                                    // FHCRC
      var n = u8.length;
      var size = (u8[n - 4] | (u8[n - 3] << 8) | (u8[n - 2] << 16)) + u8[n - 1] * 16777216;
      var out = new Uint8Array(size);
      TINF(u8.subarray(pos, n - 8), out);
      return out;
    }

    function gunzip(u8) {
      /* A gzip member always starts 1f 8b. PMTiles says what the compression is
         in its header, but a mismatch there would corrupt everything downstream
         silently, so we check the bytes instead of trusting the field. */
      if (!(u8[0] === 0x1f && u8[1] === 0x8b)) return Promise.resolve(u8);
      if (typeof DecompressionStream === 'undefined') {
        try { return Promise.resolve(gunzipJs(u8)); } catch (eJ) { return Promise.reject(eJ); }
      }
      var s = new Blob([u8]).stream().pipeThrough(new DecompressionStream('gzip'));
      return new Response(s).arrayBuffer().then(function (b) { return new Uint8Array(b); },
        function () { return gunzipJs(u8); });   // a stream error: try the JS path once
    }

    /* ------------------------------ ranges -------------------------------- */
    function getRangeOnce(url, off, len) {
      var ms = timeoutFor(len);
      var ctl = (typeof AbortController !== 'undefined') ? new AbortController() : null;
      var timer = setTimeout(function () { if (ctl) ctl.abort(); }, ms);
      return fetch(url, {
        headers: { Range: 'bytes=' + off + '-' + (off + len - 1) },
        signal: ctl ? ctl.signal : undefined
      }).then(function (r) {
        if (r.status !== 206 && r.status !== 200) {
          var er = new Error('overture range ' + r.status);
          er.status = r.status;
          throw er;
        }
        return r.arrayBuffer();
      }).then(function (b) {
        clearTimeout(timer);
        return new Uint8Array(b);
      }, function (e) {
        clearTimeout(timer);
        if (e && e.name === 'AbortError') e = new Error('timeout after ' + Math.round(ms / 1000) + 's');
        throw e;
      });
    }

    /* B5.56: up to TRIES attempts with a short backoff. A plain 4xx other than
       408/429 will not get better by asking again, so that fails at once. */
    function getRange(url, off, len) {
      var attempt = 0;
      function go() {
        return getRangeOnce(url, off, len).catch(function (e) {
          attempt++;
          var st = e && e.status;
          var hopeless = st && st >= 400 && st < 500 && st !== 408 && st !== 429;
          if (hopeless || attempt >= TRIES) throw e;
          return new Promise(function (res) { setTimeout(res, BACKOFF_MS[attempt] || 2600); }).then(go);
        });
      }
      return go();
    }

    /* ---------------------------- pmtiles v3 ------------------------------- */
    /* Header is a fixed 127 bytes. We only need the two directory extents and
       the tile-data origin; the rest is read for the sanity checks. */
    function readHeader(u8) {
      var d = new DataView(u8.buffer, u8.byteOffset, u8.byteLength);
      var magic = String.fromCharCode(u8[0], u8[1], u8[2], u8[3], u8[4], u8[5], u8[6]);
      if (magic !== 'PMTiles') throw new Error('not a pmtiles archive');
      if (u8[7] !== 3) throw new Error('pmtiles spec v' + u8[7] + ', expected 3');
      /* B5.56: DataView.getBigUint64 is missing on older Safari; two 32-bit
         reads are exact for every offset this archive can hold (< 2^53). */
      function u64(o) {
        if (d.getBigUint64) return Number(d.getBigUint64(o, true));
        return d.getUint32(o, true) + d.getUint32(o + 4, true) * 4294967296;
      }
      return {
        rootOff: u64(8), rootLen: u64(16),
        leafOff: u64(40), leafLen: u64(48),
        dataOff: u64(56),
        tileType: u8[99], minZoom: u8[100], maxZoom: u8[101]
      };
    }

    /* Directory layout: a count, then four parallel columns — delta-coded tile
       ids, run lengths, lengths, offsets. An offset of 0 (except in the first
       entry) means "immediately after the previous tile", which is how a
       clustered archive avoids storing most offsets at all. */
    function decodeDir(u8) {
      var p = { buf: u8, pos: 0 };
      var n = rv(p), i, v;
      var ids = new Float64Array(n), runs = new Float64Array(n),
          lens = new Float64Array(n), offs = new Float64Array(n);
      var last = 0;
      for (i = 0; i < n; i++) { last += rv(p); ids[i] = last; }
      for (i = 0; i < n; i++) runs[i] = rv(p);
      for (i = 0; i < n; i++) lens[i] = rv(p);
      for (i = 0; i < n; i++) {
        v = rv(p);
        offs[i] = (v === 0 && i > 0) ? (offs[i - 1] + lens[i - 1]) : (v - 1);
      }
      return { n: n, ids: ids, runs: runs, lens: lens, offs: offs };
    }

    /* Tiles are ordered along a Hilbert curve, so a tile id is the curve index
       within its zoom plus every tile at every shallower zoom. */
    function tileId(z, x, y) {
      var acc = 0, t;
      for (t = 0; t < z; t++) acc += Math.pow(4, t);
      var n = Math.pow(2, z), rx, ry, d = 0, s, px = x, py = y;
      for (s = n / 2; s >= 1; s = s / 2) {
        rx = (px & s) > 0 ? 1 : 0;
        ry = (py & s) > 0 ? 1 : 0;
        d += s * s * ((3 * rx) ^ ry);
        if (ry === 0) {
          if (rx === 1) { px = s - 1 - px; py = s - 1 - py; }
          t = px; px = py; py = t;
        }
      }
      return acc + d;
    }

    /* Largest entry whose id is <= the one we want. A run covers several ids
       with one entry; run length 0 marks a pointer to a leaf directory. */
    function findEntry(dir, want) {
      var lo = 0, hi = dir.n - 1, m, best = -1;
      while (lo <= hi) {
        m = (lo + hi) >> 1;
        if (dir.ids[m] <= want) { best = m; lo = m + 1; } else hi = m - 1;
      }
      if (best < 0) return null;
      if (dir.runs[best] === 0) {
        return { leaf: true, off: dir.offs[best], len: dir.lens[best] };
      }
      if (want - dir.ids[best] < dir.runs[best]) {
        return { leaf: false, off: dir.offs[best], len: dir.lens[best] };
      }
      return null;   /* a genuine hole: ocean, or nothing mapped */
    }

    function openArchive(url) {
      return getRange(url, 0, 16384).then(function (head) {
        var h = readHeader(head);
        var root;
        if (h.rootOff + h.rootLen <= head.length) {
          root = Promise.resolve(head.subarray(h.rootOff, h.rootOff + h.rootLen));
        } else {
          root = getRange(url, h.rootOff, h.rootLen);
        }
        return root.then(gunzip).then(function (rd) {
          return { url: url, h: h, root: decodeDir(rd), leaves: {} };
        });
      });
    }

    function getTile(ar, z, x, y) {
      var want = tileId(z, x, y);
      var e = findEntry(ar.root, want);
      if (!e) return Promise.resolve(null);
      var step = e.leaf
        ? (function () {
            var key = e.off + ':' + e.len;
            if (!ar.leaves[key]) {
              ar.leaves[key] = getRange(ar.url, ar.h.leafOff + e.off, e.len)
                .then(gunzip).then(decodeDir);
            }
            return ar.leaves[key].then(function (ld) { return findEntry(ld, want); });
          })()
        : Promise.resolve(e);
      return step.then(function (t) {
        if (!t || t.leaf) return null;
        return getRange(ar.url, ar.h.dataOff + t.off, t.len).then(gunzip);
      });
    }

    /* ------------------------------- mvt ----------------------------------- */
    /* Only what a building needs: the layer's keys and values, and each
       feature's tags and polygon geometry. Points and lines are skipped. */
    function readLayer(u8, wantName) {
      var p = { buf: u8, pos: 0 }, out = null;
      while (p.pos < u8.length) {
        var tag = rv(p), f = tag >> 3, w = tag & 7;
        if (f === 3 && w === 2) {
          var len = rv(p), end = p.pos + len;
          var L = parseLayer(u8, p.pos, end);
          p.pos = end;
          if (L && L.name === wantName) out = L;
        } else skipField(p, w);
      }
      return out;
    }

    function parseLayer(u8, from, to) {
      var p = { buf: u8, pos: from };
      var name = null, extent = 4096, keys = [], values = [], feats = [];
      while (p.pos < to) {
        var tag = rv(p), f = tag >> 3, w = tag & 7;
        if (f === 1 && w === 2) {
          var n = rv(p);
          name = utf8(u8, p.pos, p.pos + n); p.pos += n;
        } else if (f === 2 && w === 2) {
          var fl = rv(p); feats.push([p.pos, p.pos + fl]); p.pos += fl;
        } else if (f === 3 && w === 2) {
          var kl = rv(p); keys.push(utf8(u8, p.pos, p.pos + kl)); p.pos += kl;
        } else if (f === 4 && w === 2) {
          var vl = rv(p); values.push(parseValue(u8, p.pos, p.pos + vl)); p.pos += vl;
        } else if (f === 5 && w === 0) {
          extent = rv(p);
        } else skipField(p, w);
      }
      return { name: name, extent: extent, keys: keys, values: values, feats: feats };
    }

    function utf8(u8, a, b) {
      return new TextDecoder('utf-8').decode(u8.subarray(a, b));
    }

    function parseValue(u8, from, to) {
      var p = { buf: u8, pos: from };
      var d = new DataView(u8.buffer, u8.byteOffset, u8.byteLength);
      var v = null;
      while (p.pos < to) {
        var tag = rv(p), f = tag >> 3, w = tag & 7;
        if (f === 1 && w === 2) { var n = rv(p); v = utf8(u8, p.pos, p.pos + n); p.pos += n; }
        else if (f === 2 && w === 5) { v = d.getFloat32(p.pos, true); p.pos += 4; }
        else if (f === 3 && w === 1) { v = d.getFloat64(p.pos, true); p.pos += 8; }
        else if (f === 4 && w === 0) { v = rv(p); }
        else if (f === 5 && w === 0) { v = rv(p); }
        else if (f === 6 && w === 0) { var z = rv(p); v = (z >>> 1) ^ (-(z & 1)); }
        else if (f === 7 && w === 0) { v = rv(p) !== 0; }
        else skipField(p, w);
      }
      return v;
    }

    /* Geometry commands pack an id and a repeat count into one integer, and the
       parameters that follow are zigzag deltas from the previous point. */
    function readFeature(u8, from, to, L) {
      var p = { buf: u8, pos: from };
      var type = 0, tags = null, geom = null;
      while (p.pos < to) {
        var tag = rv(p), f = tag >> 3, w = tag & 7;
        if (f === 3 && w === 0) type = rv(p);
        else if (f === 2 && w === 2) { var tl = rv(p); tags = [p.pos, p.pos + tl]; p.pos += tl; }
        else if (f === 4 && w === 2) { var gl = rv(p); geom = [p.pos, p.pos + gl]; p.pos += gl; }
        else skipField(p, w);
      }
      if (type !== 3 || !geom) return null;     /* polygons only */

      var props = {};
      if (tags) {
        var tp = { buf: u8, pos: tags[0] };
        while (tp.pos < tags[1]) {
          var ki = rv(tp), vi = rv(tp);
          if (L.keys[ki] !== undefined) props[L.keys[ki]] = L.values[vi];
        }
      }

      var gp = { buf: u8, pos: geom[0] }, rings = [], cur = null;
      var x = 0, y = 0;
      while (gp.pos < geom[1]) {
        var cmd = rv(gp), id = cmd & 7, count = cmd >> 3, i;
        if (id === 1) {                          /* MoveTo: starts a ring */
          for (i = 0; i < count; i++) {
            var dx = rv(gp), dy = rv(gp);
            x += (dx >>> 1) ^ (-(dx & 1));
            y += (dy >>> 1) ^ (-(dy & 1));
            if (cur && cur.length) rings.push(cur);
            cur = [[x, y]];
          }
        } else if (id === 2) {                   /* LineTo */
          for (i = 0; i < count; i++) {
            var ex = rv(gp), ey = rv(gp);
            x += (ex >>> 1) ^ (-(ex & 1));
            y += (ey >>> 1) ^ (-(ey & 1));
            if (cur) cur.push([x, y]);
          }
        } else if (id === 7) {                   /* ClosePath */
          if (cur && cur.length) { cur.push([cur[0][0], cur[0][1]]); rings.push(cur); cur = null; }
        }
      }
      if (cur && cur.length) rings.push(cur);
      if (!rings.length) return null;
      return { props: props, rings: rings };
    }

    function signedArea(r) {
      var s = 0, i, j;
      for (i = 0, j = r.length - 1; i < r.length; j = i++) {
        s += (r[j][0] - r[i][0]) * (r[j][1] + r[i][1]);
      }
      return s / 2;
    }

    /* In MVT v2 an exterior ring winds one way and a hole the other, measured in
       tile space where y runs downward. Positive area starts a new polygon;
       negative area is a hole in the one before it. */
    function groupRings(rings) {
      var polys = [], cur = null, i;
      for (i = 0; i < rings.length; i++) {
        var a = signedArea(rings[i]);
        if (a === 0) continue;
        if (a > 0) { cur = [rings[i]]; polys.push(cur); }
        else if (cur) cur.push(rings[i]);
        else { cur = [rings[i]]; polys.push(cur); }
      }
      return polys;
    }

    function toLonLat(px, py, extent, z, tx, ty) {
      var n = Math.pow(2, z);
      var lon = ((tx + px / extent) / n) * 360 - 180;
      var k = Math.PI * (1 - 2 * ((ty + py / extent) / n));
      var lat = Math.atan(Math.sinh(k)) * 180 / Math.PI;
      return [lon, lat];
    }

    /* ------------------------- overture -> mm ------------------------------ */
    /* Overture's own field names, mapped onto the OSM keys the height and roof
       code already reads, so nothing downstream changes. Where Overture carries
       nothing — which is most of the global south, because an ML footprint has
       no storeys to count — MM_buildingHeight's footprint-area fallback takes
       over, exactly as it does for an untagged OSM building. */
    function toTags(p) {
      var t = {};
      if (p.height != null) t.height = p.height;
      if (p.num_floors != null) t['building:levels'] = p.num_floors;
      if (p.min_height != null) t.min_height = p.min_height;
      if (p.num_floors_underground != null) t['building:min_level'] = 0;
      if (p.roof_shape) t['roof:shape'] = p.roof_shape;
      if (p.roof_height != null) t['roof:height'] = p.roof_height;
      t.building = p.subtype || p.class || 'yes';
      return t;
    }

    function lon2x(lon, z) { return Math.floor((lon + 180) / 360 * Math.pow(2, z)); }
    function lat2y(lat, z) {
      var r = lat * Math.PI / 180;
      return Math.floor((1 - Math.log(Math.tan(r) + 1 / Math.cos(r)) / Math.PI) / 2 * Math.pow(2, z));
    }

    /* Returns building objects in the same shape the Overpass path produces, so
       the caller can drop them straight into out.buildings. heightOf and areaOf
       are passed in rather than imported: this module stays testable on its own. */
    function buildings(bbox, opts) {
      opts = opts || {};
      var heightOf = opts.heightOf || function () { return 8; };
      var areaOf = opts.areaOf || function () { return 100; };
      var onDiag = opts.diag || function () {};

      var x0 = lon2x(bbox.minLon, Z), x1 = lon2x(bbox.maxLon, Z);
      var y0 = lat2y(bbox.maxLat, Z), y1 = lat2y(bbox.minLat, Z);
      var want = [], tx, ty;
      for (tx = x0; tx <= x1; tx++) for (ty = y0; ty <= y1; ty++) want.push([tx, ty]);
      if (want.length > MAX_TILES) {
        return Promise.reject(new Error('crop spans ' + want.length + ' tiles'));
      }

      var t0 = Date.now(), bytes = 0;
      return openArchive(opts.archive || ARCHIVE).then(function (ar) {
        /* Sequential. Four parallel range requests against one S3 object is how
           you get throttled, and the tiles are ~1 MB each — the wire, not the
           round trip, is the cost. */
        var out = [], seen = {}, failed = 0, lastErr = null;
        return want.reduce(function (chain, t) {
          return chain.then(function () {
            /* B5.56: one tile that will not come is no longer a reason to throw
               away the ones that did -- half a town beats an empty disc. */
            return getTile(ar, Z, t[0], t[1]).catch(function (eT) {
              failed++; lastErr = eT; return null;
            }).then(function (raw) {
              if (!raw) return;
              bytes += raw.length;
              var L = readLayer(raw, 'building');
              if (!L) return;
              var i;
              for (i = 0; i < L.feats.length; i++) {
                var f = readFeature(raw, L.feats[i][0], L.feats[i][1], L);
                if (!f) continue;
                if (f.props.is_underground === true) continue;
                var polys = groupRings(f.rings), pi, ri;
                for (pi = 0; pi < polys.length; pi++) {
                  var rs = [];
                  for (ri = 0; ri < polys[pi].length; ri++) {
                    var ring = polys[pi][ri], conv = [], ci;
                    for (ci = 0; ci < ring.length; ci++) {
                      conv.push(toLonLat(ring[ci][0], ring[ci][1], L.extent, Z, t[0], t[1]));
                    }
                    rs.push(conv);
                  }
                  if (!rs.length || rs[0].length < 4) continue;
                  var o = rs[0][0];
                  /* Tiles overlap at their edges and a building on a boundary is
                     carried by both. Keep the copy whose first vertex lands in
                     the crop, and only once. */
                  if (o[0] < bbox.minLon || o[0] > bbox.maxLon ||
                      o[1] < bbox.minLat || o[1] > bbox.maxLat) continue;
                  var key = (f.props.id != null ? 'i' + f.props.id : '') +
                            'b' + o[0].toFixed(6) + ',' + o[1].toFixed(6) + ',' + rs[0].length;
                  if (seen[key]) continue;
                  seen[key] = 1;
                  var tg = toTags(f.props);
                  var h = heightOf(tg, areaOf(rs[0]));
                  out.push({
                    rings: rs, height: Math.max(h, 2.5), id: f.props.id || null,
                    rel: false, tag: tg.building,
                    lev: tg['building:levels'] || tg.height || '',
                    roof: tg['roof:shape'] || null,
                    roofHeight: parseFloat(tg['roof:height']) || 0,
                    ov: f.props['@geometry_source'] || 'Overture'
                  });
                }
              }
            });
          });
        }, Promise.resolve()).then(function () {
          if (failed && failed >= want.length) {
            throw lastErr || new Error('no tile arrived');
          }
          onDiag('overture: ' + out.length + ' buildings from ' + (want.length - failed) + '/' +
                 want.length + ' tile(s), ' + Math.round(bytes / 1024) + ' KB, ' +
                 ((Date.now() - t0) / 1000).toFixed(1) + 's' +
                 (failed ? ' (' + failed + ' tile(s) failed: ' + ((lastErr && lastErr.message) || '?') + ')' : ''));
          return { buildings: out, tiles: want.length, failed: failed, bytes: bytes, ms: Date.now() - t0 };
        });
      });
    }

    return {
      build: RELEASE, zoom: Z, archive: ARCHIVE,
      buildings: buildings,
      /* exported for the test rig only */
      _tileId: tileId, _openArchive: openArchive, _getTile: getTile, _readLayer: readLayer
    };
  })();


  /* Decides whether this crop is one of the gaps, and fills it if so.

     This was a ratio of buildings to roads, and it was wrong. Choman in
     Kurdistan came back 227 buildings against 192 roads -- a ratio of 1.18,
     just over the cut-off -- so the fill never ran, and the customer got a
     disc with a handful of buildings on it. Overture has 771 there. The ratio
     test detects buildings ABSENT and misses buildings SPARSE, and sparse is
     the commoner failure: OSM usually has the main structures and none of the
     rest.

     So: density per square kilometre, which is the thing actually being
     judged. Measured: Ejido 8, Choman 227, Grafton St 1,652, Darndale 2,449.
     A floor of 800 sits in the wide gap between a town OSM has half-drawn and
     one it has finished.

     Being liberal here is safe, and that is the point. The replace below only
     happens when Overture returns MORE buildings than OSM had, so the real
     gate is downstream: this test only decides whether to look. A false
     positive costs one tile fetch and changes nothing on the model; a false
     negative ships an empty disc to a paying customer. Not a symmetric bet. */
  /* B5.48, 2 Oct: the roads gate is gone. OV_MIN_ROADS = 20 sent every village
     -- Tehta (6 roads, Overture 1,772), Gorantla (11, 1,662), a Gujarat hospital
     (14, 1,746) -- out with zero buildings. A village HAS few roads; that is
     what makes it a village, not what makes it empty. The comment above already
     said a false positive costs one fetch. 21.4077 N 77.3611 E (2 roads,
     Overture 0) shows the honest empty case still comes out empty.

     And a middle band. Between 800 and 2,000/km2 a town is often half-drawn:
     the hospital and the main street traced, the lanes behind them not. Those
     are asked too, but only REPLACED when Overture has at least half as many
     again -- Grafton St (1,652 OSM vs 1,764 Overture) keeps its OSM buildings
     and their building:part detail, which Overture does not carry. */
  var OV_MIN_DENSITY = 800;   /* under this OSM is suspect: replace if Overture has more */
  var OV_MAX_DENSITY = 2000;  /* at or over this OSM is trusted: not asked */

  function mmOvertureFill(cfg, bbox, out) {
    if (!cfg || cfg.overtureFill === false) return Promise.resolve(out);
    if (!out || !out.buildings || !out.roads) return Promise.resolve(out);
    /* B5.48: a partial answer is no longer a reason to ship an empty disc. If
       the buildings query is the part that failed, Overture is exactly the
       thing that should stand in -- the diag line says so either way. */
    if (out.partial) diag('overture: Overpass answer was partial -- asking Overture anyway');

    var nb = out.buildings.length;

    var midLat = (bbox.minLat + bbox.maxLat) / 2;
    var wKm = (bbox.maxLon - bbox.minLon) * 111.32 * Math.cos(midLat * D2R);
    var hKm = (bbox.maxLat - bbox.minLat) * 110.57;
    var km2 = Math.max(0.01, Math.abs(wKm * hKm));
    var dens = nb / km2;
    if (dens >= OV_MAX_DENSITY) { out.overtureNote = 'osm dense'; return Promise.resolve(out); }
    var thin = dens < OV_MIN_DENSITY;

    diag('overture: ' + nb + ' buildings over ' + km2.toFixed(2) + ' km² (' +
         Math.round(dens) + '/km²) — ' + (thin
           ? 'thinner than OSM manages where it is properly surveyed.'
           : 'could be a half-drawn town.') + ' Asking Overture.');

    var ovOpts = { heightOf: MM_buildingHeight, areaOf: MM_ringAreaM2, diag: diag };
    /* B5.56: one more go at the whole thing before giving up -- the archive
       header and directories are fetched again, so a dropped connection on the
       first try does not decide the model. */
    return MM_OV.buildings(bbox, ovOpts).catch(function (e1) {
      diag('overture: first attempt failed (' + ((e1 && e1.message) || 'failed') + ') -- trying once more');
      return new Promise(function (res) { setTimeout(res, 1500); }).then(function () {
        return MM_OV.buildings(bbox, ovOpts);
      });
    }).then(function (r) {
      /* Replace, never merge. Overture already contains every OSM building
         here, conflated in at highest priority -- merging would draw the same
         handful twice, a metre apart. */
      var nOv = (r && r.buildings) ? r.buildings.length : 0;
      var better = thin ? nOv > nb : (nOv >= nb * 1.5 && nOv - nb >= 100);
      if (better) {
        out.buildings = r.buildings;
        out.buildingSource = 'overture';
        out.overture = { release: MM_OV.build, tiles: r.tiles, bytes: r.bytes, ms: r.ms };
        out.overtureNote = r.failed ? 'overture partial' : 'overture';
        diag('overture: buildings replaced — ' + nb + ' from OSM, ' +
             r.buildings.length + ' from Overture ' + MM_OV.build);
      } else {
        out.overtureNote = 'osm kept';
        diag('overture: nothing better to offer here — keeping the ' +
             nb + ' OSM buildings');
      }
      return out;
    }, function (e) {
      /* Never fatal. A render with the OSM buildings is what we had before
         this existed, and it is still a render. */
      out.overtureNote = 'ov failed: ' + String((e && e.message) || 'failed').slice(0, 60);
      diag('overture: unavailable (' + ((e && e.message) || 'failed') +
           ') — building from OSM alone');
      return out;
    });
  }

  /* -------------------- geometry source: vector tiles -------------------- */
  /* The tiles for this area are already loaded and cached by the map, and the
     OpenMapTiles schema carries building footprints with render heights. Pull
     from those instead of hitting Overpass: no third-party API to rate-limit
     us, no 30-second wait, and it can't fail while the map itself works.
     Overpass stays as a fallback for the rare style without a building layer. */

  function collectFromTiles(cfg, bbox) {
    return new Promise(function (resolve, reject) {
      whenMapLibre(function (maplibregl) {
        var holder = el('div');
        holder.style.cssText =
          'position:fixed;left:-9999px;top:0;width:900px;height:900px;pointer-events:none';
        document.body.appendChild(holder);

        var m = new maplibregl.Map({ transformRequest: mmMapReq,
          /* Its own style, not the one on screen. The visible map is satellite
             imagery now, and imagery carries no building footprints -- reading
             geometry out of it would come back empty every time. */
          container: holder,
          style: cfg.geomStyleUrl || cfg.styleUrl,
          interactive: false,
          attributionControl: false,
          bounds: [[bbox.minLon, bbox.minLat], [bbox.maxLon, bbox.maxLat]],
          fitBoundsOptions: { padding: 0, animate: false }
        });

        var done = false;
        function finish(err, data) {
          if (done) return;
          done = true;
          try { m.remove(); } catch (e) {}
          holder.remove();
          if (err) reject(err); else resolve(data);
        }
        var lastErr = '';
        var bail = setTimeout(function () {
          finish(new Error('tiles timed out after 20s' + (lastErr ? ' \u2014 ' + lastErr : '')));
        }, 20000);

        /* This used to swallow everything, so a map that could not start at all
           was reported as a generic tile timeout. On a phone the most likely
           reason is the browser refusing another WebGL context, and that is
           worth saying out loud. */
        m.on('error', function (ev) {
          var msg = (ev && ev.error && ev.error.message) || (ev && ev.message) || '';
          if (msg && !lastErr) lastErr = String(msg).slice(0, 120);
          diag('tile map error: ' + (msg || 'unknown'));
        });
        m.on('idle', function () {
          clearTimeout(bail);
          try {
            var style = m.getStyle();
            var srcId = null;
            Object.keys(style.sources || {}).forEach(function (k) {
              if (!srcId && style.sources[k].type === 'vector') srcId = k;
            });
            if (!srcId) return finish(new Error('nosource'));

            var out = {
              buildings: [], roads: [], water: [], waterways: [], coast: [],
              grass: [], urban: [], trees: [], hedges: [], rails: [],
              source: 'tiles', partial: false
            };
            var seen = {};

            function inBox(coords) {
              for (var i = 0; i < coords.length; i++) {
                var p = coords[i];
                if (p[0] >= bbox.minLon && p[0] <= bbox.maxLon &&
                    p[1] >= bbox.minLat && p[1] <= bbox.maxLat) return true;
              }
              return false;
            }
            // keep inner rings: a courtyard filled in solid is the single
            // biggest source of 'blobby' looking buildings
            function polys(geom) {
              if (geom.type === 'Polygon') return [geom.coordinates];
              if (geom.type === 'MultiPolygon') return geom.coordinates;
              return [];
            }
            function ringArea(r) {
              var a = 0;
              for (var i = 0, j = r.length - 1; i < r.length; j = i++) {
                a += (r[j][0] + r[i][0]) * (r[j][1] - r[i][1]);
              }
              return Math.abs(a / 2);
            }
            function lines(geom) {
              if (geom.type === 'LineString') return [geom.coordinates];
              if (geom.type === 'MultiLineString') return geom.coordinates;
              return [];
            }

            // layer names vary between schemas; try the known aliases
            function grab(names, handler) {
              names.forEach(function (layerName) {
                var feats;
                try {
                  feats = m.querySourceFeatures(srcId, { sourceLayer: layerName });
                } catch (e) { return; }
                (feats || []).forEach(handler);
              });
            }

            grab(['building', 'buildings'], function (f) {
              var p = f.properties || {};
              polys(f.geometry).forEach(function (rs) {
                var outer = rs[0];
                if (!outer || outer.length < 4 || !inBox(outer)) return;
                // drop slivers: tile clipping leaves degenerate scraps
                if (ringArea(outer) < 2e-9) return;
                var key = (f.id != null ? 'i' + f.id : '') +
                  'b' + outer[0][0].toFixed(6) + outer[0][1].toFixed(6) + outer.length;
                if (seen[key]) return;
                seen[key] = 1;
                /* Same height model as the Overpass path, so a tile fallback
                   does not silently switch every building back to a flat 8 m. */
                var h = MM_buildingHeight(p, MM_ringAreaM2(outer));
                /* Roof shape and roof height too. The Overpass path carries
                   these and the tile path did not, so every building on a
                   fallback render came back as a flat-topped box -- which is
                   most of why a failed fetch looks so much worse than it needs
                   to. OpenMapTiles exposes the same OSM keys, sometimes
                   flattened with an underscore. */
                out.buildings.push({
                  rings: rs, height: Math.max(h, 2.5), id: f.id,
                  roof: p['roof:shape'] || p.roof_shape || p.roof || null,
                  roofHeight: parseFloat(p['roof:height'] || p.roof_height) || 0
                });
              });
            });

            /* Everything that reads as open land. Farmland was the big omission:
               outside a city centre it is most of the ground, which is why rural
               crops came out bare while the same place elsewhere looks green. */
            var GREEN = {
              // landcover
              grass: 1, wood: 1, forest: 1, farmland: 1, wetland: 1, moor: 1,
              heath: 1, scrub: 1, tundra: 1,
              // landuse
              meadow: 1, orchard: 1, vineyard: 1, allotments: 1, farm: 1,
              greenfield: 1, plant_nursery: 1, village_green: 1, common: 1,
              recreation_ground: 1, cemetery: 1, grave_yard: 1, forestry: 1,
              // leisure and parks
              park: 1, garden: 1, pitch: 1, golf_course: 1, nature_reserve: 1,
              dog_park: 1, playground: 1, sports_centre: 1, track: 1
            };
            grab(['landcover', 'park', 'landuse'], function (f) {
              var p = f.properties || {};
              if (!GREEN[p.class] && !GREEN[p.subclass]) return;
              polys(f.geometry).forEach(function (rs) {
                var outer = rs[0];
                if (!outer || outer.length < 4 || !inBox(outer)) return;
                if (ringArea(outer) < 2e-9) return;
                var k = 'g' + outer[0][0].toFixed(5) + outer[0][1].toFixed(5) + outer.length;
                if (seen[k]) return;
                seen[k] = 1;
                out.grass.push({ rings: rs });
              });
            });

            /* A suburb is mostly 'minor' and 'service'. Dropping those left the
               terraces with no streets between them, which is most of why the
               model read as a solid mass of walls. */
            var ROAD_W = { motorway: 16, trunk: 14, primary: 12, secondary: 10,
                           tertiary: 9, minor: 7, service: 5, track: 4 };
            grab(['transportation', 'road', 'roads'], function (f) {
              var props = f.properties || {};
              var cls = props.class;
              if (!ROAD_W[cls]) return;
              // tunnels run dead straight under rivers and harbours; on a model
              // they read as scratches across the water
              if (props.brunnel === 'tunnel') return;
              var isBridge = props.brunnel === 'bridge';
              lines(f.geometry).forEach(function (l) {
                if (l.length < 2 || !inBox(l)) return;
                out.roads.push({ line: l, width: ROAD_W[cls], bridge: isBridge });
              });
            });

            grab(['water'], function (f) {
              polys(f.geometry).forEach(function (rs) {
                var outer = rs[0];
                if (!outer || outer.length < 4 || !inBox(outer)) return;
                var k = 'w' + outer[0][0].toFixed(5) + outer[0][1].toFixed(5) + outer.length;
                if (seen[k]) return;
                seen[k] = 1;
                out.water.push({ rings: rs });
              });
            });

            if (window.console) {
              console.info('[mm] tile geometry:', out.buildings.length, 'buildings,',
                out.roads.length, 'roads,', out.water.length, 'water,',
                out.grass.length, 'green');
            }
            if (!out.buildings.length) return finish(new Error('sparse'));
            finish(null, out);
          } catch (e) {
            finish(e);
          }
        });
      }, function () { reject(new Error('nomaplibre')); });
    });
  }

  /* Full-precision OSM via Overpass. This is the primary source: vector tiles
     are generalised for drawing — simplified geometry snapped to a per-tile
     grid — which is why buildings drifted off their streets and road edges came
     out ragged. Overpass returns the surveyed node coordinates. */


  /* Land that is built on rather than grown on. Kept apart from the green
     bucket so the two never fight over the same polygon. */
  var URBAN_LANDUSE = {
    residential: 1, commercial: 1, industrial: 1, retail: 1, farmyard: 1,
    construction: 1, brownfield: 1, garages: 1, quarry: 1
  };

  /* Density in metres between trees, by what the polygon actually is. A wood is
     packed; a park is sparse because most of it is mown grass and paths. */
  /* Metres between trees, by what the polygon actually is. Tightened
     throughout: at the old spacings a park got a tree every thirty metres,
     which on a 20 cm plate is one every six millimetres -- a scattering, not
     planting. The reference's parks and hillsides are carpeted, and that
     density is a large part of why its open ground reads as landscape and ours
     read as painted areas.

     Scrub and heath matter more than they look: on a Mediterranean hillside
     most of the slope is tagged that way, so an 11 m spacing was leaving the
     one thing covering most of the crop nearly bare. */
  function treeSpacingFor(t) {
    var n = t.natural, l = t.landuse, le = t.leisure;
    if (n === 'wood' || l === 'forest') return 4.5;
    if (l === 'orchard' || l === 'vineyard') return 5.5;
    if (n === 'scrub' || n === 'heath') return 7;
    if (n === 'grassland' || n === 'moor') return 0;   // B5.50: open ground is open
    if (le === 'park' || le === 'garden' || l === 'village_green') return 14;
    if (le === 'nature_reserve' || l === 'cemetery') return 13;
    if (l === 'allotments' || l === 'plant_nursery') return 9;
    return 0;                                   // grass, pitches, farmland: none
  }

  function pointInRings(lon, lat, rings) {
    var inside = false, r, i, j, k;
    for (k = 0; k < rings.length; k++) {
      r = rings[k];
      var hit = false;
      for (i = 0, j = r.length - 1; i < r.length; j = i++) {
        if (((r[i][1] > lat) !== (r[j][1] > lat)) &&
            (lon < (r[j][0] - r[i][0]) * (lat - r[i][1]) / (r[j][1] - r[i][1]) + r[i][0])) {
          hit = !hit;
        }
      }
      if (k === 0) { if (!hit) return false; inside = true; }
      else if (hit) return false;               // inside a hole
    }
    return inside;
  }

  function scatterInto(trees, rings, tags, seed) {
    var spacing = treeSpacingFor(tags);
    if (!spacing) return;
    /* B5.50: 1 = scattered over a park/garden/cemetery outline, where most of
       the ground is really lawn. The render keeps these only where the
       satellite actually sees tree cover. Woods, scrub and orchards are 0. */
    var soft = (tags.natural === 'wood' || tags.landuse === 'forest' ||
                tags.natural === 'scrub' || tags.natural === 'heath' ||
                tags.landuse === 'orchard' || tags.landuse === 'vineyard' ||
                tags.landuse === 'allotments' || tags.landuse === 'plant_nursery') ? 0 : 1;
    var r = rings[0], minLon = Infinity, maxLon = -Infinity,
        minLat = Infinity, maxLat = -Infinity, i;
    for (i = 0; i < r.length; i++) {
      if (r[i][0] < minLon) minLon = r[i][0];
      if (r[i][0] > maxLon) maxLon = r[i][0];
      if (r[i][1] < minLat) minLat = r[i][1];
      if (r[i][1] > maxLat) maxLat = r[i][1];
    }
    var latR = Math.cos(((minLat + maxLat) / 2) * D2R);
    var stepLon = spacing / (111320 * latR), stepLat = spacing / 110540;
    var cols = Math.ceil((maxLon - minLon) / stepLon);
    var rows = Math.ceil((maxLat - minLat) / stepLat);
    /* Raised with the spacing. At 5.5 m a modest wood needs a few thousand
       candidates, and the old ceiling turned a full wood into a bail-out. */
    if (cols < 1 || rows < 1 || cols * rows > 420000) return;   // absurd polygon

    // deterministic jitter: same park, same trees, every render
    var n = seed >>> 0;
    function rnd() { n = (n * 1664525 + 1013904223) >>> 0; return n / 4294967296; }

    var added = 0;
    for (var c = 0; c <= cols; c++) {
      for (var w = 0; w <= rows; w++) {
        var lon = minLon + (c + (rnd() - 0.5) * 0.7) * stepLon;
        var lat = minLat + (w + (rnd() - 0.5) * 0.7) * stepLat;
        if (lon < minLon || lon > maxLon || lat < minLat || lat > maxLat) continue;
        if (!pointInRings(lon, lat, rings)) continue;
        trees.push(soft ? [lon, lat, 1] : [lon, lat]);
        /* Was 1500. Tightening the spacing without lifting this made things
           WORSE, not better: the scan fills column by column, so a wood that
           wanted 2,200 trees got 1,500 of them all down one side and a hard
           straight edge where it stopped. A wood is either filled or it is
           not. */
        if (++added > 24000) return;            // one polygon cannot swamp the model
      }
    }
  }

  /* Fired when the email gate opens, so the network round trip overlaps with
     the visitor typing. Results land in overpassCached, so the real render a
     few seconds later reuses them instead of re-requesting. Failures are
     swallowed -- this is opportunistic, and the real attempt reports properly. */

  /* ------------------------- coastline to water ------------------------- */
  /* Seas and tidal rivers are not polygons in OSM. They are natural=coastline
     ways, directed so that LAND IS ON THE LEFT and water on the right. To fill
     them you have to clip the ways to the crop, then close each run back to the
     next one along the crop boundary, walking the boundary in the direction
     that puts the water inside. Without this, Manhattan has no rivers, Howth
     has no harbour and Sydney has no bay. */

  /* Sutherland-Hodgman against the crop rectangle.

     GPU clipping planes cut a building THROUGH its middle and leave the cut
     open, so anything straddling the plate edge rendered as a hollow shell --
     the sliced-off look along the border. Clipping the FOOTPRINT instead means
     the building is extruded already the right shape: a closed solid that ends
     flush with the edge, with a proper wall on it. The crop is a rectangle and
     therefore convex, so one pass per edge is exact.

     Works in lon/lat, which is safe because toLocal maps the bbox precisely
     onto the plate square -- clipping to the bbox IS clipping to the square. */
  function clipRingToBox(ring, b) {
    var out = ring.slice();
    if (out.length > 1) {
      var f = out[0], l = out[out.length - 1];
      if (f[0] === l[0] && f[1] === l[1]) out.pop();   // drop the closing repeat
    }
    var edges = [
      { axis: 0, at: b.minLon, keep: function (p) { return p[0] >= b.minLon; } },
      { axis: 0, at: b.maxLon, keep: function (p) { return p[0] <= b.maxLon; } },
      { axis: 1, at: b.minLat, keep: function (p) { return p[1] >= b.minLat; } },
      { axis: 1, at: b.maxLat, keep: function (p) { return p[1] <= b.maxLat; } }
    ];
    function meet(a, c, ed) {
      var d = c[ed.axis] - a[ed.axis];
      var t = d === 0 ? 0 : (ed.at - a[ed.axis]) / d;
      if (t < 0) t = 0; else if (t > 1) t = 1;
      return ed.axis === 0
        ? [ed.at, a[1] + (c[1] - a[1]) * t]
        : [a[0] + (c[0] - a[0]) * t, ed.at];
    }
    for (var e = 0; e < edges.length && out.length; e++) {
      var ed = edges[e], src = out;
      out = [];
      for (var i = 0; i < src.length; i++) {
        var cur = src[i], prev = src[(i + src.length - 1) % src.length];
        var curIn = ed.keep(cur), prevIn = ed.keep(prev);
        if (curIn) {
          if (!prevIn) out.push(meet(prev, cur, ed));
          out.push(cur);
        } else if (prevIn) {
          out.push(meet(prev, cur, ed));
        }
      }
    }
    if (out.length < 3) return null;
    out.push([out[0][0], out[0][1]]);        // close it again
    return out;
  }

  // outer ring plus any courtyards, each cut to the same window
  function clipRingsToBox(rs, b) {
    var outer = clipRingToBox(rs[0], b);
    if (!outer) return null;
    var kept = [outer];
    for (var i = 1; i < rs.length; i++) {
      if (!rs[i] || rs[i].length < 4) continue;
      var hole = clipRingToBox(rs[i], b);
      if (hole && hole.length >= 4) kept.push(hole);
    }
    return kept;
  }

  function clipSegToBox(a, c, b) {                     // Liang-Barsky
    var t0 = 0, t1 = 1, dx = c[0] - a[0], dy = c[1] - a[1];
    var ps = [-dx, dx, -dy, dy];
    var qs = [a[0] - b.minLon, b.maxLon - a[0], a[1] - b.minLat, b.maxLat - a[1]];
    for (var i = 0; i < 4; i++) {
      if (ps[i] === 0) { if (qs[i] < 0) return null; continue; }
      var r = qs[i] / ps[i];
      if (ps[i] < 0) { if (r > t1) return null; if (r > t0) t0 = r; }
      else { if (r < t0) return null; if (r < t1) t1 = r; }
    }
    return [[a[0] + t0 * dx, a[1] + t0 * dy], [a[0] + t1 * dx, a[1] + t1 * dy]];
  }

  function clipPolyToBox(pts, b) {
    var out = [], cur = null, i;
    for (i = 0; i < pts.length - 1; i++) {
      var seg = clipSegToBox(pts[i], pts[i + 1], b);
      if (!seg) { if (cur && cur.length > 1) out.push(cur); cur = null; continue; }
      if (!cur) cur = [seg[0]];
      else if (Math.abs(cur[cur.length - 1][0] - seg[0][0]) > 1e-12 ||
               Math.abs(cur[cur.length - 1][1] - seg[0][1]) > 1e-12) {
        if (cur.length > 1) out.push(cur);
        cur = [seg[0]];
      }
      cur.push(seg[1]);
    }
    if (cur && cur.length > 1) out.push(cur);
    return out;
  }

  /* Position along the crop boundary, 0..4, running CLOCKWISE from the NW
     corner. Clockwise is the direction that encloses the water side given
     OSM's land-on-the-left rule. */
  function perimT(pt, b) {
    var w = b.maxLon - b.minLon, h = b.maxLat - b.minLat;
    var eps = Math.max(w, h) * 1e-6;
    if (Math.abs(pt[1] - b.maxLat) < eps) return 0 + (pt[0] - b.minLon) / w;       // top W->E
    if (Math.abs(pt[0] - b.maxLon) < eps) return 1 + (b.maxLat - pt[1]) / h;       // right N->S
    if (Math.abs(pt[1] - b.minLat) < eps) return 2 + (b.maxLon - pt[0]) / w;       // bottom E->W
    if (Math.abs(pt[0] - b.minLon) < eps) return 3 + (pt[1] - b.minLat) / h;       // left S->N
    return -1;                                          // not on the boundary
  }

  function cornersBetween(t0, t1, b) {
    var corner = [[b.maxLon, b.maxLat], [b.maxLon, b.minLat],
                  [b.minLon, b.minLat], [b.minLon, b.maxLat]];
    var out = [], t = Math.ceil(t0 - 1e-9), guard = 0;
    var span = (t1 - t0 + 4) % 4;
    while (guard++ < 8) {
      var rel = (t - t0 + 4) % 4;
      if (rel > span + 1e-9 || (rel === 0 && guard > 1)) break;
      if (rel > 1e-9) out.push(corner[((t % 4) + 4) % 4 - 1 < 0 ? 3 : (((t % 4) + 4) % 4) - 1]);
      t += 1;
    }
    return out;
  }


  /* ----------------------- sea by flood fill ------------------------------
     Reconstructing sea from natural=coastline by walking closed rings is the
     textbook method and it is brittle: it depends on every run closing cleanly
     against the crop boundary and on the land-on-the-left winding holding, and
     when either fails it returns nothing (sea renders as land) or the
     complement (land renders as sea). Both have happened here.

     This decides the same question without either assumption. Draw the
     coastline into a grid as a barrier, flood fill inward from the crop edges,
     and then ask each resulting region a question with an unambiguous answer:
     does it contain any buildings or roads? The sea contains neither. Regions
     that are empty and large become water; everything else stays land.

     Output is axis-aligned rectangles rather than an outline, because the rest
     of the pipeline only ever asks "is this point water" and fills polygons --
     neither needs a pretty ring, and a rectangle cannot be malformed. */
  function seaByFloodFill(coastWays, bbox, buildings, roads, lc) {
    if (!coastWays || !coastWays.length) return [];
    var N = 200;
    var lonSpan = bbox.maxLon - bbox.minLon, latSpan = bbox.maxLat - bbox.minLat;
    if (!(lonSpan > 0) || !(latSpan > 0)) return [];
    var barrier = new Uint8Array(N * N);
    var region = new Int16Array(N * N);
    var i, j, k;

    function ix(lon, lat) {
      var ci = Math.floor(((lon - bbox.minLon) / lonSpan) * N);
      var cj = Math.floor(((lat - bbox.minLat) / latSpan) * N);
      if (ci < 0 || cj < 0 || ci >= N || cj >= N) return -1;
      return cj * N + ci;
    }

    /* Walk each coastline segment in steps smaller than a cell, so the barrier
       is continuous. A gap of one cell is enough for the fill to leak through
       and swallow the land. */
    var stepLon = lonSpan / N, stepLat = latSpan / N;
    for (k = 0; k < coastWays.length; k++) {
      var w = coastWays[k];
      for (i = 0; i < w.length - 1; i++) {
        var aLon = w[i][0], aLat = w[i][1], bLon = w[i + 1][0], bLat = w[i + 1][1];
        var steps = Math.ceil(Math.max(Math.abs(bLon - aLon) / stepLon,
                                       Math.abs(bLat - aLat) / stepLat) * 2) + 1;
        if (steps > 20000) steps = 20000;
        for (var s = 0; s <= steps; s++) {
          var f = s / steps;
          var c = ix(aLon + (bLon - aLon) * f, aLat + (bLat - aLat) * f);
          if (c >= 0) barrier[c] = 1;
        }
      }
    }

    // flood fill inward from every edge cell
    var next = 1, queue = new Int32Array(N * N), qh, qt;
    function fill(start) {
      qh = 0; qt = 0;
      queue[qt++] = start;
      region[start] = next;
      var count = 0;
      while (qh < qt) {
        var cur = queue[qh++];
        count++;
        var ci = cur % N, cj = (cur - ci) / N;
        if (ci > 0)     { var l = cur - 1; if (!barrier[l] && !region[l]) { region[l] = next; queue[qt++] = l; } }
        if (ci < N - 1) { var r = cur + 1; if (!barrier[r] && !region[r]) { region[r] = next; queue[qt++] = r; } }
        if (cj > 0)     { var d = cur - N; if (!barrier[d] && !region[d]) { region[d] = next; queue[qt++] = d; } }
        if (cj < N - 1) { var u = cur + N; if (!barrier[u] && !region[u]) { region[u] = next; queue[qt++] = u; } }
      }
      return count;
    }

    var sizes = [0], touchesEdge = [false];
    for (i = 0; i < N; i++) {
      var edges = [i, (N - 1) * N + i, i * N, i * N + (N - 1)];
      for (k = 0; k < 4; k++) {
        var e = edges[k];
        if (!barrier[e] && !region[e]) {
          sizes[next] = fill(e); touchesEdge[next] = true; next++;
        }
      }
    }
    /* Everything else as well, not only what touches the crop edge. A harbour
       closed off by a mole, a bay behind a spit, a lagoon -- all of them are
       enclosed by coastline and would be left as land by an edge-only fill,
       which is the sort of stray patch that shows up mid-water. The
       no-buildings-no-roads test below decides them the same way. */
    for (i = 0; i < N * N; i++) {
      if (!barrier[i] && !region[i]) {
        sizes[next] = fill(i); touchesEdge[next] = false; next++;
      }
    }
    if (next === 1) return [];

    // a region holding any of the town is not the sea
    var hasFeature = [];
    for (i = 0; i < next; i++) hasFeature.push(0);
    function mark(lon, lat) {
      var c = ix(lon, lat);
      if (c >= 0 && region[c]) hasFeature[region[c]]++;
    }
    for (i = 0; i < buildings.length; i++) {
      var br = buildings[i].rings && buildings[i].rings[0];
      if (br && br[0]) mark(br[0][0], br[0][1]);
    }
    for (i = 0; i < roads.length; i++) {
      var ln = roads[i].line;
      if (ln && ln[0]) mark(ln[0][0], ln[0][1]);
    }

    /* Two floors, not one. A region touching the crop edge has to be big to
       count -- that guard stops an empty field at the boundary being read as
       water. A region ENCLOSED by coastline is a different case: it is a
       harbour, a lagoon, a gap between islets, and it is small by nature. Held
       to the same floor, those came out as stray green patches sitting in open
       sea, which is the one place a viewer knows for certain is wrong.

       Both still require zero buildings and zero roads, which is what actually
       separates water from land. */
    /* Zero features was too strict. A harbour has a mole with a road along it,
       a bay has a jetty, an estuary has a bridge pier -- one sampled feature
       inside a thousand cells of open water was enough to call the whole basin
       land, which is the green patch sitting in the middle of a harbour.

       Judged by DENSITY instead: water is where there is essentially nothing,
       not where there is literally nothing. A town is orders of magnitude
       denser than a pier, so the two do not sit anywhere near the threshold. */
    /* Two thresholds, because the two cases carry very different prior odds.

       A region touching the crop EDGE might be open sea or might be the corner
       of a field, so it has to be both large and essentially featureless.

       A region ENCLOSED by coastline is a harbour, a bay, a lagoon, a channel
       between islets -- coastline is drawn around water, so being surrounded by
       it is itself strong evidence. Those get a far looser test, because the
       things inside them are moles, slipways, jetties and breakwaters, and one
       of those was enough to call an entire harbour land and leave a green
       wedge sitting in it.

       A real island still reads as land: it carries streets and buildings, and
       that is one or two orders of magnitude above this threshold, not a few
       per cent over it. */
    /* B5.48: the satellite gets a vote. Density alone flooded the LAND wherever
       OSM is thin: Dubai Festival City (land cover 23% water) and the Gilan
       coast (41%) both came out almost entirely sea, with the town's buildings
       standing in it -- the land side simply had too few mapped features to
       pass as land. WorldCover knows water from ground anywhere on Earth, at
       10 m, independent of how well a place has been mapped. So each region is
       sampled against it: mostly not water means land, whatever the density
       says; overwhelmingly water and not a town means sea. With no land cover
       the old density test stands on its own. */
    var lcW = null, lcT = null;
    if (lc && lc.at) {
      lcW = new Float64Array(next); lcT = new Float64Array(next);
      for (j = 1; j < N; j += 2) {
        for (i = 1; i < N; i += 2) {
          var rr = region[j * N + i];
          if (!rr) continue;
          var cls = lc.at(bbox.minLon + ((i + 0.5) / N) * lonSpan,
                          bbox.minLat + ((j + 0.5) / N) * latSpan);
          if (!cls) continue;                       // no data: no vote
          lcT[rr]++;
          if (cls === 80) lcW[rr]++;
        }
      }
    }
    var isSea = [], lcVeto = 0, lcAdd = 0;
    var edgeFloor = N * N * 0.015;
    var innerFloor = N * N * 0.0012;
    for (i = 0; i < next; i++) {
      var dens = sizes[i] > 0 ? hasFeature[i] / sizes[i] : 1;
      var limit = touchesEdge[i] ? 0.004 : 0.03;
      var bigEnough = sizes[i] >= (touchesEdge[i] ? edgeFloor : innerFloor);
      var sea = i > 0 && dens < limit && bigEnough;
      var wf = (lcT && lcT[i] >= 12) ? lcW[i] / lcT[i] : null;
      if (wf !== null && i > 0) {
        if (sea && wf < 0.4) { sea = false; lcVeto++; }
        else if (!sea && wf >= 0.7 && bigEnough && dens < 0.03) { sea = true; lcAdd++; }
      }
      isSea.push(sea);
    }
    if (window.console && (lcVeto || lcAdd)) {
      console.info('[mm] land cover overruled the flood fill: ' + lcVeto +
                   ' region(s) kept as land, ' + lcAdd + ' made sea');
    }
    var any = false, seaCells = 0, landRegions = 0;
    for (i = 1; i < next; i++) {
      if (isSea[i]) { any = true; seaCells += sizes[i]; }
      else if (!touchesEdge[i] && sizes[i] > innerFloor) landRegions++;
    }
    if (window.console && landRegions) {
      console.info('[mm] flood fill kept ' + landRegions + ' enclosed region(s) as land ' +
                   '(islands, or water it could not tell from land)');
    }
    if (!any) return [];

    /* Emit as rectangles, merged downward.

       One rectangle per row, overlapped slightly to hide the joins, was the
       obvious way and it is wrong: the overlap is two water surfaces at the
       same depth competing for the same pixels, which z-fights and draws a
       horizontal line across the sea at every row boundary. Fighting it with
       lifts or bias only moves the problem.

       Instead, runs are merged into maximal rectangles -- a run is extended
       downward for as long as the row beneath has exactly the same run -- and
       the rectangles share exact edges with no overlap at all. Nothing
       coincides, so nothing can fight, and the sea comes out as one clean
       surface anywhere in the world. */
    var out = [];
    var used = new Uint8Array(N * N);
    var isSeaCell = function (i, j) {
      var r = region[j * N + i];
      return r && isSea[r] && !used[j * N + i];
    };
    for (j = 0; j < N; j++) {
      for (i = 0; i < N; i++) {
        if (!isSeaCell(i, j)) continue;
        // widest run on this row
        var i1 = i;
        while (i1 + 1 < N && isSeaCell(i1 + 1, j)) i1++;
        // extend down while the row beneath matches this run exactly
        var j1 = j;
        for (;;) {
          var nj = j1 + 1;
          if (nj >= N) break;
          var ok = true;
          for (k = i; k <= i1; k++) {
            if (!isSeaCell(k, nj)) { ok = false; break; }
          }
          if (ok && i > 0 && isSeaCell(i - 1, nj)) ok = false;
          if (ok && i1 + 1 < N && isSeaCell(i1 + 1, nj)) ok = false;
          if (!ok) break;
          j1 = nj;
        }
        for (var mj = j; mj <= j1; mj++) {
          for (k = i; k <= i1; k++) used[mj * N + k] = 1;
        }
        var lo2 = bbox.minLon + (i / N) * lonSpan;
        var hi2 = bbox.minLon + ((i1 + 1) / N) * lonSpan;
        var la2 = bbox.minLat + (j / N) * latSpan;
        var lb2 = bbox.minLat + ((j1 + 1) / N) * latSpan;
        out.push({ rings: [[[lo2, la2], [hi2, la2], [hi2, lb2], [lo2, lb2], [lo2, la2]]],
                   kind: 'sea', flood: true });
        i = i1;
      }
    }
    return out;
  }

  /* B5.48: the flood fill runs while the Overpass answer is assembled -- before
     Overture has filled the buildings in and, often, before land cover is back.
     Both are what tell a thinly mapped shore from open water, so the sea is
     decided again once they are here. Only flood-fill sea is replaced; sea
     from the ring walk or from polygons is left alone. Never fatal. */
  function rejudgeSea(data, b, lc) {
    try {
      if (!data || !data.coast || !data.coast.length || !data.water) return;
      var had = 0;
      for (var hi = 0; hi < data.water.length; hi++) if (data.water[hi].flood) had++;
      if (!had) return;
      var fresh = seaByFloodFill(data.coast, b, data.buildings || [], data.roads || [], lc || null);
      data.water = data.water.filter(function (o) { return !o.flood; }).concat(fresh);
      diag('sea re-judged with ' + (data.buildingSource === 'overture' ? 'Overture' : 'OSM') +
           ' buildings' + (lc ? ' + land cover' : '') + ': ' + had + ' -> ' +
           fresh.length + ' flood-fill area(s)');
    } catch (e) {
      if (window.console) console.warn('[mm] sea re-judge failed:', e && e.message);
    }
  }

  function coastlineWater(ways, b) {
    var runs = [], i, k;
    for (i = 0; i < ways.length; i++) {
      var parts = clipPolyToBox(ways[i], b);
      for (k = 0; k < parts.length; k++) {
        var pr = parts[k];
        var ts = perimT(pr[0], b), te = perimT(pr[pr.length - 1], b);
        if (ts < 0 || te < 0) continue;                 // ring wholly inside: island, skip
        runs.push({ pts: pr, ts: ts, te: te, used: false });
      }
    }
    if (!runs.length) return [];

    var rings = [];
    for (i = 0; i < runs.length; i++) {
      if (runs[i].used) continue;
      var ring = [], cur = runs[i], startT = cur.ts, guard = 0;
      while (cur && !cur.used && guard++ < 64) {
        cur.used = true;
        ring = ring.concat(cur.pts);
        // walk the boundary forward from this exit to the next run's entry
        var best = null, bestGap = Infinity;
        for (k = 0; k < runs.length; k++) {
          if (runs[k].used) continue;
          var gap = (runs[k].ts - cur.te + 4) % 4;
          if (gap < bestGap) { bestGap = gap; best = runs[k]; }
        }
        var closeGap = (startT - cur.te + 4) % 4;
        if (!best || closeGap <= bestGap) {
          ring = ring.concat(cornersBetween(cur.te, startT, b));
          break;
        }
        ring = ring.concat(cornersBetween(cur.te, best.ts, b));
        cur = best;
      }
      // three points is a legitimate water area: a coast cutting one corner
      if (ring.length >= 3) { ring.push(ring[0].slice()); rings.push(ring); }
    }
    return rings;
  }


  /* Water from the vector tiles, always, alongside Overpass.

     Reconstructing sea from natural=coastline ways is the correct thing to do
     and it is also fragile: one unclosed run and either the river stays dry or
     the land floods. The tile builder already solved that problem globally and
     ships water as finished polygons -- oceans, tidal rivers, docks, lakes.
     Tile geometry is generalised, but for a river bank a few metres of
     simplification is invisible, and being reliably blue beats being precisely
     absent. This is cheap: one offscreen map, water layer only. */

  /* B5.49: the tile water/green collectors are a fallback behind Overpass.
     They waited 15 s for MapLibre's 'idle', which never fires in a hidden tab
     (no animation frames), so a customer who switched apps mid-build paid the
     full 15 s twice. Now: 6 s at most, and give up at once if the tab is or
     becomes hidden. */
  var TILE_BAIL_MS = 6000;
  function tileBail(cb) {
    var over = false, t = null;
    function stop() {
      over = true;
      clearTimeout(t);
      document.removeEventListener('visibilitychange', vis);
    }
    function fire() { if (over) return; stop(); cb(); }
    function vis() { if (document.hidden) fire(); }
    document.addEventListener('visibilitychange', vis);
    t = setTimeout(fire, document.hidden ? 0 : TILE_BAIL_MS);
    return { cancel: stop };
  }

  function collectWaterFromTiles(cfg, bbox) {
    return new Promise(function (resolve) {
      var done = false;
      function finish(list) { if (!done) { done = true; resolve(list || []); } }
      if (!cfg.styleUrl) return finish([]);

      whenMapLibre(function (maplibregl) {
        var holder = el('div');
        holder.style.cssText =
          'position:fixed;left:-9999px;top:0;width:900px;height:900px;pointer-events:none';
        document.body.appendChild(holder);

        var m;
        try {
          m = new maplibregl.Map({ transformRequest: mmMapReq,
            container: holder, style: cfg.styleUrl, interactive: false,
            attributionControl: false,
            bounds: [[bbox.minLon, bbox.minLat], [bbox.maxLon, bbox.maxLat]],
            fitBoundsOptions: { padding: 0, animate: false }
          });
        } catch (e) { holder.remove(); return finish([]); }

        function cleanup(list) {
          try { m.remove(); } catch (e) {}
          holder.remove();
          finish(list);
        }
        var bail = tileBail(function () { cleanup([]); });
        m.on('error', function () {});
        m.on('idle', function () {
          bail.cancel();
          var out = [], seen = {};
          try {
            var style = m.getStyle(), srcId = null;
            Object.keys(style.sources || {}).forEach(function (k) {
              if (!srcId && style.sources[k].type === 'vector') srcId = k;
            });
            if (!srcId) return cleanup([]);
            ['water', 'ocean', 'waterway_area', 'water_polygons'].forEach(function (layer) {
              var feats;
              try { feats = m.querySourceFeatures(srcId, { sourceLayer: layer }); }
              catch (e) { return; }
              (feats || []).forEach(function (f) {
                var g = f.geometry;
                var polys = g.type === 'Polygon' ? [g.coordinates]
                          : g.type === 'MultiPolygon' ? g.coordinates : [];
                polys.forEach(function (rs) {
                  var outer = rs[0];
                  if (!outer || outer.length < 4) return;
                  /* querySourceFeatures returns everything in every LOADED tile,
                     not everything in the crop -- and MapLibre loads well beyond
                     the bounds it was fitted to. Without this, water from a
                     neighbouring tile was being added to the model, which is how
                     lakes appeared in places that have none. collectFromTiles
                     has always done this check; this collector never did. */
                  /* Overlap of bounding boxes, NOT "has a vertex inside the
                     crop". An ocean polygon surrounds the crop -- every one of
                     its vertices is outside it -- so a vertex test throws the
                     sea away and leaves a coastal model rendering the water as
                     land. Overlap keeps anything that covers or crosses the
                     crop while still dropping water from neighbouring tiles
                     that has nothing to do with this area. */
                  var plo0 = Infinity, plo1 = -Infinity;
                  var pla0 = Infinity, pla1 = -Infinity;
                  for (var pi = 0; pi < outer.length; pi++) {
                    if (outer[pi][0] < plo0) plo0 = outer[pi][0];
                    if (outer[pi][0] > plo1) plo1 = outer[pi][0];
                    if (outer[pi][1] < pla0) pla0 = outer[pi][1];
                    if (outer[pi][1] > pla1) pla1 = outer[pi][1];
                  }
                  if (plo1 < bbox.minLon || plo0 > bbox.maxLon ||
                      pla1 < bbox.minLat || pla0 > bbox.maxLat) return;
                  var key = 'w' + outer[0][0].toFixed(5) + outer[0][1].toFixed(5) + outer.length;
                  if (seen[key]) return;
                  seen[key] = 1;
                  out.push({ rings: rs });
                });
              });
            });
          } catch (e) { return cleanup([]); }
          if (window.console) console.info('[mm] tile water:', out.length, 'polygons');
          cleanup(out);
        });
      });
    });
  }

  /* Green cover from the vector tiles, as a fallback only.

     Water already had one of these and green did not, so a detail-query failure
     took every wood, park and scrub polygon with it -- and with them every tree,
     since OSM maps a wood as an outline and the trees are scattered inside it.
     A bare hillside is the most obvious wrong thing on a model, and it was
     happening silently whenever Overpass was busy. Tiles are generalised, but a
     wood that is roughly the right shape is worth a great deal more than no
     wood at all. */
  var TILE_GREEN = {
    wood: 'wood', forest: 'wood', scrub: 'scrub', heath: 'heath',
    grass: 'grassland', grassland: 'grassland', meadow: 'meadow',
    farmland: 'farmland', park: 'park', garden: 'park', cemetery: 'cemetery',
    orchard: 'orchard', vineyard: 'vineyard', allotments: 'allotments'
  };

  function collectGreenFromTiles(cfg, bbox) {
    return new Promise(function (resolve) {
      var done = false;
      function finish(list) { if (!done) { done = true; resolve(list || []); } }
      if (!cfg.geomStyleUrl && !cfg.styleUrl) return finish([]);

      whenMapLibre(function (maplibregl) {
        var holder = el('div');
        holder.style.cssText =
          'position:fixed;left:-9999px;top:0;width:900px;height:900px;pointer-events:none';
        document.body.appendChild(holder);
        var m;
        try {
          m = new maplibregl.Map({ transformRequest: mmMapReq,
            container: holder, style: cfg.geomStyleUrl || cfg.styleUrl,
            interactive: false, attributionControl: false,
            bounds: [[bbox.minLon, bbox.minLat], [bbox.maxLon, bbox.maxLat]],
            fitBoundsOptions: { padding: 0, animate: false }
          });
        } catch (e) { holder.remove(); return finish([]); }

        function cleanup(list) {
          try { m.remove(); } catch (e) {}
          holder.remove();
          finish(list);
        }
        var bail = tileBail(function () { cleanup([]); });
        m.on('error', function () {});
        m.on('idle', function () {
          bail.cancel();
          var out = [], seen = {};
          try {
            var style = m.getStyle(), srcId = null;
            Object.keys(style.sources || {}).forEach(function (k) {
              if (!srcId && style.sources[k].type === 'vector') srcId = k;
            });
            if (!srcId) return cleanup([]);
            ['landcover', 'park', 'landuse'].forEach(function (layer) {
              var feats;
              try { feats = m.querySourceFeatures(srcId, { sourceLayer: layer }); }
              catch (e) { return; }
              (feats || []).forEach(function (f) {
                var p = f.properties || {};
                var kind = TILE_GREEN[p.class] || TILE_GREEN[p.subclass];
                if (!kind) return;
                var g = f.geometry;
                var polys = g.type === 'Polygon' ? [g.coordinates]
                          : g.type === 'MultiPolygon' ? g.coordinates : [];
                polys.forEach(function (rs) {
                  var outer = rs[0];
                  if (!outer || outer.length < 4) return;
                  var lo0 = Infinity, lo1 = -Infinity, la0 = Infinity, la1 = -Infinity;
                  for (var i = 0; i < outer.length; i++) {
                    if (outer[i][0] < lo0) lo0 = outer[i][0];
                    if (outer[i][0] > lo1) lo1 = outer[i][0];
                    if (outer[i][1] < la0) la0 = outer[i][1];
                    if (outer[i][1] > la1) la1 = outer[i][1];
                  }
                  if (lo1 < bbox.minLon || lo0 > bbox.maxLon ||
                      la1 < bbox.minLat || la0 > bbox.maxLat) return;
                  var key = 'g' + outer[0][0].toFixed(5) + outer[0][1].toFixed(5) +
                            outer.length;
                  if (seen[key]) return;
                  seen[key] = 1;
                  out.push({ rings: rs, kind: kind });
                });
              });
            });
          } catch (e) { return cleanup([]); }
          if (window.console) console.info('[mm] tile green:', out.length, 'polygons');
          cleanup(out);
        });
      }, function () { finish([]); });
    });
  }

  function warmGeometry(spec, cfg) {
    if (!spec || !spec.bbox) return;
    try {
      collectFromOverpass(cfg, spec).catch(function () {});
      collectTerrain(cfg, spec.bbox).catch(function () {});
    } catch (e) { /* opportunistic only */ }
  }

  /* Assembled geometry, keyed by the crop and the settings that shape it.
     overpassCached already stops the same query going out twice, but the parse,
     the clipping, the ring assembly and the tree scatter all ran again on every
     render. This holds the finished result, so returning to an area you have
     already previewed costs nothing at all. */
  var GEOM_CACHE = {}, GEOM_KEYS = [];

  function geomKey(cfg, spec) {
    var b = spec.bbox;
    return [b.minLat, b.minLon, b.maxLat, b.maxLon].map(function (v) {
      return (+v).toFixed(6);
    /* The URL actually used, not the setting -- otherwise a blank setting and
       the fallback share a cache key with each other but not with a URL that
       is later filled in, and a stale flat result survives the change. */
    }).join(',') + '|' + Math.round(spec.groundMeters) + '|' +
      (cfg.terrainUrl || TERRAIN_FALLBACK);
  }

  /* ---------------------------------------------------------------------
     ESA WorldCover land cover, 10 m, global, measured from Sentinel imagery.

     This answers questions OSM cannot: is there tree cover HERE, is this
     cropland or pasture, is this built-up, is this water -- everywhere on
     earth, not only where a mapper has drawn a polygon. The blanket tree
     scatter, the sparse-crop gate and the green-cover threshold all exist to
     paper over that gap and can go once this is wired into the geometry.

     Reporting only for now: nothing in the model depends on it yet.

     Served through a Cloudflare worker because ESA's bucket sends no CORS
     header. The worker reads the COG blocks covering the crop and hands back
     a grid of class numbers. */
  var MM_LANDCOVER_URL = 'https://worldcover.kissmycans.workers.dev/sample';
  var MM_LC_GRID = 96;
  var LC_NAME = {
    10: 'tree cover', 20: 'shrubland', 30: 'grassland', 40: 'cropland',
    50: 'built-up', 60: 'bare', 70: 'snow/ice', 80: 'water',
    90: 'wetland', 95: 'mangrove', 100: 'moss/lichen', 0: 'no data'
  };
  var LC_CACHE = {};
  /* Last resolved land cover, for the geometry builder. The fetch is started
     alongside the Overpass queries and is far quicker than they are, so by the
     time geometry runs it is normally here. If it is not, the builder falls
     back to the OSM-polygon path and says so -- never a broken render. */
  var MM_LC_LAST = null;

  function landCover(b) {
    var key = b.minLon.toFixed(5) + ',' + b.minLat.toFixed(5) + ',' +
              b.maxLon.toFixed(5) + ',' + b.maxLat.toFixed(5);
    if (LC_CACHE[key]) return LC_CACHE[key];

    var url = MM_LANDCOVER_URL + '?bbox=' +
              [b.minLon, b.minLat, b.maxLon, b.maxLat].join(',') +
              '&n=' + MM_LC_GRID;
    var t0 = Date.now();

    /* Never allowed to break a render. A land cover miss means the model is
       built the way it is built today, not that the render fails. */
    var p = fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d || !d.ok || !d.grid) throw new Error(d && d.error ? d.error : 'no grid');
        var total = d.grid.length, parts = [];
        Object.keys(d.histogram)
          .sort(function (x, y) { return d.histogram[y] - d.histogram[x]; })
          .forEach(function (k) {
            parts.push((LC_NAME[k] || k) + ' ' +
                       Math.round(d.histogram[k] / total * 100) + '%');
          });
        if (window.console) {
          console.info('[mm] land cover (' + MM_LC_GRID + '\u00d7' + MM_LC_GRID +
                       ', ' + (Date.now() - t0) + ' ms, ' + d.blocksRead +
                       ' block(s)): ' + parts.join(', '));
        }
        var api = {
          n: MM_LC_GRID, grid: d.grid, histogram: d.histogram,
          bbox: b,
          /* Class at a lon/lat, or 0 outside the crop. Row 0 is the north edge. */
          at: function (lon, lat) {
            var i = Math.floor((lon - b.minLon) / (b.maxLon - b.minLon) * MM_LC_GRID);
            var j = Math.floor((b.maxLat - lat) / (b.maxLat - b.minLat) * MM_LC_GRID);
            if (i < 0 || j < 0 || i >= MM_LC_GRID || j >= MM_LC_GRID) return 0;
            return d.grid[j * MM_LC_GRID + i] || 0;
          }
        };
        MM_LC_LAST = api;
        return api;
      })
      .catch(function (e) {
        if (window.console) {
          console.warn('[mm] land cover unavailable (' + (Date.now() - t0) +
                       ' ms): ' + (e && e.message) + ' -- model built without it');
        }
        return null;
      });

    LC_CACHE[key] = p;
    return p;
  }

  /* City walls, on their own, as a last resort.

     Dubrovnik has now lost its walls three times, and every time the render
     code was innocent. Walls ride in the DETAIL query alongside water, parks,
     paths and every tree in the crop -- so in a dense, well-mapped place that
     query times out, the lite retry may go too, and the thing the customer is
     buying the model FOR disappears. The vector-tile fallback carries no walls
     at all, so that path loses them every single time.

     This asks for nothing but walls. It is a handful of ways, it costs almost
     nothing, and it succeeds in exactly the conditions that kill the big query.
     Same reasoning as quartering the building query: give the thing that
     matters its own budget instead of letting it queue behind trees. */
  function collectWalls(cfg, b) {
    var bb = b.minLat + ',' + b.minLon + ',' + b.maxLat + ',' + b.maxLon;
    var q = '[out:json][timeout:20];(' +
      'way["barrier"~"^(city_wall|wall|retaining_wall)$"](' + bb + ');' +
      'way["historic"="citywalls"](' + bb + ');' +
      'relation["historic"="citywalls"](' + bb + ');' +
      ');out geom 4000;';
    return overpassFetch(cfg, q).then(function (d) {
      var outW = [];
      (d && d.elements || []).forEach(function (e) {
        var t = e.tags || {};
        if (!e.geometry || e.geometry.length < 2) return;
        outW.push({
          line: e.geometry.map(function (pt) { return [pt.lon, pt.lat]; }),
          kind: (t.historic === 'citywalls' || t.barrier === 'city_wall')
                ? 'city_wall' : (t.barrier || 'wall'),
          height: parseFloat(t.height) || 0,
          id: e.id, type: e.type
        });
      });
      return outW;
    }).catch(function () { return []; });
  }

  function collectFromOverpass(cfg, spec) {
    var b = spec.bbox;
    /* Started here so it runs alongside the Overpass queries rather than after
       them. Nothing waits on it yet. */
    landCover(b);
    var gk = geomKey(cfg, spec);
    if (GEOM_CACHE[gk]) {
      if (window.console) console.info('[mm] geometry cache hit \u2014 no refetch');
      return GEOM_CACHE[gk];
    }
    var bb = b.minLat + ',' + b.minLon + ',' + b.maxLat + ',' + b.maxLon;
    var areaKm2 = (spec.groundMeters / 1000) * (spec.groundMeters / 1000);
    var big = areaKm2 > 3;
    /* Says exactly which piece of ground was asked for. When a finished model
       looks like the wrong place, this is the line that settles it in one look
       -- paste the centre into any map and you are looking at what was built. */
    {
      diag('crop: centre ' +
        ((b.minLat + b.maxLat) / 2).toFixed(5) + ',' + ((b.minLon + b.maxLon) / 2).toFixed(5) +
        ' \u00B7 ' + Math.round(spec.groundMeters) + ' m across \u00B7 ' +
        areaKm2.toFixed(2) + ' km\u00B2 \u00B7 ' + spec.size.cm + ' cm' +
        (big ? ' \u00B7 quartered' : ''));
    }

    var roadClasses = big
      ? 'motorway|trunk|primary|secondary|tertiary|residential|unclassified'
      : 'motorway|trunk|primary|secondary|tertiary|residential|unclassified|living_street|service|pedestrian';

    /* Two requests rather than one union, run in parallel. Buildings and roads
       are what the model cannot be built without, so they get their own budget:
       a slow tree lookup can no longer drag them past the timeout, and trees no
       longer eat the element cap ahead of them (Overpass prints nodes before
       ways, so in a well-mapped area they would). Two concurrent requests is
       what a public instance allows per client, so this is the whole budget --
       do not split further. */
    /* Built per bbox so a big crop can be asked for in quarters. A 4 km^2
       building query in a dense city is a different animal from a 1 km^2 one:
       it is four times the elements and Overpass answers it by running out of
       memory, which it reports as HTTP 200 with nothing in it. Four 1 km^2
       queries are each the size of the request that already works at 20 cm. */
    function baseQuery(bb, secs) {
      return '[out:json][timeout:' + secs + '];(' +
      'way["building"](' + bb + ');' +
      'relation["building"](' + bb + ');' +
      /* Build 2: the slices tall and complex buildings are mapped in --
         setbacks, podiums, crowns. Without them a tower is its outline
         extruded straight up. */
      'way["building:part"](' + bb + ');' +
      'relation["building:part"](' + bb + ');' +
      'way["highway"~"^(' + roadClasses + ')$"](' + bb + ');' +
      /* Railways. A main line crossing a crop is one of the most recognisable
         things in it -- often more so than any single street -- and the model
         had none at all, which is enough on its own to make somewhere read as
         the wrong place. */
      'way["railway"~"^(rail|light_rail|narrow_gauge|tram|subway|preserved)$"](' + bb + ');' +
      /* No element limit. Overpass truncates in id order, and bulk imports
         assign ids in geographic batches -- so a limit here cut Manhattan along
         an import boundary and returned half the crop. Better to let the
         server's own timeout decide and fail honestly than to return a city
         with a quadrant missing. */
      ');out geom;';
    }
    /* 25, not 45. At 45 the client waited 57s per host and the server was
       still grinding after we had gone; nothing useful has ever come back that
       late. Now the server gives up at 25s and says so, we give up at 30s, and
       the backup source gets its turn while there is still budget left. */
    var qBase = baseQuery(bb, 25);

    /* 55s not 90s: this query fails often enough in a dense centre that it
       needs to fail EARLY, leaving time for the cheaper retry below rather than
       burning the whole budget and returning a colourless model. */
    /* MEASURED, 25 Sep, from Kevin's phone: map data 68.1s of a 70.4s build,
       and the query that finally answered did so in 1380 ms. The 66 seconds in
       between were this query -- the full detail set, INCLUDING every mapped
       tree as its own node -- failing on all four mirrors. Overpass does not
       error when it runs out of time: it burns the whole [timeout:55] and
       returns HTTP 200 with nothing in it, so four mirrors staggered 6s apart
       take ~66s to agree they have failed, and only then does the cheap retry
       run and come back instantly.

       So the doomed query is not sent any more. It is split at the seam that
       actually matters -- structure (water, coast, parks, landuse, paths,
       piers, WALLS) against decoration (trees, tree rows, hedges) -- and the
       structural half is the one the model cannot do without. Trees follow it
       on the same connection with a short leash, because a public instance
       allows one client two slots and the buildings query is holding the other.
       Losing the trees costs some character; waiting 66s for them costs the
       sale. */
    var qStruct = '[out:json][timeout:20];(' +
      'way["natural"="water"](' + bb + ');' +
      'way["waterway"="riverbank"](' + bb + ');' +
      'relation["natural"="water"](' + bb + ');' +
      'way["leisure"~"^(park|garden|pitch|recreation_ground|golf_course|nature_reserve|playground)$"](' + bb + ');' +
      'way["landuse"~"^(grass|forest|meadow|allotments|cemetery|recreation_ground|farmland|farm|orchard|vineyard|village_green|greenfield|plant_nursery)$"](' + bb + ');' +
      /* Built-up land. Not green, and not decoration: on a green base these are
         what tells a village from a field. */
      'way["landuse"~"^(residential|commercial|industrial|retail|farmyard|construction|brownfield|garages|quarry)$"](' + bb + ');' +
      'relation["landuse"~"^(residential|commercial|industrial|retail)$"](' + bb + ');' +
      'way["natural"~"^(wood|grassland|scrub|heath|moor|wetland)$"](' + bb + ');' +
      /* Relations too. A large wood is very often a multipolygon rather than a
         single way, so asking only for ways misses the biggest woodland in the
         crop -- exactly the areas that carry the most trees. */
      'relation["natural"~"^(wood|scrub|heath|grassland)$"](' + bb + ');' +
      'relation["landuse"~"^(forest|meadow|farmland|orchard|vineyard)$"](' + bb + ');' +
      'relation["leisure"~"^(park|garden|nature_reserve|golf_course)$"](' + bb + ');' +
      'way["waterway"~"^(river|stream|canal)$"](' + bb + ');' +
      'way["natural"="coastline"](' + bb + ');' +
      'way["landuse"~"^(reservoir|basin)$"](' + bb + ');' +
      /* Build 2: the fine detail layer -- footpaths through parks and along
         the coast, harbour piers and breakwaters, walls. Pavements beside a
         road are left out: they would only widen the road. */
      'way["highway"~"^(footway|path|steps|cycleway|bridleway|track)$"]["footway"!~"^(sidewalk|crossing)$"]["indoor"!="yes"](' + bb + ');' +
      'way["man_made"~"^(pier|breakwater|groyne)$"](' + bb + ');' +
      'relation["man_made"="pier"](' + bb + ');' +
      'way["barrier"~"^(wall|city_wall|retaining_wall)$"](' + bb + ');' +
      /* Build 4.5: barrier=city_wall is not the only way a town wall is
         mapped. historic=citywalls is just as common -- Dubrovnik, York,
         Carcassonne, Ávila all carry it on at least part of the circuit --
         and asking only for the barrier tag meant whole stretches of the one
         feature the customer is buying the model FOR simply never arrived. */
      'way["historic"="citywalls"](' + bb + ');' +
      'relation["historic"="citywalls"](' + bb + ');' +
      'way["natural"="bay"](' + bb + ');' +
      'relation["natural"="bay"](' + bb + ');' +
      /* barrier=hedge alongside natural=tree_row. In Ireland a field boundary is
         far more often tagged as a hedge than as a tree row, and the render was
         asking for only one of the two. Nothing appears where nobody has mapped
         them, which is most of the countryside -- but where someone has, the
         field pattern is the single biggest thing missing from a rural crop. */
      /* B5.38: these two moved here from the old standalone trees request,
         which was deleted. Across five logged builds that request was abandoned
         at its 5-second leash five times and returned data zero times -- so
         hedges and tree rows were never actually arriving. As two more `way`
         clauses on a union that already has twenty-two they cost no extra
         round trip, and they land whenever this query lands.

         node["natural"="tree"] did NOT come with them. It is the single most
         expensive clause in the old set -- a well-surveyed city centre is tens
         of thousands of nodes each carrying geometry -- and the renderer's
         wildTrees scatter already plants trees across every polygon this query
         returns as vegetation, which is where the trees in the models have
         always come from. */
      'way["natural"="tree_row"](' + bb + ');' +
      'way["barrier"="hedge"](' + bb + ');' +
      ');out geom;';

    /* Decoration, on its own, and allowed to fail. node["natural"="tree"] over
       a well-surveyed city centre is tens of thousands of nodes each carrying
       geometry, which is the single most expensive clause in the old set. */
    /* qTrees is GONE as of B5.38.

       It asked for node["natural"="tree"], way["natural"="tree_row"] and
       way["barrier"="hedge"] as a fourth request with a five-second leash.
       Across every build logged on 27-28 Sep it hit that leash five times out
       of five and returned data zero times -- while holding one of the two
       upstream slots a public instance allows us, which is a slot the
       buildings query needed.

       tree_row and hedge moved into the structural query above as two more
       `way` clauses: no extra round trip, and they now arrive whenever that
       query arrives instead of never. The tree NODES were not carried over --
       see the note there. */

    /* The retry behind the structural query: a shorter list again, for when
       even that does not land. */
    var qDetailLite = '[out:json][timeout:15];(' +
      'way["natural"="water"](' + bb + ');' +
      'way["waterway"="riverbank"](' + bb + ');' +
      'relation["natural"="water"](' + bb + ');' +
      'way["waterway"~"^(river|stream|canal)$"](' + bb + ');' +
      'way["natural"="coastline"](' + bb + ');' +
      'way["man_made"~"^(pier|breakwater|groyne)$"](' + bb + ');' +
      'way["barrier"="city_wall"](' + bb + ');' +
      'way["historic"="citywalls"](' + bb + ');' +
      'way["leisure"~"^(park|garden|pitch|recreation_ground|golf_course)$"](' + bb + ');' +
      'way["landuse"~"^(grass|forest|meadow|cemetery|village_green|orchard|vineyard)$"](' + bb + ');' +
      /* Woodland belongs in the LITE query too. It was only in the full one, so
         every time the detail query timed out -- which is often, in a dense or
         well-mapped area -- the retry came back with no wood, no scrub and no
         heath. On a wooded or Mediterranean crop that is nearly all the ground
         cover there is, and the hillside arrived bare. Trees are the first
         thing anyone notices missing. */
      'way["natural"~"^(wood|scrub|heath|grassland)$"](' + bb + ');' +
      ');out geom 10000;';

    var out = {
      buildings: [], roads: [], water: [], waterways: [], coast: [],
      grass: [], urban: [], trees: [], hedges: [], rails: [],
      parts: [], paths: [], piers: [], pierLines: [], walls: [],
      source: 'overpass', partial: false, missing: null
    };

    function ringsOf(e) {
      if (e.type === 'way' && e.geometry) {
        return [e.geometry.map(function (p) { return [p.lon, p.lat]; })];
      }
      if (e.type === 'relation' && e.members) {
        /* Build 3.5: stitch the members into rings.
           A multipolygon's outline is usually SPLIT across several open ways --
           that is how any large building, lake or park is mapped once it has
           more than a few hundred nodes. Taking the first member as the whole
           outline drew one open line closed into a fan across whole blocks,
           and threw the rest of the building away. Manhattan was full of them:
           273 of 457 buildings drawn, and flat pale slabs where the missing
           ones should have been. Ends are matched and walked until each ring
           closes; anything that will not close is dropped rather than guessed. */
        var outSeg = [], inSeg = [];
        e.members.forEach(function (m) {
          if (!m.geometry || m.geometry.length < 2) return;
          var r = m.geometry.map(function (p) { return [p.lon, p.lat]; });
          (m.role === 'inner' ? inSeg : outSeg).push(r);
        });
        var outers = stitchRings(outSeg), inners = stitchRings(inSeg);
        if (!outers.length) return [];
        /* Largest outer wins: a relation with several separate outlines is one
           feature here, and the biggest is the one worth drawing. */
        var big = outers[0], bigA = MM_ringAreaM2(big);
        for (var oi = 1; oi < outers.length; oi++) {
          var oa = MM_ringAreaM2(outers[oi]);
          if (oa > bigA) { big = outers[oi]; bigA = oa; }
        }
        return [big].concat(inners);
      }
      return [];
    }

    /* Walk open ways end to end into closed rings. Endpoints are compared at
       about a centimetre, which is finer than OSM's own precision. */
    function stitchRings(segs) {
      var key = function (p) { return p[0].toFixed(7) + ',' + p[1].toFixed(7); };
      var pool = segs.slice(), rings = [], dropped = 0;
      while (pool.length) {
        var cur = pool.shift().slice(), guard = 0;
        while (key(cur[0]) !== key(cur[cur.length - 1]) && guard++ < 5000) {
          var end = key(cur[cur.length - 1]), at = -1, flip = false;
          for (var i = 0; i < pool.length; i++) {
            var sg = pool[i];
            if (key(sg[0]) === end) { at = i; flip = false; break; }
            if (key(sg[sg.length - 1]) === end) { at = i; flip = true; break; }
          }
          if (at < 0) break;
          var seg = pool.splice(at, 1)[0];
          if (flip) seg = seg.slice().reverse();
          cur = cur.concat(seg.slice(1));
        }
        if (cur.length >= 4 && key(cur[0]) === key(cur[cur.length - 1])) rings.push(cur);
        else dropped++;
      }
      if (dropped && window.console && !stitchRings.warned) {
        stitchRings.warned = true;
        console.info('[mm] ' + dropped + ' multipolygon ring(s) did not close and were skipped');
      }
      return rings;
    }

    /* Build 3.8: things that are not on the surface.
       Grand Central Terminal is mapped as relation/11171793 --
       building=train_station, location=underground, layer=-2, 156,000 m2 of
       train shed under Park Avenue. Drawn as an ordinary building it became a
       flat slab over eight Midtown blocks with the real towers standing on top
       of it. The headhouse above ground is a separate way and still renders.
       A model shows what you would see standing on the street, so anything
       tagged as being below it is not in it.
       layer is trusted for buildings and NOT for roads: a street passing under
       an overpass is routinely layer=-1 and is very much on the surface. */
    var undergroundSkipped = 0;
    function belowGround(t) {
      if (t.location === 'underground' || t.location === 'underwater') return true;
      if (t.tunnel && t.tunnel !== 'no') return true;
      var ly = parseFloat(t.layer);
      return !isNaN(ly) && ly < 0;
    }

    /* Both responses go through the same reader -- an element is classified by
       its tags, not by which request happened to return it. */
    /* A way that crosses a quadrant boundary comes back in both quarters, so
       without this the seams carry two copies of the same building sitting in
       exactly the same place -- which z-fights and doubles the element count.
       Keyed on type+id, which is unique across the whole of OSM. */
    var seenEl = {};
    function absorb(data) {
      (data.elements || []).forEach(function (e) {
        if (e.id != null) {
          var ek = (e.type || '?') + '/' + e.id;
          if (seenEl[ek]) return;
          seenEl[ek] = 1;
        }
        var t = e.tags || {};

        if (e.type === 'node') {
          if (t.natural === 'tree') out.trees.push([e.lon, e.lat]);
          return;
        }
        if (!e.geometry && !e.members) return;

        if (t.barrier === 'hedge' && e.geometry && e.geometry.length >= 2) {
          /* Not trees. A hedge is a continuous low line of vegetation, and
             dropping a tree every twelve metres along one produced a row of
             lollipops standing in a field -- which is exactly what it looked
             like. Kept as a line here and drawn as a low ribbon instead. */
          out.hedges.push({
            line: e.geometry.map(function (pp) { return [pp.lon, pp.lat]; })
          });
          return;
        }
        if (t.natural === 'tree_row' && e.geometry) {
          /* Walk the row and drop a tree every ROW_SPACING metres, interpolating
             between nodes. The old version measured with Math.hypot on raw
             degrees -- treating a degree of longitude as equal to a degree of
             latitude, which at this latitude differ by about 1.67x, so spacing
             was direction-dependent -- and it only ever kept nodes that already
             existed. A straight hedgerow mapped with two nodes produced two
             trees; a curvy one produced a clump. That unevenness is what read
             as trees being in the wrong places. */
          var g = e.geometry;
          if (g.length < 2) return;
          /* 5 m, not 12. A tree row is a hedgerow -- a continuous line along a
             boundary -- and at twelve metre spacing it came out as a dotted
             line of separate blobs crossing a field, which reads as a fault
             rather than a feature. At five they touch and it reads as a line. */
          var ROW_SPACING = 5;
          var latR = Math.cos(g[0].lat * D2R);
          var carry = 0;
          for (var si = 0; si < g.length - 1; si++) {
            var aLon = g[si].lon, aLat = g[si].lat;
            var bLon = g[si + 1].lon, bLat = g[si + 1].lat;
            var dxm = (bLon - aLon) * 111320 * latR;
            var dym = (bLat - aLat) * 110540;
            var segM = Math.sqrt(dxm * dxm + dym * dym);
            if (segM < 1e-6) continue;
            for (var d = carry; d < segM; d += ROW_SPACING) {
              var f = d / segM;
              out.trees.push([aLon + (bLon - aLon) * f, aLat + (bLat - aLat) * f]);
            }
            carry = Math.max(0, carry + Math.ceil((segM - carry) / ROW_SPACING) * ROW_SPACING - segM);
          }
          return;
        }

        var rs = ringsOf(e);
        if (t['building:part'] && t['building:part'] !== 'no' && !t.building) {
          if (belowGround(t)) { undergroundSkipped++; return; }
          if (!rs.length || rs[0].length < 4) return;
          var ph = MM_partHeights(t, MM_ringAreaM2(rs[0]));
          out.parts.push({ rings: rs, top: ph.top, bot: ph.bot, id: e.id,
                           roof: t['roof:shape'] || null,
                           roofHeight: parseFloat(t['roof:height']) || 0 });
          return;
        }
        if (t.man_made === 'pier' || t.man_made === 'breakwater' || t.man_made === 'groyne') {
          var closedPier = e.type === 'relation' || (e.geometry && e.geometry.length >= 4 &&
            e.geometry[0].lat === e.geometry[e.geometry.length - 1].lat &&
            e.geometry[0].lon === e.geometry[e.geometry.length - 1].lon && t.area !== 'no');
          if (closedPier && rs.length && rs[0].length >= 4) { out.piers.push({ rings: rs }); return; }
          if (e.geometry && e.geometry.length >= 2) {
            out.pierLines.push({ line: e.geometry.map(function (p) { return [p.lon, p.lat]; }),
              width: parseFloat(t.width) || (t.man_made === 'pier' ? 3 : 6),
              kind: t.man_made, floating: t.floating === 'yes' });
          }
          return;
        }
        if (e.geometry && (t.historic === 'citywalls' ||
            (t.barrier && /^(wall|city_wall|retaining_wall)$/.test(t.barrier)))) {
          out.walls.push({ line: e.geometry.map(function (p) { return [p.lon, p.lat]; }),
                           kind: (t.historic === 'citywalls' || t.barrier === 'city_wall')
                                 ? 'city_wall' : t.barrier,
                           height: parseFloat(t.height) || 0 });
          return;
        }
        if (t.highway && e.geometry && /^(footway|path|steps|cycleway|bridleway|track)$/.test(t.highway)) {
          if (t.tunnel && t.tunnel !== 'no') return;
          if (t.indoor === 'yes' || parseFloat(t.layer) < 0) return;
          out.paths.push({ line: e.geometry.map(function (p) { return [p.lon, p.lat]; }),
                           width: parseFloat(t.width) || (t.highway === 'track' ? 3 : t.highway === 'steps' ? 2.5 : 1.8),
                           bridge: !!(t.bridge && t.bridge !== 'no') });
          return;
        }
        if (t.building) {
          if (belowGround(t)) { undergroundSkipped++; return; }
          if (!rs.length || rs[0].length < 4) return;
          var h = MM_buildingHeight(t, MM_ringAreaM2(rs[0]));
          out.buildings.push({ rings: rs, height: Math.max(h, 2.5), id: e.id,
                               /* Build 3.6: kept only so the footprint log below can
                                  name what it found. Costs three fields per building. */
                               rel: e.type === 'relation', tag: t.building,
                               lev: t['building:levels'] || t.height || '',
                               roof: t['roof:shape'] || null,
                               roofHeight: parseFloat(t['roof:height']) || 0 });
          return;
        }
        if (t.railway && e.geometry) {
          if (t.tunnel && t.tunnel !== 'no') return;
          /* The subway under Midtown is mapped with layer=-1..-5; most of it
             also carries tunnel=yes, but not all of it. location is the tag
             that means it, and unlike layer it never describes a line merely
             passing under a bridge. */
          if (t.location === 'underground') { undergroundSkipped++; return; }
          if (t.railway === 'abandoned' || t.railway === 'disused' ||
              t.railway === 'razed' || t.service === 'yard') return;
          out.rails.push({
            line: e.geometry.map(function (p) { return [p.lon, p.lat]; }),
            light: t.railway === 'tram' || t.railway === 'light_rail'
          });
          return;
        }
        if (t.highway && e.geometry) {
          if (t.tunnel && t.tunnel !== 'no') return;
          if (parseFloat(t.layer) < 0) return;
          var lanes = parseFloat(t.lanes);
          var w = parseFloat(t.width);
          if (isNaN(w)) {
            /* These are carriageway widths, not the full public right of way.
               The old numbers were closer to kerb-to-kerb including verges and
               footpaths, which at 1:5000 pushed ribbons across the front of the
               houses -- OSM gives a centreline and no width, so every one of
               these is a guess and the guess was too generous. */
            if (!isNaN(lanes)) w = Math.max(2.75, lanes * 2.9);
            else w = t.highway === 'motorway' || t.highway === 'trunk' ? 12
              : t.highway === 'primary' ? 9 : t.highway === 'secondary' ? 7.5
              : t.highway === 'tertiary' ? 6.5
              : t.highway === 'service' ? 2.5   // driveways, not streets
              : t.highway === 'pedestrian' || t.highway === 'living_street' ? 3.5 : 5.0;
          }
          out.roads.push({
            line: e.geometry.map(function (p) { return [p.lon, p.lat]; }),
            width: w,
            bridge: !!(t.bridge && t.bridge !== 'no')
          });
          return;
        }
        if (t.natural === 'coastline' && e.geometry) {
          out.coast.push(e.geometry.map(function (pp) { return [pp.lon, pp.lat]; }));
          return;
        }
        /* natural=bay is deliberately NOT here. A bay in OSM is a named sea
           area, and mappers routinely draw it as one big polygon that takes in
           the shoreline and a good deal of land with it. Rendered as water it
           floods streets that are nowhere near the sea. The actual water in a
           bay arrives as coastline or as natural=water anyway. */
        if (t.natural === 'water' ||
            t.waterway === 'riverbank' || t.waterway === 'dock' ||
            t.landuse === 'reservoir' || t.landuse === 'basin') {
          /* Kept, so the model can say "the river and the lake" rather than
             "all of the water". OSM usually says which it is; where it does
             not, "water" is honest. */
          var wk = t.water || (t.waterway === 'riverbank' ? 'river'
                 : t.waterway === 'dock' ? 'dock'
                 : t.landuse === 'reservoir' ? 'reservoir'
                 : t.landuse === 'basin' ? 'reservoir' : 'water');
          if (rs.length && rs[0].length >= 4) out.water.push({ rings: rs, kind: wk });
          return;
        }
        /* Rivers and streams are ways, not areas. Querying only polygons meant
           a suburb's river was simply absent from the model. Widths are almost
           never tagged, so they come from the class. */
        if (t.waterway && e.geometry) {
          /* Anything not open to the sky is not water you can see, and drawing
             it is why a mirror finish appeared to run along roads: a city
             stream is very often culverted under the street it follows, mapped
             with no tunnel tag but with culvert, covered, or a negative layer.
             One of those three catches nearly all of them. */
          if (t.tunnel && t.tunnel !== 'no') return;
          if (t.culvert && t.culvert !== 'no') return;
          if (t.covered && t.covered !== 'no') return;
          if (t.location === 'underground') return;
          if (t.layer && parseFloat(t.layer) < 0) return;
          var wwW = parseFloat(t.width);
          if (isNaN(wwW)) {
            wwW = t.waterway === 'river' ? 14 : t.waterway === 'canal' ? 9
                : t.waterway === 'stream' ? 3 : 1.5;
          }
          out.waterways.push({
            line: e.geometry.map(function (pp) { return [pp.lon, pp.lat]; }),
            width: wwW,
            kind: t.waterway
          });
          return;
        }
        if (t.landuse && URBAN_LANDUSE[t.landuse]) {
          if (rs.length && rs[0].length >= 4) out.urban.push({ rings: rs });
          return;                       // built-up land is never also green
        }
        if (t.leisure || t.landuse || t.natural) {
          if (rs.length && rs[0].length >= 4) {
            /* Farmland, meadow, park and rough ground were all painted the one
               green, which is why the countryside came out as a single sheet.
               OSM does distinguish them, so the distinction is free -- these are
               shades of the same colour, not new materials, so nothing changes
               on the printer or on the price. */
            var tone = 0;                                   // 0 = the base green
            if (t.landuse === 'farmland' || t.landuse === 'farm' ||
                t.landuse === 'greenfield') tone = 1;       // paler, drier
            else if (t.landuse === 'meadow' || t.natural === 'grassland') tone = 2;
            else if (t.natural === 'scrub' || t.natural === 'heath' ||
                     t.natural === 'moor' || t.natural === 'wetland') tone = 3;
            /* Carried through so the renderer can tell a worked field from a
               meadow. An orchard or vineyard is planted in rows, and those rows
               are most of what makes farmland read as farmland rather than as a
               green shape. */
            var rowKind = (t.landuse === 'orchard' || t.landuse === 'vineyard' ||
                           t.landuse === 'plant_nursery' || t.landuse === 'allotments') ? 'rows'
                        : (t.landuse === 'farmland' || t.landuse === 'farm' ||
                           t.landuse === 'meadow' || t.landuse === 'greenfield' ||
                           t.landuse === 'village_green' || t.natural === 'grassland' ||
                           t.landuse === 'grass') ? 'field'
                        : null;
            out.grass.push({ rings: rs, tone: tone, kind: rowKind,
                             wooded: !!(t.natural === 'wood' || t.landuse === 'forest' ||
                                        t.natural === 'scrub' || t.natural === 'heath') });
            /* Woods and parks are drawn as one flat green polygon, which is why
               yours read as paint and theirs read as planting. OSM maps a wood
               as an outline, not as individual trees, so the trees have to be
               scattered inside it. Seeded off the element id so the same park
               produces the same trees every time -- the preview has to match
               what gets printed. */
            if (MM_TREES) scatterInto(out.trees, rs, t, e.id || 0);
          }
        }
      });
    }

    /* Buildings and roads, in one request for a normal crop and in four for a
       big one. `big` is 3 km^2, which in practice means the 40 cm model.

       An Overpass instance that runs out of memory does not return an error --
       it returns HTTP 200 with zero elements. Four mirrors on the same oversized
       query all do the same thing, the racer accepts the agreed empty answer,
       and the model is built with no buildings and no streets at all while the
       cheaper detail query sails through with its trees and hedges. That is a
       plate of countryside where a city should be, and it is what 40 cm has
       been doing. Quartering the query keeps each request the size of the one
       that already works at 20 cm. */
    function baseSplit() {
      var midLat = (b.minLat + b.maxLat) / 2, midLon = (b.minLon + b.maxLon) / 2;
      var quads = [
        b.minLat + ',' + b.minLon + ',' + midLat + ',' + midLon,
        b.minLat + ',' + midLon + ',' + midLat + ',' + b.maxLon,
        midLat + ',' + b.minLon + ',' + b.maxLat + ',' + midLon,
        midLat + ',' + midLon + ',' + b.maxLat + ',' + b.maxLon
      ];
      var okN = 0, failN = 0;
      /* Two at a time. That is what a public instance allows one client, and
         the whole point of this is to stop leaning on them too hard. */
      function pair(i) {
        if (i >= quads.length) return Promise.resolve();
        return Promise.all(quads.slice(i, i + 2).map(function (q) {
          return overpassFetch(cfg, baseQuery(q, 25))
            .then(function (d) { absorb(d); okN++; })
            .catch(function (e) {
              failN++;
              if (window.console) console.warn('[mm] quarter failed:', e && e.message);
            });
        })).then(function () { return pair(i + 2); });
      }
      return pair(0).then(function () {
        if (window.console) {
          console.info('[mm] big crop: buildings and streets fetched in quarters \u2014 ' +
            okN + ' of ' + quads.length + ' answered');
        }
        if (!okN) throw new Error('overpass');
        if (failN) {
          out.partial = true;
          out.missing = failN + ' of 4 quarters of the buildings and streets';
        }
      });
    }

    // Both are in flight from here -- the .then chains below only await them.
    var base = big ? baseSplit() : overpassFetch(cfg, qBase).then(absorb);

    /* Detail fails soft. Losing water, green and trees costs the model some
       character; losing the buildings costs it everything, so a detail timeout
       must never send an accurate building set to the tile fallback. */
    /* ONE BUDGET FOR THE WHOLE DATA PHASE.

       Kevin's screenshot: "1 KB of map data - 184s", and only THEN switching to
       the backup source. Overpass was not slow, my timeouts were stacking. Every
       layer had its own limit and they add up: the base and detail queries race
       four mirrors at up to 70s each (~88s with the hedge stagger), then the
       detail LITE retry runs the same race again (~88s more), then the
       walls-only query, and only after all of that does the tile fallback
       start, with its own 20s and a 20s retry behind it. Four minutes of
       perfectly reasonable individual timeouts.

       So there is now a deadline on the lot. When it passes we stop waiting and
       take the simplified source, whatever is still in flight. Nothing below
       starts a fresh request once the clock has run out. */
    var DATA_BUDGET_MS = IS_TOUCH ? 75000 : 115000;
    var budgetAt = Date.now() + DATA_BUDGET_MS;
    function budgetLeft() { return budgetAt - Date.now(); }
    /* iOS throttles and often suspends a background tab outright: timers stop,
       animation frames stop, fetches stall. A budget that kept running while
       the page was in the background would give up on a request that had simply
       been paused, so the clock stops with the page. */
    var hidAt = 0;
    function onVis() {
      if (document.hidden) { hidAt = Date.now(); }
      else if (hidAt) { budgetAt += Date.now() - hidAt; hidAt = 0; }
    }
    try { document.addEventListener('visibilitychange', onVis); } catch (eV) {}

    /* Structure first, trees after. Two Overpass slots is what one client gets
       from a public instance and the buildings query is holding the other, so
       these are chained rather than fired together -- but the structural query
       now answers in a second or two, so "after" costs almost nothing. */
    var structOk = false;
    /* B5.39: the structural query now waits for the buildings query instead of
       racing alongside it.

       MEASURED 28 Sep, four cache-miss queries fired at once against the paid
       plan: every one of them failed, three with HTTP 429 in under 50ms. The
       Indie tier allows two concurrent queries and ONE BUILD WAS USING BOTH --
       so a second customer arriving at the same moment did not degrade, they
       failed outright.

       Running these back to back costs about a second now that a query answers
       in one. It cost twenty-five this morning, which is why it was parallel.
       The cheaper fix changed because the underlying speed changed.

       I considered merging the two into a single request instead -- fewer round
       trips still. Not tonight: the merge has to survive the lite retry, the
       walls top-up and the quarter-splitting path for big crops, and this is a
       four-line change that gets the same concurrency result. Merge later, with
       the suites run properly.

       base may reject; that is handled downstream in the Promise.all. Here we
       only need to know it has finished, either way. */
    var detail = base.then(null, function () {}).then(function () {
      return overpassFetch(cfg, qStruct).then(function (d) {
      absorb(d); structOk = true;
    }).catch(function (e) {
      if (window.console) console.warn('[mm] structural detail failed, retrying lite:', e && e.message);
      if (budgetLeft() < 20000) {
        out.partial = true;
        out.missing = 'water, parks and trees';
        diag('skipped the lite retry \u2014 ' + Math.round(budgetLeft() / 1000) +
             's left of the data budget');
        return;
      }
      return overpassFetch(cfg, qDetailLite).then(function (d) {
        /* structOk stays FALSE on purpose. The lite list carries city_wall and
           historic=citywalls as ways but not as relations, and not the generic
           wall/retaining_wall tags -- so the walls top-up below must still run.
           Setting it here is how Dubrovnik would lose its wall again. */
        absorb(d);
        out.partial = true;
        out.missing = 'trees';
        if (window.console) console.info('[mm] lite detail recovered water and parkland');
      }).catch(function (e2) {
        out.partial = true;
        out.missing = 'water, parks and trees';
        if (window.console) console.warn('[mm] lite detail failed too:', e2 && e2.message);
      });
      });
    });

    /* Kevin's 17:54 log on B5.29: buildings 1.0s, water and parks 6.8s, and then
       NINE MORE SECONDS of trees that arrived too late to use -- 9 of 16 seconds
       buying nothing. Trees were chained behind the structural query because a
       public instance gives one client two slots and the buildings query held
       the other. That constraint is now handled per host rather than by queueing,
       so the third query simply goes to a third mirror and its five-second
       window overlaps the wait instead of following it.
       Nothing here is allowed to reject: an absent tree is a plainer model, not
       a failed order. */
    /* Trees no longer have a request of their own -- tree rows and hedges ride
       in on the structural query, and the trees themselves are scattered by the
       renderer across whatever vegetation that query returns. Kept as a
       resolved promise so the Promise.all below keeps its shape and res[2] and
       res[3] still mean what the code reading them thinks they mean. */
    var treesDone = Promise.resolve();

    /* If the detail query degraded, the walls may have gone down with it. Ask
       for them on their own -- afterwards, so this never adds a third
       concurrent request to a public instance. */
    var detailThenWalls = detail.then(function () {
      /* Keyed on the structural query, not on out.partial. Walls live in the
         structural half, so a missing TREE layer says nothing about them --
         and topping up walls we already have is a wasted request on a public
         instance. */
      if (structOk) return;
      if (budgetLeft() < 15000) {
        diag('skipped the walls top-up \u2014 out of data budget');
        return;
      }
      return collectWalls(cfg, b).then(function (ws) {
        var added = 0;
        ws.forEach(function (w) {
          var k = (w.type || 'way') + '/' + w.id;
          if (w.id != null && seenEl[k]) return;
          if (w.id != null) seenEl[k] = 1;
          out.walls.push(w); added++;
        });
        if (window.console && added) {
          console.info('[mm] walls recovered on their own: ' + added + ' run(s) after a degraded detail query');
        }
      });
    });

    /* Runs in parallel with the Overpass pair and never rejects, so it can
       only add water, never cost us a render. */
    var tileWater = collectWaterFromTiles(cfg, b).catch(function () { return []; });
    var tileGreen = collectGreenFromTiles(cfg, b).catch(function () { return []; });

    /* The deadline itself. Whatever is still in flight is abandoned -- the
       requests carry their own abort timers, so nothing is left hanging around
       for the rest of the session. */
    var built = Promise.race([
      /* treesDone goes LAST on purpose: res[2] and res[3] are read below as the
         tile water and tile green, and inserting anything ahead of them silently
         hands the water collector the trees. */
      Promise.all([base, detailThenWalls, tileWater, tileGreen, treesDone]),
      new Promise(function (_, rej) {
        setTimeout(function () {
          var e = new Error('data budget of ' + Math.round(DATA_BUDGET_MS / 1000) +
                            's ran out waiting for the precise source');
          e.budget = true;
          rej(e);
        }, DATA_BUDGET_MS);
      })
    ]).then(function (res) {
      /* Said out loud, every build. On 28 Sep a model of Darndale shipped with
         no buildings and no streets and reported success, and nothing in the
         diagnostics named the moment it went wrong. */
      diag('assembled: ' + out.buildings.length + ' buildings \u00b7 ' +
           out.roads.length + ' roads \u00b7 ' + out.grass.length + ' green \u00b7 ' +
           out.trees.length + ' trees \u00b7 ' + out.water.length + ' water');
      if (!out.buildings.length && !out.roads.length) {
        diag('NO buildings and NO roads from the precise source \u2014 falling back');
        throw new Error('empty');
      }

      /* Hold the footprints for the marker picker, so choosing buildings does
         not repeat the slowest request in the flow. */
      lastBuildings = { key: bboxKey(b), list: out.buildings };

      /* Build 3.6: the five largest footprints in the crop, by real ground
         area. A slab covering several city blocks is always one of these, and
         this is the only way to name it without re-running the query by hand:
         the id opens straight in openstreetmap.org. */
      if (window.console && undergroundSkipped) {
        console.info('[mm] skipped ' + undergroundSkipped +
          ' underground element(s) (stations, subway, basements)');
      }
      if (window.console && out.buildings.length) {
        var fp = out.buildings.map(function (o) {
          var r = o.rings && o.rings[0];
          return { a: r ? Math.abs(MM_ringAreaM2(r)) : 0, o: o, r: r };
        }).sort(function (p, q) { return q.a - p.a; }).slice(0, 5);
        console.info('[mm] largest footprints: ' + fp.map(function (f) {
          var c = f.r ? f.r[0] : [0, 0];
          return Math.round(f.a) + ' m\u00b2 ' + (f.o.rel ? 'relation/' : 'way/') + f.o.id +
                 ' [' + (f.o.tag || '?') + (f.o.lev ? ' ' + f.o.lev : '') + '] ' +
                 c[1].toFixed(5) + ',' + c[0].toFixed(5);
        }).join(' | '));
      }

      var fromTiles = res[2] || [];

      /* Coastline FIRST, and unconditionally. The sea and every tidal river
         arrive as natural=coastline ways, not as polygons -- so for anywhere on
         a coast this is the only source of water there is. It used to run only
         when the tile collector came back empty, which meant that the moment
         tiles returned anything at all the sea was silently dropped: Dubrovnik
         came out with the Adriatic rendered as grassland, because under Meadow
         the base surface is green and nothing had overridden it. */
      if (out.coast.length) {
        /* Flood fill first: it answers the same question without depending on
           runs closing or on winding direction. The ring walk stays as a
           fallback for the case where the fill finds nothing. */
        var lcNow = (MM_LC_LAST && MM_LC_LAST.bbox &&
                     Math.abs(MM_LC_LAST.bbox.minLon - b.minLon) < 1e-9 &&
                     Math.abs(MM_LC_LAST.bbox.maxLat - b.maxLat) < 1e-9) ? MM_LC_LAST : null;
        var filled = seaByFloodFill(out.coast, b, out.buildings, out.roads, lcNow);
        if (filled.length) {
          for (var fi = 0; fi < filled.length; fi++) out.water.push(filled[fi]);
          if (window.console) {
            console.info('[mm] sea by flood fill: ' + filled.length + ' area(s) from ' +
                         out.coast.length + ' coastline way(s)');
          }
        }
        var seaRings = filled.length ? [] : coastlineWater(out.coast, b);
        /* Coastline is directed -- land on the left, water on the right -- and
           reconstruction walks the crop boundary on that assumption. Where the
           runs do not close cleanly it can come back with the complement: the
           LAND returned as the sea, which floods the town. Same invariant as
           below catches it either way. */
        var cSample = [];
        for (var cbi = 0; cbi < out.buildings.length; cbi += Math.max(1,
             Math.ceil(out.buildings.length / 400))) {
          var cbr = out.buildings[cbi].rings[0];
          if (cbr && cbr[0]) cSample.push(cbr[0]);
        }
        var seaKept = 0, seaDropped = 0;
        for (var ci = 0; ci < seaRings.length; ci++) {
          var inCount = 0;
          for (var cpi = 0; cpi < cSample.length; cpi++) {
            if (pointInRings(cSample[cpi][0], cSample[cpi][1], [seaRings[ci]])) inCount++;
          }
          if (cSample.length && inCount / cSample.length > 0.25) { seaDropped++; continue; }
          out.water.push({ rings: [seaRings[ci]], kind: 'sea' });
          seaKept++;
        }
        if (window.console && seaDropped) {
          console.warn('[mm] dropped ' + seaDropped + ' reconstructed sea area(s) ' +
                       'that contained the town -- coastline winding inverted.');
        }
        if (window.console) {
          console.info('[mm] coastline gave ' + seaRings.length + ' sea area(s) from ' +
                       out.coast.length + ' way(s)');
        }
      }

      /* Tiles are the last resort, not an addition. They are generalised and
         snapped to a per-tile grid, so where Overpass or the coastline has
         already given us water, a second coarser copy can only make it worse.
         Reached for only when the crop would otherwise have no water at all --
         which is the case that leaves a river or a bay looking like a field. */
      if (!out.water.length && fromTiles.length) {
        /* Tile water is the least trustworthy source we have, so it gets a
           sanity check that surveyed water does not need: a water area must not
           contain the town. A generalised ocean polygon that has not been cut
           at the coastline will cover the whole crop, and admitting it turns a
           coastal city into a few buildings floating in open sea -- which is a
           worse failure than having no water at all, because it is not obvious
           that anything went wrong until you look at the place you know.

           The test is blunt on purpose: count how many of this crop's buildings
           fall inside the polygon. Real water contains almost none. */
        var bldPts = [];
        for (var bi = 0; bi < out.buildings.length; bi += Math.max(1,
             Math.ceil(out.buildings.length / 400))) {
          var br = out.buildings[bi].rings[0];
          if (br && br[0]) bldPts.push(br[0]);
        }
        var kept = 0, rejected = 0;
        for (var wi = 0; wi < fromTiles.length; wi++) {
          var rings = fromTiles[wi].rings;
          var inside = 0;
          for (var pi = 0; pi < bldPts.length; pi++) {
            if (pointInRings(bldPts[pi][0], bldPts[pi][1], rings)) inside++;
          }
          if (bldPts.length && inside / bldPts.length > 0.25) {
            rejected++;
            continue;
          }
          out.water.push(fromTiles[wi]);
          kept++;
        }
        if (window.console && rejected) {
          console.warn('[mm] dropped ' + rejected + ' tile water polygon(s) that ' +
                       'contained the built-up area -- generalised ocean not cut ' +
                       'at the coastline. Kept ' + kept + '.');
        }
        if (window.console) {
          console.info('[mm] no surveyed water; using ' + fromTiles.length +
                       ' tile polygon(s) instead');
        }
      }

      /* Green fallback. Trees live inside these polygons, so an empty green set
         means a bare model no matter how the tree settings are tuned. */
      var greenTiles = res[3] || [];
      /* Fires on missing WOODLAND, not on missing green. The old test was
         `no green at all`, so a crop that returned a couple of parks and no
         wood -- which is most of what a busy Overpass gives back -- kept the
         fallback switched off and rendered flat green with nothing growing on
         it. Trees live in woods, scrub and heath; if none of those arrived,
         that is the gap worth filling, whatever else did. */
      var woodKinds = { wood: 1, scrub: 1, heath: 1 };
      var haveWood = false;
      for (var wq = 0; wq < out.grass.length; wq++) {
        if (out.grass[wq].wooded) { haveWood = true; break; }
      }
      /* Two different gaps, two different fills, and they must not be confused.

         Nothing green arrived at all -> take everything the tiles have. That is
         the case that leaves a plate with no ground cover on it.

         Green arrived but no woodland -> take ONLY the woodland. Adding the
         tiles' grass and farmland on top of surveyed green would lay a coarse
         second copy over an accurate one, and filtering to woodland in BOTH
         cases is what stripped the ground cover back out again after it had
         just been fixed. */
      if (out.grass.length && !haveWood && greenTiles.length) {
        greenTiles = greenTiles.filter(function (o) { return woodKinds[o.kind]; });
      }
      if ((!out.grass.length || !haveWood) && greenTiles.length) {
        greenTiles.forEach(function (o) {
          var tags = o.kind === 'wood' ? { natural: 'wood' }
                   : o.kind === 'scrub' ? { natural: 'scrub' }
                   : o.kind === 'heath' ? { natural: 'heath' }
                   : o.kind === 'park' ? { leisure: 'park' }
                   : o.kind === 'cemetery' ? { landuse: 'cemetery' }
                   : o.kind === 'orchard' ? { landuse: 'orchard' }
                   : o.kind === 'vineyard' ? { landuse: 'vineyard' }
                   : o.kind === 'allotments' ? { landuse: 'allotments' }
                   : o.kind === 'farmland' ? { landuse: 'farmland' }
                   : o.kind === 'meadow' ? { landuse: 'meadow' }
                   : { natural: 'grassland' };
          var tone = (o.kind === 'farmland') ? 1
                   : (o.kind === 'meadow' || o.kind === 'grassland') ? 2
                   : (o.kind === 'scrub' || o.kind === 'heath') ? 3 : 0;
          var rowKind = (o.kind === 'orchard' || o.kind === 'vineyard' ||
                         o.kind === 'allotments') ? 'rows'
                      : (o.kind === 'farmland' || o.kind === 'meadow' ||
                         o.kind === 'grassland') ? 'field' : null;
          out.grass.push({ rings: o.rings, tone: tone, kind: rowKind });
          if (MM_TREES) scatterInto(out.trees, o.rings, tags, 1);
        });
        out.partial = true;
        if (window.console) {
          console.warn('[mm] no green from Overpass -- rebuilt ' + greenTiles.length +
                       ' area(s) from tiles and scattered ' + out.trees.length + ' trees');
        }
      }

      /* Vetted tile water is kept for MASKING even when it is not used for
         drawing. The mask only decides where the ground drops and turns blue --
         it puts no polygon on the model -- so the coarseness that makes tile
         water a poor thing to draw does not matter, while its coverage is
         exactly what the flood fill lacks. A harbour the fill gives up on
         because a mole crosses it is plainly water here.

         Everything in this list has already been checked for containing the
         town, which is the guard that stops a generalised ocean polygon
         swallowing the model. */
      out.tileWater = [];
      (function () {
        var sample = [];
        for (var tb = 0; tb < out.buildings.length; tb += Math.max(1,
             Math.ceil(out.buildings.length / 400))) {
          var tr = out.buildings[tb].rings[0];
          if (tr && tr[0]) sample.push(tr[0]);
        }
        (res[2] || []).forEach(function (o) {
          var inside = 0;
          for (var sp = 0; sp < sample.length; sp++) {
            if (pointInRings(sample[sp][0], sample[sp][1], o.rings)) inside++;
          }
          if (sample.length && inside / sample.length > 0.25) return;
          out.tileWater.push(o);
        });
        if (window.console && out.tileWater.length) {
          console.info('[mm] ' + out.tileWater.length +
                       ' tile water polygon(s) kept for masking');
        }
      })();

      if (window.console) {
        console.info('[mm] water: ' + out.water.length + ' area(s) · ' +
                     out.coast.length + ' coastline way(s) · ' +
                     fromTiles.length + ' tile polygon(s) available');
      }

      if (window.console && !out.water.length && out.coast.length) {
        console.warn('[mm] this crop has coastline but produced NO water areas. ' +
                     'The sea will render as land. Coastline runs that do not ' +
                     'close against the crop edge are the usual cause.');
      }

      /* Coverage check. A large blank region can mean three different things --
         the data never arrived, it arrived and was dropped, or it arrived and
         failed to build. Counting features per cell of a 4x4 grid over the crop
         separates the first from the other two, which guessing has not. */
      (function () {
        var GRID = 4, cells = [], gi, gj;
        for (gi = 0; gi < GRID * GRID; gi++) cells.push(0);
        function bump(lon, lat) {
          var cx2 = Math.floor(((lon - b.minLon) / (b.maxLon - b.minLon)) * GRID);
          var cy2 = Math.floor(((lat - b.minLat) / (b.maxLat - b.minLat)) * GRID);
          if (cx2 < 0 || cx2 >= GRID || cy2 < 0 || cy2 >= GRID) return;
          cells[cy2 * GRID + cx2]++;
        }
        out.buildings.forEach(function (o) {
          var r = o.rings[0]; if (r && r[0]) bump(r[0][0], r[0][1]);
        });
        out.roads.forEach(function (o) {
          if (o.line && o.line[0]) bump(o.line[0][0], o.line[0][1]);
        });
        var empty = 0, rows = [];
        for (gj = GRID - 1; gj >= 0; gj--) {
          var row = '';
          for (gi = 0; gi < GRID; gi++) {
            var n = cells[gj * GRID + gi];
            if (!n) empty++;
            row += n === 0 ? ' .  ' : (String(n) + '    ').slice(0, 4);
          }
          rows.push(row);
        }
        out.coverage = (GRID * GRID - empty) + '/' + (GRID * GRID);
        if (window.console) {
          console.info('[mm] feature coverage across the crop (north at top):');
          rows.forEach(function (r) { console.info('     ' + r); });
          if (empty) {
            console.warn('[mm] ' + empty + ' of ' + (GRID * GRID) +
              ' cells have NO buildings or roads from Overpass. If those cells ' +
              'look empty in the render too, the data never arrived -- this is ' +
              'upstream of the geometry code.');
          }
        }
      })();
      /* Coastline reconstruction only when the tiles gave us nothing -- a style
         with no water layer. Belt and braces, in that order. */
      if (window.console) {
        console.info('[mm] overpass:', out.buildings.length, 'buildings,',
          out.roads.length, 'roads,', out.grass.length, 'green,',
          out.trees.length, 'trees', out.partial ? '(partial)' : '');
      }
      /* Both caches are dropped, not one. The geometry cache holds the
         assembled result for this crop; the session cache holds the raw
         responses it was built from. Evicting only the first would rebuild the
         same degraded model out of the second. */
      if (out.partial) {
        delete GEOM_CACHE[gk];
        var at = GEOM_KEYS.indexOf(gk);
        if (at >= 0) GEOM_KEYS.splice(at, 1);
        opStoreDrop(qBase); opStoreDrop(qStruct); opStoreDrop(qDetailLite);
        if (window.console) {
          console.info('[mm] this answer was incomplete -- not cached, so the ' +
                       'next render of this crop asks Overpass again');
        }
      }
      /* Gap-fill last, so it sees the finished counts, and inside the cached
         promise, so a re-render of this crop does not fetch the tiles again. */
      return mmOvertureFill(cfg, b, out);
    });

    /* Held only once it succeeds -- a rejected promise cached here would make a
       transient Overpass outage look permanent for the rest of the session. */
    GEOM_CACHE[gk] = built;
    GEOM_KEYS.push(gk);
    while (GEOM_KEYS.length > 4) delete GEOM_CACHE[GEOM_KEYS.shift()];
    built.catch(function () {
      delete GEOM_CACHE[gk];
      var at = GEOM_KEYS.indexOf(gk);
      if (at >= 0) GEOM_KEYS.splice(at, 1);
    });
    return built;
  }

  /* ----------------------------- terrain -------------------------------- */
  /* Elevation from Terrarium-encoded PNG tiles: height = R*256 + G + B/256 -
     32768 metres. Free, key-less, and the same data most terrain renderers use.
     If anything fails — CORS, a dead tile, no provider set — we return null and
     the model is built flat, exactly as before. */

  /* Web Mercator, in pixels, on the 256-pixel tile scheme the terrarium tiles
     use. These were being CALLED and never existed: collectTerrain threw a
     ReferenceError on its first line, the promise rejected, and the caller's
     .catch turned that into "no terrain" without a word. Terrain has therefore
     never once loaded -- every flat model, every missing contour line, all of
     it was this. */
  function lon2px(lon, z) {
    return ((lon + 180) / 360) * 256 * Math.pow(2, z);
  }
  function lat2px(lat, z) {
    var s = Math.sin(lat * D2R);
    if (s > 0.9999) s = 0.9999;
    if (s < -0.9999) s = -0.9999;
    return (0.5 - Math.log((1 + s) / (1 - s)) / (4 * Math.PI)) * 256 * Math.pow(2, z);
  }

  /* Walks the source list until one returns usable elevation. A source counts
     as failed if its tiles do not load, or if they load but the canvas ends up
     tainted -- which is the quiet one, because the images arrive and look fine
     and only reading the pixels back throws. Either way the next host is tried
     before giving up and building the model flat. */
  function collectTerrain(cfg, bbox) {
    var sources = cfg.terrainUrl ? [cfg.terrainUrl].concat(TERRAIN_SOURCES)
                                 : TERRAIN_SOURCES.slice();
    function attempt(i) {
      if (i >= sources.length) {
        if (window.console) {
          console.warn('[mm] no elevation from any source -- the model will be ' +
                       'flat. Tried: ' + sources.join(', '));
        }
        return Promise.resolve(null);
      }
      return collectTerrainFrom(sources[i], bbox).then(function (t) {
        if (t) {
          if (window.console && i > 0) {
            console.info('[mm] elevation from fallback source ' + (i + 1));
          }
          return t;
        }
        return attempt(i + 1);
      }, function () { return attempt(i + 1); });
    }
    return attempt(0);
  }

  function collectTerrainFrom(tileUrl, bbox) {
    return new Promise(function (resolve) {
      if (!tileUrl) return resolve(null);

      var latMid = (bbox.minLat + bbox.maxLat) / 2;
      var groundM = (bbox.maxLat - bbox.minLat) * 110540;
      var target = 220;                                   // samples across the crop
      var mpp = groundM / target;
      var z = Math.round(Math.log2((156543.03392 * Math.cos(latMid * D2R)) / mpp));
      /* 15, not 14. At 14 one pixel is roughly seven metres of ground on a
         one-kilometre crop, which is coarser than the terraces we are trying to
         cut out of it. */
      z = Math.max(6, Math.min(15, z));

      var x0 = Math.floor(lon2px(bbox.minLon, z) / 256);
      var x1 = Math.floor(lon2px(bbox.maxLon, z) / 256);
      var y0 = Math.floor(lat2px(bbox.maxLat, z) / 256);
      var y1 = Math.floor(lat2px(bbox.minLat, z) / 256);
      var cols = x1 - x0 + 1, rows = y1 - y0 + 1;
      if (cols * rows > 36) return resolve(null);         // sanity guard

      var canvas = document.createElement('canvas');
      canvas.width = cols * 256;
      canvas.height = rows * 256;
      var ctx = canvas.getContext('2d', { willReadFrequently: true });
      var pending = cols * rows, failed = 0;

      function done() {
        var data;
        try {
          data = ctx.getImageData(0, 0, canvas.width, canvas.height);
        } catch (e) {
          if (window.console) console.warn('[mm] terrain canvas tainted:', e.message);
          return resolve(null);
        }
        if (failed >= pendingTotal) return resolve(null);

        var originX = x0 * 256, originY = y0 * 256;
        var px = data.data, W = canvas.width, H = canvas.height;
        /* Despeckle (14 Oct): see the banner. noisy = this browser alters canvas
           reads; spikes = samples replaced. Both go into the Renders tab. */
        var noisy = MM_canvasNoisy(), SPIKE_M = 100;
        var memo = new Float32Array(W * H), memoSet = new Uint8Array(W * H);
        var tStat = window.MM_TERRAIN = { noisy: noisy, spikes: 0 };

        /* Bilinear, not nearest-pixel. One pixel of this raster is several
           metres of ground, so rounding to the nearest one meant the elevation
           arrived already stepped -- little square plateaus baked into the
           source before any terracing was applied. Quantising that a second
           time is what produced the blocky, tiled look on gentle ground.
           Interpolating between the four surrounding samples gives a smooth
           surface for the terracing to cut clean bands out of. */
        function raw0(gx, gy) {
          if (gx < 0) gx = 0; if (gx >= W) gx = W - 1;
          if (gy < 0) gy = 0; if (gy >= H) gy = H - 1;
          var i = (gy * W + gx) * 4;
          if (px[i + 3] === 0) return null;               // tile never arrived
          return (px[i] * 256 + px[i + 1] + px[i + 2] / 256) - 32768;
        }
        function raw(gx, gy) {
          if (gx < 0) gx = 0; if (gx >= W) gx = W - 1;
          if (gy < 0) gy = 0; if (gy >= H) gy = H - 1;
          var k = gy * W + gx;
          if (memoSet[k]) return memoSet[k] === 2 ? null : memo[k];
          var v = raw0(gx, gy), out = v;
          if (v != null) {
            var nb = [];
            for (var ny = -1; ny <= 1; ny++) {
              for (var nx = -1; nx <= 1; nx++) {
                if (!nx && !ny) continue;
                var w0 = raw0(gx + nx, gy + ny);
                if (w0 != null) nb.push(w0);
              }
            }
            if (nb.length >= 5) {
              nb.sort(function (p, q) { return p - q; });
              var med = (nb[(nb.length - 1) >> 1] + nb[nb.length >> 1]) / 2;
              if (Math.abs(v - med) > SPIKE_M) { out = med; tStat.spikes++; }
            }
          }
          memoSet[k] = out == null ? 2 : 1;
          if (out != null) memo[k] = out;
          return out;
        }
        /* A missing sample must not read as sea level. One tile arriving short
           used to return null, the caller turned that into zero, and zero is
           the bottom of the crop -- so a gap in the elevation data punched a
           notch straight down through a hillside. Search outward for a real
           value first; only give up if there is genuinely nothing nearby. */
        function nearestRaw(gx, gy) {
          var v = raw(gx, gy);
          if (v != null) return v;
          for (var r = 1; r <= 4; r++) {
            for (var dx3 = -r; dx3 <= r; dx3++) {
              for (var dy3 = -r; dy3 <= r; dy3++) {
                if (Math.abs(dx3) !== r && Math.abs(dy3) !== r) continue;
                var w2 = raw(gx + dx3, gy + dy3);
                if (w2 != null) return w2;
              }
            }
          }
          return null;
        }
        function at(lon, lat) {
          var fx = lon2px(lon, z) - originX, fy = lat2px(lat, z) - originY;
          var x0 = Math.floor(fx), y0 = Math.floor(fy);
          var tx = fx - x0, ty = fy - y0;
          var a = nearestRaw(x0, y0), b = raw(x0 + 1, y0);
          var c = raw(x0, y0 + 1), d = raw(x0 + 1, y0 + 1);
          if (a == null) return null;
          if (b == null) b = a;
          if (c == null) c = a;
          if (d == null) d = b;
          return (a * (1 - tx) + b * tx) * (1 - ty) +
                 (c * (1 - tx) + d * tx) * ty;
        }

        // sample the crop to find its own range, ignoring the rest of the tiles
        var lo = Infinity, hi = -Infinity, n = 0;
        for (var a = 0; a <= 40; a++) {
          for (var b = 0; b <= 40; b++) {
            var h = at(bbox.minLon + (bbox.maxLon - bbox.minLon) * a / 40,
                       bbox.minLat + (bbox.maxLat - bbox.minLat) * b / 40);
            if (h == null || h < -500 || h > 9000) continue;
            if (h < lo) lo = h;
            if (h > hi) hi = h;
            n++;
          }
        }
        if (!n || !isFinite(lo)) return resolve(null);
        if (window.console) {
          console.info('[mm] terrain z' + z + ': ' + lo.toFixed(0) + '\u2013' +
            hi.toFixed(0) + ' m over the crop' +
            (tStat.spikes ? ' \u00b7 ' + tStat.spikes + ' spike(s) removed' : '') +
            (noisy ? ' \u00b7 this browser adds noise to canvas reads' : ''));
        }
        resolve({ at: at, min: lo, max: hi, zoom: z });
      }

      var pendingTotal = pending;
      for (var cx = x0; cx <= x1; cx++) {
        for (var cy = y0; cy <= y1; cy++) {
          (function (tx, ty) {
            var img = new Image();
            img.crossOrigin = 'anonymous';
            img.onload = function () {
              try { ctx.drawImage(img, (tx - x0) * 256, (ty - y0) * 256); } catch (e) {}
              if (--pending === 0) done();
            };
            img.onerror = function () {
              failed++;
              if (--pending === 0) done();
            };
            img.src = tileUrl
              .replace('{z}', z).replace('{x}', tx).replace('{y}', ty);
          })(cx, cy);
        }
      }

      setTimeout(function () { if (pending > 0) { pending = 0; done(); } }, 15000);
    });
  }

  /* ---------------------------- 3D preview ------------------------------ */

  /* Desktop keeps the modal. On a phone the render is built straight into the
     page instead, as the first thing above the thumbnails — no dialog to
     dismiss, and you can scroll away from it like any other image. */
  function openPreview(spec, cfg, onBack) {
    if (!spec) return;
    var m = modalShell('3D preview', 'Reduced-quality preview of your model.', true);
    buildPreview(m.inner, spec, cfg, onBack, function () { m.close(); }, m.onClose);
  }

  function inlinePreview(host, spec, cfg, onBack, priceText, onAdd, discHost, onReady, restHost) {
    if (!spec) return;
    host.innerHTML = '';
    host.classList.remove('mm-hide');
    if (discHost) { discHost.innerHTML = ''; discHost.classList.remove('mm-hide'); }
    if (restHost) { restHost.innerHTML = ''; restHost.classList.remove('mm-hide'); }

    /* No price header and no buy button here: the total sits above the preview
       button and Add to cart directly below this block, so both would be
       duplicates a few pixels apart. */
    buildPreview(host, spec, cfg, onBack, null, function () {}, discHost, onReady, restHost);
  }


  /* Build 3: the angle strip. Injected from here rather than added to the
     section's stylesheet, so a build lands by replacing one asset and the
     theme's Liquid is left alone. */
  var GAL_CSS = [
    '.mm-gal{position:relative}',
    '.mm-gal:focus{outline:none}',
    '.mm-gal:focus-visible{outline:2px solid currentColor;outline-offset:3px;border-radius:10px}',
    '.mm-gal-track{display:flex;overflow-x:auto;overflow-y:hidden;scroll-snap-type:x mandatory;',
    'scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch}',
    '.mm-gal-track::-webkit-scrollbar{display:none}',
    '.mm-gal-slide{flex:0 0 100%;min-width:100%;scroll-snap-align:center;scroll-snap-stop:always}',
    '.mm-gal-dots{display:flex;gap:9px;justify-content:center;margin:12px 0 4px}',
    '.mm-gal-dot{width:10px;height:10px;padding:0;border:0;border-radius:50%;cursor:pointer;',
    'background:currentColor;opacity:.25;transition:opacity .2s,transform .2s}',
    '.mm-gal-dot.is-on{opacity:.85;transform:scale(1.3)}',
    /* Always visible, on every device. They were hover-only on desktop and
       hidden outright on touch, so nothing on screen said the four views could
       be flicked through -- which is exactly what Kevin could not find. */
    '.mm-gal-arrow{position:absolute;top:50%;transform:translateY(-50%);z-index:4;',
    'width:38px;height:38px;display:flex;align-items:center;justify-content:center;',
    'border:0;border-radius:50%;cursor:pointer;color:#1D1F22;background:rgba(255,255,255,.92);',
    'box-shadow:0 2px 10px rgba(0,0,0,.20);opacity:1;transition:transform .15s,background .15s}',
    '.mm-gal-arrow.is-prev{left:8px}.mm-gal-arrow.is-next{right:8px}',
    '.mm-gal.is-building .mm-gal-arrow{display:none}',
    /* In the circle the magnifier sat in a corner the crop cuts off, and the
       theme hides it until hover, so the only time anyone saw it was mid-swipe.
       Top centre, always on, and labelled -- nobody guesses a bare icon. */
    '.mm-disc .mm-pv-zoom{left:50%;right:auto;top:12px;transform:translateX(-50%);',
      'width:auto;height:auto;border-radius:999px;padding:7px 13px;gap:6px;',
      'background:rgba(255,255,255,.94);box-shadow:0 2px 10px rgba(0,0,0,.16);',
      'font:600 12.5px/1 var(--mm-face,inherit);white-space:nowrap;z-index:5}',
    '.mm-disc .mm-pv-zoom::after{content:attr(data-label)}',
    /* B5.47: the pill under the circle replaces the icon on it. */
    '.mm-disc .mm-pv-zoom{display:none!important}',
    '.mm-turn .mm-enl{display:inline-flex;align-items:center;gap:7px;padding:9px 16px;border:0;',
      'border-radius:999px;background:#fff;color:#17181A;font:600 13px/1 var(--mm-face,inherit);',
      'white-space:nowrap;cursor:pointer;box-shadow:0 2px 10px rgba(0,0,0,.16);',
      '-webkit-tap-highlight-color:transparent;transition:box-shadow .15s}',
    '.mm-turn .mm-enl:hover{box-shadow:0 3px 14px rgba(0,0,0,.24)}',
    '.mm-turn .mm-enl svg{flex:none}',
    /* B5.52: "See it in a room", beside the enlarge pill. */
    '.mm-turn .mm-enl{vertical-align:middle;margin:4px 0}',
    '.mm-turn .mm-room{display:inline-flex;align-items:center;gap:8px;padding:4px 15px 4px 4px;',
      'margin:4px 0 4px 8px;border:0;border-radius:999px;background:#fff;color:#17181A;',
      'font:600 13px/1 var(--mm-face,inherit);white-space:nowrap;cursor:pointer;vertical-align:middle;',
      'box-shadow:0 2px 10px rgba(0,0,0,.16);-webkit-tap-highlight-color:transparent;transition:box-shadow .15s}',
    '.mm-turn .mm-room:hover{box-shadow:0 3px 14px rgba(0,0,0,.24)}',
    '.mm-turn .mm-room img{width:23px;height:23px;border-radius:999px;object-fit:cover;flex:none;display:block}',
    '.mm-rooms-track::-webkit-scrollbar{display:none}',
    /* B5.49: opt-in line under the email field. */
    '.mm-optin{display:flex;align-items:flex-start;gap:9px;font-size:13px;line-height:1.4;',
      'color:#5B5E66;cursor:pointer;-webkit-user-select:none;user-select:none;text-align:left}',
    '.mm-optin input{width:18px;height:18px;margin:1px 0 0;flex:none;accent-color:#121417;cursor:pointer}',
    '.mm-gal-arrow:hover{transform:translateY(-50%) scale(1.07);background:#fff}',
    '@media (prefers-reduced-motion:reduce){.mm-gal-track{scroll-behavior:auto}}',
    /* The attention cue. Twice and then never again: a permanent pulse is
       decoration, and people stop seeing it inside ten seconds. This fires only
       when a step becomes the live one, so at any moment exactly one thing on
       the page has just moved. forwards, so it settles rather than snapping
       back. */
    '@keyframes mm-attn{0%{box-shadow:0 0 0 0 rgba(30,79,196,.42)}',
      '70%{box-shadow:0 0 0 9px rgba(30,79,196,0)}',
      '100%{box-shadow:0 0 0 0 rgba(30,79,196,0)}}',
    '.mm-attn{animation:mm-attn 1.25s ease-out 2 both}',
    /* Negative margins equal to the padding: the label gains a shape for the
       glow to follow and the row does not move a pixel. */
    '.mm-attn-pill{display:inline-block;border-radius:8px;',
      'padding:2px 8px;margin:-2px -8px}',
    '@media (prefers-reduced-motion:reduce){.mm-attn{animation:none}}',
    /* B5.67 "not yet" nudge. drop-shadow, not box-shadow: the desktop step
       panel is a curved SVG shape, and a filter glow follows its outline where
       a box-shadow would draw a rectangle round it. */
    '@keyframes mm-shake{0%,100%{transform:translateX(0)}12%{transform:translateX(-8px)}',
      '27%{transform:translateX(7px)}42%{transform:translateX(-5px)}',
      '57%{transform:translateX(3px)}72%{transform:translateX(-1px)}}',
    '@keyframes mm-glow{0%{filter:drop-shadow(0 0 0 rgba(30,79,196,0))}',
      '22%{filter:drop-shadow(0 0 12px rgba(30,79,196,.7))}',
      '100%{filter:drop-shadow(0 0 0 rgba(30,79,196,0))}}',
    '@keyframes mm-btnring{0%{box-shadow:0 0 0 0 rgba(30,79,196,.5)}',
      '70%{box-shadow:0 0 0 9px rgba(30,79,196,0)}',
      '100%{box-shadow:0 0 0 0 rgba(30,79,196,0)}}',
    '@keyframes mm-why{15%,70%{color:#1E4FC4}}',
    '@keyframes mm-whycard{15%,70%{opacity:1}}',
    '.mm-nudge{animation:mm-shake .5s cubic-bezier(.36,.07,.19,.97),mm-glow 1.1s ease-out}',
    '.mm-nudge .mm-step-next{animation:mm-btnring .9s ease-out .15s 2}',
    '.mm-why{animation:mm-why 1.4s ease-out}',
    '.mm-whycard{animation:mm-whycard 1.4s ease-out}',
    '.mm-why.mm-whycard{animation:mm-why 1.4s ease-out,mm-whycard 1.4s ease-out}',
    /* Reduced motion: glow, blue line and brightening, no shake, no ring.
       mm-configurator.css cuts EVERY animation under .mm to .01ms with
       !important when reduced motion is on, which would take the glow too,
       so these need .mm in front and !important to win back the ones that
       are not movement. The Next ring stays cut, as mm-attn already is. */
    '@media (prefers-reduced-motion:reduce){',
      '.mm .mm-nudge{animation:mm-glow 1.1s ease-out !important}',
      '.mm .mm-why{animation:mm-why 1.4s ease-out !important}',
      '.mm .mm-whycard{animation:mm-whycard 1.4s ease-out !important}',
      '.mm .mm-why.mm-whycard{animation:mm-why 1.4s ease-out,mm-whycard 1.4s ease-out !important}}',
    /* A stat that has not arrived yet scans instead of sitting on a dash.
       Four of them come back in one response, so for most of the wait the
       strip has nothing true to say -- but "nothing yet" and "stopped"
       looked identical, and the honest fix is to show which it is. */
    '@keyframes mm-scan{0%{transform:translateX(-105%)}100%{transform:translateX(105%)}}',
    '.mm-fact-wait{position:relative;display:block;height:9px;border-radius:99px;',
      'overflow:hidden;background:rgba(21,24,29,.09)}',
    '.mm-fact-wait::after{content:"";position:absolute;inset:0;transform:translateX(-105%);',
      'background:linear-gradient(90deg,transparent,rgba(30,79,196,.55),transparent);',
      'animation:mm-scan 1.15s ease-in-out infinite}',
    '@media (prefers-reduced-motion:reduce){.mm-fact-wait::after{animation:none;opacity:.3;',
      'transform:none}}',
    /* The enlarge control. It was a 30 px circle holding a magnifier and a
       data-label nothing ever rendered -- so it said nothing, and Kevin kept
       missing his own button. Three changes: 44 px (the minimum target worth
       aiming at), the expand-arrows glyph rather than a magnifier, since the
       action is "see it bigger" and not "search", and it announces itself
       once.

       Once is the whole design. A permanent pulse is decoration and stops
       being seen inside ten seconds -- the mm-attn cue above already settled
       that argument. This fires three times as the model lands, which is the
       one moment attention is guaranteed to be on the disc, then never again.
       The word is "See it full size", not "click to enlarge": it says what
       you get, not what to do with your finger, and it reads the same whether
       you are on a phone or a laptop. */
    '@keyframes mm-zoomring{0%{box-shadow:0 2px 6px rgba(20,20,19,.16),',
      '0 0 0 0 rgba(30,79,196,.5)}',
      '70%,100%{box-shadow:0 2px 6px rgba(20,20,19,.16),0 0 0 15px rgba(30,79,196,0)}}',
    '@keyframes mm-zoomhint{0%{opacity:0;transform:translateX(6px)}',
      '12%,72%{opacity:1;transform:translateX(0)}',
      '100%{opacity:0;transform:translateX(6px)}}',
    '.mm-pv-zoom{width:44px;height:44px;border-radius:12px;right:12px;top:12px;',
      'background:#fff;border:1px solid rgba(20,20,19,.14);',
      'box-shadow:0 2px 6px rgba(20,20,19,.16);animation:mm-zoomring 1.5s ease-out 3}',
    '.mm-pv-zoom::after{content:attr(data-label);position:absolute;',
      'right:calc(100% + 9px);top:50%;transform:translateY(-50%);white-space:nowrap;',
      'padding:7px 13px;border-radius:999px;background:#141413;color:#fff;',
      'font-weight:600;font-size:12.5px;line-height:1;opacity:0;',
      'animation:mm-zoomhint 4.5s ease-in-out 1}',
    '@media (prefers-reduced-motion:reduce){.mm-pv-zoom{animation:none}',
      '.mm-pv-zoom::after{animation:none;opacity:1}}'
  ].join('');
  /* The wait is two minutes at 40 cm and a single frozen sentence makes it read
     as a page that has stopped. Each line names a step this pipeline actually
     performs, keyed to the stage it belongs to, and they rotate every few
     seconds so there is always something new under the bar. */
  var TICK_LINES = {
    search: [
      'Usually under a minute \u2014 keep this page open',
      'Working out the exact piece of ground you picked',
      'Setting the scale for the size you chose',
      'Squaring the area off against the map index'
    ],
    map: [
      'Asking the map servers for this piece of ground',
      'Collecting building footprints, one by one',
      'Tracing the street network through the area',
      'Public map data is shared \u2014 there can be a queue ahead of you',
      'Picking up parks, water and tree lines',
      'Dense areas carry a lot of detail; this is the slow part',
      'Still going. Nothing has gone wrong \u2014 it is a big request'
    ],
    sat: [
      'Reading ground heights across the area',
      'Working out where the land rises and falls',
      'Levelling the water so it sits flat',
      'Checking land cover for greens and greys'
    ],
    build: [
      'Extruding every building to its own height',
      'Laying the roads over the ground',
      'Planting trees along the streets',
      'Cutting the disc and fitting the frame',
      'Trimming everything back to the circle'
    ],
    camera: [
      'Setting the studio lights',
      'Photographing the model from four angles',
      'Sharpening the finished images'
    ]
  };

  function ensureGalCss() {
    if (document.getElementById('mm-gal-css')) return;
    var st = document.createElement('style');
    st.id = 'mm-gal-css';
    st.textContent = GAL_CSS;
    document.head.appendChild(st);
  }

  function buildPreview(mount, spec, cfg, onBack, closeSelf, onClose, discHost, onReady, restHost) {
    /* Three mounts now. `discHost` is the circle (the model and the progress
       line), `mount` is the strip directly under it (the angle dots), and
       `restHost` is below the buy button (the comparison link, the legend and
       the build stats). Without the third one Add to cart sat under all of
       that and needed a scroll the moment a render landed. */
    var restMount = restHost || mount;
    ensureGalCss();
    var m = { inner: mount, onClose: onClose };

    if (onBack) {
      var backRow = el('div', 'mm-backrow');
      var back = el('button', 'mm-btn is-ghost', '\u2039  Back to place selection');
      back.type = 'button';
      back.addEventListener('click', function () {
        if (closeSelf) closeSelf();
        onBack();
      });
      backRow.appendChild(back);
      m.inner.appendChild(backRow);
    }

    /* Each size gets its own pair of scene photos. A 15 cm model on a 3 m wall
       is genuinely 5% of the frame — the only honest way to make it readable is
       a tighter shot for the smaller sizes. */
    var sz = (cfg.sizes || []).filter(function (o) { return o.id === spec.size.id; })[0] || {};
    /* A size with its own photo but no width of its own is the dangerous case:
       it inherits the section fallback, which describes a completely different
       photo, and the model comes out at the wrong scale in a shot that looks
       fine. Loud in the console rather than silent on the page. */
    if (window.console) {
      if (sz.wallImage && !sz.wallCm) {
        console.warn('[mm] size ' + spec.size.cm + 'cm has its own wall photo but no ' +
          '"Wall width in real cm" \u2014 falling back to ' + (cfg.roomWallCm || 300) +
          'cm, which describes a different photo. Set it on the size block.');
      }
      if (sz.deskImage && !sz.deskCm) {
        console.warn('[mm] size ' + spec.size.cm + 'cm has its own table photo but no ' +
          '"Photo width in real cm" \u2014 falling back to ' + (cfg.deskCm || 70) + 'cm.');
      }
    }

    /* 5.4: plain background, no desk or wall photograph.

       The photos place the model where it sits naturally in that particular
       shot -- off to one side, low in the frame, sized against a real table.
       That composition was built for a rectangle. Inside a circle it reads as
       a badly cropped photo, which is exactly what Kevin saw: the plate sitting
       low and left with wood filling the rest of the disc. On a plain ground
       the model is placed dead centre at full size and the circle looks
       deliberate.

       The deskImage / roomImage theme settings are deliberately ignored rather
       than removed, so nothing in the section schema breaks and they are there
       if we ever want the photo composition back. */
    var PLAIN_BACKDROP = true;
    var scene = {
      desk: PLAIN_BACKDROP ? null : (sz.deskImage || cfg.deskImage || null),
      deskCm: sz.deskCm || cfg.deskCm || 70,
      deskX: 50,
      deskY: 50,
      wall: PLAIN_BACKDROP ? null : (sz.wallImage || cfg.roomImage || null),
      wallCm: sz.wallCm || cfg.roomWallCm || 300,
      wallX: sz.wallX != null ? sz.wallX : 50,
      wallY: sz.wallY != null ? sz.wallY : 42
    };

    var body = el('div', 'mm-pv');
    /* The theme makes .mm-pv two columns above 760px, for the old side-by-side
       studio and room panes. In the circle layout there is one child left --
       the angle dots and their caption -- and it was landing in column one,
       which is why it sat left of centre under a centred circle. */
    if (discHost) body.setAttribute('style', 'display:block;width:100%;padding:0');

    /* Build 3: four angles in a swipeable strip. Scroll-snap does the swiping,
       so a phone flick, a trackpad, a wheel and the arrow keys all work without
       any drag handling of our own. */
    /* One pane in live mode: the customer turns the model instead of flicking
       between four photographs of it, and the three extra photographs were the
       bulk of the wait. The four-pane strip is still here for when the live
       viewer is switched off or the device cannot hold it. */
    var LIVE_UI = cfg.liveView !== false;
    var ANGLE_CAPS = LIVE_UI
      ? ['Drag to turn it']
      : ['Three-quarter view', 'From the left', 'From the right', 'From above'];
    var left = el('div', 'mm-pv-pane');
    var galTrack = el('div', 'mm-gal-track');
    var shotWraps = ANGLE_CAPS.map(function (cap) {
      var w = el('div', 'mm-pv-shot mm-gal-slide');
      if (!scene.desk) {
        w.classList.add('is-plain');
        /* The theme's plain backdrop is a warm beige gradient built for the old
           palette. Inline, because the theme's rule lands after anything we
           inject. */
        w.style.background =
          'radial-gradient(120% 100% at 50% 0%,#FFFFFF 0%,#E8ECF1 100%)';
        w.style.borderRadius = '0';
      }
      var im = el('img', 'mm-pv-desk');
      im.alt = 'Your model, ' + cap.toLowerCase();
      w.appendChild(im);
      var zoomTag = el('div', 'mm-pv-zoom', '<svg width="19" height="19" viewBox="0 0 24 24" ' +
        'fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" ' +
        'stroke-linejoin="round" aria-hidden="true"><path d="M9 3H3v6"></path>' +
        '<path d="M15 21h6v-6"></path><path d="M3 3l7.5 7.5"></path>' +
        '<path d="M21 21l-7.5-7.5"></path></svg>');
      /* Same words on both: what you get, not which gesture to use. */
      zoomTag.setAttribute('data-label', 'See it full size');
      w.appendChild(zoomTag);
      galTrack.appendChild(w);
      return w;
    });
    var studioImgs = shotWraps.map(function (w) { return w.querySelector('img'); });
    var studioWrap = shotWraps[0], studioImg = studioImgs[0];

    var gal = el('div', 'mm-gal');
    gal.appendChild(galTrack);
    var galCap = el('div', 'mm-pv-cap', ANGLE_CAPS[0]);
    var galDots = el('div', 'mm-gal-dots');
    if (ANGLE_CAPS.length < 2) galDots.style.display = 'none';
    var dotEls = ANGLE_CAPS.map(function (cap, i) {
      var d = el('button', 'mm-gal-dot' + (i ? '' : ' is-on'));
      d.type = 'button';
      d.setAttribute('aria-label', cap);
      d.addEventListener('click', function () { galGo(i); });
      galDots.appendChild(d);
      return d;
    });
    function galMark(i) {
      galCap.textContent = ANGLE_CAPS[i] || ANGLE_CAPS[0];
      dotEls.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
    }
    function galAt() {
      var w = galTrack.clientWidth || 1;
      return Math.max(0, Math.min(dotEls.length - 1, Math.round(galTrack.scrollLeft / w)));
    }
    /* Wraps, so the four views are a loop rather than a strip with two dead
       ends. The jump from the last back to the first scrolls the track rather
       than teleporting -- honest about what it is, and it never refuses. */
    function galGo(i) {
      var n = dotEls.length || 1;
      i = ((i % n) + n) % n;
      var w = galTrack.clientWidth || 0;
      if (galTrack.scrollTo) galTrack.scrollTo({ left: i * w, behavior: 'smooth' });
      else galTrack.scrollLeft = i * w;
      galMark(i);
    }
    var galTick = null;
    galTrack.addEventListener('scroll', function () {
      if (galTick) return;
      galTick = setTimeout(function () { galTick = null; galMark(galAt()); }, 90);
    }, { passive: true });
    (ANGLE_CAPS.length < 2 ? [] : ['prev', 'next']).forEach(function (way) {
      var b = el('button', 'mm-gal-arrow is-' + way,
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
        'stroke-width="2.2"><path d="M' + (way === 'prev' ? '15 5l-7 7 7 7' : '9 5l7 7-7 7') +
        '"></path></svg>');
      b.type = 'button';
      b.setAttribute('aria-label', way === 'prev' ? 'Previous view' : 'Next view');
      b.addEventListener('click', function (ev) {
        ev.stopPropagation();
        galGo(galAt() + (way === 'prev' ? -1 : 1));
      });
      gal.appendChild(b);
    });
    gal.tabIndex = 0;
    gal.addEventListener('keydown', function (ev) {
      if (ev.key === 'ArrowLeft') { galGo(galAt() - 1); ev.preventDefault(); }
      else if (ev.key === 'ArrowRight') { galGo(galAt() + 1); ev.preventDefault(); }
    });
    /* The model itself belongs in the circle; its caption and dots stay out
       here under it, where there is room for them to be read. */
    if (discHost) {
      gal.setAttribute('style',
        'position:absolute;inset:0;width:100%;height:100%;display:block');
      galTrack.style.height = '100%';
      gal.classList.add('is-building');
      discHost.appendChild(gal);
    } else {
      left.appendChild(gal);
    }
    left.appendChild(galDots);
    left.appendChild(galCap);

    var right = el('div', 'mm-pv-pane');
    var room = el('div', 'mm-pv-room');
    if (!scene.wall) room.classList.add('is-plain');
    var wallImg = el('img', 'mm-pv-wall');
    wallImg.alt = 'Your model on a wall';
    room.appendChild(wallImg);
    room.appendChild(el('div', 'mm-pv-zoom',
      '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
      'stroke-width="2"><circle cx="11" cy="11" r="7"></circle><path d="M20 20l-4-4"></path></svg>'));
    right.appendChild(room);
    right.appendChild(el('div', 'mm-pv-cap',
      '\u00D8 ' + spec.size.cm + ' cm, to scale'));

    /* The largest size shows the wall shot only. At 40 cm the piece is a wall
       object rather than something you set on a desk, and the isolated render
       beside it says less about it than seeing it hung to scale does. Driven by
       a setting rather than the number, so the lineup can change without this
       becoming a stale magic value. */
    var wallOnly = spec.size.cm >= (cfg.wallOnlyFromCm || 40);
    if (discHost) {
      /* The model is in the circle, so `left` is down to its dots and caption.
         The room shot does not come with it: a second square photo of the same
         model directly under the circle duplicated what was already on screen
         and pushed Add to cart off a 1080p display. wallImg stays built and
         detached so renderModel can keep writing to it. */
      /* Centred and legible: this row is the control for the circle above it and
         it was sitting small and hard against the left edge of a 720px box. */
      left.setAttribute('style',
        'width:100%;display:flex;flex-direction:column;align-items:center;gap:2px');
      galCap.setAttribute('style',
        'text-align:center;font-size:14.5px;font-weight:500;margin:2px 0 0');
      body.appendChild(left);
    } else {
      if (!wallOnly) body.appendChild(left);
      body.appendChild(right);
    }
    if (wallOnly) body.classList.add('is-single');
    /* Collapses the two panes while the model builds, so the progress card is
       the whole block rather than a line of text stranded in a tall gap. */
    mount.classList.add('mm-pv-loading');

    /* Both panes stay blank while the model builds, so the room and the model
       arrive together. Showing an empty sofa for forty seconds gives the reveal
       away and leaves the visitor staring at furniture. The photos are
       preloaded meanwhile, so the reveal is instant rather than a second wait. */
    shotWraps.concat([room]).forEach(function (n) {
      n.style.opacity = '0';
      n.style.transition = 'opacity .5s ease';
    });
    [scene.desk, scene.wall].forEach(function (u) {
      if (u) { var pre = new Image(); pre.src = u; }
    });

    var scenesShown = false;
    function revealScenes() {
      if (scenesShown) return;
      scenesShown = true;
      mount.classList.remove('mm-pv-loading');
      if (scene.desk) {
        shotWraps.forEach(function (w) { w.style.backgroundImage = 'url(' + scene.desk + ')'; });
      }
      if (scene.wall) room.style.backgroundImage = 'url(' + scene.wall + ')';
      // two frames, so the browser paints the backdrop before the fade starts
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          shotWraps.forEach(function (w) { w.style.opacity = '1'; });
          room.style.opacity = '1';
        });
      });
    }

    // tap either image to see the whole scene large, backdrop included
    shotWraps.concat([room]).forEach(function (node) {
      node.addEventListener('click', function () {
        if (node.style.opacity === '0') return;   // nothing to show yet
        var cv = node.querySelector('canvas');
        if (cv) {
          /* A drag that turned the model must not also open the enlarged view. */
          if (Date.now() - (cv.__mmDragEnd || 0) < 400) return;
          /* The live model itself goes into the enlarged view -- canvas and all
             -- so it can still be turned and zoomed in there. Cloning would give
             a blank canvas; the baked still is only the fallback. */
          if (cfg.__mmLive && cfg.__mmLive.enlarge) return cfg.__mmLive.enlarge();
          var im = node.querySelector('img');
          if (im && im.src) return openLightbox(im.src);
          return;
        }
        openLightboxNode(node);
      });
    });

    var status = el('div', 'mm-status', '');
    if (discHost) {
      /* The wait happens where the model is going to appear, not in a strip
         somewhere else on the page. */
      status.setAttribute('style',
        'position:absolute;inset:0;z-index:3;display:flex;flex-direction:column;' +
        'align-items:center;justify-content:center;gap:10px;text-align:center;' +
        'padding:0 14%;box-sizing:border-box;background:#E9E6DE');
      discHost.appendChild(status);
    } else {
      body.appendChild(status);
    }

    /* Above the render, because it answers the question the render provokes:
       is this really what I get? Hidden until the panes are up -- there is
       nothing to compare against while it is still building. */
    /* This was a caption beside a small outlined pill, and almost nobody
       pressed it -- it read as a footnote rather than an offer. It is now one
       wide target with the two photos shown split inside it, because the
       thumbnail explains what the button does faster than the words do, and
       because a strip is far easier to hit with a thumb than a 13px pill.
       The whole row is the button. */
    var exPair = examplePair(cfg, spec.colourway);
    var exRow = el('button', 'mm-pv-example',
      '<span class="mm-pv-example-thumb">' +
        (exPair.preview ? '<img class="is-prev" src="' + esc(exPair.preview) + '" alt="">' : '') +
        (exPair.real ? '<img class="is-real" src="' + esc(exPair.real) + '" alt="">' : '') +
        '<span class="mm-pv-example-split"></span>' +
      '</span>' +
      '<span class="mm-pv-example-txt">' +
        '<strong>' + esc(cfg.text.exampleLead || 'Real-life comparison') + '</strong>' +
        '<em>' + esc(cfg.text.exampleSub ||
          'See a printed model beside the preview it came from') + '</em>' +
      '</span>' +
      '<span class="mm-pv-example-go">' +
        esc(cfg.text.exampleTitle || 'View example') +
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7" ' +
        'fill="none" stroke="currentColor" stroke-width="2.2" ' +
        'stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</span>');
    exRow.type = 'button';
    if (restHost) {
      /* Demoted to one line of text down here. As a full-width card with a
         thumbnail it stood between the model and the checkout. */
      exRow.innerHTML = esc(cfg.text.exampleLead || 'Real-life comparison') +
        ': see a printed model beside the preview it came from \u203A';
      exRow.setAttribute('style',
        'display:block;width:100%;background:none;border:0;padding:10px 0 2px;' +
        'text-align:center;cursor:pointer;font:500 14px/1.4 inherit;color:' + MM_ACCENT_INK);
    }
    /* B6.0.2: not under the inline model any more -- the page has its own
       comparison section. The modal keeps its card. */
    if (!restHost) restMount.appendChild(exRow);
    exRow.addEventListener('click', function () {
      openExampleCompare(cfg, spec.colourway);
    });

    m.inner.appendChild(body);

    var foot = el('div', 'mm-modal-f', '<span class="mm-foot-note"></span>');
    /* B6.0.2: inline, the foot carries only the polished-water note. The
       page's own credit line covers the attribution. */
    if (restHost) foot.setAttribute('data-mm-lean', '1');
    restMount.appendChild(foot);

    var dead = false;
    /* Kevin: "there has to be an option somewhere for a customer to cancel the
       render if they misplaced or something." He is right -- a build can run a
       minute and the only way out was reloading the page, which loses every
       choice they made. Set while a build is running; null otherwise. */
    var cancelNow = null;
    m.onClose(function () { dead = true; });
    mount.dataset.mmKill = '';

    /* A single line that sits still for 40 seconds reads as a hang. The detail
       line underneath names what is actually happening and changes as real
       milestones land, so a slow Overpass response looks like work rather than
       a stall. */
    var stageNote = 'Larger models take a little longer. Keep this open.';
    var stageArt = 'search';
    /* Kept out here because stage() rewrites the whole panel: without it the
       live line blanked on every stage change and read as a stall. */
    var liveText = '';
    /* Up here, not beside pumpLine: stage() writes both, and stage() runs long
       before a var declared further down would have been assigned. That exact
       mistake has cost this file four blank screens. */
    var tickI = 0, tickDue = 0, TICK_MS = 3400;
    /* Figures shown under the bar while the model builds. Every one of these is
       a real number produced by the pipeline, filled in at the moment it
       actually arrives -- a slot reads as a dash until then. Kevin asked for
       "a bunch of random stats" to hold attention during the wait, which is a
       good instinct and the wrong method: a fabricated count is a claim the
       customer can check against the model they receive. There are plenty of
       real ones and nobody was seeing them until the very end. */
    /* Eight facts is a four-row block on a phone, and a block that tall does
       not fit inside a 280px circle -- the last row was being cut off by the
       curve. The panel sits in a disc, so the space it has is far less than the
       disc's width and height suggest. Four on a phone, all eight on desktop. */
    var FACT_ALL = ['area', 'scale', 'buildings', 'streets', 'green', 'trees', 'terrain', 'coverage'];
    /* Measured, not assumed. A 414px phone has a 302px disc and fits two rows
       of facts under the rotating line; a 360px phone has a 256px disc and does
       not, and on that one the bottom row was being cut by the curve. Asking the
       panel how wide it actually is costs one read and ends the guessing. */
    function factOrder() {
      if (!IS_TOUCH) return FACT_ALL;
      var w = (status && status.offsetWidth) || 280;
      return w < 272 ? ['area', 'buildings'] : ['area', 'buildings', 'streets', 'trees'];
    }
    var FACT_LABEL = {
      area: 'Area', scale: 'Scale', buildings: 'Buildings', streets: 'Streets',
      green: 'Parks', trees: 'Trees', terrain: 'Relief', coverage: 'Coverage'
    };
    /* Targets are the truth; `facts` is what is currently on screen. Four of
       these arrive in the same Overpass response, so without this they all
       appeared at once at the very end and the strip sat empty through the
       entire wait. They are now revealed one at a time, and a plain count
       animates up to its real figure.

       The animation is of a REAL number -- it starts at zero and lands on the
       true value, and a rising count is visibly a count rising. Kevin floated
       shuffling random digits; this gets the same "something is happening"
       without a frame in which the panel states a figure that is simply not
       true. */
    var facts = {}, factTarget = {}, factQueue = [], factTimer = 0, factRaf = 0;
    var FACT_REVEAL_MS = 220, FACT_COUNT_MS = 650;

    function setFacts(o) {
      for (var k in o) {
        if (!Object.prototype.hasOwnProperty.call(o, k)) continue;
        factTarget[k] = o[k];
        if (factOrder().indexOf(k) < 0) continue;   /* not shown at this size */
        if (factQueue.indexOf(k) < 0 && facts[k] == null) factQueue.push(k);
        else if (facts[k] != null) facts[k] = o[k];
      }
      pumpFacts();
      paintFacts();
    }

    function pumpFacts() {
      if (factTimer || !factQueue.length) return;
      factTimer = setTimeout(function () {
        factTimer = 0;
        var k = factQueue.shift();
        if (k != null) revealFact(k);
        pumpFacts();
      }, FACT_REVEAL_MS);
    }

    /* A value like "1,234" counts; "1 km", "1:5000" and "16/16" just appear. */
    function revealFact(k) {
      var target = factTarget[k];
      var n = (typeof target === 'number') ? target
            : (/^[0-9,]+$/.test(String(target)) ? parseInt(String(target).replace(/,/g, ''), 10) : null);
      if (n == null || !isFinite(n) || n <= 0) { facts[k] = target; paintFacts(); return; }
      var t0 = 0;
      var step = function (ts) {
        if (dead) return;
        if (!t0) t0 = ts;
        var p = Math.min(1, (ts - t0) / FACT_COUNT_MS);
        /* Eased so it slows into the real figure rather than stopping dead. */
        var e = 1 - Math.pow(1 - p, 3);
        facts[k] = Math.round(n * e).toLocaleString();
        paintFacts();
        if (p < 1) factRaf = requestAnimationFrame(step);
        else { facts[k] = target; paintFacts(); }
      };
      factRaf = requestAnimationFrame(step);
    }
    function paintFacts() {
      var host = status.querySelector('.mm-facts');
      if (!host) return;
      host.innerHTML = factOrder().map(function (k) {
        var v = facts[k];
        /* Fixed 16px either way, so a slot filling in does not shift the row. */
        var vh = IS_TOUCH ? 15 : 16;
        var val = (v == null)
          ? '<span style="display:flex;align-items:center;justify-content:center;height:' +
              vh + 'px"><i class="mm-fact-wait" style="width:74%"></i></span>'
          : '<span style="font:600 ' + (IS_TOUCH ? '12.5' : '13') + 'px/1.2 inherit;' +
            'font-variant-numeric:tabular-nums;color:#15181D;display:block;height:' + vh +
            'px;line-height:' + vh + 'px;overflow:hidden">' + esc(String(v)) + '</span>';
        return '<span style="display:flex;flex-direction:column;gap:1px;min-width:0;overflow:hidden">' +
          val +
          '<span style="font-size:10px;letter-spacing:.02em;text-transform:uppercase;' +
          'white-space:nowrap;overflow:hidden;text-overflow:ellipsis;' +
          'color:rgba(21,24,29,.42)">' + esc(FACT_LABEL[k]) + '</span></span>';
      }).join('');
    }

    /* An icon per stage. The line changes, the picture changes with it, and
       the bar keeps moving -- that is what makes a two-minute wait read as work
       being done rather than a page that has stopped. Drawn as inline SVG so
       there is nothing to load at the exact moment the network is busy. */
    var STAGE_ART = {
      search: 'M11 4a7 7 0 1 0 0 14 7 7 0 0 0 0-14zM20 20l-4.2-4.2',
      map: 'M9 4 3 6.5v13L9 17l6 2.5 6-2.5v-13L15 6.5 9 4zm0 0v13m6-10.5v13',
      sat: 'M5 19a7 7 0 0 1 0-14M8.5 19a3.5 3.5 0 0 1 0-7M12 5l7 7M15.5 4.5l4 4M8.5 11.5l4 4',
      paint: 'M12 3a9 9 0 1 0 0 18c1.1 0 2-.9 2-2 0-.5-.2-1-.5-1.4-.3-.4-.5-.8-.5-1.3 0-1 .9-1.8 1.9-1.8H17a4 4 0 0 0 4-4c0-4.2-4-7.5-9-7.5zM7.5 12.5h.01M10 8.5h.01M14.5 8h.01',
      build: 'M4 21V9l6-4 6 4v12M4 21h16M10 21v-5h4v5M8 12h.01M12 12h.01M16 13h.01',
      camera: 'M3 8.5A2.5 2.5 0 0 1 5.5 6h2L9 4h6l1.5 2h2A2.5 2.5 0 0 1 21 8.5v8A2.5 2.5 0 0 1 18.5 19h-13A2.5 2.5 0 0 1 3 16.5v-8zM12 9a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7z'
    };
    function stageIcon(key) {
      var d = STAGE_ART[key] || STAGE_ART.search;
      var px = IS_TOUCH ? 22 : 26;
      return '<svg width="' + px + '" height="' + px + '" viewBox="0 0 24 24" fill="none" ' +
        'stroke="currentColor" stroke-width="1.6" stroke-linecap="round" ' +
        'stroke-linejoin="round" aria-hidden="true"><path d="' + d + '"/></svg>';
    }

    function stage(pct, msg, note, art) {
      if (dead) return;
      if (art && art !== stageArt) { stageArt = art; tickI = 0; tickDue = 0; }
      /* The rotating line owns this slot now, so a stage's own note only sets
         the opening line of that stage. */
      if (note != null) stageNote = note;
      status.classList.remove('mm-hide');
      /* The disc warms from bare to the accent as the work advances, so the
         circle itself is part of the progress rather than a grey hole with a
         bar in it. */
      var t = Math.max(0, Math.min(1, pct / 100));
      try {
        status.style.background =
          'radial-gradient(120% 120% at 50% 18%, rgba(30,79,196,' +
          (0.05 + 0.12 * t).toFixed(3) + ') 0%, rgba(30,79,196,' +
          (0.02 + 0.05 * t).toFixed(3) + ') 60%, rgba(244,245,247,1) 100%)';
      } catch (e) {}
      status.innerHTML =
        /* B7.3.0: the 30-day count, pinned to the top of the box while it
           builds. Out of the flow on purpose: in it, the extra row pushed the
           facts into "Click to enlarge" on a phone. */
        (mmProofHtml(cfg) ? '<div class="mm-proof" style="position:absolute;z-index:1;left:50%;' +
          'top:' + (IS_TOUCH ? '12' : '16') + 'px;transform:translateX(-50%);width:max-content;' +
          'max-width:calc(100% - 24px);box-sizing:border-box;padding:5px 12px;border-radius:14px;' +
          'background:rgba(255,255,255,.88);border:1px solid rgba(30,79,196,.16);' +
          'font-size:' + (IS_TOUCH ? '12' : '13') + 'px;font-weight:500;line-height:1.35;' +
          'color:#15181D;text-wrap:balance">' + mmProofHtml(cfg) + '</div>' : '') +
        /* The rotating line costs a row, and a row inside a 282px disc has to
           come from somewhere. Everything above the facts is a shade tighter on
           touch; desktop is unchanged. */
        '<div class="mm-stage-art" style="color:#1E4FC4;opacity:.9;margin-bottom:' +
          (IS_TOUCH ? '0' : '2') + 'px;line-height:0">' + stageIcon(stageArt) + '</div>' +
        '<div class="mm-stage" style="font-size:' + (IS_TOUCH ? '14.5' : '15.5') +
          'px;font-weight:600;line-height:1.3">' + esc(msg) + '</div>' +
        '<div class="mm-prog" style="width:72%;max-width:260px;height:5px;border-radius:99px;' +
          'background:rgba(0,0,0,.09);overflow:hidden">' +
          '<i style="display:block;height:100%;border-radius:99px;background:#1E4FC4;' +
          'transition:width .45s ease;width:' + pct + '%"></i></div>' +
        /* Shown on the phone too. It is the one figure that is always moving and
           always true, and it is what tells someone the wait is a wait and not a
           dead page. */
        '<div class="mm-live" style="font:600 11.5px/1.3 inherit;margin-top:' +
          (IS_TOUCH ? '2' : '5') + 'px;' +
          'font-variant-numeric:tabular-nums;letter-spacing:.02em;' +
          'color:rgba(21,24,29,.5);min-height:' + (IS_TOUCH ? '13' : '15') + 'px">' +
          esc(liveText) + '</div>' +
        /* On the phone as well now. A line that changes is the difference
           between a wait and a page that has died, and that matters more on a
           phone than the row of pixels it costs. */
        '<div class="mm-foot-note" style="font-size:' + (IS_TOUCH ? '11.5' : '12.5') +
          'px;opacity:.68;line-height:1.35;min-height:1.35em">' + esc(stageNote) + '</div>' +
        /* Two columns on a phone. Four put BUILDINGS hard against STREETS and
           pushed COVERAGE out past the edge of the circle -- a strip inscribed
           in a disc has far less room than the disc's diameter suggests. */
        '<div class="mm-facts" style="display:grid;grid-template-columns:repeat(' +
          (IS_TOUCH ? '2' : '4') + ',minmax(0,1fr));' +
          'gap:' + (IS_TOUCH ? '4px 14px' : '9px 8px') + ';' +
          /* Narrower on touch than it looks like it needs to be: these are the
             lowest corners in the panel, and the lower a corner sits the less
             width the circle gives it. */
          'width:' + (IS_TOUCH ? '84%' : '86%') + ';' +
          'max-width:' + (IS_TOUCH ? '226px' : '340px') + ';' +
          'margin-top:' + (IS_TOUCH ? '6' : '10') + 'px;text-align:center"></div>' +
        /* This was a 12.5px grey underlined link, styled "quiet on purpose".
           That was wrong, and Kevin proved it: he knew the control existed, went
           looking for it, and still reported the build as having no way out --
           with the thing visible in his own screenshot. A way out nobody can
           find is not a way out. It is a bordered pill now: still secondary to
           the build, but unmistakably a button. */
        '';
        /* Cancel lives in step 5 under Generate now, not in here. Kevin's call
           and the right one: the circle is a progress readout, the card is
           where the controls are -- and a button inscribed in a disc was
           fighting for room it did not have on a 360px phone. */
      paintFacts();
    }

    function note(text) {
      if (dead) return;
      stageNote = text;
      var el = status.querySelector('.mm-foot-note');
      if (el) el.textContent = text;
    }

    /* Rotating status line. Kevin asked for this outright after watching the
       panel sit on one sentence for ninety seconds: a line that changes is the
       difference between a wait and a page that has died. Every line names a
       step this pipeline really performs -- no figures, so nothing here can
       state something untrue about his model. */
    function pumpLine(now) {
      if (dead) return;
      if (now < tickDue) return;
      var bank = TICK_LINES[stageArt] || TICK_LINES.map;
      tickDue = now + TICK_MS;
      note(bank[tickI % bank.length]);
      tickI++;
    }

    /* The always-moving line under the bar. Desktop and phone both. */
    function live(text) {
      if (dead) return;
      liveText = text || '';
      var el = status.querySelector('.mm-live');
      if (el) el.textContent = liveText;
    }
    function fmtBytes(n) {
      return n >= 1048576 ? (n / 1048576).toFixed(1) + ' MB'
           : Math.max(1, Math.round(n / 1024)) + ' KB';
    }

    function build() {
      armChip();
      /* Lead with the geodata -- "loading the 3D
         engine" tells the visitor nothing about their own model. Real numbers,
         not invented ones: the area is what they actually chose. */
      var areaKm2 = ((spec.groundMeters / 1000) * (spec.groundMeters / 1000));
      var placeName = (spec.location && spec.location.name)
        ? String(spec.location.name).split(',')[0] : null;
      var areaText = 'A circle ' + fmtAcross(spec.groundMeters);

      /* The place name goes in the headline, not just the note: "Setting up
         Dubrovnik" is the customer's own order being worked on, "preparing your
         model" is a spinner with words. Every stage below is a real step in the
         pipeline with a real number attached -- none of them are padding. */
      var placeIn = placeName ? ' \u00B7 ' + placeName : '';
      setFacts({
        /* The label already says Area; "across" wrapped the cell onto two
           lines and broke the grid's baseline. */
        area: String(fmtAcross(spec.groundMeters)).replace(/\s*across\s*$/, ''),
        scale: '1:' + Math.round(spec.groundMeters / (spec.size.cm / 100) / 100) * 100
      });
      stage(8, 'Setting up your model' + placeIn,
            'Usually under a minute. Keep this page open while it works.',
            'search');
      /* Overpass is a shared public service with no queue position to report,
         so the honest thing to say is how long we have been waiting. */
      var t0 = Date.now();
      /* Where the time actually goes. A build is a chain of very different
         costs -- a public map service, some terrain tiles, the geometry, one
         photograph -- and until now the only number anyone had was the total.
         Most of a day went into guessing which part was slow. */
      var TMARK = { start: t0 }, tPrev = t0;
      function mark(name) {
        var now = Date.now();
        TMARK[name] = now - tPrev;
        tPrev = now;
      }
      /* How much of the wait was the page sitting in the background. Kevin
         asked whether leaving Safari slows it down -- it does, a lot, and
         without this the total is unreadable because there is no way to tell a
         slow build from a paused one. */
      var bgMs = 0, bgAt = (document.hidden ? Date.now() : 0);
      function buildVis() {
        if (document.hidden) { bgAt = Date.now(); }
        else if (bgAt) { bgMs += Date.now() - bgAt; bgAt = 0; }
      }
      /* And when they come back, say what happened. A build that was paused for
         two minutes is indistinguishable from a build that was simply slow, and
         letting someone believe the second one is unfair to them and to us. */
      function buildVis2() {
        buildVis();
        if (!document.hidden && bgMs > 3000) {
          note('Paused while you were away \u2014 picking up where it left off.');
        }
      }
      try { document.addEventListener('visibilitychange', buildVis2); } catch (eB) {}
      /* Real bytes off the wire, reported by overpassFetch as the response
         streams in. Mirrors are raced, so take the furthest-along of them. */
      var bytesGot = 0;
      cfg.onOpBytes = function (n) { if (n > bytesGot) bytesGot = n; };
      /* What Cancel actually does. `dead` is checked at the top of every stage,
         every tick and every .then in the pipeline, so setting it stops the
         build reaching the screen. The requests already in flight are left to
         finish quietly -- they are cached, so a retry of the same place is
         faster, and aborting them would need plumbing through four layers for
         no benefit the customer can see.

         onReady(false) is the same call a failed build makes: the caller drops
         st.building, clears st.rendered and re-syncs, which puts the Generate
         card back exactly as it was with every choice still made. */
      /* Published so the area banner's "Change location" can stop a running
         build without knowing anything about this closure. */
      cancelNow = function () {
        if (dead) return;
        dead = true;
        try { clearInterval(ticking); } catch (eC1) {}
        cfg.onOpBytes = null;
        try { document.removeEventListener('visibilitychange', buildVis); } catch (eC2) {}
        try { document.removeEventListener('visibilitychange', buildVis2); } catch (eC3) {}
        if (cfg.__mmLive) { try { cfg.__mmLive.stop(); } catch (eC4) {} cfg.__mmLive = null; }
        diag('cancelled by the customer after ' +
             Math.round((Date.now() - TMARK.start) / 1000) + 's');
        status.classList.add('mm-hide');
        gal.classList.remove('is-building');
        mount.classList.remove('mm-pv-loading');
        try {
          var pdpC = mount.closest && mount.closest('.mm');
          if (pdpC) pdpC.classList.remove('is-rendering');
        } catch (eC5) {}
        cancelNow = null;
        cfg.__mmCancelBuild = null;
        if (onReady) { try { onReady(false, 'cancelled'); } catch (eC6) {} }
      };
      cfg.__mmCancelBuild = cancelNow;

      var ticking = setInterval(function () {
        var secs = Math.round((Date.now() - t0) / 1000);
        /* Two true figures, both always rising: what has come down the wire and
           how long it has taken. Kevin asked for numbers moving during the wait;
           these are the ones that exist. The counts of buildings and streets do
           not -- they arrive in one lump at the end -- so those slots scan
           rather than state a figure nobody has yet. */
        live((bytesGot > 0 ? fmtBytes(bytesGot) + ' of map data \u00B7 ' : '') + secs + 's');
        pumpLine(Date.now());
        var bar = status.querySelector('.mm-prog i');
        if (!bar) return;
        var w = parseFloat(bar.style.width) || 0;
        if (w < 66) bar.style.width = (w + 2) + '%';
      }, 400);

      // Load the library first and on its own, so a CDN problem can never be
      // reported as a map-data problem again.
      loadThree().then(function (THREE) {
        if (dead) return null;
        /* Reworded: the old line was a near copy of Lichtbild's. */
        stage(26, 'Pulling fresh map data' + placeIn,
              'Every building and street, surveyed \u2014 not a picture of a map.',
              'map');
        /* Precise data first. Tiles are the fallback now, not the default —
           they keep the preview working when Overpass is busy, at the cost of
           the accuracy that made buildings sit properly against their streets. */
        return collectFromOverpass(cfg, spec).catch(function (e1) {
          if (window.console) console.warn('[mm] overpass failed:', e1 && e1.message);
          if (dead) return null;
          diag('backup map source: starting (precise source gave nothing usable)');
          stage(52, 'Switching to the backup map source',
                'The precise source is busy, so this model will be less detailed.',
                'map');
          /* One automatic retry before giving up. Both sources failing at once
             is usually a blip -- a dropped fetch, a tile host hiccup -- and
             dead-ending someone who has already waited a minute and a half for
             it is the worst possible moment to do it. */
          return collectFromTiles(cfg, spec.bbox).catch(function (e2) {
            if (dead) throw e2;
            if (window.console) console.warn('[mm] tiles failed, retrying once:', e2 && e2.message);
            stage(56, 'Map data is being stubborn \u2014 one more try',
                  'The first attempt did not come back. Retrying now.', 'map');
            return new Promise(function (res) { setTimeout(res, 1400); })
              .then(function () { return collectFromTiles(cfg, spec.bbox); })
              .catch(function (e3) {
                e3.phase = 'data';
                /* Name BOTH failures. "Details: tiles" told nobody which source
                   went, or why. */
                e3.mmWhy = 'precise source: ' + ((e1 && e1.message) || 'failed') +
                           ' \u00B7 backup source: ' + ((e3 && e3.message) || 'failed');
                /* B5.59: both sources agree there is nothing here (open sea,
                   desert, a country's centre point). Not a connection problem. */
                if (e1 && e1.message === 'empty' && e3 && e3.message === 'sparse') e3.mmEmpty = true;
                throw e3;
              });
          });
        }).then(function (data) {
          if (dead) return null;
          mark('mapData');
          /* Vector tiles carry buildings and roads and nothing else -- no walls,
             no paths, no piers. Every time this path ran, a walled town lost its
             walls. One small query puts them back. */
          if (data && data.source === 'tiles') {
            return collectWalls(cfg, spec.bbox).then(function (ws) {
              if (ws.length) {
                data.walls = (data.walls || []).concat(ws);
                if (window.console) {
                  console.info('[mm] walls added to the simplified model: ' + ws.length + ' run(s)');
                }
              }
              return data;
            }).catch(function () { return data; });
          }
          return data;
        }).then(function (data) {
          if (dead) return null;
          setFacts({
            buildings: (data && data.buildings) ? data.buildings.length.toLocaleString() : 0,
            streets: (data && data.roads) ? data.roads.length.toLocaleString() : 0,
            green: (data && data.green) ? data.green.length.toLocaleString() : 0,
            trees: (data && data.trees) ? data.trees.length.toLocaleString() : 0,
            coverage: (data && data.coverage) ? data.coverage : (data && data.source === 'tiles' ? 'basic' : null)
          });
          stage(64, 'Reading the ground it stands on' + placeIn,
                (data && data.buildings ? data.buildings.length.toLocaleString() : '0') +
                ' buildings and ' + ((data && data.roads) ? data.roads.length : 0) +
                ' streets found.',
                'sat');
          return collectTerrain(cfg, spec.bbox)
            .catch(function (e) {
              /* This swallowed a ReferenceError for the entire life of the
                 feature. If terrain fails, say so. */
              if (window.console) console.warn('[mm] terrain failed:', e && e.message);
              return null;
            })
            .then(function (terrain) {
              if (terrain && isFinite(terrain.max) && isFinite(terrain.min)) {
                setFacts({ terrain: Math.round(terrain.max - terrain.min) + ' m' });
              } else {
                setFacts({ terrain: 'flat' });
              }
              /* Land cover drives water, ground colour and trees now, so give
                 it a few seconds -- it is normally back long before this. */
              mark('terrain');
              return Promise.race([
                landCover(spec.bbox),
                new Promise(function (res) { setTimeout(function () { res(null); }, 6000); })
              ]).then(function (lc) {
                if (data) data.landcover = lc || null;
                rejudgeSea(data, spec.bbox, lc);
                return [THREE, data, terrain];
              });
            });
        });
      }).then(function (pair) {
        /* The interval keeps running: the build and camera stages are another
           twenty seconds and they need the line to keep turning over too. It is
           cleared once the model is on screen, or by the catch below. */
        cfg.onOpBytes = null;
        if (dead || !pair) { clearInterval(ticking); return; }
        stage(78, 'Placing every building' + placeIn,
              'Extruding buildings, laying roads, planting trees.',
              'build');
        setTimeout(function () { stage(92, 'Lighting and photographing it',
          'Four views, so you can turn it before you buy.', 'camera'); }, 30);
        setTimeout(function () {
          if (dead) return;
          try {
            mark('prepare');
            renderModel(pair[0], pair[1], spec, cfg, studioImgs, wallImg, foot, scene, pair[2]);
            mark('model');
            clearInterval(ticking);
            var tLine = 'timing: map data ' + ((TMARK.mapData || 0) / 1000).toFixed(1) +
                 's \u00b7 terrain ' + ((TMARK.terrain || 0) / 1000).toFixed(1) +
                 's \u00b7 land cover ' + ((TMARK.prepare || 0) / 1000).toFixed(1) +
                 's \u00b7 model + photo ' + ((TMARK.model || 0) / 1000).toFixed(1) +
                 's \u00b7 TOTAL ' + ((Date.now() - TMARK.start) / 1000).toFixed(1) + 's' +
                 (bgMs > 1000 ? ' (of which ' + (bgMs / 1000).toFixed(0) +
                  's with the page in the background)' : '');
            diag(tLine);
            try { document.removeEventListener('visibilitychange', buildVis2); } catch (eB2) {}
            /* Armed builds keep the strip up with the numbers on it. Everyone
               else gets the strip out of the way, as before. */
            if (diagMode()) {
              status.innerHTML = '';
              status.classList.remove('mm-hide');
              var dRow = el('div', '');
              dRow.setAttribute('style',
                'display:flex;gap:8px;flex-wrap:wrap;justify-content:center;align-items:center');
              dRow.appendChild(el('div', 'mm-foot-note', tLine));
              dRow.appendChild(diagBtn('Copy build report'));
              status.appendChild(dRow);
            } else {
              status.classList.add('mm-hide');
            }
            /* The step card outside this function is still saying "building"
               until it is told otherwise. */
            gal.classList.remove('is-building');
            cancelNow = null; cfg.__mmCancelBuild = null;
            if (onReady) { try { onReady(true); } catch (e4) {} }
            revealScenes();
            /* Whatever happens next, the panes are real now. */
            mount.classList.remove('mm-pv-loading');
          } catch (e) {
            clearInterval(ticking);
            if (window.console) console.error('[mm] geometry build failed:', e);
            /* Come out of the rendering state, or the preview button stays
               hidden with nothing in its place and the page looks dead. */
            try {
              var pdpEl = mount.closest && mount.closest('.mm');
              if (pdpEl) pdpEl.classList.remove('is-rendering');
              mount.classList.remove('mm-pv-loading');
            } catch (e2) {}
            fail('render', e);
          }
        }, 50);
      }).catch(function (err) {
        clearInterval(ticking);
        cfg.onOpBytes = null;
        live('');
        if (dead) return;
        if (window.console) console.error('[mm] preview failed:', err);
        try {
          var pdpEl2 = mount.closest && mount.closest('.mm');
          if (pdpEl2) pdpEl2.classList.remove('is-rendering');
          mount.classList.remove('mm-pv-loading');
        } catch (e3) {}
        fail((err && err.phase) || 'data', err);
      });
    }

    /* Diagnostics used to appear only when a build FAILED, which is exactly
       backwards for the problem we have now: the builds that hurt are the ones
       that finish, slowly. Same button, both endings. Armed by putting
       ?mmdiag=1 on the URL once -- it sticks for the tab, so the customer never
       sees it and Kevin does not have to retype it between attempts. */
    function diagMode() {
      var on = /[?&]mmdiag\b/.test(String(location.search || ''));
      try {
        if (on) sessionStorage.setItem('mmDiag', '1');
        return sessionStorage.getItem('mmDiag') === '1';
      } catch (e) { return on; }
    }
    /* Kevin: "there was no copy diagnostics button on the failed screen."
       Both failure paths do call fail(), which builds one -- so the screen he
       hit either reset under him or put the button below the fold. Either way
       the evidence has to be reachable without depending on which screen is up,
       so an armed session gets a small fixed chip that is always there. Only
       ever visible with ?mmdiag=1, so no customer sees it. */
    function armChip() {
      try {
        var oldChip = document.getElementById('mm-diag-chip');
        if (!diagMode() || (oldChip && !oldChip.hasAttribute('data-early'))) return;
        if (oldChip) oldChip.remove();            // B5.46: swap the load-time chip for the full one
        var c = diagBtn('Copy build report');
        c.id = 'mm-diag-chip';
        c.setAttribute('style',
          'position:fixed;left:12px;bottom:calc(74px + env(safe-area-inset-bottom,0px));' +
          'z-index:99998;width:auto;height:auto;padding:9px 13px;border:0;' +
          'border-radius:99px;font:600 12px/1 ' + MM_FACE + ';cursor:pointer;' +
          'background:#17181A;color:#fff;box-shadow:0 2px 12px rgba(0,0,0,.34)');
        document.body.appendChild(c);
      } catch (e) {}
    }
    function diagBtn(label) {
      var cp = el('button', 'mm-btn', label);
      cp.type = 'button';
      cp.style.width = 'auto';
      cp.addEventListener('click', function (ev) {
        ev.stopPropagation();
        var nav = window.navigator || {};
        var text = ['Mounted Maps diagnostics',
          'build ' + MM_BUILD,
          'size ' + (spec.size ? spec.size.cm : '?') + ' cm \u00b7 ' +
            Math.round(spec.groundMeters || 0) + ' m across',
          'screen ' + (window.innerWidth || 0) + 'x' + (window.innerHeight || 0) +
            ' \u00b7 dpr ' + (window.devicePixelRatio || 1),
          'device ' + (nav.userAgent || 'unknown'),
          'memory ' + (nav.deviceMemory ? nav.deviceMemory + ' GB' : 'not reported'),
          ''].concat(MM_DIAG)
             /* If the previous page died mid-build, its last words go in too --
                that tape is the only record of a crash that reloads the tab. */
             .concat(MM_PREV ? ['',
               '=== THE PREVIOUS PAGE DIED MID-BUILD ===',
               'it was building: ' + MM_PREV.died,
               '--- its tape ---',
               MM_PREV.tape] : [])
             .join('\n');
        function done(ok) {
          cp.textContent = ok ? 'Copied \u2014 paste it to Kevin' : 'Select and copy this';
          if (ok) return;
          var ta = el('textarea', '');
          ta.value = text;
          ta.setAttribute('style',
            'width:100%;height:110px;font:11px/1.4 monospace;margin-top:8px');
          (cp.parentNode || status).appendChild(ta);
          try { ta.select(); } catch (e2) {}
        }
        try {
          if (nav.clipboard && nav.clipboard.writeText) {
            nav.clipboard.writeText(text).then(function () { done(true); },
                                               function () { done(false); });
          } else { done(false); }
        } catch (e) { done(false); }
      });
      return cp;
    }

    function fail(phase, err) {
      cancelNow = null; cfg.__mmCancelBuild = null;
      if (onReady) { try { onReady(false); } catch (e5) {} }
      var rendMsg = (err && err.message && /graphics memory/.test(err.message))
        ? err.message
        : 'The model geometry could not be built. Try a smaller size.';
      var empty = !!(err && err.mmEmpty);                 // B5.59
      var msg = empty
        ? 'There are no buildings or streets here to model. Choose a town, street or landmark instead.'
        : phase === 'library'
        ? 'The 3D engine could not be loaded. Check the Three.js script URL in the section settings.'
        : phase === 'render'
        ? rendMsg
        : overpassMessage(err && err.status);

      status.classList.remove('mm-hide');
      status.innerHTML = '';
      status.appendChild(el('div', '', esc(msg)));
      var detail = err && (err.mmWhy || err.message || String(err));
      if (detail && !empty) {
        status.appendChild(el('div', 'mm-foot-note', esc(detail)));
      }
      /* Everything I would have asked for, on the clipboard. Kevin is testing on
         a phone, where reaching a console needs a Mac and a cable -- I spent a
         day asking for output he could not reasonably get. */
      diag('FAILED at ' + phase + ': ' + ((err && (err.mmWhy || err.message)) || 'unknown'));
      var row = el('div', '');
      row.setAttribute('style',
        'display:flex;gap:8px;flex-wrap:wrap;justify-content:center;align-items:center');
      var again = el('button', 'mm-btn', empty ? 'Choose another spot' : 'Try again');
      again.type = 'button';
      again.style.width = 'auto';
      again.addEventListener('click', empty ? function () {
        try { window.dispatchEvent(new CustomEvent('mm:pickspot')); } catch (eP) {}
      } : build);
      row.appendChild(again);

      var cp = diagBtn('Copy diagnostics');
      row.appendChild(cp);
      status.appendChild(row);
    }

    build();
  }

  /* ------------------------------ renderer ------------------------------ */

  function renderModel(THREE, data, spec, cfg, studioImgs, wallImg, foot, scene, terrain) {
    /* B5.56: what this model was built from, for the Renders tab. */
    try {
      window.MM_LAST_GEO = ((data && data.buildings) ? data.buildings.length : 0) + ' bldg ' +
        ((data && data.buildingSource) || 'osm') +
        ((data && data.overtureNote && data.overtureNote !== 'overture' &&
          data.overtureNote !== 'osm dense') ? ' · ' + data.overtureNote : '');
    } catch (eG) {}
    /* Build 3 hands over four angle images instead of one. A single element
       still works, so an older caller is not broken by this. */
    var shotImgs = (studioImgs && studioImgs.length) ? studioImgs : [studioImgs];
    var studioImg = shotImgs[0];
    /* One pane means the live viewer: the caller wants the scene kept and
       turned, not four photographs of it. Four panes is the old path, which the
       render rig still uses as its regression test. `cfg.liveView === false`
       forces the old path back. */
    var LIVE = cfg.liveView !== false && shotImgs.length === 1 && !!shotImgs[0];
    /* Only ever one live context. A colour or frame change rebuilds everything,
       and two of these alive at once is how a browser starts killing the oldest
       and handing back a blank canvas. */
    if (cfg.__mmLive) { try { cfg.__mmLive.stop(); } catch (eL) {} cfg.__mmLive = null; }
    var probe = document.createElement('canvas');
    if (!(probe.getContext('webgl2') || probe.getContext('webgl'))) {
      /* Two very different failures wore the same message. A browser with no
         WebGL at all is a browser problem; a browser that HAS drawn for us
         already and now refuses is out of graphics contexts or memory, which is
         a phone mid-session and is fixed by reloading, not by a smaller size. */
      throw new Error(cfg.__mmDrewOnce
        ? 'The browser ran out of graphics memory. Reload the page and try again.'
        : 'WebGL is unavailable in this browser');
    }
    cfg.__mmDrewOnce = true;
    /* B5.52: a new build makes the last room shots stale. The token drops any
       composite still finishing for the previous model. */
    var roomTok = cfg.__mmRoomTok = (cfg.__mmRoomTok || 0) + 1;
    if (typeof cfg.onRooms === 'function') { try { cfg.onRooms(null); } catch (eR0) {} }

    /* Render offscreen at high resolution and hand out two flat images. No live
       canvas, so all the budget goes into one good frame instead of sixty
       mediocre ones per second.

       Sized for the DISPLAY, not for a round number. The preview panes are
       roughly 500-620 CSS px, which on a retina screen is 1000-1240 real
       pixels, and the model itself only occupies part of the frame -- so an
       image that sounded generous at 2048 was still being asked to stretch. */
    var BASE = Math.min(cfg.renderSize || 1600, 3072);
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    /* THE PHONE CAP, and this is the one that matters.

       A phone was drawing this at 3072 x 3072. BASE 1600 x dpr 2 = 3200, capped
       to 3072 -- the maximum, on the smallest device. That is 9.4 megapixels:
       ~38 MB for the colour buffer, as much again for depth, another copy
       because preserveDrawingBuffer is on for toDataURL, plus the ambient
       occlusion pass's own full-size targets and the shadow maps. Comfortably
       150 MB of GPU memory for one render, on a device that is also holding
       MapLibre and, since 5.15, a live viewer context.

       The supersample ceiling was already lowered on narrow screens -- the
       comment below even says a 4096 buffer is a lost context rather than a
       slow one -- but the OUTPUT size never was. So a phone got the worst of
       both: the largest buffer allowed AND no supersampling, because there was
       no headroom left above it.

       1100 is more than double what a 390px phone ever displays, in the circle
       or in the lightbox, and it leaves room for 2x supersampling underneath
       the same ceiling -- so the model is both lighter and better than it was.
       This fits the report exactly: two different cities, mobile only, dying at
       the end of a long wait rather than during the data fetch. */
    var SIZE = Math.min(Math.round(BASE * dpr), 3072);
    if (IS_TOUCH) SIZE = Math.min(SIZE, 1100);
    var host = document.createElement('div');
    host.style.cssText = 'position:fixed;left:-99999px;top:0;width:' + SIZE + 'px;height:' + SIZE + 'px';
    document.body.appendChild(host);

    var world = new THREE.Scene();
    /* B5.46 PHONE MEMORY. Kevin's iPhone, 30 Sep, Dublin Ø20: iOS killed the tab
       straight after "render buffer 2200px → 1100px", and the very next build
       finished in 2.8s. A device sitting on the edge of its memory limit, not a
       broken build. Two of the biggest allocations here buy nothing a phone can
       see: MSAA on a buffer already drawn at 2x and shrunk (the supersample
       smooths edges on its own), and a 4096 key-light shadow map for an image
       shown at 1100px. Phones drop both. Desktop is unchanged. */
    var PHONE_LEAN = IS_TOUCH;
    var KEY_SHADOW = PHONE_LEAN ? 2048 : 4096;
    var renderer = new THREE.WebGLRenderer({
      antialias: !PHONE_LEAN, alpha: true, preserveDrawingBuffer: true
    });
    renderer.setPixelRatio(1);

    /* Supersampling. The single biggest thing holding the render back was that
       it was drawn at exactly the size it is shown at, so every edge had only
       MSAA to smooth it -- and MSAA does nothing for the things that actually
       look rough here: the shading step along a roof, a 0.9 mm road, the speckle
       of trees. Drawing at 2x and shrinking averages four samples into every
       finished pixel, on colour as well as coverage.

       SS is a multiplier on the OUTPUT size, which never changes -- so the
       composite, the room scaling and the cart thumbnail all carry on
       untouched. Held to what the GPU admits it can allocate, and lower on
       phones, where a 4096 buffer is a lost context rather than a slow one. */
    var ssWant = +cfg.superSample || 0;                       // 0 = decide here
    var hwMax = (renderer.capabilities && renderer.capabilities.maxTextureSize) || 4096;
    var ceiling = Math.min(hwMax, isNarrow() ? 3072 : 4096);
    /* Continuous, not half-steps. Stepping 2 → 1.5 → 1 threw away most of the
       allowance whenever SIZE went up: at 3072 output, 1.5x needs 4608 and does
       not fit, so it dropped to no supersampling at all while 4096 sat unused.
       Taking whatever multiple actually fits keeps every pixel the GPU allows. */
    var SS = ssWant > 0 ? ssWant : Math.min(2, ceiling / SIZE);
    if (SS < 1) SS = 1;
    var DRAW = Math.min(Math.round(SIZE * SS), ceiling);
    renderer.setSize(DRAW, DRAW, false);
    if (window.console) {
      console.info('[mm] render ' + DRAW + 'px \u2192 ' + SIZE + 'px (' +
                   SS.toFixed(2) + '\u00D7 supersample, ' + dpr + '\u00D7 display)');
      diag('render buffer ' + DRAW + 'px \u2192 ' + SIZE + 'px (' + SS.toFixed(2) +
           '\u00D7 supersample, dpr ' + dpr + ', touch ' + IS_TOUCH +
           ', aa ' + (PHONE_LEAN ? 'off' : 'on') + ', key shadow ' + KEY_SHADOW + ')');
    }
    renderer.shadowMap.enabled = true;
    /* VSM, not PCF. PCF gives a hard-edged shadow that only softens by a texel
       or two; VSM blurs in shadow space, which is what gives the reference its
       soft, wide penumbra -- and it is what lets the sky light further down
       stand in for ambient occlusion. */
    renderer.shadowMap.type = THREE.VSMShadowMap || THREE.PCFSoftShadowMap;
    if ('outputColorSpace' in renderer && THREE.SRGBColorSpace) {
      renderer.outputColorSpace = THREE.SRGBColorSpace;
    }
    /* Without tone mapping the renderer just clamps at 1.0. Ambient 0.34 + key
       1.45 put a bone-white roof at about 1.4, so every upward-facing surface
       clipped to pure white and all the shading that makes a model read as 3D
       was thrown away -- a field of featureless blocks. ACES rolls the
       highlights off instead of cutting them, which is most of the difference
       between a render that looks lit and one that looks flat.
       EXPOSURE is the dial: raise it if the model looks muddy, drop it if the
       roofs go white again. */
    if (THREE.ACESFilmicToneMapping) {
      renderer.toneMapping = THREE.ACESFilmicToneMapping;
      /* Was 1.25. With a 2.6 key light on top, mid-tones were being pushed to
         the ceiling: a saturated green went in and a pastel one came out, and
         white buildings clipped to flat shapes with no shading on them at all.
         Pulling the exposure back is what lets the palette below actually
         arrive on screen, and gives the buildings their faces back. */
      renderer.toneMappingExposure = MM_T.exposure;
    }
    host.appendChild(renderer.domElement);

    /* Studio environment. What was here was a 512x256 canvas with a gradient
       and three white rectangles painted on it -- and it reflected as a flat
       smear, because it was flat. A lit room through PMREMGenerator is what
       gives a white surface a different value on each face, which is most of
       the difference between plastic that looks lit and plastic that looks
       painted. PMREMGenerator is core Three, so this needs no addon imports. */
    if (window.MMRender && window.MMRender.installEnvironment) {
      window.MMRender.installEnvironment(THREE, renderer, world);
    } else {
      (function () {
        var c = document.createElement('canvas');
        c.width = 512; c.height = 256;
        var g = c.getContext('2d');
        var grad = g.createLinearGradient(0, 0, 0, 256);
        grad.addColorStop(0.00, '#ffffff');
        grad.addColorStop(0.42, '#f2efe9');
        grad.addColorStop(0.50, '#b6b2a9');
        grad.addColorStop(1.00, '#6d6b67');
        g.fillStyle = grad;
        g.fillRect(0, 0, 512, 256);
        g.fillStyle = '#ffffff';
        [[36, 18, 160, 74], [250, 10, 118, 56], [406, 26, 84, 62]].forEach(function (r) {
          g.fillRect(r[0], r[1], r[2], r[3]);
        });
        var tex = new THREE.CanvasTexture(c);
        tex.mapping = THREE.EquirectangularReflectionMapping;
        if (THREE.SRGBColorSpace) tex.colorSpace = THREE.SRGBColorSpace;
        world.environment = tex;
        if (window.console) {
          console.warn('[mm] mm-render-core.js did not load -- falling back to ' +
                       'the old painted environment. Check the asset tag.');
        }
      })();
    }

    var CW = COLOURWAYS.filter(function (c) { return c.id === spec.colourway; })[0] || COLOURWAYS[0];
    var C = CW;
    var FR = FRAMES.filter(function (f) { return f.id === spec.frame; })[0] || FRAMES[0];

    var PLATE = 10, half = PLATE / 2;
    var mPerUnit = spec.groundMeters / PLATE;
    // real millimetres of the finished object, expressed in scene units
    var mm = function (x) { return (x / 10) * (PLATE / spec.size.cm); };
    /* Raised, and from the tuning file. At 1:5000 a two-storey house is 1.2 mm
       tall on a 20 cm plate -- below what a printer resolves and well below
       what the eye picks out against a green field. Every relief model
       exaggerates; the question is only by how much, and 2.5 was leaving a
       village reading as scattered chips rather than as houses. The taper
       further down still stops a tall block turning into a tower. */
    /* From the tuning file only: the section setting was a leftover that
       overrode it with a much taller value. */
    var EXAG = MM_T.heightExaggeration;
    /* Build 3.6: declared HERE, not beside liftH() further down. The detail
       layer (city walls) calls liftH() long before that line runs, and a var
       reads as undefined until its declaration is reached -- so the cap was
       undefined, liftH() returned NaN, and every walled town in the world
       (Dubrovnik, York, Lucca, Carcassonne, Xi'an) died with a NaN matrix
       inside three.js rather than an error anyone could read. */
    var LIFT_TO = 20;   // B5.51: was 12 -- 4-6 storey blocks now get the full lift

    var b = spec.bbox;
    var cx = (b.minLon + b.maxLon) / 2, cy = (b.minLat + b.maxLat) / 2;
    function toLocal(lon, lat) {
      return [((lon - cx) * 111320 * Math.cos(cy * D2R)) / mPerUnit,
              -((lat - cy) * 110540) / mPerUnit];
    }

    var clip = [
      new THREE.Plane(new THREE.Vector3(-1, 0, 0), half),
      new THREE.Plane(new THREE.Vector3(1, 0, 0), half),
      new THREE.Plane(new THREE.Vector3(0, 0, -1), half),
      new THREE.Plane(new THREE.Vector3(0, 0, 1), half)
    ];
    renderer.localClippingEnabled = true;
    function mat(c, clipped, twoSided) {
      return new THREE.MeshStandardMaterial({
        color: c, roughness: 0.86, metalness: 0.0, envMapIntensity: MM_T.envIntensity,
        side: twoSided ? THREE.DoubleSide : THREE.FrontSide,
        clippingPlanes: clipped ? clip : null,
        /* Three.js applies clipping planes to the visible surface but NOT to
           the shadow pass unless this is set. That is why buildings stopped
           neatly at the plate edge while their shadows carried on across the
           frame and out onto the backdrop. */
        clipShadows: !!clipped
      });
    }
    /* A flat black insert. The previous version painted white streaks onto a
       canvas to fake reflections, which at model scale read as scratches across
       the water rather than as a mirror -- and they were baked in, so they did
       not move with the camera the way a real reflection would.
       Black with a very low roughness lets the scene's own environment do the
       reflecting: it stays black where nothing is above it, and catches a
       genuine highlight where something is. That is what polished acrylic
       actually looks like. */
    /* Darken a colour toward black by a factor. Used so the contour lines are
       a shade of the ground they cross rather than an unrelated colour drawn
       on top of it -- which is the difference between an engraved line and a
       pen mark. */
    function shade(hex, f) {
      /* Clamped. A factor above 1 can push a channel past 255, and the bit
         shift then carries the overflow into the next channel -- a colour
         brightened too far comes back an unrelated one. */
      var cl = function (v) { return Math.max(0, Math.min(255, Math.round(v))); };
      var r = cl(((hex >> 16) & 255) * f);
      var g = cl(((hex >> 8) & 255) * f);
      var b = cl((hex & 255) * f);
      return (r << 16) | (g << 8) | b;
    }

    function mirrorMat(twoSided) {
      return new THREE.MeshStandardMaterial({
        color: 0x000000,
        roughness: 0.08,
        metalness: 0.55,
        envMapIntensity: 0.55,
        /* Water rings come out of OSM in both windings, so the painted water is
           double-sided. The mirror stands in for it and has to match, or half
           the river disappears when the camera is on the wrong side of it. */
        side: twoSided ? THREE.DoubleSide : THREE.FrontSide,
        clippingPlanes: clip,
        clipShadows: true
      });
    }

    var group = new THREE.Group();
    world.add(group);

    /* ======================= ROUND PLATE · BUILD 1 =========================
       Everything below the buildings, rebuilt for the round model.

       ONE FLOOR FOR EVERY MODEL. Three fixed levels, the same on every order:
         FLOOR_Y  top of the base disc
         WATER_Y  every sea, lake and river -- one flat sheet, never stepped
         LAND_Y   the LOWEST land in the crop, always
       Hills, cliffs and towers rise from LAND_Y as far as the place needs. The
       base, the water and the lowest ground are identical on a flat village
       and a mountain, so no model is thin and low or tall and empty.

       Water is not drawn as polygons any more. Every source (OSM water, the
       map tiles' water, rivers, and ESA WorldCover water confirmed by the
       elevation being at sea level) is burned into one grid, smoothed, and the
       land is cut out of it with marching squares. Tile seams, gaps between
       sources and seabed terraces cannot exist in that scheme -- there is only
       land or one flat sheet of water.

       The circle is cut the same way, so the plate edge is a clean arc. */
    var R = half;
    var baseT = mm(MM_T.baseThicknessMm);
    var FLOOR_Y = 0;
    var WATER_Y = mm(0.35);
    var LAND_Y = mm(0.9);
    var STEP_U = mm(MM_T.stepMm || 0.5);
    var WATER_FLOOR = FLOOR_Y;                 // kept for older call sites
    var lonPerUnit = mPerUnit / (111320 * Math.cos(cy * D2R));
    var latPerUnit = mPerUnit / 110540;
    function toLonLat(x, z) { return [cx + x * lonPerUnit, cy - z * latPerUnit]; }

    /* Land cover must be for THIS crop -- the global is the last one fetched. */
    var LC = data.landcover || null;
    if (LC && LC.bbox && (Math.abs(LC.bbox.minLon - b.minLon) > 1e-6 ||
                          Math.abs(LC.bbox.maxLat - b.maxLat) > 1e-6)) LC = null;
    if (LC && !LC.at) LC = null;
    if (window.console) {
      console.info('[mm] land cover ' + (LC ? 'in use' : 'unavailable -- OSM only'));
    }

    /* Lighter on a phone. A 420-cell grid is 350k triangles of ground before a
       single building, and the phone is now also holding a live WebGL context
       for the whole session -- memory pressure is the likeliest reason a long
       build dies on iOS. The cell size still lands under 7 m, which is finer
       than the terrain data underneath it. */
    var GN = (spec.size.cm >= 40 ? 420 : 340) * (IS_TOUCH ? 0.72 : 1);
    GN = Math.round(GN / 2) * 2;               // even, so the centre lands on a line
    var GC = PLATE / GN;
    var NN = GN + 1;                            // nodes across
    var cellM = GC * mPerUnit;

    /* Even-odd scanline fill of local rings into a cell mask. */
    function scanFill(mask, rings, val) {
      var edges = [], zmin = Infinity, zmax = -Infinity;
      rings.forEach(function (r) {
        for (var i = 0, n = r.length; i < n; i++) {
          var a = r[i], c = r[(i + 1) % n];
          if (a[1] === c[1]) continue;
          edges.push(a[0], a[1], c[0], c[1]);
          if (a[1] < zmin) zmin = a[1];
          if (a[1] > zmax) zmax = a[1];
        }
      });
      if (!edges.length) return;
      var j0 = Math.max(0, Math.floor((zmin + half) / GC - 0.5));
      var j1 = Math.min(GN - 1, Math.ceil((zmax + half) / GC - 0.5));
      var xs = [];
      for (var j = j0; j <= j1; j++) {
        var zc = -half + (j + 0.5) * GC;
        xs.length = 0;
        for (var e = 0; e < edges.length; e += 4) {
          var az = edges[e + 1], bz = edges[e + 3];
          if ((az > zc) !== (bz > zc)) {
            var ax = edges[e], bx = edges[e + 2];
            xs.push(ax + (zc - az) * (bx - ax) / (bz - az));
          }
        }
        if (xs.length < 2) continue;
        xs.sort(function (p, q) { return p - q; });
        for (var k = 0; k + 1 < xs.length; k += 2) {
          var i0 = Math.max(0, Math.ceil((xs[k] + half) / GC - 0.5));
          var i1 = Math.min(GN - 1, Math.floor((xs[k + 1] + half) / GC - 0.5));
          for (var i = i0; i <= i1; i++) mask[j * GN + i] = val;
        }
      }
    }
    function localRings(o) {
      var rs = o.rings || [o.ring], out = [];
      for (var i = 0; i < rs.length; i++) {
        if (rs[i] && rs[i].length >= 4) {
          out.push(rs[i].map(function (p) { return toLocal(p[0], p[1]); }));
        }
      }
      return out;
    }
    /* Triangle stamp (x,0,z triples, as ribbonInto writes them). */
    function stampTris(mask, pos, val) {
      for (var t = 0; t + 8 < pos.length; t += 9) {
        var ax = pos[t], az = pos[t + 2], bx = pos[t + 3], bz = pos[t + 5];
        var qx = pos[t + 6], qz = pos[t + 8];
        var d = (bz - qz) * (ax - qx) + (qx - bx) * (az - qz);
        if (!d) continue;
        var i0 = Math.max(0, Math.floor((Math.min(ax, bx, qx) + half) / GC));
        var i1 = Math.min(GN - 1, Math.floor((Math.max(ax, bx, qx) + half) / GC));
        var j0 = Math.max(0, Math.floor((Math.min(az, bz, qz) + half) / GC));
        var j1 = Math.min(GN - 1, Math.floor((Math.max(az, bz, qz) + half) / GC));
        for (var j = j0; j <= j1; j++) {
          var pz = -half + (j + 0.5) * GC;
          for (var i = i0; i <= i1; i++) {
            var px = -half + (i + 0.5) * GC;
            var w1 = ((bz - qz) * (px - qx) + (qx - bx) * (pz - qz)) / d;
            if (w1 < -0.02 || w1 > 1.02) continue;
            var w2 = ((qz - az) * (px - qx) + (ax - qx) * (pz - qz)) / d;
            if (w2 < -0.02 || w1 + w2 > 1.02) continue;
            mask[j * GN + i] = val;
          }
        }
      }
    }
    function blurField(f, n, passes) {
      var tmp = new Float32Array(f.length);
      for (var p = 0; p < passes; p++) {
        for (var j = 0; j < n; j++) {
          for (var i = 0; i < n; i++) {
            var s = 0, c = 0;
            for (var dj = -1; dj <= 1; dj++) {
              var jj = j + dj; if (jj < 0 || jj >= n) continue;
              for (var di = -1; di <= 1; di++) {
                var ii = i + di; if (ii < 0 || ii >= n) continue;
                s += f[jj * n + ii]; c++;
              }
            }
            tmp[j * n + i] = s / c;
          }
        }
        f.set(tmp);
      }
    }

    /* Lines are laid on stepped ground, so they need a point at least every
       cell -- a two-point road across three terraces used to dive under the
       middle one and vanish. */
    function densify(pts, maxLen) {
      maxLen = maxLen || GC * 1.2;
      var out = [pts[0]];
      for (var i = 1; i < pts.length; i++) {
        var a = pts[i - 1], c = pts[i], L = Math.hypot(c[0] - a[0], c[1] - a[1]);
        var n = Math.ceil(L / maxLen);
        for (var k = 1; k <= n; k++) out.push([a[0] + (c[0] - a[0]) * k / n, a[1] + (c[1] - a[1]) * k / n]);
      }
      return out;
    }
    /* Build 2: split a densified line where it meets water, so a road or
       footpath that is not a bridge stops at the bank instead of diving under
       the water and poking back up as a shard. */
    function landRuns(pts) {
      var runs = [], cur = [];
      for (var i = 0; i < pts.length; i++) {
        if (isWaterAt(pts[i][0], pts[i][1])) { if (cur.length > 1) runs.push(cur); cur = []; }
        else cur.push(pts[i]);
      }
      if (cur.length > 1) runs.push(cur);
      return runs;
    }

    /* Distance, in cells, from every cell to the nearest source cell. */
    function chamfer(isSource) {
      var D = new Float32Array(GN * GN), BIGD = 1e9, i, j, k, v;
      for (k = 0; k < GN * GN; k++) D[k] = isSource(k) ? 0 : BIGD;
      for (j = 0; j < GN; j++) for (i = 0; i < GN; i++) {
        k = j * GN + i; v = D[k];
        if (i > 0 && D[k - 1] + 1 < v) v = D[k - 1] + 1;
        if (j > 0) {
          if (D[k - GN] + 1 < v) v = D[k - GN] + 1;
          if (i > 0 && D[k - GN - 1] + 1.414 < v) v = D[k - GN - 1] + 1.414;
          if (i < GN - 1 && D[k - GN + 1] + 1.414 < v) v = D[k - GN + 1] + 1.414;
        }
        D[k] = v;
      }
      for (j = GN - 1; j >= 0; j--) for (i = GN - 1; i >= 0; i--) {
        k = j * GN + i; v = D[k];
        if (i < GN - 1 && D[k + 1] + 1 < v) v = D[k + 1] + 1;
        if (j < GN - 1) {
          if (D[k + GN] + 1 < v) v = D[k + GN] + 1;
          if (i < GN - 1 && D[k + GN + 1] + 1.414 < v) v = D[k + GN + 1] + 1.414;
          if (i > 0 && D[k + GN - 1] + 1.414 < v) v = D[k + GN - 1] + 1.414;
        }
        D[k] = v;
      }
      return D;
    }

    /* ---- water: every source into one grid ---- */
    var wCell = new Uint8Array(GN * GN), flowMask = new Uint8Array(GN * GN);
    var nWaterSrc = 0;
    var FLOWING = { river: 1, riverbank: 1, canal: 1, stream: 1, ditch: 1, drain: 1, tidal_channel: 1 };
    (data.water || []).concat(data.tileWater || []).slice(0, 8000).forEach(function (o) {
      var lr = localRings(o);
      if (!lr.length) return;
      scanFill(wCell, lr, 1); nWaterSrc++;
      if (o.kind && FLOWING[o.kind]) scanFill(flowMask, lr, 1);
    });
    var riverPos = [], thinWays = [];
    (data.waterways || []).slice(0, 2500).forEach(function (o) {
      var wLine = o.line.map(function (p) { return toLocal(p[0], p[1]); });
      /* Build 2.1: a stream is narrower than two grid cells, so cutting it into
         the ground left a broken trench whose walls hid the water -- a dark
         crack across the field. Anything under 1.5 mm is laid ON the ground as a
         flat blue line instead (detail layer); rivers and canals are still cut. */
      if (o.width / mPerUnit < mm(1.5)) {
        thinWays.push({ line: wLine, w: Math.max(o.width / mPerUnit, mm(0.5)) });
        return;
      }
      ribbonInto(riverPos, wLine, Math.max(o.width / mPerUnit, mm(0.8)));
    });
    stampTris(wCell, riverPos, 1);
    stampTris(flowMask, riverPos, 1);
    /* Sea the vectors missed: WorldCover says water AND the ground is at sea
       level. Inland lakes are never invented this way -- they sit above 3 m. */
    var seaRescued = 0;
    if (LC && terrain) {
      for (var sj = 0; sj < GN; sj++) {
        for (var si = 0; si < GN; si++) {
          if (wCell[sj * GN + si]) continue;
          var sll = toLonLat(-half + (si + 0.5) * GC, -half + (sj + 0.5) * GC);
          if (LC.at(sll[0], sll[1]) !== 80) continue;
          var sh = terrain.at(sll[0], sll[1]);
          if (sh != null && sh <= 3) { wCell[sj * GN + si] = 1; seaRescued++; }
        }
      }
    }

    /* Build 2: piers, jetties and breakwaters mapped as areas are LAND, cut
       back out of the water after every water source has been laid. */
    (data.piers || []).slice(0, 2000).forEach(function (o) {
      var lr = localRings(o);
      if (lr.length) { scanFill(wCell, lr, 0); scanFill(flowMask, lr, 0); }
    });

    /* Node fields: water fraction (smoothed) and outside-the-circle. */
    var WN = new Float32Array(NN * NN), ON = new Float32Array(NN * NN);
    for (var nj = 0; nj < NN; nj++) {
      for (var ni = 0; ni < NN; ni++) {
        var s0 = 0, c0 = 0;
        for (var dj0 = -1; dj0 <= 0; dj0++) {
          var cj = nj + dj0; if (cj < 0 || cj >= GN) continue;
          for (var di0 = -1; di0 <= 0; di0++) {
            var ci0 = ni + di0; if (ci0 < 0 || ci0 >= GN) continue;
            s0 += wCell[cj * GN + ci0]; c0++;
          }
        }
        WN[nj * NN + ni] = c0 ? s0 / c0 : 0;
        var rx = -half + ni * GC, rz = -half + nj * GC;
        var ov = (Math.hypot(rx, rz) - R) / GC + 0.5;
        ON[nj * NN + ni] = ov < 0 ? 0 : ov > 1 ? 1 : ov;
      }
    }
    blurField(WN, NN, 1);
    function FN(k) { return Math.max(WN[k], ON[k]); }

    function nodeLerp(field, x, z) {
      var fx = (x + half) / GC, fz = (z + half) / GC;
      var i = Math.floor(fx), j = Math.floor(fz);
      if (i < 0) i = 0; if (j < 0) j = 0;
      if (i > GN - 1) i = GN - 1; if (j > GN - 1) j = GN - 1;
      var tx = fx - i, tz = fz - j;
      var a = field[j * NN + i], b2 = field[j * NN + i + 1];
      var c2 = field[(j + 1) * NN + i], d2 = field[(j + 1) * NN + i + 1];
      return (a * (1 - tx) + b2 * tx) * (1 - tz) + (c2 * (1 - tx) + d2 * tx) * tz;
    }
    function isWaterAt(x, z) {
      if (x * x + z * z > R * R) return false;
      return nodeLerp(WN, x, z) >= 0.5;
    }

    /* ---- relief: fixed floor, soft cap, fixed step ---- */
    var relief = MM_T.reliefStrength;
    var EN = new Float32Array(NN * NN);
    var landMin = Infinity, landMax = -Infinity, landNodes = 0;
    for (var ek = 0; ek < NN * NN; ek++) {
      var ex = -half + (ek % NN) * GC, ez = -half + Math.floor(ek / NN) * GC;
      var eh = null;
      if (terrain) { var ell = toLonLat(ex, ez); eh = terrain.at(ell[0], ell[1]); }
      EN[ek] = eh == null ? NaN : eh;
      if (eh != null && FN(ek) < 0.5) {
        landNodes++;
        if (eh < landMin) landMin = eh;
        if (eh > landMax) landMax = eh;
      }
    }
    if (!landNodes) { landMin = 0; landMax = 0; }
    /* The floor reference is the 2nd-percentile land height, not the single
       lowest node: one pier or quay reading as seabed in the elevation data
       would otherwise drag the whole model's floor down and lift everything. */
    if (landNodes > 50) {
      var lh = [];
      for (var lq = 0; lq < NN * NN; lq += 1) if (!isNaN(EN[lq]) && FN(lq) < 0.5) lh.push(EN[lq]);
      lh.sort(function (p, q) { return p - q; });
      landMin = lh[Math.floor(lh.length * 0.02)];
      for (var lc2 = 0; lc2 < NN * NN; lc2++) if (!isNaN(EN[lc2]) && EN[lc2] < landMin) EN[lc2] = landMin;
    }

    /* ---- Build 1.1: sea vs inland water ----
       Water cells are grouped into connected bodies. A body whose shore sits
       within 3 m of the lowest land is the sea (or tidal water) and lies on the
       one fixed sea sheet. Anything higher -- a pond in a park, a canal on a
       ridge, a river inland -- lies just below its OWN banks instead of being
       cut down to sea level as a pit. */
    var wCell2 = new Uint8Array(GN * GN);
    for (var wk = 0; wk < GN * GN; wk++) {
      var wi = wk % GN, wj = Math.floor(wk / GN), k00 = wj * NN + wi;
      var wv = (WN[k00] + WN[k00 + 1] + WN[k00 + NN] + WN[k00 + NN + 1]) / 4;
      var wx = -half + (wi + 0.5) * GC, wz = -half + (wj + 0.5) * GC;
      wCell2[wk] = (wv >= 0.5 && wx * wx + wz * wz <= R * R) ? 1 : 0;
    }
    var comp = new Int32Array(GN * GN).fill(-1), compMinE = [], compSea = [];
    (function () {
      var stack = [];
      for (var s = 0; s < GN * GN; s++) {
        if (!wCell2[s] || comp[s] >= 0) continue;
        var id = compMinE.length, minE = Infinity, touchesLand = false;
        comp[s] = id; stack.push(s);
        while (stack.length) {
          var c = stack.pop(), ci = c % GN, cj = Math.floor(c / GN);
          var kk0 = cj * NN + ci, cn = [kk0, kk0 + 1, kk0 + NN, kk0 + NN + 1];
          for (var q = 0; q < 4; q++) {
            if (FN(cn[q]) < 0.5) {
              touchesLand = true;
              if (!isNaN(EN[cn[q]]) && EN[cn[q]] < minE) minE = EN[cn[q]];
            }
          }
          if (ci > 0 && wCell2[c - 1] && comp[c - 1] < 0) { comp[c - 1] = id; stack.push(c - 1); }
          if (ci < GN - 1 && wCell2[c + 1] && comp[c + 1] < 0) { comp[c + 1] = id; stack.push(c + 1); }
          if (cj > 0 && wCell2[c - GN] && comp[c - GN] < 0) { comp[c - GN] = id; stack.push(c - GN); }
          if (cj < GN - 1 && wCell2[c + GN] && comp[c + GN] < 0) { comp[c + GN] = id; stack.push(c + GN); }
        }
        compMinE.push(minE);
        compSea.push(!touchesLand || !isFinite(minE) || minE <= landMin + 3);
      }
    })();
    var seaCell = new Uint8Array(GN * GN), anySea = false;
    for (var sk = 0; sk < GN * GN; sk++) {
      if (comp[sk] >= 0 && compSea[comp[sk]] && !flowMask[sk]) { seaCell[sk] = 1; anySea = true; }
    }

    /* ---- Build 1.1: shore slope, corrected in Build 4.4 ----
       30 m elevation data smears a hillside onto the shore, which stood piers
       and quays up as cliffs. Near the sea, land may rise no faster than
       2 m + 1 m per metre inland -- a pier is a pier, the town still climbs.

       Build 4.4: that rule cannot tell a smear from a real cliff, and a real
       cliff breaks ANY slope limit. The Cliffs of Moher arrived as 4.9 m of
       land range instead of 200 and rendered as a flat green field.
       What actually separates the two is whether the high ground CONTINUES
       inland. A smear is a fringe: high at the water, low again a hundred
       metres back. A cliff is an edge: the plateau behind it is just as high.
       So before capping a node, step inland (up the distance-to-sea gradient)
       and look. If the land back there still holds most of this node's height,
       this is an edge and it is left alone. */
    if (anySea && terrain) {
      var dSea = chamfer(function (k) { return seaCell[k] === 1; });
      var LOOK_M = 130;                       // how far inland to look
      var HOLD = 0.6;                         // fraction of the height it must keep
      var lookU = LOOK_M / mPerUnit, shoreCapped = 0, shoreKept = 0;
      for (var nk = 0; nk < NN * NN; nk++) {
        if (isNaN(EN[nk])) continue;
        var ni2 = nk % NN, nj2 = Math.floor(nk / NN), dMin = Infinity;
        for (var dj3 = -1; dj3 <= 0; dj3++) {
          var cj3 = nj2 + dj3; if (cj3 < 0 || cj3 >= GN) continue;
          for (var di3 = -1; di3 <= 0; di3++) {
            var ci3 = ni2 + di3; if (ci3 < 0 || ci3 >= GN) continue;
            if (dSea[cj3 * GN + ci3] < dMin) dMin = dSea[cj3 * GN + ci3];
          }
        }
        var cap = landMin + 2 + dMin * cellM;
        if (EN[nk] <= cap) continue;

        /* Which way is inland? Up the gradient of the distance-to-sea field. */
        var ci4 = Math.min(GN - 1, Math.max(0, ni2)), cj4 = Math.min(GN - 1, Math.max(0, nj2));
        var xm = Math.max(0, ci4 - 1), xp = Math.min(GN - 1, ci4 + 1);
        var zm = Math.max(0, cj4 - 1), zp = Math.min(GN - 1, cj4 + 1);
        var gx = dSea[cj4 * GN + xp] - dSea[cj4 * GN + xm];
        var gz = dSea[zp * GN + ci4] - dSea[zm * GN + ci4];
        var gl = Math.hypot(gx, gz);
        var keep = false;
        if (gl > 1e-6) {
          var sx = -half + ni2 * GC + (gx / gl) * lookU;
          var sz = -half + nj2 * GC + (gz / gl) * lookU;
          var inlandE = nodeLerp(EN, sx, sz);
          keep = !isNaN(inlandE) &&
                 (inlandE - landMin) >= (EN[nk] - landMin) * HOLD;
        }
        if (keep) { shoreKept++; continue; }
        EN[nk] = cap;
        shoreCapped++;
      }
      if (window.console && (shoreCapped || shoreKept)) {
        console.info('[mm] shore: ' + shoreCapped + ' node(s) flattened as elevation smear, ' +
                     shoreKept + ' kept as real cliff or headland');
      }
      landMax = -Infinity;
      for (var lk = 0; lk < NN * NN; lk++) {
        if (!isNaN(EN[lk]) && FN(lk) < 0.5 && EN[lk] > landMax) landMax = EN[lk];
      }
      if (!isFinite(landMax)) landMax = landMin;
    }

    var hasRelief = !!(terrain && relief > 0 && (landMax - landMin) > 0.25);
    var reliefScale = (MM_T.reliefExaggeration || 1.25) * (relief || 1);
    /* B5.51: a flat place is stretched more, so it does not print as a
       pancake; hilly places keep today's scale (the soft cap handles them).
       Under 3 m of range is elevation-data noise, not landform -- left alone
       rather than amplified into bumps. */
    var reliefBoost = 1, landRange = landMax - landMin;
    if (hasRelief && landRange >= 3) {
      var naturalMm = landRange * reliefScale / mPerUnit / mm(1);
      reliefBoost = Math.min(2.4, Math.max(1, 8 / Math.max(naturalMm, 0.01)));
      reliefScale *= reliefBoost;
    }
    var capU = mm(MM_T.maxReliefMm || 16);
    var HN = new Float32Array(NN * NN);
    var maxLift = LAND_Y, meanLift = LAND_Y;
    for (var hk = 0; hk < NN * NN; hk++) {
      var e2 = EN[hk], hu = 0;
      if (hasRelief && !isNaN(e2)) {
        var raw = (e2 - landMin) * reliefScale / mPerUnit;
        if (raw < 0) raw = 0;
        hu = capU * (1 - Math.exp(-raw / capU));
      }
      HN[hk] = hu;
      if (FN(hk) < 0.5 && LAND_Y + hu > maxLift) maxLift = LAND_Y + hu;
    }
    var reliefReason = hasRelief ? '' :
      (!terrain ? 'tiles did not load'
        : relief <= 0 ? 'exaggeration set to 0'
        : 'crop flatter than 0.25 m');
    if (window.console) {
      console.info('[mm] relief: ' + (landMax - landMin).toFixed(1) + ' m of land range \u2192 ' +
        ((maxLift - LAND_Y) / mm(1)).toFixed(1) + ' mm above the floor, steps of ' +
        (MM_T.stepMm || 0.5) + ' mm' + (hasRelief ? '' : ' (' + reliefReason + ')') +
        (reliefBoost > 1 ? ' \u00b7 flat-ground boost \u00d7' + reliefBoost.toFixed(2) : ''));
      console.info('[mm] water: ' + nWaterSrc + ' area(s), ' + (data.waterways || []).length +
        ' waterway(s), ' + seaRescued + ' sea cell(s) confirmed by land cover + elevation, ' +
        compSea.filter(function (x) { return !x; }).length + ' inland water bod(ies)');
    }
    function qlev(h) { return Math.round(h / STEP_U) * STEP_U; }

    /* Water level per cell. Sea: the fixed sheet. Inland: a step below the
       lowest bank within ~12 m, so a river steps down its valley and a pond
       sits in its park rather than in a shaft. */
    var WL = new Float32Array(GN * GN);
    var WATER_DROP = mm(0.45), inlandCells = 0;
    (function () {
      var RAD = Math.max(2, Math.round(12 / cellM));
      var compMinH = compMinE.map(function (e) {
        if (!hasRelief || !isFinite(e)) return 0;
        var raw = Math.max(0, (e - landMin) * reliefScale / mPerUnit);
        return capU * (1 - Math.exp(-raw / capU));
      });
      for (var k = 0; k < GN * GN; k++) {
        WL[k] = WATER_Y;
        if (comp[k] < 0 || seaCell[k] || !hasRelief) continue;
        /* Still water (lake, pond, dock) is one flat sheet at its lowest
           bank; flowing water steps down with the banks beside it. */
        if (!flowMask[k]) {
          WL[k] = Math.max(WATER_Y, LAND_Y + qlev(compMinH[comp[k]]) - WATER_DROP);
          if (WL[k] > WATER_Y + 1e-6) inlandCells++;
          continue;
        }
        var ci = k % GN, cj = Math.floor(k / GN), best = Infinity;
        for (var dj = -RAD; dj <= RAD + 1; dj++) {
          var nj = cj + dj; if (nj < 0 || nj > GN) continue;
          for (var di = -RAD; di <= RAD + 1; di++) {
            var ni = ci + di; if (ni < 0 || ni > GN) continue;
            var nk = nj * NN + ni;
            if (FN(nk) < 0.5 && HN[nk] < best) best = HN[nk];
          }
        }
        if (!isFinite(best)) best = compMinH[comp[k]];
        WL[k] = Math.max(WATER_Y, LAND_Y + qlev(best) - WATER_DROP);
        if (WL[k] > WATER_Y + 1e-6) inlandCells++;
      }
    })();
    /* Build 1.2: banks. Ground beside inland water may only rise gently from
       it -- roughly one metre per metre -- so a pond, canal or river is a
       shallow step into its park or street, never a shaft. The level of the
       nearest water travels with the distance, so each bank follows its own
       stretch of river. */
    if (inlandCells && hasRelief) {
      (function () {
        var BIGD = 1e9, dI = new Float32Array(GN * GN), lv = new Float32Array(GN * GN), i, j, k;
        for (k = 0; k < GN * GN; k++) {
          if (comp[k] >= 0 && !seaCell[k] && WL[k] > WATER_Y + 1e-6) { dI[k] = 0; lv[k] = WL[k] - LAND_Y + WATER_DROP; }
          else dI[k] = BIGD;
        }
        function relax(k, n, w) { if (dI[n] + w < dI[k]) { dI[k] = dI[n] + w; lv[k] = lv[n]; } }
        for (j = 0; j < GN; j++) for (i = 0; i < GN; i++) {
          k = j * GN + i;
          if (i > 0) relax(k, k - 1, 1);
          if (j > 0) { relax(k, k - GN, 1); if (i > 0) relax(k, k - GN - 1, 1.414); if (i < GN - 1) relax(k, k - GN + 1, 1.414); }
        }
        for (j = GN - 1; j >= 0; j--) for (i = GN - 1; i >= 0; i--) {
          k = j * GN + i;
          if (i < GN - 1) relax(k, k + 1, 1);
          if (j < GN - 1) { relax(k, k + GN, 1); if (i < GN - 1) relax(k, k + GN + 1, 1.414); if (i > 0) relax(k, k + GN - 1, 1.414); }
        }
        /* Gentle in MODEL terms: at most 0.25 mm of rise per cell (about 1 in
           2.4 on the model), however steep the real ground is. */
        var slopeU = Math.min(cellM * reliefScale / mPerUnit, mm(0.25)), capped = 0;
        for (var nk = 0; nk < NN * NN; nk++) {
          if (FN(nk) >= 0.5) continue;
          var ni = nk % NN, nj = Math.floor(nk / NN), best = BIGD, bl = 0;
          for (var dj = -1; dj <= 0; dj++) {
            var cj = nj + dj; if (cj < 0 || cj >= GN) continue;
            for (var di = -1; di <= 0; di++) {
              var ci = ni + di; if (ci < 0 || ci >= GN) continue;
              var c = cj * GN + ci;
              if (dI[c] < best) { best = dI[c]; bl = lv[c]; }
            }
          }
          if (best >= BIGD / 2) continue;
          var cap = bl + slopeU * Math.max(0, best - 0.5);
          if (HN[nk] > cap) { HN[nk] = cap; capped++; }
        }
        if (window.console) console.info('[mm] banks eased beside inland water: ' + capped + ' node(s)');
      })();
    }
    if (window.console && inlandCells) {
      console.info('[mm] inland water: ' + inlandCells + ' cell(s) laid at their own banks');
    }
    function waterLevelAt(x, z) {
      var i = Math.floor((x + half) / GC), j = Math.floor((z + half) / GC);
      if (i < 0 || j < 0 || i >= GN || j >= GN) return WATER_Y;
      return WL[j * GN + i];
    }

    /* Surface height at a point: the same rule the mesh uses. */
    function terrainAt(x, z) {
      if (isWaterAt(x, z)) return waterLevelAt(x, z);
      if (!hasRelief) return LAND_Y;
      var fx = (x + half) / GC, fz = (z + half) / GC;
      var i = Math.floor(fx), j = Math.floor(fz);
      if (i < 0) i = 0; if (j < 0) j = 0;
      if (i > GN - 1) i = GN - 1; if (j > GN - 1) j = GN - 1;
      var k0 = j * NN + i;
      var h0 = HN[k0], h1 = HN[k0 + 1], h2 = HN[k0 + NN + 1], h3 = HN[k0 + NN];
      var q0 = qlev(h0), q1 = qlev(h1), q2 = qlev(h2), q3 = qlev(h3);
      var lo = Math.min(q0, q1, q2, q3), hi = Math.max(q0, q1, q2, q3);
      var tx = fx - i, tz = fz - j;
      if (hi - lo > STEP_U * 1.5) {
        return LAND_Y + (q0 * (1 - tx) + q1 * tx) * (1 - tz) + (q3 * (1 - tx) + q2 * tx) * tz;
      }
      return LAND_Y + qlev((h0 * (1 - tx) + h1 * tx) * (1 - tz) + (h3 * (1 - tx) + h2 * tx) * tz);
    }
    function terrainRawAt(x, z) { return terrainAt(x, z) - LAND_Y; }

    /* ---- ground class: green / built / dense (Meadow only) ---- */
    var isGreenBase = spec.colourway === 'full';
    var bMask = new Uint8Array(GN * GN);
    (data.buildings || []).slice(0, 20000).forEach(function (o) {
      var lr = localRings(o);
      if (lr.length) scanFill(bMask, [lr[0]], 1);
    });
    /* Building coverage within ~35 m, for the city-grey ground and for garden
       trees (none in a dense centre). Summed-area table. */
    var SAT = new Float32Array((GN + 1) * (GN + 1));
    for (var yj = 0; yj < GN; yj++) {
      var rowS = 0;
      for (var yi = 0; yi < GN; yi++) {
        rowS += bMask[yj * GN + yi];
        SAT[(yj + 1) * (GN + 1) + yi + 1] = SAT[yj * (GN + 1) + yi + 1] + rowS;
      }
    }
    var DR = Math.max(2, Math.round(35 / cellM));
    function densityAt(i, j) {
      var i0 = Math.max(0, i - DR), i1 = Math.min(GN, i + DR + 1);
      var j0 = Math.max(0, j - DR), j1 = Math.min(GN, j + DR + 1);
      var s = SAT[j1 * (GN + 1) + i1] - SAT[j0 * (GN + 1) + i1] -
              SAT[j1 * (GN + 1) + i0] + SAT[j0 * (GN + 1) + i0];
      return s / ((i1 - i0) * (j1 - j0));
    }
    var gScore = new Float32Array(GN * GN);
    if (isGreenBase) {
      var GREEN_LC = { 10: 1, 20: 1, 30: 1, 40: 1, 90: 1, 95: 1, 100: 1 };
      for (var gk = 0; gk < GN * GN; gk++) {
        if (LC) {
          var gll = toLonLat(-half + ((gk % GN) + 0.5) * GC, -half + (Math.floor(gk / GN) + 0.5) * GC);
          var cls = LC.at(gll[0], gll[1]);
          gScore[gk] = GREEN_LC[cls] ? 1 : (cls === 0 || cls === 80) ? 0.5 : 0;
        } else {
          gScore[gk] = 1;
        }
      }
      var urbanMask = new Uint8Array(GN * GN);
      (data.urban || []).slice(0, 4000).forEach(function (o) {
        var lr = localRings(o); if (lr.length) scanFill(urbanMask, lr, 1);
      });
      /* Built ground: a morphological closing of the buildings. Everything
         within 25 m of a building, shrunk back by 15 m -- so houses in a
         village merge into one continuous built area (gaps under ~50 m are
         filled) while a lone farmhouse keeps a small rounded yard of ~10 m.
         No discs, no squares. */
      var dB = chamfer(function (k) { return bMask[k] === 1; });
      var R1 = 25 / cellM, R2 = 15 / cellM;
      var dOut = chamfer(function (k) { return dB[k] > R1; });
      for (var ck = 0; ck < GN * GN; ck++) if (dOut[ck] > R2) urbanMask[ck] = 1;
      for (var uk = 0; uk < GN * GN; uk++) if (urbanMask[uk]) gScore[uk] = 0;
      blurField(gScore, GN, 2);
      /* Mapped parks and fields last, crisp, over everything. */
      var parkMask = new Uint8Array(GN * GN);
      (data.grass || []).slice(0, 6000).forEach(function (o) {
        var lr = localRings(o); if (lr.length) scanFill(parkMask, lr, 1);
      });
      for (var pk = 0; pk < GN * GN; pk++) if (parkMask[pk]) gScore[pk] = 1;
      var pierMask = new Uint8Array(GN * GN);
      (data.piers || []).slice(0, 2000).forEach(function (o) {
        var lr = localRings(o); if (lr.length) scanFill(pierMask, lr, 1);
      });
      for (var pq = 0; pq < GN * GN; pq++) if (pierMask[pq]) gScore[pq] = 0;
    }
    var cGreen = new THREE.Color(C.grass), cTan = new THREE.Color(C.ground);
    var cDense = new THREE.Color(C.groundDense != null ? C.groundDense : C.ground);
    var cBase = new THREE.Color(C.base);
    var cellCol = new THREE.Color();
    function colourOfCell(i, j) {
      if (!isGreenBase) return cellCol.copy(cTan);
      if (gScore[j * GN + i] >= 0.5) return cellCol.copy(cGreen);
      var d = densityAt(i, j);
      var t = d <= 0.18 ? 0 : d >= 0.38 ? 1 : (d - 0.18) / 0.2;
      return cellCol.copy(cTan).lerp(cDense, t);
    }

    /* ---- the ground mesh: marching squares over land, terraces inside ---- */
    var gp = [], gc = [], inlandPos = [];
    var greenCells = 0;
    function V(x, y, z, col) { gp.push(x, y, z); gc.push(col.r, col.g, col.b); }
    /* Build 2.1: the cut face where land meets the ring. Drawn as a few hundred
       flat quads it shaded quad by quad -- vertical streaks down the side of any
       hill that reaches the edge. Its own mesh with normals pointing straight
       out from the centre shades it as the one smooth curved face it is. */
    var rimP = [], rimN = [];
    function rimWall(p, q, yp, yq) {
      /* Wound to face outward, so the explicit normals agree with the side the
         renderer considers the front. */
      var dx = q[0] - p[0], dz = q[1] - p[1];
      if (dz * (p[0] + q[0]) - dx * (p[1] + q[1]) < 0) {
        var tp = p; p = q; q = tp; var ty = yp; yp = yq; yq = ty;
      }
      var lp = Math.hypot(p[0], p[1]) || 1, lq = Math.hypot(q[0], q[1]) || 1;
      var np = [p[0] / lp, 0, p[1] / lp], nq = [q[0] / lq, 0, q[1] / lq];
      rimP.push(p[0], yp, p[1], q[0], yq, q[1], q[0], FLOOR_Y, q[1],
                p[0], yp, p[1], q[0], FLOOR_Y, q[1], p[0], FLOOR_Y, p[1]);
      rimN.push.apply(rimN, np.concat(nq, nq, np, nq, np));
    }
    function fanUp(poly, yOf, col) {
      if (poly.length < 3) return;
      /* Pieces are convex (a cell square cut by straight lines), so triangles
         and quads need no centre point -- half the triangles on open ground. */
      if (poly.length <= 4) {
        var P0 = poly[0], y0 = yOf(P0[0], P0[1]);
        for (var t = 1; t + 1 < poly.length; t++) {
          var Pa = poly[t + 1], Pb = poly[t];
          V(P0[0], y0, P0[1], col);
          V(Pa[0], yOf(Pa[0], Pa[1]), Pa[1], col);
          V(Pb[0], yOf(Pb[0], Pb[1]), Pb[1], col);
        }
        return;
      }
      var mx = 0, mz = 0;
      for (var q = 0; q < poly.length; q++) { mx += poly[q][0]; mz += poly[q][1]; }
      mx /= poly.length; mz /= poly.length;
      var ym = yOf(mx, mz);
      for (var k = 0; k < poly.length; k++) {
        var a = poly[(k + 1) % poly.length], c = poly[k];
        V(mx, ym, mz, col); V(a[0], yOf(a[0], a[1]), a[1], col); V(c[0], yOf(c[0], c[1]), c[1], col);
      }
    }
    function wallDown(p, q, yp, yq, col) {
      V(p[0], yp, p[1], col); V(q[0], yq, q[1], col); V(q[0], FLOOR_Y, q[1], col);
      V(p[0], yp, p[1], col); V(q[0], FLOOR_Y, q[1], col); V(p[0], FLOOR_Y, p[1], col);
    }
    function clipHalf(poly, ax, az, nx, nz, keepPos) {
      var out = [];
      for (var k = 0; k < poly.length; k++) {
        var P = poly[k], Q = poly[(k + 1) % poly.length];
        var dp = (P[0] - ax) * nx + (P[1] - az) * nz, dq = (Q[0] - ax) * nx + (Q[1] - az) * nz;
        if (!keepPos) { dp = -dp; dq = -dq; }
        if (dp >= 0) out.push(P);
        if ((dp >= 0) !== (dq >= 0)) {
          var t = dp / (dp - dq);
          out.push([P[0] + (Q[0] - P[0]) * t, P[1] + (Q[1] - P[1]) * t]);
        }
      }
      return out;
    }
    var bankC = new THREE.Color(C.ground);
    var riserC = new THREE.Color();
    var RISER_LIFT = MM_T.riserLift != null ? MM_T.riserLift : 1;
    /* Where two stretches of river sit at different levels, a small face so
       there is never a gap to see through. */
    function inlandSteps(ci, cj, x0, z0, wl) {
      if (ci < GN - 1) {
        var wr = WL[cj * GN + ci + 1];
        if (comp[cj * GN + ci + 1] >= 0 && Math.abs(wr - wl) > 1e-6) {
          var xe = x0 + GC, lo = Math.min(wl, wr), hi = Math.max(wl, wr);
          inlandPos.push(xe, lo, z0, xe, hi, z0, xe, hi, z0 + GC, xe, lo, z0, xe, hi, z0 + GC, xe, lo, z0 + GC);
        }
      }
      if (cj < GN - 1) {
        var wd = WL[(cj + 1) * GN + ci];
        if (comp[(cj + 1) * GN + ci] >= 0 && Math.abs(wd - wl) > 1e-6) {
          var ze = z0 + GC, lo2 = Math.min(wl, wd), hi2 = Math.max(wl, wd);
          inlandPos.push(x0, lo2, ze, x0, hi2, ze, x0 + GC, hi2, ze, x0, lo2, ze, x0 + GC, hi2, ze, x0 + GC, lo2, ze);
        }
      }
    }
    for (var cj2 = 0; cj2 < GN; cj2++) {
      for (var ci2 = 0; ci2 < GN; ci2++) {
        var k0 = cj2 * NN + ci2, kk = [k0, k0 + 1, k0 + NN + 1, k0 + NN];
        var f = [FN(kk[0]), FN(kk[1]), FN(kk[2]), FN(kk[3])];
        var ins = [f[0] < 0.5, f[1] < 0.5, f[2] < 0.5, f[3] < 0.5];
        if (!ins[0] && !ins[1] && !ins[2] && !ins[3]) {
          /* All water. Inland water needs its own surface here too -- this
             was missing, so the middle of a pond showed the sea sheet far
             below and every park pond became a pit. */
          var wlF = WL[cj2 * GN + ci2];
          if (wlF > WATER_Y + 1e-6) {
            var xf = -half + ci2 * GC, zf = -half + cj2 * GC;
            inlandPos.push(xf, wlF, zf, xf + GC, wlF, zf + GC, xf + GC, wlF, zf,
                           xf, wlF, zf, xf, wlF, zf + GC, xf + GC, wlF, zf + GC);
            inlandSteps(ci2, cj2, xf, zf, wlF);
          }
          continue;
        }
        var x0 = -half + ci2 * GC, z0 = -half + cj2 * GC;
        var P4 = [[x0, z0], [x0 + GC, z0], [x0 + GC, z0 + GC], [x0, z0 + GC]];
        var h4 = [HN[kk[0]], HN[kk[1]], HN[kk[2]], HN[kk[3]]];
        var q4 = [qlev(h4[0]), qlev(h4[1]), qlev(h4[2]), qlev(h4[3])];
        var lo = Math.min(q4[0], q4[1], q4[2], q4[3]), hi = Math.max(q4[0], q4[1], q4[2], q4[3]);
        var col = colourOfCell(ci2, cj2);
        if (isGreenBase && gScore[cj2 * GN + ci2] >= 0.5) greenCells++;

        /* Land pieces + boundary segments (with whether the edge is the rim). */
        var pieces = [], segs = [], cross = [], poly = [];
        for (var e = 0; e < 4; e++) {
          var a = e, c = (e + 1) % 4;
          if (ins[a]) poly.push(P4[a]);
          if (ins[a] !== ins[c]) {
            var t = (0.5 - f[a]) / (f[c] - f[a]);
            var px = P4[a][0] + (P4[c][0] - P4[a][0]) * t, pz = P4[a][1] + (P4[c][1] - P4[a][1]) * t;
            var oc = ON[kk[a]] + (ON[kk[c]] - ON[kk[a]]) * t, wn = WN[kk[a]] + (WN[kk[c]] - WN[kk[a]]) * t;
            var cp = [px, pz]; cp.rim = oc > wn;
            poly.push(cp); cross.push(cp);
          }
        }
        if (cross.length === 4) {
          var centreLand = (f[0] + f[1] + f[2] + f[3]) / 4 < 0.5;
          if (centreLand) {
            pieces.push(poly); segs.push([cross[0], cross[1]], [cross[2], cross[3]]);
          } else {
            var landCorner = ins[0] ? 0 : 1;
            if (landCorner === 0) {
              pieces.push([cross[3], P4[0], cross[0]], [cross[1], P4[2], cross[2]]);
              segs.push([cross[3], cross[0]], [cross[1], cross[2]]);
            } else {
              pieces.push([cross[0], P4[1], cross[1]], [cross[2], P4[3], cross[3]]);
              segs.push([cross[0], cross[1]], [cross[2], cross[3]]);
            }
          }
        } else {
          pieces.push(poly);
          if (cross.length === 2) segs.push([cross[0], cross[1]]);
        }

        /* Height rule for this cell. */
        var bil = function (x, z) {
          var tx = (x - x0) / GC, tz = (z - z0) / GC;
          return (h4[0] * (1 - tx) + h4[1] * tx) * (1 - tz) + (h4[3] * (1 - tx) + h4[2] * tx) * tz;
        };
        var yOf, split = null;
        if (!hasRelief || hi === lo) {
          var yFlat = LAND_Y + lo;
          yOf = function () { return yFlat; };
        } else if (hi - lo < STEP_U * 1.5) {
          var T = (lo + hi) / 2, tc = [];
          for (var e2 = 0; e2 < 4; e2++) {
            var a2 = e2, c2 = (e2 + 1) % 4;
            if ((h4[a2] >= T) !== (h4[c2] >= T)) {
              var tt = (T - h4[a2]) / (h4[c2] - h4[a2]);
              tc.push([P4[a2][0] + (P4[c2][0] - P4[a2][0]) * tt, P4[a2][1] + (P4[c2][1] - P4[a2][1]) * tt]);
            }
          }
          if (tc.length === 2) {
            var dx = tc[1][0] - tc[0][0], dz = tc[1][1] - tc[0][1];
            var nl = Math.hypot(dx, dz) || 1;
            split = { ax: tc[0][0], az: tc[0][1], nx: -dz / nl, nz: dx / nl, lo: LAND_Y + lo, hi: LAND_Y + hi };
            var up = -1;
            for (var e3 = 0; e3 < 4; e3++) if (h4[e3] >= T) { up = e3; break; }
            var sd = (P4[up][0] - split.ax) * split.nx + (P4[up][1] - split.az) * split.nz;
            split.upPos = sd >= 0;
            yOf = function (x, z) {
              var s = (x - split.ax) * split.nx + (z - split.az) * split.nz;
              return ((s >= 0) === split.upPos) ? split.hi : split.lo;
            };
          } else {
            yOf = function (x, z) { return LAND_Y + qlev(bil(x, z)); };
          }
        } else {
          yOf = function (x, z) {
            var tx = (x - x0) / GC, tz = (z - z0) / GC;
            return LAND_Y + (q4[0] * (1 - tx) + q4[1] * tx) * (1 - tz) + (q4[3] * (1 - tx) + q4[2] * tx) * tz;
          };
        }

        for (var pc = 0; pc < pieces.length; pc++) {
          var pl = pieces[pc];
          if (split) {
            var upP = clipHalf(pl, split.ax, split.az, split.nx, split.nz, split.upPos);
            var loP = clipHalf(pl, split.ax, split.az, split.nx, split.nz, !split.upPos);
            fanUp(upP, function () { return split.hi; }, col);
            fanUp(loP, function () { return split.lo; }, col);
            /* The riser: the part of the step line inside this land piece. */
            var onLine = [];
            for (var r2 = 0; r2 < upP.length; r2++) {
              var sdd = (upP[r2][0] - split.ax) * split.nx + (upP[r2][1] - split.az) * split.nz;
              if (Math.abs(sdd) < GC * 1e-4) onLine.push(upP[r2]);
            }
            if (onLine.length >= 2) {
              var A = onLine[0], B2 = onLine[onLine.length - 1];
              /* Build 4.4: lifted, not tinted -- the same colour carrying more
                 albedo, so a vertical face that receives less light still lands
                 near the surface it steps down from. Without this the step line
                 reads as a pen mark across a field. */
              riserC.setRGB(Math.min(1, col.r * RISER_LIFT),
                            Math.min(1, col.g * RISER_LIFT),
                            Math.min(1, col.b * RISER_LIFT));
              V(A[0], split.lo, A[1], riserC); V(B2[0], split.lo, B2[1], riserC); V(B2[0], split.hi, B2[1], riserC);
              V(A[0], split.lo, A[1], riserC); V(B2[0], split.hi, B2[1], riserC); V(A[0], split.hi, A[1], riserC);
            }
          } else {
            fanUp(pl, yOf, col);
          }
        }
        /* Inland water surface for this cell (sea is the disc underneath). */
        var wl = WL[cj2 * GN + ci2];
        if (wl > WATER_Y + 1e-6 && (!ins[0] || !ins[1] || !ins[2] || !ins[3])) {
          inlandSteps(ci2, cj2, x0, z0, wl);
          var wpoly = [];
          for (var we = 0; we < 4; we++) {
            var wa = we, wc = (we + 1) % 4;
            if (!ins[wa]) wpoly.push(P4[wa]);
            if (ins[wa] !== ins[wc]) {
              var wt = (0.5 - f[wa]) / (f[wc] - f[wa]);
              wpoly.push([P4[wa][0] + (P4[wc][0] - P4[wa][0]) * wt, P4[wa][1] + (P4[wc][1] - P4[wa][1]) * wt]);
            }
          }
          for (var wt2 = 1; wt2 + 1 < wpoly.length; wt2++) {
            var A0 = wpoly[0], Aa = wpoly[wt2 + 1], Ab = wpoly[wt2];
            inlandPos.push(A0[0], wl, A0[1], Aa[0], wl, Aa[1], Ab[0], wl, Ab[1]);
          }
        }
        for (var sg = 0; sg < segs.length; sg++) {
          var p1 = segs[sg][0], p2 = segs[sg][1];
          var rim = p1.rim || p2.rim;
          if (rim) rimWall(p1, p2, yOf(p1[0], p1[1]), yOf(p2[0], p2[1]));
          else wallDown(p1, p2, yOf(p1[0], p1[1]), yOf(p2[0], p2[1]), bankC);
        }
      }
    }
    /* ---- Build 4.2: give the ground form -----------------------------------
       Two thirds of a village plate is one unbroken green, and it reads as
       painted card next to the trees. Nothing here invents a second material:
       it is the lightness that varies, the way a real surface does under a real
       light, and it stays inside one colour.
         - a low-frequency wander, so a field is not a flat fill
         - lightness that follows the relief, so a terrace has a lit side */
    (function () {
      var amp = MM_T.groundVariation || 0, rel = MM_T.groundReliefTone || 0;
      if (amp <= 0 && rel <= 0) return;
      var span = Math.max(1e-6, maxLift - LAND_Y);
      for (var i = 0; i < gc.length; i += 3) {
        var x = gp[i], y = gp[i + 1], z = gp[i + 2];
        /* Two sine fields crossed at odd frequencies: no texture to load, no
           repeat the eye can find, and it costs one pass over the vertices. */
        var n = 0.5 * Math.sin(x * 1.7 + Math.cos(z * 1.3) * 1.9) +
                0.5 * Math.sin(z * 2.6 - Math.cos(x * 2.1) * 1.4);
        var f = 1 + n * amp + ((y - LAND_Y) / span - 0.35) * rel;
        if (f < 0.75) f = 0.75; else if (f > 1.25) f = 1.25;
        gc[i] *= f; gc[i + 1] *= f; gc[i + 2] *= f;
      }
    })();

    var topGeo = new THREE.BufferGeometry();
    topGeo.setAttribute('position', new THREE.Float32BufferAttribute(gp, 3));
    topGeo.setAttribute('color', new THREE.Float32BufferAttribute(gc, 3));
    topGeo.computeVertexNormals();
    var groundMat = mat(0xffffff, false, true);
    groundMat.vertexColors = true;
    var groundTop = new THREE.Mesh(topGeo, groundMat);
    groundTop.receiveShadow = true;
    groundTop.castShadow = true;
    group.add(groundTop);
    if (rimP.length) {
      var rimGeo = new THREE.BufferGeometry();
      rimGeo.setAttribute('position', new THREE.Float32BufferAttribute(rimP, 3));
      rimGeo.setAttribute('normal', new THREE.Float32BufferAttribute(rimN, 3));
      var rimMesh = new THREE.Mesh(rimGeo, mat(C.base, false, false));
      rimMesh.receiveShadow = true;
      rimMesh.castShadow = true;
      group.add(rimMesh);
    }
    if (window.console) {
      console.info('[mm] ground: ' + (gp.length / 9) + ' tris on a ' + GN + '\u00b2 grid (' +
        cellM.toFixed(1) + ' m cells)' + (isGreenBase ? ', ' +
        Math.round(greenCells / Math.max(1, GN * GN * 0.785) * 100) + '% green' : ''));
    }

    /* The base disc. */
    var plate = new THREE.Mesh(new THREE.CylinderGeometry(R, R, baseT, 256), mat(C.base, false));
    plate.position.y = FLOOR_Y - baseT / 2;
    plate.receiveShadow = true;
    plate.castShadow = true;
    group.add(plate);

    /* Anything laid on the ground. Over water it is pushed just under the
       sheet, so a road along a quay stops at the shore. */
    function drape(geo, lift) {
      var pa = geo.attributes.position;
      for (var i = 0; i < pa.count; i++) {
        var dx2 = pa.getX(i), dz2 = pa.getZ(i);
        pa.setY(i, isWaterAt(dx2, dz2) ? waterLevelAt(dx2, dz2) - mm(0.2) : terrainAt(dx2, dz2) + lift);
      }
      geo.computeVertexNormals();
      return geo;
    }

    /* Circle clipping for footprints (convex polygon clip in plate space) and
       for lines (roads, rails, bridges). */
    var CIRC = [];
    (function () {
      var n = 160, rr = R * 0.998;
      for (var i = 0; i < n; i++) {
        var a = (i / n) * Math.PI * 2;
        CIRC.push([Math.cos(a) * rr, Math.sin(a) * rr]);
      }
    })();
    function clipLocalRingToCircle(pts) {
      var out = pts.slice();
      if (out.length > 1 && out[0][0] === out[out.length - 1][0] && out[0][1] === out[out.length - 1][1]) out.pop();
      for (var e = 0; e < CIRC.length && out.length; e++) {
        var A = CIRC[e], B = CIRC[(e + 1) % CIRC.length], inp = out; out = [];
        var ex = B[0] - A[0], ez = B[1] - A[1];
        for (var k = 0; k < inp.length; k++) {
          var P = inp[k], Q = inp[(k + 1) % inp.length];
          var dp = ex * (P[1] - A[1]) - ez * (P[0] - A[0]);
          var dq = ex * (Q[1] - A[1]) - ez * (Q[0] - A[0]);
          if (dp >= 0) out.push(P);
          if ((dp >= 0) !== (dq >= 0)) {
            var t = dp / (dp - dq);
            out.push([P[0] + (Q[0] - P[0]) * t, P[1] + (Q[1] - P[1]) * t]);
          }
        }
      }
      if (out.length < 3) return null;
      out.push(out[0]);
      return out;
    }
    function clipRingsToCircle(rs) {
      var locs = rs.map(function (r) { return r.map(function (p) { return toLocal(p[0], p[1]); }); });
      var allIn = true, anyNear = false;
      for (var i = 0; i < locs[0].length; i++) {
        var d = Math.hypot(locs[0][i][0], locs[0][i][1]);
        if (d > R * 0.997) allIn = false;
        if (d < R * 1.2) anyNear = true;
      }
      if (allIn) return rs;
      if (!anyNear) return null;
      var outer = clipLocalRingToCircle(locs[0]);
      if (!outer) return null;
      var res = [outer.map(function (p) { return toLonLat(p[0], p[1]); })];
      for (var h = 1; h < locs.length; h++) {
        var hr = clipLocalRingToCircle(locs[h]);
        if (hr) res.push(hr.map(function (p) { return toLonLat(p[0], p[1]); }));
      }
      return res;
    }
    function clipLineToCircle(pts, rr) {
      rr = rr || R * 0.998;
      var runs = [], cur = [];
      function inside(p) { return p[0] * p[0] + p[1] * p[1] <= rr * rr; }
      function hit(P, Q) {
        var dx = Q[0] - P[0], dz = Q[1] - P[1];
        var A = dx * dx + dz * dz, B = 2 * (P[0] * dx + P[1] * dz), Cc = P[0] * P[0] + P[1] * P[1] - rr * rr;
        var disc = B * B - 4 * A * Cc;
        if (disc < 0 || A === 0) return [];
        var sq = Math.sqrt(disc), t1 = (-B - sq) / (2 * A), t2 = (-B + sq) / (2 * A), out = [];
        if (t1 > 0 && t1 < 1) out.push(t1);
        if (t2 > 0 && t2 < 1) out.push(t2);
        return out.map(function (t) { return [P[0] + dx * t, P[1] + dz * t]; });
      }
      for (var i = 0; i < pts.length; i++) {
        var P = pts[i];
        if (i === 0) { if (inside(P)) cur.push(P); continue; }
        var Pr = pts[i - 1], inP = inside(Pr), inQ = inside(P), xs = hit(Pr, P);
        if (inP && inQ) { cur.push(P); }
        else if (inP && !inQ) { if (xs[0]) cur.push(xs[0]); if (cur.length > 1) runs.push(cur); cur = []; }
        else if (!inP && inQ) { cur = [xs[0] || P, P]; }
        else if (xs.length === 2) { runs.push([xs[0], xs[1]]); }
      }
      if (cur.length > 1) runs.push(cur);
      return runs;
    }

    /* Shape geometry is built in the XY plane and every caller then applies
       rotateX(-PI/2), which maps shape-Y onto scene MINUS Z. Roads and trees
       never pass through that rotation -- they are written straight to
       (x, 0, z) from toLocal. Without the negation below, buildings and grass
       came out mirrored north-south against the roads and trees they are meant
       to sit between, which is exactly the two-groups-on-different-axes effect.

       Rings are also walked in reverse. Negating one axis flips a polygon's
       winding; reversing the point order flips it back, so outer rings and
       holes keep the orientation ExtrudeGeometry expects. */
    function shapeOf(rs) {
      var outer = rs[0], n = outer.length;
      var s0 = new THREE.Shape();
      var p0 = toLocal(outer[n - 1][0], outer[n - 1][1]);
      s0.moveTo(p0[0], -p0[1]);
      for (var i = n - 2; i >= 0; i--) {
        var p = toLocal(outer[i][0], outer[i][1]);
        s0.lineTo(p[0], -p[1]);
      }
      for (var h = 1; h < rs.length; h++) {
        var ring = rs[h];
        if (!ring || ring.length < 4) continue;
        var m = ring.length;
        var path = new THREE.Path();
        var q0 = toLocal(ring[m - 1][0], ring[m - 1][1]);
        path.moveTo(q0[0], -q0[1]);
        for (var k = m - 2; k >= 0; k--) {
          var q = toLocal(ring[k][0], ring[k][1]);
          path.lineTo(q[0], -q[1]);
        }
        s0.holes.push(path);
      }
      return s0;
    }

    /* `level` forces every vertex to one height instead of draping the shape
       over the ground. Water needs it: the terrain is quantised into bands, so
       draping the sea across it steps the sea, and a flat surface split into
       several polygons then meets at different heights -- which is the row of
       horizontal lines running across open water. Standing water is level by
       definition, and no amount of tidying the polygons fixes a surface that
       is genuinely at different heights in different places. */
    function flatLayer(items, colour, y, cap, override, level) {
      var mm2 = override || mat(colour, true, true), n = 0;
      items.slice(0, cap).forEach(function (o) {
        var rs = o.rings || [o.ring];
        if (!rs[0] || rs[0].length < 4) return;
        var g;
        try { g = new THREE.ShapeGeometry(shapeOf(rs)); } catch (e) { return; }
        g.rotateX(-Math.PI / 2);
        if (level != null) {
          var pa2 = g.attributes.position;
          for (var q2 = 0; q2 < pa2.count; q2++) pa2.setY(q2, level);
          g.computeVertexNormals();
        } else {
          drape(g, y);
        }
        var mesh = new THREE.Mesh(g, mm2);
        mesh.receiveShadow = true;   // parks and water were catching nothing
        group.add(mesh);
        n++;
      });
      return n;
    }

    var greenCount = 0;   // green is painted into the ground mesh now

    /* Ordinary roads go UNDER the water, bridges go over it. That way a road
       running along a quay stops at the shoreline instead of streaking across
       the river, while the bridges that genuinely cross it still read. */
    var roadMat = mat(C.road, true, true);
    var roadPos = [];

    /* Every road used to be a run of detached quads with square ends. Three
       artefacts came out of that, and together they are most of what looked
       like roads sitting in the wrong place: a wedge-shaped hole on the OUTSIDE
       of every bend, a notch wherever one way ends against another, and square
       butt ends poking past junctions. Mitring the joins and capping the ends
       closes all three. */
    function ribbonInto(into, pts, w, edgesOut) {
      var h = w / 2, n = pts.length;
      if (n < 2) return;

      // unit direction of each segment; degenerate ones inherit their neighbour
      var seg = [], k;
      for (k = 0; k < n - 1; k++) {
        var dx = pts[k + 1][0] - pts[k][0], dz = pts[k + 1][1] - pts[k][1];
        var len = Math.hypot(dx, dz);
        seg.push(len < 1e-9 ? null : [dx / len, dz / len]);
      }
      var carryDir = null;
      for (k = 0; k < seg.length; k++) { if (seg[k]) carryDir = seg[k]; else seg[k] = carryDir; }
      for (k = seg.length - 1; k >= 0; k--) { if (!seg[k]) seg[k] = seg[k + 1] || null; }
      if (!seg[0]) return;

      var L = [], R = [];
      for (k = 0; k < n; k++) {
        var a = seg[Math.max(0, k - 1)], b = seg[Math.min(seg.length - 1, k)];
        var mx = -(a[1] + b[1]), mz = a[0] + b[0];
        var ml = Math.hypot(mx, mz);
        if (ml < 1e-9) { mx = -a[1]; mz = a[0]; ml = 1; }
        mx /= ml; mz /= ml;
        // the miter runs away to infinity on a hairpin, so clamp its length
        // 0.28 let a corner run out to 3.6x the half-width, which spiked roads
      // into the houses on every tight cul-de-sac bend. 0.62 caps it near
      // 1.6x, the usual bevel threshold.
      var cosH = Math.max(0.62, mx * -a[1] + mz * a[0]);
        var sc = h / cosH;
        L.push([pts[k][0] + mx * sc, pts[k][1] + mz * sc]);
        R.push([pts[k][0] - mx * sc, pts[k][1] - mz * sc]);
      }
      /* The mitred left and right edges, handed back on request. A bridge needs
         exactly these to stand its side walls on, and recomputing them would
         mean a second, subtly different mitre. */
      if (edgesOut) edgesOut.push({ L: L, R: R });
      for (k = 0; k < n - 1; k++) {
        into.push(L[k][0], 0, L[k][1], L[k + 1][0], 0, L[k + 1][1], R[k + 1][0], 0, R[k + 1][1]);
        into.push(L[k][0], 0, L[k][1], R[k + 1][0], 0, R[k + 1][1], R[k][0], 0, R[k][1]);
      }

      // round cap at each end: fills the notch where a way meets another way
      var ends = [pts[0], pts[n - 1]];
      for (var ei = 0; ei < 2; ei++) {
        var c = ends[ei];
        for (var q = 0; q < 8; q++) {
          var a1 = (q / 8) * Math.PI * 2, a2 = ((q + 1) / 8) * Math.PI * 2;
          into.push(c[0], 0, c[1],
                    c[0] + Math.cos(a1) * h, 0, c[1] + Math.sin(a1) * h,
                    c[0] + Math.cos(a2) * h, 0, c[1] + Math.sin(a2) * h);
        }
      }
    }

    /* Same for roads: a truncated motorway looks far worse than a missing
       service lane, so rank by how much of the model each one occupies. */
    var ROAD_CAP = 9000;
    var roadList = (data.roads || []);
    if (roadList.length > ROAD_CAP) {
      roadList = roadList.slice().sort(function (x, y) {
        function len(l) {
          var d = 0;
          for (var q = 0; q < l.length - 1; q++) {
            d += Math.hypot(l[q + 1][0] - l[q][0], l[q + 1][1] - l[q][1]);
          }
          return d;
        }
        return (y.width * len(y.line)) - (x.width * len(x.line));
      }).slice(0, ROAD_CAP);
    }
    var bridgeList = [];
    roadList.forEach(function (o) {
      var w = Math.max(o.width / mPerUnit, mm(0.45));
      clipLineToCircle(o.line.map(function (p) { return toLocal(p[0], p[1]); }), R - w / 2)
        .forEach(function (line) {
          line = densify(line);
          if (o.bridge) bridgeList.push({ line: line, w: w });
          else landRuns(line).forEach(function (run) { ribbonInto(roadPos, run, w); });
        });
    });

    /* A bridge is not a stripe of tarmac painted across the river. Drawn as a
       flat ribbon it reads as exactly that -- and it would not print either: a
       surface hanging in the air with nothing under it. Given sides that drop to
       the water it becomes a raised solid, which is what a bridge looks like
       from above and what a nozzle can actually lay down.

       Vertices carry their own height rather than going through drape(), which
       flattens everything it touches to a single lift. Terrain is still
       followed, so a bridge over a valley rides the ground beneath it. */
    function bridgeSolids(items, topLift, botLift, material) {
      if (!items.length) return;
      /* Belt and braces after the LIFT_TO bug: a height that is not a real
         number would fill the mesh with NaN, and a single NaN vertex takes the
         whole render down inside three.js, not just this shape. */
      if (!isFinite(topLift) || !isFinite(botLift)) {
        if (window.console) console.error('[mm] bridgeSolids: bad lift ' + topLift + '/' + botLift + ' -- skipped');
        return;
      }
      var pos = [];
      function vert(p, lift) { pos.push(p[0], terrainAt(p[0], p[1]) + lift, p[1]); }
      function tri(a, la, b, lb, c, lc) { vert(a, la); vert(b, lb); vert(c, lc); }
      function wall(e, k, hi, lo) {          // one quad of side wall
        tri(e[k], hi, e[k + 1], hi, e[k + 1], lo);
        tri(e[k], hi, e[k + 1], lo, e[k], lo);
      }

      items.forEach(function (it) {
        var edges = [], scratch = [];
        ribbonInto(scratch, it.line, it.w, edges);
        if (!edges.length) return;
        var L = edges[0].L, R = edges[0].R;
        if (L.length < 2) return;

        for (var k = 0; k < L.length - 1; k++) {
          // deck
          tri(L[k], topLift, L[k + 1], topLift, R[k + 1], topLift);
          tri(L[k], topLift, R[k + 1], topLift, R[k], topLift);
          /* Underside. Never seen, but without it the mesh is an open shell
             and a slicer has no idea what is inside the bridge and what is
             outside -- which is the difference between a solid deck and a
             sheet of paper standing on two walls. */
          tri(L[k], botLift, R[k + 1], botLift, L[k + 1], botLift);
          tri(L[k], botLift, R[k], botLift, R[k + 1], botLift);
          // the two sides, which are the whole point
          wall(L, k, topLift, botLift);
          wall(R, k, topLift, botLift);
        }
        // close each end, so the deck reads as solid where it meets the bank
        var last = L.length - 1;
        tri(L[0], topLift, R[0], topLift, R[0], botLift);
        tri(L[0], topLift, R[0], botLift, L[0], botLift);
        tri(L[last], topLift, R[last], topLift, R[last], botLift);
        tri(L[last], topLift, R[last], botLift, L[last], botLift);
      });

      if (!pos.length) return;
      var g = new THREE.BufferGeometry();
      g.setAttribute('position', new THREE.Float32BufferAttribute(pos, 3));
      g.computeVertexNormals();
      var m = new THREE.Mesh(g, material || roadMat);
      m.castShadow = true;        // a bridge that casts nothing floats
      m.receiveShadow = true;
      group.add(m);
    }

    function addRibbon(pos, lift) {
      if (!pos.length) return;
      var g = new THREE.BufferGeometry();
      g.setAttribute('position', new THREE.Float32BufferAttribute(pos, 3));
      drape(g, lift);
      var useMat = roadMat;
      /* Build 1.2 tinted Meadow streets by density (light lanes, grey city
         channels). Build 2.2: streets print in the bone building material, so
         they are drawn in it -- bone on tan reads without any tint. */
      if (false) {
        var pa3 = g.attributes.position, rc = new Float32Array(pa3.count * 3);
        var cLite = new THREE.Color(0xEDE9E1), cCity = new THREE.Color(0xBAB6AE), cc = new THREE.Color();
        for (var rv = 0; rv < pa3.count; rv++) {
          var ri = Math.min(GN - 1, Math.max(0, Math.floor((pa3.getX(rv) + half) / GC)));
          var rj = Math.min(GN - 1, Math.max(0, Math.floor((pa3.getZ(rv) + half) / GC)));
          var dd = densityAt(ri, rj), tt = dd <= 0.14 ? 0 : dd >= 0.34 ? 1 : (dd - 0.14) / 0.2;
          cc.copy(cLite).lerp(cCity, tt);
          rc[rv * 3] = cc.r; rc[rv * 3 + 1] = cc.g; rc[rv * 3 + 2] = cc.b;
        }
        g.setAttribute('color', new THREE.BufferAttribute(rc, 3));
        useMat = mat(0xffffff, true, true);
        useMat.vertexColors = true;
      }
      var rmesh2 = new THREE.Mesh(g, useMat);
      rmesh2.receiveShadow = true;   // streets were catching nothing either
      group.add(rmesh2);
    }

    addRibbon(roadPos, mm(0.38));

    /* ======================= DETAIL LAYER · BUILD 2 ========================
       The fine lines that make a model look surveyed rather than sketched:
       footpaths through parks and along the shore, tracks across fields,
       jetties and pontoons in the harbour, breakwaters, walls. */
    (function () {
      var pathPos = [], pathBridges = [];
      (data.paths || []).slice(0, 12000).forEach(function (o) {
        var w = Math.max(o.width / mPerUnit, mm(0.22));
        clipLineToCircle(o.line.map(function (p) { return toLocal(p[0], p[1]); }), R - w / 2)
          .forEach(function (line) {
            line = densify(line);
            if (o.bridge) pathBridges.push({ line: line, w: w });
            else landRuns(line).forEach(function (run) { ribbonInto(pathPos, run, w); });
          });
      });
      if (pathPos.length) {
        var pg = new THREE.BufferGeometry();
        pg.setAttribute('position', new THREE.Float32BufferAttribute(pathPos, 3));
        drape(pg, mm(0.22));
        var pm = mat(C.road, true, true);
        var pmesh = new THREE.Mesh(pg, pm);
        pmesh.receiveShadow = true;
        group.add(pmesh);
      }
      if (pathBridges.length) bridgeSolids(pathBridges, mm(1.2), mm(0.4));

      /* Build 2.1: streams, laid on the ground in the water colour. */
      var streamPos = [];
      thinWays.forEach(function (o) {
        clipLineToCircle(o.line, R - o.w / 2).forEach(function (line) {
          landRuns(densify(line)).forEach(function (run) { ribbonInto(streamPos, run, o.w); });
        });
      });
      if (streamPos.length) {
        var sgeo = new THREE.BufferGeometry();
        sgeo.setAttribute('position', new THREE.Float32BufferAttribute(streamPos, 3));
        drape(sgeo, mm(0.08));
        var smesh = new THREE.Mesh(sgeo, spec.mirrorWater ? mirrorMat(true) : mat(C.water, true, true));
        smesh.receiveShadow = true;
        group.add(smesh);
      }

      var pierMat = mat(C.bld, true, true);
      var decks = [], breaks = [];
      (data.pierLines || []).slice(0, 3000).forEach(function (o) {
        var w = Math.max(o.width / mPerUnit, mm(o.kind === 'pier' ? 0.3 : 0.45));
        clipLineToCircle(o.line.map(function (p) { return toLocal(p[0], p[1]); }), R - w / 2)
          .forEach(function (line) {
            (o.kind === 'pier' ? decks : breaks).push({ line: densify(line), w: w });
          });
      });
      if (decks.length) bridgeSolids(decks, mm(0.6), -mm(0.25), pierMat);
      if (breaks.length) bridgeSolids(breaks, mm(1.1), -mm(0.25), pierMat);

      var walls = [], cityWalls = [];
      (data.walls || []).slice(0, 8000).forEach(function (o) {
        var L = 0, pts = o.line.map(function (p) { return toLocal(p[0], p[1]); });
        for (var i = 1; i < pts.length; i++) L += Math.hypot(pts[i][0] - pts[i - 1][0], pts[i][1] - pts[i - 1][1]);
        if (L * mPerUnit < 20 && o.kind === 'wall') return;   // garden walls: only the long ones
        var city = o.kind === 'city_wall';
        var w = Math.max((city ? 3 : 0.6) / mPerUnit, mm(city ? 0.35 : 0.2));
        clipLineToCircle(pts, R - w / 2).forEach(function (line) {
          (city ? cityWalls : walls).push({ line: densify(line), w: w });
        });
      });
      var wallMat = mat(C.bld, true, true);
      if (walls.length) bridgeSolids(walls, mm(0.5), -mm(0.05), wallMat);
      /* Build 4.5: a walled town is bought BECAUSE of the wall, and at 8 m
         run through the lift it came out around 3 mm -- a bone ribbon lost
         against bone buildings. Dubrovnik's walls are 25 m in places, so 14 m
         is still under-stating them, and the floor keeps it readable on a
         small plate or a wide crop where the scale would otherwise bury it. */
      if (cityWalls.length) {
        var cwH = Math.max(mm(MM_T.cityWallMinMm || 2.4),
                           liftH(MM_T.cityWallM || 14) / mPerUnit);
        bridgeSolids(cityWalls, cwH, -mm(0.05), wallMat);
      }
      if (window.console) {
        console.info('[mm] detail: ' + (data.paths || []).length + ' path(s), ' +
          (data.pierLines || []).length + ' pier/breakwater line(s), ' + (data.piers || []).length +
          ' pier area(s), ' + walls.length + ' wall run(s), ' + cityWalls.length + ' city wall run(s)');
      }
    })();

    /* Track: a ballast bed with a darker rail line along it. Two ribbons rather
       than one, because what makes a railway recognisable from above is not its
       width -- it is that it runs dead straight through everything else at a
       constant width while the roads bend around. */
    (function () {
      var rails = data.rails || [];
      if (!rails.length) return;
      var bedPos = [], railPos = [];
      rails.slice(0, 3000).forEach(function (o) {
        /* Street trams and light rail run in the road; drawn as railway
           ballast they became brown channels through a city centre. */
        if (o.light) return;
        var bedW = Math.max((o.light ? 5.0 : 7.5) / mPerUnit, mm(0.7));
        clipLineToCircle(o.line.map(function (p) { return toLocal(p[0], p[1]); }), R - bedW / 2)
          .forEach(function (pts) {
            landRuns(densify(pts)).forEach(function (run) {
              ribbonInto(bedPos, run, bedW);
              ribbonInto(railPos, run, bedW * 0.42);
            });
          });
      });
      function emitRail(arr, colour, lift) {
        if (!arr.length) return;
        var g = new THREE.BufferGeometry();
        g.setAttribute('position', new THREE.Float32BufferAttribute(arr, 3));
        drape(g, lift);
        var m = new THREE.Mesh(g, mat(colour, true, true));
        m.receiveShadow = true;
        group.add(m);
      }
      emitRail(bedPos, isGreenBase ? C.road : 0xC4C0B8, mm(0.3));
      emitRail(railPos, isGreenBase ? C.bld : 0x9A968F, mm(0.45));
      if (window.console) {
        console.info('[mm] ' + rails.length + ' railway segment(s)');
      }
    })();
    /* =========================== WATER · BUILD 1 ==========================
       One flat sheet under the whole circle. The land was cut out of the same
       grid above it, so there is nothing that can step, seam or float. */
    var waterMat = spec.mirrorWater ? mirrorMat(true) : mat(C.water, true, true);
    var waterDisc = new THREE.Mesh(new THREE.CircleGeometry(R * 0.999, 256), waterMat);
    waterDisc.rotation.x = -Math.PI / 2;
    waterDisc.position.y = WATER_Y;
    waterDisc.receiveShadow = true;
    group.add(waterDisc);
    if (inlandPos.length) {
      var ig = new THREE.BufferGeometry();
      ig.setAttribute('position', new THREE.Float32BufferAttribute(inlandPos, 3));
      ig.computeVertexNormals();
      var im = new THREE.Mesh(ig, waterMat);
      im.receiveShadow = true;
      group.add(im);
    }

    /* Two thin lines following every shore a millimetre or two out, the way a
       nautical chart draws depth. Distance field from the land, contoured. */
    (function () {
      if (spec.mirrorWater) return;
      var BIG = 1e9, D = new Float32Array(NN * NN), anyLand = false, anyWater = false, k;
      for (k = 0; k < NN * NN; k++) {
        if (FN(k) < 0.5) { D[k] = 0; anyLand = true; }
        else { D[k] = BIG; if (ON[k] < 0.5) anyWater = true; }
      }
      if (!anyLand || !anyWater) return;
      var a1 = GC, a2 = GC * Math.SQRT2, i, j, v;
      for (j = 0; j < NN; j++) {
        for (i = 0; i < NN; i++) {
          k = j * NN + i; v = D[k];
          if (i > 0 && D[k - 1] + a1 < v) v = D[k - 1] + a1;
          if (j > 0) {
            if (D[k - NN] + a1 < v) v = D[k - NN] + a1;
            if (i > 0 && D[k - NN - 1] + a2 < v) v = D[k - NN - 1] + a2;
            if (i < NN - 1 && D[k - NN + 1] + a2 < v) v = D[k - NN + 1] + a2;
          }
          D[k] = v;
        }
      }
      for (j = NN - 1; j >= 0; j--) {
        for (i = NN - 1; i >= 0; i--) {
          k = j * NN + i; v = D[k];
          if (i < NN - 1 && D[k + 1] + a1 < v) v = D[k + 1] + a1;
          if (j < NN - 1) {
            if (D[k + NN] + a1 < v) v = D[k + NN] + a1;
            if (i < NN - 1 && D[k + NN + 1] + a2 < v) v = D[k + NN + 1] + a2;
            if (i > 0 && D[k + NN - 1] + a2 < v) v = D[k + NN - 1] + a2;
          }
          D[k] = v;
        }
      }
      var pos = [], hw = mm(0.08), y = WATER_Y + mm(0.015);
      function seg(ax, az, bx, bz) {
        var mx = (ax + bx) / 2, mz = (az + bz) / 2;
        if (mx * mx + mz * mz > R * R * 0.97) return;
        var mi = Math.floor((mx + half) / GC), mj = Math.floor((mz + half) / GC);
        if (mi < 0 || mj < 0 || mi >= GN || mj >= GN || (comp[mj * GN + mi] >= 0 && !seaCell[mj * GN + mi])) return;
        var dx = bx - ax, dz = bz - az, L = Math.hypot(dx, dz);
        if (L < 1e-9) return;
        var nx = -dz / L * hw, nz = dx / L * hw;
        pos.push(ax + nx, y, az + nz, bx + nx, y, bz + nz, bx - nx, y, bz - nz);
        pos.push(ax + nx, y, az + nz, bx - nx, y, bz - nz, ax - nx, y, az - nz);
      }
      [mm(1.1), mm(2.4)].forEach(function (lev) {
        for (var cj = 0; cj < GN; cj++) {
          for (var ci = 0; ci < GN; ci++) {
            var k0 = cj * NN + ci;
            var v0 = D[k0], v1 = D[k0 + 1], v2 = D[k0 + NN + 1], v3 = D[k0 + NN];
            var mn = Math.min(v0, v1, v2, v3), mx = Math.max(v0, v1, v2, v3);
            if (mn > lev || mx < lev || mx > BIG / 2) continue;
            var x0 = -half + ci * GC, z0 = -half + cj * GC, P = [];
            var C4 = [[x0, z0, v0], [x0 + GC, z0, v1], [x0 + GC, z0 + GC, v2], [x0, z0 + GC, v3]];
            for (var e = 0; e < 4; e++) {
              var A = C4[e], B = C4[(e + 1) % 4];
              if ((A[2] > lev) !== (B[2] > lev)) {
                var t = (lev - A[2]) / (B[2] - A[2]);
                P.push([A[0] + (B[0] - A[0]) * t, A[1] + (B[1] - A[1]) * t]);
              }
            }
            if (P.length >= 2) seg(P[0][0], P[0][1], P[1][0], P[1][1]);
            if (P.length === 4) seg(P[2][0], P[2][1], P[3][0], P[3][1]);
          }
        }
      });
      if (!pos.length) return;
      var g = new THREE.BufferGeometry();
      g.setAttribute('position', new THREE.Float32BufferAttribute(pos, 3));
      g.computeVertexNormals();
      var m = new THREE.Mesh(g, mat(shade(C.water, 0.8), false, true));
      m.receiveShadow = true;
      group.add(m);
    })();

    bridgeSolids(bridgeList, mm(2.4), mm(0.3));

    var marked = {};
    (spec.markers || []).forEach(function (mk) { marked[mk.osmWayId] = mk.colour; });
    /* grey stays in this lookup only so markers saved before it was withdrawn
       still render, and a shared link or cart line carrying it does not come
       back as an unmarked building. It is no longer offered in the picker. */
    var MC = { cream: 0xE8DEBD, blue: 0x7FB9DE, green: 0x5FBF7F, grey: 0x8A8A8A };

    /* Two-sided. A clipping plane cuts fragments, it does not cap the hole, so
       with front-face-only material every building sliced at the plate edge was
       an open shell -- you looked straight through the cut into the dark behind
       it, which is the "chewed" edge. Rendering back faces fills the cut so a
       half building reads as solid, the way it will actually print. */
    var bldMat = mat(C.bld, true, true);
    bldMat.roughness = 0.88;
    bldMat.envMapIntensity = MM_T.envIntensity;

    /* Two-tone: roof one colour, walls another. This is the single clearest
       difference between our buildings and the reference's. With one colour top
       and side, a cluster of houses merges into a pale smudge -- there is
       nothing telling the eye where one ends and the next begins, because the
       only separation is shading and at this scale the shading is tiny. Giving
       the up-facing faces their own tone separates every building from its
       neighbour and from the ground it stands on.

       Done with vertex colours off the face normal rather than two meshes, so
       it costs no extra draw calls and works on flat roofs and pitched ones
       alike. NOTE for production: this implies the roof is a second material on
       the plate. Set MM_T.twoToneBuildings to false to go back to one. */
    var bldMatVC = mat(0xffffff, true, true);
    bldMatVC.roughness = 0.88;
    bldMatVC.envMapIntensity = MM_T.envIntensity;
    bldMatVC.vertexColors = true;

    var ROOF_C = new THREE.Color(MM_T.roofColour);
    var WALL_C = new THREE.Color(C.bld);

    /* Build 4.2. The old two-tone painted roofs a different COLOUR, which
       claimed a second filament that is not on the plate -- that is why it was
       switched off. This paints the same colour at two brightnesses instead:
       an up-facing face is brighter because it faces the sky, which is true of
       the object in your hand, and it is the only thing that separates one
       roof from the next when the camera is straight down.
       On top of that each building carries its own slight lightness, so a
       block stops reading as one white mass. Deterministic from the OSM id, so
       the same place renders the same way every time. */
    function bldHash(id) {
      var h = (Math.imul(id | 0, 374761393) + 668265263) | 0;
      h = Math.imul(h ^ (h >>> 13), 1274126177);
      return ((h ^ (h >>> 16)) >>> 0) / 4294967296;
    }
    function paintFaces(geo, id) {
      var nrm = geo.attributes.normal, posA = geo.attributes.position;
      if (!nrm) { geo.computeVertexNormals(); nrm = geo.attributes.normal; }
      var tint = 1 + (bldHash(id == null ? 1 : id) - 0.5) * 2 * (MM_T.bldVariation || 0);
      var boost = MM_T.roofBoost || 1;
      var wr = WALL_C.r * tint, wg = WALL_C.g * tint, wb = WALL_C.b * tint;
      var col = new Float32Array(posA.count * 3);
      for (var i = 0; i < posA.count; i++) {
        var k = nrm.getY(i) > 0.5 ? boost : 1;
        col[i * 3] = Math.min(1, wr * k);
        col[i * 3 + 1] = Math.min(1, wg * k);
        col[i * 3 + 2] = Math.min(1, wb * k);
      }
      geo.setAttribute('color', new THREE.BufferAttribute(col, 3));
      return geo;
    }
    /* One entry point so both the whole-building and the building:part paths
       get the same treatment; a highlighted building keeps its solid colour. */
    function addBld(g, id, y) {
      var m = matFor(id);
      if (m === bldMat) { paintFaces(g, id); m = bldMatVC; }
      addBuildingMesh(g, m, y);
    }
    var markMats = {};
    var count = 0, tallest = 0;

    /* ---------------------------- gabled roofs ---------------------------- */
    /* Flat extrusions are why a residential crop reads as a field of blocks
       rather than houses. A terrace's ridge line running the length of the row
       is the strongest single cue that these are dwellings.

       Only applied where it is safe: the footprint has to genuinely fill its
       oriented bounding box, and be small enough to be a house. An L-shaped
       block or a supermarket keeps its flat roof, because a gable stretched
       over an OBB it doesn't fill would overhang into the street. */

    function orientedBox(ring) {
      // principal axis by covariance — cheaper than rotating calipers and
      // exact enough for the near-rectangular footprints this gates on
      var n = ring.length - 1, cx = 0, cz = 0, i;
      if (n < 3) return null;
      for (i = 0; i < n; i++) { cx += ring[i][0]; cz += ring[i][1]; }
      cx /= n; cz /= n;
      var sxx = 0, sxz = 0, szz = 0;
      for (i = 0; i < n; i++) {
        var dx = ring[i][0] - cx, dz = ring[i][1] - cz;
        sxx += dx * dx; sxz += dx * dz; szz += dz * dz;
      }
      var theta = 0.5 * Math.atan2(2 * sxz, sxx - szz);
      var ux = Math.cos(theta), uz = Math.sin(theta);
      var lo1 = Infinity, hi1 = -Infinity, lo2 = Infinity, hi2 = -Infinity;
      for (i = 0; i < n; i++) {
        var ex = ring[i][0] - cx, ez = ring[i][1] - cz;
        var a = ex * ux + ez * uz, b = -ex * uz + ez * ux;
        if (a < lo1) lo1 = a; if (a > hi1) hi1 = a;
        if (b < lo2) lo2 = b; if (b > hi2) hi2 = b;
      }
      var la = hi1 - lo1, lb = hi2 - lo2;
      if (!(la > 0) || !(lb > 0)) return null;
      // recentre on the box, not the centroid
      var ca = (lo1 + hi1) / 2, cb = (lo2 + hi2) / 2;
      return { cx: cx + ca * ux - cb * uz, cz: cz + ca * uz + cb * ux,
               ux: ux, uz: uz, la: la, lb: lb };
    }

    function ringArea2(ring) {
      var a = 0;
      for (var i = 0, j = ring.length - 1; i < ring.length; j = i++) {
        a += (ring[j][0] + ring[i][0]) * (ring[j][1] - ring[i][1]);
      }
      return Math.abs(a / 2);
    }

    /* Returns a gable prism sitting on top of the walls, or null when the
       footprint is not rectangular or house-sized enough to risk it. */
    function gableFor(ring, wallTop, roofH, shapeTag) {
      var box = orientedBox(ring);
      if (!box) return null;
      var fill = ringArea2(ring) / (box.la * box.lb);
      if (fill < 0.78) return null;                 // not rectangular enough

      // ridge runs along the LONG axis, slope across the short one
      var longU, shortU, halfLong, halfShort;
      if (box.la >= box.lb) {
        longU = [box.ux, box.uz]; shortU = [-box.uz, box.ux];
        halfLong = box.la / 2; halfShort = box.lb / 2;
      } else {
        longU = [-box.uz, box.ux]; shortU = [box.ux, box.uz];
        halfLong = box.lb / 2; halfShort = box.la / 2;
      }

      function P(alongLong, alongShort, y) {
        return [box.cx + longU[0] * alongLong + shortU[0] * alongShort, y,
                box.cz + longU[1] * alongLong + shortU[1] * alongShort];
      }

      /* A long terrace wants a gable running its length. A near-square block
         wants a hip, because a gable on a square building looks like a tent.
         Same six triangles either way -- the ridge just stops short of the ends,
         which turns the vertical gable ends into sloping hip faces. */
      if (shapeTag === 'flat') return null;
      var hip = shapeTag === 'hipped' || shapeTag === 'half-hipped' ||
                shapeTag === 'pyramidal' ||
                (!shapeTag && halfLong / halfShort < 1.6);
      var ridgeHalf = hip ? Math.max(halfLong - halfShort, 0) : halfLong;

      var top = wallTop + roofH;
      var a = P(-halfLong, -halfShort, wallTop), b = P(halfLong, -halfShort, wallTop);
      var c = P(halfLong,   halfShort, wallTop), d = P(-halfLong, halfShort, wallTop);
      var r0 = P(-ridgeHalf, 0, top), r1 = P(ridgeHalf, 0, top);

      var v = [];
      function tri(p, q, r) { v.push(p[0],p[1],p[2], q[0],q[1],q[2], r[0],r[1],r[2]); }
      /* Winding matters: bldMat is front-side only, so a triangle wound the
         wrong way is simply not drawn. Every face below is ordered so its
         normal comes out pointing up and away from the ridge. */
      tri(a, r1, b); tri(a, r0, r1);      // slope on one side
      tri(c, r0, d); tri(c, r1, r0);      // slope on the other
      tri(a, d, r0);                       // end: vertical for a gable,
      tri(b, r1, c);                       //      sloping for a hip
      var geo = new THREE.BufferGeometry();
      geo.setAttribute('position', new THREE.Float32BufferAttribute(v, 3));
      geo.computeVertexNormals();
      return geo;
    }

    /* Client-side caps must drop the LEAST important things, not the earliest
       ids. Sorting by footprint first means an over-dense crop loses sheds and
       garages rather than whole neighbourhoods. */
    var BLD_CAP = 14000;
    var bldList = (data.buildings || []);

    /* Ground cover now lives in the ground mesh (Build 1). */

    if (bldList.length > BLD_CAP) {
      bldList = bldList.slice().sort(function (x, y) {
        return ringArea2(y.rings[0]) - ringArea2(x.rings[0]);
      }).slice(0, BLD_CAP);
      if (window.console) {
        console.warn('[mm] ' + data.buildings.length +
                     ' buildings, kept the ' + BLD_CAP + ' largest');
      }
    }
    /* ========================= BUILDINGS · BUILD 2 =========================
       Heights: the lift is added to the first 12 m only, so a house gets the
       full exaggeration and a tower stays close to true scale.

       Parts: where OSM maps a building in slices (building:part), the slices
       are drawn and the plain outline is not -- podiums, setbacks, crowns and
       towers, each from its own bottom to its own top.

       Roofs: pitched roofs over ANY footprint, L-shapes and terraces included.
       The ridge runs along the building's own long walls, the roof is two
       true planes split along it, and every wall's top follows the roof so
       there is never a gap under the eaves. */
    function liftH(h) { return h + (EXAG - 1) * Math.min(Math.max(h, 0), LIFT_TO); }
    var PITCHED = { gabled: 1, hipped: 1, 'half-hipped': 1, gambrel: 1, mansard: 1,
                    saltbox: 1, pyramidal: 1, side_hipped: 1, round: 1, skillion: 1 };

    /* Smallest rectangle around the footprint, aligned to one of its own
       edges -- so a ridge runs parallel to the walls, as it does. */
    function minRect(r) {
      var n = r.length, best = null;
      for (var e = 0; e < n; e++) {
        var a = r[e], c = r[(e + 1) % n];
        var dx = c[0] - a[0], dz = c[1] - a[1], L = Math.hypot(dx, dz);
        if (L < 1e-9) continue;
        var ux = dx / L, uz = dz / L;
        var lo1 = Infinity, hi1 = -Infinity, lo2 = Infinity, hi2 = -Infinity;
        for (var i = 0; i < n; i++) {
          var p = r[i][0] * ux + r[i][1] * uz, q = -r[i][0] * uz + r[i][1] * ux;
          if (p < lo1) lo1 = p; if (p > hi1) hi1 = p;
          if (q < lo2) lo2 = q; if (q > hi2) hi2 = q;
        }
        var area = (hi1 - lo1) * (hi2 - lo2);
        if (!best || area < best.area) {
          var ca = (lo1 + hi1) / 2, cb = (lo2 + hi2) / 2;
          best = { area: area, cx: ca * ux - cb * uz, cz: ca * uz + cb * ux,
                   ux: ux, uz: uz, la: hi1 - lo1, lb: hi2 - lo2 };
        }
      }
      if (!best || !(best.la > 0) || !(best.lb > 0)) return null;
      if (best.lb > best.la) {       // make u the long axis
        var t = best.ux; best.ux = -best.uz; best.uz = t;
        t = best.la; best.la = best.lb; best.lb = t;
      }
      return best;
    }
    function pitchedGeo(ring, wallH, roofH, kind, boxIn) {
      var r = ring.slice();
      if (r.length > 1 && r[0][0] === r[r.length - 1][0] && r[0][1] === r[r.length - 1][1]) r.pop();
      if (r.length < 3) return null;
      var box = boxIn || minRect(r);
      if (!box) return null;
      var nx = -box.uz, nz = box.ux, hw = box.lb / 2, skill = kind === 'skillion';
      function sAt(p) { return (p[0] - box.cx) * nx + (p[1] - box.cz) * nz; }
      function yTop(p) {
        var s = sAt(p), t = skill ? (s + hw) / (2 * hw) : 1 - Math.abs(s) / hw;
        return wallH + roofH * (t < 0 ? 0 : t > 1 ? 1 : t);
      }
      var rr = [];
      for (var k = 0; k < r.length; k++) {
        var P = r[k], Q = r[(k + 1) % r.length];
        rr.push(P);
        if (!skill) {
          var sp = sAt(P), sq = sAt(Q);
          if (sp * sq < 0) {
            var tt = sp / (sp - sq);
            rr.push([P[0] + (Q[0] - P[0]) * tt, P[1] + (Q[1] - P[1]) * tt]);
          }
        }
      }
      var pos = [];
      for (var w = 0; w < rr.length; w++) {
        var A = rr[w], B = rr[(w + 1) % rr.length], ya = yTop(A), yb = yTop(B);
        pos.push(A[0], 0, A[1], B[0], 0, B[1], B[0], yb, B[1]);
        pos.push(A[0], 0, A[1], B[0], yb, B[1], A[0], ya, A[1]);
      }
      var halves = skill ? [rr]
        : [clipHalf(rr, box.cx, box.cz, nx, nz, true), clipHalf(rr, box.cx, box.cz, nx, nz, false)];
      for (var h = 0; h < halves.length; h++) {
        var hp = halves[h];
        if (hp.length < 3) continue;
        var tris;
        try { tris = THREE.ShapeUtils.triangulateShape(hp.map(function (p) { return new THREE.Vector2(p[0], p[1]); }), []); }
        catch (e) { tris = []; }
        for (var ti = 0; ti < tris.length; ti++) {
          var a = hp[tris[ti][0]], b2 = hp[tris[ti][1]], c = hp[tris[ti][2]];
          pos.push(a[0], yTop(a), a[1], b2[0], yTop(b2), b2[1], c[0], yTop(c), c[1]);
        }
      }
      var g = new THREE.BufferGeometry();
      g.setAttribute('position', new THREE.Float32BufferAttribute(pos, 3));
      g.computeVertexNormals();
      return g;
    }
    function groundUnder(localRing) {
      var yMin = Infinity;
      for (var fv = 0; fv < localRing.length; fv++) {
        var gy = terrainAt(localRing[fv][0], localRing[fv][1]);
        if (gy < yMin) yMin = gy;
      }
      return (isFinite(yMin) ? yMin : LAND_Y) - mm(0.1);
    }
    /* Build 2.1: roofs. Three things made Build 2's roofs read as shards:
       irregular footprints were forced under one ridge, so every wing off the
       ridge line became a sloping blade; a terraced house took its ridge along
       its own depth, so a row became a row of teeth; and the lifted roof had no
       ceiling, so a steep one reached 56 degrees. The roof still takes the same
       lift as the walls -- without it a house is a tall box under a flat lid,
       tested -- but it is capped at 50 degrees and at 4 m of real roof. */
    var ROOF_SLOPE = 0.78;                        // untagged roofs, about 38 degrees before the lift
    var ROOF_MAX_SLOPE = Math.tan(50 * D2R);      // nothing steeper than 50 once lifted
    var ROOF_MAX_M = 4;                           // untagged roof, real metres
    var ROOF_MIN_FILL = 0.82;                     // footprint area / its rectangle
    var AUTO_PITCH_MAX_M = 12;                    // untagged: up to about four storeys
    var ridgesTurned = 0, flatByShape = 0;

    function roofFor(box, totalU, roofTagM) {
      var hwM = box.lb * mPerUnit / 2;
      var realM = roofTagM > 0 ? roofTagM : Math.min(hwM * ROOF_SLOPE, ROOF_MAX_M);
      var liftM = Math.min(realM * EXAG, hwM * ROOF_MAX_SLOPE);
      return Math.min(liftM / mPerUnit, totalU * 0.5);
    }

    /* Shared walls. A footprint edge lying on a neighbour's edge is a party
       wall, and a roof ridge runs across party walls, not along them -- which
       is what lines a terrace up under one continuous ridge. */
    var SW_TOL = 0.6 / mPerUnit, SW_MIN = 2 / mPerUnit, SW_CELL = 12 / mPerUnit;
    var swHash = {};
    function swEach(ring, fn) {
      for (var i = 0; i + 1 < ring.length; i++) {
        var A = ring[i], B = ring[i + 1];
        var dx = B[0] - A[0], dz = B[1] - A[1], L = Math.hypot(dx, dz);
        if (L >= SW_MIN) fn(A, B, dx / L, dz / L, L);
      }
    }
    function swCells(A, B, fn) {
      var i0 = Math.floor(Math.min(A[0], B[0]) / SW_CELL), i1 = Math.floor(Math.max(A[0], B[0]) / SW_CELL);
      var j0 = Math.floor(Math.min(A[1], B[1]) / SW_CELL), j1 = Math.floor(Math.max(A[1], B[1]) / SW_CELL);
      for (var i = i0; i <= i1; i++) for (var j = j0; j <= j1; j++) fn(i + ',' + j);
    }
    function swIndex(list) {
      list.forEach(function (o, bi) {
        if (!o.rings || !o.rings[0]) return;
        o._sw = bi;
        var loc = o.rings[0].map(function (pt) { return toLocal(pt[0], pt[1]); });
        swEach(loc, function (A, B) {
          var e = { b: bi, A: A, B: B };
          swCells(A, B, function (k) { (swHash[k] || (swHash[k] = [])).push(e); });
        });
      });
    }
    function sharedDir(ring, bi) {
      var best = 0, dir = null;
      swEach(ring, function (A, B, ux, uz, L) {
        var got = 0, seen = [];
        swCells(A, B, function (k) {
          var list = swHash[k];
          if (!list) return;
          for (var n = 0; n < list.length; n++) {
            var e = list[n];
            if (e.b === bi || seen.indexOf(e) >= 0) continue;
            seen.push(e);
            var vx = e.B[0] - e.A[0], vz = e.B[1] - e.A[1], Lv = Math.hypot(vx, vz);
            if (Math.abs((ux * vx + uz * vz) / Lv) < 0.99) continue;
            var d1 = (e.A[0] - A[0]) * -uz + (e.A[1] - A[1]) * ux;
            var d2 = (e.B[0] - A[0]) * -uz + (e.B[1] - A[1]) * ux;
            if (Math.abs(d1) > SW_TOL || Math.abs(d2) > SW_TOL) continue;
            var t1 = (e.A[0] - A[0]) * ux + (e.A[1] - A[1]) * uz;
            var t2 = (e.B[0] - A[0]) * ux + (e.B[1] - A[1]) * uz;
            var ov = Math.min(L, Math.max(t1, t2)) - Math.max(0, Math.min(t1, t2));
            if (ov >= Math.max(1.5 / mPerUnit, 0.3 * Math.min(L, Lv))) got += ov;
          }
        });
        if (got > best) { best = got; dir = [ux, uz]; }
      });
      return dir;
    }
    /* The rectangle a roof is built on, turned to run across any party wall.
       null when the footprint is too far from a rectangle to carry one ridge. */
    function roofBox(localRing, bi) {
      var box = minRect(localRing);
      if (!box) return null;
      if (ringArea2(localRing) / (box.la * box.lb) < ROOF_MIN_FILL) { flatByShape++; return null; }
      var sd = bi != null ? sharedDir(localRing, bi) : null;
      if (sd && Math.abs(box.ux * sd[0] + box.uz * sd[1]) > 0.7) {
        var t = box.ux; box.ux = -box.uz; box.uz = t;
        t = box.la; box.la = box.lb; box.lb = t;
        ridgesTurned++;
      }
      return box;
    }
    function addBuildingMesh(g, use, y) {
      var mesh = new THREE.Mesh(g, use);
      mesh.position.y = y;
      mesh.castShadow = true;
      mesh.receiveShadow = true;
      group.add(mesh);
    }
    function matFor(id) {
      if (id != null && marked[id] != null) {
        var key = marked[id];
        if (!markMats[key]) markMats[key] = mat(MC[key], true);
        return markMats[key];
      }
      return bldMat;
    }

    /* Which outlines are drawn as parts instead. */
    var partList = (data.parts || []).slice(0, 25000), partsUsed = 0;
    if (partList.length) {
      var PB = {}, PBS = 0.0006;
      partList.forEach(function (p) {
        var r0 = p.rings[0], sx = 0, sy = 0, n = r0.length - 1;
        for (var i = 0; i < n; i++) { sx += r0[i][0]; sy += r0[i][1]; }
        p._c = [sx / n, sy / n];
        var key = Math.floor(p._c[0] / PBS) + ',' + Math.floor(p._c[1] / PBS);
        (PB[key] || (PB[key] = [])).push(p);
      });
      bldList.forEach(function (o) {
        var r0 = o.rings[0], lo0 = Infinity, lo1 = -Infinity, la0 = Infinity, la1 = -Infinity;
        for (var i = 0; i < r0.length; i++) {
          if (r0[i][0] < lo0) lo0 = r0[i][0]; if (r0[i][0] > lo1) lo1 = r0[i][0];
          if (r0[i][1] < la0) la0 = r0[i][1]; if (r0[i][1] > la1) la1 = r0[i][1];
        }
        for (var gx = Math.floor(lo0 / PBS); gx <= Math.floor(lo1 / PBS); gx++) {
          for (var gz = Math.floor(la0 / PBS); gz <= Math.floor(la1 / PBS); gz++) {
            var L = PB[gx + ',' + gz];
            if (!L) continue;
            for (var k = 0; k < L.length; k++) {
              if (L[k].parent == null && pointInRings(L[k]._c[0], L[k]._c[1], o.rings)) {
                L[k].parent = o.id; o.hasParts = true;
              }
            }
          }
        }
      });
      /* B7.1.1 (Kevin, 27 Oct): an outline is only swapped for its parts when
         the parts really stand on its footprint. OSM often maps just the dome
         or the tower of a big building as a part. Dublin's Custom House has one
         part, the dome, starting 20 m up, so the whole building vanished and
         the dome floated over an empty plot. Now parts that start at the ground
         must cover at least 60% of the outline's area; otherwise the outline is
         drawn as well, and the parts sit on it. */
      function netArea(rs) {
        var a = 0;
        for (var q = 0; q < rs.length; q++) {
          var r = rs[q], s = 0;
          for (var i = 0, j = r.length - 1; i < r.length; j = i++) {
            s += (r[j][0] + r[i][0]) * (r[j][1] - r[i][1]);
          }
          a += (q === 0 ? 1 : -1) * Math.abs(s / 2);
        }
        return a;
      }
      var PA = {}, keptOutlines = 0;
      partList.forEach(function (p) {
        if (p.parent == null || !(p.bot < 1)) return;
        PA[p.parent] = (PA[p.parent] || 0) + netArea(p.rings);
      });
      bldList.forEach(function (o) {
        if (!o.hasParts) return;
        var own = netArea(o.rings);
        if (own > 0 && (PA[o.id] || 0) < own * 0.6) { o.hasParts = false; keptOutlines++; }
      });
      if (keptOutlines && window.console) {
        console.info('[mm] ' + keptOutlines + ' outline(s) kept under parts that cover only part of them (domes, towers)');
      }
    }

    /* B7.4.0: landmarks (MM_LANDMARKS). The data's own footprint at the spot,
       when it has one, sets the exact centre and the turn, so the model lines
       up with the paths around it; otherwise its coordinates and usual turn.
       The model is built first: if anything fails, the map's own shapes stay. */
    var lmPlaced = [];
    MM_LANDMARKS.forEach(function (lm) {
      try {
        var c = toLocal(lm.lon, lm.lat), hb = lm.clearM / mPerUnit;
        if (Math.hypot(c[0], c[1]) > half + hb * 1.42) return;
        var ang = lm.turn * D2R, best = null, bestA = 0;
        bldList.forEach(function (o) {
          var r0 = (o.rings || [o.ring])[0];
          if (!r0 || r0.length < 4) return;
          var lr = r0.map(function (p) { return toLocal(p[0], p[1]); });
          var a = ringArea2(lr) * mPerUnit * mPerUnit;
          if (a < lm.footMinM2 || a > lm.footMaxM2) return;
          var bx = minRect(lr);
          if (!bx || Math.hypot(bx.cx - c[0], bx.cz - c[1]) * mPerUnit > 30) return;
          if (a > bestA) { bestA = a; best = bx; }
        });
        if (best) { c = [best.cx, best.cz]; ang = Math.atan2(-best.uz, best.ux); }
        var g = lm.geo(THREE, function (m) { return m / mPerUnit; },
                       function (m) { return liftH(m) / mPerUnit; }, mm);
        g.rotateY(ang);
        g.translate(c[0], 0, c[1]);
        var ca = Math.cos(ang), sa = Math.sin(ang), gone = 0, markId = null;
        var onBase = function (r0) {
          var sx = 0, sz = 0, n = r0.length - 1;
          for (var i = 0; i < n; i++) { var q = toLocal(r0[i][0], r0[i][1]); sx += q[0]; sz += q[1]; }
          var dx = sx / n - c[0], dz = sz / n - c[1];
          return Math.abs(dx * ca - dz * sa) <= hb && Math.abs(dx * sa + dz * ca) <= hb;
        };
        bldList.forEach(function (o) {
          var r0 = (o.rings || [o.ring])[0];
          if (!r0 || r0.length < 4 || !onBase(r0)) return;
          o._lm = true; gone++;
          if (markId == null && marked[o.id] != null) markId = o.id;
        });
        partList.forEach(function (p) {
          var r0 = p.rings && p.rings[0];
          if (r0 && r0.length >= 4 && onBase(r0)) { p._lm = true; gone++; }
        });
        lmPlaced.push({ lm: lm, g: g, x: c[0], z: c[1], id: markId, gone: gone, fromData: !!best });
      } catch (eL) {
        if (window.console) console.warn('[mm] landmark ' + lm.id + ' skipped:', eL && eL.message);
      }
    });

    var pitchedCount = 0;
    swIndex(bldList);
    bldList.forEach(function (o) {
      if (o.hasParts || o._lm) return;              // B7.4.0: _lm = under a landmark
      var rs = o.rings || [o.ring];
      if (!rs[0] || rs[0].length < 4) return;
      rs = clipRingsToCircle(rs);
      if (!rs || rs[0].length < 4) return;
      var totalU = Math.max(liftH(o.height) / mPerUnit, mm(0.8));
      var localRing = rs[0].map(function (pt) { return toLocal(pt[0], pt[1]); });
      var footArea = ringArea2(localRing) * mPerUnit * mPerUnit;
      var pitched = rs.length === 1 && footArea > 15 && (
        (o.roof && PITCHED[o.roof]) || (!o.roof && footArea < 450 && o.height <= AUTO_PITCH_MAX_M));
      var g = null;
      var box = pitched ? roofBox(localRing, o._sw) : null;
      if (box) {
        var roofU = roofFor(box, totalU, o.roofHeight);
        if (roofU > mm(0.15)) {
          g = pitchedGeo(localRing, totalU - roofU, roofU, o.roof, box);
          if (g) pitchedCount++;
        }
      }
      if (!g) {
        try { g = new THREE.ExtrudeGeometry(shapeOf(rs), { depth: totalU, bevelEnabled: false }); }
        catch (e) { return; }
        g.rotateX(-Math.PI / 2);
      }
      addBld(g, o.id, groundUnder(localRing));
      if (totalU > tallest) tallest = totalU;
      count++;
    });

    partList.forEach(function (p) {
      if (p._lm) return;                             // B7.4.0
      var rs = clipRingsToCircle(p.rings);
      if (!rs || rs[0].length < 4) return;
      var botU = liftH(p.bot) / mPerUnit;
      var topU = Math.max(liftH(p.top) / mPerUnit, botU + mm(0.3));
      var localRing = rs[0].map(function (pt) { return toLocal(pt[0], pt[1]); });
      var g = null;
      var pbox = rs.length === 1 && p.roof && PITCHED[p.roof] ? roofBox(localRing, null) : null;
      if (pbox) {
        var roofU = roofFor(pbox, topU - botU, p.roofHeight);
        if (roofU > mm(0.15)) g = pitchedGeo(localRing, topU - botU - roofU, roofU, p.roof, pbox);
      }
      if (!g) {
        try { g = new THREE.ExtrudeGeometry(shapeOf(rs), { depth: topU - botU, bevelEnabled: false }); }
        catch (e) { return; }
        g.rotateX(-Math.PI / 2);
      }
      addBld(g, p.parent != null ? p.parent : p.id, groundUnder(localRing) + botU);
      if (topU > tallest) tallest = topU;
      partsUsed++;
    });
    /* B7.4.0: the landmarks, in the building colour, on the lowest ground under
       their base. A building the visitor had marked keeps its marker colour. */
    lmPlaced.forEach(function (P) {
      try {
        var hw = P.lm.baseM / 2 / mPerUnit;
        var base = [[P.x - hw, P.z - hw], [P.x + hw, P.z - hw], [P.x + hw, P.z + hw],
                    [P.x - hw, P.z + hw], [P.x - hw, P.z - hw]];
        addBld(P.g, P.id, groundUnder(base));
        var topU = liftH(P.lm.heightM) / mPerUnit;
        if (topU > tallest) tallest = topU;
        count++;
        if (window.console) {
          console.info('[mm] landmark: ' + P.lm.name + ', ' + P.gone + ' map shape(s) on its base left out, ' +
            (P.fromData ? 'lined up on the map footprint' : 'placed by its coordinates'));
        }
      } catch (eP) {
        if (window.console) console.warn('[mm] landmark ' + P.lm.id + ' not drawn:', eP && eP.message);
      }
    });
    if (window.console) {
      console.info('[mm] buildings: ' + count + ' drawn (' + pitchedCount + ' pitched, ' +
        ridgesTurned + ' ridge(s) turned across party walls, ' + flatByShape +
        ' left flat as too irregular for one ridge), ' +
        partsUsed + ' building part(s) replacing ' +
        bldList.filter(function (o) { return o.hasParts; }).length + ' outline(s)');
    }

    /* ============================ TREES · BUILD 1 ==========================
       Where a tree goes is decided by evidence, most specific first:
         1. trees OSM has surveyed (nodes, tree rows, mapped woods)
         2. hedgerows, as rows of small trees -- what they look like from above
         3. ESA WorldCover tree cover, measured from satellites at 10 m, every
            place on earth: woods, shelter belts, hedgerows nobody mapped
         4. garden trees on built-up ground outside dense centres
       Never on water, a building or a road, never over the rim, and never
       closer than a few metres to another tree, so woods read as many trees
       rather than one dark mass. Round canopies in a living green, each tree
       a slightly different size and shade. */
    var treeCount = 0, greenCover = 0;
    (function () {
      /* B5.50: guarded -- if the new tree code ever throws, the model still
         renders, without trees, instead of the whole render failing. */
      try {
      if (!THREE.InstancedMesh || MM_T.trees === false) return;
      var MAXT = isNarrow() ? 22600 : 44000;   // B5.50: same phone triangle budget as before
      var canopy = Math.max(3.0 / mPerUnit, mm(0.5));
      var SEP = Math.max(3.4 / mPerUnit, canopy * 1.25);
      var rMask = new Uint8Array(GN * GN);
      (function () {
        var rp = [];
        (data.roads || []).slice(0, 9000).forEach(function (o) {
          ribbonInto(rp, o.line.map(function (p) { return toLocal(p[0], p[1]); }),
                     (o.width + 1.5) / mPerUnit);
        });
        (data.rails || []).slice(0, 3000).forEach(function (o) {
          ribbonInto(rp, o.line.map(function (p) { return toLocal(p[0], p[1]); }), 8 / mPerUnit);
        });
        (data.paths || []).slice(0, 12000).forEach(function (o) {
          ribbonInto(rp, o.line.map(function (p) { return toLocal(p[0], p[1]); }), (o.width + 1) / mPerUnit);
        });
        thinWays.forEach(function (o) { ribbonInto(rp, o.line, o.w + 1.5 / mPerUnit); });
        stampTris(rMask, rp, 1);
      })();
      function cellOf(x, z) {
        var i = Math.floor((x + half) / GC), j = Math.floor((z + half) / GC);
        if (i < 0 || j < 0 || i >= GN || j >= GN) return -1;
        return j * GN + i;
      }
      function hash2(a, c) {
        var h = (Math.imul(a | 0, 374761393) + Math.imul(c | 0, 668265263)) | 0;
        h = Math.imul(h ^ (h >>> 13), 1274126177);
        return ((h ^ (h >>> 16)) >>> 0) / 4294967296;
      }
      var buckets = {}, pts = [];
      function near(x, z, sep) {
        var bx = Math.floor(x / SEP), bz = Math.floor(z / SEP);
        for (var dx = -1; dx <= 1; dx++) {
          for (var dz = -1; dz <= 1; dz++) {
            var L = buckets[(bx + dx) + ',' + (bz + dz)];
            if (!L) continue;
            for (var k = 0; k < L.length; k += 2) {
              var ex = L[k] - x, ez = L[k + 1] - z;
              if (ex * ex + ez * ez < sep * sep) return true;
            }
          }
        }
        return false;
      }
      function add(x, z, s, sepMul) {
        if (pts.length / 3 >= MAXT) return false;
        var rr = R - canopy * s * 1.05;
        if (x * x + z * z > rr * rr) return false;
        var c = cellOf(x, z);
        if (c < 0 || bMask[c] || rMask[c]) return false;
        if (isWaterAt(x, z)) return false;
        if (near(x, z, SEP * (sepMul || 1))) return false;
        var key = Math.floor(x / SEP) + ',' + Math.floor(z / SEP);
        (buckets[key] || (buckets[key] = [])).push(x, z);
        pts.push(x, z, s);
        return true;
      }
      var n1 = 0, n2 = 0, n3 = 0, n4 = 0;
      (data.trees || []).slice(0, IS_TOUCH ? 40000 : 120000).forEach(function (t, i) {
        if (t[2] === 1 && LC && LC.at) {
          var lcc = LC.at(t[0], t[1]);
          if (lcc !== 10 && lcc !== 20 && lcc !== 95) return;
        }
        var lp = toLocal(t[0], t[1]);
        if (add(lp[0], lp[1], 0.85 + hash2(i, 7) * 0.4, 0.8)) n1++;
      });
      (data.hedges || []).slice(0, 5000).forEach(function (o, hi) {
        var L = o.line.map(function (p) { return toLocal(p[0], p[1]); });
        var step = 4.5 / mPerUnit;
        for (var k = 0; k < L.length - 1; k++) {
          var dx = L[k + 1][0] - L[k][0], dz = L[k + 1][1] - L[k][1], len = Math.hypot(dx, dz);
          for (var d = 0; d < len; d += step) {
            if (add(L[k][0] + dx * d / len, L[k][1] + dz * d / len,
                    0.62 + hash2(hi, k * 97 + Math.round(d * 1e3)) * 0.25, 0.7)) n2++;
          }
        }
      });
      if (LC && LC.grid && LC.n) {
        var LN = LC.n, lcW = PLATE / LN;
        var lcM = lcW * mPerUnit;
        var perGarden = (lcM * lcM) / 150;     // green gardens inside built-up ground
        var perStreet = (lcM * lcM) / 900;     // the odd street tree elsewhere
        /* B5.50: satellite forest is planted like a mapped wood -- a jittered
           grid at wood spacing, so canopies touch and a forest reads as forest
           instead of green speckle on pale grass. Its edge follows a smoothed
           (bilinear) cover field with a dithered threshold, not the grid's
           square cells. If the whole crop will not fit under the tree cap, the
           spacing (and tree size) grows evenly instead of one side filling and
           the rest going bald. */
        var lcTree = function (li, lj) {
          li = li < 0 ? 0 : (li >= LN ? LN - 1 : li);
          lj = lj < 0 ? 0 : (lj >= LN ? LN - 1 : lj);
          var c = LC.grid[lj * LN + li];
          return (c === 10 || c === 95) ? 1 : (c === 20 ? 0.35 : 0);
        };
        var coverAt = function (x, z) {
          var fx = (x + half) / lcW - 0.5, fz = (z + half) / lcW - 0.5;
          var i0 = Math.floor(fx), j0 = Math.floor(fz), tx = fx - i0, tz = fz - j0;
          return lcTree(i0, j0) * (1 - tx) * (1 - tz) + lcTree(i0 + 1, j0) * tx * (1 - tz) +
                 lcTree(i0, j0 + 1) * (1 - tx) * tz + lcTree(i0 + 1, j0 + 1) * tx * tz;
        };
        /* B5.51: tree cover within ~40 m of built-up ground is a city park or
           a leafy street, not a forest. St Stephen's Green came out as a solid
           pine wood under B5.50. There it is thinned to park spacing. */
        var urbanR = Math.max(1, Math.round(40 / Math.max(lcM, 1)));
        var urbanCell = new Uint8Array(LN * LN);
        /* ...and in a crop that is mostly city, ALL tree cover is park or
           street trees -- the middle of a big park included. */
        var builtShare = 0;
        for (var bk = 0; bk < LN * LN; bk++) if (LC.grid[bk] === 50) builtShare++;
        builtShare /= LN * LN;
        if (builtShare > 0.35) urbanCell.fill(1);
        for (var uj = 0; uj < LN; uj++) {
          for (var ui = 0; ui < LN; ui++) {
            if (LC.grid[uj * LN + ui] !== 50) continue;
            for (var dj = -urbanR; dj <= urbanR; dj++) {
              for (var di = -urbanR; di <= urbanR; di++) {
                var ni = ui + di, nj = uj + dj;
                if (ni >= 0 && nj >= 0 && ni < LN && nj < LN) urbanCell[nj * LN + ni] = 1;
              }
            }
          }
        }
        var URBAN_KEEP = 0.28;                 // ~ 8.5 m spacing instead of 4.5 m
        var coverCells = 0;
        for (var ck = 0; ck < LN * LN; ck++) {
          coverCells += lcTree(ck % LN, Math.floor(ck / LN)) * (urbanCell[ck] ? URBAN_KEEP : 1);
        }
        var coverArea = coverCells * lcW * lcW * 0.785;
        var room = Math.max(1, MAXT - pts.length / 3);
        var stepU = Math.max(4.5 / mPerUnit, SEP * 1.02);
        if (coverArea / (stepU * stepU) > room) stepU = Math.sqrt(coverArea / room) * 1.04;
        var grow = Math.min(1.6, Math.max(1, stepU * mPerUnit / 4.5));
        var gN = Math.ceil(PLATE / stepU);
        for (var gj = 0; gj <= gN; gj++) {
          for (var gi = 0; gi <= gN; gi++) {
            var px = -half + (gi + 0.5 + (hash2(gi, gj * 7 + 1) - 0.5) * 0.7) * stepU;
            var pz = -half + (gj + 0.5 + (hash2(gi * 13 + 5, gj) - 0.5) * 0.7) * stepU;
            var cv = coverAt(px, pz);
            if (cv <= 0) continue;
            if (cv < 0.999 && cv < 0.25 + hash2(gi * 31 + 3, gj * 17 + 9) * 0.5) continue;
            var uli = Math.floor((px + half) / lcW), ulj = Math.floor((pz + half) / lcW);
            if (uli >= 0 && ulj >= 0 && uli < LN && ulj < LN && urbanCell[ulj * LN + uli] &&
                hash2(gi * 7 + 11, gj * 5 + 3) > URBAN_KEEP) continue;
            if (add(px, pz, grow * (0.82 + hash2(gi, gj + 77) * 0.36), 0.9)) n3++;
          }
        }
        /* Gardens and the odd street tree on built-up ground: as before. */
        for (var lj = 0; lj < LN; lj++) {
          for (var li = 0; li < LN; li++) {
            var cls = LC.grid[lj * LN + li];
            if (!(isGreenBase && (cls === 30 || cls === 40 || cls === 50))) continue;
            var x0 = -half + li * lcW, z0 = -half + lj * lcW;
            var gi2 = Math.min(GN - 1, Math.floor((li + 0.5) * lcW / GC));
            var gj2 = Math.min(GN - 1, Math.floor((lj + 0.5) * lcW / GC));
            var built = gScore[gj2 * GN + gi2] < 0.5;
            var rate = (cls !== 50 && built) ? perGarden
                     : (cls === 50 && densityAt(gi2, gj2) < 0.42 ? perStreet : 0);
            if (rate <= 0) continue;
            var want = Math.floor(rate) + (hash2(li * 131 + 7, lj) < rate % 1 ? 1 : 0);
            for (var w = 0; w < want * 2 && want > 0; w++) {
              var hx = hash2(li * 7919 + w, lj * 104729 + 17);
              var hz = hash2(li * 104729 + 3, lj * 7919 + w * 31);
              if (add(x0 + hx * lcW, z0 + hz * lcW, 0.82 * (0.75 + hash2(li + w, lj - w) * 0.5))) {
                n4++;
                if (--want <= 0) break;
              }
            }
          }
        }
      }
      var placed = pts.length / 3;
      treeCount = placed;
      greenCover = isGreenBase ? greenCells / Math.max(1, GN * GN * 0.785) : 0;
      if (window.console) {
        console.info('[mm] trees: ' + placed + ' (' + n1 + ' surveyed, ' + n2 + ' hedgerow, ' +
                     n3 + ' from land cover, ' + n4 + ' garden)');
      }
      if (!placed) return;
      /* B5.50: a textured pine replaces the round blob (Kevin, 2 Oct: option D).
         Four star-shaped tiers with drooping tips and a short trunk, shaded dark
         at the bottom and light at the tips, flat-shaded so every facet catches
         the light. Three variants so a forest is not one tree repeated. 92
         triangles each, against 80 for the old blob. */
      function pineGeo(seedP, ramp) {
        var pos = [], col = [], sd = seedP >>> 0;
        function r() { sd = (sd * 1664525 + 1013904223) >>> 0; return sd / 4294967296; }
        var H = 3.2, tiers = 4, pts2 = 10, rad0 = 1.10, notch = 0.52, droop = 0.34,
            jit = 0.28, taper = 0.62, stack = 0.70, tierH = 0.50, trunk = 0.30;
        function shade(y) { var tt = Math.max(0, Math.min(1, y / H)); return ramp[0] + ramp[1] * tt; }
        function tri(p, q, u) {
          [p, q, u].forEach(function (v) {
            pos.push(v[0], v[1], v[2]);
            var k = shade(v[1]);
            col.push(k, k, k);
          });
        }
        for (var ti = 0; ti < tiers; ti++) {
          var f = ti / tiers;
          var yb = trunk + (H - trunk) * f * stack;
          var rad = rad0 * (1 - f * taper);
          var top = Math.min(H, yb + (H - trunk) * tierH * (1 - f * 0.25));
          var apex = [0, top, 0], twist = r() * Math.PI, rim = [];
          for (var ri = 0; ri < pts2 * 2; ri++) {
            var ang = twist + ri * Math.PI / pts2, outer = ri % 2 === 0;
            var rr = rad * (outer ? 1 : notch) * (1 + (r() - 0.5) * jit);
            var yy = yb - (outer ? droop * rad : 0) + (r() - 0.5) * jit * rad * 0.5;
            rim.push([Math.cos(ang) * rr, yy, Math.sin(ang) * rr]);
          }
          for (var rj = 0; rj < rim.length; rj++) tri(apex, rim[(rj + 1) % rim.length], rim[rj]);
        }
        var trR = rad0 * 0.13;
        for (var si = 0; si < 6; si++) {
          var a0 = si * Math.PI / 3, a1 = (si + 1) * Math.PI / 3;
          var p0 = [Math.cos(a0) * trR, 0, Math.sin(a0) * trR], p1 = [Math.cos(a1) * trR, 0, Math.sin(a1) * trR];
          var q0 = [p0[0], trunk + 0.3, p0[2]], q1 = [p1[0], trunk + 0.3, p1[2]];
          tri(p0, q1, p1); tri(p0, q0, q1);
        }
        var g = new THREE.BufferGeometry();
        g.setAttribute('position', new THREE.Float32BufferAttribute(pos, 3));
        g.setAttribute('color', new THREE.Float32BufferAttribute(col, 3));
        g.computeVertexNormals();
        g.scale(canopy, canopy, canopy);
        return g;
      }
      var RAMP = isGreenBase ? [0.72, 0.42] : [0.86, 0.20];
      var tm = mat(0xffffff, true);
      tm.roughness = 0.92;
      tm.flatShading = true;
      tm.vertexColors = true;
      tm.side = THREE.DoubleSide;
      var VARS = [9, 21, 37];
      var whichV = new Uint8Array(placed), perV = [0, 0, 0];
      for (var tq = 0; tq < placed; tq++) { whichV[tq] = Math.floor(hash2(tq, 91) * 3) % 3; perV[whichV[tq]]++; }
      var insts = VARS.map(function (sv, vi) {
        if (!perV[vi]) return null;
        var m = new THREE.InstancedMesh(pineGeo(sv, RAMP), tm, perV[vi]);
        m.castShadow = true;
        m.receiveShadow = true;
        return m;
      });
      var fill = [0, 0, 0];
      var dummy = new THREE.Object3D(), base = new THREE.Color(C.tree != null ? C.tree : C.grass);
      var tc = new THREE.Color(), light = new THREE.Color(0xffffff), dark = new THREE.Color(0x000000);
      var tv = MM_T.treeVariation != null ? MM_T.treeVariation : 1;
      for (var t = 0; t < placed; t++) {
        var x = pts[t * 3], z = pts[t * 3 + 1], s = pts[t * 3 + 2];
        /* Trunk base sunk a little, so trees on a slope do not float. */
        dummy.position.set(x, terrainAt(x, z) - canopy * s * 0.15, z);
        dummy.scale.set(s * (1 + (hash2(t, 41) - 0.5) * 0.22 * tv),
                        s * (0.86 + hash2(t, 3) * 0.54 * tv),
                        s * (1 + (hash2(t, 53) - 0.5) * 0.22 * tv));
        dummy.rotation.set((hash2(t, 71) - 0.5) * 0.1 * tv, hash2(t, 11) * Math.PI * 2,
                           (hash2(t, 73) - 0.5) * 0.1 * tv);
        dummy.updateMatrix();
        var vi = whichV[t], im = insts[vi], slot = fill[vi]++;
        im.setMatrixAt(slot, dummy.matrix);
        var v = hash2(t, 29);
        tc.copy(base);
        if (v < 0.5) tc.lerp(dark, (0.5 - v) * 0.34 * tv);
        else tc.lerp(light, (v - 0.5) * 0.26 * tv);
        tc.offsetHSL((hash2(t, 67) - 0.5) * 0.035 * tv, 0, 0);
        im.setColorAt(slot, tc);
      }
      insts.forEach(function (m) {
        if (!m) return;
        if (m.instanceColor) m.instanceColor.needsUpdate = true;
        group.add(m);
      });
      } catch (eT) {
        if (window.console) console.warn('[mm] trees skipped: ' + (eT && eT.message));
      }
    })();

    /* ===================== RING · B5.66 PREMIUM FRAMES ======================
       Kevin, 11 Oct: the frames are taller now, and the render draws the frame
       he actually prints. Each profile is the frame's cross-section, measured
       off his Bambu files:
         15 cm  MM-frame-15cm-PETG-premium-X1C-v2
         20 cm  MM-frame-20cm-PETG-premium-light-X1C
         40 cm  MM-frame-40cm-COMBO-quarterbase-print-x4-PETG-X1C -- printed as
                four quarters of one ring; drawn as the full ring they make.

       pts are [r, z] in real millimetres: r from the centre, z from the FRONT
       face (z = 0 is the face the viewer sees -- it prints on the bed, and the
       keyhole hanger is cut into the back at z = h). Walked counter-clockwise
       in (r, up): back chamfer, outer wall up to the front, front face inward,
       recess wall and 45 degree seat down to the inner ledge, back face out.
       That order is what makes three.js face every band outward.

       seat  = radius of the front recess the map sits in. Drawn at exactly R,
               so the map meets the frame with no gap; every other radius keeps
               its measured distance from the seat.
       proud = how far the front face stands above the lowest land. 15 / 20:
               the map disc's back rests on the 45 degree seat 3.5 mm in, and
               its lowest land is 2 mm above its back. 40: the base quarters'
               3 mm rim rests on the seat 6.6 mm in, the map quarters sit on
               the base, land 2 mm above that. If a real print sits differently,
               this one number per size is what to change. */
    var FRAME_PROFILES = {
      15: { seat: 75.3, h: 13, proud: 1.5,
            pts: [[86.28, 13], [86.88, 12.4], [85.3, 1], [84.3, 0], [75.8, 0],
                  [75.3, 0.5], [75.3, 3.2], [72.3, 6.2], [72.3, 13]] },
      20: { seat: 100.3, h: 16, proud: 1.5,
            pts: [[113.7, 16], [114.3, 15.4], [112.3, 1], [111.3, 0], [100.8, 0],
                  [100.3, 0.5], [100.3, 3.2], [97.3, 6.2], [97.3, 16]] },
      40: { seat: 200.6, h: 20, proud: 1.6,
            pts: [[222.6, 20], [223.2, 19.4], [220.6, 1], [219.6, 0], [201.1, 0],
                  [200.6, 0.5], [200.6, 6], [197.6, 9], [197.6, 20]] }
    };
    function frameProfileFor(cm) {
      if (FRAME_PROFILES[cm]) return FRAME_PROFILES[cm];
      /* An unlisted size borrows the nearest listed profile. The radii are
         offsets from the seat, so it still fits whatever plate it is given. */
      var keys = Object.keys(FRAME_PROFILES).map(Number), best = keys[0], i;
      for (i = 1; i < keys.length; i++) {
        if (Math.abs(keys[i] - cm) < Math.abs(best - cm)) best = keys[i];
      }
      return FRAME_PROFILES[best];
    }
    /* One LatheGeometry per straight edge of the profile, not one for the whole
       outline: a single lathe averages normals across every corner, which
       rounds the chamfers and the flat faces into one soft blob. Per edge,
       each face shades flat, the way the print does. */
    /* B5.68: oak, generated once and reused. The canvas is 180 mm along the
       grain (x, which wraps) by 90 mm across it (y). frameLathes lays the UVs
       out in those real millimetres, so the grain has the same density on
       every face and size and runs on unbroken over each edge. Growth rings
       are irregular (their spacing wanders), late wood is a narrow darker
       line, fibres streak along the grain, and oak's open pores show as
       short dark dashes in the early wood. The bump map recesses the pores
       and late lines slightly so the lacquer catches them. */
    function woodGrainTextures(THREE) {
      if (woodGrainTextures.cache) return woodGrainTextures.cache;
      var W = 1024, H = 512, PX = 8;
      var cv = document.createElement('canvas'), bv = document.createElement('canvas');
      cv.width = bv.width = W; cv.height = bv.height = H;
      var cx = cv.getContext('2d'), bx = bv.getContext('2d');
      var img = cx.createImageData(W, H), bim = bx.createImageData(W, H);
      var d = img.data, bd = bim.data;
      function h2(i, j) { var t = Math.sin(i * 127.1 + j * 311.7) * 43758.5453; return t - Math.floor(t); }
      function vn(x, y, per) {                 // value noise, periodic in x
        var xi = Math.floor(x), yi = Math.floor(y), xf = x - xi, yf = y - yi;
        var x0 = ((xi % per) + per) % per, x1 = (x0 + 1) % per;
        var u = xf * xf * (3 - 2 * xf), v = yf * yf * (3 - 2 * yf);
        var a = h2(x0, yi), b = h2(x1, yi), c = h2(x0, yi + 1), e = h2(x1, yi + 1);
        return a + (b - a) * u + (c - a) * v + (a - b - c + e) * u * v;
      }
      function fbm(x, y, per, oct) {
        var t = 0, amp = 0.5, n = oct || 4;
        for (var o = 0; o < n; o++) { t += amp * vn(x, y, per); x *= 2; y *= 2; per *= 2; amp *= 0.5; }
        return t;
      }
      function sstep(a, b, x) { x = Math.max(0, Math.min(1, (x - a) / (b - a))); return x * x * (3 - 2 * x); }
      var early = [160, 125, 90], late = [113, 83, 55], deep = [76, 54, 35];
      var i = 0, x, y;
      for (y = 0; y < H; y++) {
        var drift = 3.0 * fbm(0.7, y / H * 6, 1, 3);   // ring spacing wanders across the board
        for (x = 0; x < W; x++) {
          var gx = x / W * PX, gy = y / H;
          /* Long, gentle waves: two octaves only, so the lines bend, not jitter. */
          var wob = (fbm(gx * 0.5, gy * 2.2, PX / 2, 2) - 0.5) * 18;
          var yw = y + wob;
          var t = yw / 12 + drift;
          var f = t - Math.floor(t);
          var lateW = sstep(0.76, 0.9, f) * (1 - sstep(0.94, 1, f));
          /* Fine streaks follow the same bend as the rings. */
          var fib = fbm(gx * 1.5, yw / H * 170, PX * 1.5, 3);
          var broad = fbm(gx * 0.5 + 3.1, gy * 1.6, PX / 2, 2);
          /* Oak's open pores: short thin dashes along the grain, early wood only. */
          var pv = vn(gx * 5, yw / H * 640, PX * 5);
          var pore = f < 0.7 ? sstep(0.88, 0.95, pv) : 0;
          var k = lateW * 0.5 + (fib - 0.5) * 0.42 + (broad - 0.5) * 0.2;
          k = Math.max(0, Math.min(1, k));
          var r = early[0] + (late[0] - early[0]) * k;
          var g = early[1] + (late[1] - early[1]) * k;
          var bl = early[2] + (late[2] - early[2]) * k;
          var pm = pore * 0.38;
          r = r * (1 - pm) + deep[0] * pm; g = g * (1 - pm) + deep[1] * pm; bl = bl * (1 - pm) + deep[2] * pm;
          d[i] = r; d[i + 1] = g; d[i + 2] = bl; d[i + 3] = 255;
          var hgt = 230 - lateW * 55 - pore * 90 - (fib - 0.5) * 50;
          bd[i] = bd[i + 1] = bd[i + 2] = Math.max(0, Math.min(255, hgt)); bd[i + 3] = 255;
          i += 4;
        }
      }
      cx.putImageData(img, 0, 0); bx.putImageData(bim, 0, 0);
      function tex(c, srgb) {
        var t2 = new THREE.CanvasTexture(c);
        t2.wrapS = THREE.RepeatWrapping; t2.wrapT = THREE.ClampToEdgeWrapping;
        t2.anisotropy = 8;
        if (srgb) {
          if (THREE.SRGBColorSpace) t2.colorSpace = THREE.SRGBColorSpace;
          else if (THREE.sRGBEncoding) t2.encoding = THREE.sRGBEncoding;
        }
        return t2;
      }
      woodGrainTextures.cache = { map: tex(cv, true), bump: tex(bv, false) };
      return woodGrainTextures.cache;
    }
    function frameLathes(THREE, prof, R0, mmF, yFront, seg) {
      var P = prof.pts, out = [], k, sAt = 0;
      /* B5.68: UVs in real millimetres for the wood grain (black and white
         carry no texture, so this changes nothing for them). u: whole 180 mm
         tiles round the outer edge, so the wrap has no seam. v: distance
         along the profile over 90 mm, so the grain is continuous over edges. */
      var rMax = P.reduce(function (m, q) { return Math.max(m, q[0]); }, 0);
      var tilesU = Math.max(1, Math.round(2 * Math.PI * rMax / 180));
      for (k = 0; k < P.length; k++) {
        var a = P[k], b = P[(k + 1) % P.length];
        var g = new THREE.LatheGeometry([
          new THREE.Vector2(R0 + mmF(a[0] - prof.seat), yFront - mmF(a[1])),
          new THREE.Vector2(R0 + mmF(b[0] - prof.seat), yFront - mmF(b[1]))
        ], seg);
        var len = Math.hypot(b[0] - a[0], b[1] - a[1]);
        var uv = g.attributes.uv;
        for (var vi = 0; vi < uv.count; vi++) {
          var ring = Math.floor(vi / 2), j = vi % 2;
          uv.setXY(vi, ring / seg * tilesU, (sAt + j * len) / 90);
        }
        uv.needsUpdate = true;
        sAt += len;
        out.push(g);
      }
      return out;
    }

    var FPROF = frameProfileFor(spec.size.cm);
    var fw = mm(FPROF.pts.reduce(function (m, q) { return Math.max(m, q[0]); }, 0) - FPROF.seat);
    var outer = PLATE + 2 * fw;
    var lipUse = mm(FPROF.proud);
    var frameTop = LAND_Y + lipUse;
    /* The object's back plane: what rests on the desk and against the wall.
       It was the plate's underside; the deeper frame now reaches further back
       than the plate does, so the frame decides it. */
    var plateBottom = Math.min(FLOOR_Y - baseT, frameTop - mm(FPROF.h));
    var frameMat = new THREE.MeshStandardMaterial({
      color: FR.hex, roughness: FR.id === 'black' ? 0.62 : 0.72, metalness: 0.0,
      envMapIntensity: 0.45
    });
    /* B5.68: the wood frame is its own material: oak grain as colour, the
       pores and late rings as a faint bump, and a thin lacquer coat on top.
       If the canvas cannot be made it stays the flat oak colour above. */
    if (FR.grain) {
      try {
        var wood = woodGrainTextures(THREE);
        frameMat = new THREE.MeshPhysicalMaterial({
          color: 0xFFFFFF, map: wood.map, bumpMap: wood.bump, bumpScale: 0.35,
          roughness: 0.5, metalness: 0.0, clearcoat: 0.3, clearcoatRoughness: 0.42,
          envMapIntensity: 0.45
        });
      } catch (eW) {
        if (window.console) console.warn('[mm] wood grain skipped: ' + (eW && eW.message));
      }
    }
    frameLathes(THREE, FPROF, R, mm, frameTop, 256).forEach(function (g) {
      var m = new THREE.Mesh(g, frameMat);
      m.castShadow = true;
      m.receiveShadow = true;
      group.add(m);
    });
    /* B7.0: the name label, set into the front of the frame (Muasher's
       plaque). Its top sits flush with the frame's front face, centred on
       the face band, nearest the viewer. Never blocks the model: any error
       and the frame is simply drawn without it.
       B7.0.5 (Kevin, 26 Oct: "the label ... isn't curved at all"): the plaque
       follows the frame round, an arc on the middle of the face band, and the
       words follow it. */
    (function () {
      var LT = spec.label && spec.label !== 'None' ? String(spec.label) : '';
      if (!LT) return;
      try {
        var LM = MM_LABEL_MM, LTONE = labelTone(spec.frame), k;
        var faceR = FPROF.pts.filter(function (q) { return q[1] === 0; }).map(function (q) { return q[0]; });
        var rIn = faceR.length ? Math.min.apply(null, faceR) : FPROF.seat;
        var rOut = faceR.length ? Math.max.apply(null, faceR) : FPROF.seat + 9;
        var rcS = R + mm((rIn + rOut) / 2 - FPROF.seat);          /* centre line of the arc, scene units */
        var Hs = mm(LM.h), T2 = mm(LM.t), yTop = frameTop + mm(0.1);
        var span = mm(LM.w) / rcS, capA = (Hs / 2) / rcS, a = span / 2 - capA;
        var outline = labelArcOutline(rcS, Hs / 2, a, 28);
        var sh2 = new THREE.Shape(outline.map(function (p) { return new THREE.Vector2(p[0], -p[1]); }));
        var bodyG = new THREE.ExtrudeGeometry(sh2, { depth: T2, bevelEnabled: false, curveSegments: 1 });
        bodyG.rotateX(-Math.PI / 2);
        bodyG.translate(0, yTop - T2, 0);
        /* the frame's own material (oak grain included), UVs in the same real
           millimetres the frame uses, so the grain matches in density */
        var uvA = bodyG.getAttribute('uv'), mmU = mm(1);
        if (uvA) { for (k = 0; k < uvA.count; k++) uvA.setXY(k, uvA.getX(k) / mmU / 180, uvA.getY(k) / mmU / 90); uvA.needsUpdate = true; }
        var body2 = new THREE.Mesh(bodyG, frameMat);
        body2.castShadow = true; body2.receiveShadow = true;
        group.add(body2);
        var tex = new THREE.CanvasTexture(labelCanvas(LT, LTONE, spec.labelIcon, true));
        if (THREE.SRGBColorSpace) tex.colorSpace = THREE.SRGBColorSpace;
        else if (THREE.sRGBEncoding) tex.encoding = THREE.sRGBEncoding;
        tex.anisotropy = 8;
        /* the face: a strip round the arc, the picture laid along it */
        var SEG = 64, pos = [], uv = [], idx = [], yF = yTop + mm(0.01);
        for (k = 0; k <= SEG; k++) {
          var u = k / SEG, ph = -span / 2 + span * u, sn = Math.sin(ph), cs = Math.cos(ph);
          pos.push(sn * (rcS - Hs / 2), yF, cs * (rcS - Hs / 2), sn * (rcS + Hs / 2), yF, cs * (rcS + Hs / 2));
          uv.push(u, 1, u, 0);
          if (k < SEG) { var q0 = k * 2; idx.push(q0, q0 + 1, q0 + 2, q0 + 1, q0 + 3, q0 + 2); }
        }
        var topG = new THREE.BufferGeometry();
        topG.setAttribute('position', new THREE.Float32BufferAttribute(pos, 3));
        topG.setAttribute('uv', new THREE.Float32BufferAttribute(uv, 2));
        topG.setIndex(idx);
        topG.computeVertexNormals();
        var nrm = topG.getAttribute('normal');
        for (k = 0; k < nrm.count; k++) nrm.setXYZ(k, 0, 1, 0);
        var topM = new THREE.Mesh(topG, new THREE.MeshStandardMaterial({
          map: tex, transparent: true, alphaTest: 0.04, depthWrite: false, roughness: 0.6, metalness: 0, side: THREE.DoubleSide,
          envMapIntensity: 0.45, polygonOffset: true, polygonOffsetFactor: -2, polygonOffsetUnits: -2 }));
        topM.receiveShadow = true;
        group.add(topM);
        if (window.console) console.info('[mm] name label on the frame (curved): ' + (spec.labelIcon ? '[' + spec.labelIcon + '] ' : '') + LT);
      } catch (eL) {
        if (window.console) console.warn('[mm] label skipped: ' + (eL && eL.message));
      }
    })();

    /* The 40 cm model is four quarter plates. Show the two seams honestly, as
       hairlines across the map. */
    if ((spec.size.plates || 1) >= 4) {
      (function () {
        var sp = [], w = mm(0.28), n = 400;
        function line(ax, az, bx, bz) {
          var nx = -(bz - az), nz = bx - ax, L = Math.hypot(nx, nz);
          nx = nx / L * w / 2; nz = nz / L * w / 2;
          for (var i = 0; i < n; i++) {
            var t0 = i / n, t1 = (i + 1) / n;
            var x0 = ax + (bx - ax) * t0, z0 = az + (bz - az) * t0;
            var x1 = ax + (bx - ax) * t1, z1 = az + (bz - az) * t1;
            var y0 = terrainAt(x0, z0) + mm(0.04), y1 = terrainAt(x1, z1) + mm(0.04);
            sp.push(x0 + nx, y0, z0 + nz, x1 + nx, y1, z1 + nz, x1 - nx, y1, z1 - nz);
            sp.push(x0 + nx, y0, z0 + nz, x1 - nx, y1, z1 - nz, x0 - nx, y0, z0 - nz);
          }
        }
        line(-R * 0.999, 0, R * 0.999, 0);
        line(0, -R * 0.999, 0, R * 0.999);
        var sg = new THREE.BufferGeometry();
        sg.setAttribute('position', new THREE.Float32BufferAttribute(sp, 3));
        sg.computeVertexNormals();
        group.add(new THREE.Mesh(sg, mat(shade(C.base, 0.55), false, true)));
      })();
    }

    /* AmbientLight adds the same value to every surface at every angle, which
       is the enemy of depth -- it is why walls and roofs read as one tone. A
       hemisphere light carries a sky-to-ground gradient instead, so vertical
       faces darken toward their base. That is not real ambient occlusion, but
       it buys most of what AO buys here for no extra passes. */
    /* Ambient and fill are what LIFT shadows. Cutting them roughly in half
       while raising the key keeps lit surfaces at the same brightness but drops
       shadowed ones from ~0.94 to ~0.50 of full light -- that is the whole
       difference between a shadow you can see and one you can read. */
    /* Pulled back from 0.34. Ambient light fills shadows from every direction
       at once, so a generous hemisphere makes a shadow a slightly greyer patch
       of the same surface rather than a shadow. The key is raised to
       compensate, so lit faces stay where they were and only the shaded ones
       drop. */
    world.add(new THREE.HemisphereLight(0xffffff, 0xA79E8C, MM_T.hemiIntensity));

    /* Sky light standing in for ambient occlusion. Straight down, so its shadow
       is each building's own footprint -- but blurred wide, so that footprint
       spreads into the street beside it and the base of every wall and every
       narrow street darkens. That contact darkening is most of what makes the
       reference read as an object and ours as a diagram. */
    var skyLight = new THREE.DirectionalLight(0xE9EEF5, MM_T.skyIntensity);
    skyLight.position.set(0.01, 40, 0.01);
    skyLight.castShadow = true;
    skyLight.shadow.mapSize.set(2048, 2048);
    skyLight.shadow.camera.left = -7.2;
    skyLight.shadow.camera.right = 7.2;
    skyLight.shadow.camera.top = 7.2;
    skyLight.shadow.camera.bottom = -7.2;
    skyLight.shadow.camera.near = 1;
    skyLight.shadow.camera.far = 90;
    skyLight.shadow.radius = MM_T.skyShadowRadius;
    skyLight.shadow.blurSamples = 24;
    skyLight.shadow.bias = -0.0002;
    world.add(skyLight);

    /* Dropped from a near-overhead 57 degrees to about 40. High sun means short
       shadows, and short shadows on a 1:5000 model mean buildings barely
       register as having height at all. Raking light is what makes a relief
       model read. */
    var keyLight = new THREE.DirectionalLight(0xfffaf0, MM_T.keyIntensity);
    /* Light from the TOP RIGHT in both shots, so everything falls bottom-left
       and agrees with the CSS shadow on the composited image. In the wall view
       the camera looks straight down with screen-right = +X and screen-up = -Z,
       so +X / -Z is the top-right corner; the three-quarter studio camera sees
       it from the same side. */
    keyLight.position.set(7.5, 8.5, -6);
    keyLight.castShadow = true;
    // a terrace is ~19 shadow texels wide at 2048; 4096 puts contact shadows
    // back under individual buildings instead of smearing them together
    keyLight.shadow.mapSize.set(KEY_SHADOW, KEY_SHADOW);   // B5.46: 2048 on phones
    /* Widened with the lower sun. A shadow now runs about twice a building's
       height, and anything falling outside this box is simply not drawn -- so
       a tight frustum would clip shadows off at the edge of the plate. */
    /* Sized to what is actually in the scene rather than a fixed box. A tall
       building at a low sun throws several times its own height, and anything
       landing outside this frustum is simply not drawn -- which reads as
       buildings that cast nothing. `tallest` is the tallest extrusion built
       above; on a flat crop this is the old 8.4 either way. */
    var MM_SH = 8.4 + (tallest || 0) * 2.6;
    keyLight.shadow.camera.left = -MM_SH;
    keyLight.shadow.camera.right = MM_SH;
    keyLight.shadow.camera.top = MM_SH;
    keyLight.shadow.camera.bottom = -MM_SH;
    keyLight.shadow.camera.near = 1;
    keyLight.shadow.camera.far = 60 + (tallest || 0) * 6;
    keyLight.shadow.bias = -0.00006;
    keyLight.shadow.normalBias = 0.004;
    /* VSM radius is in shadow texels: halve it with the map so the blur
       covers the same ground on a phone as on a desktop. */
    keyLight.shadow.radius = MM_T.keyShadowRadius * KEY_SHADOW / 4096;
    keyLight.shadow.blurSamples = 16;
    world.add(keyLight);

    /* Moving the key means the painted contact shadow has to move with it, or
       the two disagree and the whole thing reads as a composite. */
    var blobRef = null;
    function setKey(x, y, z) {
      keyLight.position.set(x, y, z);
      fill.position.set(-x * 0.9, Math.abs(y) * 0.62, -z * 0.9);
      if (!blobRef) return;
      var horiz = Math.hypot(x, z) || 1;
      var drop = (frameTop - plateBottom) * (horiz / (y || 1));
      blobRef.position.x = -(x / horiz) * drop;
      blobRef.position.z = -(z / horiz) * drop;
    }
    var fill = new THREE.DirectionalLight(0xE8EDF5, MM_T.fillIntensity);
    fill.position.set(-8, 5.5, 9);   // opposite the key, filling the shadow side
    world.add(fill);

    var surface = new THREE.Mesh(
      /* Build 3.2: big. The wall camera sits much further back than the desk
         one, and at 60 units square the catcher's own edge came into frame. */
      new THREE.PlaneGeometry(300, 300),
      /* Kept, but light. A directional light at 40 degrees throws a hard band
         the length of the model's own thickness, which detaches from the frame
         and reads as a mistake. The soft blob below does the grounding; this
         only adds definition right at the edge. */
      new THREE.ShadowMaterial({ opacity: 0.20 })
    );
    surface.rotation.x = -Math.PI / 2;
    /* Sit the catcher on the model's true underside. The frame bars are the
       lowest geometry -- their bottom is (maxLift + lip - fh). Any gap between
       the model and this plane throws the contact shadow sideways, which is why
       it looked detached from the frame rather than tucked under it. */
    /* Under the lowest thing in the scene. That used to be the frame at -baseT;
       since the plate was fixed to grow downward it is the plate, at
       -(baseT + maxLift), and a backdrop above that cuts through it. */
    surface.position.y = plateBottom - 0.002;
    surface.receiveShadow = true;
    world.add(surface);

    var blobMesh = null;
    /* A painted contact shadow, the way a product photographer would light it.
       A blurred rounded rectangle the size of the frame, nudged along the
       light's own direction so it agrees with everything else in the scene.
       This is what actually grounds the model on the table. */
    (function () {
      var S = 256, cv = document.createElement('canvas');
      cv.width = cv.height = S;
      var g2 = cv.getContext('2d');
      if (!g2) return;
      var inset = S * 0.17, r = S * 0.05;
      try { g2.filter = 'blur(' + Math.round(S * 0.085) + 'px)'; } catch (e) {}
      g2.fillStyle = 'rgba(0,0,0,1)';
      g2.beginPath();
      var x0 = inset, y0 = inset, w0 = S - inset * 2, h0 = S - inset * 2;
      g2.arc(S / 2, S / 2, w0 / 2, 0, Math.PI * 2);   // round model, round shadow
      g2.fill();

      var tex = new THREE.CanvasTexture(cv);
      if ('colorSpace' in tex && THREE.SRGBColorSpace) tex.colorSpace = THREE.SRGBColorSpace;
      /* 1.22, down from 1.45.

         MEASURED 29 Sep on the live 20 cm Darndale shot, reading the alpha
         channel of the rendered PNG directly: the image is 1600x1600, the model
         occupies 1402px of it (87.6%, which is the `fill: 0.88` above), and the
         shadow was still at alpha 29 when it ran off the left and right edges.
         Top and bottom were clean at 0 -- the plate is wide and short, so only
         the sides were short of room.

         The frame cannot grow: .mm-disc clips to a circle with overflow:hidden,
         which is what puts the map in a circle, so a bigger image is cut by the
         circle instead of the square. That leaves making the model smaller in
         frame or making the shadow narrower, and the model is the thing Kevin
         signed off. So the shadow comes in.

         A complete smaller shadow reads as a photograph; a bigger one sliced
         off square reads as a render, which is the whole thing this build has
         been fighting. Put this back to 1.45 and drop `fill` to about 0.74 if
         the trade is ever worth making the other way. */
      /* Keyed to PLATE, NOT to `outer`. That was the bug: `outer` grows with
         the frame, so widening the ring from 3 mm to 15 mm took the blob from
         12.57 to 14.03 and put it straight back into the range the paragraph
         above measured as clipping (known-bad was 14.94). The camera fits the
         model, and the shadow's room in frame is therefore fixed no matter how
         wide the ring is -- so the shadow must not track the ring.
         PLATE is 10 and never changes, so 1.26 reproduces the 12.6 that
         measured clean and a future frame change cannot move it again. */
      var blobSize = PLATE * 1.26;
      var blob = new THREE.Mesh(
        new THREE.PlaneGeometry(blobSize, blobSize),
        new THREE.MeshBasicMaterial({
          map: tex, transparent: true, opacity: 0.42,
          depthWrite: false, color: 0x000000
        })
      );
      blob.rotation.x = -Math.PI / 2;

      // slide it along the light direction by the model's own height
      var lx = keyLight.position.x, ly = keyLight.position.y, lz = keyLight.position.z;
      var horiz = Math.hypot(lx, lz) || 1;
      var drop = (frameTop - plateBottom) * (horiz / (ly || 1));
      blob.position.set(-(lx / horiz) * drop, surface.position.y + 0.004,
                        -(lz / horiz) * drop);
      blob.renderOrder = -1;
      world.add(blob);
      blobMesh = blob;
      blobRef = blob;
    })();

    var downCv = null;
    /* Ambient occlusion, built once at the draw size and reused for both
       shots. If the target cannot be created -- an old driver, a lost context
       -- it stays null and the render falls through to the plain path rather
       than failing. */
    var aoPass = null;
    /* Build 4.1: the pass now carries the image grade as well as the occlusion,
       so it has to run whenever EITHER is wanted. */
    if (window.MMRender && window.MMRender.makeAO &&
        (MM_T.aoIntensity > 0 || MM_T.gradeOn)) {
      try { aoPass = window.MMRender.makeAO(THREE, renderer, DRAW); }
      catch (e) {
        if (window.console) console.warn('[mm] AO unavailable:', e && e.message);
      }
      if (window.console) {
        console.info('[mm] ambient occlusion ' + (aoPass ? 'on' : 'unavailable'));
      }
    }

    /* Split so the log says which half of a shot is slow. Drawing the frame and
       encoding it to a data URL are completely different costs, and at 2400px
       the encode is not the small one. */
    var msDraw = [], msEnc = [];
    function shoot(camera) {
      var tD = (window.performance || Date).now();
      camera.updateProjectionMatrix();
      /* If the AO pass reports it could not draw -- a shader that failed to
         compile, a lost context -- fall through to the plain render rather than
         handing back a blank image. */
      if (!aoPass || aoPass.render(world, camera) !== true) {
        renderer.render(world, camera);
      }
      msDraw.push(Math.round((window.performance || Date).now() - tD));
      var tE = (window.performance || Date).now();
      function enc(v) { msEnc.push(Math.round((window.performance || Date).now() - tE)); return v; }
      try {
        if (SS === 1) return enc(renderer.domElement.toDataURL('image/png'));
        if (!downCv) {
          downCv = document.createElement('canvas');
          downCv.width = downCv.height = SIZE;
        }
        var g3 = downCv.getContext('2d');
        /* Cleared first: the model is drawn on transparency, so without this
           the wall shot would composite on top of the desk shot. */
        g3.clearRect(0, 0, SIZE, SIZE);
        g3.imageSmoothingEnabled = true;
        g3.imageSmoothingQuality = 'high';
        g3.drawImage(renderer.domElement, 0, 0, SIZE, SIZE);
        return enc(downCv.toDataURL('image/png'));
      } catch (e) { msEnc.push(-1); return null; }
    }

    /* Frame each camera so a known fraction of the image is filled by the
       plate. Previously I fitted the *diagonal*, which left the square itself
       filling barely half the frame — hence a model that looked far away. */
    var outer = PLATE + 2 * fw;
    function distFor(fovDeg, frac, extent) {
      return extent / (2 * frac * Math.tan((fovDeg / 2) * D2R));
    }
    var WALL_FILL = 0.92;   // plate width as a fraction of the wall shot
    /* Raised. The reference fills far more of its shot than we were, which is
       most of why their 20 cm model looks bigger than ours at the same size. */
    var DESK_FILL = 0.82;
    /* How much of the finished image the PLATE itself takes, measured off each
       camera. The scale against the backdrop photo still comes from the two
       constants above, so a model is exactly the size on screen it was before
       Build 3 -- these are the safety rail that stops a pane cropping the piece,
       and the check that all four angles show it at one size. */
    var deskFrac = DESK_FILL, wallFrac = WALL_FILL;

    /* ===================== BUILD 3 · THE SHOTS ==========================
       Four angles plus the wall shot. The model is built once, so each extra
       view costs one more draw rather than another model -- and turning the
       piece is what shows it is an object rather than a picture.

       Framed on the model's own bounding box, not on the plate. The plate is
       the same size everywhere; a city of towers is not, and fitting the plate
       alone is what pushed Manhattan's skyline out the top of the frame. */
    var modelBox = new THREE.Box3().setFromObject(group);
    /* Clamped to the plate side to side. Several layers are cut to the circle
       by clipping planes at draw time rather than in their geometry, so their
       raw extent runs well past the ring and would frame the shot around map
       that is never drawn. Height is left alone -- that is the part that varies
       and the whole reason for framing on the model at all. */
    modelBox.min.x = Math.max(modelBox.min.x, -outer / 2);
    modelBox.max.x = Math.min(modelBox.max.x, outer / 2);
    modelBox.min.z = Math.max(modelBox.min.z, -outer / 2);
    modelBox.max.z = Math.min(modelBox.max.z, outer / 2);
    modelBox.min.y = Math.max(modelBox.min.y, plateBottom);
    var boxC = modelBox.getCenter(new THREE.Vector3());
    if (window.console) {
      var bs = modelBox.getSize(new THREE.Vector3());
      console.info('[mm] model box: ' + bs.x.toFixed(1) + ' x ' + bs.z.toFixed(1) +
                   ' plate units, ' + (bs.y / mm(1)).toFixed(1) + ' mm tall');
    }
    /* Fitted to the piece as a cylinder rather than as a box: the plate is
       round, and a box's corners stick out past it by 40 per cent, which is
       empty frame on every three-quarter shot. Top and bottom rings, so a tower
       standing at the rim is still inside the frame. */
    var boxPts = [];
    (function () {
      var rr = outer / 2, N = 32;
      for (var bi = 0; bi < N; bi++) {
        var ba = bi / N * Math.PI * 2, bx = Math.cos(ba) * rr, bz = Math.sin(ba) * rr;
        boxPts.push(new THREE.Vector3(bx, modelBox.min.y, bz));
        boxPts.push(new THREE.Vector3(bx, modelBox.max.y, bz));
      }
    })();
    /* Distance solved rather than guessed: for each corner, the distance at
       which it lands exactly on the edge of the frame, then the largest wins.
       fill is how much of the half-frame the model is allowed to take. */
    function aimCam(cam, dirArr, fov, fill) {
      var d = new THREE.Vector3(dirArr[0], dirArr[1], dirArr[2]).normalize();
      var up = Math.abs(d.y) > 0.985 ? new THREE.Vector3(0, 0, -1) : new THREE.Vector3(0, 1, 0);
      var rt = new THREE.Vector3().crossVectors(up, d).normalize();
      var cu = new THREE.Vector3().crossVectors(d, rt).normalize();
      var T = Math.tan(fov / 2 * D2R) * fill, dist = 0;
      for (var bp = 0; bp < boxPts.length; bp++) {
        var v = boxPts[bp].clone().sub(boxC);
        var lat = Math.max(Math.abs(v.dot(rt)), Math.abs(v.dot(cu)));
        var need = v.dot(d) + lat / T;
        if (need > dist) dist = need;
      }
      cam.fov = fov;
      cam.up.copy(up);
      cam.position.copy(boxC).addScaledVector(d, dist);
      cam.lookAt(boxC);
      /* Near and far wrapped tightly around the model: a 0.1-to-600 range
         spends nearly the whole depth buffer on empty space in front of it. */
      cam.near = Math.max(0.5, dist - 30);
      cam.far = dist + 40;
      cam.updateProjectionMatrix();
      return cam;
    }
    /* The key light follows the camera, about fifty degrees to its left and
       high, so every angle is lit the same way and the shadows always rake
       away from the viewer. Hand-placed lights per angle drift apart. */
    function keyFor(dirArr) {
      var hx = dirArr[0], hz = dirArr[2], hl = Math.hypot(hx, hz);
      /* Build 4.3: straight down gets its own low key -- that pane has no
         perspective to read depth from, so the shadows are the only thing
         telling one roof from the next. */
      if (hl < 0.2) return MM_T.topKey || MM_T.wallKey;
      var a = Math.atan2(hz, hx) + 0.85;
      var rr = MM_T.keyRadius || 9.0, hh = MM_T.keyHeight || 9.5;
      return [Math.cos(a) * rr, hh, Math.sin(a) * rr];
    }
    /* Longer lenses than Build 2's 26 degrees. Wide angle on a small object is
       the instant tell that something is a render, and it is what made the
       towers at the rim lean outward off the plate. */
    var ANGLES = [
      /* B5.51: y lowered (0.56/0.54 -> 0.46/0.44), about 34 -> 28 degrees
         above the horizon, so building and terrain height actually show. */
      { cap: 'three-quarter', dir: [-0.31, 0.46, 0.77], fov: 20, fill: 0.88 },
      { cap: 'left',          dir: [-0.82, 0.44, 0.20], fov: 20, fill: 0.88 },
      { cap: 'right',         dir: [ 0.66, 0.44, 0.52], fov: 20, fill: 0.88 },
      { cap: 'above',         dir: [ 0.02, 1.00, 0.05], fov: 16, fill: 0.92 }
    ];
    function plateFracFor(cam) {
      /* project() reads the camera's inverse world matrix, which three only
         refreshes inside render() -- measuring before the first shot gave a
         stale matrix and a nonsense fraction (111% of the frame). */
      cam.updateMatrixWorld(true);
      cam.matrixWorldInverse.copy(cam.matrixWorld).invert();
      /* The rim right round, not one diameter: from the side, the plate's east
         -west diameter runs away from the camera and measures a fifth of its
         real width on screen. */
      var lo = 1e9, hi = -1e9, pv = new THREE.Vector3();
      for (var pf = 0; pf < 48; pf++) {
        var pa = pf / 48 * Math.PI * 2;
        pv.set(Math.cos(pa) * outer / 2, LAND_Y, Math.sin(pa) * outer / 2).project(cam);
        if (pv.x < lo) lo = pv.x;
        if (pv.x > hi) hi = pv.x;
      }
      var f = (hi - lo) / 2;
      return (f > 0.05 && f < 1.5) ? f : DESK_FILL;
    }
    /* ---- Build 3.6: NaN sweep -------------------------------------------
       One vertex that is not a real number poisons the bounding sphere, then
       the shadow and camera matrices, and three.js then fails deep inside a
       uniform upload with a message about a function nobody wrote. The render
       dies whole. OSM is mapped by hand in every country on earth, so there
       will always be another shape that surprises this code.
       So: check once, drop what is broken, say what was dropped, and still
       hand the customer a model. A missing wall is a bug report. A blank
       screen is a lost order. */
    (function () {
      var dropped = [], bad = [];
      world.traverse(function (o) {
        if (!o.isMesh && !o.isInstancedMesh) return;
        var a = o.geometry && o.geometry.attributes && o.geometry.attributes.position;
        if (!a || !a.array) return;
        var arr = a.array;
        for (var i = 0; i < arr.length; i++) {
          if (!isFinite(arr[i])) { bad.push(o); return; }
        }
      });
      bad.forEach(function (o) {
        dropped.push((o.geometry.attributes.position.count | 0) + ' verts');
        if (o.parent) o.parent.remove(o);
        if (o.geometry && o.geometry.dispose) o.geometry.dispose();
      });
      if (dropped.length && window.console) {
        console.error('[mm] dropped ' + dropped.length + ' mesh(es) with unusable geometry: ' +
                      dropped.join(', ') + ' -- the rest of the model is intact');
      }
    })();

    var shotSrcs = [], shotMs = [], shotFracs = [];
    var heroGeo = null;                                // B5.52: table room shot
    /* The four photographs ARE the wait: about fifty seconds of an eighty second
       build, and 98% of that is drawing, not encoding. In live mode one is
       baked -- the email, the Klaviyo payload and the cart thumbnail all need a
       real image file, and it is the poster while the canvas warms -- and the
       other three are replaced by the scene the customer can turn themselves,
       which we were building and then throwing away. */
    (LIVE ? ANGLES.slice(0, 1) : ANGLES).forEach(function (a, ai) {
      var t0s = Date.now();
      var cam = aimCam(new THREE.PerspectiveCamera(a.fov, 1, 2, 120), a.dir, a.fov, a.fill);
      var k = keyFor(a.dir);
      setKey(k[0], k[1], k[2]);
      /* Each angle frames differently, so each one gets its own measured plate
         fraction. Using the hero's for all four made the same model appear at
         four different sizes against the same backdrop. */
      shotFracs.push(plateFracFor(cam));
      if (ai === 0) deskFrac = shotFracs[0];
      var src = shoot(cam);
      if (ai === 0 && src) { try { heroGeo = discGeo(cam); } catch (eG) {} }
      shotSrcs.push(src);
      shotMs.push(Date.now() - t0s);
      if (src && shotImgs[ai]) shotImgs[ai].src = src;
    });
    var studioSrc = shotSrcs[0];
    if (window.console) {
      console.info('[mm] shots: ' + (LIVE ? ANGLES.slice(0, 1) : ANGLES).map(function (a, ai) {
        return a.cap + ' ' + shotMs[ai] + 'ms (draw ' + (msDraw[ai] || 0) +
               ' + encode ' + (msEnc[ai] || 0) + '), plate ' +
               Math.round(shotFracs[ai] * 100) + '% of frame';
      }).join(' \u00b7 '));
      var sumD = 0, sumE = 0;
      msDraw.forEach(function (v) { sumD += v; });
      msEnc.forEach(function (v) { sumE += v; });
      console.info('[mm] shot cost: ' + sumD + 'ms drawing, ' + sumE + 'ms encoding');
    }

    // kept for the old single-shot framing maths below
    var sFov = 26;
    var sDist = distFor(sFov, DESK_FILL, outer * 1.3);
    /* Near and far pulled in hard. A 0.1-to-600 range spends nearly all of the
       depth buffer on empty space in front of the model, and ambient occlusion
       reads depth -- at that precision the differences it needs are below the
       noise floor. The model is ten units across and the camera sits about
       twenty-five away. */

    /* Light on the CAMERA's side, so the shadow falls away from the viewer
       rather than across the table in front of the model. That is the product
       photography convention and the thing that separates this from a render.
       The two cameras point completely differently, so each gets its own light
       position -- one setting cannot serve both. */
    /* Dropped from 45 degrees to 27. Shadow length doubles, which is the only
       depth cue left on a model with no terrain relief under it. Still on the
       camera's side and still from the left, so shadows rake across to the
       right and away from the viewer. */
    /* Lower than before: at ~36 degrees the shadows were barely longer than
       the buildings, and shadow length is most of what says a block has height
       at 1:5000. */

    /* Cart thumbnail. Captured from the WALL shot composited onto the room
       photo, because that is the image that sells -- the frame hanging in a
       room, not a render floating on grey. Falls back to the bare render if the
       room photo cannot be read, and to nothing at all if anything throws: a
       thumbnail is never worth breaking a preview over. */
    /* Composites a render onto its backdrop photo at a given size -- the
       picture the customer actually saw, not a model floating on grey. One
       function for both panes: the desk shot and the wall shot differ only in
       which photo, how the model is scaled against it, and where it sits. */
    function compositeShot(renderSrc, sc, S, mime, quality, done) {
      if (!renderSrc) {
        if (window.console) console.warn('[mm] no render to composite');
        return done(null);
      }
      var cv = document.createElement('canvas');
      cv.width = cv.height = S;
      var g2 = cv.getContext('2d');
      if (!g2) return done(null);

      function finish() {
        try { done(cv.toDataURL(mime, quality)); }
        catch (e) {
          // a cross-origin backdrop without CORS headers taints the canvas
          if (window.console) console.warn('[mm] composite canvas tainted:', e.message);
          done(null);
        }
      }
      function drawModel(img, pct, xPct, yPct) {
        var w = S * (pct / 100);
        g2.drawImage(img, S * (xPct / 100) - w / 2, S * (yPct / 100) - w / 2, w, w);
      }

      var model = new Image();
      model.onerror = function () { done(null); };
      model.onload = function () {
        // the same sizing place() uses, so this matches what they were shown
        var pct = sc.bg ? (spec.size.cm / (sc.cm || 140)) * 100 / sc.fill : sc.solo;
        /* The same cap place() applies on screen, which this had never copied.
           THAT is what cut the top off the emailed render: place() clamps to
           98/frac so the plate cannot run past the pane, and the email did
           not, so the two drifted apart the moment the ring got wider --
           a wider ring raises `frac`, the on-screen copy shrank to fit and the
           email carried on at the old size. It clipped at the TOP rather than
           evenly because the wall scene sits at y 42%, above centre.
           Same clamp, same numbers, one image. */
        var capPct = 98 / Math.max(sc.frac || sc.fill, 0.05);
        pct = Math.max(6, Math.min(pct, 150, capPct));
        var xPct = sc.x != null ? sc.x : 50;
        var yPct = sc.y != null ? sc.y : 50;

        if (!sc.bg) {
          g2.fillStyle = '#EFEDE8'; g2.fillRect(0, 0, S, S);
          drawModel(model, pct, xPct, yPct); return finish();
        }
        var bg = new Image();
        bg.crossOrigin = 'anonymous';
        bg.onload = function () {
          // cover-fit the backdrop, then place the model exactly as on screen
          var r = Math.max(S / bg.width, S / bg.height);
          var bw = bg.width * r, bh = bg.height * r;
          try { g2.drawImage(bg, (S - bw) / 2, (S - bh) / 2, bw, bh); }
          catch (e) { g2.fillStyle = '#EFEDE8'; g2.fillRect(0, 0, S, S); }
          drawModel(model, pct, xPct, yPct);
          finish();
        };
        bg.onerror = function () {
          g2.fillStyle = '#EFEDE8'; g2.fillRect(0, 0, S, S);
          drawModel(model, pct, xPct, yPct);
          finish();
        };
        bg.src = sc.bg;
      };
      model.src = renderSrc;
    }

    /* `frac` is the plate's measured share of that camera's frame. It is what
       the on-screen cap is computed from, so it has to travel with the scene
       or the email cannot apply the same cap. */
    function wallScene() {
      return { bg: scene.wall, cm: scene.wallCm, x: scene.wallX, y: scene.wallY,
               fill: WALL_FILL, solo: 96, frac: wallFrac };   // B5.52: 62 -> 96, the square-on wall shot is framed looser (0.58)
    }
    function deskScene() {
      return { bg: scene.desk, cm: scene.deskCm, x: scene.deskX, y: scene.deskY,
               fill: DESK_FILL, solo: 100, frac: deskFrac };
    }

    function thumbShot(renderSrc, S, done) {
      if (!renderSrc) return done(null);
      var cv = document.createElement('canvas');
      cv.width = cv.height = S;
      var g4 = cv.getContext('2d');
      if (!g4) return done(null);
      var im = new Image();
      im.onerror = function () { done(null); };
      im.onload = function () {
        g4.fillStyle = '#EFEDE8';
        g4.fillRect(0, 0, S, S);
        var pad = Math.round(S * 0.04);
        g4.imageSmoothingEnabled = true;
        g4.imageSmoothingQuality = 'high';
        g4.drawImage(im, pad, pad, S - pad * 2, S - pad * 2);
        try { done(cv.toDataURL('image/jpeg', 0.78)); }
        catch (e) { done(null); }
      };
      im.src = renderSrc;
    }

    function stashThumb(renderSrc) {
      if (!spec || !spec.centre) {
        if (window.console) console.warn('[mm] thumbnail skipped: spec.centre missing');
        return;
      }
      var KEY = MM_thumbKey(spec);
      /* Build 3: the cart thumbnail is the model itself, trimmed and centred,
         not the room photo. At the 60-ish pixels a cart line gives it, a room
         is texture and the model is three of those pixels -- and the piece is
         round now, so it reads as itself against a plain ground. */
      thumbShot(renderSrc, 400, function (url) {
        if (!url) return;
        try {
          MM_thumbPut(KEY, url);
          /* Also written to a fixed key. The drawer opens seconds after this
             render, so "the last thing configured" is a reliable fallback if the
             coordinate key ever fails to match -- and it removes a whole class
             of silent mismatch between the two files. */
          localStorage.setItem('mm-thumb:last', url);
          if (window.console) {
            console.info('[mm] cart thumbnail saved (' + Math.round(url.length / 1024) +
                         'kB) under ' + KEY);
          }
        } catch (e) {
          if (window.console) console.warn('[mm] cart thumbnail not stored:', e.message);
        }
      });
    }

    /* Hands the finished render back to the page. Nothing is sent from in here:
       renderModel has no idea whether an address was given. It composites both
       panes -- the same pair the customer is looking at -- and passes them up,
       and init decides what to do with them. */
    /* B5.52: where the model sits in a baked shot, as fractions of the frame:
       its centre (the same point the approved sheet was anchored on) and its
       full outer width across the rim. The room composite scales from these, so
       it does not care how tightly each camera was framed. */
    function discGeo(cam) {
      cam.updateMatrixWorld(true);
      cam.matrixWorldInverse.copy(cam.matrixWorld).invert();
      function pj(x, y, z) {
        var p = new THREE.Vector3(x, y, z).project(cam);
        return [(p.x + 1) / 2, (1 - p.y) / 2];
      }
      var c = pj(0, plateBottom + 0.3, 0), r = outer / 2, lo = 1e9, hi = -1e9;
      for (var a = 0; a < 72; a++) {
        var t = a / 72 * Math.PI * 2;
        for (var h = 0; h < 2; h++) {
          var q = pj(Math.cos(t) * r, plateBottom + h * 0.6, -Math.sin(t) * r);
          if (q[0] < lo) lo = q[0];
          if (q[0] > hi) hi = q[0];
        }
      }
      return { cx: c[0], cy: c[1], w: hi - lo };
    }

    /* B5.52: both room shots, then the page and the email. If a photo is not
       there yet (not uploaded) or anything fails, the email falls back to the
       B5.51 picture and the page simply shows no room button. */
    /* GUARD (12 Oct): measure both renders before compositing. Either one empty means
       "blank": no pictures in the email, no room button on the page. */
    function roomsHandOff() {
      MM_renderCoverage(lowSrc || studioSrc, function (ct) {
        MM_renderCoverage(wallSrc, function (cw) {
          if (roomTok !== cfg.__mmRoomTok) return;          // a newer build took over
          window.MM_LAST_COVER = { table: ct, wall: cw };
          if (MM_isBlank(ct) || MM_isBlank(cw)) return blankHandOff(ct, cw);
          try { roomsHandOffGo(); }
          catch (eRm) { try { handOffRender(wallSrc, studioSrc); } catch (e) { /* nor for the email */ } }
        });
      });
    }
    /* B6.4: blank guard straight off the pass canvases, then both photos,
       then the composites. Any failure falls back to the plain pictures. */
    function canvasCover(cv) {
      if (!cv) return 0;
      try {
        var N = 64, c = document.createElement('canvas'); c.width = c.height = N;
        var g = c.getContext('2d'); g.drawImage(cv, 0, 0, N, N);
        var p = g.getImageData(0, 0, N, N).data, hit = 0;
        for (var i = 3; i < p.length; i += 4) if (p[i] > 24) hit++;
        return hit / (N * N);
      } catch (e) { return -1; }
    }
    function rooms2() {
      var ct = canvasCover(R2.table.img), cw = canvasCover(R2.wall.img);
      window.MM_LAST_COVER = { table: ct, wall: cw };
      if (MM_isBlank(ct) || MM_isBlank(cw)) return blankHandOff(ct, cw);
      /* Desktop gets the photos at their full 1600 px; phones stay at 1200. */
      var S = IS_TOUCH ? Math.min(cfg.roomShotPx || 1200, 1200) : 1600, E = cfg.emailShotPx || 900;
      var imgs = {}, left = 2, over = false;
      function fail(why) {
        if (over) return; over = true;
        if (window.console) console.warn('[mm] room shots skipped: ' + why);
        try { handOffRender(wallSrc, studioSrc); } catch (e) {}
      }
      function go() {
        if (over || --left) return;
        if (roomTok !== cfg.__mmRoomTok) { over = true; return; }        // a newer build took over
        try {
          var out = {};
          ['table', 'wall'].forEach(function (shot) {
            var cv = window.MMRooms.composite(imgs[shot], roomDef2, shot, R2[shot], R2.shadow, S);
            var page = cv.toDataURL('image/jpeg', 0.88), email = page;
            if (E && E < S) {
              var ec = document.createElement('canvas'); ec.width = ec.height = E;
              var eg = ec.getContext('2d'); eg.imageSmoothingEnabled = true; eg.imageSmoothingQuality = 'high';
              eg.drawImage(cv, 0, 0, E, E);
              email = ec.toDataURL('image/jpeg', 0.84);
            }
            out[shot] = { page: page, email: email };
          });
          over = true;
          /* let go of the big pass canvases straight away (phone memory) */
          ['wall', 'table', 'shadow'].forEach(function (k) { if (R2[k] && R2[k].img) { R2[k].img.width = R2[k].img.height = 0; } });
          var rooms = { table: out.table.page, wall: out.wall.page, cm: spec.size.cm };
          if (typeof cfg.onRooms === 'function') { try { cfg.onRooms(rooms); } catch (eO) {} }
          if (typeof cfg.onRendered === 'function') {
            try { cfg.onRendered({ image: out.wall.email, imageDesk: out.table.email }); }
            catch (e) { if (window.console) console.warn('[mm] onRendered threw:', e.message); }
          }
          if (window.console) console.info('[mm] room shots ready (B6.4, ' + S + 'px)');
        } catch (eC) { over = false; fail('composite failed (' + (eC && eC.message) + ')'); }
      }
      ['table', 'wall'].forEach(function (shot) {
        var im = new Image();
        im.crossOrigin = 'anonymous';
        im.onload = function () { imgs[shot] = im; go(); };
        im.onerror = function () { fail('room photo missing -- upload ' + roomDef2[shot].file + ' to Shopify > Content > Files'); };
        im.src = MM_roomUrl(roomDef2[shot].file, 1600);
      });
    }
    function blankHandOff(ct, cw) {
      if (window.console) {
        console.warn('[mm] render came back blank (table ' + Math.round(ct * 100) + '%, wall ' +
                     Math.round(cw * 100) + '% drawn): the email goes without pictures');
      }
      if (typeof cfg.onRendered === 'function') {
        try { cfg.onRendered({ image: null, imageDesk: null, blank: true, cover: [ct, cw] }); }
        catch (e) { if (window.console) console.warn('[mm] onRendered threw:', e.message); }
      }
    }

    function roomsHandOffGo() {
      var def = roomDef;
      var tSrc = lowSrc || studioSrc, tGeo = lowSrc ? lowGeo : heroGeo;   // B5.53
      if (!def || !wallSrc || !MM_geoOk(wallGeo) || !tSrc || !MM_geoOk(tGeo)) {
        return handOffRender(wallSrc, studioSrc);
      }
      var S = Math.min(cfg.roomShotPx || 1200, 1600), E = cfg.emailShotPx || 900;
      MM_roomComposite({ model: tSrc, geo: tGeo, room: def.table, S: S, E: E }, function (t) {
        if (roomTok !== cfg.__mmRoomTok) return;          // a newer build took over
        if (!t) return handOffRender(wallSrc, studioSrc);
        MM_roomComposite({ model: wallSrc, geo: wallGeo, room: def.wall, S: S, E: E }, function (w) {
          if (roomTok !== cfg.__mmRoomTok) return;
          if (!w) return handOffRender(wallSrc, studioSrc);
          var rooms = { table: t.page, wall: w.page, cm: spec.size.cm };
          if (typeof cfg.onRooms === 'function') {
            try { cfg.onRooms(rooms); } catch (eO) {}
          }
          if (typeof cfg.onRendered === 'function') {
            try { cfg.onRendered({ image: w.email, imageDesk: t.email }); }
            catch (e) { if (window.console) console.warn('[mm] onRendered threw:', e.message); }
          }
          if (window.console) console.info('[mm] room shots ready (' + S + 'px)');
        });
      });
    }

    function handOffRender(wallSrc, deskSrc) {
      if (typeof cfg.onRendered !== 'function') return;
      var px = cfg.emailShotPx || 900;
      compositeShot(wallSrc, wallScene(), px, 'image/jpeg', 0.82, function (wallUrl) {
        compositeShot(deskSrc, deskScene(), px, 'image/jpeg', 0.82, function (deskUrl) {
          try { cfg.onRendered({ image: wallUrl, imageDesk: deskUrl }); }
          catch (e) { if (window.console) console.warn('[mm] onRendered threw:', e.message); }
        });
      });
    }

    /* Build 3: the wall shot. Three changes from the straight-down version.
       A longer lens, so a tower at the rim no longer leans out over the frame.
       A few degrees off square, so the piece reads as an object standing off
       the wall rather than as a flat picture of a map. And the wall itself is
       behind it now: the shadow catcher is dropped back by the hanging gap and
       left visible, so the model throws a real shadow onto the wall the way it
       does in the room it will hang in. The painted contact blob is hidden for
       this one -- it is a shadow for a model sitting on a desk. */
    /* Build 3.2: the sky light casts no shadow for this one. It is a wide
       blurred light straight overhead, and its shadow camera is a square only
       a little bigger than the plate -- on the wall that arrived as a big grey
       rectangle with hard edges around the model, brightest where a tall city
       blocked the most light. The wall wants one shadow, thrown by the key. */
    /* B6.4: the room shots come from MMRooms (see the B6.4 block near the
       top). The old 6-degree wall shot below only runs when a size has no new
       photos, so nothing that read wallSrc / wallGeo / lowSrc changes. */
    var R2 = null, roomDef2 = (window.MMRooms && window.MMRooms.forSize) ? window.MMRooms.forSize(spec.size.cm) : null;
    if (roomDef2) {
      /* B6.5.2: the safety net. Note everything the room shots can touch... */
      var NET = null;
      try {
        NET = { mats: [], meshes: [], objs: [], lights: [], exp: renderer.toneMappingExposure };
        var netSeen = [];
        group.traverse(function (o) {
          if (!o.isMesh) return;
          NET.meshes.push([o, o.visible]);
          (Array.isArray(o.material) ? o.material : [o.material]).forEach(function (mt) {
            if (!mt || netSeen.indexOf(mt) >= 0) return;
            netSeen.push(mt);
            NET.mats.push([mt, mt.colorWrite, mt.depthWrite, mt.visible, mt.opacity, mt.envMapIntensity]);
          });
        });
        [surface, blobMesh].forEach(function (o) {
          if (o) NET.objs.push([o, o.visible, o.position.y, o.material ? o.material.opacity : null]);
        });
        world.traverse(function (o) {
          if (o.isLight) NET.lights.push([o, o.visible, o.intensity, o.position.clone(), o.castShadow,
                                          o.shadow ? o.shadow.radius : null]);
        });
      } catch (eNet) { NET = null; }
      try {
        var hemiL = null;
        world.children.forEach(function (o) { if (o.isHemisphereLight) hemiL = o; });
        var roomModels = [];
        group.traverse(function (o) { if (o.isMesh) roomModels.push(o); });
        var passPx = Math.min(DRAW, IS_TOUCH ? 1200 : 2048);   /* phones: lighter on memory */
        var tR = Date.now();
        R2 = window.MMRooms.passes({
          THREE: THREE, renderer: renderer, world: world, key: keyLight, sky: skyLight, fill: fill, hemi: hemiL,
          catcher: surface, hide: [blobMesh], models: roomModels, outer: outer, plateBottom: plateBottom, frameTop: frameTop,
          read: function (px) {
            var c = document.createElement('canvas'); c.width = c.height = px;
            var g = c.getContext('2d'); g.imageSmoothingEnabled = true; g.imageSmoothingQuality = 'high';
            g.drawImage(renderer.domElement, 0, 0, px, px);
            return c;
          }
        }, roomDef2, passPx);
        if (window.console) console.info('[mm] room passes ' + (Date.now() - tR) + 'ms (' + passPx + 'px)');
      } catch (eR2) {
        R2 = null;
        if (window.console) console.warn('[mm] room passes failed, using the old wall shot:', eR2 && eR2.message);
      } finally {
        /* ...and put all of it back, whatever happened. */
        if (NET) {
          var netFixed = 0;
          try {
            NET.mats.forEach(function (r) {
              var mt = r[0];
              if (mt.colorWrite !== r[1]) { mt.colorWrite = r[1]; netFixed++; }
              if (mt.depthWrite !== r[2]) { mt.depthWrite = r[2]; netFixed++; }
              if (mt.visible !== r[3]) { mt.visible = r[3]; netFixed++; }
              if (mt.opacity !== r[4]) { mt.opacity = r[4]; netFixed++; }
              if (mt.envMapIntensity !== r[5]) { mt.envMapIntensity = r[5]; netFixed++; }
            });
            NET.meshes.forEach(function (r) { if (r[0].visible !== r[1]) { r[0].visible = r[1]; netFixed++; } });
            NET.objs.forEach(function (r) {
              var o = r[0];
              if (o.visible !== r[1]) { o.visible = r[1]; netFixed++; }
              if (o.position.y !== r[2]) { o.position.y = r[2]; o.updateMatrixWorld(true); netFixed++; }
              if (o.material && r[3] != null && o.material.opacity !== r[3]) { o.material.opacity = r[3]; netFixed++; }
            });
            NET.lights.forEach(function (r) {
              var L = r[0];
              if (L.visible !== r[1]) { L.visible = r[1]; netFixed++; }
              if (L.intensity !== r[2]) { L.intensity = r[2]; netFixed++; }
              if (!L.position.equals(r[3])) { L.position.copy(r[3]); netFixed++; }
              if (L.castShadow !== r[4]) { L.castShadow = r[4]; netFixed++; }
              if (L.shadow && r[5] != null && L.shadow.radius !== r[5]) { L.shadow.radius = r[5]; netFixed++; }
            });
            if (renderer.toneMappingExposure !== NET.exp) { renderer.toneMappingExposure = NET.exp; netFixed++; }
          } catch (eFix) {
            if (window.console) console.warn('[mm] safety net could not finish:', eFix && eFix.message);
          }
          if (netFixed && window.console) {
            console.warn('[mm] safety net: the room shots left ' + netFixed + ' thing(s) changed on the model; all put back');
          }
          window.MM_DIAG_NET = netFixed;   /* for checks: 0 = nothing needed putting back */
        }
      }
    }
    var wallSrc = null, wallGeo = null, lowSrc = null, lowGeo = null;
    var wFov = 18;
    var wallCam = aimCam(new THREE.PerspectiveCamera(wFov, 1, 2, 120),
                         [0, Math.cos(6 * D2R), -Math.sin(6 * D2R)], wFov, 0.58);
    wallFrac = plateFracFor(wallCam);
    function shootPlain(cam) {
      var keepAO = aoPass;
      aoPass = null;
      try { return shoot(cam); } finally { aoPass = keepAO; }
    }
    if (R2 && R2.wall && R2.table) {
      try { wallSrc = R2.wall.img.toDataURL('image/png'); } catch (eW) { wallSrc = null; }
      wallGeo = { cx: R2.wall.geo.cx, cy: R2.wall.geo.cy, w: R2.wall.geo.w };
      setKey(MM_T.wallKey[0], MM_T.wallKey[1], MM_T.wallKey[2]);   // the live viewer's light, as before
    } else {
      R2 = null;
      var skyCastWas = skyLight.castShadow;
      skyLight.castShadow = false;
      surface.position.y = plateBottom - mm(8);
      surface.material.opacity = 0.26;
      surface.visible = true;
      if (blobMesh) blobMesh.visible = false;
      setKey(MM_T.wallKey[0], MM_T.wallKey[1], MM_T.wallKey[2]);
      wallSrc = shootPlain(wallCam);
      if (wallSrc) { try { wallGeo = discGeo(wallCam); } catch (eG2) {} }
      surface.position.y = plateBottom - 0.002;
      surface.material.opacity = 0.20;
      skyLight.castShadow = skyCastWas;
      if (blobMesh) blobMesh.visible = true;
    }
    if (wallSrc) wallImg.src = wallSrc;
    try { stashThumb(studioSrc); } catch (e) { /* never break the render */ }
    var roomDef = R2 ? null : MM_roomFor(spec.size.cm);
    if (roomDef) {
      try {
        var isLow = roomDef.table.cam === 'low';
        var tDir = isLow ? MM_ROOM_LOW_DIR : ANGLES[0].dir;
        var tCam = aimCam(new THREE.PerspectiveCamera(20, 1, 2, 120), tDir, 20,
                          isLow ? 0.80 : ANGLES[0].fill);
        lowSrc = shootPlain(tCam);
        if (lowSrc) lowGeo = discGeo(tCam);
      } catch (eLow) { lowSrc = null; lowGeo = null; }
    }
    try { if (R2) rooms2(); else roomsHandOff(); }
    catch (eRm) { try { handOffRender(wallSrc, studioSrc); } catch (e) { /* nor for the email */ } }

    /* Compositing. With a scene photo we scale to real life, because there is
       something real to be scaled against. With no photo there is nothing to
       compare to, so scaling down only makes the model small for no reason —
       fill the pane instead. */
    scene = scene || {};
    function place(img, hasScene, sceneCm, xPct, yPct, fill, soloPct, frac) {
      var pct = hasScene
        ? (spec.size.cm / (sceneCm || 140)) * 100 / fill
        : soloPct;
      /* Never wider than the pane. `fill` is the plate's share of the image, so
         98 / fill is the scale at which the plate just touches both edges. True
         scale wins until it would run the model off the sides -- which is what
         cropped the three-quarter views once the framing got tighter. */
      var capPct = 98 / Math.max(frac || fill, 0.05);
      img.style.width = Math.max(6, Math.min(pct, 150, capPct)).toFixed(2) + '%';
      img.style.left = (xPct != null ? xPct : 50) + '%';
      img.style.top = (yPct != null ? yPct : 50) + '%';
    }
    shotImgs.forEach(function (im, ii) {
      place(im, !!scene.desk, scene.deskCm, scene.deskX, scene.deskY,
            DESK_FILL, 100, shotFracs[ii]);
    });
    place(wallImg, !!scene.wall, scene.wallCm, scene.wallX, scene.wallY,
          WALL_FILL, 62, wallFrac);

    /* ------------------------- the live viewer --------------------------
       Everything above already built this scene in WebGL. The old path
       photographed it four times and threw it away; this keeps it and lets the
       customer turn it.

       Three things make it affordable on a phone: no ambient-occlusion pass
       (that is what makes a baked shot cost ten seconds), the shadow map drawn
       once and frozen because only the camera moves, and render-on-demand --
       it draws while a finger is down and while the spin decays, then stops
       dead. An idle model costs nothing.

       And it measures itself. If the first frames on this device are too slow
       the whole thing is handed back and the baked still stands in its place,
       because a stuttering model is worse than a sharp photograph. */
    function startLive() {
      var pane = shotImgs[0] && shotImgs[0].parentNode;
      if (!pane || !pane.appendChild) return false;

      var cv = renderer.domElement;
      /* The baked still is the poster UNDER the canvas, and the canvas draws on
         transparency -- so until this hides it you are looking at two models at
         once, the live one turning over a static one that never moves. It comes
         straight back if the fallback fires. */
      var poster = shotImgs[0];
      /* Whichever box the canvas is currently living in -- the disc, or the
         enlarged view. The WebGL context travels with the element, so the model
         can be moved between the two without rebuilding anything. */
      var hostEl = pane;
      function boxPx() {
        return Math.max(240, Math.round(hostEl.clientWidth || hostEl.offsetWidth || 480));
      }
      var px = boxPx();
      /* Capped at 2: beyond that a phone is drawing four times the pixels for a
         difference nobody can see at arm's length. */
      var ratio = Math.min(2, window.devicePixelRatio || 1);
      /* And never more than 1600 pixels of backing store whatever the screen
         says. The offscreen render is already capped for the same reason -- a
         phone has very little graphics memory to spare and this canvas is alive
         for the rest of the session. */
      /* B7.1.0: the enlarged view fills the screen, so it is a rectangle and
         has its own height. Null on the page, where the disc is square. */
      var pxH = null;
      function fitCanvas() {
        var h = pxH || px;
        var r = Math.min(ratio, 1600 / Math.max(px, h, 1));
        renderer.setPixelRatio(Math.max(1, r));
        renderer.setSize(px, h, false);
        if (cam) cam.aspect = px / h;
      }
      fitCanvas();
      cv.style.cssText =
        'position:absolute;inset:0;width:100%;height:100%;display:block;' +
        'touch-action:none;cursor:grab;z-index:2;opacity:0;transition:opacity .18s';
      pane.appendChild(cv);

      var cam = aimCam(new THREE.PerspectiveCamera(ANGLES[0].fov, 1, 2, 120),
                       ANGLES[0].dir, ANGLES[0].fov, ANGLES[0].fill);
      var R = Math.sqrt(cam.position.x * cam.position.x + cam.position.z * cam.position.z);
      var az = Math.atan2(cam.position.z, cam.position.x);
      var el0 = Math.atan2(cam.position.y,
                           Math.sqrt(cam.position.x * cam.position.x + cam.position.z * cam.position.z));
      var dist = cam.position.length();
      var EL_MIN = 0.12, EL_MAX = 1.45;      // never under the plate, never past straight down
      var elv = Math.max(EL_MIN, Math.min(EL_MAX, el0));
      /* Zoom clamps, measured from the framing the hero shot chose. In as far as
         the plate filling the circle, out only a little past where it started --
         far enough to see the whole thing on its shadow, never far enough to
         lose it as a speck in the middle of a disc. */
      var D0 = dist, D_MIN = D0 * 0.48, D_MAX = D0 * 1.35;
      var AZ0 = az, ELV0 = elv;   /* B7.2.0: the hero angle, kept for the email clip */

      function aim() {
        var ch = Math.cos(elv) * dist, cy = Math.sin(elv) * dist;
        cam.position.set(Math.cos(az) * ch, cy, Math.sin(az) * ch);
        cam.lookAt(0, 0, 0);
        /* B7.1.0: near and far follow the distance, the same rule aimCam uses,
           so zooming right in never slices the front off the model. */
        cam.near = Math.max(0.5, dist - 30);
        cam.far = dist + 40;
        cam.updateProjectionMatrix();
      }

      var gaps = [], lastTs = 0, graded = false, alive = true, queued = false;
      /* `cont` means this frame was drawn inside a continuous loop -- the
         reveal spin or the flick glide -- where the next frame is requested the
         instant this one finishes. There is no idle time in that loop, so any
         gap is real frame cost however large it is. Without the distinction a
         genuinely slow device produced nothing but gaps over the idle cutoff,
         every one was thrown away as idle, and the guard never graded at all --
         it failed open on exactly the devices it exists to catch. */
      function draw(ts, cont) {
        queued = false;
        if (!alive) return;
        renderer.render(world, cam);
        /* Frame cost is the gap between one animation frame and the next, NOT
           the time renderer.render() takes to return. render() only queues the
           work -- timing around it measured 4.9 ms on a machine that was really
           taking 157 ms, which would have let the guard pass a device that
           cannot hold this at all. The browser will not fire the next animation
           frame until the last one is actually on screen, so the gap between
           them is the honest number. Gaps over 100 ms are idle time, not slow
           frames, and are thrown away. */
        if (typeof ts === 'number') {
          if (lastTs && !graded && !document.hidden) {
            var d = ts - lastTs;
            if (d > 0 && (cont || d < 100)) {
              gaps.push(d);
              /* Ten is enough to be sure. Five is enough when they are all
                 catastrophic -- no point spinning a slideshow eleven more times
                 in front of someone to confirm it. */
              if (gaps.length >= 10 || (gaps.length >= 5 && median(gaps) > 120)) grade();
            }
          }
          lastTs = ts;
        }
      }
      function median(a) {
        var srt = a.slice().sort(function (x, y) { return x - y; });
        return srt[Math.floor(srt.length / 2)];
      }
      function need() {
        if (queued || !alive) return;
        queued = true;
        requestAnimationFrame(draw);
      }

      /* The budget check. Median, not mean: one long frame while a texture
         uploads should not condemn a device that is otherwise fine. 40 ms is
         25 fps, the point below which a drag stops feeling attached to your
         finger. */
      function grade() {
        if (graded) return;
        graded = true;
        var med = median(gaps);
        if (window.console) {
          console.info('[mm] live view: ' + med.toFixed(1) + ' ms median frame (' +
            (1000 / med).toFixed(0) + ' fps) over ' + gaps.length + ' frames, ' +
            px + 'px at ' + ratio + 'x');
        }
        if (med > 40) {
          if (window.console) {
            console.warn('[mm] live view too slow here (' + med.toFixed(0) +
              ' ms/frame) \u2014 falling back to the baked still');
          }
          stop();
        } else {
          /* B7.2.0: this device holds the live view, so it can also record the
             2-second clip the emails show (assets/mm-clip.js). The clip file is
             only fetched now, never at page load. It draws while the page is
             still and stops at the first touch. Any failure means no clip and
             the emails keep the still render. */
          try {
            window.MM_LIVE3D = { THREE: THREE, renderer: renderer, world: world, az: AZ0, elv: ELV0, dist: D0,
                                 fov: cam.fov, alive: function () { return alive; }, redraw: need };
            if (window.MM_CLIP) window.dispatchEvent(new Event('mm:live3d'));
            else if (!document.getElementById('mm-clip-js')) {
              var mmCs = document.querySelector('script[src*="mm-configurator"]');
              if (mmCs) {
                var mmSc = document.createElement('script');
                mmSc.id = 'mm-clip-js'; mmSc.async = true;
                mmSc.src = mmCs.src.replace(/mm-configurator(\.min)?\.js.*$/, 'mm-clip.js?v=' + encodeURIComponent((window.MM_BUILDS && window.MM_BUILDS.configurator) || 'B7.2.0'));
                document.head.appendChild(mmSc);
              }
            }
          } catch (eClip) {}
        }
      }

      /* A short turn the moment it appears. It shows the model is a thing you
         can turn rather than a photograph -- nobody drags a picture to find
         out -- and it is also the calibration run: twelve real animation frames
         is exactly what grade() needs to decide whether this device can hold
         it. If it cannot, the fallback happens during the reveal, before the
         customer has touched anything. */
      function reveal(n) {
        if (!alive || down) return;
        az -= 0.022;
        aim();
        requestAnimationFrame(function (ts) {
          draw(ts, true);
          if (n > 1 && alive) reveal(n - 1);
        });
      }

      /* --------------------------- turning it --------------------------- */
      var down = false, lx = 0, ly = 0, moved = 0, vx = 0, spin = 0;
      /* Pinch. The model had none: the lightbox got pinch-to-zoom long ago and
         the live canvas never did, so on a phone there was simply no way to
         zoom the thing you are buying. Tracked through pointer events, which
         report every finger separately, rather than touch events -- the drag
         handlers below are already pointer-based and two systems watching the
         same fingers fight each other. */
      var pts = {}, pinchD = 0, pinchDist0 = 0;
      function ptList() {
        var out = [];
        for (var k in pts) if (Object.prototype.hasOwnProperty.call(pts, k)) out.push(pts[k]);
        return out;
      }
      function spread(a) {
        var dx = a[0].x - a[1].x, dy = a[0].y - a[1].y;
        return Math.sqrt(dx * dx + dy * dy);
      }

      function onDown(e) {
        if (e.pointerId != null) pts[e.pointerId] = { x: e.clientX, y: e.clientY };
        var two = ptList();
        if (two.length === 2) {
          /* A second finger ends the drag and starts a pinch. */
          down = false; spin = 0;
          pinchD = spread(two); pinchDist0 = dist;
          return;
        }
        down = true; moved = 0; vx = 0;
        lx = e.clientX; ly = e.clientY;
        cv.style.cursor = 'grabbing';
        if (cv.setPointerCapture && e.pointerId != null) {
          try { cv.setPointerCapture(e.pointerId); } catch (e2) {}
        }
      }
      function onMove(e) {
        if (e.pointerId != null && pts[e.pointerId]) {
          pts[e.pointerId].x = e.clientX; pts[e.pointerId].y = e.clientY;
        }
        var two = ptList();
        if (two.length === 2 && pinchD > 0) {
          if (e.cancelable) e.preventDefault();
          /* Fingers apart = closer, the same direction as pinching a photo. */
          var r = spread(two) / pinchD;
          if (r > 0.05) dist = Math.max(D_MIN, Math.min(D_MAX, pinchDist0 / r));
          aim(); need();
          return;
        }
        if (!down) return;
        var dx = e.clientX - lx, dy = e.clientY - ly;
        lx = e.clientX; ly = e.clientY;
        moved += Math.abs(dx) + Math.abs(dy);
        /* Divided by the canvas width, so a drag across the model turns it the
           same amount on a phone as on a desktop. */
        az -= dx * (3.2 / px);
        /* Tilt at about a third of the turn rate. Matching them made every
           sideways drag lift or drop the model as well, which is what read as
           the thing fighting you. */
        elv = Math.max(EL_MIN, Math.min(EL_MAX, elv + dy * (1.1 / px)));
        vx = dx;
        aim(); need();
        if (e.cancelable) e.preventDefault();
      }
      function onUp(e) {
        if (e && e.pointerId != null) delete pts[e.pointerId];
        if (ptList().length < 2) pinchD = 0;
        /* One finger left after a pinch: start a fresh drag from where it is
           rather than jumping the model by the gap between the two. */
        if (!down && ptList().length === 1) {
          var rest = ptList()[0];
          down = true; moved = 0; vx = 0; lx = rest.x; ly = rest.y;
          return;
        }
        if (!down) return;
        down = false;
        cv.style.cursor = 'grab';
        /* The pane's own click handler reads this: a drag that turned the model
           must not also open the lightbox behind it. */
        if (moved > 8) cv.__mmDragEnd = Date.now();
        /* A flick keeps turning and eases off, the way a thing with weight
           does. Without it the model stops the instant you let go, which reads
           as a picture that happens to follow your finger. */
        spin = Math.abs(vx) > 2 ? vx : 0;
        if (spin) requestAnimationFrame(glide);
      }
      function glide(ts) {
        if (!alive || down || Math.abs(spin) < 0.4) { spin = 0; return; }
        az -= spin * (3.2 / px);
        spin *= 0.94;
        aim(); draw(ts, true);
        requestAnimationFrame(glide);
      }
      /* Turning a phone sideways changes the disc's width, and a canvas whose
         backing store was sized for the old width is a blurry model until
         something else redraws it. Only on a real change, and only past 12%, so
         a URL bar sliding away does not trigger a resize. */
      function onResize() {
        if (!alive) return;
        if (lb) { layoutLb(); return; }
        var w2 = boxPx();
        if (Math.abs(w2 - px) / px < 0.12) return;
        px = w2;
        fitCanvas();
        aim(); need();
      }
      window.addEventListener('resize', onResize);

      /* Scroll to zoom, desktop's natural gesture for this. preventDefault so
         the page does not scroll out from under the model at the same time. */
      cv.addEventListener('wheel', function (e) {
        if (!alive) return;
        if (e.cancelable) e.preventDefault();
        /* Proportional to how far you actually scrolled, not a fixed step per
           event. A trackpad fires dozens of small events for one flick, and at
           8% each that crossed the whole range in an instant and slammed into
           the stop -- which is what read as jumpy and wrong rather than
           inverted. deltaMode 1 is lines and 2 is pages; normalise both to
           something pixel-ish first, then clamp so one violent scroll cannot
           teleport it. Scroll up zooms in, which is what every map and 3D
           viewer does. */
        var dy = e.deltaY * (e.deltaMode === 1 ? 16 : e.deltaMode === 2 ? 100 : 1);
        dy = Math.max(-60, Math.min(60, dy));
        dist = Math.max(D_MIN, Math.min(D_MAX, dist * Math.exp(dy * 0.0016)));
        aim(); need();
      }, { passive: false });

      cv.addEventListener('pointerdown', onDown);
      cv.addEventListener('pointermove', onMove, { passive: false });
      cv.addEventListener('pointerup', onUp);
      cv.addEventListener('pointercancel', onUp);
      cv.addEventListener('lostpointercapture', onUp);

      function stop() {
        if (!alive) return;
        alive = false;
        try { if (lb) { lb.remove(); lb = null; document.documentElement.style.overflow = lbOverflow; } } catch (eS) {}
        try { if (lbChat) { lbChat.style.display = lbChatVis; lbChat = null; } } catch (eC) {}
        if (poster) poster.style.visibility = '';
        try { cv.remove(); } catch (e3) {}
        try { renderer.dispose(); } catch (e4) {}
        try {
          var lz = renderer.getContext().getExtension('WEBGL_lose_context');
          if (lz) lz.loseContext();
        } catch (e5) {}
        try { host.remove(); } catch (e6) {}
        window.removeEventListener('resize', onResize);
        if (cfg.__mmLive && cfg.__mmLive.stop === stop) cfg.__mmLive = null;
      }

      /* Only the camera moves from here, so the shadow map never needs drawing
         again. This is the single biggest saving per frame. */
      aim();
      renderer.render(world, cam);
      renderer.shadowMap.autoUpdate = false;
      var tFirst = (window.performance || Date).now();
      draw();
      cv.style.opacity = '1';
      if (poster) poster.style.visibility = 'hidden';
      if (window.console) {
        console.info('[mm] live view ready in ' +
          Math.round((window.performance || Date).now() - tFirst) + ' ms after the hero shot');
      }
      /* B7.1.1: the opening turn is also the speed check, so it waits until
         the page has finished the work that follows the hero shot, and until
         the tab is in view. Run straight away, a fast laptop clocked 125 ms
         frames for that one busy second and lost its 3D view to the still
         photo (Tap to enlarge then opens the flat picture). */
      function revealWhenCalm() {
        if (!alive) return;
        if (document.hidden) {
          document.addEventListener('visibilitychange', function onVis() {
            if (document.hidden) return;
            document.removeEventListener('visibilitychange', onVis);
            revealWhenCalm();
          });
          return;
        }
        reveal(16);
      }
      if (window.requestIdleCallback) {
        requestIdleCallback(function () { setTimeout(revealWhenCalm, 150); }, { timeout: 2500 });
      } else {
        setTimeout(revealWhenCalm, 900);
      }
      /* ------------------------- the enlarged view -------------------------
         Tapping to enlarge used to open a bare <img>: no close button and no
         way to zoom. The model is right there and alive, so the enlarged view
         is now the model itself -- moved into the overlay, canvas and WebGL
         context together, and moved back on close. Rotate, pinch and scroll all
         come with it because the handlers are bound to the element.

         The backdrop slot is here and empty: the moment there is a table photo
         in the theme settings, the enlarged view shows the model standing on it
         and still turning. No extra render, because there is no extra render
         anywhere in this. */
      /* B7.1.0 (Kevin, 27 Oct): on a phone "Tap to enlarge" looked like it did
         nothing. The box was a square capped at 94% of the screen width, which
         is the size the disc already is on a phone, at the same zoom. Now it
         fills the screen, glides straight in to a closer three-quarter view,
         and says "Swipe to look around" underneath. Closing puts the disc back
         exactly as it was. */
      var lb = null, lbStage = null, lbSaved = null, lbAnim = 0, lbOverflow = '', lbChat = null, lbChatVis = '';
      function layoutLb() {
        if (!lb || !lbStage) return;
        var vw = window.innerWidth, vh = window.innerHeight, phone = vw < 700;
        var w = phone ? vw : Math.min(vw - 48, 1400);
        var h = Math.max(240, vh - 124);
        lbStage.style.width = Math.round(w) + 'px';
        lbStage.style.height = Math.round(h) + 'px';
        lbStage.style.borderRadius = phone ? '0' : '14px';
        px = Math.round(w); pxH = Math.round(h);
        /* Pinching out must still reach the whole plate on a tall, narrow
           screen, so the far stop grows with how narrow the box is. */
        D_MAX = D0 * 1.35 / Math.min(1, px / pxH);
        if (dist > D_MAX) dist = D_MAX;
        fitCanvas(); aim(); need();
      }
      function glideTo(t, ms) {
        var f = { az: az, elv: elv, dist: dist }, t0 = 0, id = ++lbAnim;
        if (!(ms > 0)) {
          az = t.az; elv = t.elv; dist = t.dist;
          aim(); need();
          return;
        }
        function step(ts) {
          if (!alive || !lb || id !== lbAnim || down) return;
          if (!t0) t0 = ts;
          var k = Math.min(1, (ts - t0) / ms), e = 1 - Math.pow(1 - k, 3);
          az = f.az + (t.az - f.az) * e;
          elv = f.elv + (t.elv - f.elv) * e;
          dist = f.dist + (t.dist - f.dist) * e;
          aim(); draw(ts);
          if (k < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      }
      function enlarge() {
        if (!alive || lb) return;
        lb = el('div', 'mm-lightbox');
        lb.setAttribute('style',
          'position:fixed;inset:0;z-index:99999;display:flex;flex-direction:column;' +
          'align-items:center;justify-content:flex-start;padding-top:60px;' +
          'box-sizing:border-box;touch-action:none;background:rgba(18,19,22,.92);' +
          '-webkit-backdrop-filter:blur(3px);backdrop-filter:blur(3px)');

        lbStage = el('div', '');
        lbStage.setAttribute('style',
          'position:relative;flex:none;overflow:hidden;' +
          'background:' + (scene.desk ? 'transparent' : 'rgba(255,255,255,.06)'));
        /* Waiting on Kevin's photograph; harmless until there is one. */
        if (scene.desk) {
          lbStage.style.background =
            '#fff url("' + scene.desk + '") center/cover no-repeat';
        }
        lb.appendChild(lbStage);

        /* Private class name on purpose. The theme stylesheet owns .mm-lb-close
           and pins it bottom-centre with left:50% + transform; an inline style
           only overrides the properties it actually names, so reusing that
           class made the button stretch the whole viewport. left/bottom/
           transform are reset here too, belt and braces. */
        var shut = el('button', 'mm-live-close', 'Close');
        shut.type = 'button';
        shut.setAttribute('style',
          'position:fixed;top:max(12px,env(safe-area-inset-top));right:14px;' +
          'left:auto;bottom:auto;transform:none;width:auto;height:auto;' +
          'min-width:0;max-width:none;display:inline-block;' +
          'border:0;border-radius:99px;padding:11px 18px;cursor:pointer;' +
          'font:600 15px/1 ' + MM_FACE + ';background:#fff;color:#17181A;' +
          'box-shadow:0 2px 14px rgba(0,0,0,.3);z-index:3');
        shut.addEventListener('click', function (ev) { ev.stopPropagation(); shrink(); });
        lb.appendChild(shut);

        /* Kevin's line, right under the model. */
        var hint = el('div', 'mm-live-hint');
        hint.innerHTML =
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
          'stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
          '<path d="M7 8l-4 4 4 4"></path><path d="M17 8l4 4-4 4"></path>' +
          '<path d="M3 12h18"></path></svg>' +
          '<span>' + (IS_TOUCH ? 'Swipe to look around' : 'Drag to look around') + '</span>' +
          '<span style="opacity:.6">' + (IS_TOUCH ? 'Pinch to zoom' : 'Scroll to zoom') + '</span>';
        hint.setAttribute('style',
          'flex:none;margin-top:16px;display:flex;align-items:center;gap:10px;' +
          'color:#fff;font:600 15px/1.3 ' + MM_FACE);
        lb.appendChild(hint);

        lb.addEventListener('click', function (ev) { if (ev.target === lb) shrink(); });
        document.addEventListener('keydown', onKeyLb);
        lbOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        document.body.appendChild(lb);
        /* The chat bubble sits above everything; it waits while this is open. */
        lbChat = document.querySelector('shopify-chat');
        if (lbChat) { lbChatVis = lbChat.style.display; lbChat.style.display = 'none'; }

        lbSaved = { az: az, elv: elv, dist: dist, dmin: D_MIN, dmax: D_MAX };
        var pagePx = px;
        hostEl = lbStage;
        lbStage.appendChild(cv);
        layoutLb();
        D_MIN = D0 * 0.32;
        /* About twice the size it was on the page, measured in screen pixels.
           A little less on a wide screen, so the whole frame still fits. */
        var dT = pxH * dist / ((pxH > px ? 2.1 : 1.75) * pagePx);
        dT = Math.max(D_MIN, Math.min(D_MAX, dT));
        var calm = false;
        try { calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (eM) {}
        /* Higher on a tall phone screen, so the plate fills more of it. */
        glideTo({ az: az - 0.32, elv: Math.max(EL_MIN, Math.min(EL_MAX, pxH > px ? 0.72 : 0.62)), dist: dT },
                calm ? 0 : 480);
        /* The arrows sway twice so the line reads as an instruction. */
        try {
          hint.firstChild.animate(
            [{ transform: 'translateX(0)' }, { transform: 'translateX(-5px)' },
             { transform: 'translateX(5px)' }, { transform: 'translateX(0)' }],
            { duration: 900, delay: 500, iterations: calm ? 0 : 2, easing: 'ease-in-out' });
        } catch (eA) {}
      }
      function onKeyLb(e) { if (e.key === 'Escape') shrink(); }
      function shrink() {
        if (!lb) return;
        lbAnim++;
        document.removeEventListener('keydown', onKeyLb);
        try { lb.remove(); } catch (e) {}
        lb = null; lbStage = null;
        document.documentElement.style.overflow = lbOverflow;
        if (lbChat) { lbChat.style.display = lbChatVis; lbChat = null; }
        hostEl = pane;
        pane.appendChild(cv);
        pxH = null;
        if (lbSaved) {
          az = lbSaved.az; elv = lbSaved.elv; dist = lbSaved.dist;
          D_MIN = lbSaved.dmin; D_MAX = lbSaved.dmax;
          lbSaved = null;
        }
        px = boxPx(); fitCanvas(); aim(); draw();
      }

      cfg.__mmLive = { stop: stop, enlarge: enlarge };
      /* The pane keeps the baked still underneath as the poster and the
         fallback, so if stop() ever runs there is already a picture there. */
      return true;
    }

    var liveOk = false;
    if (LIVE) {
      try { liveOk = startLive(); }
      catch (eLive) {
        if (window.console) console.warn('[mm] live view failed to start:', eLive && eLive.message);
      }
    }

    /* Skipped when the live viewer took the context: everything below this
       point still runs, because the legend, the stats line and the credit are
       the same either way. Only the teardown is conditional. */
    if (!liveOk) {
    renderer.dispose();
    /* dispose() frees Three's own objects but leaves the GL context alive in
       most browsers, and the context holds the draw buffer -- now up to four
       times larger. Every colour or frame change builds another one, and a
       browser keeps only a handful before it starts killing the oldest, which
       surfaces as a preview that renders blank after a few changes. This hands
       it back straight away. */
    try {
      var lose = renderer.getContext().getExtension('WEBGL_lose_context');
      if (lose) lose.loseContext();
    } catch (e) { /* nothing to do if the browser will not co-operate */ }
    host.remove();
    }

    var hex = function (n) { return '#' + ('000000' + n.toString(16)).slice(-6); };
    var items = spec.colourway === 'mono'
      ? [[CW.name + ' \u2014 one material', C.bld]]
      : spec.colourway === 'duo'
      ? [['Bone \u2014 ground, roads, buildings', C.bld], ['Water', C.water]]
      : [['Ground', C.ground], ['Buildings, roads and paths', C.bld],
         ['Parks and grass', C.grass], ['Water', C.water]];
    /* The mirror is not an extra material on top of the scheme -- it stands in
       for the water, so it takes the water's place in the key rather than
       listing a blue swatch the model does not have. */
    if (spec.mirrorWater) {
      items = items.filter(function (i) { return i[0] !== 'Water'; });
      items.push(['Polished water', 0x14161A]);
    }
    items.push([FR.name + ' frame', FR.hex]);
    (spec.markers || []).forEach(function (mk) {
      var name = 'Highlighted buildings';
      if (!items.some(function (i) { return i[0] === name; })) items.push([name, MC[mk.colour]]);
    });

    /* The mirror renders as flat black on screen, because that is genuinely
       what an unlit polished surface looks like. On the real model it reflects
       the room. Without saying so, a customer reads the preview as "my river is
       a black hole" -- which is the one place this preview does not tell the
       truth about the finished piece, so it gets said in words. */
    /* Names what it actually covers. "All of the water" is vague where the crop
       has one river, and wrong where it has none at all -- and someone paying
       extra for a mirror on a crop with no water in it deserves to be told
       before they order, not after. Written from the tags OSM gave us, so it
       says lake when there is a lake. */
    var mirrorNote = '';
    if (spec.mirrorWater) {
      var WATER_NAMES = {
        sea: 'the sea', ocean: 'the ocean', bay: 'the bay', river: 'the river',
        canal: 'the canal', lake: 'the lake', pond: 'the pond',
        reservoir: 'the reservoir', dock: 'the dock', stream: 'the streams',
        ditch: 'the streams', drain: 'the streams', water: 'the water'
      };
      var ORDER = ['sea', 'ocean', 'bay', 'river', 'canal', 'lake', 'reservoir',
                   'pond', 'dock', 'stream', 'water'];
      var seen = {};
      (data.water || []).forEach(function (o) { if (o.kind) seen[o.kind] = 1; });
      (data.waterways || []).forEach(function (o) {
        if (o.kind) seen[o.kind === 'ditch' || o.kind === 'drain' ? 'stream' : o.kind] = 1;
      });
      var named = [];
      ORDER.forEach(function (k) {
        if (seen[k] && WATER_NAMES[k] && named.indexOf(WATER_NAMES[k]) === -1) {
          named.push(WATER_NAMES[k]);
        }
      });
      if (named.length > 3) named = named.slice(0, 3);

      var hasWater = (data.water || []).length || (data.waterways || []).length;
      var what = named.length === 0 ? 'all of the water'
        : named.length === 1 ? named[0]
        : named.slice(0, -1).join(', ') + ' and ' + named[named.length - 1];

      var head, body;
      if (!hasWater) {
        head = 'There is no water in this crop, so polished water will not be visible.';
        body = 'Polished water replaces water with a polished insert. This ' +
               'view has none, so nothing on your model would change. Move the ' +
               'crop to include a river, lake or coast, or drop the finish.';
      } else {
        head = 'Polished water replaces ' + what + ', which is why it is black here.';
        body = 'On your model that becomes a polished insert reflecting ' +
               'the room. A flat render cannot show a reflection, so it is ' +
               'drawn as black.';
      }
      mirrorNote = '<p class="mm-mirror-note' + (hasWater ? '' : ' is-warn') +
        '"><strong>' + esc(head) + '</strong>' + esc(body) + '</p>';
    }

    if (foot.getAttribute && foot.getAttribute('data-mm-lean') === '1') {
      foot.innerHTML = mirrorNote;
      foot.style.display = mirrorNote ? '' : 'none';
      return function () {};
    }
    foot.innerHTML = mirrorNote +
      '<div class="mm-legend is-inline">' + items.map(function (i) {
        return '<span><i style="background:' + hex(i[1]) + '"></i>' + esc(i[0]) + '</span>';
      }).join('') + '</div>' +
      '<span class="mm-foot-note">' + count + ' buildings' +
      (data.buildings && data.buildings.length > count
        ? ' of ' + data.buildings.length.toLocaleString() : '') + ' \u00B7 ' +
      (data.roads || []).length + ' road segments \u00B7 ' + greenCount +
      /* The separator belongs to the coverage term, not to the line. It used to
         sit on both sides of it, so an empty coverage printed "trees -- --". */
      ' green areas \u00B7 ' + treeCount + ' trees' +
      /* Walls reported explicitly, including zero. Kevin has now lost the
         Dubrovnik city wall twice, and both times the first question was
         whether the data arrived at all -- which nothing on the page answered.
         A "0 walls" next to "simplified data" tells you it is the source; a
         "0 walls" next to "precise data" tells you it is the query. */
      ' \u00B7 ' + ((data.walls || []).filter(function (w) {
        return w && w.kind === 'city_wall';
      }).length) + ' city-wall runs' +
      (data.coverage ? ' \u00B7 coverage ' + data.coverage : '') +
      ' \u00B7 ' +
      (data.source === 'tiles'
        ? 'simplified data'
        : data.partial
          ? 'precise data \u2014 ' + esc(data.missing || 'some layers') + ' unavailable'
          : 'precise data') +
      ' \u00B7 heights \u00D7' + EXAG +
      /* Reported either way. Silence when terrain is missing is what let a
         buried terrain surface look identical to no terrain at all. */
      (hasRelief
        ? ' \u00B7 terrain ' + Math.round(terrain.max - terrain.min) + ' m over ' +
          (maxLift / mm(1)).toFixed(1) + ' mm'
        : ' \u00B7 no terrain (' + esc(reliefReason) + ')') +
      '</span>' +
      /* The second half of the attribution, and the half that matters most:
         this line sits directly under the model the customer is judging, which
         is where a credit for the data and the generator belongs. The one at
         the foot of the page is easy to scroll past. */
      '<span class="mm-foot-note mm-credit-inline" style="display:block;margin-top:6px;font-size:9.5px;opacity:.75">' +
        'Models generated with <a href="https://miniskyline.com" target="_blank" rel="noopener">Mini Skyline</a>' +
        ' \u00B7 Map data \u00A9 <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a> contributors' +
      '</span>';

    return function () {};
  }

  /* ------------------------- start (must stay last) -----------------------
     Everything above is declared by now, so boot() can safely run synchronously
     on a deferred script. See the note at the boot() definition. */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
